(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './Bitakore-common.js', './kotlinx-coroutines-core.js', './kotlinx-html.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlinx-serialization-kotlinx-serialization-json.js', './PaymentsKit-web.js', './WalletKit-web.js', './WalletKit-common.js', './PaymentsKit-common.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./Bitakore-common.js'), require('./kotlinx-coroutines-core.js'), require('./kotlinx-html.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./PaymentsKit-web.js'), require('./WalletKit-web.js'), require('./WalletKit-common.js'), require('./PaymentsKit-common.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'com.universaliun.bitakore:frontend'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'com.universaliun.bitakore:frontend'.");
    }
    if (typeof globalThis['Bitakore-common'] === 'undefined') {
      throw new Error("Error loading module 'com.universaliun.bitakore:frontend'. Its dependency 'Bitakore-common' was not found. Please, check whether 'Bitakore-common' is loaded prior to 'com.universaliun.bitakore:frontend'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'com.universaliun.bitakore:frontend'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'com.universaliun.bitakore:frontend'.");
    }
    if (typeof globalThis['kotlinx-html'] === 'undefined') {
      throw new Error("Error loading module 'com.universaliun.bitakore:frontend'. Its dependency 'kotlinx-html' was not found. Please, check whether 'kotlinx-html' is loaded prior to 'com.universaliun.bitakore:frontend'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'com.universaliun.bitakore:frontend'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'com.universaliun.bitakore:frontend'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'com.universaliun.bitakore:frontend'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'com.universaliun.bitakore:frontend'.");
    }
    if (typeof globalThis['PaymentsKit-web'] === 'undefined') {
      throw new Error("Error loading module 'com.universaliun.bitakore:frontend'. Its dependency 'PaymentsKit-web' was not found. Please, check whether 'PaymentsKit-web' is loaded prior to 'com.universaliun.bitakore:frontend'.");
    }
    if (typeof globalThis['WalletKit-web'] === 'undefined') {
      throw new Error("Error loading module 'com.universaliun.bitakore:frontend'. Its dependency 'WalletKit-web' was not found. Please, check whether 'WalletKit-web' is loaded prior to 'com.universaliun.bitakore:frontend'.");
    }
    if (typeof globalThis['WalletKit-common'] === 'undefined') {
      throw new Error("Error loading module 'com.universaliun.bitakore:frontend'. Its dependency 'WalletKit-common' was not found. Please, check whether 'WalletKit-common' is loaded prior to 'com.universaliun.bitakore:frontend'.");
    }
    if (typeof globalThis['PaymentsKit-common'] === 'undefined') {
      throw new Error("Error loading module 'com.universaliun.bitakore:frontend'. Its dependency 'PaymentsKit-common' was not found. Please, check whether 'PaymentsKit-common' is loaded prior to 'com.universaliun.bitakore:frontend'.");
    }
    globalThis['com.universaliun.bitakore:frontend'] = factory(typeof globalThis['com.universaliun.bitakore:frontend'] === 'undefined' ? {} : globalThis['com.universaliun.bitakore:frontend'], globalThis['kotlin-kotlin-stdlib'], globalThis['Bitakore-common'], globalThis['kotlinx-coroutines-core'], globalThis['kotlinx-html'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlinx-serialization-kotlinx-serialization-json'], globalThis['PaymentsKit-web'], globalThis['WalletKit-web'], globalThis['WalletKit-common'], globalThis['PaymentsKit-common']);
  }
}(function (_, kotlin_kotlin, kotlin_com_universaliun_bitakore_common, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_kotlinx_kotlinx_html, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_com_universaliun_payments_web, kotlin_com_universaliun_wallet_web, kotlin_com_universaliun_wallet_common, kotlin_com_universaliun_payments_common) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var log2 = Math.log2;
  var protoOf = kotlin_kotlin.$_$.ba;
  var getStringHashCode = kotlin_kotlin.$_$.c9;
  var initMetadataForClass = kotlin_kotlin.$_$.e9;
  var ActivityCategory_AVIATION_getInstance = kotlin_com_universaliun_bitakore_common.$_$.n;
  var ActivityCategory_AIR_SPORTS_getInstance = kotlin_com_universaliun_bitakore_common.$_$.k;
  var ActivityCategory_UNDERWATER_getInstance = kotlin_com_universaliun_bitakore_common.$_$.s;
  var ActivityCategory_MARITIME_getInstance = kotlin_com_universaliun_bitakore_common.$_$.p;
  var ActivityCategory_MOUNTAIN_getInstance = kotlin_com_universaliun_bitakore_common.$_$.q;
  var ActivityCategory_HEAVY_MACHINERY_getInstance = kotlin_com_universaliun_bitakore_common.$_$.o;
  var ActivityCategory_TECHNICAL_TRADES_getInstance = kotlin_com_universaliun_bitakore_common.$_$.r;
  var ActivityCategory_ATHLETICS_getInstance = kotlin_com_universaliun_bitakore_common.$_$.m;
  var ActivityCategory_ANIMAL_HANDLING_getInstance = kotlin_com_universaliun_bitakore_common.$_$.l;
  var ActivityCategory_VOCATIONAL_getInstance = kotlin_com_universaliun_bitakore_common.$_$.t;
  var listOf = kotlin_kotlin.$_$.v5;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.c3;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.t2;
  var Unit_instance = kotlin_kotlin.$_$.p2;
  var to = kotlin_kotlin.$_$.td;
  var mapOf = kotlin_kotlin.$_$.y5;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.q4;
  var mapCapacity = kotlin_kotlin.$_$.w5;
  var coerceAtLeast = kotlin_kotlin.$_$.ha;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.b3;
  var plus = kotlin_kotlin.$_$.z5;
  var Enum = kotlin_kotlin.$_$.lc;
  var VOID = kotlin_kotlin.$_$.b;
  var contains = kotlin_kotlin.$_$.wa;
  var endsWith = kotlin_kotlin.$_$.xa;
  var initMetadataForCompanion = kotlin_kotlin.$_$.f9;
  var emptyList = kotlin_kotlin.$_$.e5;
  var toString = kotlin_kotlin.$_$.da;
  var getBooleanHashCode = kotlin_kotlin.$_$.z8;
  var getNumberHashCode = kotlin_kotlin.$_$.a9;
  var hashCode = kotlin_kotlin.$_$.d9;
  var equals = kotlin_kotlin.$_$.y8;
  var valueOf = kotlin_com_universaliun_bitakore_common.$_$.a;
  var toList = kotlin_kotlin.$_$.p6;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.t3;
  var addAll = kotlin_kotlin.$_$.o4;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.z2;
  var MainScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d;
  var append = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.k;
  var THROW_CCE = kotlin_kotlin.$_$.tc;
  var isCharSequence = kotlin_kotlin.$_$.o9;
  var trim = kotlin_kotlin.$_$.ec;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.i3;
  var isBlank = kotlin_kotlin.$_$.bb;
  var first = kotlin_kotlin.$_$.i5;
  var take = kotlin_kotlin.$_$.qb;
  var last = kotlin_kotlin.$_$.s5;
  var CoroutineImpl = kotlin_kotlin.$_$.m7;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c;
  var isInterface = kotlin_kotlin.$_$.s9;
  var Companion_instance = kotlin_kotlin.$_$.k2;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.x6;
  var getKClass = kotlin_kotlin.$_$.sa;
  var arrayOf = kotlin_kotlin.$_$.hd;
  var createKType = kotlin_kotlin.$_$.qa;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
  var toSet = kotlin_kotlin.$_$.s6;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.h;
  var createFailure = kotlin_kotlin.$_$.jd;
  var emptySet = kotlin_kotlin.$_$.g5;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.j;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.k;
  var initMetadataForLambda = kotlin_kotlin.$_$.i9;
  var constructCallableReference = kotlin_kotlin.$_$.w8;
  var enumEncode = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.j;
  var attributesMapOf = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.o1;
  var IMG = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.y;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.r3;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.e;
  var initMetadataForObject = kotlin_kotlin.$_$.j9;
  var Collection = kotlin_kotlin.$_$.c4;
  var equals_0 = kotlin_kotlin.$_$.ya;
  var attributesMapOf_0 = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.p1;
  var DIV = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.s;
  var InputType_text_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.i;
  var INPUT = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.z;
  var set_id = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.r1;
  var set_onFocusFunction = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.n;
  var set_onInputFunction = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.o;
  var set_onBlurFunction = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.l;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.s2;
  var FunctionAdapter = kotlin_kotlin.$_$.k8;
  var Comparator = kotlin_kotlin.$_$.ic;
  var compareValues = kotlin_kotlin.$_$.v6;
  var sortedWith = kotlin_kotlin.$_$.j6;
  var set_onClickFunction = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.m;
  var enumEntries = kotlin_kotlin.$_$.o7;
  var mapOf_0 = kotlin_kotlin.$_$.x5;
  var emptyMap = kotlin_kotlin.$_$.f5;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.qd;
  var joinToString = kotlin_kotlin.$_$.o5;
  var plus_0 = kotlin_kotlin.$_$.b6;
  var removePrefix = kotlin_kotlin.$_$.eb;
  var split = kotlin_kotlin.$_$.jb;
  var toMap = kotlin_kotlin.$_$.r6;
  var P = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.e1;
  var BUTTON = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.r;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.d;
  var replace = kotlin_kotlin.$_$.hb;
  var OPTION = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.d1;
  var copyToArray = kotlin_kotlin.$_$.d5;
  var charSequenceLength = kotlin_kotlin.$_$.t8;
  var flatten = kotlin_kotlin.$_$.j5;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.e3;
  var shuffled = kotlin_kotlin.$_$.h6;
  var take_0 = kotlin_kotlin.$_$.l6;
  var until = kotlin_kotlin.$_$.oa;
  var numberRangeToNumber = kotlin_kotlin.$_$.x9;
  var Default_getInstance = kotlin_kotlin.$_$.e2;
  var random = kotlin_kotlin.$_$.ma;
  var random_0 = kotlin_kotlin.$_$.c6;
  var toMap_0 = kotlin_kotlin.$_$.q6;
  var numberToLong = kotlin_kotlin.$_$.g8;
  var Long = kotlin_kotlin.$_$.pc;
  var compare = kotlin_kotlin.$_$.t7;
  var KtList = kotlin_kotlin.$_$.h4;
  var createInvariantKTypeProjection = kotlin_kotlin.$_$.pa;
  var A = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.q;
  var unsafe = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.s1;
  var SVG = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.h1;
  var getValue = kotlin_kotlin.$_$.k5;
  var LABEL = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.a1;
  var set_onKeyDownFunction = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.p;
  var UL = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.n1;
  var InputType_hidden_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.f;
  var ButtonType_button_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.a;
  var round = kotlin_kotlin.$_$.fa;
  var numberToInt = kotlin_kotlin.$_$.z9;
  var SPAN = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.g1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k;
  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.q2;
  var lazy = kotlin_kotlin.$_$.od;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectCreate = kotlin_kotlin.$_$.aa;
  var toString_0 = kotlin_kotlin.$_$.sd;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
  var equalsLong = kotlin_kotlin.$_$.y7;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
  var LinkedHashSetSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i;
  var SerializableWith = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
  var values = kotlin_com_universaliun_bitakore_common.$_$.b;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var JsonObjectSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j;
  var values_0 = kotlin_com_universaliun_bitakore_common.$_$.e;
  var values_1 = kotlin_com_universaliun_bitakore_common.$_$.c;
  var values_2 = kotlin_com_universaliun_bitakore_common.$_$.f;
  var values_3 = kotlin_com_universaliun_bitakore_common.$_$.d;
  var values_4 = kotlin_com_universaliun_bitakore_common.$_$.j;
  var values_5 = kotlin_com_universaliun_bitakore_common.$_$.h;
  var Exception = kotlin_kotlin.$_$.nc;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.m3;
  var captureStack = kotlin_kotlin.$_$.o8;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.g9;
  var await_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
  var sum = kotlin_kotlin.$_$.k6;
  var KtSet = kotlin_kotlin.$_$.n4;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.f2;
  var toLongOrNull = kotlin_kotlin.$_$.wb;
  var TABLE = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.i1;
  var TR = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.m1;
  var TH = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.l1;
  var compareBy = kotlin_kotlin.$_$.u6;
  var TD = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.j1;
  var substringBefore = kotlin_kotlin.$_$.nb;
  var setOf = kotlin_kotlin.$_$.g6;
  var set_classes = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.q1;
  var InputType_password_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.h;
  var VisibilityDecision_APPROVED_getInstance = kotlin_com_universaliun_bitakore_common.$_$.y;
  var VisibilityDecision_REJECTED_getInstance = kotlin_com_universaliun_bitakore_common.$_$.z;
  var H3 = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.w;
  var ClaimDecision_APPROVED_getInstance = kotlin_com_universaliun_bitakore_common.$_$.u;
  var ClaimDecision_REJECTED_getInstance = kotlin_com_universaliun_bitakore_common.$_$.v;
  var compareTo = kotlin_kotlin.$_$.v8;
  var FORM = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.t;
  var InputType_email_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.d;
  var ButtonType_submit_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.b;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.w3;
  var fromInt = kotlin_kotlin.$_$.z7;
  var divide = kotlin_kotlin.$_$.x7;
  var modulo = kotlin_kotlin.$_$.d8;
  var padStart = kotlin_kotlin.$_$.db;
  var valueOf_0 = kotlin_com_universaliun_bitakore_common.$_$.g;
  var toDoubleOrNull = kotlin_kotlin.$_$.sb;
  var coerceAtMost = kotlin_kotlin.$_$.ia;
  var roundToInt = kotlin_kotlin.$_$.ea;
  var listOfNotNull = kotlin_kotlin.$_$.t5;
  var toList_0 = kotlin_kotlin.$_$.o6;
  var firstOrNull = kotlin_kotlin.$_$.h5;
  var SELECT = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.f1;
  var H4 = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.x;
  var OL = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.c1;
  var LI = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.b1;
  var substring = kotlin_kotlin.$_$.pb;
  var toIntOrNull = kotlin_kotlin.$_$.ub;
  var JsonObjectBuilder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.c;
  var put = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.h;
  var put_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.g;
  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.d;
  var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.b;
  var JsonPrimitive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.e;
  var put_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
  var substringAfterLast = kotlin_kotlin.$_$.lb;
  var PaymentMethodsLabels = kotlin_com_universaliun_payments_web.$_$.d;
  var WalletLabels = kotlin_com_universaliun_wallet_web.$_$.b;
  var AddCardLabels = kotlin_com_universaliun_payments_web.$_$.b;
  var get_walletKitJson = kotlin_com_universaliun_wallet_common.$_$.c;
  var WalletDto = kotlin_com_universaliun_wallet_common.$_$.b;
  var TopUpPaymentMethodOption = kotlin_com_universaliun_wallet_web.$_$.a;
  var renderWallet = kotlin_com_universaliun_wallet_web.$_$.c;
  var TopUpWalletRequestDto = kotlin_com_universaliun_wallet_common.$_$.a;
  var get_paymentsKitJson = kotlin_com_universaliun_payments_common.$_$.d;
  var PaymentMethodDto = kotlin_com_universaliun_payments_common.$_$.a;
  var renderPaymentMethodsList = kotlin_com_universaliun_payments_web.$_$.e;
  var AddCardFlow = kotlin_com_universaliun_payments_web.$_$.a;
  var PaymentMethodsClassNames = kotlin_com_universaliun_payments_web.$_$.c;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.k3;
  var InputType_number_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.g;
  var VerificationDecision_APPROVED_getInstance = kotlin_com_universaliun_bitakore_common.$_$.w;
  var VerificationDecision_REJECTED_getInstance = kotlin_com_universaliun_bitakore_common.$_$.x;
  var CompanyMemberRole_COMPANY_ADMIN_getInstance = kotlin_com_universaliun_bitakore_common.$_$.b1;
  var CompanyMemberRole_ACTIVITY_VERIFIER_getInstance = kotlin_com_universaliun_bitakore_common.$_$.a1;
  var H2 = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.v;
  var InputType_file_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.e;
  var CompanyType_MARKETER_getInstance = kotlin_com_universaliun_bitakore_common.$_$.d1;
  var CompanyType_ACTIVITY_CENTER_getInstance = kotlin_com_universaliun_bitakore_common.$_$.c1;
  var H1 = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.u;
  var valueOf_1 = kotlin_com_universaliun_bitakore_common.$_$.i;
  var TEXTAREA = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.k1;
  var InputType_checkBox_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_html.$_$.c;
  var ensureNotNull = kotlin_kotlin.$_$.kd;
  var setOf_0 = kotlin_kotlin.$_$.f6;
  var repeat = kotlin_kotlin.$_$.gb;
  var charCodeAt = kotlin_kotlin.$_$.r8;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.f;
  var numberToChar = kotlin_kotlin.$_$.y9;
  var charArrayOf = kotlin_kotlin.$_$.p8;
  var trimEnd = kotlin_kotlin.$_$.cc;
  var json = kotlin_kotlin.$_$.v9;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ActivityCatalogEntry, 'ActivityCatalogEntry');
  initMetadataForClass(FieldKind, 'FieldKind', VOID, Enum);
  initMetadataForClass(OutputMode, 'OutputMode', VOID, Enum);
  initMetadataForCompanion(Companion);
  initMetadataForClass(UnitDimension, 'UnitDimension', VOID, Enum);
  initMetadataForClass(ActivityField, 'ActivityField');
  initMetadataForClass(FieldGroup, 'FieldGroup');
  initMetadataForClass(ActivitySchema, 'ActivitySchema');
  initMetadataForLambda(CommonModule$initAuthNav$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CommonModule$initAuthNav$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForObject(CommonModule, 'CommonModule');
  initMetadataForClass(CountryCatalogEntry, 'CountryCatalogEntry');
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(Locale, 'Locale', VOID, Enum);
  initMetadataForObject(I18n, 'I18n');
  initMetadataForClass(ConsentState, 'ConsentState', VOID, Enum);
  initMetadataForObject(Analytics, 'Analytics');
  initMetadataForObject(ConsentBanner, 'ConsentBanner');
  initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForLambda(refreshAdCarousel$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(recordAdClick$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(flushAdDisplayTimes$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(runLocationSearch$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(resolveLocationLabel$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(startUpsellCheckout$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_1);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ErrorResponse, 'ErrorResponse', ErrorResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForCompanion(Companion_2);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TokenResponse, 'TokenResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForCompanion(Companion_3);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LoginRequest, 'LoginRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForCompanion(Companion_4);
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MeResponse, 'MeResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  initMetadataForCompanion(Companion_5);
  initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PasskeyRegistrationStartResponse, 'PasskeyRegistrationStartResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  initMetadataForCompanion(Companion_6);
  initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PasskeyRegistrationFinishRequest, 'PasskeyRegistrationFinishRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  initMetadataForCompanion(Companion_7);
  initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PasskeyRegistrationFinishResponse, 'PasskeyRegistrationFinishResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  initMetadataForCompanion(Companion_8);
  initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PasskeyLoginStartRequest, 'PasskeyLoginStartRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  initMetadataForCompanion(Companion_9);
  initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PasskeyLoginStartResponse, 'PasskeyLoginStartResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  initMetadataForCompanion(Companion_10);
  initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PasskeyLoginFinishRequest, 'PasskeyLoginFinishRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  initMetadataForCompanion(Companion_11);
  initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MagicLinkRequestRequest, 'MagicLinkRequestRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  initMetadataForCompanion(Companion_12);
  initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MagicLinkConsumeRequest, 'MagicLinkConsumeRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
  initMetadataForCompanion(Companion_13);
  initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ForgotPasswordRequest, 'ForgotPasswordRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
  initMetadataForCompanion(Companion_14);
  initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ResetPasswordRequest, 'ResetPasswordRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
  initMetadataForCompanion(Companion_15);
  initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupRequest, 'SetupRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
  initMetadataForCompanion(Companion_16);
  initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OAuthCompleteRequest, 'OAuthCompleteRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
  initMetadataForCompanion(Companion_17);
  initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpdateDisplayNameRequest, 'UpdateDisplayNameRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
  initMetadataForCompanion(Companion_18);
  initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpdateDisplayNameResponse, 'UpdateDisplayNameResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
  initMetadataForCompanion(Companion_19);
  initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UserAdminResponse, 'UserAdminResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
  initMetadataForCompanion(Companion_20);
  initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PagedUsersResponse, 'PagedUsersResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
  initMetadataForCompanion(Companion_21);
  initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpdateUserAdminRequest, 'UpdateUserAdminRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
  initMetadataForCompanion(Companion_22);
  initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RegisterOwnBitacoraEntryRequest, 'RegisterOwnBitacoraEntryRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
  initMetadataForCompanion(Companion_23);
  initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(VerifyBitacoraEntryRequest, 'VerifyBitacoraEntryRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_21});
  initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TrackPointResponse, 'TrackPointResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_22});
  initMetadataForCompanion(Companion_24);
  initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ActivityTrackResponse, 'ActivityTrackResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
  initMetadataForCompanion(Companion_25);
  initMetadataForObject($serializer_24, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(BitacoraEntryResponse, 'BitacoraEntryResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
  initMetadataForCompanion(Companion_26);
  initMetadataForObject($serializer_25, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TrackImportResponse, 'TrackImportResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_25});
  initMetadataForCompanion(Companion_27);
  initMetadataForObject($serializer_26, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetMyRegisteredActivitiesRequest, 'SetMyRegisteredActivitiesRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_26});
  initMetadataForCompanion(Companion_28);
  initMetadataForObject($serializer_27, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(InstructorCandidateResponse, 'InstructorCandidateResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_27});
  initMetadataForCompanion(Companion_29);
  initMetadataForObject($serializer_28, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(InviteToClaimEntryRequest, 'InviteToClaimEntryRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_28});
  initMetadataForCompanion(Companion_30);
  initMetadataForObject($serializer_29, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ClaimInvitationOutcomeResponse, 'ClaimInvitationOutcomeResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_29});
  initMetadataForCompanion(Companion_31);
  initMetadataForObject($serializer_30, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RegisterCenterBitacoraEntryRequest, 'RegisterCenterBitacoraEntryRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_30});
  initMetadataForCompanion(Companion_32);
  initMetadataForObject($serializer_31, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(GeocodeResultResponse, 'GeocodeResultResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_31});
  initMetadataForCompanion(Companion_33);
  initMetadataForObject($serializer_32, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ActivityCenterResponse, 'ActivityCenterResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_32});
  initMetadataForCompanion(Companion_34);
  initMetadataForObject($serializer_33, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MyLocationResponse, 'MyLocationResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_33});
  initMetadataForCompanion(Companion_35);
  initMetadataForObject($serializer_34, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DiscoverPhotoResponse, 'DiscoverPhotoResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_34});
  initMetadataForObject($serializer_35, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LeaderboardEntryResponse, 'LeaderboardEntryResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_35});
  initMetadataForCompanion(Companion_36);
  initMetadataForObject($serializer_36, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LeaderboardPeriodResponse, 'LeaderboardPeriodResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_36});
  initMetadataForCompanion(Companion_37);
  initMetadataForObject($serializer_37, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LeaderboardResponse, 'LeaderboardResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_37});
  initMetadataForCompanion(Companion_38);
  initMetadataForObject($serializer_38, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AdvertisementResponse, 'AdvertisementResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_38});
  initMetadataForCompanion(Companion_39);
  initMetadataForObject($serializer_39, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AdCampaignResponse, 'AdCampaignResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_39});
  initMetadataForCompanion(Companion_40);
  initMetadataForObject($serializer_40, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RecordAdDisplayTimeRequest, 'RecordAdDisplayTimeRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_40});
  initMetadataForCompanion(Companion_41);
  initMetadataForObject($serializer_41, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AllocateAdCampaignBudgetRequest, 'AllocateAdCampaignBudgetRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_41});
  initMetadataForCompanion(Companion_42);
  initMetadataForObject($serializer_42, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CheckoutSessionUrlResponse, 'CheckoutSessionUrlResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_42});
  initMetadataForCompanion(Companion_43);
  initMetadataForObject($serializer_43, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ActivityTypeTotalResponse, 'ActivityTypeTotalResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_43});
  initMetadataForCompanion(Companion_44);
  initMetadataForObject($serializer_44, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CompanyAnalyticsResponse, 'CompanyAnalyticsResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_44});
  initMetadataForCompanion(Companion_45);
  initMetadataForObject($serializer_45, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RegisterIssuingAuthorityRequest, 'RegisterIssuingAuthorityRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_45});
  initMetadataForCompanion(Companion_46);
  initMetadataForObject($serializer_46, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpdateIssuingAuthorityRequest, 'UpdateIssuingAuthorityRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_46});
  initMetadataForCompanion(Companion_47);
  initMetadataForObject($serializer_47, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(IssuingAuthorityResponse, 'IssuingAuthorityResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_47});
  initMetadataForCompanion(Companion_48);
  initMetadataForObject($serializer_48, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CreateCertificationTypeRequest, 'CreateCertificationTypeRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_48});
  initMetadataForCompanion(Companion_49);
  initMetadataForObject($serializer_49, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpdateCertificationTypeRequest, 'UpdateCertificationTypeRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_49});
  initMetadataForCompanion(Companion_50);
  initMetadataForObject($serializer_50, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CertificationTypeResponse, 'CertificationTypeResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_50});
  initMetadataForCompanion(Companion_51);
  initMetadataForObject($serializer_51, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CredentialResponse, 'CredentialResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_51});
  initMetadataForCompanion(Companion_52);
  initMetadataForObject($serializer_52, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetCompanyActivityOfferingsRequest, 'SetCompanyActivityOfferingsRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_52});
  initMetadataForCompanion(Companion_53);
  initMetadataForObject($serializer_53, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CompanyActivityOfferingsResponse, 'CompanyActivityOfferingsResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_53});
  initMetadataForCompanion(Companion_54);
  initMetadataForObject($serializer_54, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RequestCertificationVisibilityRequest, 'RequestCertificationVisibilityRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_54});
  initMetadataForCompanion(Companion_55);
  initMetadataForObject($serializer_55, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RespondToCertificationVisibilityRequestRequest, 'RespondToCertificationVisibilityRequestRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_55});
  initMetadataForCompanion(Companion_56);
  initMetadataForObject($serializer_56, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CertificationVisibilityRequestResponse, 'CertificationVisibilityRequestResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_56});
  initMetadataForCompanion(Companion_57);
  initMetadataForObject($serializer_57, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(VisibilityRequestOutcomeResponse, 'VisibilityRequestOutcomeResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_57});
  initMetadataForCompanion(Companion_58);
  initMetadataForObject($serializer_58, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RespondToClaimRequestRequest, 'RespondToClaimRequestRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_58});
  initMetadataForCompanion(Companion_59);
  initMetadataForObject($serializer_59, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(BitacoraEntryClaimRequestResponse, 'BitacoraEntryClaimRequestResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_59});
  initMetadataForCompanion(Companion_60);
  initMetadataForObject($serializer_60, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DeviceSyncConnectResponse, 'DeviceSyncConnectResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_60});
  initMetadataForCompanion(Companion_61);
  initMetadataForObject($serializer_61, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DeviceSyncConnectionResponse, 'DeviceSyncConnectionResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_61});
  initMetadataForCompanion(Companion_62);
  initMetadataForObject($serializer_62, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(StartSubscriptionCheckoutRequest, 'StartSubscriptionCheckoutRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_62});
  initMetadataForCompanion(Companion_63);
  initMetadataForObject($serializer_63, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AdSizeRateResponse, 'AdSizeRateResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_63});
  initMetadataForCompanion(Companion_64);
  initMetadataForObject($serializer_64, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AdTierSurchargeResponse, 'AdTierSurchargeResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_64});
  initMetadataForCompanion(Companion_65);
  initMetadataForObject($serializer_65, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AdPricingResponse, 'AdPricingResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_65});
  initMetadataForCompanion(Companion_66);
  initMetadataForObject($serializer_66, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetAdSizeRateRequest, 'SetAdSizeRateRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_66});
  initMetadataForCompanion(Companion_67);
  initMetadataForObject($serializer_67, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetAdTierSurchargeRequest, 'SetAdTierSurchargeRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_67});
  initMetadataForCompanion(Companion_68);
  initMetadataForObject($serializer_68, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RegisterCompanyRequest, 'RegisterCompanyRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_68});
  initMetadataForCompanion(Companion_69);
  initMetadataForObject($serializer_69, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RegisterCompanyResponse, 'RegisterCompanyResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_69});
  initMetadataForCompanion(Companion_70);
  initMetadataForObject($serializer_70, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RegisterPractitionerRequest, 'RegisterPractitionerRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_70});
  initMetadataForCompanion(Companion_71);
  initMetadataForObject($serializer_71, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RegisterPractitionerResponse, 'RegisterPractitionerResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_71});
  initMetadataForCompanion(Companion_72);
  initMetadataForObject($serializer_72, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AcceptInvitationRequest, 'AcceptInvitationRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_72});
  initMetadataForCompanion(Companion_73);
  initMetadataForObject($serializer_73, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MyProfileResponse, 'MyProfileResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_73});
  initMetadataForCompanion(Companion_74);
  initMetadataForObject($serializer_74, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpdateMyNicknameRequest, 'UpdateMyNicknameRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_74});
  initMetadataForCompanion(Companion_75);
  initMetadataForObject($serializer_75, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpdateMyNicknameResponse, 'UpdateMyNicknameResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_75});
  initMetadataForCompanion(Companion_76);
  initMetadataForObject($serializer_76, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UploadResponse, 'UploadResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_76});
  initMetadataForCompanion(Companion_77);
  initMetadataForObject($serializer_77, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CompanyResponse, 'CompanyResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_77});
  initMetadataForCompanion(Companion_78);
  initMetadataForObject($serializer_78, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpdateCompanyAdminRequest, 'UpdateCompanyAdminRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_78});
  initMetadataForCompanion(Companion_79);
  initMetadataForObject($serializer_79, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetCompanyLocationRequest, 'SetCompanyLocationRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_79});
  initMetadataForCompanion(Companion_80);
  initMetadataForObject($serializer_80, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PagedCompaniesResponse, 'PagedCompaniesResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_80});
  initMetadataForCompanion(Companion_81);
  initMetadataForObject($serializer_81, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(InviteCompanyMemberRequest, 'InviteCompanyMemberRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_81});
  initMetadataForCompanion(Companion_82);
  initMetadataForObject($serializer_82, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CompanyMemberResponse, 'CompanyMemberResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_82});
  initMetadataForCompanion(Companion_83);
  initMetadataForObject($serializer_83, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpdateCompanyMemberRoleRequest, 'UpdateCompanyMemberRoleRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_83});
  initMetadataForCompanion(Companion_84);
  initMetadataForObject($serializer_84, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CompanyPhotoResponse, 'CompanyPhotoResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_84});
  initMetadataForClass(ApiException, 'ApiException', VOID, Exception);
  initMetadataForCoroutine($deleteNoContentCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($rawRequestCOROUTINE$, CoroutineImpl);
  initMetadataForObject(ApiClient, 'ApiClient', VOID, VOID, VOID, [2, 4]);
  initMetadataForCoroutine($attachPasskeyToCurrentAccountCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($loginWithPasskeyCOROUTINE$, CoroutineImpl);
  initMetadataForObject(AcceptInvitationPageModule, 'AcceptInvitationPageModule');
  initMetadataForLambda(submitAcceptInvitation$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ActivityOfferingsPageModule, 'ActivityOfferingsPageModule');
  initMetadataForLambda(loadOfferings$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitOfferings$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(loadCompanyPhotos$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitCompanyPhotoUpload$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(deleteCompanyPhoto$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ActivitySelectionPageModule, 'ActivitySelectionPageModule');
  initMetadataForLambda(loadRegisteredActivities$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitActivitySelection$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(AdminAdPricingPageModule, 'AdminAdPricingPageModule');
  initMetadataForLambda(loadAdPricing$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitSizeRate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitTierSurcharge$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ActivityCentersPageModule, 'ActivityCentersPageModule');
  initMetadataForObject(CertificationIssuersPageModule, 'CertificationIssuersPageModule');
  initMetadataForObject(MarketersPageModule, 'MarketersPageModule');
  initMetadataForLambda(loadAdminCompanyCountries$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(loadAdminCompanies$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitCompanyForm$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(removeCompany$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(AdminUsersPageModule, 'AdminUsersPageModule');
  initMetadataForLambda(loadAdminUsers$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitUserForm$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(removeUser$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($attachPasskeyIfSelectedCOROUTINE$, CoroutineImpl);
  initMetadataForObject(CertificationTypesPageModule, 'CertificationTypesPageModule');
  initMetadataForLambda(loadAuthorities$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitNewAuthority$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(loadCertificationTypes$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(removeCertificationType$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitCertificationForm$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(CertificationVisibilityRequestsPageModule, 'CertificationVisibilityRequestsPageModule');
  initMetadataForLambda(loadPending$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(decide$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ClaimInvitationsPageModule, 'ClaimInvitationsPageModule');
  initMetadataForLambda(loadPendingClaims$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(decideClaim$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(CompanyActivityLogPageModule, 'CompanyActivityLogPageModule');
  initMetadataForLambda(loadCompanyEntries$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForLambda(submitClaimInvite$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(CompanyAnalyticsPageModule, 'CompanyAnalyticsPageModule');
  initMetadataForLambda(loadCompanyAnalytics$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(CompanyTeamPageModule, 'CompanyTeamPageModule');
  initMetadataForLambda(submitInviteMember$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(loadTeamMembers$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitMemberRoleForm$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(removeMember$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(DiscoverPageModule, 'DiscoverPageModule');
  initMetadataForLambda(loadRegisteredActivitiesForFilter$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(fallbackToCloudFrontLocation$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(runDiscoverSearch$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($fetchActivityCentersCOROUTINE$, CoroutineImpl);
  initMetadataForObject(ForgotPasswordPageModule, 'ForgotPasswordPageModule');
  initMetadataForLambda(submitForgotPasswordRequest$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(HomePageModule, 'HomePageModule');
  initMetadataForObject(IssuingAuthoritiesPageModule, 'IssuingAuthoritiesPageModule');
  initMetadataForLambda(loadAuthorities$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(removeAuthority$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitAuthorityForm$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(LeaderboardPageModule, 'LeaderboardPageModule');
  initMetadataForClass(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForLambda(loadRegisteredActivitiesForLeaderboard$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(loadLeaderboard$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(LogActivityPageModule, 'LogActivityPageModule');
  initMetadataForLambda(loadRegisteredActivitiesForFilter$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(runInstructorSearch$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitLogActivity$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($importTrackFileCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($uploadEntryPhotosCOROUTINE$, CoroutineImpl);
  initMetadataForObject(LogCenterActivityPageModule, 'LogCenterActivityPageModule');
  initMetadataForLambda(submitLogCenterActivity$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($uploadCenterEntryPhotosCOROUTINE$, CoroutineImpl);
  initMetadataForClass(CubeFaces, 'CubeFaces');
  initMetadataForObject(LoginPageModule, 'LoginPageModule');
  initMetadataForLambda(submitPasswordLogin$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitPasskeyLogin$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitMagicLinkRequest$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(MagicLinkLandingPageModule, 'MagicLinkLandingPageModule');
  initMetadataForLambda(consumeMagicLink$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(MarketerAdvertisementsPageModule, 'MarketerAdvertisementsPageModule');
  initMetadataForLambda(submitAdvertisement$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(loadAdvertisements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(deactivateAdvertisement$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($deleteRawCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($putRawCOROUTINE$, CoroutineImpl);
  initMetadataForObject(BitakorePaymentsHttpClient, 'BitakorePaymentsHttpClient', VOID, VOID, VOID, [1, 2]);
  initMetadataForObject(BitakoreWalletKitHttpClient, 'BitakoreWalletKitHttpClient', VOID, VOID, VOID, [1, 2]);
  initMetadataForObject(MarketerBillingPageModule, 'MarketerBillingPageModule');
  initMetadataForLambda(renderWalletSection$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitTopUp$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlin_Comparator$0_4, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForLambda(loadPaymentMethods$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(setDefaultPaymentMethod$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(removePaymentMethod$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(startAddPaymentMethod$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(MarketerCampaignsPageModule, 'MarketerCampaignsPageModule');
  initMetadataForLambda(submitCampaign$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(loadCampaigns$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(setCampaignStatus$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(topUpCampaignBudget$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(MyBitacoraPageModule, 'MyBitacoraPageModule');
  initMetadataForLambda(loadMyEntries$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlin_Comparator$0_5, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForObject(OAuthCallbackPageModule, 'OAuthCallbackPageModule');
  initMetadataForLambda(completeOAuthCallback$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(PendingApprovalsPageModule, 'PendingApprovalsPageModule');
  initMetadataForLambda(loadPending$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(decide$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForObject(PrivacyPageModule, 'PrivacyPageModule');
  initMetadataForObject(ProfilePageModule, 'ProfilePageModule');
  initMetadataForLambda(loadProfile$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(loadCompanyOfferingsLink$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitCompanyLocation$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitDisplayNameUpdate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitNicknameUpdate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitAvatarUpload$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(RegisterPageModule, 'RegisterPageModule');
  initMetadataForLambda(submitPractitionerRegistration$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitOrganizationRegistration$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(RequestCertificationVisibilityPageModule, 'RequestCertificationVisibilityPageModule');
  initMetadataForLambda(loadMyCompany$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(loadOfferings$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(saveOfferings$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(submitVisibilityRequest$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(loadSentRequests$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(viewCertifications$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ResetPasswordPageModule, 'ResetPasswordPageModule');
  initMetadataForLambda(submitResetPassword$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(SettingsPageModule, 'SettingsPageModule');
  initMetadataForLambda(loadConnections$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(connect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(disconnect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(SetupPageModule, 'SetupPageModule');
  initMetadataForLambda(submitSetup$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(TermsPageModule, 'TermsPageModule');
  initMetadataForCoroutine($navigateAfterAuthCOROUTINE$, CoroutineImpl);
  initMetadataForObject(AuthState, 'AuthState');
  initMetadataForCoroutine($createPasskeyCredentialCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getPasskeyAssertionCOROUTINE$, CoroutineImpl);
  //endregion
  function get_activityCatalog() {
    _init_properties_ActivityCatalog_kt__3j7xns();
    return activityCatalog;
  }
  var activityCatalog;
  function get_activityCatalogByCategory() {
    _init_properties_ActivityCatalog_kt__3j7xns();
    return activityCatalogByCategory;
  }
  var activityCatalogByCategory;
  function get_activityCategoryI18nKeys() {
    _init_properties_ActivityCatalog_kt__3j7xns();
    return activityCategoryI18nKeys;
  }
  var activityCategoryI18nKeys;
  var activityCategoryEnglishLabels;
  function get_recreationalActivityTypeI18nKeys() {
    _init_properties_ActivityCatalog_kt__3j7xns();
    return recreationalActivityTypeI18nKeys;
  }
  var recreationalActivityTypeI18nKeys;
  function get_activityTypeDisplayI18nKeys() {
    _init_properties_ActivityCatalog_kt__3j7xns();
    return activityTypeDisplayI18nKeys;
  }
  var activityTypeDisplayI18nKeys;
  function ActivityCatalogEntry(value, label, category, labelI18nKey) {
    this.s24_1 = value;
    this.t24_1 = label;
    this.u24_1 = category;
    this.v24_1 = labelI18nKey;
  }
  protoOf(ActivityCatalogEntry).toString = function () {
    return 'ActivityCatalogEntry(value=' + this.s24_1 + ', label=' + this.t24_1 + ', category=' + this.u24_1.toString() + ', labelI18nKey=' + this.v24_1 + ')';
  };
  protoOf(ActivityCatalogEntry).hashCode = function () {
    var result = getStringHashCode(this.s24_1);
    result = imul(result, 31) + getStringHashCode(this.t24_1) | 0;
    result = imul(result, 31) + this.u24_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.v24_1) | 0;
    return result;
  };
  protoOf(ActivityCatalogEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ActivityCatalogEntry))
      return false;
    if (!(this.s24_1 === other.s24_1))
      return false;
    if (!(this.t24_1 === other.t24_1))
      return false;
    if (!this.u24_1.equals(other.u24_1))
      return false;
    if (!(this.v24_1 === other.v24_1))
      return false;
    return true;
  };
  var properties_initialized_ActivityCatalog_kt_igboli;
  function _init_properties_ActivityCatalog_kt__3j7xns() {
    if (!properties_initialized_ActivityCatalog_kt_igboli) {
      properties_initialized_ActivityCatalog_kt_igboli = true;
      activityCatalog = listOf([new ActivityCatalogEntry('STUDENT_PILOT', 'Student Pilot', ActivityCategory_AVIATION_getInstance(), 'activityCatalog.type.studentPilot'), new ActivityCatalogEntry('AIRLINE_TRANSPORT_PILOT', 'Airline Transport Pilot', ActivityCategory_AVIATION_getInstance(), 'activityCatalog.type.airlineTransportPilot'), new ActivityCatalogEntry('FLIGHT_INSTRUCTOR', 'Flight Instructor', ActivityCategory_AVIATION_getInstance(), 'activityCatalog.type.flightInstructor'), new ActivityCatalogEntry('AIRCRAFT_MAINTENANCE_TECHNICIAN', 'Aircraft Maintenance Technician', ActivityCategory_AVIATION_getInstance(), 'activityCatalog.type.aircraftMaintenanceTechnician'), new ActivityCatalogEntry('DRONE_OPERATOR', 'Drone / UAS Operator', ActivityCategory_AVIATION_getInstance(), 'activityCatalog.type.droneOperator'), new ActivityCatalogEntry('GLIDER_PILOT', 'Glider & Sailplane Pilot', ActivityCategory_AVIATION_getInstance(), 'activityCatalog.type.gliderPilot'), new ActivityCatalogEntry('HOT_AIR_BALLOON_PILOT', 'Hot Air Balloon Pilot', ActivityCategory_AVIATION_getInstance(), 'activityCatalog.type.hotAirBalloonPilot'), new ActivityCatalogEntry('FLIGHT_SIMULATOR_OPERATOR', 'Flight Simulator Operator', ActivityCategory_AVIATION_getInstance(), 'activityCatalog.type.flightSimulatorOperator'), new ActivityCatalogEntry('ASTRONAUT', 'Astronaut / Analog Astronaut', ActivityCategory_AVIATION_getInstance(), 'activityCatalog.type.astronaut'), new ActivityCatalogEntry('AEROBATIC_PILOT', 'Aerobatic & Airshow Pilot', ActivityCategory_AVIATION_getInstance(), 'activityCatalog.type.aerobaticPilot'), new ActivityCatalogEntry('PARACHUTE_RIGGER', 'Parachute Rigger', ActivityCategory_AVIATION_getInstance(), 'activityCatalog.type.parachuteRigger'), new ActivityCatalogEntry('SKYDIVER', 'Skydiver', ActivityCategory_AIR_SPORTS_getInstance(), 'activityCatalog.type.skydiver'), new ActivityCatalogEntry('PARAGLIDER', 'Paraglider', ActivityCategory_AIR_SPORTS_getInstance(), 'activityCatalog.type.paraglider'), new ActivityCatalogEntry('HANG_GLIDER', 'Hang Glider', ActivityCategory_AIR_SPORTS_getInstance(), 'activityCatalog.type.hangGlider'), new ActivityCatalogEntry('BASE_JUMPER', 'BASE Jumper', ActivityCategory_AIR_SPORTS_getInstance(), 'activityCatalog.type.baseJumper'), new ActivityCatalogEntry('PARAMOTOR_PILOT', 'Paramotor (PPG) Pilot', ActivityCategory_AIR_SPORTS_getInstance(), 'activityCatalog.type.paramotorPilot'), new ActivityCatalogEntry('SPEEDWING_FLYER', 'Speedwing / Proximity Flyer', ActivityCategory_AIR_SPORTS_getInstance(), 'activityCatalog.type.speedwingFlyer'), new ActivityCatalogEntry('WINGSUIT_PILOT', 'Wingsuit Pilot', ActivityCategory_AIR_SPORTS_getInstance(), 'activityCatalog.type.wingsuitPilot'), new ActivityCatalogEntry('INDOOR_SKYDIVING_COACH', 'Indoor Skydiving Coach', ActivityCategory_AIR_SPORTS_getInstance(), 'activityCatalog.type.indoorSkydivingCoach'), new ActivityCatalogEntry('RECREATIONAL_SCUBA_DIVER', 'Recreational Scuba Diver', ActivityCategory_UNDERWATER_getInstance(), 'activityCatalog.type.recreationalScubaDiver'), new ActivityCatalogEntry('TECHNICAL_DIVER', 'Technical & Deep Diver', ActivityCategory_UNDERWATER_getInstance(), 'activityCatalog.type.technicalDiver'), new ActivityCatalogEntry('COMMERCIAL_DIVER', 'Commercial & Saturation Diver', ActivityCategory_UNDERWATER_getInstance(), 'activityCatalog.type.commercialDiver'), new ActivityCatalogEntry('SCIENTIFIC_RESEARCH_DIVER', 'Scientific Research Diver', ActivityCategory_UNDERWATER_getInstance(), 'activityCatalog.type.scientificResearchDiver'), new ActivityCatalogEntry('FREEDIVER', 'Freediver', ActivityCategory_UNDERWATER_getInstance(), 'activityCatalog.type.freediver'), new ActivityCatalogEntry('PUBLIC_SAFETY_DIVER', 'Public Safety Diver', ActivityCategory_UNDERWATER_getInstance(), 'activityCatalog.type.publicSafetyDiver'), new ActivityCatalogEntry('SPEARFISHING_DIVER', 'Spearfishing Diver', ActivityCategory_UNDERWATER_getInstance(), 'activityCatalog.type.spearfishingDiver'), new ActivityCatalogEntry('UNDERWATER_PHOTOGRAPHER', 'Underwater Photographer', ActivityCategory_UNDERWATER_getInstance(), 'activityCatalog.type.underwaterPhotographer'), new ActivityCatalogEntry('MERCHANT_MARINE', 'Merchant Marine / Commercial Crew', ActivityCategory_MARITIME_getInstance(), 'activityCatalog.type.merchantMarine'), new ActivityCatalogEntry('SAILING_CAPTAIN', 'Sailing & Yachting Captain', ActivityCategory_MARITIME_getInstance(), 'activityCatalog.type.sailingCaptain'), new ActivityCatalogEntry('WHITEWATER_GUIDE', 'Professional Whitewater Guide', ActivityCategory_MARITIME_getInstance(), 'activityCatalog.type.whitewaterGuide'), new ActivityCatalogEntry('LIFEGUARD', 'Lifeguard / Open-Water Rescue', ActivityCategory_MARITIME_getInstance(), 'activityCatalog.type.lifeguard'), new ActivityCatalogEntry('ROWING_ATHLETE', 'Rowing & Sculling Athlete', ActivityCategory_MARITIME_getInstance(), 'activityCatalog.type.rowingAthlete'), new ActivityCatalogEntry('SURFER', 'Surfer / Stand-Up Paddleboarder', ActivityCategory_MARITIME_getInstance(), 'activityCatalog.type.surfer'), new ActivityCatalogEntry('KITESURFER', 'Kitesurfer & Windsurfer', ActivityCategory_MARITIME_getInstance(), 'activityCatalog.type.kitesurfer'), new ActivityCatalogEntry('ALPINE_MOUNTAINEER', 'Alpine Mountaineer', ActivityCategory_MOUNTAIN_getInstance(), 'activityCatalog.type.alpineMountaineer'), new ActivityCatalogEntry('ROCK_CLIMBER', 'Rock Climber', ActivityCategory_MOUNTAIN_getInstance(), 'activityCatalog.type.rockClimber'), new ActivityCatalogEntry('ICE_CLIMBER', 'Ice Climber', ActivityCategory_MOUNTAIN_getInstance(), 'activityCatalog.type.iceClimber'), new ActivityCatalogEntry('SPELUNKER', 'Spelunker (Cave Explorer)', ActivityCategory_MOUNTAIN_getInstance(), 'activityCatalog.type.spelunker'), new ActivityCatalogEntry('THRU_HIKER', 'Backcountry & Thru-Hiker', ActivityCategory_MOUNTAIN_getInstance(), 'activityCatalog.type.thruHiker'), new ActivityCatalogEntry('CANYONEER', 'Canyoneer', ActivityCategory_MOUNTAIN_getInstance(), 'activityCatalog.type.canyoneer'), new ActivityCatalogEntry('BACKCOUNTRY_SKIER', 'Backcountry & Splitboard Skier', ActivityCategory_MOUNTAIN_getInstance(), 'activityCatalog.type.backcountrySkier'), new ActivityCatalogEntry('CDL_TRUCK_DRIVER', 'Commercial Truck Driver (CDL)', ActivityCategory_HEAVY_MACHINERY_getInstance(), 'activityCatalog.type.cdlTruckDriver'), new ActivityCatalogEntry('TRANSIT_OPERATOR', 'Bus, Transit & Passenger Operator', ActivityCategory_HEAVY_MACHINERY_getInstance(), 'activityCatalog.type.transitOperator'), new ActivityCatalogEntry('CRANE_OPERATOR', 'Tower Crane & Rigging Operator', ActivityCategory_HEAVY_MACHINERY_getInstance(), 'activityCatalog.type.craneOperator'), new ActivityCatalogEntry('FORKLIFT_OPERATOR', 'Forklift & Warehouse Operator', ActivityCategory_HEAVY_MACHINERY_getInstance(), 'activityCatalog.type.forkliftOperator'), new ActivityCatalogEntry('RAILWAY_CONDUCTOR', 'Railway Conductor / Engineer', ActivityCategory_HEAVY_MACHINERY_getInstance(), 'activityCatalog.type.railwayConductor'), new ActivityCatalogEntry('HEAVY_EQUIPMENT_OPERATOR', 'Heavy Equipment Operator', ActivityCategory_HEAVY_MACHINERY_getInstance(), 'activityCatalog.type.heavyEquipmentOperator'), new ActivityCatalogEntry('LAB_RESEARCHER', 'Laboratory Researcher / Chemist', ActivityCategory_TECHNICAL_TRADES_getInstance(), 'activityCatalog.type.labResearcher'), new ActivityCatalogEntry('HAM_RADIO_OPERATOR', 'Amateur (Ham) Radio Operator', ActivityCategory_TECHNICAL_TRADES_getInstance(), 'activityCatalog.type.hamRadioOperator'), new ActivityCatalogEntry('ENVIRONMENTAL_FIELD_CREW', 'Environmental Field Sampling Crew', ActivityCategory_TECHNICAL_TRADES_getInstance(), 'activityCatalog.type.environmentalFieldCrew'), new ActivityCatalogEntry('SOFTWARE_QA_ENGINEER', 'Software QA Engineer / Red-Team', ActivityCategory_TECHNICAL_TRADES_getInstance(), 'activityCatalog.type.softwareQaEngineer'), new ActivityCatalogEntry('SOUND_ENGINEER', 'Sound & Recording Engineer', ActivityCategory_TECHNICAL_TRADES_getInstance(), 'activityCatalog.type.soundEngineer'), new ActivityCatalogEntry('LAND_SURVEYOR', 'Land & Geodetic Surveyor', ActivityCategory_TECHNICAL_TRADES_getInstance(), 'activityCatalog.type.landSurveyor'), new ActivityCatalogEntry('POWERLIFTER', 'Powerlifter & Weightlifter', ActivityCategory_ATHLETICS_getInstance(), 'activityCatalog.type.powerlifter'), new ActivityCatalogEntry('TRAIL_RUNNER', 'Marathon, Ultra & Trail Runner', ActivityCategory_ATHLETICS_getInstance(), 'activityCatalog.type.trailRunner'), new ActivityCatalogEntry('TRIATHLETE', 'Triathlete (Ironman/Multisport)', ActivityCategory_ATHLETICS_getInstance(), 'activityCatalog.type.triathlete'), new ActivityCatalogEntry('PHYSICAL_THERAPY_PATIENT', 'Physical Therapy & Rehab Patient', ActivityCategory_ATHLETICS_getInstance(), 'activityCatalog.type.physicalTherapyPatient'), new ActivityCatalogEntry('TRACK_AND_FIELD_THROWER', 'Track & Field Thrower', ActivityCategory_ATHLETICS_getInstance(), 'activityCatalog.type.trackAndFieldThrower'), new ActivityCatalogEntry('COMPETITIVE_CYCLIST', 'Competitive Cyclist', ActivityCategory_ATHLETICS_getInstance(), 'activityCatalog.type.competitiveCyclist'), new ActivityCatalogEntry('COMPETITIVE_SWIMMER', 'Competitive Swimmer', ActivityCategory_ATHLETICS_getInstance(), 'activityCatalog.type.competitiveSwimmer'), new ActivityCatalogEntry('EQUESTRIAN', 'Equestrian & Horse Trainer', ActivityCategory_ANIMAL_HANDLING_getInstance(), 'activityCatalog.type.equestrian'), new ActivityCatalogEntry('WORKING_DOG_HANDLER', 'Working Dog Handler (K9/SAR)', ActivityCategory_ANIMAL_HANDLING_getInstance(), 'activityCatalog.type.workingDogHandler'), new ActivityCatalogEntry('FALCONER', 'Falconer', ActivityCategory_ANIMAL_HANDLING_getInstance(), 'activityCatalog.type.falconer'), new ActivityCatalogEntry('BEEKEEPER', 'Beekeeper (Apiary Manager)', ActivityCategory_ANIMAL_HANDLING_getInstance(), 'activityCatalog.type.beekeeper'), new ActivityCatalogEntry('LIVESTOCK_HANDLER', 'Livestock & Ranch Handler', ActivityCategory_ANIMAL_HANDLING_getInstance(), 'activityCatalog.type.livestockHandler'), new ActivityCatalogEntry('TATTOO_APPRENTICE', 'Tattoo & Body Piercing Apprentice', ActivityCategory_VOCATIONAL_getInstance(), 'activityCatalog.type.tattooApprentice'), new ActivityCatalogEntry('TRADE_APPRENTICE', 'Electrician/Plumbing/HVAC Apprentice', ActivityCategory_VOCATIONAL_getInstance(), 'activityCatalog.type.tradeApprentice'), new ActivityCatalogEntry('SCUBA_LIFE_SUPPORT_TECHNICIAN', 'Scuba Life-Support Repair Technician', ActivityCategory_VOCATIONAL_getInstance(), 'activityCatalog.type.scubaLifeSupportTechnician'), new ActivityCatalogEntry('WELDING_APPRENTICE', 'Welding Apprentice', ActivityCategory_VOCATIONAL_getInstance(), 'activityCatalog.type.weldingApprentice'), new ActivityCatalogEntry('CULINARY_APPRENTICE', 'Culinary Apprentice', ActivityCategory_VOCATIONAL_getInstance(), 'activityCatalog.type.culinaryApprentice')]);
      // Inline function 'kotlin.collections.groupBy' call
      var tmp0 = get_activityCatalog();
      // Inline function 'kotlin.collections.groupByTo' call
      var destination = LinkedHashMap_init_$Create$();
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var key = element.u24_1;
        // Inline function 'kotlin.collections.getOrPut' call
        var value = destination.i2(key);
        var tmp;
        if (value == null) {
          var answer = ArrayList_init_$Create$();
          destination.m2(key, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        var list = tmp;
        list.x(element);
      }
      activityCatalogByCategory = destination;
      activityCategoryI18nKeys = mapOf([to(ActivityCategory_AVIATION_getInstance(), 'activityCatalog.category.aviation'), to(ActivityCategory_AIR_SPORTS_getInstance(), 'activityCatalog.category.nonEngineAirSports'), to(ActivityCategory_UNDERWATER_getInstance(), 'activityCatalog.category.underwaterSports'), to(ActivityCategory_MARITIME_getInstance(), 'activityCatalog.category.maritime'), to(ActivityCategory_MOUNTAIN_getInstance(), 'activityCatalog.category.mountainClimbing'), to(ActivityCategory_HEAVY_MACHINERY_getInstance(), 'activityCatalog.category.heavyMachinery'), to(ActivityCategory_TECHNICAL_TRADES_getInstance(), 'activityCatalog.category.technicalTrades'), to(ActivityCategory_ATHLETICS_getInstance(), 'activityCatalog.category.highPerformanceAthletics'), to(ActivityCategory_ANIMAL_HANDLING_getInstance(), 'activityCatalog.category.animalHandling'), to(ActivityCategory_VOCATIONAL_getInstance(), 'activityCatalog.category.vocationalApprenticeships')]);
      activityCategoryEnglishLabels = mapOf([to(ActivityCategory_AVIATION_getInstance(), 'Aviation, Aerospace & Spaceflight'), to(ActivityCategory_AIR_SPORTS_getInstance(), 'Non-Engine Air Sports & Freeflight'), to(ActivityCategory_UNDERWATER_getInstance(), 'Underwater Sports, Sciences & Exploration'), to(ActivityCategory_MARITIME_getInstance(), 'Maritime, Vessel & Water Sports'), to(ActivityCategory_MOUNTAIN_getInstance(), 'Mountain, Climbing & Wilderness Exploration'), to(ActivityCategory_HEAVY_MACHINERY_getInstance(), 'Heavy Machinery, Transport & Logistics'), to(ActivityCategory_TECHNICAL_TRADES_getInstance(), 'Technical Trades, Radio & Lab Sciences'), to(ActivityCategory_ATHLETICS_getInstance(), 'High-Performance Athletics & Sports Medicine'), to(ActivityCategory_ANIMAL_HANDLING_getInstance(), 'Animal Handling, Training & Ecosystems'), to(ActivityCategory_VOCATIONAL_getInstance(), 'Vocational Apprenticeships & Creative Guilds')]);
      recreationalActivityTypeI18nKeys = mapOf([to('WALKER', 'activityCatalog.recreational.walker'), to('RUNNER', 'activityCatalog.recreational.runner'), to('RAFTER', 'activityCatalog.recreational.rafter'), to('GOLFER', 'activityCatalog.recreational.golfer'), to('DARTS_PLAYER', 'activityCatalog.recreational.dartsPlayer'), to('BASEBALL_PLAYER', 'activityCatalog.recreational.baseballPlayer'), to('BILLIARDS_PLAYER', 'activityCatalog.recreational.billiardsPlayer'), to('ALPINE_SKIER', 'activityCatalog.recreational.alpineSkier'), to('DOWNHILL_MOUNTAIN_BIKER', 'activityCatalog.recreational.downhillMountainBiker'), to('YOGA_PRACTITIONER', 'activityCatalog.recreational.yogaPractitioner'), to('CARD_PLAYER', 'activityCatalog.recreational.cardPlayer'), to('RACE_CAR_DRIVER', 'activityCatalog.recreational.raceCarDriver'), to('MOTORCYCLE_RIDER', 'activityCatalog.recreational.motorcycleRider')]);
      // Inline function 'kotlin.collections.associate' call
      var this_0 = get_activityCatalog();
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination_0 = LinkedHashMap_init_$Create$_0(capacity);
      var _iterator__ex2g4s_0 = this_0.t();
      while (_iterator__ex2g4s_0.u()) {
        var element_0 = _iterator__ex2g4s_0.v();
        // Inline function 'kotlin.collections.plusAssign' call
        var pair = to(element_0.s24_1, element_0.v24_1);
        destination_0.m2(pair.e9_1, pair.f9_1);
      }
      activityTypeDisplayI18nKeys = plus(destination_0, get_recreationalActivityTypeI18nKeys());
    }
  }
  function get_ACTIVITY_SCHEMAS() {
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return ACTIVITY_SCHEMAS;
  }
  var ACTIVITY_SCHEMAS;
  function get_ACTIVITY_FIELD_GROUPS() {
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return ACTIVITY_FIELD_GROUPS;
  }
  var ACTIVITY_FIELD_GROUPS;
  var FieldKind_TEXT_instance;
  var FieldKind_NUMBER_instance;
  var FieldKind_INT_instance;
  var FieldKind_BOOLEAN_instance;
  var FieldKind_CSV_LIST_instance;
  var FieldKind_CSV_NUMBER_LIST_instance;
  var FieldKind_SELECT_instance;
  var FieldKind_entriesInitialized;
  function FieldKind_initEntries() {
    if (FieldKind_entriesInitialized)
      return Unit_instance;
    FieldKind_entriesInitialized = true;
    FieldKind_TEXT_instance = new FieldKind('TEXT', 0);
    FieldKind_NUMBER_instance = new FieldKind('NUMBER', 1);
    FieldKind_INT_instance = new FieldKind('INT', 2);
    FieldKind_BOOLEAN_instance = new FieldKind('BOOLEAN', 3);
    FieldKind_CSV_LIST_instance = new FieldKind('CSV_LIST', 4);
    FieldKind_CSV_NUMBER_LIST_instance = new FieldKind('CSV_NUMBER_LIST', 5);
    FieldKind_SELECT_instance = new FieldKind('SELECT', 6);
  }
  function FieldKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  var OutputMode_OMIT_IF_BLANK_instance;
  var OutputMode_ALWAYS_STRING_instance;
  var OutputMode_ALWAYS_NUMBER_instance;
  var OutputMode_ALWAYS_LIST_instance;
  var OutputMode_ALWAYS_BOOLEAN_instance;
  var OutputMode_FIXED_instance;
  var OutputMode_entriesInitialized;
  function OutputMode_initEntries() {
    if (OutputMode_entriesInitialized)
      return Unit_instance;
    OutputMode_entriesInitialized = true;
    OutputMode_OMIT_IF_BLANK_instance = new OutputMode('OMIT_IF_BLANK', 0);
    OutputMode_ALWAYS_STRING_instance = new OutputMode('ALWAYS_STRING', 1);
    OutputMode_ALWAYS_NUMBER_instance = new OutputMode('ALWAYS_NUMBER', 2);
    OutputMode_ALWAYS_LIST_instance = new OutputMode('ALWAYS_LIST', 3);
    OutputMode_ALWAYS_BOOLEAN_instance = new OutputMode('ALWAYS_BOOLEAN', 4);
    OutputMode_FIXED_instance = new OutputMode('FIXED', 5);
  }
  function OutputMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  var UnitDimension_LENGTH_M_instance;
  var UnitDimension_LENGTH_FT_instance;
  var UnitDimension_LENGTH_KM_instance;
  var UnitDimension_LENGTH_NM_instance;
  var UnitDimension_LENGTH_MM_instance;
  var UnitDimension_TEMPERATURE_C_instance;
  var UnitDimension_PRESSURE_BAR_instance;
  var UnitDimension_PRESSURE_KPA_instance;
  var UnitDimension_PRESSURE_HPA_instance;
  var UnitDimension_SPEED_KPH_instance;
  var UnitDimension_SPEED_KNOTS_instance;
  var UnitDimension_MASS_KG_instance;
  var UnitDimension_VOLUME_L_instance;
  function Companion() {
  }
  protoOf(Companion).w24 = function (id, kind) {
    if (!kind.equals(FieldKind_NUMBER_getInstance()) && !kind.equals(FieldKind_INT_getInstance()))
      return null;
    if (contains(id, 'Seconds'))
      return null;
    return contains(id, 'Temp') && endsWith(id, 'C') ? UnitDimension_TEMPERATURE_C_getInstance() : endsWith(id, 'Kpa') ? UnitDimension_PRESSURE_KPA_getInstance() : endsWith(id, 'Hpa') ? UnitDimension_PRESSURE_HPA_getInstance() : endsWith(id, 'Bar') ? UnitDimension_PRESSURE_BAR_getInstance() : endsWith(id, 'Kph') ? UnitDimension_SPEED_KPH_getInstance() : endsWith(id, 'Knots') ? UnitDimension_SPEED_KNOTS_getInstance() : endsWith(id, 'Km') ? UnitDimension_LENGTH_KM_getInstance() : endsWith(id, 'Nm') ? UnitDimension_LENGTH_NM_getInstance() : endsWith(id, 'Mm') ? UnitDimension_LENGTH_MM_getInstance() : endsWith(id, 'Feet') ? UnitDimension_LENGTH_FT_getInstance() : endsWith(id, 'Meters') ? UnitDimension_LENGTH_M_getInstance() : endsWith(id, 'Kg') ? UnitDimension_MASS_KG_getInstance() : endsWith(id, 'Liters') ? UnitDimension_VOLUME_L_getInstance() : null;
  };
  var Companion_instance_0;
  function Companion_getInstance() {
    return Companion_instance_0;
  }
  function UnitDimension$lambda(ft) {
    return ft * 0.3048;
  }
  function UnitDimension$lambda_0(m) {
    return m / 0.3048;
  }
  function UnitDimension$lambda_1(mi) {
    return mi * 1.60934;
  }
  function UnitDimension$lambda_2(km) {
    return km / 1.852;
  }
  function UnitDimension$lambda_3(inches) {
    return inches * 25.4;
  }
  function UnitDimension$lambda_4(f) {
    return (f - 32.0) * 5.0 / 9.0;
  }
  function UnitDimension$lambda_5(psi) {
    return psi * 0.0689476;
  }
  function UnitDimension$lambda_6(psi) {
    return psi * 6.89476;
  }
  function UnitDimension$lambda_7(inHg) {
    return inHg * 33.8639;
  }
  function UnitDimension$lambda_8(mph) {
    return mph * 1.60934;
  }
  function UnitDimension$lambda_9(kph) {
    return kph / 1.852;
  }
  function UnitDimension$lambda_10(lb) {
    return lb * 0.453592;
  }
  function UnitDimension$lambda_11(gal) {
    return gal * 3.78541;
  }
  var UnitDimension_entriesInitialized;
  function UnitDimension_initEntries() {
    if (UnitDimension_entriesInitialized)
      return Unit_instance;
    UnitDimension_entriesInitialized = true;
    UnitDimension_LENGTH_M_instance = new UnitDimension('LENGTH_M', 0, 'unit.meters', 'unit.feet', UnitDimension$lambda);
    UnitDimension_LENGTH_FT_instance = new UnitDimension('LENGTH_FT', 1, 'unit.feet', 'unit.meters', UnitDimension$lambda_0);
    UnitDimension_LENGTH_KM_instance = new UnitDimension('LENGTH_KM', 2, 'unit.km', 'unit.miles', UnitDimension$lambda_1);
    UnitDimension_LENGTH_NM_instance = new UnitDimension('LENGTH_NM', 3, 'unit.nm', 'unit.km', UnitDimension$lambda_2);
    UnitDimension_LENGTH_MM_instance = new UnitDimension('LENGTH_MM', 4, 'unit.mm', 'unit.inches', UnitDimension$lambda_3);
    UnitDimension_TEMPERATURE_C_instance = new UnitDimension('TEMPERATURE_C', 5, 'unit.celsius', 'unit.fahrenheit', UnitDimension$lambda_4);
    UnitDimension_PRESSURE_BAR_instance = new UnitDimension('PRESSURE_BAR', 6, 'unit.bar', 'unit.psi', UnitDimension$lambda_5);
    UnitDimension_PRESSURE_KPA_instance = new UnitDimension('PRESSURE_KPA', 7, 'unit.kpa', 'unit.psi', UnitDimension$lambda_6);
    UnitDimension_PRESSURE_HPA_instance = new UnitDimension('PRESSURE_HPA', 8, 'unit.hpa', 'unit.inHg', UnitDimension$lambda_7);
    UnitDimension_SPEED_KPH_instance = new UnitDimension('SPEED_KPH', 9, 'unit.kph', 'unit.mph', UnitDimension$lambda_8);
    UnitDimension_SPEED_KNOTS_instance = new UnitDimension('SPEED_KNOTS', 10, 'unit.knots', 'unit.kph', UnitDimension$lambda_9);
    UnitDimension_MASS_KG_instance = new UnitDimension('MASS_KG', 11, 'unit.kg', 'unit.lb', UnitDimension$lambda_10);
    UnitDimension_VOLUME_L_instance = new UnitDimension('VOLUME_L', 12, 'unit.liters', 'unit.gallons', UnitDimension$lambda_11);
  }
  function UnitDimension(name, ordinal, canonicalSymbolI18nKey, alternateSymbolI18nKey, alternateToCanonical) {
    Enum.call(this, name, ordinal);
    this.z24_1 = canonicalSymbolI18nKey;
    this.a25_1 = alternateSymbolI18nKey;
    this.b25_1 = alternateToCanonical;
  }
  function ActivityField(id, i18nKey, kind, outputMode, jsonKey, required, numberDefault, fixedValue, allowNegative, mustBePositive, selectOptions) {
    kind = kind === VOID ? FieldKind_TEXT_getInstance() : kind;
    outputMode = outputMode === VOID ? OutputMode_OMIT_IF_BLANK_getInstance() : outputMode;
    jsonKey = jsonKey === VOID ? id : jsonKey;
    required = required === VOID ? false : required;
    numberDefault = numberDefault === VOID ? 0.0 : numberDefault;
    fixedValue = fixedValue === VOID ? null : fixedValue;
    allowNegative = allowNegative === VOID ? false : allowNegative;
    mustBePositive = mustBePositive === VOID ? false : mustBePositive;
    selectOptions = selectOptions === VOID ? emptyList() : selectOptions;
    this.c25_1 = id;
    this.d25_1 = i18nKey;
    this.e25_1 = kind;
    this.f25_1 = outputMode;
    this.g25_1 = jsonKey;
    this.h25_1 = required;
    this.i25_1 = numberDefault;
    this.j25_1 = fixedValue;
    this.k25_1 = allowNegative;
    this.l25_1 = mustBePositive;
    this.m25_1 = selectOptions;
    this.n25_1 = Companion_instance_0.w24(this.c25_1, this.e25_1);
    var tmp = this;
    var tmp0_subject = this.n25_1;
    tmp.o25_1 = (tmp0_subject == null ? -1 : tmp0_subject.t2_1) === 5 ? -273.15 : null;
    var tmp_0 = this;
    var tmp0_subject_0 = this.n25_1;
    tmp_0.p25_1 = (tmp0_subject_0 == null ? -1 : tmp0_subject_0.t2_1) === 5 ? -459.67 : null;
  }
  protoOf(ActivityField).toString = function () {
    return 'ActivityField(id=' + this.c25_1 + ', i18nKey=' + this.d25_1 + ', kind=' + this.e25_1.toString() + ', outputMode=' + this.f25_1.toString() + ', jsonKey=' + this.g25_1 + ', required=' + this.h25_1 + ', numberDefault=' + this.i25_1 + ', fixedValue=' + this.j25_1 + ', allowNegative=' + this.k25_1 + ', mustBePositive=' + this.l25_1 + ', selectOptions=' + toString(this.m25_1) + ')';
  };
  protoOf(ActivityField).hashCode = function () {
    var result = getStringHashCode(this.c25_1);
    result = imul(result, 31) + getStringHashCode(this.d25_1) | 0;
    result = imul(result, 31) + this.e25_1.hashCode() | 0;
    result = imul(result, 31) + this.f25_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.g25_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h25_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i25_1) | 0;
    result = imul(result, 31) + (this.j25_1 == null ? 0 : this.j25_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k25_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l25_1) | 0;
    result = imul(result, 31) + hashCode(this.m25_1) | 0;
    return result;
  };
  protoOf(ActivityField).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ActivityField))
      return false;
    if (!(this.c25_1 === other.c25_1))
      return false;
    if (!(this.d25_1 === other.d25_1))
      return false;
    if (!this.e25_1.equals(other.e25_1))
      return false;
    if (!this.f25_1.equals(other.f25_1))
      return false;
    if (!(this.g25_1 === other.g25_1))
      return false;
    if (!(this.h25_1 === other.h25_1))
      return false;
    if (!equals(this.i25_1, other.i25_1))
      return false;
    if (!(this.j25_1 == other.j25_1))
      return false;
    if (!(this.k25_1 === other.k25_1))
      return false;
    if (!(this.l25_1 === other.l25_1))
      return false;
    if (!equals(this.m25_1, other.m25_1))
      return false;
    return true;
  };
  function FieldGroup(key, headingI18nKey, fields) {
    this.q25_1 = key;
    this.r25_1 = headingI18nKey;
    this.s25_1 = fields;
  }
  protoOf(FieldGroup).toString = function () {
    return 'FieldGroup(key=' + this.q25_1 + ', headingI18nKey=' + this.r25_1 + ', fields=' + toString(this.s25_1) + ')';
  };
  protoOf(FieldGroup).hashCode = function () {
    var result = getStringHashCode(this.q25_1);
    result = imul(result, 31) + getStringHashCode(this.r25_1) | 0;
    result = imul(result, 31) + hashCode(this.s25_1) | 0;
    return result;
  };
  protoOf(FieldGroup).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FieldGroup))
      return false;
    if (!(this.q25_1 === other.q25_1))
      return false;
    if (!(this.r25_1 === other.r25_1))
      return false;
    if (!equals(this.s25_1, other.s25_1))
      return false;
    return true;
  };
  function ActivitySchema(activityType, optionI18nKey, groups, requiresInstructor) {
    requiresInstructor = requiresInstructor === VOID ? valueOf(activityType).dj_1 : requiresInstructor;
    this.t25_1 = activityType;
    this.u25_1 = optionI18nKey;
    this.v25_1 = groups;
    this.w25_1 = requiresInstructor;
  }
  protoOf(ActivitySchema).toString = function () {
    return 'ActivitySchema(activityType=' + this.t25_1 + ', optionI18nKey=' + this.u25_1 + ', groups=' + toString(this.v25_1) + ', requiresInstructor=' + this.w25_1 + ')';
  };
  protoOf(ActivitySchema).hashCode = function () {
    var result = getStringHashCode(this.t25_1);
    result = imul(result, 31) + getStringHashCode(this.u25_1) | 0;
    result = imul(result, 31) + hashCode(this.v25_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w25_1) | 0;
    return result;
  };
  protoOf(ActivitySchema).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ActivitySchema))
      return false;
    if (!(this.t25_1 === other.t25_1))
      return false;
    if (!(this.u25_1 === other.u25_1))
      return false;
    if (!equals(this.v25_1, other.v25_1))
      return false;
    if (!(this.w25_1 === other.w25_1))
      return false;
    return true;
  };
  function opt(id, i18n, kind, jsonKey, allowNegative, mustBePositive) {
    kind = kind === VOID ? FieldKind_TEXT_getInstance() : kind;
    jsonKey = jsonKey === VOID ? id : jsonKey;
    allowNegative = allowNegative === VOID ? false : allowNegative;
    mustBePositive = mustBePositive === VOID ? false : mustBePositive;
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return new ActivityField(id, i18n, kind, OutputMode_OMIT_IF_BLANK_getInstance(), jsonKey, VOID, VOID, VOID, allowNegative, mustBePositive);
  }
  function optNum(id, i18n, jsonKey, allowNegative, mustBePositive) {
    jsonKey = jsonKey === VOID ? id : jsonKey;
    allowNegative = allowNegative === VOID ? false : allowNegative;
    mustBePositive = mustBePositive === VOID ? false : mustBePositive;
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return opt(id, i18n, FieldKind_NUMBER_getInstance(), jsonKey, allowNegative, mustBePositive);
  }
  function optInt(id, i18n, jsonKey, allowNegative) {
    jsonKey = jsonKey === VOID ? id : jsonKey;
    allowNegative = allowNegative === VOID ? false : allowNegative;
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return opt(id, i18n, FieldKind_INT_getInstance(), jsonKey, allowNegative);
  }
  function str(id, i18n, jsonKey, required) {
    jsonKey = jsonKey === VOID ? id : jsonKey;
    required = required === VOID ? false : required;
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return new ActivityField(id, i18n, FieldKind_TEXT_getInstance(), OutputMode_ALWAYS_STRING_getInstance(), jsonKey, required);
  }
  function num(id, i18n, default_0, jsonKey, allowNegative) {
    default_0 = default_0 === VOID ? 0.0 : default_0;
    jsonKey = jsonKey === VOID ? id : jsonKey;
    allowNegative = allowNegative === VOID ? false : allowNegative;
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return new ActivityField(id, i18n, FieldKind_NUMBER_getInstance(), OutputMode_ALWAYS_NUMBER_getInstance(), jsonKey, VOID, default_0, VOID, allowNegative);
  }
  function int(id, i18n, default_0, jsonKey, allowNegative) {
    default_0 = default_0 === VOID ? 0.0 : default_0;
    jsonKey = jsonKey === VOID ? id : jsonKey;
    allowNegative = allowNegative === VOID ? false : allowNegative;
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return new ActivityField(id, i18n, FieldKind_INT_getInstance(), OutputMode_ALWAYS_NUMBER_getInstance(), jsonKey, VOID, default_0, VOID, allowNegative);
  }
  function list(id, i18n, jsonKey) {
    jsonKey = jsonKey === VOID ? id : jsonKey;
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return new ActivityField(id, i18n, FieldKind_CSV_LIST_getInstance(), OutputMode_ALWAYS_LIST_getInstance(), jsonKey);
  }
  function numList(id, i18n, jsonKey) {
    jsonKey = jsonKey === VOID ? id : jsonKey;
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return new ActivityField(id, i18n, FieldKind_CSV_NUMBER_LIST_getInstance(), OutputMode_ALWAYS_LIST_getInstance(), jsonKey);
  }
  function bool(id, i18n, jsonKey) {
    jsonKey = jsonKey === VOID ? id : jsonKey;
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return new ActivityField(id, i18n, FieldKind_BOOLEAN_getInstance(), OutputMode_ALWAYS_BOOLEAN_getInstance(), jsonKey);
  }
  function fixed(jsonKey, value) {
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return new ActivityField(jsonKey, '', FieldKind_INT_getInstance(), OutputMode_FIXED_getInstance(), jsonKey, VOID, VOID, value);
  }
  function select(id, i18n, options, jsonKey) {
    jsonKey = jsonKey === VOID ? id : jsonKey;
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return new ActivityField(id, i18n, FieldKind_SELECT_getInstance(), OutputMode_OMIT_IF_BLANK_getInstance(), jsonKey, VOID, VOID, VOID, VOID, VOID, options);
  }
  function group(key, heading, fields) {
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return new FieldGroup(key, heading, toList(fields));
  }
  function schema(activityType, option, groups) {
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return new ActivitySchema(activityType, option, toList(groups));
  }
  function single(activityType, option, heading, fields) {
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    return schema(activityType, option, [group(activityType, heading, fields.slice())]);
  }
  function activitySchema(activityType) {
    _init_properties_ActivityFieldSchema_kt__s8dddm();
    // Inline function 'kotlin.collections.find' call
    var tmp0 = get_ACTIVITY_SCHEMAS();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.t25_1 === activityType) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = "No ActivitySchema registered for activity type '" + activityType + "'";
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function FieldKind_TEXT_getInstance() {
    FieldKind_initEntries();
    return FieldKind_TEXT_instance;
  }
  function FieldKind_NUMBER_getInstance() {
    FieldKind_initEntries();
    return FieldKind_NUMBER_instance;
  }
  function FieldKind_INT_getInstance() {
    FieldKind_initEntries();
    return FieldKind_INT_instance;
  }
  function FieldKind_BOOLEAN_getInstance() {
    FieldKind_initEntries();
    return FieldKind_BOOLEAN_instance;
  }
  function FieldKind_CSV_LIST_getInstance() {
    FieldKind_initEntries();
    return FieldKind_CSV_LIST_instance;
  }
  function FieldKind_CSV_NUMBER_LIST_getInstance() {
    FieldKind_initEntries();
    return FieldKind_CSV_NUMBER_LIST_instance;
  }
  function FieldKind_SELECT_getInstance() {
    FieldKind_initEntries();
    return FieldKind_SELECT_instance;
  }
  function OutputMode_OMIT_IF_BLANK_getInstance() {
    OutputMode_initEntries();
    return OutputMode_OMIT_IF_BLANK_instance;
  }
  function OutputMode_ALWAYS_STRING_getInstance() {
    OutputMode_initEntries();
    return OutputMode_ALWAYS_STRING_instance;
  }
  function OutputMode_ALWAYS_NUMBER_getInstance() {
    OutputMode_initEntries();
    return OutputMode_ALWAYS_NUMBER_instance;
  }
  function OutputMode_ALWAYS_LIST_getInstance() {
    OutputMode_initEntries();
    return OutputMode_ALWAYS_LIST_instance;
  }
  function OutputMode_ALWAYS_BOOLEAN_getInstance() {
    OutputMode_initEntries();
    return OutputMode_ALWAYS_BOOLEAN_instance;
  }
  function OutputMode_FIXED_getInstance() {
    OutputMode_initEntries();
    return OutputMode_FIXED_instance;
  }
  function UnitDimension_LENGTH_M_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_LENGTH_M_instance;
  }
  function UnitDimension_LENGTH_FT_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_LENGTH_FT_instance;
  }
  function UnitDimension_LENGTH_KM_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_LENGTH_KM_instance;
  }
  function UnitDimension_LENGTH_NM_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_LENGTH_NM_instance;
  }
  function UnitDimension_LENGTH_MM_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_LENGTH_MM_instance;
  }
  function UnitDimension_TEMPERATURE_C_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_TEMPERATURE_C_instance;
  }
  function UnitDimension_PRESSURE_BAR_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_PRESSURE_BAR_instance;
  }
  function UnitDimension_PRESSURE_KPA_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_PRESSURE_KPA_instance;
  }
  function UnitDimension_PRESSURE_HPA_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_PRESSURE_HPA_instance;
  }
  function UnitDimension_SPEED_KPH_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_SPEED_KPH_instance;
  }
  function UnitDimension_SPEED_KNOTS_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_SPEED_KNOTS_instance;
  }
  function UnitDimension_MASS_KG_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_MASS_KG_instance;
  }
  function UnitDimension_VOLUME_L_getInstance() {
    UnitDimension_initEntries();
    return UnitDimension_VOLUME_L_instance;
  }
  var properties_initialized_ActivityFieldSchema_kt_wofdno;
  function _init_properties_ActivityFieldSchema_kt__s8dddm() {
    if (!properties_initialized_ActivityFieldSchema_kt_wofdno) {
      properties_initialized_ActivityFieldSchema_kt_wofdno = true;
      ACTIVITY_SCHEMAS = listOf([single('RECREATIONAL_SCUBA_DIVER', 'logActivity.activityType.scubaDive', 'logActivity.scuba.heading', [fixed('diveNumber', 0), optNum('maxDepthMeters', 'logActivity.scuba.maxDepth'), optInt('bottomTimeMinutes', 'logActivity.scuba.bottomTime'), optInt('surfaceIntervalMinutes', 'logActivity.scuba.surfaceInterval'), optNum('startPressureBar', 'logActivity.scuba.startPressure'), optNum('endPressureBar', 'logActivity.scuba.endPressure'), select('gasMix', 'logActivity.scuba.gasMix', listOf([to('AIR', 'logActivity.scuba.gasMixOption.air'), to('EAN32', 'logActivity.scuba.gasMixOption.ean32'), to('EAN36', 'logActivity.scuba.gasMixOption.ean36'), to('TRIMIX', 'logActivity.scuba.gasMixOption.trimix'), to('HELIOX', 'logActivity.scuba.gasMixOption.heliox'), to('OTHER', 'logActivity.scuba.gasMixOption.other')])), optNum('waterTempSurfaceC', 'logActivity.scuba.waterTempSurface', VOID, true), optNum('waterTempBottomC', 'logActivity.scuba.waterTempBottom', VOID, true), optNum('visibilityMeters', 'logActivity.scuba.visibility', VOID, VOID, true), opt('currentStrength', 'logActivity.scuba.currentStrength'), optInt('exposureSuitThicknessMm', 'logActivity.scuba.exposureSuitThickness'), optNum('weightKg', 'logActivity.scuba.weightCarried')]), single('STUDENT_PILOT', 'logActivity.activityType.studentPilot', 'logActivity.pilot.heading', [opt('aircraftMake', 'logActivity.pilot.aircraftMake'), opt('aircraftModel', 'logActivity.pilot.aircraftModel'), opt('tailRegistration', 'logActivity.pilot.tailRegistration'), optNum('dualInstructionHours', 'logActivity.pilot.dualInstructionHours'), optNum('soloFlightHours', 'logActivity.pilot.soloFlightHours'), optNum('crossCountryDistanceNm', 'logActivity.pilot.crossCountryDistance'), optNum('nightHours', 'logActivity.pilot.nightHours'), optNum('instrumentHours', 'logActivity.pilot.instrumentHours'), opt('departureAirportCode', 'logActivity.pilot.departureAirportCode'), opt('arrivalAirportCode', 'logActivity.pilot.arrivalAirportCode'), list('intermediateStops', 'logActivity.pilot.intermediateStops'), optInt('dayLandings', 'logActivity.pilot.dayLandings'), optInt('nightLandings', 'logActivity.pilot.nightLandings')]), single('ROCK_CLIMBER', 'logActivity.activityType.rockClimb', 'logActivity.climb.heading', [opt('routeName', 'logActivity.climb.routeName'), optInt('pitchCount', 'logActivity.climb.pitchCount'), opt('pitchGrade', 'logActivity.climb.pitchGrade'), optNum('climbLengthMeters', 'logActivity.climb.climbLength'), opt('style', 'logActivity.climb.style'), list('tradGearSizes', 'logActivity.climb.tradGearSizes'), optInt('fallOccurrences', 'logActivity.climb.fallOccurrences')]), schema('WALKER', 'logActivity.activityType.walk', [group('gpsTrackSummary', 'logActivity.gpsTrack.heading', [num('distanceMeters', 'logActivity.gpsTrack.distance'), int('durationSeconds', 'logActivity.gpsTrack.duration')])]), schema('RUNNER', 'logActivity.activityType.run', [group('gpsTrackSummary', 'logActivity.gpsTrack.heading', [num('distanceMeters', 'logActivity.gpsTrack.distance'), int('durationSeconds', 'logActivity.gpsTrack.duration')])]), schema('PARAGLIDER', 'logActivity.activityType.paraglide', [group('gpsTrackSummary', 'logActivity.gpsTrack.heading', [num('distanceMeters', 'logActivity.gpsTrack.distance'), int('durationSeconds', 'logActivity.gpsTrack.duration')])]), schema('HANG_GLIDER', 'logActivity.activityType.hangGlide', [group('gpsTrackSummary', 'logActivity.gpsTrack.heading', [num('distanceMeters', 'logActivity.gpsTrack.distance'), int('durationSeconds', 'logActivity.gpsTrack.duration')])]), schema('GLIDER_PILOT', 'logActivity.activityType.gliderFlight', [group('gpsTrackSummary', 'logActivity.gpsTrack.heading', [num('distanceMeters', 'logActivity.gpsTrack.distance'), int('durationSeconds', 'logActivity.gpsTrack.duration')]), group('GLIDER_PILOT', 'logActivity.glider.heading', [opt('aircraftRegistration', 'logActivity.glider.aircraftRegistration')])]), single('RAFTER', 'logActivity.activityType.raft', 'logActivity.raft.heading', [str('riverName', 'logActivity.raft.riverName', VOID, true), str('maxRapidClass', 'logActivity.raft.maxRapidClass', VOID, true), optNum('sectionDistanceKm', 'logActivity.raft.sectionDistance')]), single('GOLFER', 'logActivity.activityType.golf', 'logActivity.golf.heading', [str('courseName', 'logActivity.golf.courseName'), int('holesPlayed', 'logActivity.golf.holesPlayed'), int('totalStrokes', 'logActivity.golf.totalStrokes'), int('coursePar', 'logActivity.golf.coursePar'), optInt('puttsTotal', 'logActivity.golf.puttsTotal'), optInt('fairwaysHit', 'logActivity.golf.fairwaysHit'), optInt('greensInRegulation', 'logActivity.golf.greensInRegulation')]), single('DARTS_PLAYER', 'logActivity.activityType.darts', 'logActivity.darts.heading', [str('gameFormat', 'logActivity.darts.gameFormat'), int('legsWon', 'logActivity.darts.legsWon'), int('legsLost', 'logActivity.darts.legsLost'), optInt('highestCheckout', 'logActivity.darts.highestCheckout'), optNum('checkoutPercentage', 'logActivity.darts.checkoutPercentage'), int('oneEightiesCount', 'logActivity.darts.oneEightiesCount')]), single('TRACK_AND_FIELD_THROWER', 'logActivity.activityType.javelin', 'logActivity.trackThrow.heading', [str('event', 'logActivity.trackThrow.event'), num('throwDistanceMeters', 'logActivity.trackThrow.distanceMeters', VOID, 'distanceMeters'), opt('competitionName', 'logActivity.trackThrow.competitionName'), optNum('windSpeedMetersPerSecond', 'logActivity.trackThrow.windSpeed')]), single('BASEBALL_PLAYER', 'logActivity.activityType.baseball', 'logActivity.baseball.heading', [str('position', 'logActivity.baseball.position'), opt('opponentTeam', 'logActivity.baseball.opponentTeam'), optInt('atBats', 'logActivity.baseball.atBats'), optInt('hits', 'logActivity.baseball.hits'), optInt('runsBattedIn', 'logActivity.baseball.runsBattedIn'), optNum('inningsPitched', 'logActivity.baseball.inningsPitched'), optInt('strikeoutsPitched', 'logActivity.baseball.strikeoutsPitched')]), single('BILLIARDS_PLAYER', 'logActivity.activityType.billiards', 'logActivity.billiards.heading', [str('gameType', 'logActivity.billiards.gameType'), int('framesWon', 'logActivity.billiards.framesWon'), int('framesLost', 'logActivity.billiards.framesLost'), optInt('highestBreak', 'logActivity.billiards.highestBreak'), opt('opponentName', 'logActivity.billiards.opponentName')]), single('ALPINE_SKIER', 'logActivity.activityType.alpineSki', 'logActivity.alpineSki.heading', [str('resortName', 'logActivity.alpineSki.resortName'), int('runsCompleted', 'logActivity.alpineSki.runsCompleted'), num('skiVerticalDescentMeters', 'logActivity.alpineSki.verticalDescent', VOID, 'verticalDescentMeters'), optNum('skiMaxSpeedKph', 'logActivity.alpineSki.maxSpeed', 'maxSpeedKph'), opt('snowCondition', 'logActivity.alpineSki.snowCondition')]), single('DOWNHILL_MOUNTAIN_BIKER', 'logActivity.activityType.downhillMtb', 'logActivity.downhillMtb.heading', [str('trailName', 'logActivity.downhillMtb.trailName'), num('mtbVerticalDescentMeters', 'logActivity.downhillMtb.verticalDescent', VOID, 'verticalDescentMeters'), num('mtbDistanceMeters', 'logActivity.downhillMtb.distance', VOID, 'distanceMeters'), int('mtbDurationSeconds', 'logActivity.downhillMtb.duration', VOID, 'durationSeconds'), optNum('mtbMaxSpeedKph', 'logActivity.downhillMtb.maxSpeed', 'maxSpeedKph')]), single('YOGA_PRACTITIONER', 'logActivity.activityType.yoga', 'logActivity.yoga.heading', [str('yogaStyle', 'logActivity.yoga.style', 'style'), int('yogaDurationMinutes', 'logActivity.yoga.durationMinutes', VOID, 'durationMinutes'), list('poseSequence', 'logActivity.yoga.poseSequence'), opt('yogaInstructorName', 'logActivity.yoga.instructorName', VOID, 'instructorName')]), single('CARD_PLAYER', 'logActivity.activityType.cards', 'logActivity.cards.heading', [str('gameName', 'logActivity.cards.gameName'), str('result', 'logActivity.cards.result'), optInt('score', 'logActivity.cards.score'), list('opponents', 'logActivity.cards.opponents')]), single('RACE_CAR_DRIVER', 'logActivity.activityType.raceCar', 'logActivity.raceCar.heading', [str('trackName', 'logActivity.raceCar.trackName'), str('carMakeModel', 'logActivity.raceCar.carMakeModel'), int('lapsCompleted', 'logActivity.raceCar.lapsCompleted'), optNum('bestLapTimeSeconds', 'logActivity.raceCar.bestLapTime'), opt('sessionType', 'logActivity.raceCar.sessionType')]), single('MOTORCYCLE_RIDER', 'logActivity.activityType.motorcycle', 'logActivity.motorcycle.heading', [str('routeOrTrackName', 'logActivity.motorcycle.routeOrTrackName'), str('motorcycleMakeModel', 'logActivity.motorcycle.motorcycleMakeModel'), optNum('distanceKm', 'logActivity.motorcycle.distanceKm'), optInt('motorcycleDurationMinutes', 'logActivity.motorcycle.durationMinutes', 'durationMinutes'), optNum('motorcycleMaxSpeedKph', 'logActivity.motorcycle.maxSpeed', 'maxSpeedKph'), opt('rideType', 'logActivity.motorcycle.rideType')]), single('AIRLINE_TRANSPORT_PILOT', 'logActivity.activityType.atp', 'logActivity.atp.heading', [num('picHours', 'logActivity.atp.picHours'), optNum('sicHours', 'logActivity.atp.sicHours'), optNum('actualInstrumentHours', 'logActivity.atp.actualInstrumentHours'), optNum('simulatedInstrumentHours', 'logActivity.atp.simulatedInstrumentHours'), optNum('nightCrossCountryHours', 'logActivity.atp.nightCrossCountryHours'), optNum('multiEngineHours', 'logActivity.atp.multiEngineHours'), optNum('turbineEngineHours', 'logActivity.atp.turbineEngineHours'), bool('heavyAircraftClassification', 'logActivity.atp.heavyAircraftClassification'), int('precisionApproaches', 'logActivity.atp.precisionApproaches'), int('nonPrecisionApproaches', 'logActivity.atp.nonPrecisionApproaches'), int('holdingPatterns', 'logActivity.atp.holdingPatterns')]), single('FLIGHT_INSTRUCTOR', 'logActivity.activityType.flightInstructor', 'logActivity.flightInstructor.heading', [str('studentName', 'logActivity.flightInstructor.studentName'), str('licenseTrack', 'logActivity.flightInstructor.licenseTrack'), optNum('groundInstructionHours', 'logActivity.flightInstructor.groundInstructionHours'), optNum('dualFlightInstructionHours', 'logActivity.flightInstructor.dualFlightInstructionHours'), bool('soloEndorsementGiven', 'logActivity.flightInstructor.soloEndorsementGiven'), bool('checkrideReadinessSignOff', 'logActivity.flightInstructor.checkrideReadinessSignOff'), bool('knowledgeTestClearanceGiven', 'logActivity.flightInstructor.knowledgeTestClearanceGiven')]), single('AIRCRAFT_MAINTENANCE_TECHNICIAN', 'logActivity.activityType.aircraftMaintenance', 'logActivity.aircraftMaintenance.heading', [str('aircraftTailNumber', 'logActivity.aircraftMaintenance.aircraftTailNumber'), opt('componentSerialNumber', 'logActivity.aircraftMaintenance.componentSerialNumber'), opt('engineModel', 'logActivity.aircraftMaintenance.engineModel'), optNum('totalAirframeHours', 'logActivity.aircraftMaintenance.totalAirframeHours'), optInt('engineCyclesSinceNew', 'logActivity.aircraftMaintenance.engineCyclesSinceNew'), optNum('timeSinceMajorOverhaulHours', 'logActivity.aircraftMaintenance.timeSinceMajorOverhaulHours'), list('airworthinessDirectiveRefs', 'logActivity.aircraftMaintenance.airworthinessDirectiveRefs'), list('serviceBulletinRefs', 'logActivity.aircraftMaintenance.serviceBulletinRefs'), list('partsReplaced', 'logActivity.aircraftMaintenance.partsReplaced'), opt('returnToServiceStamp', 'logActivity.aircraftMaintenance.returnToServiceStamp'), str('aAndPLicenseNumber', 'logActivity.aircraftMaintenance.aAndPLicenseNumber')]), single('DRONE_OPERATOR', 'logActivity.activityType.drone', 'logActivity.drone.heading', [str('airspaceClassification', 'logActivity.drone.airspaceClassification'), opt('laancAuthorizationNumber', 'logActivity.drone.laancAuthorizationNumber'), str('droneModel', 'logActivity.drone.droneModel'), opt('batterySerialNumber', 'logActivity.drone.batterySerialNumber'), optInt('batteryChargeCycles', 'logActivity.drone.batteryChargeCycles'), optNum('payloadWeightKg', 'logActivity.drone.payloadWeightKg'), optNum('maxAltitudeAglMeters', 'logActivity.drone.maxAltitudeAglMeters'), opt('incidentNotes', 'logActivity.drone.incidentNotes')]), single('HOT_AIR_BALLOON_PILOT', 'logActivity.activityType.hotAirBalloon', 'logActivity.hotAirBalloon.heading', [str('envelopeModel', 'logActivity.hotAirBalloon.envelopeModel'), opt('basketSize', 'logActivity.hotAirBalloon.basketSize'), optNum('totalBurnerHours', 'logActivity.hotAirBalloon.totalBurnerHours'), optNum('prePropaneVolumeLiters', 'logActivity.hotAirBalloon.prePropaneVolumeLiters'), optNum('postFlightResidualPressureBar', 'logActivity.hotAirBalloon.postFlightResidualPressureBar'), optNum('ambientTemperatureC', 'logActivity.hotAirBalloon.ambientTemperatureC', VOID, true), optNum('surfaceWindSpeedKph', 'logActivity.hotAirBalloon.surfaceWindSpeedKph'), opt('launchCoordinates', 'logActivity.hotAirBalloon.launchCoordinates'), opt('landingCoordinates', 'logActivity.hotAirBalloon.landingCoordinates')]), single('FLIGHT_SIMULATOR_OPERATOR', 'logActivity.activityType.flightSim', 'logActivity.flightSim.heading', [str('deviceQualificationLevel', 'logActivity.flightSim.deviceQualificationLevel'), opt('simulatedWeatherMinimums', 'logActivity.flightSim.simulatedWeatherMinimums'), list('emergencyFailuresIntroduced', 'logActivity.flightSim.emergencyFailuresIntroduced'), optNum('loggedInstrumentHours', 'logActivity.flightSim.loggedInstrumentHours'), int('approachCountTowardCurrency', 'logActivity.flightSim.approachCountTowardCurrency')]), single('ASTRONAUT', 'logActivity.activityType.astronaut', 'logActivity.astronaut.heading', [str('missionDesignation', 'logActivity.astronaut.missionDesignation'), opt('habitatCoordinates', 'logActivity.astronaut.habitatCoordinates'), optNum('vacuumChamberPressureKpa', 'logActivity.astronaut.vacuumChamberPressureKpa'), optNum('suitPressurizationMinutes', 'logActivity.astronaut.suitPressurizationMinutes'), optNum('lifeSupportDurationMinutes', 'logActivity.astronaut.lifeSupportDurationMinutes'), opt('lifeSupportAirMix', 'logActivity.astronaut.lifeSupportAirMix'), list('sampleCollectionTags', 'logActivity.astronaut.sampleCollectionTags'), list('structuralRepairMilestones', 'logActivity.astronaut.structuralRepairMilestones')]), single('AEROBATIC_PILOT', 'logActivity.activityType.aerobatic', 'logActivity.aerobatic.heading', [list('maneuverSequence', 'logActivity.aerobatic.maneuverSequence'), optNum('positiveGForcePeak', 'logActivity.aerobatic.positiveGForcePeak', VOID, true), optNum('negativeGForcePeak', 'logActivity.aerobatic.negativeGForcePeak', VOID, true), optNum('entryAltitudeMeters', 'logActivity.aerobatic.entryAltitudeMeters'), optNum('exitAltitudeMeters', 'logActivity.aerobatic.exitAltitudeMeters'), str('aerobaticCategoryRating', 'logActivity.aerobatic.aerobaticCategoryRating'), opt('airshowWaiverNumber', 'logActivity.aerobatic.airshowWaiverNumber'), optNum('displayBoxFloorAltitudeMeters', 'logActivity.aerobatic.displayBoxFloorAltitudeMeters')]), single('PARACHUTE_RIGGER', 'logActivity.activityType.parachuteRigger', 'logActivity.parachuteRigger.heading', [str('parachuteSerialNumber', 'logActivity.parachuteRigger.parachuteSerialNumber'), bool('lineContinuityCheckPassed', 'logActivity.parachuteRigger.lineContinuityCheckPassed'), bool('canopyPorosityTestPassed', 'logActivity.parachuteRigger.canopyPorosityTestPassed'), opt('aadBatteryStatus', 'logActivity.parachuteRigger.aadBatteryStatus'), str('masterRiggerCertificateNumber', 'logActivity.parachuteRigger.masterRiggerCertificateNumber'), opt('sealNumberApplied', 'logActivity.parachuteRigger.sealNumberApplied')]), single('SKYDIVER', 'logActivity.activityType.skydive', 'logActivity.skydive.heading', [int('jumpNumber', 'logActivity.skydive.jumpNumber'), opt('aircraftType', 'logActivity.skydive.aircraftType'), optNum('exitAltitudeAglMeters', 'logActivity.skydive.exitAltitudeAglMeters'), optNum('deploymentAltitudeMeters', 'logActivity.skydive.deploymentAltitudeMeters'), optInt('freefallTimeSeconds', 'logActivity.skydive.freefallTimeSeconds'), optNum('terminalVelocityReachedKph', 'logActivity.skydive.terminalVelocityReachedKph'), list('maneuverTypes', 'logActivity.skydive.maneuverTypes'), opt('mainCanopyModel', 'logActivity.skydive.mainCanopyModel'), optNum('canopySquareFootage', 'logActivity.skydive.canopySquareFootage'), optNum('landingAccuracyMeters', 'logActivity.skydive.landingAccuracyMeters'), opt('uspaLicenseNumber', 'logActivity.skydive.uspaLicenseNumber')]), single('BASE_JUMPER', 'logActivity.activityType.baseJump', 'logActivity.baseJump.heading', [str('objectClassification', 'logActivity.baseJump.objectClassification'), optNum('objectHeightMeters', 'logActivity.baseJump.objectHeightMeters'), opt('landingZoneObstacles', 'logActivity.baseJump.landingZoneObstacles'), str('deploymentMethod', 'logActivity.baseJump.deploymentMethod'), optNum('delayDurationSeconds', 'logActivity.baseJump.delayDurationSeconds'), opt('canopyHeadingPerformance', 'logActivity.baseJump.canopyHeadingPerformance')]), single('PARAMOTOR_PILOT', 'logActivity.activityType.paramotor', 'logActivity.paramotor.heading', [str('paramotorFrameModel', 'logActivity.paramotor.paramotorFrameModel'), opt('engineRpmRange', 'logActivity.paramotor.engineRpmRange'), optNum('cylinderHeadTempC', 'logActivity.paramotor.cylinderHeadTempC', VOID, true), optNum('exhaustGasTempC', 'logActivity.paramotor.exhaustGasTempC', VOID, true), opt('fuelMixRatio', 'logActivity.paramotor.fuelMixRatio'), optNum('fuelVolumeConsumedLiters', 'logActivity.paramotor.fuelVolumeConsumedLiters'), optNum('flightRangeKm', 'logActivity.paramotor.flightRangeKm'), optInt('durationSeconds', 'logActivity.paramotor.durationSeconds')]), single('SPEEDWING_FLYER', 'logActivity.activityType.speedwing', 'logActivity.speedwing.heading', [optNum('mountainSlopeAngleDegrees', 'logActivity.speedwing.mountainSlopeAngleDegrees'), optNum('canopyDistanceFromTerrainMeters', 'logActivity.speedwing.canopyDistanceFromTerrainMeters'), optNum('glideRatio', 'logActivity.speedwing.glideRatio'), optNum('footLaunchRollDistanceMeters', 'logActivity.speedwing.footLaunchRollDistanceMeters'), optNum('maxGroundSpeedKph', 'logActivity.speedwing.maxGroundSpeedKph')]), single('WINGSUIT_PILOT', 'logActivity.activityType.wingsuit', 'logActivity.wingsuit.heading', [optNum('glideRatioAchieved', 'logActivity.wingsuit.glideRatioAchieved'), optNum('horizontalToVerticalSpeedRatio', 'logActivity.wingsuit.horizontalToVerticalSpeedRatio'), optInt('flightTimeBeforeDeploymentSeconds', 'logActivity.wingsuit.flightTimeBeforeDeploymentSeconds'), str('wingsuitModel', 'logActivity.wingsuit.wingsuitModel'), optNum('wingSurfaceAreaSqM', 'logActivity.wingsuit.wingSurfaceAreaSqM'), optInt('jumpNumberOnSuit', 'logActivity.wingsuit.jumpNumberOnSuit'), bool('firstFlightCourseCompleted', 'logActivity.wingsuit.firstFlightCourseCompleted'), optInt('jumpNumberMilestone', 'logActivity.wingsuit.jumpNumberMilestone')]), single('INDOOR_SKYDIVING_COACH', 'logActivity.activityType.indoorSkydiving', 'logActivity.indoorSkydiving.heading', [str('tunnelFacility', 'logActivity.indoorSkydiving.tunnelFacility'), optNum('windSpeedKph', 'logActivity.indoorSkydiving.windSpeedKph'), optInt('sessionDurationMinutes', 'logActivity.indoorSkydiving.sessionDurationMinutes'), list('bodyPositionDrills', 'logActivity.indoorSkydiving.bodyPositionDrills'), optInt('freeflyTransitionAttempts', 'logActivity.indoorSkydiving.freeflyTransitionAttempts'), opt('studentCertificationLevel', 'logActivity.indoorSkydiving.studentCertificationLevel')]), single('TECHNICAL_DIVER', 'logActivity.activityType.techDive', 'logActivity.techDive.heading', [optNum('bottomMixOxygenPercent', 'logActivity.techDive.bottomMixOxygenPercent'), optNum('bottomMixHeliumPercent', 'logActivity.techDive.bottomMixHeliumPercent'), list('travelMixFractions', 'logActivity.techDive.travelMixFractions'), list('decompressionGasChoices', 'logActivity.techDive.decompressionGasChoices'), optInt('plannedDecoRuntimeMinutes', 'logActivity.techDive.plannedDecoRuntimeMinutes'), optInt('actualDecoRuntimeMinutes', 'logActivity.techDive.actualDecoRuntimeMinutes'), numList('deepStopDepthsMeters', 'logActivity.techDive.deepStopDepthsMeters'), numList('gasSwitchCheckpointsMeters', 'logActivity.techDive.gasSwitchCheckpointsMeters'), optNum('twinsetTankPressureBar', 'logActivity.techDive.twinsetTankPressureBar'), list('stageBottleCapacities', 'logActivity.techDive.stageBottleCapacities'), optNum('ccrSetpointPpo2', 'logActivity.techDive.ccrSetpointPpo2')]), single('COMMERCIAL_DIVER', 'logActivity.activityType.commercialDive', 'logActivity.commercialDive.heading', [optNum('storageDepthPressureBar', 'logActivity.commercialDive.storageDepthPressureBar'), optNum('gasReclaimEfficiencyPercent', 'logActivity.commercialDive.gasReclaimEfficiencyPercent'), optNum('chamberHumidityPercent', 'logActivity.commercialDive.chamberHumidityPercent'), optNum('bellLockoutMinutes', 'logActivity.commercialDive.bellLockoutMinutes'), optNum('bellRecoveryMinutes', 'logActivity.commercialDive.bellRecoveryMinutes'), optNum('hotWaterSuitTempC', 'logActivity.commercialDive.hotWaterSuitTempC', VOID, true), optNum('toolOperatingPressureBar', 'logActivity.commercialDive.toolOperatingPressureBar'), optNum('underwaterWeldingArcHours', 'logActivity.commercialDive.underwaterWeldingArcHours'), opt('ndtReadouts', 'logActivity.commercialDive.ndtReadouts')]), single('SCIENTIFIC_RESEARCH_DIVER', 'logActivity.activityType.sciDive', 'logActivity.sciDive.heading', [opt('quadratGridCoordinates', 'logActivity.sciDive.quadratGridCoordinates'), optNum('transectLineLengthMeters', 'logActivity.sciDive.transectLineLengthMeters'), list('sampleCanisterBarcodes', 'logActivity.sciDive.sampleCanisterBarcodes'), opt('marineLifeCounts', 'logActivity.sciDive.marineLifeCounts'), opt('substrateComposition', 'logActivity.sciDive.substrateComposition'), optNum('sensorDeploymentDepthMeters', 'logActivity.sciDive.sensorDeploymentDepthMeters')]), single('FREEDIVER', 'logActivity.activityType.freedive', 'logActivity.freedive.heading', [optInt('staticBreathHoldSeconds', 'logActivity.freedive.staticBreathHoldSeconds'), optNum('dynamicHorizontalDistanceMeters', 'logActivity.freedive.dynamicHorizontalDistanceMeters'), optNum('constantWeightDepthMeters', 'logActivity.freedive.constantWeightDepthMeters'), optInt('surfaceRecoverySeconds', 'logActivity.freedive.surfaceRecoverySeconds'), optNum('pulseOximetryPercent', 'logActivity.freedive.pulseOximetryPercent'), optInt('packingBreathCount', 'logActivity.freedive.packingBreathCount')]), single('PUBLIC_SAFETY_DIVER', 'logActivity.activityType.safetyDive', 'logActivity.safetyDive.heading', [str('searchPatternProfile', 'logActivity.safetyDive.searchPatternProfile'), opt('visibility', 'logActivity.safetyDive.visibility'), opt('evidenceBagTrackingNumber', 'logActivity.safetyDive.evidenceBagTrackingNumber'), opt('recoveryDepthCoordinates', 'logActivity.safetyDive.recoveryDepthCoordinates')]), single('SPEARFISHING_DIVER', 'logActivity.activityType.spearfishing', 'logActivity.spearfishing.heading', [list('speciesCaught', 'logActivity.spearfishing.speciesCaught'), optNum('weightKg', 'logActivity.spearfishing.weightKg'), optNum('lengthCm', 'logActivity.spearfishing.lengthCm'), opt('spearGunBandConfiguration', 'logActivity.spearfishing.spearGunBandConfiguration'), optNum('depthOfTakesMeters', 'logActivity.spearfishing.depthOfTakesMeters'), optInt('breathHoldSeconds', 'logActivity.spearfishing.breathHoldSeconds'), optInt('diveCount', 'logActivity.spearfishing.diveCount'), bool('diveBuddyPresent', 'logActivity.spearfishing.diveBuddyPresent'), bool('surfaceSignalingDeviceUsed', 'logActivity.spearfishing.surfaceSignalingDeviceUsed'), optNum('catchBagWeightKg', 'logActivity.spearfishing.catchBagWeightKg')]), single('UNDERWATER_PHOTOGRAPHER', 'logActivity.activityType.underwaterPhoto', 'logActivity.underwaterPhoto.heading', [str('cameraHousingModel', 'logActivity.underwaterPhoto.cameraHousingModel'), optNum('depthRatingMeters', 'logActivity.underwaterPhoto.depthRatingMeters'), opt('strobeSetup', 'logActivity.underwaterPhoto.strobeSetup'), opt('diveSite', 'logActivity.underwaterPhoto.diveSite'), opt('subjectSpeciesOrWreck', 'logActivity.underwaterPhoto.subjectSpeciesOrWreck'), opt('footageDurationOrShotCount', 'logActivity.underwaterPhoto.footageDurationOrShotCount')]), single('MERCHANT_MARINE', 'logActivity.activityType.merchantMarine', 'logActivity.merchantMarine.heading', [str('vesselName', 'logActivity.merchantMarine.vesselName'), opt('imoNumber', 'logActivity.merchantMarine.imoNumber'), optNum('grossTonnage', 'logActivity.merchantMarine.grossTonnage'), optNum('enginePropulsionHp', 'logActivity.merchantMarine.enginePropulsionHp'), optNum('navigationWatchHours', 'logActivity.merchantMarine.navigationWatchHours'), optNum('engineRoomWatchHours', 'logActivity.merchantMarine.engineRoomWatchHours'), optNum('lookoutDutyHours', 'logActivity.merchantMarine.lookoutDutyHours'), optInt('seaDaysLogged', 'logActivity.merchantMarine.seaDaysLogged'), list('foreignPortsVisited', 'logActivity.merchantMarine.foreignPortsVisited'), opt('cargoConfiguration', 'logActivity.merchantMarine.cargoConfiguration')]), single('SAILING_CAPTAIN', 'logActivity.activityType.sailing', 'logActivity.sailing.heading', [optNum('trueHeadingDegrees', 'logActivity.sailing.trueHeadingDegrees'), optNum('magneticVariationDegrees', 'logActivity.sailing.magneticVariationDegrees', VOID, true), opt('deadReckoningCoordinates', 'logActivity.sailing.deadReckoningCoordinates'), list('gpsWaypoints', 'logActivity.sailing.gpsWaypoints'), opt('sailPlanConfiguration', 'logActivity.sailing.sailPlanConfiguration'), optNum('engineRuntimeHours', 'logActivity.sailing.engineRuntimeHours'), optNum('batteryBankVoltage', 'logActivity.sailing.batteryBankVoltage'), optNum('barometricPressureHpa', 'logActivity.sailing.barometricPressureHpa'), optInt('seaStateBeaufort', 'logActivity.sailing.seaStateBeaufort'), optNum('windSpeedKnots', 'logActivity.sailing.windSpeedKnots'), optNum('windAngleDegrees', 'logActivity.sailing.windAngleDegrees')]), single('WHITEWATER_GUIDE', 'logActivity.activityType.whitewaterGuide', 'logActivity.whitewaterGuide.heading', [str('riverSystemName', 'logActivity.whitewaterGuide.riverSystemName'), opt('runSector', 'logActivity.whitewaterGuide.runSector'), optNum('gaugeHeightFeet', 'logActivity.whitewaterGuide.gaugeHeightFeet'), optNum('flowVolumeCfs', 'logActivity.whitewaterGuide.flowVolumeCfs'), list('rapidClassificationsTraversed', 'logActivity.whitewaterGuide.rapidClassificationsTraversed'), int('flipOrWrapIncidents', 'logActivity.whitewaterGuide.flipOrWrapIncidents'), optInt('passengerHeadcount', 'logActivity.whitewaterGuide.passengerHeadcount')]), single('LIFEGUARD', 'logActivity.activityType.lifeguard', 'logActivity.lifeguard.heading', [optNum('surfZoneWaveHeightMeters', 'logActivity.lifeguard.surfZoneWaveHeightMeters'), opt('ripCurrentRiskLevel', 'logActivity.lifeguard.ripCurrentRiskLevel'), optNum('uvIndex', 'logActivity.lifeguard.uvIndex'), optNum('waterTempC', 'logActivity.lifeguard.waterTempC', VOID, true), int('swimmerAssists', 'logActivity.lifeguard.swimmerAssists'), int('medicalFirstAidTreatments', 'logActivity.lifeguard.medicalFirstAidTreatments'), int('missingPersonSweeps', 'logActivity.lifeguard.missingPersonSweeps'), optNum('poolChlorinePpm', 'logActivity.lifeguard.poolChlorinePpm'), optNum('poolPhBalance', 'logActivity.lifeguard.poolPhBalance'), optInt('turnoverFiltrationCycles', 'logActivity.lifeguard.turnoverFiltrationCycles')]), single('ROWING_ATHLETE', 'logActivity.activityType.rowing', 'logActivity.rowing.heading', [num('distanceMeters', 'logActivity.rowing.distanceMeters'), optNum('splitTimePer500mSeconds', 'logActivity.rowing.splitTimePer500mSeconds'), optNum('strokeRateSpm', 'logActivity.rowing.strokeRateSpm'), optInt('avgHeartRateBpm', 'logActivity.rowing.avgHeartRateBpm'), optNum('peakPowerOutputWatts', 'logActivity.rowing.peakPowerOutputWatts')]), single('SURFER', 'logActivity.activityType.surf', 'logActivity.surf.heading', [optNum('swellHeightMeters', 'logActivity.surf.swellHeightMeters'), optNum('swellPeriodSeconds', 'logActivity.surf.swellPeriodSeconds'), opt('tideStage', 'logActivity.surf.tideStage'), opt('windDirection', 'logActivity.surf.windDirection'), optInt('waveCount', 'logActivity.surf.waveCount'), optInt('longestRideDurationSeconds', 'logActivity.surf.longestRideDurationSeconds'), list('maneuverTypesLanded', 'logActivity.surf.maneuverTypesLanded'), opt('boardLengthOrVolume', 'logActivity.surf.boardLengthOrVolume'), opt('finSetup', 'logActivity.surf.finSetup'), optNum('leashLengthM', 'logActivity.surf.leashLengthM')]), single('KITESURFER', 'logActivity.activityType.kitesurf', 'logActivity.kitesurf.heading', [optNum('kiteOrSailSizeSqM', 'logActivity.kitesurf.kiteOrSailSizeSqM'), opt('boardType', 'logActivity.kitesurf.boardType'), optNum('lineLengthM', 'logActivity.kitesurf.lineLengthM'), optNum('windSpeedKnots', 'logActivity.kitesurf.windSpeedKnots'), optNum('gustFactor', 'logActivity.kitesurf.gustFactor'), opt('waterState', 'logActivity.kitesurf.waterState'), opt('jumpHeightOrHangtime', 'logActivity.kitesurf.jumpHeightOrHangtime'), optInt('trickAttemptsLanded', 'logActivity.kitesurf.trickAttemptsLanded'), bool('selfRescueDrills', 'logActivity.kitesurf.selfRescueDrills')]), single('ALPINE_MOUNTAINEER', 'logActivity.activityType.alpineMountaineer', 'logActivity.alpineMountaineer.heading', [num('peakElevationMeters', 'logActivity.alpineMountaineer.peakElevationMeters'), optNum('totalElevationGainMeters', 'logActivity.alpineMountaineer.totalElevationGainMeters'), optNum('totalElevationLossMeters', 'logActivity.alpineMountaineer.totalElevationLossMeters'), optNum('approachTrailLengthKm', 'logActivity.alpineMountaineer.approachTrailLengthKm'), opt('alpineCommitmentGrade', 'logActivity.alpineMountaineer.alpineCommitmentGrade'), opt('technicalCruxDifficulty', 'logActivity.alpineMountaineer.technicalCruxDifficulty'), opt('routeProtectionStatus', 'logActivity.alpineMountaineer.routeProtectionStatus'), opt('summitWindowTime', 'logActivity.alpineMountaineer.summitWindowTime')]), single('ICE_CLIMBER', 'logActivity.activityType.iceClimb', 'logActivity.iceClimb.heading', [opt('waterIceGrade', 'logActivity.iceClimb.waterIceGrade'), opt('alpineIceGrade', 'logActivity.iceClimb.alpineIceGrade'), opt('iceConsistency', 'logActivity.iceClimb.iceConsistency'), optNum('ambientTemperatureC', 'logActivity.iceClimb.ambientTemperatureC', VOID, true), optNum('iceThicknessEstimateCm', 'logActivity.iceClimb.iceThicknessEstimateCm'), list('iceScrewSizesAndDepths', 'logActivity.iceClimb.iceScrewSizesAndDepths'), int('vThreadAnchorCount', 'logActivity.iceClimb.vThreadAnchorCount'), opt('toolOrCramponModel', 'logActivity.iceClimb.toolOrCramponModel')]), single('SPELUNKER', 'logActivity.activityType.caving', 'logActivity.caving.heading', [str('caveSystemName', 'logActivity.caving.caveSystemName'), opt('passageDimensions', 'logActivity.caving.passageDimensions'), optNum('totalSurveyedLengthMeters', 'logActivity.caving.totalSurveyedLengthMeters'), numList('ropeDropDepthsMeters', 'logActivity.caving.ropeDropDepthsMeters'), optInt('riggingAnchorPoints', 'logActivity.caving.riggingAnchorPoints'), opt('ascentDescentDeviceUsed', 'logActivity.caving.ascentDescentDeviceUsed'), opt('baselineSurveyVectors', 'logActivity.caving.baselineSurveyVectors'), opt('sumpDivingTimeline', 'logActivity.caving.sumpDivingTimeline'), opt('calloutExitTime', 'logActivity.caving.calloutExitTime')]), single('THRU_HIKER', 'logActivity.activityType.thruHike', 'logActivity.thruHike.heading', [num('dailyMileageKm', 'logActivity.thruHike.dailyMileageKm'), optNum('elevationGainMeters', 'logActivity.thruHike.elevationGainMeters'), optNum('elevationLossMeters', 'logActivity.thruHike.elevationLossMeters'), optNum('packWeightKg', 'logActivity.thruHike.packWeightKg'), list('waterSourceLocations', 'logActivity.thruHike.waterSourceLocations'), opt('resupplyStop', 'logActivity.thruHike.resupplyStop'), list('trailJunctionMarkers', 'logActivity.thruHike.trailJunctionMarkers'), opt('terrainTypeNotes', 'logActivity.thruHike.terrainTypeNotes'), opt('weatherEncountered', 'logActivity.thruHike.weatherEncountered')]), single('CANYONEER', 'logActivity.activityType.canyoneer', 'logActivity.canyoneer.heading', [optNum('rappelLengthMeters', 'logActivity.canyoneer.rappelLengthMeters'), opt('anchorStyle', 'logActivity.canyoneer.anchorStyle'), optNum('ropeDiameterMm', 'logActivity.canyoneer.ropeDiameterMm'), numList('poolDepthsMeters', 'logActivity.canyoneer.poolDepthsMeters'), numList('jumpOrSlideHeightsMeters', 'logActivity.canyoneer.jumpOrSlideHeightsMeters'), opt('waterFlowRate', 'logActivity.canyoneer.waterFlowRate'), opt('flashFloodRiskForecast', 'logActivity.canyoneer.flashFloodRiskForecast'), opt('weatherWindow', 'logActivity.canyoneer.weatherWindow'), opt('groupExitTime', 'logActivity.canyoneer.groupExitTime')]), single('BACKCOUNTRY_SKIER', 'logActivity.activityType.backcountrySki', 'logActivity.backcountrySki.heading', [str('avalancheDangerRating', 'logActivity.backcountrySki.avalancheDangerRating'), optNum('slopeAngleDegrees', 'logActivity.backcountrySki.slopeAngleDegrees'), opt('aspect', 'logActivity.backcountrySki.aspect'), optNum('skinTrackVerticalGainMeters', 'logActivity.backcountrySki.skinTrackVerticalGainMeters'), optInt('transitionsCount', 'logActivity.backcountrySki.transitionsCount'), optNum('totalTourDistanceKm', 'logActivity.backcountrySki.totalTourDistanceKm'), bool('beaconProbeShovelChecked', 'logActivity.backcountrySki.beaconProbeShovelChecked'), bool('avalancheAirbagDeployed', 'logActivity.backcountrySki.avalancheAirbagDeployed')]), single('CDL_TRUCK_DRIVER', 'logActivity.activityType.truckDriver', 'logActivity.truckDriver.heading', [num('drivingHours', 'logActivity.truckDriver.drivingHours'), optNum('onDutyNotDrivingHours', 'logActivity.truckDriver.onDutyNotDrivingHours'), optNum('sleeperBerthHours', 'logActivity.truckDriver.sleeperBerthHours'), opt('routeManifestNumber', 'logActivity.truckDriver.routeManifestNumber'), optNum('odometerStartKm', 'logActivity.truckDriver.odometerStartKm'), optNum('odometerEndKm', 'logActivity.truckDriver.odometerEndKm'), int('fuelStops', 'logActivity.truckDriver.fuelStops'), bool('preTripInspectionPassed', 'logActivity.truckDriver.preTripInspectionPassed'), bool('postTripInspectionPassed', 'logActivity.truckDriver.postTripInspectionPassed'), list('hosViolationFlags', 'logActivity.truckDriver.hosViolationFlags'), opt('eldDeviceId', 'logActivity.truckDriver.eldDeviceId')]), single('TRANSIT_OPERATOR', 'logActivity.activityType.transit', 'logActivity.transit.heading', [str('routeNumber', 'logActivity.transit.routeNumber'), opt('timingLoopAdherence', 'logActivity.transit.timingLoopAdherence'), opt('stopDelayNotes', 'logActivity.transit.stopDelayNotes'), optInt('passengerBoardingCount', 'logActivity.transit.passengerBoardingCount'), optInt('fareOrAdaLiftUsage', 'logActivity.transit.fareOrAdaLiftUsage'), bool('dailySafetyCheckpointPassed', 'logActivity.transit.dailySafetyCheckpointPassed'), opt('brakeAndTireInspectionNotes', 'logActivity.transit.brakeAndTireInspectionNotes'), list('incidentReports', 'logActivity.transit.incidentReports')]), single('CRANE_OPERATOR', 'logActivity.activityType.crane', 'logActivity.crane.heading', [num('loadMassKg', 'logActivity.crane.loadMassKg'), optNum('loadChartPercentageUsed', 'logActivity.crane.loadChartPercentageUsed'), opt('riggingConfiguration', 'logActivity.crane.riggingConfiguration'), optNum('boomLengthMeters', 'logActivity.crane.boomLengthMeters'), opt('counterweightConfiguration', 'logActivity.crane.counterweightConfiguration'), optNum('windSpeedThresholdKph', 'logActivity.crane.windSpeedThresholdKph'), opt('visibilityConditions', 'logActivity.crane.visibilityConditions'), bool('signalPersonConfirmed', 'logActivity.crane.signalPersonConfirmed')]), single('FORKLIFT_OPERATOR', 'logActivity.activityType.forklift', 'logActivity.forklift.heading', [bool('forksAndMastInspectionPassed', 'logActivity.forklift.forksAndMastInspectionPassed'), bool('hornLightsBrakesChecked', 'logActivity.forklift.hornLightsBrakesChecked'), list('leakOrDamageFlags', 'logActivity.forklift.leakOrDamageFlags'), optNum('loadWeightMovedKg', 'logActivity.forklift.loadWeightMovedKg'), opt('aisleOrZoneWorked', 'logActivity.forklift.aisleOrZoneWorked'), int('batteryOrPropaneSwapCount', 'logActivity.forklift.batteryOrPropaneSwapCount'), int('nearMissReports', 'logActivity.forklift.nearMissReports'), opt('rackCollisionNotes', 'logActivity.forklift.rackCollisionNotes')]), single('RAILWAY_CONDUCTOR', 'logActivity.activityType.railway', 'logActivity.railway.heading', [str('lineRouteSegment', 'logActivity.railway.lineRouteSegment'), optInt('consistCarCount', 'logActivity.railway.consistCarCount'), optNum('consistTonnage', 'logActivity.railway.consistTonnage'), bool('brakeTestVerified', 'logActivity.railway.brakeTestVerified'), opt('signalComplianceLog', 'logActivity.railway.signalComplianceLog'), list('speedRestrictionZonesObserved', 'logActivity.railway.speedRestrictionZonesObserved'), opt('trackWarrantAuthorityNumber', 'logActivity.railway.trackWarrantAuthorityNumber')]), single('HEAVY_EQUIPMENT_OPERATOR', 'logActivity.activityType.heavyEquipment', 'logActivity.heavyEquipment.heading', [str('equipmentType', 'logActivity.heavyEquipment.equipmentType'), optNum('hourMeterReading', 'logActivity.heavyEquipment.hourMeterReading'), opt('attachmentUsed', 'logActivity.heavyEquipment.attachmentUsed'), optNum('materialMovedCubicYards', 'logActivity.heavyEquipment.materialMovedCubicYards'), opt('gradeToleranceAchieved', 'logActivity.heavyEquipment.gradeToleranceAchieved'), opt('siteLocation', 'logActivity.heavyEquipment.siteLocation'), bool('preShiftInspectionPassed', 'logActivity.heavyEquipment.preShiftInspectionPassed'), bool('undergroundUtilityLocatesConfirmed', 'logActivity.heavyEquipment.undergroundUtilityLocatesConfirmed'), bool('spotterPresent', 'logActivity.heavyEquipment.spotterPresent')]), single('LAB_RESEARCHER', 'logActivity.activityType.labResearch', 'logActivity.labResearch.heading', [str('experimentProtocolId', 'logActivity.labResearch.experimentProtocolId'), opt('hypothesisStatement', 'logActivity.labResearch.hypothesisStatement'), list('reagentLotNumbers', 'logActivity.labResearch.reagentLotNumbers'), optNum('reactionTimeMinutes', 'logActivity.labResearch.reactionTimeMinutes'), optNum('temperatureC', 'logActivity.labResearch.temperatureC', VOID, true), optNum('pressureKpa', 'logActivity.labResearch.pressureKpa'), optNum('yieldPercent', 'logActivity.labResearch.yieldPercent'), opt('witnessOrCoSigner', 'logActivity.labResearch.witnessOrCoSigner'), opt('notebookPageReference', 'logActivity.labResearch.notebookPageReference'), opt('instrumentCalibrationReference', 'logActivity.labResearch.instrumentCalibrationReference')]), single('HAM_RADIO_OPERATOR', 'logActivity.activityType.hamRadio', 'logActivity.hamRadio.heading', [str('contactCallSign', 'logActivity.hamRadio.contactCallSign'), num('frequencyMhz', 'logActivity.hamRadio.frequencyMhz'), str('mode', 'logActivity.hamRadio.mode'), opt('signalReportSent', 'logActivity.hamRadio.signalReportSent'), opt('signalReportReceived', 'logActivity.hamRadio.signalReportReceived'), opt('bandConditions', 'logActivity.hamRadio.bandConditions'), optNum('powerOutputWatts', 'logActivity.hamRadio.powerOutputWatts'), opt('antennaConfiguration', 'logActivity.hamRadio.antennaConfiguration'), bool('qslCardConfirmed', 'logActivity.hamRadio.qslCardConfirmed')]), single('ENVIRONMENTAL_FIELD_CREW', 'logActivity.activityType.envField', 'logActivity.envField.heading', [str('sampleIdBarcode', 'logActivity.envField.sampleIdBarcode'), opt('gpsCoordinates', 'logActivity.envField.gpsCoordinates'), opt('collectorSignature', 'logActivity.envField.collectorSignature'), opt('transferLog', 'logActivity.envField.transferLog'), opt('preservationMethod', 'logActivity.envField.preservationMethod'), optNum('waterOrSoilTempC', 'logActivity.envField.waterOrSoilTempC', VOID, true), optNum('phReading', 'logActivity.envField.phReading'), optNum('conductivityReading', 'logActivity.envField.conductivityReading'), opt('weatherAtCollection', 'logActivity.envField.weatherAtCollection')]), single('SOFTWARE_QA_ENGINEER', 'logActivity.activityType.qaTesting', 'logActivity.qaTesting.heading', [str('buildCommitHash', 'logActivity.qaTesting.buildCommitHash'), str('environment', 'logActivity.qaTesting.environment'), opt('testSuiteVersion', 'logActivity.qaTesting.testSuiteVersion'), opt('bugReplicationSteps', 'logActivity.qaTesting.bugReplicationSteps'), opt('severityClassification', 'logActivity.qaTesting.severityClassification'), opt('affectedComponent', 'logActivity.qaTesting.affectedComponent'), opt('vulnerabilityPayloadUsed', 'logActivity.qaTesting.vulnerabilityPayloadUsed'), opt('cveOrCweReference', 'logActivity.qaTesting.cveOrCweReference'), opt('exploitTimelineNotes', 'logActivity.qaTesting.exploitTimelineNotes')]), single('SOUND_ENGINEER', 'logActivity.activityType.soundRecording', 'logActivity.soundRecording.heading', [str('studioOrVenue', 'logActivity.soundRecording.studioOrVenue'), list('microphoneModelsAndPlacement', 'logActivity.soundRecording.microphoneModelsAndPlacement'), optNum('preampGainSettingsDb', 'logActivity.soundRecording.preampGainSettingsDb'), optInt('trackTakeNumber', 'logActivity.soundRecording.trackTakeNumber'), optNum('tempoBpm', 'logActivity.soundRecording.tempoBpm'), opt('key', 'logActivity.soundRecording.key'), bool('compOrKeeperFlag', 'logActivity.soundRecording.compOrKeeperFlag'), list('pluginChainUsed', 'logActivity.soundRecording.pluginChainUsed'), opt('busRoutingConfiguration', 'logActivity.soundRecording.busRoutingConfiguration'), optNum('masterExportLoudnessLufs', 'logActivity.soundRecording.masterExportLoudnessLufs')]), single('LAND_SURVEYOR', 'logActivity.activityType.landSurvey', 'logActivity.landSurvey.heading', [opt('benchmarkReference', 'logActivity.landSurvey.benchmarkReference'), opt('gpsRtkCoordinates', 'logActivity.landSurvey.gpsRtkCoordinates'), opt('totalStationReadings', 'logActivity.landSurvey.totalStationReadings'), opt('instrumentModel', 'logActivity.landSurvey.instrumentModel'), opt('calibrationDate', 'logActivity.landSurvey.calibrationDate'), opt('platOrBoundarySketchReference', 'logActivity.landSurvey.platOrBoundarySketchReference'), opt('clientOrProjectNumber', 'logActivity.landSurvey.clientOrProjectNumber')]), single('POWERLIFTER', 'logActivity.activityType.powerlifting', 'logActivity.powerlifting.heading', [optNum('totalSessionTonnageKg', 'logActivity.powerlifting.totalSessionTonnageKg'), list('setsRepsWeightLog', 'logActivity.powerlifting.setsRepsWeightLog'), optNum('rpe', 'logActivity.powerlifting.rpe'), optNum('barVelocityMs', 'logActivity.powerlifting.barVelocityMs'), optNum('oneRepMaxEstimateKg', 'logActivity.powerlifting.oneRepMaxEstimateKg'), list('competitionAttempts', 'logActivity.powerlifting.competitionAttempts')]), single('TRAIL_RUNNER', 'logActivity.activityType.trailRun', 'logActivity.trailRun.heading', [num('distanceMeters', 'logActivity.trailRun.distanceMeters'), int('durationSeconds', 'logActivity.trailRun.durationSeconds'), optNum('paceSecondsPerKm', 'logActivity.trailRun.paceSecondsPerKm'), optNum('elevationGainMeters', 'logActivity.trailRun.elevationGainMeters'), optInt('avgHeartRateBpm', 'logActivity.trailRun.avgHeartRateBpm'), optInt('cadenceSpm', 'logActivity.trailRun.cadenceSpm'), opt('shoeModel', 'logActivity.trailRun.shoeModel'), optNum('cumulativeShoeMileageKm', 'logActivity.trailRun.cumulativeShoeMileageKm')]), single('TRIATHLETE', 'logActivity.activityType.triathlon', 'logActivity.triathlon.heading', [int('swimSplitSeconds', 'logActivity.triathlon.swimSplitSeconds'), int('bikeSplitSeconds', 'logActivity.triathlon.bikeSplitSeconds'), int('runSplitSeconds', 'logActivity.triathlon.runSplitSeconds'), optInt('t1DurationSeconds', 'logActivity.triathlon.t1DurationSeconds'), optInt('t2DurationSeconds', 'logActivity.triathlon.t2DurationSeconds'), opt('wetsuitBikeRunGearConfiguration', 'logActivity.triathlon.wetsuitBikeRunGearConfiguration'), opt('nutritionPlanFollowed', 'logActivity.triathlon.nutritionPlanFollowed')]), single('PHYSICAL_THERAPY_PATIENT', 'logActivity.activityType.physicalTherapy', 'logActivity.physicalTherapy.heading', [optNum('rangeOfMotionDegrees', 'logActivity.physicalTherapy.rangeOfMotionDegrees'), optInt('painRatingScale', 'logActivity.physicalTherapy.painRatingScale'), list('exerciseSetsReps', 'logActivity.physicalTherapy.exerciseSetsReps'), opt('resistanceOrTissueLoadProgression', 'logActivity.physicalTherapy.resistanceOrTissueLoadProgression'), opt('therapistSignature', 'logActivity.physicalTherapy.therapistSignature'), opt('nextMilestoneOrReassessmentDate', 'logActivity.physicalTherapy.nextMilestoneOrReassessmentDate')]), single('COMPETITIVE_CYCLIST', 'logActivity.activityType.cycling', 'logActivity.cycling.heading', [num('distanceMeters', 'logActivity.cycling.distanceMeters'), optNum('avgPowerWatts', 'logActivity.cycling.avgPowerWatts'), optNum('normalizedPowerWatts', 'logActivity.cycling.normalizedPowerWatts'), optNum('cadenceRpm', 'logActivity.cycling.cadenceRpm'), optInt('avgHeartRateBpm', 'logActivity.cycling.avgHeartRateBpm'), optNum('ftpTestResultWatts', 'logActivity.cycling.ftpTestResultWatts'), opt('bikeSetup', 'logActivity.cycling.bikeSetup'), optNum('tirePressureBar', 'logActivity.cycling.tirePressureBar'), opt('gearRatio', 'logActivity.cycling.gearRatio')]), single('COMPETITIVE_SWIMMER', 'logActivity.activityType.swimming', 'logActivity.swimming.heading', [str('strokeType', 'logActivity.swimming.strokeType'), num('distancePerSetMeters', 'logActivity.swimming.distancePerSetMeters'), optInt('restIntervalSeconds', 'logActivity.swimming.restIntervalSeconds'), optNum('pacePer100mSeconds', 'logActivity.swimming.pacePer100mSeconds'), optInt('avgHeartRateBpm', 'logActivity.swimming.avgHeartRateBpm'), optInt('strokeCountPerLength', 'logActivity.swimming.strokeCountPerLength'), opt('poolLengthType', 'logActivity.swimming.poolLengthType'), opt('suitType', 'logActivity.swimming.suitType')]), single('EQUESTRIAN', 'logActivity.activityType.equestrian', 'logActivity.equestrian.heading', [optNum('ridingRingHours', 'logActivity.equestrian.ridingRingHours'), opt('jumpingCountAndHeights', 'logActivity.equestrian.jumpingCountAndHeights'), str('discipline', 'logActivity.equestrian.discipline'), opt('farrierShoeingRotationDate', 'logActivity.equestrian.farrierShoeingRotationDate'), list('veterinaryLogEntries', 'logActivity.equestrian.veterinaryLogEntries'), opt('competitionScores', 'logActivity.equestrian.competitionScores'), opt('lamenessOrSoundnessNotes', 'logActivity.equestrian.lamenessOrSoundnessNotes')]), single('WORKING_DOG_HANDLER', 'logActivity.activityType.workingDog', 'logActivity.workingDog.heading', [optNum('scentTrailTrackingHours', 'logActivity.workingDog.scentTrailTrackingHours'), optNum('dummyTargetFindRatio', 'logActivity.workingDog.dummyTargetFindRatio'), list('distractionResistanceDrills', 'logActivity.workingDog.distractionResistanceDrills'), opt('searchAreaOrGrid', 'logActivity.workingDog.searchAreaOrGrid'), opt('findOutcome', 'logActivity.workingDog.findOutcome'), opt('certificationLevel', 'logActivity.workingDog.certificationLevel'), opt('recertificationDueDate', 'logActivity.workingDog.recertificationDueDate')]), single('FALCONER', 'logActivity.activityType.falconry', 'logActivity.falconry.heading', [str('raptorSpecies', 'logActivity.falconry.raptorSpecies'), optNum('baselineOrFlyingWeightG', 'logActivity.falconry.baselineOrFlyingWeightG'), opt('dailyFeedingSchedule', 'logActivity.falconry.dailyFeedingSchedule'), optNum('freeFlightAirtimeMinutes', 'logActivity.falconry.freeFlightAirtimeMinutes'), bool('wildHuntSuccess', 'logActivity.falconry.wildHuntSuccess'), bool('jessesTelemetryUnitChecked', 'logActivity.falconry.jessesTelemetryUnitChecked'), opt('mewsHousingConditionNotes', 'logActivity.falconry.mewsHousingConditionNotes')]), single('BEEKEEPER', 'logActivity.activityType.apiary', 'logActivity.apiary.heading', [str('hiveId', 'logActivity.apiary.hiveId'), opt('queenSurvivalOrLayingStatus', 'logActivity.apiary.queenSurvivalOrLayingStatus'), opt('broodPatternNotes', 'logActivity.apiary.broodPatternNotes'), optInt('varroaMiteCount', 'logActivity.apiary.varroaMiteCount'), opt('diseaseOrPestTreatmentApplied', 'logActivity.apiary.diseaseOrPestTreatmentApplied'), optNum('seasonalHoneyYieldKg', 'logActivity.apiary.seasonalHoneyYieldKg'), optInt('frameCountHarvested', 'logActivity.apiary.frameCountHarvested')]), single('LIVESTOCK_HANDLER', 'logActivity.activityType.livestock', 'logActivity.livestock.heading', [int('headCount', 'logActivity.livestock.headCount'), list('tagOrIdNumbers', 'logActivity.livestock.tagOrIdNumbers'), optNum('weightGainTrackingKg', 'logActivity.livestock.weightGainTrackingKg'), opt('vaccinationSchedule', 'logActivity.livestock.vaccinationSchedule'), opt('medicationAdministered', 'logActivity.livestock.medicationAdministered'), opt('calvingOrLambingRecords', 'logActivity.livestock.calvingOrLambingRecords'), opt('pastureRotationDate', 'logActivity.livestock.pastureRotationDate'), opt('feedRations', 'logActivity.livestock.feedRations')]), single('TATTOO_APPRENTICE', 'logActivity.activityType.tattooApprentice', 'logActivity.tattooApprentice.heading', [optNum('skinCanvasHours', 'logActivity.tattooApprentice.skinCanvasHours'), str('supervisingArtist', 'logActivity.tattooApprentice.supervisingArtist'), optInt('autoclaveSterilizationCycles', 'logActivity.tattooApprentice.autoclaveSterilizationCycles'), opt('sporeTestResult', 'logActivity.tattooApprentice.sporeTestResult'), opt('crossContaminationExamResult', 'logActivity.tattooApprentice.crossContaminationExamResult'), opt('bloodbornePathogenCertificationDate', 'logActivity.tattooApprentice.bloodbornePathogenCertificationDate')]), single('TRADE_APPRENTICE', 'logActivity.activityType.tradeApprentice', 'logActivity.tradeApprentice.heading', [str('jobSiteOrProject', 'logActivity.tradeApprentice.jobSiteOrProject'), opt('commercialVsResidentialHours', 'logActivity.tradeApprentice.commercialVsResidentialHours'), opt('taskCategory', 'logActivity.tradeApprentice.taskCategory'), str('masterTradespersonNameOrLicense', 'logActivity.tradeApprentice.masterTradespersonNameOrLicense'), opt('signOffDate', 'logActivity.tradeApprentice.signOffDate'), optNum('cumulativeHoursTowardLicense', 'logActivity.tradeApprentice.cumulativeHoursTowardLicense'), list('codeExamMilestones', 'logActivity.tradeApprentice.codeExamMilestones')]), single('SCUBA_LIFE_SUPPORT_TECHNICIAN', 'logActivity.activityType.scubaService', 'logActivity.scubaService.heading', [str('regulatorSerialNumber', 'logActivity.scubaService.regulatorSerialNumber'), list('componentTeardownChecklist', 'logActivity.scubaService.componentTeardownChecklist'), list('partsReplaced', 'logActivity.scubaService.partsReplaced'), optNum('intermediatePressureTestReadingBar', 'logActivity.scubaService.intermediatePressureTestReadingBar'), bool('crackingOrVenturiEffectCheckPassed', 'logActivity.scubaService.crackingOrVenturiEffectCheckPassed'), opt('manufacturerWarrantyStatus', 'logActivity.scubaService.manufacturerWarrantyStatus'), str('technicianCertificationNumber', 'logActivity.scubaService.technicianCertificationNumber')]), single('WELDING_APPRENTICE', 'logActivity.activityType.weldingApprentice', 'logActivity.weldingApprentice.heading', [optNum('arcHours', 'logActivity.weldingApprentice.arcHours'), opt('metalTypeAndThickness', 'logActivity.weldingApprentice.metalTypeAndThickness'), str('weldProcess', 'logActivity.weldingApprentice.weldProcess'), opt('jointIntegrityTestResult', 'logActivity.weldingApprentice.jointIntegrityTestResult'), optNum('defectRate', 'logActivity.weldingApprentice.defectRate'), opt('awsCertificationTrack', 'logActivity.weldingApprentice.awsCertificationTrack'), opt('supervisingWelderSignOff', 'logActivity.weldingApprentice.supervisingWelderSignOff')]), single('CULINARY_APPRENTICE', 'logActivity.activityType.culinaryApprentice', 'logActivity.culinaryApprentice.heading', [str('kitchenStationAssigned', 'logActivity.culinaryApprentice.kitchenStationAssigned'), opt('supervisingChef', 'logActivity.culinaryApprentice.supervisingChef'), optNum('hoursLogged', 'logActivity.culinaryApprentice.hoursLogged'), opt('knifeSkillsAssessmentResult', 'logActivity.culinaryApprentice.knifeSkillsAssessmentResult'), opt('foodSafetyCertification', 'logActivity.culinaryApprentice.foodSafetyCertification'), opt('recipeExecutionTestResult', 'logActivity.culinaryApprentice.recipeExecutionTestResult'), opt('executiveChefSignature', 'logActivity.culinaryApprentice.executiveChefSignature'), optNum('apprenticeshipHoursTowardCertification', 'logActivity.culinaryApprentice.apprenticeshipHoursTowardCertification')])]);
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0 = get_ACTIVITY_SCHEMAS();
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var list_0 = element.v25_1;
        addAll(destination, list_0);
      }
      // Inline function 'kotlin.collections.distinctBy' call
      var set = HashSet_init_$Create$();
      var list_1 = ArrayList_init_$Create$();
      var _iterator__ex2g4s_0 = destination.t();
      while (_iterator__ex2g4s_0.u()) {
        var e = _iterator__ex2g4s_0.v();
        var key = e.q25_1;
        if (set.x(key)) {
          list_1.x(e);
        }
      }
      ACTIVITY_FIELD_GROUPS = list_1;
    }
  }
  function get_AppScope() {
    _init_properties_AppScope_kt__e9fb1p();
    return AppScope;
  }
  var AppScope;
  var properties_initialized_AppScope_kt_9z3ewb;
  function _init_properties_AppScope_kt__e9fb1p() {
    if (!properties_initialized_AppScope_kt_9z3ewb) {
      properties_initialized_AppScope_kt_9z3ewb = true;
      AppScope = MainScope();
    }
  }
  function setHidden($this, dataAuth, hidden) {
    var nodes = document.querySelectorAll('[data-auth="' + dataAuth + '"]');
    var inductionVariable = 0;
    var last = nodes.length;
    if (inductionVariable < last)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = nodes.item(i);
        var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var el = tmp_0;
        if (hidden) {
          el.classList.add('hidden');
        } else {
          el.classList.remove('hidden');
        }
      }
       while (inductionVariable < last);
  }
  function renderAvatar($this, avatarEl, profile) {
    avatarEl.innerHTML = '';
    var avatarUrl = profile.b26_1;
    var initials = initialsOf($this, profile.y25_1);
    if (!(avatarUrl == null)) {
      append(avatarEl, CommonModule$renderAvatar$lambda(avatarUrl, profile));
    } else if (!(initials == null)) {
      avatarEl.textContent = initials;
    } else {
      append(avatarEl, CommonModule$renderAvatar$lambda_0);
    }
  }
  function initialsOf($this, displayName) {
    // Inline function 'kotlin.text.trim' call
    var tmp0 = toString(trim(isCharSequence(displayName) ? displayName : THROW_CCE()));
    // Inline function 'kotlin.text.split' call
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = Regex_init_$Create$('\\s+').hb(tmp0, 0);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0_0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination.x(element);
      }
    }
    var words = destination;
    var tmp;
    if (words.r()) {
      tmp = null;
    } else if (words.z() === 1) {
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = take(words.a1(0), 2).toUpperCase();
    } else {
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = (take(first(words), 1) + take(last(words), 1)).toUpperCase();
    }
    return tmp;
  }
  function CommonModule$initAuthNav$lambda(event) {
    event.preventDefault();
    AuthState_instance.p2();
    window.location.href = '/';
    return Unit_instance;
  }
  function CommonModule$initAuthNav$lambda_0($code) {
    return function (it) {
      I18n_getInstance().l26($code);
      var tmp0_safe_receiver = document.getElementById('langDropdownToggle');
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.textContent = I18n_getInstance().r26().p26_1;
      }
      return Unit_instance;
    };
  }
  function CommonModule$initAuthNav$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CommonModule$initAuthNav$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(CommonModule$initAuthNav$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CommonModule$initAuthNav$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.a27_1;
            this.u7_1 = 2;
            this.c27_1 = Companion_instance;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/auth/me';
            this.d27_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.d27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(MeResponse), arrayOf([]), false));
            var ARGUMENT = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2).j27_1;
            var tmp2_0 = toSet(ARGUMENT);
            var tmp_0 = this;
            this.c27_1;
            tmp_0.b27_1 = _Result___init__impl__xyqfz8(tmp2_0);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.b27_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var tmp0_0 = this.b27_1;
            var tmp2_1 = emptySet();
            var tmp$ret$0;
            l$ret$1: do {
              if (_Result___get_isFailure__impl__jpiriv(tmp0_0)) {
                tmp$ret$0 = tmp2_1;
                break l$ret$1;
              }
              tmp$ret$0 = _Result___get_value__impl__bjfvqg(tmp0_0);
            }
             while (false);
            var roles = tmp$ret$0;
            AuthState_instance.k27(roles);
            setHidden(CommonModule_instance, 'super-admin', !roles.c2('SUPER_ADMIN'));
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(CommonModule$initAuthNav$slambda).h22 = function ($this$launch, completion) {
    var i = new CommonModule$initAuthNav$slambda(completion);
    i.a27_1 = $this$launch;
    return i;
  };
  function CommonModule$initAuthNav$slambda_0(resultContinuation) {
    var i = new CommonModule$initAuthNav$slambda(resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function CommonModule$initAuthNav$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CommonModule$initAuthNav$slambda_1).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(CommonModule$initAuthNav$slambda_1).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CommonModule$initAuthNav$slambda_1).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.t27_1;
            this.u7_1 = 2;
            this.v27_1 = Companion_instance;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/members/me';
            this.w27_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.w27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(MyProfileResponse), arrayOf([]), false));
            var tmp2_0 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            this.v27_1;
            tmp_0.u27_1 = _Result___init__impl__xyqfz8(tmp2_0);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.u27_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            var this_3 = this.u27_1;
            var profile = _Result___get_isFailure__impl__jpiriv(this_3) ? null : _Result___get_value__impl__bjfvqg(this_3);
            var tmp_3 = document.getElementById('userAvatar');
            var tmp0_elvis_lhs = tmp_3 instanceof HTMLElement ? tmp_3 : null;
            var tmp_4;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_4 = tmp0_elvis_lhs;
            }

            var avatarEl = tmp_4;
            if (!(profile == null)) {
              renderAvatar(CommonModule_instance, avatarEl, profile);
            }

            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(CommonModule$initAuthNav$slambda_1).h22 = function ($this$launch, completion) {
    var i = new CommonModule$initAuthNav$slambda_1(completion);
    i.t27_1 = $this$launch;
    return i;
  };
  function CommonModule$initAuthNav$slambda_2(resultContinuation) {
    var i = new CommonModule$initAuthNav$slambda_1(resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function CommonModule$renderAvatar$lambda($avatarUrl, $profile) {
    return function ($this$append) {
      var tmp0_src = $avatarUrl;
      // Inline function 'kotlinx.html.img' call
      var alt = $profile.y25_1;
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new IMG(attributesMapOf(['alt', alt, 'src', tmp0_src, 'loading', null == null ? null : enumEncode(null), 'class', null]), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function CommonModule$renderAvatar$lambda_0($this$append) {
    uiIcon_0($this$append, 'person');
    return Unit_instance;
  }
  function CommonModule() {
  }
  protoOf(CommonModule).x27 = function () {
    setHidden(this, 'guest', AuthState_instance.y27());
    setHidden(this, 'user', !AuthState_instance.y27());
    setHidden(this, 'super-admin', !AuthState_instance.z27());
    var tmp0_safe_receiver = document.getElementById('logoutNavLink');
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.addEventListener('click', CommonModule$initAuthNav$lambda);
    }
    var langOptions = document.querySelectorAll('.lang-option');
    var inductionVariable = 0;
    var last = langOptions.length;
    if (inductionVariable < last)
      $l$loop_0: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = langOptions.item(i);
        var tmp1_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var el = tmp_0;
        var tmp2_elvis_lhs = el.getAttribute('data-lang');
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var code = tmp_1;
        el.addEventListener('click', CommonModule$initAuthNav$lambda_0(code));
      }
       while (inductionVariable < last);
    if (!AuthState_instance.y27())
      return Unit_instance;
    if (AuthState_instance.a28() == null) {
      var tmp_2 = get_AppScope();
      launch(tmp_2, VOID, VOID, CommonModule$initAuthNav$slambda_0(null));
    }
    var tmp_3 = get_AppScope();
    launch(tmp_3, VOID, VOID, CommonModule$initAuthNav$slambda_2(null));
  };
  var CommonModule_instance;
  function CommonModule_getInstance() {
    return CommonModule_instance;
  }
  function get_countryCatalog() {
    _init_properties_CountryCatalog_kt__tmykj();
    return countryCatalog;
  }
  var countryCatalog;
  function get_countryPickerCodes() {
    _init_properties_CountryCatalog_kt__tmykj();
    return countryPickerCodes;
  }
  var countryPickerCodes;
  function get_countryTranslations() {
    _init_properties_CountryCatalog_kt__tmykj();
    return countryTranslations;
  }
  var countryTranslations;
  function CountryCatalogEntry(code, englishName, i18nKey) {
    this.b28_1 = code;
    this.c28_1 = englishName;
    this.d28_1 = i18nKey;
  }
  protoOf(CountryCatalogEntry).toString = function () {
    return 'CountryCatalogEntry(code=' + this.b28_1 + ', englishName=' + this.c28_1 + ', i18nKey=' + this.d28_1 + ')';
  };
  protoOf(CountryCatalogEntry).hashCode = function () {
    var result = getStringHashCode(this.b28_1);
    result = imul(result, 31) + getStringHashCode(this.c28_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d28_1) | 0;
    return result;
  };
  protoOf(CountryCatalogEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CountryCatalogEntry))
      return false;
    if (!(this.b28_1 === other.b28_1))
      return false;
    if (!(this.c28_1 === other.c28_1))
      return false;
    if (!(this.d28_1 === other.d28_1))
      return false;
    return true;
  };
  function countryDisplayName(code) {
    _init_properties_CountryCatalog_kt__tmykj();
    var tmp;
    var tmp0 = get_countryCatalog();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.r();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.b28_1 === code) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      tmp = I18n_getInstance().e28('country.' + code);
    } else {
      tmp = code;
    }
    return tmp;
  }
  function countryCodeForDisplayName(displayName) {
    _init_properties_CountryCatalog_kt__tmykj();
    // Inline function 'kotlin.collections.find' call
    var tmp0 = get_countryCatalog();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (equals_0(countryDisplayName(element.b28_1), displayName, true)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b28_1;
  }
  function countryPicker(_this__u8e3s4, inputId, placeholder, required, placeholderI18nKey) {
    required = required === VOID ? false : required;
    placeholderI18nKey = placeholderI18nKey === VOID ? null : placeholderI18nKey;
    _init_properties_CountryCatalog_kt__tmykj();
    // Inline function 'kotlinx.html.div' call
    var classes = 'country-picker';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new DIV(attributesMapOf_0('class', classes), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    // Inline function 'kotlinx.html.input' call
    var tmp0_safe_receiver = InputType_text_getInstance();
    var tmp = tmp0_safe_receiver == null ? null : enumEncode(tmp0_safe_receiver);
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new INPUT(attributesMapOf(['type', tmp, 'formenctype', tmp_0, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_0.j1f());
    this_1.j1f().a1h(this_1);
    set_id(this_1, inputId);
    this_1.b1m(placeholder);
    if (!(placeholderI18nKey == null)) {
      var tmp0 = this_1.l1f();
      // Inline function 'kotlin.collections.set' call
      var key = 'data-i18n-placeholder';
      tmp0.m2(key, placeholderI18nKey);
    }
    var tmp0_0 = this_1.l1f();
    // Inline function 'kotlin.collections.set' call
    var key_0 = 'autocomplete';
    tmp0_0.m2(key_0, 'off');
    this_1.c1m(required);
    set_onFocusFunction(this_1, countryPicker$lambda(inputId));
    set_onInputFunction(this_1, countryPicker$lambda_0(inputId));
    set_onBlurFunction(this_1, countryPicker$lambda_1(inputId));
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.div' call
    var classes_0 = 'country-picker-options';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new DIV(attributesMapOf_0('class', classes_0), this_0.j1f());
    this_2.j1f().a1h(this_2);
    set_id(this_2, inputId + '-options');
    this_2.j1f().b1h(this_2);
    this_0.j1f().b1h(this_0);
  }
  function renderCountryOptions(inputId, codes) {
    var tmp;
    if (codes === VOID) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = get_countryCatalog();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.t();
      while (_iterator__ex2g4s.u()) {
        var item = _iterator__ex2g4s.v();
        var tmp$ret$2 = item.b28_1;
        destination.x(tmp$ret$2);
      }
      tmp = destination;
    } else {
      tmp = codes;
    }
    codes = tmp;
    _init_properties_CountryCatalog_kt__tmykj();
    // Inline function 'kotlin.collections.set' call
    get_countryPickerCodes().m2(inputId, codes);
    renderCountryDropdownOptions(inputId, codes);
  }
  function renderCountryDropdownOptions(inputId, codes) {
    _init_properties_CountryCatalog_kt__tmykj();
    var tmp = document.getElementById(inputId);
    var input = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById(inputId + '-options');
    var panel = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    panel.innerHTML = '';
    append(panel, renderCountryDropdownOptions$lambda(codes, input, inputId));
  }
  function openCountryDropdown(inputId) {
    _init_properties_CountryCatalog_kt__tmykj();
    var tmp = document.getElementById(inputId);
    var input = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
    // Inline function 'kotlin.text.trim' call
    var this_0 = input.value;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var typed = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())).toLowerCase();
    var tmp0_elvis_lhs = get_countryPickerCodes().i2(inputId);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.map' call
      var this_1 = get_countryCatalog();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s = this_1.t();
      while (_iterator__ex2g4s.u()) {
        var item = _iterator__ex2g4s.v();
        var tmp$ret$5 = item.b28_1;
        destination.x(tmp$ret$5);
      }
      tmp_0 = destination;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var codes = tmp_0;
    var tmp_1;
    if (isBlank(typed)) {
      tmp_1 = codes;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var _iterator__ex2g4s_0 = codes.t();
      while (_iterator__ex2g4s_0.u()) {
        var element = _iterator__ex2g4s_0.v();
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$9 = countryDisplayName(element).toLowerCase();
        if (contains(tmp$ret$9, typed)) {
          destination_0.x(element);
        }
      }
      tmp_1 = destination_0;
    }
    var matches = tmp_1;
    renderCountryDropdownOptions(inputId, matches);
    var tmp_2 = document.getElementById(inputId + '-options');
    (tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE()).classList.add('open');
  }
  function closeCountryDropdown(inputId) {
    _init_properties_CountryCatalog_kt__tmykj();
    var tmp = document.getElementById(inputId + '-options');
    (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('open');
  }
  function wireCountryPicker(inputId) {
    _init_properties_CountryCatalog_kt__tmykj();
    var tmp = document.getElementById(inputId);
    var input = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
    input.addEventListener('focus', wireCountryPicker$lambda(inputId));
    input.addEventListener('input', wireCountryPicker$lambda_0(inputId));
    input.addEventListener('blur', wireCountryPicker$lambda_1(inputId));
  }
  function countryInputValue(inputId) {
    _init_properties_CountryCatalog_kt__tmykj();
    var tmp = document.getElementById(inputId);
    // Inline function 'kotlin.text.trim' call
    var this_0 = (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value;
    var raw = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    if (isBlank(raw))
      return null;
    var tmp0_elvis_lhs = countryCodeForDisplayName(raw);
    return tmp0_elvis_lhs == null ? raw : tmp0_elvis_lhs;
  }
  function setCountryInputValue(inputId, code) {
    _init_properties_CountryCatalog_kt__tmykj();
    var tmp = document.getElementById(inputId);
    var tmp_0 = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
    var tmp_1;
    if (code == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = countryDisplayName(code);
    }
    var tmp1_elvis_lhs = tmp_1;
    tmp_0.value = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  }
  function countryPicker$lambda($inputId) {
    return function (it) {
      openCountryDropdown($inputId);
      return Unit_instance;
    };
  }
  function countryPicker$lambda_0($inputId) {
    return function (it) {
      openCountryDropdown($inputId);
      return Unit_instance;
    };
  }
  function countryPicker$lambda$lambda($inputId) {
    return function () {
      closeCountryDropdown($inputId);
      return Unit_instance;
    };
  }
  function countryPicker$lambda_1($inputId) {
    return function (it) {
      var tmp = window;
      tmp.setTimeout(countryPicker$lambda$lambda($inputId), 150);
      return Unit_instance;
    };
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.f28_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).cc = function (a, b) {
    return this.f28_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.cc(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).c3 = function () {
    return this.f28_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.c3(), other.c3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.c3());
  };
  function renderCountryDropdownOptions$lambda$lambda(a, b) {
    _init_properties_CountryCatalog_kt__tmykj();
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = countryDisplayName(a);
    var tmp$ret$2 = countryDisplayName(b);
    return compareValues(tmp, tmp$ret$2);
  }
  function renderCountryDropdownOptions$lambda$lambda_0($input, $code, $inputId) {
    return function (it) {
      $input.value = countryDisplayName($code);
      closeCountryDropdown($inputId);
      return Unit_instance;
    };
  }
  function renderCountryDropdownOptions$lambda($codes, $input, $inputId) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.sortedBy' call
      var this_0 = $codes;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp = renderCountryDropdownOptions$lambda$lambda;
      var tmp$ret$1 = new sam$kotlin_Comparator$0(tmp);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = sortedWith(this_0, tmp$ret$1).t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = 'country-picker-option';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_1 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_1.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_1.j1f().a1h(this_1);
        this_1.n1f(countryDisplayName(element));
        set_onClickFunction(this_1, renderCountryDropdownOptions$lambda$lambda_0($input, element, $inputId));
        this_1.j1f().b1h(this_1);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function wireCountryPicker$lambda($inputId) {
    return function (it) {
      openCountryDropdown($inputId);
      return Unit_instance;
    };
  }
  function wireCountryPicker$lambda_0($inputId) {
    return function (it) {
      openCountryDropdown($inputId);
      return Unit_instance;
    };
  }
  function wireCountryPicker$lambda$lambda($inputId) {
    return function () {
      closeCountryDropdown($inputId);
      return Unit_instance;
    };
  }
  function wireCountryPicker$lambda_1($inputId) {
    return function (it) {
      var tmp = window;
      tmp.setTimeout(wireCountryPicker$lambda$lambda($inputId), 150);
      return Unit_instance;
    };
  }
  var properties_initialized_CountryCatalog_kt_itamf9;
  function _init_properties_CountryCatalog_kt__tmykj() {
    if (!properties_initialized_CountryCatalog_kt_itamf9) {
      properties_initialized_CountryCatalog_kt_itamf9 = true;
      countryCatalog = listOf([new CountryCatalogEntry('AF', 'Afghanistan', 'country.AF'), new CountryCatalogEntry('AL', 'Albania', 'country.AL'), new CountryCatalogEntry('DZ', 'Algeria', 'country.DZ'), new CountryCatalogEntry('AD', 'Andorra', 'country.AD'), new CountryCatalogEntry('AO', 'Angola', 'country.AO'), new CountryCatalogEntry('AG', 'Antigua and Barbuda', 'country.AG'), new CountryCatalogEntry('AR', 'Argentina', 'country.AR'), new CountryCatalogEntry('AM', 'Armenia', 'country.AM'), new CountryCatalogEntry('AU', 'Australia', 'country.AU'), new CountryCatalogEntry('AT', 'Austria', 'country.AT'), new CountryCatalogEntry('AZ', 'Azerbaijan', 'country.AZ'), new CountryCatalogEntry('BS', 'The Bahamas', 'country.BS'), new CountryCatalogEntry('BH', 'Bahrain', 'country.BH'), new CountryCatalogEntry('BD', 'Bangladesh', 'country.BD'), new CountryCatalogEntry('BB', 'Barbados', 'country.BB'), new CountryCatalogEntry('BY', 'Belarus', 'country.BY'), new CountryCatalogEntry('BE', 'Belgium', 'country.BE'), new CountryCatalogEntry('BZ', 'Belize', 'country.BZ'), new CountryCatalogEntry('BJ', 'Benin', 'country.BJ'), new CountryCatalogEntry('BT', 'Bhutan', 'country.BT'), new CountryCatalogEntry('BO', 'Bolivia', 'country.BO'), new CountryCatalogEntry('BA', 'Bosnia and Herzegovina', 'country.BA'), new CountryCatalogEntry('BW', 'Botswana', 'country.BW'), new CountryCatalogEntry('BR', 'Brazil', 'country.BR'), new CountryCatalogEntry('BN', 'Brunei', 'country.BN'), new CountryCatalogEntry('BG', 'Bulgaria', 'country.BG'), new CountryCatalogEntry('BF', 'Burkina Faso', 'country.BF'), new CountryCatalogEntry('BI', 'Burundi', 'country.BI'), new CountryCatalogEntry('CV', 'Cabo Verde', 'country.CV'), new CountryCatalogEntry('KH', 'Cambodia', 'country.KH'), new CountryCatalogEntry('CM', 'Cameroon', 'country.CM'), new CountryCatalogEntry('CA', 'Canada', 'country.CA'), new CountryCatalogEntry('CF', 'Central African Republic', 'country.CF'), new CountryCatalogEntry('TD', 'Chad', 'country.TD'), new CountryCatalogEntry('CL', 'Chile', 'country.CL'), new CountryCatalogEntry('CN', 'China', 'country.CN'), new CountryCatalogEntry('CO', 'Colombia', 'country.CO'), new CountryCatalogEntry('KM', 'Comoros', 'country.KM'), new CountryCatalogEntry('CD', 'Democratic Republic of the Congo', 'country.CD'), new CountryCatalogEntry('CG', 'Republic of the Congo', 'country.CG'), new CountryCatalogEntry('CR', 'Costa Rica', 'country.CR'), new CountryCatalogEntry('CI', "C\xF4te d'Ivoire", 'country.CI'), new CountryCatalogEntry('HR', 'Croatia', 'country.HR'), new CountryCatalogEntry('CU', 'Cuba', 'country.CU'), new CountryCatalogEntry('CY', 'Cyprus', 'country.CY'), new CountryCatalogEntry('CZ', 'Czechia', 'country.CZ'), new CountryCatalogEntry('DK', 'Denmark', 'country.DK'), new CountryCatalogEntry('DJ', 'Djibouti', 'country.DJ'), new CountryCatalogEntry('DM', 'Dominica', 'country.DM'), new CountryCatalogEntry('DO', 'Dominican Republic', 'country.DO'), new CountryCatalogEntry('EC', 'Ecuador', 'country.EC'), new CountryCatalogEntry('EG', 'Egypt', 'country.EG'), new CountryCatalogEntry('SV', 'El Salvador', 'country.SV'), new CountryCatalogEntry('GQ', 'Equatorial Guinea', 'country.GQ'), new CountryCatalogEntry('ER', 'Eritrea', 'country.ER'), new CountryCatalogEntry('EE', 'Estonia', 'country.EE'), new CountryCatalogEntry('SZ', 'Eswatini', 'country.SZ'), new CountryCatalogEntry('ET', 'Ethiopia', 'country.ET'), new CountryCatalogEntry('FJ', 'Fiji', 'country.FJ'), new CountryCatalogEntry('FI', 'Finland', 'country.FI'), new CountryCatalogEntry('FR', 'France', 'country.FR'), new CountryCatalogEntry('GA', 'Gabon', 'country.GA'), new CountryCatalogEntry('GM', 'The Gambia', 'country.GM'), new CountryCatalogEntry('GE', 'Georgia', 'country.GE'), new CountryCatalogEntry('DE', 'Germany', 'country.DE'), new CountryCatalogEntry('GH', 'Ghana', 'country.GH'), new CountryCatalogEntry('GR', 'Greece', 'country.GR'), new CountryCatalogEntry('GD', 'Grenada', 'country.GD'), new CountryCatalogEntry('GT', 'Guatemala', 'country.GT'), new CountryCatalogEntry('GN', 'Guinea', 'country.GN'), new CountryCatalogEntry('GW', 'Guinea-Bissau', 'country.GW'), new CountryCatalogEntry('GY', 'Guyana', 'country.GY'), new CountryCatalogEntry('HT', 'Haiti', 'country.HT'), new CountryCatalogEntry('HN', 'Honduras', 'country.HN'), new CountryCatalogEntry('HU', 'Hungary', 'country.HU'), new CountryCatalogEntry('IS', 'Iceland', 'country.IS'), new CountryCatalogEntry('IN', 'India', 'country.IN'), new CountryCatalogEntry('ID', 'Indonesia', 'country.ID'), new CountryCatalogEntry('IR', 'Iran', 'country.IR'), new CountryCatalogEntry('IQ', 'Iraq', 'country.IQ'), new CountryCatalogEntry('IE', 'Ireland', 'country.IE'), new CountryCatalogEntry('IL', 'Israel', 'country.IL'), new CountryCatalogEntry('IT', 'Italy', 'country.IT'), new CountryCatalogEntry('JM', 'Jamaica', 'country.JM'), new CountryCatalogEntry('JP', 'Japan', 'country.JP'), new CountryCatalogEntry('JO', 'Jordan', 'country.JO'), new CountryCatalogEntry('KZ', 'Kazakhstan', 'country.KZ'), new CountryCatalogEntry('KE', 'Kenya', 'country.KE'), new CountryCatalogEntry('KI', 'Kiribati', 'country.KI'), new CountryCatalogEntry('XK', 'Kosovo', 'country.XK'), new CountryCatalogEntry('KW', 'Kuwait', 'country.KW'), new CountryCatalogEntry('KG', 'Kyrgyzstan', 'country.KG'), new CountryCatalogEntry('LA', 'Laos', 'country.LA'), new CountryCatalogEntry('LV', 'Latvia', 'country.LV'), new CountryCatalogEntry('LB', 'Lebanon', 'country.LB'), new CountryCatalogEntry('LS', 'Lesotho', 'country.LS'), new CountryCatalogEntry('LR', 'Liberia', 'country.LR'), new CountryCatalogEntry('LY', 'Libya', 'country.LY'), new CountryCatalogEntry('LI', 'Liechtenstein', 'country.LI'), new CountryCatalogEntry('LT', 'Lithuania', 'country.LT'), new CountryCatalogEntry('LU', 'Luxembourg', 'country.LU'), new CountryCatalogEntry('MG', 'Madagascar', 'country.MG'), new CountryCatalogEntry('MW', 'Malawi', 'country.MW'), new CountryCatalogEntry('MY', 'Malaysia', 'country.MY'), new CountryCatalogEntry('MV', 'Maldives', 'country.MV'), new CountryCatalogEntry('ML', 'Mali', 'country.ML'), new CountryCatalogEntry('MT', 'Malta', 'country.MT'), new CountryCatalogEntry('MH', 'Marshall Islands', 'country.MH'), new CountryCatalogEntry('MR', 'Mauritania', 'country.MR'), new CountryCatalogEntry('MU', 'Mauritius', 'country.MU'), new CountryCatalogEntry('MX', 'Mexico', 'country.MX'), new CountryCatalogEntry('FM', 'Micronesia', 'country.FM'), new CountryCatalogEntry('MD', 'Moldova', 'country.MD'), new CountryCatalogEntry('MC', 'Monaco', 'country.MC'), new CountryCatalogEntry('MN', 'Mongolia', 'country.MN'), new CountryCatalogEntry('ME', 'Montenegro', 'country.ME'), new CountryCatalogEntry('MA', 'Morocco', 'country.MA'), new CountryCatalogEntry('MZ', 'Mozambique', 'country.MZ'), new CountryCatalogEntry('MM', 'Myanmar', 'country.MM'), new CountryCatalogEntry('NA', 'Namibia', 'country.NA'), new CountryCatalogEntry('NR', 'Nauru', 'country.NR'), new CountryCatalogEntry('NP', 'Nepal', 'country.NP'), new CountryCatalogEntry('NL', 'Netherlands', 'country.NL'), new CountryCatalogEntry('NZ', 'New Zealand', 'country.NZ'), new CountryCatalogEntry('NI', 'Nicaragua', 'country.NI'), new CountryCatalogEntry('NE', 'Niger', 'country.NE'), new CountryCatalogEntry('NG', 'Nigeria', 'country.NG'), new CountryCatalogEntry('KP', 'North Korea', 'country.KP'), new CountryCatalogEntry('MK', 'North Macedonia', 'country.MK'), new CountryCatalogEntry('NO', 'Norway', 'country.NO'), new CountryCatalogEntry('OM', 'Oman', 'country.OM'), new CountryCatalogEntry('PK', 'Pakistan', 'country.PK'), new CountryCatalogEntry('PW', 'Palau', 'country.PW'), new CountryCatalogEntry('PS', 'Palestine', 'country.PS'), new CountryCatalogEntry('PA', 'Panama', 'country.PA'), new CountryCatalogEntry('PG', 'Papua New Guinea', 'country.PG'), new CountryCatalogEntry('PY', 'Paraguay', 'country.PY'), new CountryCatalogEntry('PE', 'Peru', 'country.PE'), new CountryCatalogEntry('PH', 'Philippines', 'country.PH'), new CountryCatalogEntry('PL', 'Poland', 'country.PL'), new CountryCatalogEntry('PT', 'Portugal', 'country.PT'), new CountryCatalogEntry('QA', 'Qatar', 'country.QA'), new CountryCatalogEntry('RO', 'Romania', 'country.RO'), new CountryCatalogEntry('RU', 'Russia', 'country.RU'), new CountryCatalogEntry('RW', 'Rwanda', 'country.RW'), new CountryCatalogEntry('KN', 'Saint Kitts and Nevis', 'country.KN'), new CountryCatalogEntry('LC', 'Saint Lucia', 'country.LC'), new CountryCatalogEntry('VC', 'Saint Vincent and the Grenadines', 'country.VC'), new CountryCatalogEntry('WS', 'Samoa', 'country.WS'), new CountryCatalogEntry('SM', 'San Marino', 'country.SM'), new CountryCatalogEntry('ST', 'S\xE3o Tom\xE9 and Pr\xEDncipe', 'country.ST'), new CountryCatalogEntry('SA', 'Saudi Arabia', 'country.SA'), new CountryCatalogEntry('SN', 'Senegal', 'country.SN'), new CountryCatalogEntry('RS', 'Serbia', 'country.RS'), new CountryCatalogEntry('SC', 'Seychelles', 'country.SC'), new CountryCatalogEntry('SL', 'Sierra Leone', 'country.SL'), new CountryCatalogEntry('SG', 'Singapore', 'country.SG'), new CountryCatalogEntry('SK', 'Slovakia', 'country.SK'), new CountryCatalogEntry('SI', 'Slovenia', 'country.SI'), new CountryCatalogEntry('SB', 'Solomon Islands', 'country.SB'), new CountryCatalogEntry('SO', 'Somalia', 'country.SO'), new CountryCatalogEntry('ZA', 'South Africa', 'country.ZA'), new CountryCatalogEntry('KR', 'South Korea', 'country.KR'), new CountryCatalogEntry('SS', 'South Sudan', 'country.SS'), new CountryCatalogEntry('ES', 'Spain', 'country.ES'), new CountryCatalogEntry('LK', 'Sri Lanka', 'country.LK'), new CountryCatalogEntry('SD', 'Sudan', 'country.SD'), new CountryCatalogEntry('SR', 'Suriname', 'country.SR'), new CountryCatalogEntry('SE', 'Sweden', 'country.SE'), new CountryCatalogEntry('CH', 'Switzerland', 'country.CH'), new CountryCatalogEntry('SY', 'Syria', 'country.SY'), new CountryCatalogEntry('TW', 'Taiwan', 'country.TW'), new CountryCatalogEntry('TJ', 'Tajikistan', 'country.TJ'), new CountryCatalogEntry('TZ', 'Tanzania', 'country.TZ'), new CountryCatalogEntry('TH', 'Thailand', 'country.TH'), new CountryCatalogEntry('TL', 'Timor-Leste', 'country.TL'), new CountryCatalogEntry('TG', 'Togo', 'country.TG'), new CountryCatalogEntry('TO', 'Tonga', 'country.TO'), new CountryCatalogEntry('TT', 'Trinidad and Tobago', 'country.TT'), new CountryCatalogEntry('TN', 'Tunisia', 'country.TN'), new CountryCatalogEntry('TR', 'Turkey', 'country.TR'), new CountryCatalogEntry('TM', 'Turkmenistan', 'country.TM'), new CountryCatalogEntry('TV', 'Tuvalu', 'country.TV'), new CountryCatalogEntry('UG', 'Uganda', 'country.UG'), new CountryCatalogEntry('UA', 'Ukraine', 'country.UA'), new CountryCatalogEntry('AE', 'United Arab Emirates', 'country.AE'), new CountryCatalogEntry('GB', 'United Kingdom', 'country.GB'), new CountryCatalogEntry('US', 'United States', 'country.US'), new CountryCatalogEntry('UY', 'Uruguay', 'country.UY'), new CountryCatalogEntry('UZ', 'Uzbekistan', 'country.UZ'), new CountryCatalogEntry('VU', 'Vanuatu', 'country.VU'), new CountryCatalogEntry('VA', 'Vatican City', 'country.VA'), new CountryCatalogEntry('VE', 'Venezuela', 'country.VE'), new CountryCatalogEntry('VN', 'Vietnam', 'country.VN'), new CountryCatalogEntry('YE', 'Yemen', 'country.YE'), new CountryCatalogEntry('ZM', 'Zambia', 'country.ZM'), new CountryCatalogEntry('ZW', 'Zimbabwe', 'country.ZW')]);
      // Inline function 'kotlin.collections.mutableMapOf' call
      countryPickerCodes = LinkedHashMap_init_$Create$();
      countryTranslations = mapOf([to('country.AF', mapOf([to('en', 'Afghanistan'), to('es', 'Afganist\xE1n'), to('fr', 'Afghanistan'), to('pt', 'Afeganist\xE3o'), to('zh', '\u963F\u5BCC\u6C57')])), to('country.AL', mapOf([to('en', 'Albania'), to('es', 'Albania'), to('fr', 'Albanie'), to('pt', 'Alb\xE2nia'), to('zh', '\u963F\u5C14\u5DF4\u5C3C\u4E9A')])), to('country.DZ', mapOf([to('en', 'Algeria'), to('es', 'Argelia'), to('fr', 'Alg\xE9rie'), to('pt', 'Arg\xE9lia'), to('zh', '\u963F\u5C14\u53CA\u5229\u4E9A')])), to('country.AD', mapOf([to('en', 'Andorra'), to('es', 'Andorra'), to('fr', 'Andorre'), to('pt', 'Andorra'), to('zh', '\u5B89\u9053\u5C14')])), to('country.AO', mapOf([to('en', 'Angola'), to('es', 'Angola'), to('fr', 'Angola'), to('pt', 'Angola'), to('zh', '\u5B89\u54E5\u62C9')])), to('country.AG', mapOf([to('en', 'Antigua and Barbuda'), to('es', 'Antigua y Barbuda'), to('fr', 'Antigua-et-Barbuda'), to('pt', 'Ant\xEDgua e Barbuda'), to('zh', '\u5B89\u63D0\u74DC\u548C\u5DF4\u5E03\u8FBE')])), to('country.AR', mapOf([to('en', 'Argentina'), to('es', 'Argentina'), to('fr', 'Argentine'), to('pt', 'Argentina'), to('zh', '\u963F\u6839\u5EF7')])), to('country.AM', mapOf([to('en', 'Armenia'), to('es', 'Armenia'), to('fr', 'Arm\xE9nie'), to('pt', 'Arm\xEAnia'), to('zh', '\u4E9A\u7F8E\u5C3C\u4E9A')])), to('country.AU', mapOf([to('en', 'Australia'), to('es', 'Australia'), to('fr', 'Australie'), to('pt', 'Austr\xE1lia'), to('zh', '\u6FB3\u5927\u5229\u4E9A')])), to('country.AT', mapOf([to('en', 'Austria'), to('es', 'Austria'), to('fr', 'Autriche'), to('pt', '\xC1ustria'), to('zh', '\u5965\u5730\u5229')])), to('country.AZ', mapOf([to('en', 'Azerbaijan'), to('es', 'Azerbaiy\xE1n'), to('fr', 'Azerba\xEFdjan'), to('pt', 'Azerbaij\xE3o'), to('zh', '\u963F\u585E\u62DC\u7586')])), to('country.BS', mapOf([to('en', 'The Bahamas'), to('es', 'Bahamas'), to('fr', 'Bahamas'), to('pt', 'Baamas'), to('zh', '\u5DF4\u54C8\u9A6C')])), to('country.BH', mapOf([to('en', 'Bahrain'), to('es', 'Bar\xE9in'), to('fr', 'Bahre\xEFn'), to('pt', 'Barein'), to('zh', '\u5DF4\u6797')])), to('country.BD', mapOf([to('en', 'Bangladesh'), to('es', 'Banglad\xE9s'), to('fr', 'Bangladesh'), to('pt', 'Bangladeche'), to('zh', '\u5B5F\u52A0\u62C9\u56FD')])), to('country.BB', mapOf([to('en', 'Barbados'), to('es', 'Barbados'), to('fr', 'Barbade'), to('pt', 'Barbados'), to('zh', '\u5DF4\u5DF4\u591A\u65AF')])), to('country.BY', mapOf([to('en', 'Belarus'), to('es', 'Bielorrusia'), to('fr', 'Bi\xE9lorussie'), to('pt', 'Bielorr\xFAssia'), to('zh', '\u767D\u4FC4\u7F57\u65AF')])), to('country.BE', mapOf([to('en', 'Belgium'), to('es', 'B\xE9lgica'), to('fr', 'Belgique'), to('pt', 'B\xE9lgica'), to('zh', '\u6BD4\u5229\u65F6')])), to('country.BZ', mapOf([to('en', 'Belize'), to('es', 'Belice'), to('fr', 'Belize'), to('pt', 'Belize'), to('zh', '\u4F2F\u5229\u5179')])), to('country.BJ', mapOf([to('en', 'Benin'), to('es', 'Ben\xEDn'), to('fr', 'B\xE9nin'), to('pt', 'Benin'), to('zh', '\u8D1D\u5B81')])), to('country.BT', mapOf([to('en', 'Bhutan'), to('es', 'But\xE1n'), to('fr', 'Bhoutan'), to('pt', 'But\xE3o'), to('zh', '\u4E0D\u4E39')])), to('country.BO', mapOf([to('en', 'Bolivia'), to('es', 'Bolivia'), to('fr', 'Bolivie'), to('pt', 'Bol\xEDvia'), to('zh', '\u73BB\u5229\u7EF4\u4E9A')])), to('country.BA', mapOf([to('en', 'Bosnia and Herzegovina'), to('es', 'Bosnia y Herzegovina'), to('fr', 'Bosnie-Herz\xE9govine'), to('pt', 'B\xF3snia e Herzegovina'), to('zh', '\u6CE2\u65AF\u5C3C\u4E9A\u548C\u9ED1\u585E\u54E5\u7EF4\u90A3')])), to('country.BW', mapOf([to('en', 'Botswana'), to('es', 'Botsuana'), to('fr', 'Botswana'), to('pt', 'Botsuana'), to('zh', '\u535A\u8328\u74E6\u7EB3')])), to('country.BR', mapOf([to('en', 'Brazil'), to('es', 'Brasil'), to('fr', 'Br\xE9sil'), to('pt', 'Brasil'), to('zh', '\u5DF4\u897F')])), to('country.BN', mapOf([to('en', 'Brunei'), to('es', 'Brun\xE9i'), to('fr', 'Brunei'), to('pt', 'Brunei'), to('zh', '\u6587\u83B1')])), to('country.BG', mapOf([to('en', 'Bulgaria'), to('es', 'Bulgaria'), to('fr', 'Bulgarie'), to('pt', 'Bulg\xE1ria'), to('zh', '\u4FDD\u52A0\u5229\u4E9A')])), to('country.BF', mapOf([to('en', 'Burkina Faso'), to('es', 'Burkina Faso'), to('fr', 'Burkina Faso'), to('pt', 'Burquina Faso'), to('zh', '\u5E03\u57FA\u7EB3\u6CD5\u7D22')])), to('country.BI', mapOf([to('en', 'Burundi'), to('es', 'Burundi'), to('fr', 'Burundi'), to('pt', 'Burundi'), to('zh', '\u5E03\u9686\u8FEA')])), to('country.CV', mapOf([to('en', 'Cabo Verde'), to('es', 'Cabo Verde'), to('fr', 'Cap-Vert'), to('pt', 'Cabo Verde'), to('zh', '\u4F5B\u5F97\u89D2')])), to('country.KH', mapOf([to('en', 'Cambodia'), to('es', 'Camboya'), to('fr', 'Cambodge'), to('pt', 'Camboja'), to('zh', '\u67EC\u57D4\u5BE8')])), to('country.CM', mapOf([to('en', 'Cameroon'), to('es', 'Camer\xFAn'), to('fr', 'Cameroun'), to('pt', 'Camar\xF5es'), to('zh', '\u5580\u9EA6\u9686')])), to('country.CA', mapOf([to('en', 'Canada'), to('es', 'Canad\xE1'), to('fr', 'Canada'), to('pt', 'Canad\xE1'), to('zh', '\u52A0\u62FF\u5927')])), to('country.CF', mapOf([to('en', 'Central African Republic'), to('es', 'Rep\xFAblica Centroafricana'), to('fr', 'R\xE9publique centrafricaine'), to('pt', 'Rep\xFAblica Centro-Africana'), to('zh', '\u4E2D\u975E\u5171\u548C\u56FD')])), to('country.TD', mapOf([to('en', 'Chad'), to('es', 'Chad'), to('fr', 'Tchad'), to('pt', 'Chade'), to('zh', '\u4E4D\u5F97')])), to('country.CL', mapOf([to('en', 'Chile'), to('es', 'Chile'), to('fr', 'Chili'), to('pt', 'Chile'), to('zh', '\u667A\u5229')])), to('country.CN', mapOf([to('en', 'China'), to('es', 'China'), to('fr', 'Chine'), to('pt', 'China'), to('zh', '\u4E2D\u56FD')])), to('country.CO', mapOf([to('en', 'Colombia'), to('es', 'Colombia'), to('fr', 'Colombie'), to('pt', 'Col\xF4mbia'), to('zh', '\u54E5\u4F26\u6BD4\u4E9A')])), to('country.KM', mapOf([to('en', 'Comoros'), to('es', 'Comoras'), to('fr', 'Comores'), to('pt', 'Comores'), to('zh', '\u79D1\u6469\u7F57')])), to('country.CD', mapOf([to('en', 'Democratic Republic of the Congo'), to('es', 'Rep\xFAblica Democr\xE1tica del Congo'), to('fr', 'R\xE9publique d\xE9mocratique du Congo'), to('pt', 'Rep\xFAblica Democr\xE1tica do Congo'), to('zh', '\u521A\u679C\u6C11\u4E3B\u5171\u548C\u56FD')])), to('country.CG', mapOf([to('en', 'Republic of the Congo'), to('es', 'Rep\xFAblica del Congo'), to('fr', 'R\xE9publique du Congo'), to('pt', 'Rep\xFAblica do Congo'), to('zh', '\u521A\u679C\u5171\u548C\u56FD')])), to('country.CR', mapOf([to('en', 'Costa Rica'), to('es', 'Costa Rica'), to('fr', 'Costa Rica'), to('pt', 'Costa Rica'), to('zh', '\u54E5\u65AF\u8FBE\u9ECE\u52A0')])), to('country.CI', mapOf([to('en', "C\xF4te d'Ivoire"), to('es', 'Costa de Marfil'), to('fr', "C\xF4te d'Ivoire"), to('pt', 'Costa do Marfim'), to('zh', '\u79D1\u7279\u8FEA\u74E6')])), to('country.HR', mapOf([to('en', 'Croatia'), to('es', 'Croacia'), to('fr', 'Croatie'), to('pt', 'Cro\xE1cia'), to('zh', '\u514B\u7F57\u5730\u4E9A')])), to('country.CU', mapOf([to('en', 'Cuba'), to('es', 'Cuba'), to('fr', 'Cuba'), to('pt', 'Cuba'), to('zh', '\u53E4\u5DF4')])), to('country.CY', mapOf([to('en', 'Cyprus'), to('es', 'Chipre'), to('fr', 'Chypre'), to('pt', 'Chipre'), to('zh', '\u585E\u6D66\u8DEF\u65AF')])), to('country.CZ', mapOf([to('en', 'Czechia'), to('es', 'Chequia'), to('fr', 'Tch\xE9quie'), to('pt', 'Ch\xE9quia'), to('zh', '\u6377\u514B')])), to('country.DK', mapOf([to('en', 'Denmark'), to('es', 'Dinamarca'), to('fr', 'Danemark'), to('pt', 'Dinamarca'), to('zh', '\u4E39\u9EA6')])), to('country.DJ', mapOf([to('en', 'Djibouti'), to('es', 'Yibuti'), to('fr', 'Djibouti'), to('pt', 'Djibuti'), to('zh', '\u5409\u5E03\u63D0')])), to('country.DM', mapOf([to('en', 'Dominica'), to('es', 'Dominica'), to('fr', 'Dominique'), to('pt', 'Dominica'), to('zh', '\u591A\u7C73\u5C3C\u514B')])), to('country.DO', mapOf([to('en', 'Dominican Republic'), to('es', 'Rep\xFAblica Dominicana'), to('fr', 'R\xE9publique dominicaine'), to('pt', 'Rep\xFAblica Dominicana'), to('zh', '\u591A\u7C73\u5C3C\u52A0\u5171\u548C\u56FD')])), to('country.EC', mapOf([to('en', 'Ecuador'), to('es', 'Ecuador'), to('fr', '\xC9quateur'), to('pt', 'Equador'), to('zh', '\u5384\u74DC\u591A\u5C14')])), to('country.EG', mapOf([to('en', 'Egypt'), to('es', 'Egipto'), to('fr', '\xC9gypte'), to('pt', 'Egito'), to('zh', '\u57C3\u53CA')])), to('country.SV', mapOf([to('en', 'El Salvador'), to('es', 'El Salvador'), to('fr', 'Salvador'), to('pt', 'El Salvador'), to('zh', '\u8428\u5C14\u74E6\u591A')])), to('country.GQ', mapOf([to('en', 'Equatorial Guinea'), to('es', 'Guinea Ecuatorial'), to('fr', 'Guin\xE9e \xE9quatoriale'), to('pt', 'Guin\xE9 Equatorial'), to('zh', '\u8D64\u9053\u51E0\u5185\u4E9A')])), to('country.ER', mapOf([to('en', 'Eritrea'), to('es', 'Eritrea'), to('fr', '\xC9rythr\xE9e'), to('pt', 'Eritreia'), to('zh', '\u5384\u7ACB\u7279\u91CC\u4E9A')])), to('country.EE', mapOf([to('en', 'Estonia'), to('es', 'Estonia'), to('fr', 'Estonie'), to('pt', 'Est\xF4nia'), to('zh', '\u7231\u6C99\u5C3C\u4E9A')])), to('country.SZ', mapOf([to('en', 'Eswatini'), to('es', 'Esuatini'), to('fr', 'Eswatini'), to('pt', 'Essuat\xEDni'), to('zh', '\u65AF\u5A01\u58EB\u5170')])), to('country.ET', mapOf([to('en', 'Ethiopia'), to('es', 'Etiop\xEDa'), to('fr', '\xC9thiopie'), to('pt', 'Eti\xF3pia'), to('zh', '\u57C3\u585E\u4FC4\u6BD4\u4E9A')])), to('country.FJ', mapOf([to('en', 'Fiji'), to('es', 'Fiyi'), to('fr', 'Fidji'), to('pt', 'Fiji'), to('zh', '\u6590\u6D4E')])), to('country.FI', mapOf([to('en', 'Finland'), to('es', 'Finlandia'), to('fr', 'Finlande'), to('pt', 'Finl\xE2ndia'), to('zh', '\u82AC\u5170')])), to('country.FR', mapOf([to('en', 'France'), to('es', 'Francia'), to('fr', 'France'), to('pt', 'Fran\xE7a'), to('zh', '\u6CD5\u56FD')])), to('country.GA', mapOf([to('en', 'Gabon'), to('es', 'Gab\xF3n'), to('fr', 'Gabon'), to('pt', 'Gab\xE3o'), to('zh', '\u52A0\u84EC')])), to('country.GM', mapOf([to('en', 'The Gambia'), to('es', 'Gambia'), to('fr', 'Gambie'), to('pt', 'G\xE2mbia'), to('zh', '\u5188\u6BD4\u4E9A')])), to('country.GE', mapOf([to('en', 'Georgia'), to('es', 'Georgia'), to('fr', 'G\xE9orgie'), to('pt', 'Ge\xF3rgia'), to('zh', '\u683C\u9C81\u5409\u4E9A')])), to('country.DE', mapOf([to('en', 'Germany'), to('es', 'Alemania'), to('fr', 'Allemagne'), to('pt', 'Alemanha'), to('zh', '\u5FB7\u56FD')])), to('country.GH', mapOf([to('en', 'Ghana'), to('es', 'Ghana'), to('fr', 'Ghana'), to('pt', 'Gana'), to('zh', '\u52A0\u7EB3')])), to('country.GR', mapOf([to('en', 'Greece'), to('es', 'Grecia'), to('fr', 'Gr\xE8ce'), to('pt', 'Gr\xE9cia'), to('zh', '\u5E0C\u814A')])), to('country.GD', mapOf([to('en', 'Grenada'), to('es', 'Granada'), to('fr', 'Grenade'), to('pt', 'Granada'), to('zh', '\u683C\u6797\u7EB3\u8FBE')])), to('country.GT', mapOf([to('en', 'Guatemala'), to('es', 'Guatemala'), to('fr', 'Guatemala'), to('pt', 'Guatemala'), to('zh', '\u5371\u5730\u9A6C\u62C9')])), to('country.GN', mapOf([to('en', 'Guinea'), to('es', 'Guinea'), to('fr', 'Guin\xE9e'), to('pt', 'Guin\xE9'), to('zh', '\u51E0\u5185\u4E9A')])), to('country.GW', mapOf([to('en', 'Guinea-Bissau'), to('es', 'Guinea-Bis\xE1u'), to('fr', 'Guin\xE9e-Bissau'), to('pt', 'Guin\xE9-Bissau'), to('zh', '\u51E0\u5185\u4E9A\u6BD4\u7ECD')])), to('country.GY', mapOf([to('en', 'Guyana'), to('es', 'Guyana'), to('fr', 'Guyana'), to('pt', 'Guiana'), to('zh', '\u572D\u4E9A\u90A3')])), to('country.HT', mapOf([to('en', 'Haiti'), to('es', 'Hait\xED'), to('fr', 'Ha\xEFti'), to('pt', 'Haiti'), to('zh', '\u6D77\u5730')])), to('country.HN', mapOf([to('en', 'Honduras'), to('es', 'Honduras'), to('fr', 'Honduras'), to('pt', 'Honduras'), to('zh', '\u6D2A\u90FD\u62C9\u65AF')])), to('country.HU', mapOf([to('en', 'Hungary'), to('es', 'Hungr\xEDa'), to('fr', 'Hongrie'), to('pt', 'Hungria'), to('zh', '\u5308\u7259\u5229')])), to('country.IS', mapOf([to('en', 'Iceland'), to('es', 'Islandia'), to('fr', 'Islande'), to('pt', 'Isl\xE2ndia'), to('zh', '\u51B0\u5C9B')])), to('country.IN', mapOf([to('en', 'India'), to('es', 'India'), to('fr', 'Inde'), to('pt', '\xCDndia'), to('zh', '\u5370\u5EA6')])), to('country.ID', mapOf([to('en', 'Indonesia'), to('es', 'Indonesia'), to('fr', 'Indon\xE9sie'), to('pt', 'Indon\xE9sia'), to('zh', '\u5370\u5EA6\u5C3C\u897F\u4E9A')])), to('country.IR', mapOf([to('en', 'Iran'), to('es', 'Ir\xE1n'), to('fr', 'Iran'), to('pt', 'Ir\xE3'), to('zh', '\u4F0A\u6717')])), to('country.IQ', mapOf([to('en', 'Iraq'), to('es', 'Irak'), to('fr', 'Irak'), to('pt', 'Iraque'), to('zh', '\u4F0A\u62C9\u514B')])), to('country.IE', mapOf([to('en', 'Ireland'), to('es', 'Irlanda'), to('fr', 'Irlande'), to('pt', 'Irlanda'), to('zh', '\u7231\u5C14\u5170')])), to('country.IL', mapOf([to('en', 'Israel'), to('es', 'Israel'), to('fr', 'Isra\xEBl'), to('pt', 'Israel'), to('zh', '\u4EE5\u8272\u5217')])), to('country.IT', mapOf([to('en', 'Italy'), to('es', 'Italia'), to('fr', 'Italie'), to('pt', 'It\xE1lia'), to('zh', '\u610F\u5927\u5229')])), to('country.JM', mapOf([to('en', 'Jamaica'), to('es', 'Jamaica'), to('fr', 'Jama\xEFque'), to('pt', 'Jamaica'), to('zh', '\u7259\u4E70\u52A0')])), to('country.JP', mapOf([to('en', 'Japan'), to('es', 'Jap\xF3n'), to('fr', 'Japon'), to('pt', 'Jap\xE3o'), to('zh', '\u65E5\u672C')])), to('country.JO', mapOf([to('en', 'Jordan'), to('es', 'Jordania'), to('fr', 'Jordanie'), to('pt', 'Jord\xE2nia'), to('zh', '\u7EA6\u65E6')])), to('country.KZ', mapOf([to('en', 'Kazakhstan'), to('es', 'Kazajist\xE1n'), to('fr', 'Kazakhstan'), to('pt', 'Cazaquist\xE3o'), to('zh', '\u54C8\u8428\u514B\u65AF\u5766')])), to('country.KE', mapOf([to('en', 'Kenya'), to('es', 'Kenia'), to('fr', 'Kenya'), to('pt', 'Qu\xEAnia'), to('zh', '\u80AF\u5C3C\u4E9A')])), to('country.KI', mapOf([to('en', 'Kiribati'), to('es', 'Kiribati'), to('fr', 'Kiribati'), to('pt', 'Kiribati'), to('zh', '\u57FA\u91CC\u5DF4\u65AF')])), to('country.XK', mapOf([to('en', 'Kosovo'), to('es', 'Kosovo'), to('fr', 'Kosovo'), to('pt', 'Kosovo'), to('zh', '\u79D1\u7D22\u6C83')])), to('country.KW', mapOf([to('en', 'Kuwait'), to('es', 'Kuwait'), to('fr', 'Kowe\xEFt'), to('pt', 'Kuwait'), to('zh', '\u79D1\u5A01\u7279')])), to('country.KG', mapOf([to('en', 'Kyrgyzstan'), to('es', 'Kirguist\xE1n'), to('fr', 'Kirghizistan'), to('pt', 'Quirguist\xE3o'), to('zh', '\u5409\u5C14\u5409\u65AF\u65AF\u5766')])), to('country.LA', mapOf([to('en', 'Laos'), to('es', 'Laos'), to('fr', 'Laos'), to('pt', 'Laos'), to('zh', '\u8001\u631D')])), to('country.LV', mapOf([to('en', 'Latvia'), to('es', 'Letonia'), to('fr', 'Lettonie'), to('pt', 'Let\xF4nia'), to('zh', '\u62C9\u8131\u7EF4\u4E9A')])), to('country.LB', mapOf([to('en', 'Lebanon'), to('es', 'L\xEDbano'), to('fr', 'Liban'), to('pt', 'L\xEDbano'), to('zh', '\u9ECE\u5DF4\u5AE9')])), to('country.LS', mapOf([to('en', 'Lesotho'), to('es', 'Lesoto'), to('fr', 'Lesotho'), to('pt', 'Lesoto'), to('zh', '\u83B1\u7D22\u6258')])), to('country.LR', mapOf([to('en', 'Liberia'), to('es', 'Liberia'), to('fr', 'Lib\xE9ria'), to('pt', 'Lib\xE9ria'), to('zh', '\u5229\u6BD4\u91CC\u4E9A')])), to('country.LY', mapOf([to('en', 'Libya'), to('es', 'Libia'), to('fr', 'Libye'), to('pt', 'L\xEDbia'), to('zh', '\u5229\u6BD4\u4E9A')])), to('country.LI', mapOf([to('en', 'Liechtenstein'), to('es', 'Liechtenstein'), to('fr', 'Liechtenstein'), to('pt', 'Listenstaine'), to('zh', '\u5217\u652F\u6566\u58EB\u767B')])), to('country.LT', mapOf([to('en', 'Lithuania'), to('es', 'Lituania'), to('fr', 'Lituanie'), to('pt', 'Litu\xE2nia'), to('zh', '\u7ACB\u9676\u5B9B')])), to('country.LU', mapOf([to('en', 'Luxembourg'), to('es', 'Luxemburgo'), to('fr', 'Luxembourg'), to('pt', 'Luxemburgo'), to('zh', '\u5362\u68EE\u5821')])), to('country.MG', mapOf([to('en', 'Madagascar'), to('es', 'Madagascar'), to('fr', 'Madagascar'), to('pt', 'Madag\xE1scar'), to('zh', '\u9A6C\u8FBE\u52A0\u65AF\u52A0')])), to('country.MW', mapOf([to('en', 'Malawi'), to('es', 'Malaui'), to('fr', 'Malawi'), to('pt', 'Malawi'), to('zh', '\u9A6C\u62C9\u7EF4')])), to('country.MY', mapOf([to('en', 'Malaysia'), to('es', 'Malasia'), to('fr', 'Malaisie'), to('pt', 'Mal\xE1sia'), to('zh', '\u9A6C\u6765\u897F\u4E9A')])), to('country.MV', mapOf([to('en', 'Maldives'), to('es', 'Maldivas'), to('fr', 'Maldives'), to('pt', 'Maldivas'), to('zh', '\u9A6C\u5C14\u4EE3\u592B')])), to('country.ML', mapOf([to('en', 'Mali'), to('es', 'Mal\xED'), to('fr', 'Mali'), to('pt', 'Mali'), to('zh', '\u9A6C\u91CC')])), to('country.MT', mapOf([to('en', 'Malta'), to('es', 'Malta'), to('fr', 'Malte'), to('pt', 'Malta'), to('zh', '\u9A6C\u8033\u4ED6')])), to('country.MH', mapOf([to('en', 'Marshall Islands'), to('es', 'Islas Marshall'), to('fr', '\xCEles Marshall'), to('pt', 'Ilhas Marshall'), to('zh', '\u9A6C\u7ECD\u5C14\u7FA4\u5C9B')])), to('country.MR', mapOf([to('en', 'Mauritania'), to('es', 'Mauritania'), to('fr', 'Mauritanie'), to('pt', 'Maurit\xE2nia'), to('zh', '\u6BDB\u91CC\u5854\u5C3C\u4E9A')])), to('country.MU', mapOf([to('en', 'Mauritius'), to('es', 'Mauricio'), to('fr', 'Maurice'), to('pt', 'Maur\xEDcia'), to('zh', '\u6BDB\u91CC\u6C42\u65AF')])), to('country.MX', mapOf([to('en', 'Mexico'), to('es', 'M\xE9xico'), to('fr', 'Mexique'), to('pt', 'M\xE9xico'), to('zh', '\u58A8\u897F\u54E5')])), to('country.FM', mapOf([to('en', 'Micronesia'), to('es', 'Micronesia'), to('fr', 'Micron\xE9sie'), to('pt', 'Micron\xE9sia'), to('zh', '\u5BC6\u514B\u7F57\u5C3C\u897F\u4E9A')])), to('country.MD', mapOf([to('en', 'Moldova'), to('es', 'Moldavia'), to('fr', 'Moldavie'), to('pt', 'Mold\xE1via'), to('zh', '\u6469\u5C14\u591A\u74E6')])), to('country.MC', mapOf([to('en', 'Monaco'), to('es', 'M\xF3naco'), to('fr', 'Monaco'), to('pt', 'M\xF4naco'), to('zh', '\u6469\u7EB3\u54E5')])), to('country.MN', mapOf([to('en', 'Mongolia'), to('es', 'Mongolia'), to('fr', 'Mongolie'), to('pt', 'Mong\xF3lia'), to('zh', '\u8499\u53E4')])), to('country.ME', mapOf([to('en', 'Montenegro'), to('es', 'Montenegro'), to('fr', 'Mont\xE9n\xE9gro'), to('pt', 'Montenegro'), to('zh', '\u9ED1\u5C71')])), to('country.MA', mapOf([to('en', 'Morocco'), to('es', 'Marruecos'), to('fr', 'Maroc'), to('pt', 'Marrocos'), to('zh', '\u6469\u6D1B\u54E5')])), to('country.MZ', mapOf([to('en', 'Mozambique'), to('es', 'Mozambique'), to('fr', 'Mozambique'), to('pt', 'Mo\xE7ambique'), to('zh', '\u83AB\u6851\u6BD4\u514B')])), to('country.MM', mapOf([to('en', 'Myanmar'), to('es', 'Myanmar'), to('fr', 'Myanmar'), to('pt', 'Myanmar'), to('zh', '\u7F05\u7538')])), to('country.NA', mapOf([to('en', 'Namibia'), to('es', 'Namibia'), to('fr', 'Namibie'), to('pt', 'Nam\xEDbia'), to('zh', '\u7EB3\u7C73\u6BD4\u4E9A')])), to('country.NR', mapOf([to('en', 'Nauru'), to('es', 'Nauru'), to('fr', 'Nauru'), to('pt', 'Nauru'), to('zh', '\u7459\u9C81')])), to('country.NP', mapOf([to('en', 'Nepal'), to('es', 'Nepal'), to('fr', 'N\xE9pal'), to('pt', 'Nepal'), to('zh', '\u5C3C\u6CCA\u5C14')])), to('country.NL', mapOf([to('en', 'Netherlands'), to('es', 'Pa\xEDses Bajos'), to('fr', 'Pays-Bas'), to('pt', 'Pa\xEDses Baixos'), to('zh', '\u8377\u5170')])), to('country.NZ', mapOf([to('en', 'New Zealand'), to('es', 'Nueva Zelanda'), to('fr', 'Nouvelle-Z\xE9lande'), to('pt', 'Nova Zel\xE2ndia'), to('zh', '\u65B0\u897F\u5170')])), to('country.NI', mapOf([to('en', 'Nicaragua'), to('es', 'Nicaragua'), to('fr', 'Nicaragua'), to('pt', 'Nicar\xE1gua'), to('zh', '\u5C3C\u52A0\u62C9\u74DC')])), to('country.NE', mapOf([to('en', 'Niger'), to('es', 'N\xEDger'), to('fr', 'Niger'), to('pt', 'N\xEDger'), to('zh', '\u5C3C\u65E5\u5C14')])), to('country.NG', mapOf([to('en', 'Nigeria'), to('es', 'Nigeria'), to('fr', 'Nigeria'), to('pt', 'Nig\xE9ria'), to('zh', '\u5C3C\u65E5\u5229\u4E9A')])), to('country.KP', mapOf([to('en', 'North Korea'), to('es', 'Corea del Norte'), to('fr', 'Cor\xE9e du Nord'), to('pt', 'Coreia do Norte'), to('zh', '\u671D\u9C9C')])), to('country.MK', mapOf([to('en', 'North Macedonia'), to('es', 'Macedonia del Norte'), to('fr', 'Mac\xE9doine du Nord'), to('pt', 'Maced\xF4nia do Norte'), to('zh', '\u5317\u9A6C\u5176\u987F')])), to('country.NO', mapOf([to('en', 'Norway'), to('es', 'Noruega'), to('fr', 'Norv\xE8ge'), to('pt', 'Noruega'), to('zh', '\u632A\u5A01')])), to('country.OM', mapOf([to('en', 'Oman'), to('es', 'Om\xE1n'), to('fr', 'Oman'), to('pt', 'Om\xE3'), to('zh', '\u963F\u66FC')])), to('country.PK', mapOf([to('en', 'Pakistan'), to('es', 'Pakist\xE1n'), to('fr', 'Pakistan'), to('pt', 'Paquist\xE3o'), to('zh', '\u5DF4\u57FA\u65AF\u5766')])), to('country.PW', mapOf([to('en', 'Palau'), to('es', 'Palaos'), to('fr', 'Palaos'), to('pt', 'Palau'), to('zh', '\u5E15\u52B3')])), to('country.PS', mapOf([to('en', 'Palestine'), to('es', 'Palestina'), to('fr', 'Palestine'), to('pt', 'Palestina'), to('zh', '\u5DF4\u52D2\u65AF\u5766')])), to('country.PA', mapOf([to('en', 'Panama'), to('es', 'Panam\xE1'), to('fr', 'Panama'), to('pt', 'Panam\xE1'), to('zh', '\u5DF4\u62FF\u9A6C')])), to('country.PG', mapOf([to('en', 'Papua New Guinea'), to('es', 'Pap\xFAa Nueva Guinea'), to('fr', 'Papouasie-Nouvelle-Guin\xE9e'), to('pt', 'Papua-Nova Guin\xE9'), to('zh', '\u5DF4\u5E03\u4E9A\u65B0\u51E0\u5185\u4E9A')])), to('country.PY', mapOf([to('en', 'Paraguay'), to('es', 'Paraguay'), to('fr', 'Paraguay'), to('pt', 'Paraguai'), to('zh', '\u5DF4\u62C9\u572D')])), to('country.PE', mapOf([to('en', 'Peru'), to('es', 'Per\xFA'), to('fr', 'P\xE9rou'), to('pt', 'Peru'), to('zh', '\u79D8\u9C81')])), to('country.PH', mapOf([to('en', 'Philippines'), to('es', 'Filipinas'), to('fr', 'Philippines'), to('pt', 'Filipinas'), to('zh', '\u83F2\u5F8B\u5BBE')])), to('country.PL', mapOf([to('en', 'Poland'), to('es', 'Polonia'), to('fr', 'Pologne'), to('pt', 'Pol\xF4nia'), to('zh', '\u6CE2\u5170')])), to('country.PT', mapOf([to('en', 'Portugal'), to('es', 'Portugal'), to('fr', 'Portugal'), to('pt', 'Portugal'), to('zh', '\u8461\u8404\u7259')])), to('country.QA', mapOf([to('en', 'Qatar'), to('es', 'Catar'), to('fr', 'Qatar'), to('pt', 'Catar'), to('zh', '\u5361\u5854\u5C14')])), to('country.RO', mapOf([to('en', 'Romania'), to('es', 'Rumania'), to('fr', 'Roumanie'), to('pt', 'Rom\xEAnia'), to('zh', '\u7F57\u9A6C\u5C3C\u4E9A')])), to('country.RU', mapOf([to('en', 'Russia'), to('es', 'Rusia'), to('fr', 'Russie'), to('pt', 'R\xFAssia'), to('zh', '\u4FC4\u7F57\u65AF')])), to('country.RW', mapOf([to('en', 'Rwanda'), to('es', 'Ruanda'), to('fr', 'Rwanda'), to('pt', 'Ruanda'), to('zh', '\u5362\u65FA\u8FBE')])), to('country.KN', mapOf([to('en', 'Saint Kitts and Nevis'), to('es', 'San Crist\xF3bal y Nieves'), to('fr', 'Saint-Christophe-et-Ni\xE9v\xE8s'), to('pt', 'S\xE3o Crist\xF3v\xE3o e Nevis'), to('zh', '\u5723\u57FA\u8328\u548C\u5C3C\u7EF4\u65AF')])), to('country.LC', mapOf([to('en', 'Saint Lucia'), to('es', 'Santa Luc\xEDa'), to('fr', 'Sainte-Lucie'), to('pt', 'Santa L\xFAcia'), to('zh', '\u5723\u5362\u897F\u4E9A')])), to('country.VC', mapOf([to('en', 'Saint Vincent and the Grenadines'), to('es', 'San Vicente y las Granadinas'), to('fr', 'Saint-Vincent-et-les-Grenadines'), to('pt', 'S\xE3o Vicente e Granadinas'), to('zh', '\u5723\u6587\u68EE\u7279\u548C\u683C\u6797\u7EB3\u4E01\u65AF')])), to('country.WS', mapOf([to('en', 'Samoa'), to('es', 'Samoa'), to('fr', 'Samoa'), to('pt', 'Samoa'), to('zh', '\u8428\u6469\u4E9A')])), to('country.SM', mapOf([to('en', 'San Marino'), to('es', 'San Marino'), to('fr', 'Saint-Marin'), to('pt', 'San Marino'), to('zh', '\u5723\u9A6C\u529B\u8BFA')])), to('country.ST', mapOf([to('en', 'S\xE3o Tom\xE9 and Pr\xEDncipe'), to('es', 'Santo Tom\xE9 y Pr\xEDncipe'), to('fr', 'Sao Tom\xE9-et-Principe'), to('pt', 'S\xE3o Tom\xE9 e Pr\xEDncipe'), to('zh', '\u5723\u591A\u7F8E\u548C\u666E\u6797\u897F\u6BD4')])), to('country.SA', mapOf([to('en', 'Saudi Arabia'), to('es', 'Arabia Saudita'), to('fr', 'Arabie saoudite'), to('pt', 'Ar\xE1bia Saudita'), to('zh', '\u6C99\u7279\u963F\u62C9\u4F2F')])), to('country.SN', mapOf([to('en', 'Senegal'), to('es', 'Senegal'), to('fr', 'S\xE9n\xE9gal'), to('pt', 'Senegal'), to('zh', '\u585E\u5185\u52A0\u5C14')])), to('country.RS', mapOf([to('en', 'Serbia'), to('es', 'Serbia'), to('fr', 'Serbie'), to('pt', 'S\xE9rvia'), to('zh', '\u585E\u5C14\u7EF4\u4E9A')])), to('country.SC', mapOf([to('en', 'Seychelles'), to('es', 'Seychelles'), to('fr', 'Seychelles'), to('pt', 'Seicheles'), to('zh', '\u585E\u820C\u5C14')])), to('country.SL', mapOf([to('en', 'Sierra Leone'), to('es', 'Sierra Leona'), to('fr', 'Sierra Leone'), to('pt', 'Serra Leoa'), to('zh', '\u585E\u62C9\u5229\u6602')])), to('country.SG', mapOf([to('en', 'Singapore'), to('es', 'Singapur'), to('fr', 'Singapour'), to('pt', 'Singapura'), to('zh', '\u65B0\u52A0\u5761')])), to('country.SK', mapOf([to('en', 'Slovakia'), to('es', 'Eslovaquia'), to('fr', 'Slovaquie'), to('pt', 'Eslov\xE1quia'), to('zh', '\u65AF\u6D1B\u4F10\u514B')])), to('country.SI', mapOf([to('en', 'Slovenia'), to('es', 'Eslovenia'), to('fr', 'Slov\xE9nie'), to('pt', 'Eslov\xEAnia'), to('zh', '\u65AF\u6D1B\u6587\u5C3C\u4E9A')])), to('country.SB', mapOf([to('en', 'Solomon Islands'), to('es', 'Islas Salom\xF3n'), to('fr', '\xCEles Salomon'), to('pt', 'Ilhas Salom\xE3o'), to('zh', '\u6240\u7F57\u95E8\u7FA4\u5C9B')])), to('country.SO', mapOf([to('en', 'Somalia'), to('es', 'Somalia'), to('fr', 'Somalie'), to('pt', 'Som\xE1lia'), to('zh', '\u7D22\u9A6C\u91CC')])), to('country.ZA', mapOf([to('en', 'South Africa'), to('es', 'Sud\xE1frica'), to('fr', 'Afrique du Sud'), to('pt', '\xC1frica do Sul'), to('zh', '\u5357\u975E')])), to('country.KR', mapOf([to('en', 'South Korea'), to('es', 'Corea del Sur'), to('fr', 'Cor\xE9e du Sud'), to('pt', 'Coreia do Sul'), to('zh', '\u97E9\u56FD')])), to('country.SS', mapOf([to('en', 'South Sudan'), to('es', 'Sud\xE1n del Sur'), to('fr', 'Soudan du Sud'), to('pt', 'Sud\xE3o do Sul'), to('zh', '\u5357\u82CF\u4E39')])), to('country.ES', mapOf([to('en', 'Spain'), to('es', 'Espa\xF1a'), to('fr', 'Espagne'), to('pt', 'Espanha'), to('zh', '\u897F\u73ED\u7259')])), to('country.LK', mapOf([to('en', 'Sri Lanka'), to('es', 'Sri Lanka'), to('fr', 'Sri Lanka'), to('pt', 'Sri Lanka'), to('zh', '\u65AF\u91CC\u5170\u5361')])), to('country.SD', mapOf([to('en', 'Sudan'), to('es', 'Sud\xE1n'), to('fr', 'Soudan'), to('pt', 'Sud\xE3o'), to('zh', '\u82CF\u4E39')])), to('country.SR', mapOf([to('en', 'Suriname'), to('es', 'Surinam'), to('fr', 'Suriname'), to('pt', 'Suriname'), to('zh', '\u82CF\u91CC\u5357')])), to('country.SE', mapOf([to('en', 'Sweden'), to('es', 'Suecia'), to('fr', 'Su\xE8de'), to('pt', 'Su\xE9cia'), to('zh', '\u745E\u5178')])), to('country.CH', mapOf([to('en', 'Switzerland'), to('es', 'Suiza'), to('fr', 'Suisse'), to('pt', 'Su\xED\xE7a'), to('zh', '\u745E\u58EB')])), to('country.SY', mapOf([to('en', 'Syria'), to('es', 'Siria'), to('fr', 'Syrie'), to('pt', 'S\xEDria'), to('zh', '\u53D9\u5229\u4E9A')])), to('country.TW', mapOf([to('en', 'Taiwan'), to('es', 'Taiw\xE1n'), to('fr', 'Ta\xEFwan'), to('pt', 'Taiwan'), to('zh', '\u53F0\u6E7E')])), to('country.TJ', mapOf([to('en', 'Tajikistan'), to('es', 'Tayikist\xE1n'), to('fr', 'Tadjikistan'), to('pt', 'Tajiquist\xE3o'), to('zh', '\u5854\u5409\u514B\u65AF\u5766')])), to('country.TZ', mapOf([to('en', 'Tanzania'), to('es', 'Tanzania'), to('fr', 'Tanzanie'), to('pt', 'Tanz\xE2nia'), to('zh', '\u5766\u6851\u5C3C\u4E9A')])), to('country.TH', mapOf([to('en', 'Thailand'), to('es', 'Tailandia'), to('fr', 'Tha\xEFlande'), to('pt', 'Tail\xE2ndia'), to('zh', '\u6CF0\u56FD')])), to('country.TL', mapOf([to('en', 'Timor-Leste'), to('es', 'Timor Oriental'), to('fr', 'Timor oriental'), to('pt', 'Timor-Leste'), to('zh', '\u4E1C\u5E1D\u6C76')])), to('country.TG', mapOf([to('en', 'Togo'), to('es', 'Togo'), to('fr', 'Togo'), to('pt', 'Togo'), to('zh', '\u591A\u54E5')])), to('country.TO', mapOf([to('en', 'Tonga'), to('es', 'Tonga'), to('fr', 'Tonga'), to('pt', 'Tonga'), to('zh', '\u6C64\u52A0')])), to('country.TT', mapOf([to('en', 'Trinidad and Tobago'), to('es', 'Trinidad y Tobago'), to('fr', 'Trinit\xE9-et-Tobago'), to('pt', 'Trinidad e Tobago'), to('zh', '\u7279\u7ACB\u5C3C\u8FBE\u548C\u591A\u5DF4\u54E5')])), to('country.TN', mapOf([to('en', 'Tunisia'), to('es', 'T\xFAnez'), to('fr', 'Tunisie'), to('pt', 'Tun\xEDsia'), to('zh', '\u7A81\u5C3C\u65AF')])), to('country.TR', mapOf([to('en', 'Turkey'), to('es', 'Turqu\xEDa'), to('fr', 'Turquie'), to('pt', 'Turquia'), to('zh', '\u571F\u8033\u5176')])), to('country.TM', mapOf([to('en', 'Turkmenistan'), to('es', 'Turkmenist\xE1n'), to('fr', 'Turkm\xE9nistan'), to('pt', 'Turcomenist\xE3o'), to('zh', '\u571F\u5E93\u66FC\u65AF\u5766')])), to('country.TV', mapOf([to('en', 'Tuvalu'), to('es', 'Tuvalu'), to('fr', 'Tuvalu'), to('pt', 'Tuvalu'), to('zh', '\u56FE\u74E6\u5362')])), to('country.UG', mapOf([to('en', 'Uganda'), to('es', 'Uganda'), to('fr', 'Ouganda'), to('pt', 'Uganda'), to('zh', '\u4E4C\u5E72\u8FBE')])), to('country.UA', mapOf([to('en', 'Ukraine'), to('es', 'Ucrania'), to('fr', 'Ukraine'), to('pt', 'Ucr\xE2nia'), to('zh', '\u4E4C\u514B\u5170')])), to('country.AE', mapOf([to('en', 'United Arab Emirates'), to('es', 'Emiratos \xC1rabes Unidos'), to('fr', '\xC9mirats arabes unis'), to('pt', 'Emirados \xC1rabes Unidos'), to('zh', '\u963F\u62C9\u4F2F\u8054\u5408\u914B\u957F\u56FD')])), to('country.GB', mapOf([to('en', 'United Kingdom'), to('es', 'Reino Unido'), to('fr', 'Royaume-Uni'), to('pt', 'Reino Unido'), to('zh', '\u82F1\u56FD')])), to('country.US', mapOf([to('en', 'United States'), to('es', 'Estados Unidos'), to('fr', '\xC9tats-Unis'), to('pt', 'Estados Unidos'), to('zh', '\u7F8E\u56FD')])), to('country.UY', mapOf([to('en', 'Uruguay'), to('es', 'Uruguay'), to('fr', 'Uruguay'), to('pt', 'Uruguai'), to('zh', '\u4E4C\u62C9\u572D')])), to('country.UZ', mapOf([to('en', 'Uzbekistan'), to('es', 'Uzbekist\xE1n'), to('fr', 'Ouzb\xE9kistan'), to('pt', 'Uzbequist\xE3o'), to('zh', '\u4E4C\u5179\u522B\u514B\u65AF\u5766')])), to('country.VU', mapOf([to('en', 'Vanuatu'), to('es', 'Vanuatu'), to('fr', 'Vanuatu'), to('pt', 'Vanuatu'), to('zh', '\u74E6\u52AA\u963F\u56FE')])), to('country.VA', mapOf([to('en', 'Vatican City'), to('es', 'Ciudad del Vaticano'), to('fr', 'Cit\xE9 du Vatican'), to('pt', 'Cidade do Vaticano'), to('zh', '\u68B5\u8482\u5188')])), to('country.VE', mapOf([to('en', 'Venezuela'), to('es', 'Venezuela'), to('fr', 'Venezuela'), to('pt', 'Venezuela'), to('zh', '\u59D4\u5185\u745E\u62C9')])), to('country.VN', mapOf([to('en', 'Vietnam'), to('es', 'Vietnam'), to('fr', 'Vi\xEAt Nam'), to('pt', 'Vietn\xE3'), to('zh', '\u8D8A\u5357')])), to('country.YE', mapOf([to('en', 'Yemen'), to('es', 'Yemen'), to('fr', 'Y\xE9men'), to('pt', 'I\xEAmen'), to('zh', '\u4E5F\u95E8')])), to('country.ZM', mapOf([to('en', 'Zambia'), to('es', 'Zambia'), to('fr', 'Zambie'), to('pt', 'Z\xE2mbia'), to('zh', '\u8D5E\u6BD4\u4E9A')])), to('country.ZW', mapOf([to('en', 'Zimbabwe'), to('es', 'Zimbabue'), to('fr', 'Zimbabwe'), to('pt', 'Zimb\xE1bue'), to('zh', '\u6D25\u5DF4\u5E03\u97E6')]))]);
    }
  }
  var Locale_ENGLISH_instance;
  var Locale_SPANISH_instance;
  var Locale_FRENCH_instance;
  var Locale_PORTUGUESE_instance;
  var Locale_CHINESE_instance;
  function Companion_0() {
  }
  protoOf(Companion_0).g28 = function (code) {
    // Inline function 'kotlin.collections.find' call
    var tmp0 = get_entries();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.o26_1 === code) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  var Companion_instance_1;
  function Companion_getInstance_0() {
    return Companion_instance_1;
  }
  function values_6() {
    return [Locale_ENGLISH_getInstance(), Locale_SPANISH_getInstance(), Locale_FRENCH_getInstance(), Locale_PORTUGUESE_getInstance(), Locale_CHINESE_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values_6());
    return $ENTRIES;
  }
  var Locale_entriesInitialized;
  function Locale_initEntries() {
    if (Locale_entriesInitialized)
      return Unit_instance;
    Locale_entriesInitialized = true;
    Locale_ENGLISH_instance = new Locale('ENGLISH', 0, 'en', '\uD83C\uDDFA\uD83C\uDDF8', 'English');
    Locale_SPANISH_instance = new Locale('SPANISH', 1, 'es', '\uD83C\uDDEA\uD83C\uDDF8', 'Espa\xF1ol');
    Locale_FRENCH_instance = new Locale('FRENCH', 2, 'fr', '\uD83C\uDDEB\uD83C\uDDF7', 'Fran\xE7ais');
    Locale_PORTUGUESE_instance = new Locale('PORTUGUESE', 3, 'pt', '\uD83C\uDDE7\uD83C\uDDF7', 'Portugu\xEAs');
    Locale_CHINESE_instance = new Locale('CHINESE', 4, 'zh', '\uD83C\uDDE8\uD83C\uDDF3', '\u4E2D\u6587');
  }
  var $ENTRIES;
  function Locale(name, ordinal, code, flag, label) {
    Enum.call(this, name, ordinal);
    this.o26_1 = code;
    this.p26_1 = flag;
    this.q26_1 = label;
  }
  function _set_locale__t3qkub($this, value) {
    return localStorage.setItem('bitakore.locale', value.o26_1);
  }
  function detectBrowserLocale($this) {
    var browserCode = take(window.navigator.language, 2);
    var tmp0_elvis_lhs = Companion_instance_1.g28(browserCode);
    return tmp0_elvis_lhs == null ? Locale_ENGLISH_getInstance() : tmp0_elvis_lhs;
  }
  function I18n() {
    I18n_instance = this;
    this.j26_1 = 'bitakore.locale';
    this.k26_1 = plus(mapOf([to('nav.logActivity', mapOf([to('en', 'Log activity'), to('es', 'Registrar actividad'), to('fr', 'Enregistrer une activit\xE9'), to('pt', 'Registrar atividade'), to('zh', '\u8BB0\u5F55\u6D3B\u52A8')])), to('layout.addLogEntryFab', mapOf([to('en', 'Add log entry'), to('es', 'A\xF1adir entrada'), to('fr', 'Ajouter une entr\xE9e'), to('pt', 'Adicionar entrada'), to('zh', '\u6DFB\u52A0\u8BB0\u5F55')])), to('nav.myBitacora', mapOf([to('en', 'My bit\xE1cora'), to('es', 'Mi bit\xE1cora'), to('fr', 'Mon bit\xE1cora'), to('pt', 'Minha bit\xE1cora'), to('zh', '\u6211\u7684 bit\xE1cora')])), to('nav.leaderboard', mapOf([to('en', 'Leaderboard'), to('es', 'Clasificaci\xF3n'), to('fr', 'Classement'), to('pt', 'Classifica\xE7\xE3o'), to('zh', '\u6392\u884C\u699C')])), to('leaderboard.title', mapOf([to('en', 'Leaderboard'), to('es', 'Clasificaci\xF3n'), to('fr', 'Classement'), to('pt', 'Classifica\xE7\xE3o'), to('zh', '\u6392\u884C\u699C')])), to('leaderboard.activityType', mapOf([to('en', 'Activity'), to('es', 'Actividad'), to('fr', 'Activit\xE9'), to('pt', 'Atividade'), to('zh', '\u6D3B\u52A8')])), to('leaderboard.period.week', mapOf([to('en', 'Last week'), to('es', '\xDAltima semana'), to('fr', 'Semaine derni\xE8re'), to('pt', '\xDAltima semana'), to('zh', '\u4E0A\u5468')])), to('leaderboard.period.month', mapOf([to('en', 'Last month'), to('es', '\xDAltimo mes'), to('fr', 'Mois dernier'), to('pt', '\xDAltimo m\xEAs'), to('zh', '\u4E0A\u6708')])), to('leaderboard.period.year', mapOf([to('en', 'Last year'), to('es', '\xDAltimo a\xF1o'), to('fr', 'Ann\xE9e derni\xE8re'), to('pt', '\xDAltimo ano'), to('zh', '\u53BB\u5E74')])), to('leaderboard.byEventCount', mapOf([to('en', 'By number of events'), to('es', 'Por n\xFAmero de eventos'), to('fr', "Par nombre d'\xE9v\xE9nements"), to('pt', 'Por n\xFAmero de eventos'), to('zh', '\u6309\u6D3B\u52A8\u6B21\u6570')])), to('leaderboard.byDistance', mapOf([to('en', 'By distance'), to('es', 'Por distancia'), to('fr', 'Par distance'), to('pt', 'Por dist\xE2ncia'), to('zh', '\u6309\u8DDD\u79BB')])), to('leaderboard.byTime', mapOf([to('en', 'By time'), to('es', 'Por tiempo'), to('fr', 'Par temps'), to('pt', 'Por tempo'), to('zh', '\u6309\u65F6\u957F')])), to('leaderboard.empty', mapOf([to('en', 'No one has set a nickname and logged this activity in this period yet.'), to('es', 'Nadie ha configurado un apodo ni registrado esta actividad en este periodo todav\xEDa.'), to('fr', "Personne n'a encore d\xE9fini de pseudo ni enregistr\xE9 cette activit\xE9 pour cette p\xE9riode."), to('pt', 'Ainda ningu\xE9m definiu um apelido e registrou esta atividade neste per\xEDodo.'), to('zh', '\u6B64\u671F\u95F4\u8FD8\u6CA1\u6709\u4EBA\u8BBE\u7F6E\u6635\u79F0\u5E76\u8BB0\u5F55\u6B64\u6D3B\u52A8\u3002')])), to('leaderboard.noRegisteredActivities', mapOf([to('en', 'Register an activity type in your profile to see its leaderboard.'), to('es', 'Registra un tipo de actividad en tu perfil para ver su clasificaci\xF3n.'), to('fr', "Enregistrez un type d'activit\xE9 dans votre profil pour voir son classement."), to('pt', 'Registre um tipo de atividade no seu perfil para ver sua classifica\xE7\xE3o.'), to('zh', '\u5728\u4E2A\u4EBA\u8D44\u6599\u4E2D\u6CE8\u518C\u4E00\u9879\u6D3B\u52A8\u7C7B\u578B\u4EE5\u67E5\u770B\u5176\u6392\u884C\u699C\u3002')])), to('nav.approvals', mapOf([to('en', 'Invitation register activity'), to('es', 'Invitaci\xF3n para registrar actividad'), to('fr', 'Invitation \xE0 enregistrer une activit\xE9'), to('pt', 'Convite para registrar atividade'), to('zh', '\u9080\u8BF7\u6CE8\u518C\u6D3B\u52A8')])), to('nav.claimInvitations', mapOf([to('en', 'Claim invitations'), to('es', 'Invitaciones de reclamo'), to('fr', 'Invitations de r\xE9clamation'), to('pt', 'Convites de reivindica\xE7\xE3o'), to('zh', '\u8BA4\u9886\u9080\u8BF7')])), to('nav.certRequests', mapOf([to('en', 'Cert visualization request'), to('es', 'Solicitud de visualizaci\xF3n de certificaci\xF3n'), to('fr', 'Demande de visualisation de certification'), to('pt', 'Solicita\xE7\xE3o de visualiza\xE7\xE3o de certifica\xE7\xE3o'), to('zh', '\u8BC1\u4E66\u67E5\u770B\u8BF7\u6C42')])), to('nav.requestCertifications', mapOf([to('en', 'Request user certifications'), to('es', 'Solicitar certificaciones de usuario'), to('fr', "Demander les certifications de l'utilisateur"), to('pt', 'Solicitar certifica\xE7\xF5es do usu\xE1rio'), to('zh', '\u7533\u8BF7\u7528\u6237\u8BA4\u8BC1')])), to('nav.certifications', mapOf([to('en', 'Certifications'), to('es', 'Certificaciones'), to('fr', 'Certifications'), to('pt', 'Certifica\xE7\xF5es'), to('zh', '\u8BA4\u8BC1')])), to('nav.issuingAuthorities', mapOf([to('en', 'Issuing authorities'), to('es', 'Entidades emisoras'), to('fr', 'Organismes \xE9metteurs'), to('pt', 'Entidades emissoras'), to('zh', '\u9881\u53D1\u673A\u6784')])), to('nav.adminUsers', mapOf([to('en', 'Users'), to('es', 'Usuarios'), to('fr', 'Utilisateurs'), to('pt', 'Usu\xE1rios'), to('zh', '\u7528\u6237')])), to('nav.activityCenters', mapOf([to('en', 'Activity centers'), to('es', 'Centros de actividad'), to('fr', "Centres d'activit\xE9"), to('pt', 'Centros de atividade'), to('zh', '\u6D3B\u52A8\u4E2D\u5FC3')])), to('nav.certificationIssuers', mapOf([to('en', 'Certification issuers'), to('es', 'Entidades certificadoras'), to('fr', 'Organismes de certification'), to('pt', 'Entidades certificadoras'), to('zh', '\u8BA4\u8BC1\u673A\u6784')])), to('nav.marketers', mapOf([to('en', 'Marketers'), to('es', 'Comercializadoras'), to('fr', 'Agences marketing'), to('pt', 'Comercializadoras'), to('zh', '\u8425\u9500\u5546')])), to('nav.incoming', mapOf([to('en', 'Incoming'), to('es', 'Entrantes'), to('fr', 'Entrant'), to('pt', 'Recebidas'), to('zh', '\u6536\u4EF6')])), to('nav.outgoing', mapOf([to('en', 'Outgoing'), to('es', 'Salientes'), to('fr', 'Sortant'), to('pt', 'Enviadas'), to('zh', '\u53D1\u4EF6')])), to('nav.profile', mapOf([to('en', 'Profile'), to('es', 'Perfil'), to('fr', 'Profil'), to('pt', 'Perfil'), to('zh', '\u4E2A\u4EBA\u8D44\u6599')])), to('nav.settings', mapOf([to('en', 'Settings'), to('es', 'Ajustes'), to('fr', 'Param\xE8tres'), to('pt', 'Configura\xE7\xF5es'), to('zh', '\u8BBE\u7F6E')])), to('nav.logout', mapOf([to('en', 'Log out'), to('es', 'Cerrar sesi\xF3n'), to('fr', 'D\xE9connexion'), to('pt', 'Sair'), to('zh', '\u9000\u51FA\u767B\u5F55')])), to('nav.login', mapOf([to('en', 'Log in'), to('es', 'Iniciar sesi\xF3n'), to('fr', 'Connexion'), to('pt', 'Entrar'), to('zh', '\u767B\u5F55')])), to('nav.register', mapOf([to('en', 'Register'), to('es', 'Registrarse'), to('fr', "S'inscrire"), to('pt', 'Registrar-se'), to('zh', '\u6CE8\u518C')])), to('settings.title', mapOf([to('en', 'Connected devices'), to('es', 'Dispositivos conectados'), to('fr', 'Appareils connect\xE9s'), to('pt', 'Dispositivos conectados'), to('zh', '\u5DF2\u8FDE\u63A5\u8BBE\u5907')])), to('settings.deviceSyncDescription', mapOf([to('en', 'Link a smartwatch or fitness platform to import activities automatically.'), to('es', 'Vincula un reloj inteligente o plataforma de fitness para importar actividades autom\xE1ticamente.'), to('fr', 'Associez une montre connect\xE9e ou une plateforme fitness pour importer automatiquement vos activit\xE9s.'), to('pt', 'Vincule um smartwatch ou plataforma de fitness para importar atividades automaticamente.'), to('zh', '\u5173\u8054\u667A\u80FD\u624B\u8868\u6216\u5065\u8EAB\u5E73\u53F0\u4EE5\u81EA\u52A8\u5BFC\u5165\u6D3B\u52A8\u3002')])), to('settings.connectedTo', mapOf([to('en', 'Connected to '), to('es', 'Conectado a '), to('fr', 'Connect\xE9 \xE0 '), to('pt', 'Conectado a '), to('zh', '\u5DF2\u8FDE\u63A5\u5230 ')])), to('settings.loadError', mapOf([to('en', 'Could not load connected devices: '), to('es', 'No se pudieron cargar los dispositivos conectados: '), to('fr', 'Impossible de charger les appareils connect\xE9s : '), to('pt', 'N\xE3o foi poss\xEDvel carregar os dispositivos conectados: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u5DF2\u8FDE\u63A5\u8BBE\u5907\uFF1A')])), to('settings.status', mapOf([to('en', 'Status: '), to('es', 'Estado: '), to('fr', 'Statut : '), to('pt', 'Status: '), to('zh', '\u72B6\u6001\uFF1A')])), to('settings.lastSynced', mapOf([to('en', 'Last synced: '), to('es', '\xDAltima sincronizaci\xF3n: '), to('fr', 'Derni\xE8re synchronisation : '), to('pt', '\xDAltima sincroniza\xE7\xE3o: '), to('zh', '\u4E0A\u6B21\u540C\u6B65\uFF1A')])), to('settings.notConnected', mapOf([to('en', 'Not connected.'), to('es', 'No conectado.'), to('fr', 'Non connect\xE9.'), to('pt', 'N\xE3o conectado.'), to('zh', '\u672A\u8FDE\u63A5\u3002')])), to('settings.connect', mapOf([to('en', 'Connect'), to('es', 'Conectar'), to('fr', 'Connecter'), to('pt', 'Conectar'), to('zh', '\u8FDE\u63A5')])), to('settings.disconnect', mapOf([to('en', 'Disconnect'), to('es', 'Desconectar'), to('fr', 'D\xE9connecter'), to('pt', 'Desconectar'), to('zh', '\u65AD\u5F00\u8FDE\u63A5')])), to('settings.onDeviceOnly', mapOf([to('en', 'Available in the Bitakore mobile app.'), to('es', 'Disponible en la app m\xF3vil de Bitakore.'), to('fr', "Disponible dans l'application mobile Bitakore."), to('pt', 'Dispon\xEDvel no aplicativo m\xF3vel Bitakore.'), to('zh', '\u53EF\u5728 Bitakore \u624B\u673A\u5E94\u7528\u4E2D\u4F7F\u7528\u3002')])), to('activitySelection.title', mapOf([to('en', 'Which activities do you practice?'), to('es', '\xBFQu\xE9 actividades practicas?'), to('fr', 'Quelles activit\xE9s pratiquez-vous ?'), to('pt', 'Quais atividades voc\xEA pratica?'), to('zh', '\u4F60\u4ECE\u4E8B\u54EA\u4E9B\u6D3B\u52A8?')])), to('activitySelection.subtitle', mapOf([to('en', 'Select every activity you log or plan to log \u2014 you can change this later from your profile.'), to('es', 'Selecciona cada actividad que registras o planeas registrar \u2014 puedes cambiarlo luego desde tu perfil.'), to('fr', "S\xE9lectionnez chaque activit\xE9 que vous enregistrez ou pr\xE9voyez d'enregistrer \u2014 vous pourrez modifier cela plus tard depuis votre profil."), to('pt', 'Selecione cada atividade que voc\xEA registra ou pretende registrar \u2014 voc\xEA pode alterar isso depois no seu perfil.'), to('zh', '\u9009\u62E9\u4F60\u8BB0\u5F55\u6216\u8BA1\u5212\u8BB0\u5F55\u7684\u6BCF\u9879\u6D3B\u52A8\u2014\u2014\u4E4B\u540E\u53EF\u4EE5\u5728\u4E2A\u4EBA\u8D44\u6599\u4E2D\u66F4\u6539\u3002')])), to('activitySelection.searchPlaceholder', mapOf([to('en', 'Search activities\u2026'), to('es', 'Buscar actividades\u2026'), to('fr', 'Rechercher des activit\xE9s\u2026'), to('pt', 'Pesquisar atividades\u2026'), to('zh', '\u641C\u7D22\u6D3B\u52A8\u2026')])), to('activitySelection.submitButton', mapOf([to('en', 'Save'), to('es', 'Guardar'), to('fr', 'Enregistrer'), to('pt', 'Salvar'), to('zh', '\u4FDD\u5B58')])), to('activitySelection.loadErrorPrefix', mapOf([to('en', 'Could not load your current activities: '), to('es', 'No se pudieron cargar tus actividades actuales: '), to('fr', 'Impossible de charger vos activit\xE9s actuelles : '), to('pt', 'N\xE3o foi poss\xEDvel carregar suas atividades atuais: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u60A8\u5F53\u524D\u7684\u6D3B\u52A8: ')])), to('activitySelection.removeWarningPrefix', mapOf([to('en', 'Removing '), to('es', 'Eliminar '), to('fr', 'La suppression de '), to('pt', 'Remover '), to('zh', '\u79FB\u9664 ')])), to('activitySelection.removeWarningMiddle', mapOf([to('en', ' will permanently delete '), to('es', ' eliminar\xE1 permanentemente '), to('fr', ' supprimera d\xE9finitivement '), to('pt', ' excluir\xE1 permanentemente '), to('zh', ' \u5C06\u6C38\u4E45\u5220\u9664 ')])), to('activitySelection.removeWarningSuffix', mapOf([to('en', ' logged entries.'), to('es', ' entradas registradas.'), to('fr', ' entr\xE9es enregistr\xE9es.'), to('pt', ' entradas registradas.'), to('zh', ' \u6761\u5DF2\u8BB0\u5F55\u7684\u6761\u76EE\u3002')])), to('activityOfferings.removeWarningPrefix', mapOf([to('en', 'Removing '), to('es', 'Eliminar '), to('fr', 'La suppression de '), to('pt', 'Remover '), to('zh', '\u79FB\u9664 ')])), to('activityOfferings.removeWarningMiddle', mapOf([to('en', ' will permanently delete '), to('es', ' eliminar\xE1 permanentemente '), to('fr', ' supprimera d\xE9finitivement '), to('pt', ' excluir\xE1 permanentemente '), to('zh', ' \u5C06\u6C38\u4E45\u5220\u9664 ')])), to('activityOfferings.removeWarningSuffix', mapOf([to('en', ' logged entries.'), to('es', ' entradas registradas.'), to('fr', ' entr\xE9es enregistr\xE9es.'), to('pt', ' entradas registradas.'), to('zh', ' \u6761\u5DF2\u8BB0\u5F55\u7684\u6761\u76EE\u3002')])), to('activitySelection.confirmDeleteButton', mapOf([to('en', 'Yes, delete these entries and save'), to('es', 'S\xED, eliminar estas entradas y guardar'), to('fr', 'Oui, supprimer ces entr\xE9es et enregistrer'), to('pt', 'Sim, excluir essas entradas e salvar'), to('zh', '\u662F\u7684\uFF0C\u5220\u9664\u8FD9\u4E9B\u6761\u76EE\u5E76\u4FDD\u5B58')])), to('home.title', mapOf([to('en', 'Bitakore'), to('es', 'Bitakore'), to('fr', 'Bitakore'), to('pt', 'Bitakore'), to('zh', 'Bitakore')])), to('home.tagline', mapOf([to('en', 'Sports logging for teams, activity centers, and practitioners.'), to('es', 'Registro deportivo para equipos, centros de actividades y practicantes.'), to('fr', "Suivi sportif pour les \xE9quipes, les centres d'activit\xE9s et les pratiquants."), to('pt', 'Registro esportivo para equipes, centros de atividades e praticantes.'), to('zh', '\u4E3A\u56E2\u961F\u3001\u6D3B\u52A8\u4E2D\u5FC3\u548C\u4ECE\u4E1A\u8005\u63D0\u4F9B\u7684\u8FD0\u52A8\u8BB0\u5F55\u670D\u52A1\u3002')])), to('acceptInvitation.title', mapOf([to('en', 'Accept invitation'), to('es', 'Aceptar invitaci\xF3n'), to('fr', "Accepter l'invitation"), to('pt', 'Aceitar convite'), to('zh', '\u63A5\u53D7\u9080\u8BF7')])), to('acceptInvitation.missingCode', mapOf([to('en', 'Missing invitation code \u2014 use the link from your invitation email.'), to('es', 'Falta el c\xF3digo de invitaci\xF3n \u2014 usa el enlace de tu correo de invitaci\xF3n.'), to('fr', "Code d'invitation manquant \u2014 utilisez le lien de votre e-mail d'invitation."), to('pt', 'C\xF3digo de convite ausente \u2014 use o link do seu e-mail de convite.'), to('zh', '\u7F3A\u5C11\u9080\u8BF7\u7801 \u2014 \u8BF7\u4F7F\u7528\u9080\u8BF7\u90AE\u4EF6\u4E2D\u7684\u94FE\u63A5\u3002')])), to('acceptInvitation.nameLabel', mapOf([to('en', 'Your name'), to('es', 'Tu nombre'), to('fr', 'Votre nom'), to('pt', 'Seu nome'), to('zh', '\u60A8\u7684\u59D3\u540D')])), to('acceptInvitation.joinButton', mapOf([to('en', 'Join'), to('es', 'Unirse'), to('fr', 'Rejoindre'), to('pt', 'Entrar'), to('zh', '\u52A0\u5165')])), to('acceptInvitation.genericErrorPrefix', mapOf([to('en', 'Something went wrong:'), to('es', 'Ocurri\xF3 un error:'), to('fr', "Une erreur s'est produite :"), to('pt', 'Algo deu errado:'), to('zh', '\u51FA\u73B0\u9519\u8BEF\uFF1A')])), to('activityOfferings.missingCompanyTitle', mapOf([to('en', 'Missing company'), to('es', 'Falta la empresa'), to('fr', 'Entreprise manquante'), to('pt', 'Empresa em falta'), to('zh', '\u7F3A\u5C11\u516C\u53F8\u4FE1\u606F')])), to('activityOfferings.missingCompanyBody', mapOf([to('en', 'No company was specified.'), to('es', 'No se especific\xF3 ninguna empresa.'), to('fr', "Aucune entreprise n'a \xE9t\xE9 sp\xE9cifi\xE9e."), to('pt', 'Nenhuma empresa foi especificada.'), to('zh', '\u672A\u6307\u5B9A\u516C\u53F8\u3002')])), to('activityOfferings.title', mapOf([to('en', 'Which activities do you offer?'), to('es', '\xBFQu\xE9 actividades ofreces?'), to('fr', 'Quelles activit\xE9s proposez-vous ?'), to('pt', 'Quais atividades voc\xEA oferece?'), to('zh', '\u60A8\u63D0\u4F9B\u54EA\u4E9B\u6D3B\u52A8\uFF1F')])), to('activityOfferings.subtitle', mapOf([to('en', 'Select every activity practitioners can log at this center \u2014 you can change this later from your profile.'), to('es', 'Selecciona todas las actividades que los practicantes pueden registrar en este centro; puedes cambiarlo m\xE1s tarde desde tu perfil.'), to('fr', 'S\xE9lectionnez toutes les activit\xE9s que les pratiquants peuvent enregistrer dans ce centre \u2014 vous pourrez modifier cela plus tard depuis votre profil.'), to('pt', 'Selecione todas as atividades que os praticantes podem registrar neste centro \u2014 voc\xEA pode alterar isso mais tarde no seu perfil.'), to('zh', '\u9009\u62E9\u7EC3\u4E60\u8005\u53EF\u4EE5\u5728\u6B64\u4E2D\u5FC3\u8BB0\u5F55\u7684\u6240\u6709\u6D3B\u52A8\u2014\u2014\u60A8\u4EE5\u540E\u53EF\u4EE5\u5728\u4E2A\u4EBA\u8D44\u6599\u4E2D\u66F4\u6539\u6B64\u8BBE\u7F6E\u3002')])), to('activityOfferings.saveButton', mapOf([to('en', 'Save'), to('es', 'Guardar'), to('fr', 'Enregistrer'), to('pt', 'Salvar'), to('zh', '\u4FDD\u5B58')])), to('activityOfferings.loadOfferingsErrorPrefix', mapOf([to('en', 'Could not load current offerings: '), to('es', 'No se pudieron cargar las actividades actuales: '), to('fr', 'Impossible de charger les offres actuelles : '), to('pt', 'N\xE3o foi poss\xEDvel carregar as ofertas atuais: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u5F53\u524D\u63D0\u4F9B\u7684\u6D3B\u52A8\uFF1A')])), to('activityOfferings.confirmRemovalButton', mapOf([to('en', 'Yes, delete these entries and save'), to('es', 'S\xED, eliminar estos registros y guardar'), to('fr', 'Oui, supprimer ces entr\xE9es et enregistrer'), to('pt', 'Sim, excluir estes registros e salvar'), to('zh', '\u662F\u7684\uFF0C\u5220\u9664\u8FD9\u4E9B\u8BB0\u5F55\u5E76\u4FDD\u5B58')])), to('companyPhotos.heading', mapOf([to('en', 'Photos'), to('es', 'Fotos'), to('fr', 'Photos'), to('pt', 'Fotos'), to('zh', '\u7167\u7247')])), to('companyPhotos.description', mapOf([to('en', 'Up to 5 promotional photos shown to nearby practitioners on the Discover page.'), to('es', 'Hasta 5 fotos promocionales mostradas a practicantes cercanos en la p\xE1gina Descubrir.'), to('fr', "Jusqu'\xE0 5 photos promotionnelles montr\xE9es aux pratiquants proches sur la page D\xE9couvrir."), to('pt', 'At\xE9 5 fotos promocionais mostradas a praticantes pr\xF3ximos na p\xE1gina Descobrir.'), to('zh', '\u6700\u591A5\u5F20\u5BA3\u4F20\u7167\u7247,\u4F1A\u5C55\u793A\u7ED9\u9644\u8FD1\u7684\u7528\u6237\u3002')])), to('companyPhotos.uploadLabel', mapOf([to('en', 'Add a photo'), to('es', 'Agregar una foto'), to('fr', 'Ajouter une photo'), to('pt', 'Adicionar uma foto'), to('zh', '\u6DFB\u52A0\u7167\u7247')])), to('companyPhotos.uploadButton', mapOf([to('en', 'Upload'), to('es', 'Subir'), to('fr', 'T\xE9l\xE9charger'), to('pt', 'Enviar'), to('zh', '\u4E0A\u4F20')])), to('companyPhotos.deleteButton', mapOf([to('en', 'Remove'), to('es', 'Quitar'), to('fr', 'Retirer'), to('pt', 'Remover'), to('zh', '\u79FB\u9664')])), to('companyPhotos.selectFileError', mapOf([to('en', 'Choose a photo first.'), to('es', 'Elige primero una foto.'), to('fr', "Choisissez d'abord une photo."), to('pt', 'Escolha uma foto primeiro.'), to('zh', '\u8BF7\u5148\u9009\u62E9\u4E00\u5F20\u7167\u7247\u3002')])), to('companyPhotos.genericErrorPrefix', mapOf([to('en', 'Upload failed: '), to('es', 'Error al subir: '), to('fr', '\xC9chec du t\xE9l\xE9chargement : '), to('pt', 'Falha ao enviar: '), to('zh', '\u4E0A\u4F20\u5931\u8D25:')])), to('marketerAds.missingCompanyTitle', mapOf([to('en', 'No marketer specified'), to('es', 'No se especific\xF3 un anunciante'), to('fr', 'Aucun annonceur sp\xE9cifi\xE9'), to('pt', 'Nenhum anunciante especificado'), to('zh', '\u672A\u6307\u5B9A\u8425\u9500\u5546')])), to('marketerAds.missingCompanyBody', mapOf([to('en', 'This page needs a marketer company id in the URL.'), to('es', 'Esta p\xE1gina necesita un id de empresa anunciante en la URL.'), to('fr', "Cette page a besoin d'un identifiant d'entreprise annonceur dans l'URL."), to('pt', 'Esta p\xE1gina precisa de um id de empresa anunciante na URL.'), to('zh', '\u6B64\u9875\u9762\u9700\u8981\u5728\u7F51\u5740\u4E2D\u6307\u5B9A\u8425\u9500\u5546\u516C\u53F8ID\u3002')])), to('marketerAds.title', mapOf([to('en', 'Advertisements'), to('es', 'Anuncios'), to('fr', 'Publicit\xE9s'), to('pt', 'An\xFAncios'), to('zh', '\u5E7F\u544A')])), to('marketerAds.subtitle', mapOf([to('en', 'Photos shown to practitioners on the Discover page, targeted by sport and location.'), to('es', 'Fotos mostradas a los practicantes en la p\xE1gina Descubrir, seg\xFAn deporte y ubicaci\xF3n.'), to('fr', 'Photos montr\xE9es aux pratiquants sur la page D\xE9couvrir, cibl\xE9es par sport et emplacement.'), to('pt', 'Fotos mostradas aos praticantes na p\xE1gina Descobrir, segmentadas por esporte e localiza\xE7\xE3o.'), to('zh', '\u5728\u53D1\u73B0\u9875\u9762\u5411\u7528\u6237\u5C55\u793A\u7684\u7167\u7247,\u6309\u8FD0\u52A8\u548C\u4F4D\u7F6E\u5B9A\u5411\u6295\u653E\u3002')])), to('marketerAds.imageLabel', mapOf([to('en', 'Ad image'), to('es', 'Imagen del anuncio'), to('fr', "Image de l'annonce"), to('pt', 'Imagem do an\xFAncio'), to('zh', '\u5E7F\u544A\u56FE\u7247')])), to('marketerAds.activityTypesHeading', mapOf([to('en', 'Sports'), to('es', 'Deportes'), to('fr', 'Sports'), to('pt', 'Esportes'), to('zh', '\u8FD0\u52A8')])), to('marketerAds.targetAreaHeading', mapOf([to('en', 'Target area'), to('es', '\xC1rea objetivo'), to('fr', 'Zone cibl\xE9e'), to('pt', '\xC1rea-alvo'), to('zh', '\u76EE\u6807\u533A\u57DF')])), to('marketerAds.destinationUrlLabel', mapOf([to('en', 'Destination link (optional)'), to('es', 'Enlace de destino (opcional)'), to('fr', 'Lien de destination (facultatif)'), to('pt', 'Link de destino (opcional)'), to('zh', '\u76EE\u6807\u94FE\u63A5(\u53EF\u9009)')])), to('marketerAds.radiusLabel', mapOf([to('en', 'Radius (km)'), to('es', 'Radio (km)'), to('fr', 'Rayon (km)'), to('pt', 'Raio (km)'), to('zh', '\u534A\u5F84(\u516C\u91CC)')])), to('marketerAds.submitButton', mapOf([to('en', 'Publish ad'), to('es', 'Publicar anuncio'), to('fr', "Publier l'annonce"), to('pt', 'Publicar an\xFAncio'), to('zh', '\u53D1\u5E03\u5E7F\u544A')])), to('marketerAds.selectImageError', mapOf([to('en', 'Choose an image first.'), to('es', 'Elige primero una imagen.'), to('fr', "Choisissez d'abord une image."), to('pt', 'Escolha uma imagem primeiro.'), to('zh', '\u8BF7\u5148\u9009\u62E9\u4E00\u5F20\u56FE\u7247\u3002')])), to('marketerAds.selectActivityTypeError', mapOf([to('en', 'Choose at least one sport.'), to('es', 'Elige al menos un deporte.'), to('fr', 'Choisissez au moins un sport.'), to('pt', 'Escolha pelo menos um esporte.'), to('zh', '\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u9879\u8FD0\u52A8\u3002')])), to('marketerAds.selectLocationError', mapOf([to('en', 'Search for a place and confirm a location first.'), to('es', 'Busca un lugar y confirma una ubicaci\xF3n primero.'), to('fr', "Recherchez un lieu et confirmez un emplacement d'abord."), to('pt', 'Pesquise um local e confirme uma localiza\xE7\xE3o primeiro.'), to('zh', '\u8BF7\u5148\u641C\u7D22\u5730\u70B9\u5E76\u786E\u8BA4\u4F4D\u7F6E\u3002')])), to('marketerAds.genericErrorPrefix', mapOf([to('en', 'Could not publish the ad: '), to('es', 'No se pudo publicar el anuncio: '), to('fr', "Impossible de publier l'annonce : "), to('pt', 'N\xE3o foi poss\xEDvel publicar o an\xFAncio: '), to('zh', '\u65E0\u6CD5\u53D1\u5E03\u5E7F\u544A:')])), to('marketerAds.yourAdsHeading', mapOf([to('en', 'Your ads'), to('es', 'Tus anuncios'), to('fr', 'Vos annonces'), to('pt', 'Seus an\xFAncios'), to('zh', '\u60A8\u7684\u5E7F\u544A')])), to('marketerAds.noAdsYet', mapOf([to('en', 'No ads yet.'), to('es', 'A\xFAn no hay anuncios.'), to('fr', "Pas encore d'annonces."), to('pt', 'Ainda n\xE3o h\xE1 an\xFAncios.'), to('zh', '\u6682\u65E0\u5E7F\u544A\u3002')])), to('marketerAds.radiusPrefix', mapOf([to('en', 'Radius: '), to('es', 'Radio: '), to('fr', 'Rayon : '), to('pt', 'Raio: '), to('zh', '\u534A\u5F84:')])), to('marketerAds.radiusSuffix', mapOf([to('en', ' km'), to('es', ' km'), to('fr', ' km'), to('pt', ' km'), to('zh', ' \u516C\u91CC')])), to('marketerAds.activeLabel', mapOf([to('en', 'Active'), to('es', 'Activo'), to('fr', 'Actif'), to('pt', 'Ativo'), to('zh', '\u6D3B\u8DC3')])), to('marketerAds.inactiveLabel', mapOf([to('en', 'Inactive'), to('es', 'Inactivo'), to('fr', 'Inactif'), to('pt', 'Inativo'), to('zh', '\u5DF2\u505C\u7528')])), to('marketerAds.deactivateButton', mapOf([to('en', 'Deactivate'), to('es', 'Desactivar'), to('fr', 'D\xE9sactiver'), to('pt', 'Desativar'), to('zh', '\u505C\u7528')])), to('marketerCampaigns.missingCompanyTitle', mapOf([to('en', 'No marketer specified'), to('es', 'No se especific\xF3 un anunciante'), to('fr', 'Aucun annonceur sp\xE9cifi\xE9'), to('pt', 'Nenhum anunciante especificado'), to('zh', '\u672A\u6307\u5B9A\u8425\u9500\u5546')])), to('marketerCampaigns.missingCompanyBody', mapOf([to('en', 'This page needs a marketer company id in the URL.'), to('es', 'Esta p\xE1gina necesita un id de empresa anunciante en la URL.'), to('fr', "Cette page a besoin d'un identifiant d'entreprise annonceur dans l'URL."), to('pt', 'Esta p\xE1gina precisa de um id de empresa anunciante na URL.'), to('zh', '\u6B64\u9875\u9762\u9700\u8981\u5728\u7F51\u5740\u4E2D\u6307\u5B9A\u8425\u9500\u5546\u516C\u53F8ID\u3002')])), to('marketerCampaigns.title', mapOf([to('en', 'Ad campaigns'), to('es', 'Campa\xF1as publicitarias'), to('fr', 'Campagnes publicitaires'), to('pt', 'Campanhas publicit\xE1rias'), to('zh', '\u5E7F\u544A\u6D3B\u52A8')])), to('marketerCampaigns.subtitle', mapOf([to('en', 'Schedule sponsored placement in the Discover feed, with a prepaid budget you control.'), to('es', 'Programa publicidad patrocinada en el feed de Descubrir, con un presupuesto prepagado que controlas.'), to('fr', 'Planifiez un placement sponsoris\xE9 dans le fil D\xE9couvrir, avec un budget pr\xE9pay\xE9 que vous contr\xF4lez.'), to('pt', 'Agende posicionamento patrocinado no feed Descobrir, com um or\xE7amento pr\xE9-pago que voc\xEA controla.'), to('zh', '\u5728\u53D1\u73B0\u4FE1\u606F\u6D41\u4E2D\u5B89\u6392\u8D5E\u52A9\u4F4D\u7F6E\u6295\u653E\uFF0C\u4F7F\u7528\u60A8\u81EA\u884C\u638C\u63A7\u7684\u9884\u4ED8\u9884\u7B97\u3002')])), to('marketerCampaigns.imageLabel', mapOf([to('en', 'Ad image'), to('es', 'Imagen del anuncio'), to('fr', "Image de l'annonce"), to('pt', 'Imagem do an\xFAncio'), to('zh', '\u5E7F\u544A\u56FE\u7247')])), to('marketerCampaigns.activityTypesHeading', mapOf([to('en', 'Sports'), to('es', 'Deportes'), to('fr', 'Sports'), to('pt', 'Esportes'), to('zh', '\u8FD0\u52A8')])), to('marketerCampaigns.targetAreaHeading', mapOf([to('en', 'Target area'), to('es', '\xC1rea objetivo'), to('fr', 'Zone cibl\xE9e'), to('pt', '\xC1rea-alvo'), to('zh', '\u76EE\u6807\u533A\u57DF')])), to('marketerCampaigns.radiusLabel', mapOf([to('en', 'Radius (km)'), to('es', 'Radio (km)'), to('fr', 'Rayon (km)'), to('pt', 'Raio (km)'), to('zh', '\u534A\u5F84(\u516C\u91CC)')])), to('marketerCampaigns.destinationUrlLabel', mapOf([to('en', 'Destination link (optional)'), to('es', 'Enlace de destino (opcional)'), to('fr', 'Lien de destination (facultatif)'), to('pt', 'Link de destino (opcional)'), to('zh', '\u76EE\u6807\u94FE\u63A5(\u53EF\u9009)')])), to('marketerCampaigns.startDateLabel', mapOf([to('en', 'Start date'), to('es', 'Fecha de inicio'), to('fr', 'Date de d\xE9but'), to('pt', 'Data de in\xEDcio'), to('zh', '\u5F00\u59CB\u65E5\u671F')])), to('marketerCampaigns.endDateLabel', mapOf([to('en', 'End date (optional)'), to('es', 'Fecha de fin (opcional)'), to('fr', 'Date de fin (facultatif)'), to('pt', 'Data de t\xE9rmino (opcional)'), to('zh', '\u7ED3\u675F\u65E5\u671F\uFF08\u53EF\u9009\uFF09')])), to('marketerCampaigns.sizeLabel', mapOf([to('en', 'Ad size'), to('es', 'Tama\xF1o del anuncio'), to('fr', "Taille de l'annonce"), to('pt', 'Tamanho do an\xFAncio'), to('zh', '\u5E7F\u544A\u5C3A\u5BF8')])), to('marketerCampaigns.size.small', mapOf([to('en', 'Small'), to('es', 'Peque\xF1o'), to('fr', 'Petit'), to('pt', 'Pequeno'), to('zh', '\u5C0F')])), to('marketerCampaigns.size.medium', mapOf([to('en', 'Medium'), to('es', 'Mediano'), to('fr', 'Moyen'), to('pt', 'M\xE9dio'), to('zh', '\u4E2D')])), to('marketerCampaigns.size.large', mapOf([to('en', 'Large'), to('es', 'Grande'), to('fr', 'Grand'), to('pt', 'Grande'), to('zh', '\u5927')])), to('marketerCampaigns.placementLabel', mapOf([to('en', 'Placement'), to('es', 'Ubicaci\xF3n'), to('fr', 'Placement'), to('pt', 'Posicionamento'), to('zh', '\u6295\u653E\u4F4D\u7F6E')])), to('marketerCampaigns.placement.standard', mapOf([to('en', 'Standard'), to('es', 'Est\xE1ndar'), to('fr', 'Standard'), to('pt', 'Padr\xE3o'), to('zh', '\u6807\u51C6')])), to('marketerCampaigns.placement.featured', mapOf([to('en', 'Featured (sorts first, costs more)'), to('es', 'Destacado (aparece primero, cuesta m\xE1s)'), to('fr', 'En vedette (appara\xEEt en premier, co\xFBte plus cher)'), to('pt', 'Destaque (aparece primeiro, custa mais)'), to('zh', '\u7CBE\u9009\uFF08\u6392\u5728\u524D\u9762\uFF0C\u8D39\u7528\u66F4\u9AD8\uFF09')])), to('marketerCampaigns.budgetLabel', mapOf([to('en', 'Total budget (USD)'), to('es', 'Presupuesto total (USD)'), to('fr', 'Budget total (USD)'), to('pt', 'Or\xE7amento total (USD)'), to('zh', '\u603B\u9884\u7B97\uFF08\u7F8E\u5143\uFF09')])), to('marketerCampaigns.dailyBudgetLabel', mapOf([to('en', 'Daily cap (USD, optional)'), to('es', 'L\xEDmite diario (USD, opcional)'), to('fr', 'Plafond quotidien (USD, facultatif)'), to('pt', 'Limite di\xE1rio (USD, opcional)'), to('zh', '\u6BCF\u65E5\u4E0A\u9650\uFF08\u7F8E\u5143\uFF0C\u53EF\u9009\uFF09')])), to('marketerCampaigns.submitButton', mapOf([to('en', 'Launch campaign'), to('es', 'Lanzar campa\xF1a'), to('fr', 'Lancer la campagne'), to('pt', 'Lan\xE7ar campanha'), to('zh', '\u542F\u52A8\u6D3B\u52A8')])), to('marketerCampaigns.selectImageError', mapOf([to('en', 'Choose an image first.'), to('es', 'Elige primero una imagen.'), to('fr', "Choisissez d'abord une image."), to('pt', 'Escolha uma imagem primeiro.'), to('zh', '\u8BF7\u5148\u9009\u62E9\u4E00\u5F20\u56FE\u7247\u3002')])), to('marketerCampaigns.selectActivityTypeError', mapOf([to('en', 'Choose at least one sport.'), to('es', 'Elige al menos un deporte.'), to('fr', 'Choisissez au moins un sport.'), to('pt', 'Escolha pelo menos um esporte.'), to('zh', '\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u9879\u8FD0\u52A8\u3002')])), to('marketerCampaigns.selectLocationError', mapOf([to('en', 'Search for a place and confirm a location first.'), to('es', 'Busca un lugar y confirma una ubicaci\xF3n primero.'), to('fr', "Recherchez un lieu et confirmez un emplacement d'abord."), to('pt', 'Pesquise um local e confirme uma localiza\xE7\xE3o primeiro.'), to('zh', '\u8BF7\u5148\u641C\u7D22\u5730\u70B9\u5E76\u786E\u8BA4\u4F4D\u7F6E\u3002')])), to('marketerCampaigns.selectStartDateError', mapOf([to('en', 'Choose a start date.'), to('es', 'Elige una fecha de inicio.'), to('fr', 'Choisissez une date de d\xE9but.'), to('pt', 'Escolha uma data de in\xEDcio.'), to('zh', '\u8BF7\u9009\u62E9\u5F00\u59CB\u65E5\u671F\u3002')])), to('marketerCampaigns.selectBudgetError', mapOf([to('en', 'Enter a budget greater than zero.'), to('es', 'Ingresa un presupuesto mayor que cero.'), to('fr', 'Saisissez un budget sup\xE9rieur \xE0 z\xE9ro.'), to('pt', 'Insira um or\xE7amento maior que zero.'), to('zh', '\u8BF7\u8F93\u5165\u5927\u4E8E\u96F6\u7684\u9884\u7B97\u3002')])), to('marketerCampaigns.genericErrorPrefix', mapOf([to('en', 'Could not save the campaign: '), to('es', 'No se pudo guardar la campa\xF1a: '), to('fr', "Impossible d'enregistrer la campagne : "), to('pt', 'N\xE3o foi poss\xEDvel salvar a campanha: '), to('zh', '\u65E0\u6CD5\u4FDD\u5B58\u5E7F\u544A\u6D3B\u52A8:')])), to('marketerCampaigns.yourCampaignsHeading', mapOf([to('en', 'Your campaigns'), to('es', 'Tus campa\xF1as'), to('fr', 'Vos campagnes'), to('pt', 'Suas campanhas'), to('zh', '\u60A8\u7684\u5E7F\u544A\u6D3B\u52A8')])), to('marketerCampaigns.noCampaignsYet', mapOf([to('en', 'No campaigns yet.'), to('es', 'A\xFAn no hay campa\xF1as.'), to('fr', 'Pas encore de campagnes.'), to('pt', 'Ainda n\xE3o h\xE1 campanhas.'), to('zh', '\u6682\u65E0\u5E7F\u544A\u6D3B\u52A8\u3002')])), to('marketerCampaigns.sizePrefix', mapOf([to('en', 'Size: '), to('es', 'Tama\xF1o: '), to('fr', 'Taille : '), to('pt', 'Tamanho: '), to('zh', '\u5C3A\u5BF8:')])), to('marketerCampaigns.placementPrefix', mapOf([to('en', 'Placement: '), to('es', 'Ubicaci\xF3n: '), to('fr', 'Placement : '), to('pt', 'Posicionamento: '), to('zh', '\u6295\u653E\u4F4D\u7F6E:')])), to('marketerCampaigns.startedPrefix', mapOf([to('en', 'Starts: '), to('es', 'Comienza: '), to('fr', 'D\xE9bute : '), to('pt', 'In\xEDcio: '), to('zh', '\u5F00\u59CB:')])), to('marketerCampaigns.endsPrefix', mapOf([to('en', 'Ends: '), to('es', 'Termina: '), to('fr', 'Se termine : '), to('pt', 'T\xE9rmino: '), to('zh', '\u7ED3\u675F:')])), to('marketerCampaigns.dailyBudgetPrefix', mapOf([to('en', 'Daily cap: '), to('es', 'L\xEDmite diario: '), to('fr', 'Plafond quotidien : '), to('pt', 'Limite di\xE1rio: '), to('zh', '\u6BCF\u65E5\u4E0A\u9650:')])), to('marketerCampaigns.impressionsLabel', mapOf([to('en', 'Impressions: '), to('es', 'Impresiones: '), to('fr', 'Impressions : '), to('pt', 'Impress\xF5es: '), to('zh', '\u5C55\u793A\u6B21\u6570:')])), to('marketerCampaigns.clicksLabel', mapOf([to('en', 'Clicks: '), to('es', 'Clics: '), to('fr', 'Clics : '), to('pt', 'Cliques: '), to('zh', '\u70B9\u51FB\u6B21\u6570:')])), to('marketerCampaigns.timeDisplayedLabel', mapOf([to('en', 'Time on screen: '), to('es', 'Tiempo en pantalla: '), to('fr', "Temps \xE0 l'\xE9cran : "), to('pt', 'Tempo na tela: '), to('zh', '\u5C4F\u5E55\u5C55\u793A\u65F6\u957F:')])), to('marketerCampaigns.pauseButton', mapOf([to('en', 'Pause'), to('es', 'Pausar'), to('fr', 'Suspendre'), to('pt', 'Pausar'), to('zh', '\u6682\u505C')])), to('marketerCampaigns.resumeButton', mapOf([to('en', 'Resume'), to('es', 'Reanudar'), to('fr', 'Reprendre'), to('pt', 'Retomar'), to('zh', '\u6062\u590D')])), to('marketerCampaigns.topupLabel', mapOf([to('en', 'Top up (USD)'), to('es', 'Recargar (USD)'), to('fr', 'Recharger (USD)'), to('pt', 'Recarregar (USD)'), to('zh', '\u5145\u503C\uFF08\u7F8E\u5143\uFF09')])), to('marketerCampaigns.topupButton', mapOf([to('en', 'Add funds'), to('es', 'Agregar fondos'), to('fr', 'Ajouter des fonds'), to('pt', 'Adicionar fundos'), to('zh', '\u6DFB\u52A0\u8D44\u91D1')])), to('marketerCampaigns.topupAmountError', mapOf([to('en', 'Enter an amount greater than zero.'), to('es', 'Ingresa un monto mayor que cero.'), to('fr', 'Saisissez un montant sup\xE9rieur \xE0 z\xE9ro.'), to('pt', 'Insira um valor maior que zero.'), to('zh', '\u8BF7\u8F93\u5165\u5927\u4E8E\u96F6\u7684\u91D1\u989D\u3002')])), to('marketerBilling.missingCompanyTitle', mapOf([to('en', 'No marketer specified'), to('es', 'No se especific\xF3 un anunciante'), to('fr', 'Aucun annonceur sp\xE9cifi\xE9'), to('pt', 'Nenhum anunciante especificado'), to('zh', '\u672A\u6307\u5B9A\u8425\u9500\u5546')])), to('marketerBilling.missingCompanyBody', mapOf([to('en', 'This page needs a marketer company id in the URL.'), to('es', 'Esta p\xE1gina necesita un id de empresa anunciante en la URL.'), to('fr', "Cette page a besoin d'un identifiant d'entreprise annonceur dans l'URL."), to('pt', 'Esta p\xE1gina precisa de um id de empresa anunciante na URL.'), to('zh', '\u6B64\u9875\u9762\u9700\u8981\u5728\u7F51\u5740\u4E2D\u6307\u5B9A\u8425\u9500\u5546\u516C\u53F8ID\u3002')])), to('marketerBilling.title', mapOf([to('en', 'Billing'), to('es', 'Facturaci\xF3n'), to('fr', 'Facturation'), to('pt', 'Faturamento'), to('zh', '\u8D26\u5355')])), to('marketerBilling.subtitle', mapOf([to('en', "Payment methods used for campaign budgets and subscription renewals. The primary card is tried first; if it's declined, the next one is tried automatically."), to('es', 'M\xE9todos de pago usados para presupuestos de campa\xF1a y renovaciones de suscripci\xF3n. Se intenta primero con la tarjeta principal; si es rechazada, se intenta autom\xE1ticamente con la siguiente.'), to('fr', "Moyens de paiement utilis\xE9s pour les budgets de campagne et les renouvellements d'abonnement. La carte principale est essay\xE9e en premier ; si elle est refus\xE9e, la suivante est essay\xE9e automatiquement."), to('pt', 'Formas de pagamento usadas para or\xE7amentos de campanha e renova\xE7\xF5es de assinatura. O cart\xE3o principal \xE9 tentado primeiro; se for recusado, o pr\xF3ximo \xE9 tentado automaticamente.'), to('zh', '\u7528\u4E8E\u5E7F\u544A\u6D3B\u52A8\u9884\u7B97\u548C\u8BA2\u9605\u7EED\u8D39\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002\u7CFB\u7EDF\u4F1A\u4F18\u5148\u5C1D\u8BD5\u4E3B\u8981\u5361\u7247\uFF1B\u82E5\u88AB\u62D2\u7EDD\uFF0C\u5C06\u81EA\u52A8\u5C1D\u8BD5\u4E0B\u4E00\u5F20\u3002')])), to('marketerBilling.walletHeading', mapOf([to('en', 'Wallet'), to('es', 'Monedero'), to('fr', 'Portefeuille'), to('pt', 'Carteira'), to('zh', '\u94B1\u5305')])), to('marketerBilling.topupCardLabel', mapOf([to('en', 'Card'), to('es', 'Tarjeta'), to('fr', 'Carte'), to('pt', 'Cart\xE3o'), to('zh', '\u5361\u7247')])), to('marketerBilling.topupAmountLabel', mapOf([to('en', 'Amount'), to('es', 'Monto'), to('fr', 'Montant'), to('pt', 'Valor'), to('zh', '\u91D1\u989D')])), to('marketerBilling.topupButton', mapOf([to('en', 'Top up wallet'), to('es', 'Recargar monedero'), to('fr', 'Recharger le portefeuille'), to('pt', 'Recarregar carteira'), to('zh', '\u5145\u503C\u94B1\u5305')])), to('marketerBilling.walletLoadError', mapOf([to('en', 'Could not load your wallet.'), to('es', 'No se pudo cargar tu monedero.'), to('fr', 'Impossible de charger votre portefeuille.'), to('pt', 'N\xE3o foi poss\xEDvel carregar sua carteira.'), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u60A8\u7684\u94B1\u5305\u3002')])), to('marketerBilling.topupNoCardError', mapOf([to('en', 'Add a card before topping up.'), to('es', 'Agrega una tarjeta antes de recargar.'), to('fr', 'Ajoutez une carte avant de recharger.'), to('pt', 'Adicione um cart\xE3o antes de recarregar.'), to('zh', '\u8BF7\u5148\u6DFB\u52A0\u5361\u7247\u518D\u5145\u503C\u3002')])), to('marketerBilling.topupAmountError', mapOf([to('en', 'Enter an amount greater than zero.'), to('es', 'Ingresa un monto mayor que cero.'), to('fr', 'Saisissez un montant sup\xE9rieur \xE0 z\xE9ro.'), to('pt', 'Insira um valor maior que zero.'), to('zh', '\u8BF7\u8F93\u5165\u5927\u4E8E\u96F6\u7684\u91D1\u989D\u3002')])), to('marketerBilling.addButton', mapOf([to('en', 'Add payment method'), to('es', 'Agregar m\xE9todo de pago'), to('fr', 'Ajouter un moyen de paiement'), to('pt', 'Adicionar forma de pagamento'), to('zh', '\u6DFB\u52A0\u4ED8\u6B3E\u65B9\u5F0F')])), to('marketerBilling.methodsHeading', mapOf([to('en', 'Your payment methods'), to('es', 'Tus m\xE9todos de pago'), to('fr', 'Vos moyens de paiement'), to('pt', 'Suas formas de pagamento'), to('zh', '\u60A8\u7684\u4ED8\u6B3E\u65B9\u5F0F')])), to('marketerBilling.addCardHeading', mapOf([to('en', 'Add a card'), to('es', 'Agregar una tarjeta'), to('fr', 'Ajouter une carte'), to('pt', 'Adicionar um cart\xE3o'), to('zh', '\u6DFB\u52A0\u5361\u7247')])), to('marketerBilling.saveCardButton', mapOf([to('en', 'Save card'), to('es', 'Guardar tarjeta'), to('fr', 'Enregistrer la carte'), to('pt', 'Salvar cart\xE3o'), to('zh', '\u4FDD\u5B58\u5361\u7247')])), to('marketerBilling.providersPrefix', mapOf([to('en', 'Registered with: '), to('es', 'Registrada con: '), to('fr', 'Enregistr\xE9e aupr\xE8s de : '), to('pt', 'Registrado com: '), to('zh', '\u5DF2\u6CE8\u518C\u4E8E:')])), to('marketerBilling.noProviderConfiguredError', mapOf([to('en', 'No payment provider is configured yet.'), to('es', 'A\xFAn no hay ning\xFAn proveedor de pago configurado.'), to('fr', "Aucun prestataire de paiement n'est encore configur\xE9."), to('pt', 'Nenhum provedor de pagamento configurado ainda.'), to('zh', '\u5C1A\u672A\u914D\u7F6E\u4EFB\u4F55\u652F\u4ED8\u63D0\u4F9B\u5546\u3002')])), to('marketerBilling.stripeNotLoadedError', mapOf([to('en', 'Payment form did not load \u2014 please retry.'), to('es', 'El formulario de pago no carg\xF3, vuelve a intentarlo.'), to('fr', "Le formulaire de paiement n'a pas pu se charger, veuillez r\xE9essayer."), to('pt', 'O formul\xE1rio de pagamento n\xE3o carregou, tente novamente.'), to('zh', '\u652F\u4ED8\u8868\u5355\u672A\u80FD\u52A0\u8F7D\uFF0C\u8BF7\u91CD\u8BD5\u3002')])), to('marketerBilling.cardSaveError', mapOf([to('en', 'Could not save the card.'), to('es', 'No se pudo guardar la tarjeta.'), to('fr', "Impossible d'enregistrer la carte."), to('pt', 'N\xE3o foi poss\xEDvel salvar o cart\xE3o.'), to('zh', '\u65E0\u6CD5\u4FDD\u5B58\u5361\u7247\u3002')])), to('marketerBilling.noMethodsYet', mapOf([to('en', 'No payment methods yet.'), to('es', 'A\xFAn no hay m\xE9todos de pago.'), to('fr', 'Pas encore de moyen de paiement.'), to('pt', 'Ainda n\xE3o h\xE1 formas de pagamento.'), to('zh', '\u6682\u65E0\u4ED8\u6B3E\u65B9\u5F0F\u3002')])), to('marketerBilling.expiresPrefix', mapOf([to('en', 'Expires: '), to('es', 'Vence: '), to('fr', 'Expire : '), to('pt', 'Expira: '), to('zh', '\u6709\u6548\u671F\u81F3:')])), to('marketerBilling.primaryLabel', mapOf([to('en', 'Primary'), to('es', 'Principal'), to('fr', 'Principale'), to('pt', 'Principal'), to('zh', '\u4E3B\u8981')])), to('marketerBilling.setPrimaryButton', mapOf([to('en', 'Set as primary'), to('es', 'Establecer como principal'), to('fr', 'D\xE9finir comme principale'), to('pt', 'Definir como principal'), to('zh', '\u8BBE\u4E3A\u4E3B\u8981')])), to('marketerBilling.removeButton', mapOf([to('en', 'Remove'), to('es', 'Eliminar'), to('fr', 'Supprimer'), to('pt', 'Remover'), to('zh', '\u79FB\u9664')])), to('marketerBilling.genericErrorPrefix', mapOf([to('en', 'Something went wrong: '), to('es', 'Algo sali\xF3 mal: '), to('fr', 'Une erreur est survenue : '), to('pt', 'Algo deu errado: '), to('zh', '\u51FA\u9519\u4E86:')])), to('adminAdPricing.title', mapOf([to('en', 'Ad pricing'), to('es', 'Precios de anuncios'), to('fr', 'Tarification des annonces'), to('pt', 'Pre\xE7os de an\xFAncios'), to('zh', '\u5E7F\u544A\u5B9A\u4EF7')])), to('adminAdPricing.subtitle', mapOf([to('en', "Cost per impression is the size's base cost plus the placement tier's surcharge, in the country's own currency."), to('es', 'El costo por impresi\xF3n es el costo base del tama\xF1o m\xE1s el recargo del nivel de ubicaci\xF3n, en la moneda propia del pa\xEDs.'), to('fr', 'Le co\xFBt par impression est le co\xFBt de base de la taille plus la majoration du niveau de placement, dans la devise propre du pays.'), to('pt', 'O custo por impress\xE3o \xE9 o custo base do tamanho mais a sobretaxa do n\xEDvel de posicionamento, na moeda pr\xF3pria do pa\xEDs.'), to('zh', '\u6BCF\u6B21\u5C55\u793A\u7684\u8D39\u7528\u4E3A\u8BE5\u5C3A\u5BF8\u7684\u57FA\u7840\u8D39\u7528\u52A0\u4E0A\u6295\u653E\u4F4D\u7F6E\u7B49\u7EA7\u7684\u9644\u52A0\u8D39\uFF0C\u6309\u8BE5\u56FD\u81EA\u8EAB\u8D27\u5E01\u8BA1\u7B97\u3002')])), to('adminAdPricing.sizeRatesHeading', mapOf([to('en', 'Size rates'), to('es', 'Tarifas por tama\xF1o'), to('fr', 'Tarifs par taille'), to('pt', 'Tarifas por tamanho'), to('zh', '\u5C3A\u5BF8\u8D39\u7387')])), to('adminAdPricing.tierSurchargesHeading', mapOf([to('en', 'Tier surcharges'), to('es', 'Recargos por nivel'), to('fr', 'Majorations par niveau'), to('pt', 'Sobretaxas por n\xEDvel'), to('zh', '\u7B49\u7EA7\u9644\u52A0\u8D39')])), to('adminAdPricing.countryLabel', mapOf([to('en', 'Country'), to('es', 'Pa\xEDs'), to('fr', 'Pays'), to('pt', 'Pa\xEDs'), to('zh', '\u56FD\u5BB6')])), to('adminAdPricing.costCentsLabel', mapOf([to('en', 'Cost per impression (cents)'), to('es', 'Costo por impresi\xF3n (centavos)'), to('fr', 'Co\xFBt par impression (centimes)'), to('pt', 'Custo por impress\xE3o (centavos)'), to('zh', '\u6BCF\u6B21\u5C55\u793A\u8D39\u7528\uFF08\u5206\uFF09')])), to('adminAdPricing.surchargeCentsLabel', mapOf([to('en', 'Surcharge (cents)'), to('es', 'Recargo (centavos)'), to('fr', 'Majoration (centimes)'), to('pt', 'Sobretaxa (centavos)'), to('zh', '\u9644\u52A0\u8D39\uFF08\u5206\uFF09')])), to('adminAdPricing.setRateButton', mapOf([to('en', 'Set rate'), to('es', 'Establecer tarifa'), to('fr', 'D\xE9finir le tarif'), to('pt', 'Definir tarifa'), to('zh', '\u8BBE\u7F6E\u8D39\u7387')])), to('adminAdPricing.setSurchargeButton', mapOf([to('en', 'Set surcharge'), to('es', 'Establecer recargo'), to('fr', 'D\xE9finir la majoration'), to('pt', 'Definir sobretaxa'), to('zh', '\u8BBE\u7F6E\u9644\u52A0\u8D39')])), to('adminAdPricing.noRatesYet', mapOf([to('en', 'No size rates configured yet.'), to('es', 'A\xFAn no hay tarifas por tama\xF1o configuradas.'), to('fr', 'Aucun tarif par taille configur\xE9 pour le moment.'), to('pt', 'Nenhuma tarifa por tamanho configurada ainda.'), to('zh', '\u5C1A\u672A\u914D\u7F6E\u4EFB\u4F55\u5C3A\u5BF8\u8D39\u7387\u3002')])), to('adminAdPricing.noSurchargesYet', mapOf([to('en', 'No tier surcharges configured yet.'), to('es', 'A\xFAn no hay recargos por nivel configurados.'), to('fr', 'Aucune majoration par niveau configur\xE9e pour le moment.'), to('pt', 'Nenhuma sobretaxa por n\xEDvel configurada ainda.'), to('zh', '\u5C1A\u672A\u914D\u7F6E\u4EFB\u4F55\u7B49\u7EA7\u9644\u52A0\u8D39\u3002')])), to('adminAdPricing.selectCountryError', mapOf([to('en', 'Choose a country first.'), to('es', 'Elige primero un pa\xEDs.'), to('fr', "Choisissez d'abord un pays."), to('pt', 'Escolha um pa\xEDs primeiro.'), to('zh', '\u8BF7\u5148\u9009\u62E9\u4E00\u4E2A\u56FD\u5BB6\u3002')])), to('adminAdPricing.invalidCostError', mapOf([to('en', 'Enter an amount of zero or more.'), to('es', 'Ingresa un monto de cero o m\xE1s.'), to('fr', 'Saisissez un montant de z\xE9ro ou plus.'), to('pt', 'Insira um valor de zero ou mais.'), to('zh', '\u8BF7\u8F93\u5165\u96F6\u6216\u4EE5\u4E0A\u7684\u91D1\u989D\u3002')])), to('adminAdPricing.genericErrorPrefix', mapOf([to('en', 'Something went wrong: '), to('es', 'Algo sali\xF3 mal: '), to('fr', 'Une erreur est survenue : '), to('pt', 'Algo deu errado: '), to('zh', '\u51FA\u9519\u4E86:')])), to('nav.adPricing', mapOf([to('en', 'Ad pricing'), to('es', 'Precios de anuncios'), to('fr', 'Tarification des annonces'), to('pt', 'Pre\xE7os de an\xFAncios'), to('zh', '\u5E7F\u544A\u5B9A\u4EF7')])), to('companyAnalytics.missingCompanyTitle', mapOf([to('en', 'No company specified'), to('es', 'No se especific\xF3 una empresa'), to('fr', 'Aucune entreprise sp\xE9cifi\xE9e'), to('pt', 'Nenhuma empresa especificada'), to('zh', '\u672A\u6307\u5B9A\u516C\u53F8')])), to('companyAnalytics.missingCompanyBody', mapOf([to('en', 'This page needs a company id in the URL.'), to('es', 'Esta p\xE1gina necesita un id de empresa en la URL.'), to('fr', "Cette page a besoin d'un identifiant d'entreprise dans l'URL."), to('pt', 'Esta p\xE1gina precisa de um id de empresa na URL.'), to('zh', '\u6B64\u9875\u9762\u9700\u8981\u5728\u7F51\u5740\u4E2D\u6307\u5B9A\u516C\u53F8ID\u3002')])), to('companyAnalytics.title', mapOf([to('en', 'Company analytics'), to('es', 'Anal\xEDtica de la empresa'), to('fr', "Analytique de l'entreprise"), to('pt', 'An\xE1lise da empresa'), to('zh', '\u516C\u53F8\u5206\u6790')])), to('companyAnalytics.periodLabel', mapOf([to('en', 'Period'), to('es', 'Periodo'), to('fr', 'P\xE9riode'), to('pt', 'Per\xEDodo'), to('zh', '\u5468\u671F')])), to('companyAnalytics.loadError', mapOf([to('en', 'Could not load analytics'), to('es', 'No se pudo cargar la anal\xEDtica'), to('fr', "Impossible de charger l'analytique"), to('pt', 'N\xE3o foi poss\xEDvel carregar a an\xE1lise'), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u5206\u6790\u6570\u636E')])), to('companyAnalytics.empty', mapOf([to('en', 'No verified activities logged by company members in this period yet.'), to('es', 'A\xFAn no hay actividades verificadas registradas por miembros de la empresa en este periodo.'), to('fr', "Aucune activit\xE9 v\xE9rifi\xE9e enregistr\xE9e par les membres de l'entreprise pour cette p\xE9riode."), to('pt', 'Ainda n\xE3o h\xE1 atividades verificadas registradas por membros da empresa neste per\xEDodo.'), to('zh', '\u6B64\u671F\u95F4\u516C\u53F8\u6210\u5458\u5C1A\u672A\u8BB0\u5F55\u4EFB\u4F55\u5DF2\u9A8C\u8BC1\u7684\u6D3B\u52A8\u3002')])), to('companyAnalytics.totalDistance', mapOf([to('en', 'Total distance'), to('es', 'Distancia total'), to('fr', 'Distance totale'), to('pt', 'Dist\xE2ncia total'), to('zh', '\u603B\u8DDD\u79BB')])), to('companyAnalytics.totalEntries', mapOf([to('en', 'Total activities'), to('es', 'Actividades totales'), to('fr', 'Activit\xE9s totales'), to('pt', 'Atividades totais'), to('zh', '\u6D3B\u52A8\u603B\u6570')])), to('companyAnalytics.activeMembers', mapOf([to('en', 'Active members'), to('es', 'Miembros activos'), to('fr', 'Membres actifs'), to('pt', 'Membros ativos'), to('zh', '\u6D3B\u8DC3\u6210\u5458')])), to('companyAnalytics.byActivityHeading', mapOf([to('en', 'By activity type'), to('es', 'Por tipo de actividad'), to('fr', "Par type d'activit\xE9"), to('pt', 'Por tipo de atividade'), to('zh', '\u6309\u6D3B\u52A8\u7C7B\u578B')])), to('authMethod.title', mapOf([to('en', 'How should this account sign in?'), to('es', '\xBFC\xF3mo deber\xEDa iniciar sesi\xF3n esta cuenta?'), to('fr', 'Comment ce compte doit-il se connecter ?'), to('pt', 'Como esta conta deve entrar?'), to('zh', '\u6B64\u8D26\u6237\u5E94\u5982\u4F55\u767B\u5F55\uFF1F')])), to('authMethod.passkeyLabel', mapOf([to('en', 'Passkey (Face ID / Touch ID / security key) \u2014 recommended, no password needed'), to('es', 'Clave de acceso (Face ID / Touch ID / llave de seguridad) \u2014 recomendado, sin necesidad de contrase\xF1a'), to('fr', "Cl\xE9 d'acc\xE8s (Face ID / Touch ID / cl\xE9 de s\xE9curit\xE9) \u2014 recommand\xE9, aucun mot de passe requis"), to('pt', 'Chave de acesso (Face ID / Touch ID / chave de seguran\xE7a) \u2014 recomendado, sem necessidade de senha'), to('zh', '\u901A\u884C\u5BC6\u94A5\uFF08Face ID / Touch ID / \u5B89\u5168\u5BC6\u94A5\uFF09\u2014 \u63A8\u8350\uFF0C\u65E0\u9700\u5BC6\u7801')])), to('authMethod.passkeyExplainer', mapOf([to('en', "Passkeys use Face ID, Touch ID, or a security key instead of a password. They're the most secure way to sign in: nothing to type, nothing that can be phished, and nothing that leaks in a data breach. Your device proves it's you \u2014 the private key never leaves it."), to('es', 'Las claves de acceso usan Face ID, Touch ID o una llave de seguridad en lugar de una contrase\xF1a. Son la forma m\xE1s segura de iniciar sesi\xF3n: no hay nada que escribir, nada que se pueda suplantar (phishing) y nada que se filtre en una brecha de datos. Tu dispositivo demuestra que eres t\xFA \u2014 la clave privada nunca sale de \xE9l.'), to('fr', "Les cl\xE9s d'acc\xE8s utilisent Face ID, Touch ID ou une cl\xE9 de s\xE9curit\xE9 au lieu d'un mot de passe. C'est le moyen le plus s\xFBr de se connecter : rien \xE0 taper, rien qui puisse \xEAtre hame\xE7onn\xE9, et rien qui puisse fuiter lors d'une violation de donn\xE9es. Votre appareil prouve que c'est bien vous \u2014 la cl\xE9 priv\xE9e ne le quitte jamais."), to('pt', 'As chaves de acesso usam Face ID, Touch ID ou uma chave de seguran\xE7a em vez de uma senha. \xC9 a forma mais segura de entrar: nada para digitar, nada que possa ser phishing e nada que vaze em um vazamento de dados. Seu dispositivo prova que \xE9 voc\xEA \u2014 a chave privada nunca sai dele.'), to('zh', '\u901A\u884C\u5BC6\u94A5\u4F7F\u7528 Face ID\u3001Touch ID \u6216\u5B89\u5168\u5BC6\u94A5\u6765\u4EE3\u66FF\u5BC6\u7801\u3002\u8FD9\u662F\u6700\u5B89\u5168\u7684\u767B\u5F55\u65B9\u5F0F\uFF1A\u65E0\u9700\u8F93\u5165\u4EFB\u4F55\u5185\u5BB9\uFF0C\u65E0\u6CD5\u88AB\u9493\u9C7C\u7A83\u53D6\uFF0C\u4E5F\u4E0D\u4F1A\u5728\u6570\u636E\u6CC4\u9732\u4E2D\u5916\u6CC4\u3002\u60A8\u7684\u8BBE\u5907\u4F1A\u8BC1\u660E\u60A8\u7684\u8EAB\u4EFD\u2014\u2014\u79C1\u94A5\u6C38\u8FDC\u4E0D\u4F1A\u79BB\u5F00\u8BBE\u5907\u3002')])), to('authMethod.passwordLabel', mapOf([to('en', 'Also set up a password'), to('es', 'Tambi\xE9n configurar una contrase\xF1a'), to('fr', 'Configurer \xE9galement un mot de passe'), to('pt', 'Tamb\xE9m configurar uma senha'), to('zh', '\u540C\u65F6\u8BBE\u7F6E\u5BC6\u7801')])), to('authMethod.passwordFieldLabel', mapOf([to('en', 'Password'), to('es', 'Contrase\xF1a'), to('fr', 'Mot de passe'), to('pt', 'Senha'), to('zh', '\u5BC6\u7801')])), to('authMethod.warningChooseOne', mapOf([to('en', 'Choose at least one sign-in method.'), to('es', 'Elige al menos un m\xE9todo de inicio de sesi\xF3n.'), to('fr', 'Choisissez au moins une m\xE9thode de connexion.'), to('pt', 'Escolha pelo menos um m\xE9todo de login.'), to('zh', '\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u79CD\u767B\u5F55\u65B9\u5F0F\u3002')])), to('certificationTypes.title', mapOf([to('en', 'Certifications'), to('es', 'Certificaciones'), to('fr', 'Certifications'), to('pt', 'Certifica\xE7\xF5es'), to('zh', '\u8BA4\u8BC1')])), to('certificationTypes.loading', mapOf([to('en', 'Loading\u2026'), to('es', 'Cargando\u2026'), to('fr', 'Chargement\u2026'), to('pt', 'Carregando\u2026'), to('zh', '\u52A0\u8F7D\u4E2D\u2026')])), to('certificationTypes.authorityNamePlaceholder', mapOf([to('en', 'Name (e.g. PADI)'), to('es', 'Nombre (p. ej. PADI)'), to('fr', 'Nom (ex. PADI)'), to('pt', 'Nome (ex. PADI)'), to('zh', '\u540D\u79F0\uFF08\u4F8B\u5982 PADI\uFF09')])), to('certificationTypes.authorityCountryPlaceholder', mapOf([to('en', 'Country (optional)'), to('es', 'Pa\xEDs (opcional)'), to('fr', 'Pays (facultatif)'), to('pt', 'Pa\xEDs (opcional)'), to('zh', '\u56FD\u5BB6\uFF08\u53EF\u9009\uFF09')])), to('certificationTypes.authorityWebsitePlaceholder', mapOf([to('en', 'Website (optional)'), to('es', 'Sitio web (opcional)'), to('fr', 'Site web (facultatif)'), to('pt', 'Site (opcional)'), to('zh', '\u7F51\u7AD9\uFF08\u53EF\u9009\uFF09')])), to('certificationTypes.addAuthorityButton', mapOf([to('en', 'Add authority'), to('es', 'A\xF1adir entidad'), to('fr', 'Ajouter un organisme'), to('pt', 'Adicionar entidade'), to('zh', '\u6DFB\u52A0\u673A\u6784')])), to('certificationTypes.certificationTypesHeading', mapOf([to('en', 'Certification types'), to('es', 'Tipos de certificaci\xF3n'), to('fr', 'Types de certification'), to('pt', 'Tipos de certifica\xE7\xE3o'), to('zh', '\u8BA4\u8BC1\u7C7B\u578B')])), to('certificationTypes.addCertificationButton', mapOf([to('en', 'Add Certification'), to('es', 'A\xF1adir certificaci\xF3n'), to('fr', 'Ajouter une certification'), to('pt', 'Adicionar certifica\xE7\xE3o'), to('zh', '\u6DFB\u52A0\u8BA4\u8BC1')])), to('certificationTypes.addAuthorityModalHeading', mapOf([to('en', 'Add issuing authority'), to('es', 'A\xF1adir entidad emisora'), to('fr', 'Ajouter un organisme \xE9metteur'), to('pt', 'Adicionar entidade emissora'), to('zh', '\u6DFB\u52A0\u9881\u53D1\u673A\u6784')])), to('certificationTypes.issuingAuthoritySearchPlaceholder', mapOf([to('en', 'Search issuing authorities\u2026'), to('es', 'Buscar entidades emisoras\u2026'), to('fr', 'Rechercher des organismes \xE9metteurs\u2026'), to('pt', 'Pesquisar entidades emissoras\u2026'), to('zh', '\u641C\u7D22\u9881\u53D1\u673A\u6784\u2026')])), to('certificationTypes.unknownAuthorityError', mapOf([to('en', 'Select an issuing authority from the list.'), to('es', 'Selecciona una entidad emisora de la lista.'), to('fr', 'S\xE9lectionnez un organisme \xE9metteur dans la liste.'), to('pt', 'Selecione uma entidade emissora da lista.'), to('zh', '\u8BF7\u4ECE\u5217\u8868\u4E2D\u9009\u62E9\u4E00\u4E2A\u9881\u53D1\u673A\u6784\u3002')])), to('certificationTypes.newCertificationHeading', mapOf([to('en', 'New certification'), to('es', 'Nueva certificaci\xF3n'), to('fr', 'Nouvelle certification'), to('pt', 'Nova certifica\xE7\xE3o'), to('zh', '\u65B0\u8BA4\u8BC1')])), to('certificationTypes.issuingAuthorityLabel', mapOf([to('en', 'Issuing authority'), to('es', 'Entidad emisora'), to('fr', 'Organisme \xE9metteur'), to('pt', 'Entidade emissora'), to('zh', '\u9881\u53D1\u673A\u6784')])), to('certificationTypes.nameLabel', mapOf([to('en', 'Name'), to('es', 'Nombre'), to('fr', 'Nom'), to('pt', 'Nome'), to('zh', '\u540D\u79F0')])), to('certificationTypes.validatedActivitiesHeading', mapOf([to('en', 'Validated activities'), to('es', 'Actividades validadas'), to('fr', 'Activit\xE9s valid\xE9es'), to('pt', 'Atividades validadas'), to('zh', '\u5DF2\u9A8C\u8BC1\u7684\u6D3B\u52A8')])), to('certificationTypes.validatedActivitiesHelp', mapOf([to('en', 'Which activities holding this certification entitles the holder to verify others for \u2014 required.'), to('es', 'Qu\xE9 actividades le otorgan al titular de esta certificaci\xF3n el derecho a verificar a otros \u2014 obligatorio.'), to('fr', "Les activit\xE9s pour lesquelles le titulaire de cette certification est autoris\xE9 \xE0 v\xE9rifier d'autres personnes \u2014 obligatoire."), to('pt', 'Quais atividades esta certifica\xE7\xE3o autoriza o titular a verificar outras pessoas \u2014 obrigat\xF3rio.'), to('zh', '\u6301\u6709\u6B64\u8BA4\u8BC1\u53EF\u5BF9\u54EA\u4E9B\u6D3B\u52A8\u7684\u5176\u4ED6\u4EBA\u8FDB\u884C\u9A8C\u8BC1\u2014\u2014\u5FC5\u586B\u3002')])), to('certificationTypes.saveCertificationButton', mapOf([to('en', 'Save certification'), to('es', 'Guardar certificaci\xF3n'), to('fr', 'Enregistrer la certification'), to('pt', 'Salvar certifica\xE7\xE3o'), to('zh', '\u4FDD\u5B58\u8BA4\u8BC1')])), to('certificationTypes.cancelButton', mapOf([to('en', 'Cancel'), to('es', 'Cancelar'), to('fr', 'Annuler'), to('pt', 'Cancelar'), to('zh', '\u53D6\u6D88')])), to('certificationTypes.loadAuthoritiesErrorPrefix', mapOf([to('en', 'Could not load authorities: '), to('es', 'No se pudieron cargar las entidades: '), to('fr', 'Impossible de charger les organismes : '), to('pt', 'N\xE3o foi poss\xEDvel carregar as entidades: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u673A\u6784\uFF1A')])), to('certificationTypes.authorityAddedStatus', mapOf([to('en', 'Added.'), to('es', 'A\xF1adida.'), to('fr', 'Ajout\xE9.'), to('pt', 'Adicionada.'), to('zh', '\u5DF2\u6DFB\u52A0\u3002')])), to('certificationTypes.loadCertificationsErrorPrefix', mapOf([to('en', 'Could not load certifications: '), to('es', 'No se pudieron cargar las certificaciones: '), to('fr', 'Impossible de charger les certifications : '), to('pt', 'N\xE3o foi poss\xEDvel carregar as certifica\xE7\xF5es: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u8BA4\u8BC1\uFF1A')])), to('certificationTypes.noCertificationsYet', mapOf([to('en', 'No certifications yet \u2014 create one above.'), to('es', 'A\xFAn no hay certificaciones \u2014 crea una arriba.'), to('fr', "Aucune certification pour l'instant \u2014 cr\xE9ez-en une ci-dessus."), to('pt', 'Ainda n\xE3o h\xE1 certifica\xE7\xF5es \u2014 crie uma acima.'), to('zh', '\u5C1A\u65E0\u8BA4\u8BC1\u2014\u2014\u8BF7\u5728\u4E0A\u65B9\u521B\u5EFA\u3002')])), to('certificationTypes.editButton', mapOf([to('en', 'Edit'), to('es', 'Editar'), to('fr', 'Modifier'), to('pt', 'Editar'), to('zh', '\u7F16\u8F91')])), to('certificationTypes.removeButton', mapOf([to('en', 'Remove'), to('es', 'Quitar'), to('fr', 'Retirer'), to('pt', 'Remover'), to('zh', '\u79FB\u9664')])), to('certificationTypes.removeErrorPrefix', mapOf([to('en', 'Could not remove: '), to('es', 'No se pudo quitar: '), to('fr', 'Impossible de retirer : '), to('pt', 'N\xE3o foi poss\xEDvel remover: '), to('zh', '\u65E0\u6CD5\u79FB\u9664\uFF1A')])), to('certificationTypes.editCertificationPrefix', mapOf([to('en', 'Edit '), to('es', 'Editar '), to('fr', 'Modifier '), to('pt', 'Editar '), to('zh', '\u7F16\u8F91')])), to('certificationTypes.selectAtLeastOneActivityError', mapOf([to('en', 'Select at least one activity this certification validates.'), to('es', 'Selecciona al menos una actividad que valide esta certificaci\xF3n.'), to('fr', 'S\xE9lectionnez au moins une activit\xE9 que cette certification valide.'), to('pt', 'Selecione pelo menos uma atividade que esta certifica\xE7\xE3o valida.'), to('zh', '\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u9879\u6B64\u8BA4\u8BC1\u9A8C\u8BC1\u7684\u6D3B\u52A8\u3002')])), to('certificationTypes.certificationCreatedStatus', mapOf([to('en', 'Certification created.'), to('es', 'Certificaci\xF3n creada.'), to('fr', 'Certification cr\xE9\xE9e.'), to('pt', 'Certifica\xE7\xE3o criada.'), to('zh', '\u8BA4\u8BC1\u5DF2\u521B\u5EFA\u3002')])), to('certificationTypes.certificationUpdatedStatus', mapOf([to('en', 'Certification updated.'), to('es', 'Certificaci\xF3n actualizada.'), to('fr', 'Certification mise \xE0 jour.'), to('pt', 'Certifica\xE7\xE3o atualizada.'), to('zh', '\u8BA4\u8BC1\u5DF2\u66F4\u65B0\u3002')])), to('certificationTypes.nameColumn', mapOf([to('en', 'Name'), to('es', 'Nombre'), to('fr', 'Nom'), to('pt', 'Nome'), to('zh', '\u540D\u79F0')])), to('certificationTypes.issuingAuthorityColumn', mapOf([to('en', 'Issuing authority'), to('es', 'Entidad emisora'), to('fr', 'Organisme \xE9metteur'), to('pt', 'Entidade emissora'), to('zh', '\u9881\u53D1\u673A\u6784')])), to('certificationTypes.validatesColumn', mapOf([to('en', 'Validates'), to('es', 'Valida'), to('fr', 'Valide'), to('pt', 'Valida'), to('zh', '\u9A8C\u8BC1')])), to('certificationTypes.actionsColumn', mapOf([to('en', 'Actions'), to('es', 'Acciones'), to('fr', 'Actions'), to('pt', 'A\xE7\xF5es'), to('zh', '\u64CD\u4F5C')])), to('certificationTypes.searchPlaceholder', mapOf([to('en', 'Search by name or authority\u2026'), to('es', 'Buscar por nombre o entidad\u2026'), to('fr', 'Rechercher par nom ou organisme\u2026'), to('pt', 'Buscar por nome ou entidade\u2026'), to('zh', '\u6309\u540D\u79F0\u6216\u673A\u6784\u641C\u7D22\u2026')])), to('certificationTypes.filterButton', mapOf([to('en', 'Filter'), to('es', 'Filtrar'), to('fr', 'Filtrer'), to('pt', 'Filtrar'), to('zh', '\u7B5B\u9009')])), to('certificationTypes.noMatchingCertifications', mapOf([to('en', 'No certifications match your filters.'), to('es', 'Ninguna certificaci\xF3n coincide con los filtros.'), to('fr', 'Aucune certification ne correspond aux filtres.'), to('pt', 'Nenhuma certifica\xE7\xE3o corresponde aos filtros.'), to('zh', '\u6CA1\u6709\u7B26\u5408\u7B5B\u9009\u6761\u4EF6\u7684\u8BA4\u8BC1\u3002')])), to('certificationTypes.showInactiveLabel', mapOf([to('en', 'Show inactive'), to('es', 'Mostrar inactivas'), to('fr', 'Afficher les inactifs'), to('pt', 'Mostrar inativas'), to('zh', '\u663E\u793A\u672A\u6FC0\u6D3B')])), to('certificationTypes.activeLabel', mapOf([to('en', 'Active'), to('es', 'Activa'), to('fr', 'Actif'), to('pt', 'Ativa'), to('zh', '\u5DF2\u542F\u7528')])), to('certificationTypes.inactiveBadge', mapOf([to('en', 'Inactive'), to('es', 'Inactiva'), to('fr', 'Inactif'), to('pt', 'Inativa'), to('zh', '\u672A\u6FC0\u6D3B')])), to('certificationTypes.deleteConfirmPrefix', mapOf([to('en', 'Delete '), to('es', 'Eliminar '), to('fr', 'Supprimer '), to('pt', 'Excluir '), to('zh', '\u5220\u9664')])), to('certificationTypes.deleteConfirmSuffix', mapOf([to('en', '? It will be deactivated but can be reactivated later.'), to('es', '? Se desactivar\xE1, pero puede reactivarse m\xE1s tarde.'), to('fr', ' ? Elle sera d\xE9sactiv\xE9e mais pourra \xEAtre r\xE9activ\xE9e plus tard.'), to('pt', '? Ser\xE1 desativada, mas pode ser reativada mais tarde.'), to('zh', '\uFF1F\u5B83\u5C06\u88AB\u505C\u7528\uFF0C\u4F46\u4E4B\u540E\u53EF\u4EE5\u91CD\u65B0\u6FC0\u6D3B\u3002')])), to('issuingAuthorities.title', mapOf([to('en', 'Issuing authorities'), to('es', 'Entidades emisoras'), to('fr', 'Organismes \xE9metteurs'), to('pt', 'Entidades emissoras'), to('zh', '\u9881\u53D1\u673A\u6784')])), to('issuingAuthorities.subtitle', mapOf([to('en', 'Every issuing authority certification types can be attributed to.'), to('es', 'Todas las entidades emisoras a las que se pueden atribuir los tipos de certificaci\xF3n.'), to('fr', 'Tous les organismes \xE9metteurs auxquels les types de certification peuvent \xEAtre attribu\xE9s.'), to('pt', 'Todas as entidades emissoras \xE0s quais os tipos de certifica\xE7\xE3o podem ser atribu\xEDdos.'), to('zh', '\u6240\u6709\u53EF\u5F52\u5C5E\u8BA4\u8BC1\u7C7B\u578B\u7684\u9881\u53D1\u673A\u6784\u3002')])), to('issuingAuthorities.loading', mapOf([to('en', 'Loading\u2026'), to('es', 'Cargando\u2026'), to('fr', 'Chargement\u2026'), to('pt', 'Carregando\u2026'), to('zh', '\u52A0\u8F7D\u4E2D\u2026')])), to('issuingAuthorities.loadErrorPrefix', mapOf([to('en', 'Could not load authorities: '), to('es', 'No se pudieron cargar las entidades: '), to('fr', 'Impossible de charger les organismes : '), to('pt', 'N\xE3o foi poss\xEDvel carregar as entidades: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u673A\u6784\uFF1A')])), to('issuingAuthorities.noAuthoritiesYet', mapOf([to('en', 'No issuing authorities yet \u2014 add one above.'), to('es', 'A\xFAn no hay entidades emisoras \u2014 a\xF1ade una arriba.'), to('fr', "Aucun organisme \xE9metteur pour l'instant \u2014 ajoutez-en un ci-dessus."), to('pt', 'Ainda n\xE3o h\xE1 entidades emissoras \u2014 adicione uma acima.'), to('zh', '\u5C1A\u65E0\u9881\u53D1\u673A\u6784\u2014\u2014\u8BF7\u5728\u4E0A\u65B9\u6DFB\u52A0\u3002')])), to('issuingAuthorities.addButton', mapOf([to('en', 'Add authority'), to('es', 'A\xF1adir entidad'), to('fr', 'Ajouter un organisme'), to('pt', 'Adicionar entidade'), to('zh', '\u6DFB\u52A0\u673A\u6784')])), to('issuingAuthorities.editButton', mapOf([to('en', 'Edit'), to('es', 'Editar'), to('fr', 'Modifier'), to('pt', 'Editar'), to('zh', '\u7F16\u8F91')])), to('issuingAuthorities.removeButton', mapOf([to('en', 'Remove'), to('es', 'Quitar'), to('fr', 'Retirer'), to('pt', 'Remover'), to('zh', '\u79FB\u9664')])), to('issuingAuthorities.removeErrorPrefix', mapOf([to('en', 'Could not remove: '), to('es', 'No se pudo quitar: '), to('fr', 'Impossible de retirer : '), to('pt', 'N\xE3o foi poss\xEDvel remover: '), to('zh', '\u65E0\u6CD5\u79FB\u9664\uFF1A')])), to('issuingAuthorities.newAuthorityHeading', mapOf([to('en', 'Add issuing authority'), to('es', 'A\xF1adir entidad emisora'), to('fr', 'Ajouter un organisme \xE9metteur'), to('pt', 'Adicionar entidade emissora'), to('zh', '\u6DFB\u52A0\u9881\u53D1\u673A\u6784')])), to('issuingAuthorities.editAuthorityPrefix', mapOf([to('en', 'Edit '), to('es', 'Editar '), to('fr', 'Modifier '), to('pt', 'Editar '), to('zh', '\u7F16\u8F91')])), to('issuingAuthorities.namePlaceholder', mapOf([to('en', 'Name (e.g. PADI)'), to('es', 'Nombre (p. ej. PADI)'), to('fr', 'Nom (ex. PADI)'), to('pt', 'Nome (ex. PADI)'), to('zh', '\u540D\u79F0\uFF08\u4F8B\u5982 PADI\uFF09')])), to('issuingAuthorities.countryPlaceholder', mapOf([to('en', 'Country (optional)'), to('es', 'Pa\xEDs (opcional)'), to('fr', 'Pays (facultatif)'), to('pt', 'Pa\xEDs (opcional)'), to('zh', '\u56FD\u5BB6\uFF08\u53EF\u9009\uFF09')])), to('issuingAuthorities.websitePlaceholder', mapOf([to('en', 'Website (optional)'), to('es', 'Sitio web (opcional)'), to('fr', 'Site web (facultatif)'), to('pt', 'Site (opcional)'), to('zh', '\u7F51\u7AD9\uFF08\u53EF\u9009\uFF09')])), to('issuingAuthorities.cancelButton', mapOf([to('en', 'Cancel'), to('es', 'Cancelar'), to('fr', 'Annuler'), to('pt', 'Cancelar'), to('zh', '\u53D6\u6D88')])), to('issuingAuthorities.saveButton', mapOf([to('en', 'Save'), to('es', 'Guardar'), to('fr', 'Enregistrer'), to('pt', 'Salvar'), to('zh', '\u4FDD\u5B58')])), to('issuingAuthorities.authorityAddedStatus', mapOf([to('en', 'Added.'), to('es', 'A\xF1adida.'), to('fr', 'Ajout\xE9.'), to('pt', 'Adicionada.'), to('zh', '\u5DF2\u6DFB\u52A0\u3002')])), to('issuingAuthorities.authorityUpdatedStatus', mapOf([to('en', 'Updated.'), to('es', 'Actualizada.'), to('fr', 'Mis \xE0 jour.'), to('pt', 'Atualizada.'), to('zh', '\u5DF2\u66F4\u65B0\u3002')])), to('issuingAuthorities.nameColumn', mapOf([to('en', 'Name'), to('es', 'Nombre'), to('fr', 'Nom'), to('pt', 'Nome'), to('zh', '\u540D\u79F0')])), to('issuingAuthorities.countryColumn', mapOf([to('en', 'Country'), to('es', 'Pa\xEDs'), to('fr', 'Pays'), to('pt', 'Pa\xEDs'), to('zh', '\u56FD\u5BB6')])), to('issuingAuthorities.websiteColumn', mapOf([to('en', 'Website'), to('es', 'Sitio web'), to('fr', 'Site web'), to('pt', 'Site'), to('zh', '\u7F51\u7AD9')])), to('issuingAuthorities.actionsColumn', mapOf([to('en', 'Actions'), to('es', 'Acciones'), to('fr', 'Actions'), to('pt', 'A\xE7\xF5es'), to('zh', '\u64CD\u4F5C')])), to('issuingAuthorities.searchPlaceholder', mapOf([to('en', 'Search by name\u2026'), to('es', 'Buscar por nombre\u2026'), to('fr', 'Rechercher par nom\u2026'), to('pt', 'Buscar por nome\u2026'), to('zh', '\u6309\u540D\u79F0\u641C\u7D22\u2026')])), to('issuingAuthorities.allCountriesPlaceholder', mapOf([to('en', 'All countries'), to('es', 'Todos los pa\xEDses'), to('fr', 'Tous les pays'), to('pt', 'Todos os pa\xEDses'), to('zh', '\u6240\u6709\u56FD\u5BB6')])), to('issuingAuthorities.filterButton', mapOf([to('en', 'Filter'), to('es', 'Filtrar'), to('fr', 'Filtrer'), to('pt', 'Filtrar'), to('zh', '\u7B5B\u9009')])), to('issuingAuthorities.noMatchingAuthorities', mapOf([to('en', 'No authorities match your filters.'), to('es', 'Ninguna entidad coincide con los filtros.'), to('fr', 'Aucun organisme ne correspond aux filtres.'), to('pt', 'Nenhuma entidade corresponde aos filtros.'), to('zh', '\u6CA1\u6709\u7B26\u5408\u7B5B\u9009\u6761\u4EF6\u7684\u673A\u6784\u3002')])), to('issuingAuthorities.showInactiveLabel', mapOf([to('en', 'Show inactive'), to('es', 'Mostrar inactivas'), to('fr', 'Afficher les inactifs'), to('pt', 'Mostrar inativas'), to('zh', '\u663E\u793A\u672A\u6FC0\u6D3B')])), to('issuingAuthorities.activeLabel', mapOf([to('en', 'Active'), to('es', 'Activa'), to('fr', 'Actif'), to('pt', 'Ativa'), to('zh', '\u5DF2\u542F\u7528')])), to('issuingAuthorities.inactiveBadge', mapOf([to('en', 'Inactive'), to('es', 'Inactiva'), to('fr', 'Inactif'), to('pt', 'Inativa'), to('zh', '\u672A\u6FC0\u6D3B')])), to('issuingAuthorities.deleteConfirmPrefix', mapOf([to('en', 'Delete '), to('es', 'Eliminar '), to('fr', 'Supprimer '), to('pt', 'Excluir '), to('zh', '\u5220\u9664')])), to('issuingAuthorities.deleteConfirmSuffix', mapOf([to('en', '? It will be deactivated but can be reactivated later.'), to('es', '? Se desactivar\xE1, pero puede reactivarse m\xE1s tarde.'), to('fr', ' ? Il sera d\xE9sactiv\xE9 mais pourra \xEAtre r\xE9activ\xE9 plus tard.'), to('pt', '? Ser\xE1 desativada, mas pode ser reativada mais tarde.'), to('zh', '\uFF1F\u5B83\u5C06\u88AB\u505C\u7528\uFF0C\u4F46\u4E4B\u540E\u53EF\u4EE5\u91CD\u65B0\u6FC0\u6D3B\u3002')])), to('certVisibilityRequests.title', mapOf([to('en', 'Certification visibility requests'), to('es', 'Solicitudes de visibilidad de certificaciones'), to('fr', 'Demandes de visibilit\xE9 des certifications'), to('pt', 'Solicita\xE7\xF5es de visibilidade de certifica\xE7\xF5es'), to('zh', '\u8BA4\u8BC1\u53EF\u89C1\u6027\u8BF7\u6C42')])), to('certVisibilityRequests.description', mapOf([to('en', "Activity centers that ask to view your certifications appear here. Requests you don't answer expire after 12 hours; approving one lets that center view your certifications for the requested activity for the next 12 hours."), to('es', 'Aqu\xED aparecen los centros de actividad que solicitan ver tus certificaciones. Las solicitudes que no respondas caducan despu\xE9s de 12 horas; aprobar una permite que ese centro vea tus certificaciones para la actividad solicitada durante las siguientes 12 horas.'), to('fr', "Les centres d'activit\xE9 qui demandent \xE0 consulter vos certifications apparaissent ici. Les demandes auxquelles vous ne r\xE9pondez pas expirent au bout de 12 heures ; en approuver une permet \xE0 ce centre de consulter vos certifications pour l'activit\xE9 demand\xE9e pendant les 12 heures suivantes."), to('pt', 'Os centros de atividade que solicitam ver suas certifica\xE7\xF5es aparecem aqui. As solicita\xE7\xF5es que voc\xEA n\xE3o responder expiram ap\xF3s 12 horas; aprovar uma permite que esse centro veja suas certifica\xE7\xF5es para a atividade solicitada pelas pr\xF3ximas 12 horas.'), to('zh', '\u5728\u6B64\u663E\u793A\u8BF7\u6C42\u67E5\u770B\u60A8\u8BA4\u8BC1\u4FE1\u606F\u7684\u6D3B\u52A8\u4E2D\u5FC3\u3002\u672A\u56DE\u5E94\u7684\u8BF7\u6C42\u5C06\u572812\u5C0F\u65F6\u540E\u8FC7\u671F\uFF1B\u6279\u51C6\u540E\uFF0C\u8BE5\u4E2D\u5FC3\u53EF\u5728\u63A5\u4E0B\u6765\u768412\u5C0F\u65F6\u5185\u67E5\u770B\u60A8\u5728\u6240\u7533\u8BF7\u6D3B\u52A8\u9879\u76EE\u4E0A\u7684\u8BA4\u8BC1\u4FE1\u606F\u3002')])), to('certVisibilityRequests.loading', mapOf([to('en', 'Loading\u2026'), to('es', 'Cargando\u2026'), to('fr', 'Chargement\u2026'), to('pt', 'Carregando\u2026'), to('zh', '\u52A0\u8F7D\u4E2D\u2026')])), to('certVisibilityRequests.loadError', mapOf([to('en', 'Could not load visibility requests:'), to('es', 'No se pudieron cargar las solicitudes de visibilidad:'), to('fr', 'Impossible de charger les demandes de visibilit\xE9 :'), to('pt', 'N\xE3o foi poss\xEDvel carregar as solicita\xE7\xF5es de visibilidade:'), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u53EF\u89C1\u6027\u8BF7\u6C42\uFF1A')])), to('certVisibilityRequests.noPendingRequests', mapOf([to('en', 'No pending requests right now.'), to('es', 'No hay solicitudes pendientes en este momento.'), to('fr', 'Aucune demande en attente pour le moment.'), to('pt', 'Nenhuma solicita\xE7\xE3o pendente no momento.'), to('zh', '\u76EE\u524D\u6CA1\u6709\u5F85\u5904\u7406\u7684\u8BF7\u6C42\u3002')])), to('certVisibilityRequests.respondBy', mapOf([to('en', 'Respond by:'), to('es', 'Responder antes de:'), to('fr', 'R\xE9pondre avant le :'), to('pt', 'Responder at\xE9:'), to('zh', '\u56DE\u5E94\u622A\u6B62\uFF1A')])), to('certVisibilityRequests.approveButton', mapOf([to('en', 'Approve'), to('es', 'Aprobar'), to('fr', 'Approuver'), to('pt', 'Aprovar'), to('zh', '\u6279\u51C6')])), to('certVisibilityRequests.rejectButton', mapOf([to('en', 'Reject'), to('es', 'Rechazar'), to('fr', 'Refuser'), to('pt', 'Rejeitar'), to('zh', '\u62D2\u7EDD')])), to('companyActivityLog.missingCompanyTitle', mapOf([to('en', 'Missing company'), to('es', 'Falta el centro'), to('fr', 'Centre manquant'), to('pt', 'Empresa n\xE3o informada'), to('zh', '\u7F3A\u5C11\u4E2D\u5FC3\u4FE1\u606F')])), to('companyActivityLog.missingCompanyBody', mapOf([to('en', 'No company was specified.'), to('es', 'No se especific\xF3 ning\xFAn centro.'), to('fr', "Aucun centre n'a \xE9t\xE9 sp\xE9cifi\xE9."), to('pt', 'Nenhuma empresa foi especificada.'), to('zh', '\u672A\u6307\u5B9A\u4EFB\u4F55\u4E2D\u5FC3\u3002')])), to('companyActivityLog.title', mapOf([to('en', "This center's activity log"), to('es', 'Registro de actividades de este centro'), to('fr', "Journal d'activit\xE9s de ce centre"), to('pt', 'Registro de atividades deste centro'), to('zh', '\u8BE5\u4E2D\u5FC3\u7684\u6D3B\u52A8\u65E5\u5FD7')])), to('companyActivityLog.activityLabel', mapOf([to('en', 'Activity'), to('es', 'Actividad'), to('fr', 'Activit\xE9'), to('pt', 'Atividade'), to('zh', '\u6D3B\u52A8')])), to('companyActivityLog.allActivitiesOption', mapOf([to('en', 'All activities'), to('es', 'Todas las actividades'), to('fr', 'Toutes les activit\xE9s'), to('pt', 'Todas as atividades'), to('zh', '\u6240\u6709\u6D3B\u52A8')])), to('companyActivityLog.fromLabel', mapOf([to('en', 'From'), to('es', 'Desde'), to('fr', 'Du'), to('pt', 'De'), to('zh', '\u8D77\u59CB\u65E5\u671F')])), to('companyActivityLog.toLabel', mapOf([to('en', 'To'), to('es', 'Hasta'), to('fr', 'Au'), to('pt', 'At\xE9'), to('zh', '\u7ED3\u675F\u65E5\u671F')])), to('companyActivityLog.filterButton', mapOf([to('en', 'Filter'), to('es', 'Filtrar'), to('fr', 'Filtrer'), to('pt', 'Filtrar'), to('zh', '\u7B5B\u9009')])), to('companyActivityLog.dateRangeInvalidError', mapOf([to('en', "The 'from' date must be on or before the 'to' date."), to('es', "La fecha 'desde' debe ser anterior o igual a la fecha 'hasta'."), to('fr', 'La date \xAB du \xBB doit \xEAtre ant\xE9rieure ou \xE9gale \xE0 la date \xAB au \xBB.'), to('pt', "A data 'de' deve ser anterior ou igual \xE0 data 'at\xE9'."), to('zh', '\u201C\u8D77\u59CB\u201D\u65E5\u671F\u5FC5\u987B\u65E9\u4E8E\u6216\u7B49\u4E8E\u201C\u622A\u6B62\u201D\u65E5\u671F\u3002')])), to('companyActivityLog.loading', mapOf([to('en', 'Loading\u2026'), to('es', 'Cargando\u2026'), to('fr', 'Chargement\u2026'), to('pt', 'Carregando\u2026'), to('zh', '\u52A0\u8F7D\u4E2D\u2026')])), to('companyActivityLog.loadError', mapOf([to('en', "Could not load this center's activity log:"), to('es', 'No se pudo cargar el registro de actividades de este centro:'), to('fr', "Impossible de charger le journal d'activit\xE9s de ce centre :"), to('pt', 'N\xE3o foi poss\xEDvel carregar o registro de atividades deste centro:'), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u8BE5\u4E2D\u5FC3\u7684\u6D3B\u52A8\u65E5\u5FD7\uFF1A')])), to('companyActivityLog.noActivitiesForFilter', mapOf([to('en', 'No activities logged for this filter.'), to('es', 'No hay actividades registradas para este filtro.'), to('fr', 'Aucune activit\xE9 enregistr\xE9e pour ce filtre.'), to('pt', 'Nenhuma atividade registrada para este filtro.'), to('zh', '\u6CA1\u6709\u7B26\u5408\u8BE5\u7B5B\u9009\u6761\u4EF6\u7684\u6D3B\u52A8\u8BB0\u5F55\u3002')])), to('companyActivityLog.loggedAtLabel', mapOf([to('en', 'Logged at:'), to('es', 'Registrado el:'), to('fr', 'Enregistr\xE9 le :'), to('pt', 'Registrado em:'), to('zh', '\u8BB0\u5F55\u65F6\u95F4\uFF1A')])), to('companyActivityLog.walkInGuestLabel', mapOf([to('en', 'Walk-in guest:'), to('es', 'Invitado sin cuenta:'), to('fr', 'Invit\xE9 sans compte :'), to('pt', 'Convidado sem cadastro:'), to('zh', '\u4E34\u65F6\u8BBF\u5BA2\uFF1A')])), to('companyActivityLog.unknownGuestName', mapOf([to('en', 'unknown'), to('es', 'desconocido'), to('fr', 'inconnu'), to('pt', 'desconhecido'), to('zh', '\u672A\u77E5')])), to('companyActivityLog.noEmailFallback', mapOf([to('en', 'no email'), to('es', 'sin correo electr\xF3nico'), to('fr', 'aucun e-mail'), to('pt', 'sem e-mail'), to('zh', '\u65E0\u7535\u5B50\u90AE\u7BB1')])), to('companyActivityLog.notesLabel', mapOf([to('en', 'Notes:'), to('es', 'Notas:'), to('fr', 'Notes :'), to('pt', 'Notas:'), to('zh', '\u5907\u6CE8\uFF1A')])), to('companyActivityLog.inviteLabel', mapOf([to('en', 'Invite a user to claim this entry'), to('es', 'Invitar a un usuario a reclamar esta entrada'), to('fr', 'Inviter un utilisateur \xE0 revendiquer cette entr\xE9e'), to('pt', 'Convidar um usu\xE1rio para reivindicar este registro'), to('zh', '\u9080\u8BF7\u7528\u6237\u8BA4\u9886\u6B64\u8BB0\u5F55')])), to('companyActivityLog.sendInviteButton', mapOf([to('en', 'Send invite'), to('es', 'Enviar invitaci\xF3n'), to('fr', "Envoyer l'invitation"), to('pt', 'Enviar convite'), to('zh', '\u53D1\u9001\u9080\u8BF7')])), to('companyActivityLog.inviteSentPrefix', mapOf([to('en', 'Invite sent to'), to('es', 'Invitaci\xF3n enviada a'), to('fr', 'Invitation envoy\xE9e \xE0'), to('pt', 'Convite enviado para'), to('zh', '\u9080\u8BF7\u5DF2\u53D1\u9001\u81F3')])), to('companyActivityLog.noAccountPrefix', mapOf([to('en', 'No account found for'), to('es', 'No se encontr\xF3 ninguna cuenta para'), to('fr', 'Aucun compte trouv\xE9 pour'), to('pt', 'Nenhuma conta encontrada para'), to('zh', '\u672A\u627E\u5230\u8BE5\u90AE\u7BB1\u5BF9\u5E94\u7684\u8D26\u6237\uFF1A')])), to('companyActivityLog.noAccountSuffix', mapOf([to('en', "yet \u2014 they'll need to register first."), to('es', 'todav\xEDa \u2014 deber\xE1n registrarse primero.'), to('fr', "pour le moment \u2014 cette personne devra d'abord s'inscrire."), to('pt', 'ainda \u2014 a pessoa precisar\xE1 se cadastrar primeiro.'), to('zh', '\uFF0C\u5BF9\u65B9\u9700\u8981\u5148\u6CE8\u518C\u3002')])), to('companyActivityLog.duplicatePendingPrefix', mapOf([to('en', 'An invite is already pending for'), to('es', 'Ya hay una invitaci\xF3n pendiente para'), to('fr', 'Une invitation est d\xE9j\xE0 en attente pour'), to('pt', 'J\xE1 existe um convite pendente para'), to('zh', '\u5DF2\u6709\u4E00\u4E2A\u5F85\u5904\u7406\u7684\u9080\u8BF7\u53D1\u7ED9')])), to('logActivity.title', mapOf([to('en', 'Log an activity'), to('es', 'Registrar una actividad'), to('fr', 'Enregistrer une activit\xE9'), to('pt', 'Registrar uma atividade'), to('zh', '\u8BB0\u5F55\u4E00\u9879\u6D3B\u52A8')])), to('logActivity.activityTypeLabel', mapOf([to('en', 'Activity type'), to('es', 'Tipo de actividad'), to('fr', "Type d'activit\xE9"), to('pt', 'Tipo de atividade'), to('zh', '\u6D3B\u52A8\u7C7B\u578B')])), to('logActivity.selectActivityTypePlaceholder', mapOf([to('en', 'Select an activity\u2026'), to('es', 'Selecciona una actividad\u2026'), to('fr', 'S\xE9lectionnez une activit\xE9\u2026'), to('pt', 'Selecione uma atividade\u2026'), to('zh', '\u9009\u62E9\u4E00\u9879\u6D3B\u52A8\u2026')])), to('logActivity.selectOptionPlaceholder', mapOf([to('en', 'Select\u2026'), to('es', 'Selecciona\u2026'), to('fr', 'S\xE9lectionnez\u2026'), to('pt', 'Selecione\u2026'), to('zh', '\u8BF7\u9009\u62E9\u2026')])), to('logActivity.selectActivityTypeError', mapOf([to('en', 'Please select an activity type.'), to('es', 'Selecciona un tipo de actividad.'), to('fr', "Veuillez s\xE9lectionner un type d'activit\xE9."), to('pt', 'Selecione um tipo de atividade.'), to('zh', '\u8BF7\u9009\u62E9\u6D3B\u52A8\u7C7B\u578B\u3002')])), to('logActivity.loggedAtRequiredError', mapOf([to('en', 'Please enter the date and time.'), to('es', 'Introduce la fecha y la hora.'), to('fr', "Veuillez saisir la date et l'heure."), to('pt', 'Informe a data e a hora.'), to('zh', '\u8BF7\u8F93\u5165\u65E5\u671F\u548C\u65F6\u95F4\u3002')])), to('logActivity.loggedAtFutureError', mapOf([to('en', "The date and time can't be in the future."), to('es', 'La fecha y hora no pueden estar en el futuro.'), to('fr', "La date et l'heure ne peuvent pas \xEAtre dans le futur."), to('pt', 'A data e a hora n\xE3o podem estar no futuro.'), to('zh', '\u65E5\u671F\u548C\u65F6\u95F4\u4E0D\u80FD\u662F\u672A\u6765\u65F6\u95F4\u3002')])), to('logActivity.activityType.scubaDive', mapOf([to('en', 'Recreational scuba dive'), to('es', 'Buceo recreativo'), to('fr', 'Plong\xE9e sous-marine de loisir'), to('pt', 'Mergulho recreativo'), to('zh', '\u4F11\u95F2\u6C34\u80BA\u6F5C\u6C34')])), to('logActivity.activityType.studentPilot', mapOf([to('en', 'Student pilot flight'), to('es', 'Vuelo de piloto estudiante'), to('fr', "Vol d'\xE9l\xE8ve-pilote"), to('pt', 'Voo de piloto estudante'), to('zh', '\u5B66\u5458\u98DE\u884C\u5458\u98DE\u884C')])), to('logActivity.activityType.rockClimb', mapOf([to('en', 'Rock climb'), to('es', 'Escalada en roca'), to('fr', 'Escalade'), to('pt', 'Escalada em rocha'), to('zh', '\u6500\u5CA9')])), to('logActivity.activityType.walk', mapOf([to('en', 'Walk (GPS track)'), to('es', 'Caminata (track GPS)'), to('fr', 'Marche (trace GPS)'), to('pt', 'Caminhada (trilha GPS)'), to('zh', '\u6B65\u884C(GPS\u8F68\u8FF9)')])), to('logActivity.activityType.run', mapOf([to('en', 'Run (GPS track)'), to('es', 'Carrera (track GPS)'), to('fr', 'Course (trace GPS)'), to('pt', 'Corrida (trilha GPS)'), to('zh', '\u8DD1\u6B65(GPS\u8F68\u8FF9)')])), to('logActivity.activityType.raft', mapOf([to('en', 'Whitewater raft (GPS track)'), to('es', 'Descenso de r\xE1pidos (track GPS)'), to('fr', 'Rafting en eaux vives (trace GPS)'), to('pt', 'Rafting em corredeiras (trilha GPS)'), to('zh', '\u6FC0\u6D41\u6F02\u6D41(GPS\u8F68\u8FF9)')])), to('logActivity.activityType.paraglide', mapOf([to('en', 'Paraglide (GPS track)'), to('es', 'Parapente (track GPS)'), to('fr', 'Parapente (trace GPS)'), to('pt', 'Parapente (trilha GPS)'), to('zh', '\u6ED1\u7FD4\u4F1E(GPS\u8F68\u8FF9)')])), to('logActivity.activityType.hangGlide', mapOf([to('en', 'Hang glide (GPS track)'), to('es', 'Ala delta (track GPS)'), to('fr', 'Deltaplane (trace GPS)'), to('pt', 'Asa delta (trilha GPS)'), to('zh', '\u60AC\u6302\u6ED1\u7FD4(GPS\u8F68\u8FF9)')])), to('logActivity.activityType.gliderFlight', mapOf([to('en', 'Glider flight (GPS track)'), to('es', 'Vuelo en planeador (track GPS)'), to('fr', 'Vol en planeur (trace GPS)'), to('pt', 'Voo de planador (trilha GPS)'), to('zh', '\u6ED1\u7FD4\u673A\u98DE\u884C(GPS\u8F68\u8FF9)')])), to('logActivity.instructorLabel', mapOf([to('en', 'Instructor / witness'), to('es', 'Instructor/testigo'), to('fr', 'Instructeur/t\xE9moin'), to('pt', 'Instrutor/testemunha'), to('zh', '\u6559\u7EC3/\u89C1\u8BC1\u4EBA')])), to('logActivity.instructorSearchPlaceholder', mapOf([to('en', 'Search by name\u2026'), to('es', 'Buscar por nombre\u2026'), to('fr', 'Rechercher par nom\u2026'), to('pt', 'Buscar por nome\u2026'), to('zh', '\u6309\u59D3\u540D\u641C\u7D22\u2026')])), to('logActivity.noInstructorCandidates', mapOf([to('en', 'No one registered for this activity matches that name.'), to('es', 'Nadie registrado para esta actividad coincide con ese nombre.'), to('fr', "Personne d'inscrit \xE0 cette activit\xE9 ne correspond \xE0 ce nom."), to('pt', 'Ningu\xE9m registrado para esta atividade corresponde a esse nome.'), to('zh', '\u6CA1\u6709\u6CE8\u518C\u6B64\u6D3B\u52A8\u7684\u4EBA\u4E0E\u8BE5\u59D3\u540D\u5339\u914D\u3002')])), to('logActivity.selectInstructorError', mapOf([to('en', 'Please search for and select an instructor/witness.'), to('es', 'Busca y selecciona un instructor/testigo.'), to('fr', 'Veuillez rechercher et s\xE9lectionner un instructeur/t\xE9moin.'), to('pt', 'Pesquise e selecione um instrutor/testemunha.'), to('zh', '\u8BF7\u641C\u7D22\u5E76\u9009\u62E9\u4E00\u4F4D\u6559\u7EC3/\u89C1\u8BC1\u4EBA\u3002')])), to('logActivity.activityFilterMineLabel', mapOf([to('en', 'Mine'), to('es', 'M\xEDas'), to('fr', 'Les miennes'), to('pt', 'Minhas'), to('zh', '\u6211\u7684')])), to('logActivity.activityFilterAllLabel', mapOf([to('en', 'All'), to('es', 'Todas'), to('fr', 'Toutes'), to('pt', 'Todas'), to('zh', '\u5168\u90E8')])), to('logActivity.startedAtLabel', mapOf([to('en', 'Start date & time'), to('es', 'Fecha y hora de inicio'), to('fr', 'Date et heure de d\xE9but'), to('pt', 'Data e hora de in\xEDcio'), to('zh', '\u5F00\u59CB\u65E5\u671F\u548C\u65F6\u95F4')])), to('logActivity.endedAtLabel', mapOf([to('en', 'End date & time'), to('es', 'Fecha y hora de fin'), to('fr', 'Date et heure de fin'), to('pt', 'Data e hora de t\xE9rmino'), to('zh', '\u7ED3\u675F\u65E5\u671F\u548C\u65F6\u95F4')])), to('logActivity.endedBeforeStartedError', mapOf([to('en', "The end time can't be before the start time."), to('es', 'La hora de fin no puede ser anterior a la hora de inicio.'), to('fr', "L'heure de fin ne peut pas \xEAtre ant\xE9rieure \xE0 l'heure de d\xE9but."), to('pt', 'A hora de t\xE9rmino n\xE3o pode ser anterior \xE0 hora de in\xEDcio.'), to('zh', '\u7ED3\u675F\u65F6\u95F4\u4E0D\u80FD\u65E9\u4E8E\u5F00\u59CB\u65F6\u95F4\u3002')])), to('logActivity.deviceTrackHeading', mapOf([to('en', 'Device track file (optional)'), to('es', 'Archivo de track del dispositivo (opcional)'), to('fr', "Fichier de trace de l'appareil (facultatif)"), to('pt', 'Arquivo de trilha do dispositivo (opcional)'), to('zh', '\u8BBE\u5907\u8F68\u8FF9\u6587\u4EF6(\u53EF\u9009)')])), to('logActivity.deviceTrackDescription', mapOf([to('en', "Attach a GPX, TCX, IGC, UDDF, or FIT file exported from a GPS watch, glider logger, or dive computer \u2014 the recorded route is shown on a map and any extra details the file carries (heart rate, altitude gain, gas mix, ...) are shown below once submitted. It doesn't fill in the fields above; those are still the stored, authoritative record."), to('es', 'Adjunta un archivo GPX, TCX, IGC, UDDF o FIT exportado desde un reloj GPS, un registrador de planeador o un ordenador de buceo \u2014 la ruta registrada se muestra en un mapa y cualquier detalle adicional que contenga el archivo (frecuencia card\xEDaca, ganancia de altitud, mezcla de gases, ...) se muestra debajo una vez enviado. No rellena los campos anteriores; esos siguen siendo el registro almacenado y autoritativo.'), to('fr', "Joignez un fichier GPX, TCX, IGC, UDDF ou FIT export\xE9 depuis une montre GPS, un enregistreur de planeur ou un ordinateur de plong\xE9e \u2014 le parcours enregistr\xE9 est affich\xE9 sur une carte et tout d\xE9tail suppl\xE9mentaire que contient le fichier (fr\xE9quence cardiaque, d\xE9nivel\xE9, m\xE9lange gazeux, ...) est affich\xE9 ci-dessous une fois soumis. Cela ne remplit pas les champs ci-dessus ; ceux-ci restent l'enregistrement stock\xE9 et faisant autorit\xE9."), to('pt', 'Anexe um arquivo GPX, TCX, IGC, UDDF ou FIT exportado de um rel\xF3gio GPS, um registrador de planador ou um computador de mergulho \u2014 a rota registrada \xE9 exibida em um mapa e quaisquer detalhes extras que o arquivo contenha (frequ\xEAncia card\xEDaca, ganho de altitude, mistura de gases, ...) s\xE3o exibidos abaixo ap\xF3s o envio. Isso n\xE3o preenche os campos acima; esses continuam sendo o registro armazenado e oficial.'), to('zh', '\u4E0A\u4F20\u4ECEGPS\u624B\u8868\u3001\u6ED1\u7FD4\u673A\u8BB0\u5F55\u4EEA\u6216\u6F5C\u6C34\u7535\u8111\u5BFC\u51FA\u7684GPX\u3001TCX\u3001IGC\u3001UDDF\u6216FIT\u6587\u4EF6\u2014\u2014\u8BB0\u5F55\u7684\u8DEF\u7EBF\u4F1A\u663E\u793A\u5728\u5730\u56FE\u4E0A,\u6587\u4EF6\u643A\u5E26\u7684\u4EFB\u4F55\u989D\u5916\u7EC6\u8282(\u5FC3\u7387\u3001\u722C\u5347\u9AD8\u5EA6\u3001\u6C14\u4F53\u6DF7\u5408\u6BD4\u7B49)\u4F1A\u5728\u63D0\u4EA4\u540E\u663E\u793A\u5728\u4E0B\u65B9\u3002\u5B83\u4E0D\u4F1A\u81EA\u52A8\u586B\u5199\u4E0A\u9762\u7684\u5B57\u6BB5;\u90A3\u4E9B\u5B57\u6BB5\u4ECD\u7136\u662F\u5B58\u50A8\u7684\u6743\u5A01\u8BB0\u5F55\u3002')])), to('logActivity.trackFileLabel', mapOf([to('en', 'Track file'), to('es', 'Archivo de track'), to('fr', 'Fichier de trace'), to('pt', 'Arquivo de trilha'), to('zh', '\u8F68\u8FF9\u6587\u4EF6')])), to('logActivity.locationHeading', mapOf([to('en', 'Location (optional)'), to('es', 'Ubicaci\xF3n (opcional)'), to('fr', 'Emplacement (facultatif)'), to('pt', 'Localiza\xE7\xE3o (opcional)'), to('zh', '\u4F4D\u7F6E(\u53EF\u9009)')])), to('logActivity.photosHeading', mapOf([to('en', 'Photos (optional)'), to('es', 'Fotos (opcional)'), to('fr', 'Photos (facultatif)'), to('pt', 'Fotos (opcional)'), to('zh', '\u7167\u7247(\u53EF\u9009)')])), to('logActivity.photosDescription', mapOf([to('en', "Add up to 5 photos from this activity \u2014 they're resized for the web automatically."), to('es', 'Agrega hasta 5 fotos de esta actividad \u2014 se redimensionan autom\xE1ticamente para la web.'), to('fr', "Ajoutez jusqu'\xE0 5 photos de cette activit\xE9 \u2014 elles sont redimensionn\xE9es automatiquement pour le web."), to('pt', 'Adicione at\xE9 5 fotos desta atividade \u2014 elas s\xE3o redimensionadas automaticamente para a web.'), to('zh', '\u6700\u591A\u6DFB\u52A05\u5F20\u6B64\u6D3B\u52A8\u7684\u7167\u7247\u2014\u2014\u5C06\u81EA\u52A8\u8C03\u6574\u4E3A\u9002\u5408\u7F51\u9875\u7684\u5927\u5C0F\u3002')])), to('logActivity.photosLabel', mapOf([to('en', 'Photos'), to('es', 'Fotos'), to('fr', 'Photos'), to('pt', 'Fotos'), to('zh', '\u7167\u7247')])), to('logActivity.tooManyPhotosError', mapOf([to('en', 'Choose at most 5 photos.'), to('es', 'Elige como m\xE1ximo 5 fotos.'), to('fr', 'Choisissez au plus 5 photos.'), to('pt', 'Escolha no m\xE1ximo 5 fotos.'), to('zh', '\u6700\u591A\u9009\u62E95\u5F20\u7167\u7247\u3002')])), to('logActivity.photoUploadFailedPrefix', mapOf([to('en', 'A photo could not be uploaded: '), to('es', 'No se pudo subir una foto: '), to('fr', "Une photo n'a pas pu \xEAtre t\xE9l\xE9charg\xE9e : "), to('pt', 'N\xE3o foi poss\xEDvel enviar uma foto: '), to('zh', '\u6709\u4E00\u5F20\u7167\u7247\u65E0\u6CD5\u4E0A\u4F20:')])), to('location.searchLabel', mapOf([to('en', 'Search for a place'), to('es', 'Buscar un lugar'), to('fr', 'Rechercher un lieu'), to('pt', 'Pesquisar um local'), to('zh', '\u641C\u7D22\u5730\u70B9')])), to('location.useMyLocationButton', mapOf([to('en', 'Use my current location'), to('es', 'Usar mi ubicaci\xF3n actual'), to('fr', 'Utiliser ma position actuelle'), to('pt', 'Usar minha localiza\xE7\xE3o atual'), to('zh', '\u4F7F\u7528\u6211\u7684\u5F53\u524D\u4F4D\u7F6E')])), to('logActivity.notesLabel', mapOf([to('en', 'Notes'), to('es', 'Notas'), to('fr', 'Notes'), to('pt', 'Notas'), to('zh', '\u5907\u6CE8')])), to('logActivity.submitButton', mapOf([to('en', 'Submit for approval'), to('es', 'Enviar para aprobaci\xF3n'), to('fr', 'Soumettre pour approbation'), to('pt', 'Enviar para aprova\xE7\xE3o'), to('zh', '\u63D0\u4EA4\u5BA1\u6279')])), to('unit.meters', mapOf([to('en', 'm'), to('es', 'm'), to('fr', 'm'), to('pt', 'm'), to('zh', '\u7C73')])), to('unit.feet', mapOf([to('en', 'ft'), to('es', 'pies'), to('fr', 'pi'), to('pt', 'p\xE9s'), to('zh', '\u82F1\u5C3A')])), to('unit.km', mapOf([to('en', 'km'), to('es', 'km'), to('fr', 'km'), to('pt', 'km'), to('zh', '\u516C\u91CC')])), to('unit.miles', mapOf([to('en', 'mi'), to('es', 'mi'), to('fr', 'mi'), to('pt', 'mi'), to('zh', '\u82F1\u91CC')])), to('unit.nm', mapOf([to('en', 'nm'), to('es', 'mn'), to('fr', 'mn'), to('pt', 'mn'), to('zh', '\u6D77\u91CC')])), to('unit.mm', mapOf([to('en', 'mm'), to('es', 'mm'), to('fr', 'mm'), to('pt', 'mm'), to('zh', '\u6BEB\u7C73')])), to('unit.inches', mapOf([to('en', 'in'), to('es', 'pulg'), to('fr', 'po'), to('pt', 'pol'), to('zh', '\u82F1\u5BF8')])), to('unit.celsius', mapOf([to('en', '\xB0C'), to('es', '\xB0C'), to('fr', '\xB0C'), to('pt', '\xB0C'), to('zh', '\xB0C')])), to('unit.fahrenheit', mapOf([to('en', '\xB0F'), to('es', '\xB0F'), to('fr', '\xB0F'), to('pt', '\xB0F'), to('zh', '\xB0F')])), to('unit.bar', mapOf([to('en', 'bar'), to('es', 'bar'), to('fr', 'bar'), to('pt', 'bar'), to('zh', '\u5DF4')])), to('unit.psi', mapOf([to('en', 'psi'), to('es', 'psi'), to('fr', 'psi'), to('pt', 'psi'), to('zh', 'psi')])), to('unit.kpa', mapOf([to('en', 'kPa'), to('es', 'kPa'), to('fr', 'kPa'), to('pt', 'kPa'), to('zh', '\u5343\u5E15')])), to('unit.hpa', mapOf([to('en', 'hPa'), to('es', 'hPa'), to('fr', 'hPa'), to('pt', 'hPa'), to('zh', '\u767E\u5E15')])), to('unit.inHg', mapOf([to('en', 'inHg'), to('es', 'inHg'), to('fr', 'inHg'), to('pt', 'inHg'), to('zh', '\u82F1\u5BF8\u6C5E\u67F1')])), to('unit.kph', mapOf([to('en', 'km/h'), to('es', 'km/h'), to('fr', 'km/h'), to('pt', 'km/h'), to('zh', '\u516C\u91CC/\u5C0F\u65F6')])), to('unit.mph', mapOf([to('en', 'mph'), to('es', 'mph'), to('fr', 'mi/h'), to('pt', 'mph'), to('zh', '\u82F1\u91CC/\u5C0F\u65F6')])), to('unit.knots', mapOf([to('en', 'kn'), to('es', 'nudos'), to('fr', 'n\u0153uds'), to('pt', 'n\xF3s'), to('zh', '\u8282')])), to('unit.kg', mapOf([to('en', 'kg'), to('es', 'kg'), to('fr', 'kg'), to('pt', 'kg'), to('zh', '\u516C\u65A4')])), to('unit.lb', mapOf([to('en', 'lb'), to('es', 'lb'), to('fr', 'lb'), to('pt', 'lb'), to('zh', '\u78C5')])), to('unit.liters', mapOf([to('en', 'L'), to('es', 'L'), to('fr', 'L'), to('pt', 'L'), to('zh', '\u5347')])), to('unit.gallons', mapOf([to('en', 'gal'), to('es', 'gal'), to('fr', 'gal'), to('pt', 'gal'), to('zh', '\u52A0\u4ED1')])), to('location.geolocationNotSupported', mapOf([to('en', "Geolocation isn't supported by this browser."), to('es', 'Este navegador no admite la geolocalizaci\xF3n.'), to('fr', "La g\xE9olocalisation n'est pas prise en charge par ce navigateur."), to('pt', 'A geolocaliza\xE7\xE3o n\xE3o \xE9 suportada por este navegador.'), to('zh', '\u6B64\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u5730\u7406\u5B9A\u4F4D\u3002')])), to('location.locating', mapOf([to('en', 'Locating\u2026'), to('es', 'Localizando\u2026'), to('fr', 'Localisation\u2026'), to('pt', 'Localizando\u2026'), to('zh', '\u6B63\u5728\u5B9A\u4F4D\u2026')])), to('location.locationCaptured', mapOf([to('en', 'Location captured.'), to('es', 'Ubicaci\xF3n capturada.'), to('fr', 'Position captur\xE9e.'), to('pt', 'Localiza\xE7\xE3o capturada.'), to('zh', '\u5DF2\u83B7\u53D6\u4F4D\u7F6E\u3002')])), to('location.locationError', mapOf([to('en', 'Could not get your location.'), to('es', 'No se pudo obtener tu ubicaci\xF3n.'), to('fr', "Impossible d'obtenir votre position."), to('pt', 'N\xE3o foi poss\xEDvel obter sua localiza\xE7\xE3o.'), to('zh', '\u65E0\u6CD5\u83B7\u53D6\u60A8\u7684\u4F4D\u7F6E\u3002')])), to('discover.title', mapOf([to('en', 'Discover activity centers'), to('es', 'Descubrir centros de actividades'), to('fr', "D\xE9couvrir des centres d'activit\xE9s"), to('pt', 'Descobrir centros de atividades'), to('zh', '\u53D1\u73B0\u6D3B\u52A8\u4E2D\u5FC3')])), to('discover.activityTypeLabel', mapOf([to('en', 'Activity'), to('es', 'Actividad'), to('fr', 'Activit\xE9'), to('pt', 'Atividade'), to('zh', '\u6D3B\u52A8')])), to('discover.selectActivityTypePlaceholder', mapOf([to('en', 'Select an activity\u2026'), to('es', 'Selecciona una actividad\u2026'), to('fr', 'S\xE9lectionnez une activit\xE9\u2026'), to('pt', 'Selecione uma atividade\u2026'), to('zh', '\u9009\u62E9\u4E00\u9879\u6D3B\u52A8\u2026')])), to('discover.radiusLabel', mapOf([to('en', 'Search radius (km)'), to('es', 'Radio de b\xFAsqueda (km)'), to('fr', 'Rayon de recherche (km)'), to('pt', 'Raio de busca (km)'), to('zh', '\u641C\u7D22\u534A\u5F84\uFF08\u516C\u91CC\uFF09')])), to('discover.submitButton', mapOf([to('en', 'Search'), to('es', 'Buscar'), to('fr', 'Rechercher'), to('pt', 'Buscar'), to('zh', '\u641C\u7D22')])), to('discover.selectActivityTypeError', mapOf([to('en', 'Choose an activity first.'), to('es', 'Elige primero una actividad.'), to('fr', "Choisissez d'abord une activit\xE9."), to('pt', 'Escolha uma atividade primeiro.'), to('zh', '\u8BF7\u5148\u9009\u62E9\u4E00\u9879\u6D3B\u52A8\u3002')])), to('discover.selectLocationError', mapOf([to('en', 'Search for a place and confirm a location first.'), to('es', 'Busca un lugar y confirma una ubicaci\xF3n primero.'), to('fr', "Recherchez un lieu et confirmez un emplacement d'abord."), to('pt', 'Pesquise um local e confirme uma localiza\xE7\xE3o primeiro.'), to('zh', '\u8BF7\u5148\u641C\u7D22\u5730\u70B9\u5E76\u786E\u8BA4\u4F4D\u7F6E\u3002')])), to('discover.genericErrorPrefix', mapOf([to('en', 'Search failed: '), to('es', 'Error en la b\xFAsqueda: '), to('fr', '\xC9chec de la recherche : '), to('pt', 'Falha na busca: '), to('zh', '\u641C\u7D22\u5931\u8D25\uFF1A')])), to('discover.noResults', mapOf([to('en', 'No activity centers found nearby yet.'), to('es', 'A\xFAn no se encontraron centros de actividades cercanos.'), to('fr', "Aucun centre d'activit\xE9s trouv\xE9 \xE0 proximit\xE9 pour l'instant."), to('pt', 'Nenhum centro de atividades encontrado por perto ainda.'), to('zh', '\u9644\u8FD1\u5C1A\u672A\u627E\u5230\u6D3B\u52A8\u4E2D\u5FC3\u3002')])), to('discover.activityFilterMineLabel', mapOf([to('en', 'Mine'), to('es', 'M\xEDas'), to('fr', 'Les miennes'), to('pt', 'Minhas'), to('zh', '\u6211\u7684')])), to('discover.activityFilterAllLabel', mapOf([to('en', 'All'), to('es', 'Todas'), to('fr', 'Toutes'), to('pt', 'Todas'), to('zh', '\u5168\u90E8')])), to('discover.openSearchButton', mapOf([to('en', 'Search activity centers'), to('es', 'Buscar centros de actividades'), to('fr', "Rechercher des centres d'activit\xE9s"), to('pt', 'Pesquisar centros de atividades'), to('zh', '\u641C\u7D22\u6D3B\u52A8\u4E2D\u5FC3')])), to('discover.resultsFoundPrefix', mapOf([to('en', 'Found '), to('es', 'Se encontraron '), to('fr', 'Trouv\xE9 '), to('pt', 'Encontrados '), to('zh', '\u627E\u5230 ')])), to('discover.resultsFoundSuffix', mapOf([to('en', ' activity centers nearby.'), to('es', ' centros de actividades cerca.'), to('fr', " centres d'activit\xE9s \xE0 proximit\xE9."), to('pt', ' centros de atividades por perto.'), to('zh', ' \u4E2A\u9644\u8FD1\u7684\u6D3B\u52A8\u4E2D\u5FC3\u3002')])), to('logActivity.scuba.heading', mapOf([to('en', 'Dive details'), to('es', 'Detalles del buceo'), to('fr', 'D\xE9tails de la plong\xE9e'), to('pt', 'Detalhes do mergulho'), to('zh', '\u6F5C\u6C34\u8BE6\u60C5')])), to('logActivity.scuba.maxDepth', mapOf([to('en', 'Max depth (m)'), to('es', 'Profundidad m\xE1xima (m)'), to('fr', 'Profondeur maximale (m)'), to('pt', 'Profundidade m\xE1xima (m)'), to('zh', '\u6700\u5927\u6DF1\u5EA6(\u7C73)')])), to('logActivity.scuba.bottomTime', mapOf([to('en', 'Bottom time (min)'), to('es', 'Tiempo de fondo (min)'), to('fr', 'Temps de fond (min)'), to('pt', 'Tempo de fundo (min)'), to('zh', '\u6C34\u4E0B\u65F6\u95F4(\u5206\u949F)')])), to('logActivity.scuba.surfaceInterval', mapOf([to('en', 'Surface interval (min, optional)'), to('es', 'Intervalo en superficie (min, opcional)'), to('fr', 'Intervalle de surface (min, facultatif)'), to('pt', 'Intervalo de superf\xEDcie (min, opcional)'), to('zh', '\u6C34\u9762\u95F4\u9694\u65F6\u95F4(\u5206\u949F,\u53EF\u9009)')])), to('logActivity.scuba.startPressure', mapOf([to('en', 'Start pressure (bar)'), to('es', 'Presi\xF3n inicial (bar)'), to('fr', 'Pression initiale (bar)'), to('pt', 'Press\xE3o inicial (bar)'), to('zh', '\u8D77\u59CB\u538B\u529B(\u5DF4)')])), to('logActivity.scuba.endPressure', mapOf([to('en', 'End pressure (bar)'), to('es', 'Presi\xF3n final (bar)'), to('fr', 'Pression finale (bar)'), to('pt', 'Press\xE3o final (bar)'), to('zh', '\u7ED3\u675F\u538B\u529B(\u5DF4)')])), to('logActivity.scuba.gasMix', mapOf([to('en', 'Gas mix'), to('es', 'Mezcla de gases'), to('fr', 'M\xE9lange gazeux'), to('pt', 'Mistura de gases'), to('zh', '\u6C14\u4F53\u6DF7\u5408\u6BD4')])), to('logActivity.scuba.gasMixOption.air', mapOf([to('en', 'Air'), to('es', 'Aire'), to('fr', 'Air'), to('pt', 'Ar'), to('zh', '\u7A7A\u6C14')])), to('logActivity.scuba.gasMixOption.ean32', mapOf([to('en', 'Nitrox EAN32'), to('es', 'Nitrox EAN32'), to('fr', 'Nitrox EAN32'), to('pt', 'Nitrox EAN32'), to('zh', '\u5BCC\u6C27\u7A7A\u6C14 EAN32')])), to('logActivity.scuba.gasMixOption.ean36', mapOf([to('en', 'Nitrox EAN36'), to('es', 'Nitrox EAN36'), to('fr', 'Nitrox EAN36'), to('pt', 'Nitrox EAN36'), to('zh', '\u5BCC\u6C27\u7A7A\u6C14 EAN36')])), to('logActivity.scuba.gasMixOption.trimix', mapOf([to('en', 'Trimix'), to('es', 'Trimix'), to('fr', 'Trimix'), to('pt', 'Trimix'), to('zh', '\u4E09\u5143\u6C14\u4F53')])), to('logActivity.scuba.gasMixOption.heliox', mapOf([to('en', 'Heliox'), to('es', 'Heliox'), to('fr', 'H\xE9liox'), to('pt', 'Heliox'), to('zh', '\u6C26\u6C27\u6DF7\u5408\u6C14')])), to('logActivity.scuba.gasMixOption.other', mapOf([to('en', 'Other'), to('es', 'Otra'), to('fr', 'Autre'), to('pt', 'Outra'), to('zh', '\u5176\u4ED6')])), to('logActivity.scuba.waterTempSurface', mapOf([to('en', 'Water temp surface (\xB0C, optional)'), to('es', 'Temperatura del agua en superficie (\xB0C, opcional)'), to('fr', "Temp\xE9rature de l'eau en surface (\xB0C, facultatif)"), to('pt', 'Temperatura da \xE1gua na superf\xEDcie (\xB0C, opcional)'), to('zh', '\u6C34\u9762\u6C34\u6E29(\xB0C,\u53EF\u9009)')])), to('logActivity.scuba.waterTempBottom', mapOf([to('en', 'Water temp bottom (\xB0C, optional)'), to('es', 'Temperatura del agua en el fondo (\xB0C, opcional)'), to('fr', "Temp\xE9rature de l'eau au fond (\xB0C, facultatif)"), to('pt', 'Temperatura da \xE1gua no fundo (\xB0C, opcional)'), to('zh', '\u6C34\u5E95\u6C34\u6E29(\xB0C,\u53EF\u9009)')])), to('logActivity.scuba.visibility', mapOf([to('en', 'Visibility (m, optional)'), to('es', 'Visibilidad (m, opcional)'), to('fr', 'Visibilit\xE9 (m, facultatif)'), to('pt', 'Visibilidade (m, opcional)'), to('zh', '\u80FD\u89C1\u5EA6(\u7C73,\u53EF\u9009)')])), to('logActivity.scuba.currentStrength', mapOf([to('en', 'Current strength (optional)'), to('es', 'Intensidad de la corriente (opcional)'), to('fr', 'Force du courant (facultatif)'), to('pt', 'Intensidade da corrente (opcional)'), to('zh', '\u6C34\u6D41\u5F3A\u5EA6(\u53EF\u9009)')])), to('logActivity.scuba.exposureSuitThickness', mapOf([to('en', 'Exposure suit thickness (mm, optional)'), to('es', 'Grosor del traje de exposici\xF3n (mm, opcional)'), to('fr', '\xC9paisseur de la combinaison (mm, facultatif)'), to('pt', 'Espessura do traje de exposi\xE7\xE3o (mm, opcional)'), to('zh', '\u9632\u62A4\u670D\u539A\u5EA6(\u6BEB\u7C73,\u53EF\u9009)')])), to('logActivity.scuba.weightCarried', mapOf([to('en', 'Weight carried (kg, optional)'), to('es', 'Peso llevado (kg, opcional)'), to('fr', 'Poids port\xE9 (kg, facultatif)'), to('pt', 'Peso utilizado (kg, opcional)'), to('zh', '\u914D\u91CD(\u516C\u65A4,\u53EF\u9009)')])), to('logActivity.pilot.heading', mapOf([to('en', 'Flight details'), to('es', 'Detalles del vuelo'), to('fr', 'D\xE9tails du vol'), to('pt', 'Detalhes do voo'), to('zh', '\u98DE\u884C\u8BE6\u60C5')])), to('logActivity.pilot.aircraftMake', mapOf([to('en', 'Aircraft make'), to('es', 'Marca de la aeronave'), to('fr', "Marque de l'a\xE9ronef"), to('pt', 'Marca da aeronave'), to('zh', '\u98DE\u673A\u5236\u9020\u5546')])), to('logActivity.pilot.aircraftModel', mapOf([to('en', 'Aircraft model'), to('es', 'Modelo de la aeronave'), to('fr', "Mod\xE8le de l'a\xE9ronef"), to('pt', 'Modelo da aeronave'), to('zh', '\u98DE\u673A\u578B\u53F7')])), to('logActivity.pilot.tailRegistration', mapOf([to('en', 'Tail registration'), to('es', 'Matr\xEDcula de la aeronave'), to('fr', "Immatriculation de l'a\xE9ronef"), to('pt', 'Matr\xEDcula da aeronave'), to('zh', '\u673A\u5C3E\u6CE8\u518C\u53F7')])), to('logActivity.pilot.dualInstructionHours', mapOf([to('en', 'Dual instruction hours'), to('es', 'Horas de instrucci\xF3n con instructor'), to('fr', "Heures d'instruction en double commande"), to('pt', 'Horas de instru\xE7\xE3o com instrutor'), to('zh', '\u53CC\u4EBA\u6559\u5B66\u98DE\u884C\u5C0F\u65F6\u6570')])), to('logActivity.pilot.soloFlightHours', mapOf([to('en', 'Solo flight hours'), to('es', 'Horas de vuelo solo'), to('fr', 'Heures de vol en solo'), to('pt', 'Horas de voo solo'), to('zh', '\u5355\u98DE\u98DE\u884C\u5C0F\u65F6\u6570')])), to('logActivity.pilot.crossCountryDistance', mapOf([to('en', 'Cross-country distance (nm)'), to('es', 'Distancia de navegaci\xF3n (nm)'), to('fr', 'Distance de navigation (nm)'), to('pt', 'Dist\xE2ncia de navega\xE7\xE3o (nm)'), to('zh', '\u8D8A\u91CE\u98DE\u884C\u8DDD\u79BB(\u6D77\u91CC)')])), to('logActivity.pilot.nightHours', mapOf([to('en', 'Night hours'), to('es', 'Horas nocturnas'), to('fr', 'Heures de nuit'), to('pt', 'Horas noturnas'), to('zh', '\u591C\u95F4\u98DE\u884C\u5C0F\u65F6\u6570')])), to('logActivity.pilot.instrumentHours', mapOf([to('en', 'Instrument hours'), to('es', 'Horas de vuelo instrumental'), to('fr', 'Heures de vol aux instruments'), to('pt', 'Horas de voo por instrumentos'), to('zh', '\u4EEA\u8868\u98DE\u884C\u5C0F\u65F6\u6570')])), to('logActivity.pilot.departureAirportCode', mapOf([to('en', 'Departure airport code'), to('es', 'C\xF3digo del aeropuerto de salida'), to('fr', "Code de l'a\xE9roport de d\xE9part"), to('pt', 'C\xF3digo do aeroporto de partida'), to('zh', '\u8D77\u98DE\u673A\u573A\u4EE3\u7801')])), to('logActivity.pilot.arrivalAirportCode', mapOf([to('en', 'Arrival airport code'), to('es', 'C\xF3digo del aeropuerto de llegada'), to('fr', "Code de l'a\xE9roport d'arriv\xE9e"), to('pt', 'C\xF3digo do aeroporto de chegada'), to('zh', '\u5230\u8FBE\u673A\u573A\u4EE3\u7801')])), to('logActivity.pilot.intermediateStops', mapOf([to('en', 'Intermediate stops (comma-separated, optional)'), to('es', 'Escalas intermedias (separadas por comas, opcional)'), to('fr', 'Escales interm\xE9diaires (s\xE9par\xE9es par des virgules, facultatif)'), to('pt', 'Paradas intermedi\xE1rias (separadas por v\xEDrgula, opcional)'), to('zh', '\u4E2D\u9014\u505C\u9760\u7AD9(\u9017\u53F7\u5206\u9694,\u53EF\u9009)')])), to('logActivity.pilot.dayLandings', mapOf([to('en', 'Day landings'), to('es', 'Aterrizajes diurnos'), to('fr', 'Atterrissages de jour'), to('pt', 'Pousos diurnos'), to('zh', '\u65E5\u95F4\u7740\u9646\u6B21\u6570')])), to('logActivity.pilot.nightLandings', mapOf([to('en', 'Night landings'), to('es', 'Aterrizajes nocturnos'), to('fr', 'Atterrissages de nuit'), to('pt', 'Pousos noturnos'), to('zh', '\u591C\u95F4\u7740\u9646\u6B21\u6570')])), to('logActivity.climb.heading', mapOf([to('en', 'Climb details'), to('es', 'Detalles de la escalada'), to('fr', "D\xE9tails de l'escalade"), to('pt', 'Detalhes da escalada'), to('zh', '\u6500\u767B\u8BE6\u60C5')])), to('logActivity.climb.routeName', mapOf([to('en', 'Route name'), to('es', 'Nombre de la v\xEDa'), to('fr', 'Nom de la voie'), to('pt', 'Nome da via'), to('zh', '\u8DEF\u7EBF\u540D\u79F0')])), to('logActivity.climb.pitchCount', mapOf([to('en', 'Pitch count'), to('es', 'N\xFAmero de largos'), to('fr', 'Nombre de longueurs'), to('pt', 'N\xFAmero de trechos'), to('zh', '\u7EF3\u8DDD\u6570\u91CF')])), to('logActivity.climb.pitchGrade', mapOf([to('en', 'Pitch grade'), to('es', 'Grado del largo'), to('fr', 'Cotation de la longueur'), to('pt', 'Grau do trecho'), to('zh', '\u7EF3\u8DDD\u96BE\u5EA6\u7B49\u7EA7')])), to('logActivity.climb.climbLength', mapOf([to('en', 'Climb length (m)'), to('es', 'Longitud de la escalada (m)'), to('fr', "Longueur de l'escalade (m)"), to('pt', 'Comprimento da escalada (m)'), to('zh', '\u6500\u767B\u957F\u5EA6(\u7C73)')])), to('logActivity.climb.style', mapOf([to('en', 'Style (onsight, flash, redpoint, top-rope, ...)'), to('es', 'Estilo (a vista, flash, redpoint, top-rope, ...)'), to('fr', 'Style (\xE0 vue, flash, \xE0 la corde, moulinette, ...)'), to('pt', 'Estilo (\xE0 vista, flash, redpoint, top-rope, ...)'), to('zh', '\u98CE\u683C(\u95EA\u6500\u3001\u8BD5\u6500\u3001\u9876\u7EF3\u7B49)')])), to('logActivity.climb.tradGearSizes', mapOf([to('en', 'Trad gear sizes (comma-separated, optional)'), to('es', 'Tallas del material de escalada tradicional (separadas por comas, opcional)'), to('fr', "Tailles du mat\xE9riel d'escalade traditionnelle (s\xE9par\xE9es par des virgules, facultatif)"), to('pt', 'Tamanhos do equipamento de escalada tradicional (separados por v\xEDrgula, opcional)'), to('zh', '\u4F20\u7EDF\u6500\u767B\u5668\u6750\u5C3A\u5BF8(\u9017\u53F7\u5206\u9694,\u53EF\u9009)')])), to('logActivity.climb.fallOccurrences', mapOf([to('en', 'Fall occurrences'), to('es', 'N\xFAmero de ca\xEDdas'), to('fr', 'Nombre de chutes'), to('pt', 'N\xFAmero de quedas'), to('zh', '\u5760\u843D\u6B21\u6570')])), to('logActivity.gpsTrack.heading', mapOf([to('en', 'Track summary (optional \u2014 starts at 0 if left blank)'), to('es', 'Resumen del track (opcional \u2014 comienza en 0 si se deja en blanco)'), to('fr', 'R\xE9sum\xE9 de la trace (facultatif \u2014 commence \xE0 0 si laiss\xE9 vide)'), to('pt', 'Resumo da trilha (opcional \u2014 come\xE7a em 0 se deixado em branco)'), to('zh', '\u8F68\u8FF9\u6458\u8981(\u53EF\u9009\u2014\u2014\u7559\u7A7A\u5219\u4ECE0\u5F00\u59CB)')])), to('logActivity.gpsTrack.distance', mapOf([to('en', 'Distance (m)'), to('es', 'Distancia (m)'), to('fr', 'Distance (m)'), to('pt', 'Dist\xE2ncia (m)'), to('zh', '\u8DDD\u79BB(\u7C73)')])), to('logActivity.gpsTrack.duration', mapOf([to('en', 'Duration (seconds)'), to('es', 'Duraci\xF3n (segundos)'), to('fr', 'Dur\xE9e (secondes)'), to('pt', 'Dura\xE7\xE3o (segundos)'), to('zh', '\u6301\u7EED\u65F6\u95F4(\u79D2)')])), to('logActivity.raft.heading', mapOf([to('en', 'Raft details'), to('es', 'Detalles del descenso'), to('fr', 'D\xE9tails du rafting'), to('pt', 'Detalhes do rafting'), to('zh', '\u6F02\u6D41\u8BE6\u60C5')])), to('logActivity.raft.riverName', mapOf([to('en', 'River name'), to('es', 'Nombre del r\xEDo'), to('fr', 'Nom de la rivi\xE8re'), to('pt', 'Nome do rio'), to('zh', '\u6CB3\u6D41\u540D\u79F0')])), to('logActivity.raft.maxRapidClass', mapOf([to('en', 'Max rapid class'), to('es', 'Clase m\xE1xima de r\xE1pido'), to('fr', 'Classe maximale de rapide'), to('pt', 'Classe m\xE1xima de corredeira'), to('zh', '\u6700\u9AD8\u6025\u6D41\u7B49\u7EA7')])), to('logActivity.raft.sectionDistance', mapOf([to('en', 'Section distance (km, optional)'), to('es', 'Distancia del tramo (km, opcional)'), to('fr', 'Distance du tron\xE7on (km, facultatif)'), to('pt', 'Dist\xE2ncia do trecho (km, opcional)'), to('zh', '\u8DEF\u6BB5\u8DDD\u79BB(\u516C\u91CC,\u53EF\u9009)')])), to('logActivity.glider.heading', mapOf([to('en', 'Glider details'), to('es', 'Detalles del planeador'), to('fr', 'D\xE9tails du planeur'), to('pt', 'Detalhes do planador'), to('zh', '\u6ED1\u7FD4\u673A\u8BE6\u60C5')])), to('logActivity.glider.aircraftRegistration', mapOf([to('en', 'Aircraft registration (optional)'), to('es', 'Matr\xEDcula de la aeronave (opcional)'), to('fr', "Immatriculation de l'a\xE9ronef (facultatif)"), to('pt', 'Matr\xEDcula da aeronave (opcional)'), to('zh', '\u98DE\u673A\u6CE8\u518C\u53F7(\u53EF\u9009)')])), to('logActivity.unrecognizedTrackFileType', mapOf([to('en', 'Unrecognized track file type \u2014 expected .gpx, .tcx, .igc, .uddf, or .fit.'), to('es', 'Tipo de archivo de track no reconocido \u2014 se esperaba .gpx, .tcx, .igc, .uddf o .fit.'), to('fr', 'Type de fichier de trace non reconnu \u2014 attendu .gpx, .tcx, .igc, .uddf ou .fit.'), to('pt', 'Tipo de arquivo de trilha n\xE3o reconhecido \u2014 esperado .gpx, .tcx, .igc, .uddf ou .fit.'), to('zh', '\u65E0\u6CD5\u8BC6\u522B\u7684\u8F68\u8FF9\u6587\u4EF6\u7C7B\u578B\u2014\u2014\u5E94\u4E3A.gpx\u3001.tcx\u3001.igc\u3001.uddf\u6216.fit\u3002')])), to('logActivity.submittedAwaitingApproval', mapOf([to('en', "Submitted \u2014 awaiting your instructor's approval."), to('es', 'Enviado \u2014 esperando la aprobaci\xF3n de tu instructor.'), to('fr', "Soumis \u2014 en attente de l'approbation de votre instructeur."), to('pt', 'Enviado \u2014 aguardando a aprova\xE7\xE3o do seu instrutor.'), to('zh', '\u5DF2\u63D0\u4EA4\u2014\u2014\u7B49\u5F85\u60A8\u7684\u6559\u7EC3\u5BA1\u6279\u3002')])), to('logActivity.genericErrorPrefix', mapOf([to('en', 'Something went wrong: '), to('es', 'Algo sali\xF3 mal: '), to('fr', "Une erreur s'est produite : "), to('pt', 'Algo deu errado: '), to('zh', '\u51FA\u9519\u4E86:')])), to('logActivity.trackProcessedPrefix', mapOf([to('en', 'Track file processed \u2014 '), to('es', 'Archivo de track procesado \u2014 '), to('fr', 'Fichier de trace trait\xE9 \u2014 '), to('pt', 'Arquivo de trilha processado \u2014 '), to('zh', '\u8F68\u8FF9\u6587\u4EF6\u5DF2\u5904\u7406\u2014\u2014')])), to('logActivity.trackProcessedSuffix', mapOf([to('en', ' points.'), to('es', ' puntos.'), to('fr', ' points.'), to('pt', ' pontos.'), to('zh', '\u4E2A\u70B9\u3002')])), to('logActivity.fromFileHeading', mapOf([to('en', 'From the file:'), to('es', 'Del archivo:'), to('fr', 'Du fichier :'), to('pt', 'Do arquivo:'), to('zh', '\u6765\u81EA\u6587\u4EF6:')])), to('logActivity.trackProcessingFailedPrefix', mapOf([to('en', 'Entry created, but the track file could not be processed: '), to('es', 'Entrada creada, pero no se pudo procesar el archivo de track: '), to('fr', "Entr\xE9e cr\xE9\xE9e, mais le fichier de trace n'a pas pu \xEAtre trait\xE9 : "), to('pt', 'Registro criado, mas o arquivo de trilha n\xE3o p\xF4de ser processado: '), to('zh', '\u8BB0\u5F55\u5DF2\u521B\u5EFA,\u4F46\u8F68\u8FF9\u6587\u4EF6\u65E0\u6CD5\u5904\u7406:')])), to('logCenterActivity.missingCompanyTitle', mapOf([to('en', 'Missing company'), to('es', 'Falta la empresa'), to('fr', 'Entreprise manquante'), to('pt', 'Empresa ausente'), to('zh', '\u7F3A\u5C11\u516C\u53F8')])), to('logCenterActivity.missingCompanyMessage', mapOf([to('en', 'No company was specified.'), to('es', 'No se especific\xF3 ninguna empresa.'), to('fr', "Aucune entreprise n'a \xE9t\xE9 sp\xE9cifi\xE9e."), to('pt', 'Nenhuma empresa foi especificada.'), to('zh', '\u672A\u6307\u5B9A\u516C\u53F8\u3002')])), to('logCenterActivity.title', mapOf([to('en', 'Log an activity at this center'), to('es', 'Registrar una actividad en este centro'), to('fr', 'Enregistrer une activit\xE9 dans ce centre'), to('pt', 'Registrar uma atividade neste centro'), to('zh', '\u5728\u6B64\u4E2D\u5FC3\u8BB0\u5F55\u4E00\u9879\u6D3B\u52A8')])), to('logCenterActivity.subjectKindLabel', mapOf([to('en', 'Who is this for?'), to('es', '\xBFPara qui\xE9n es esto?'), to('fr', 'Pour qui est-ce ?'), to('pt', 'Para quem \xE9 isto?'), to('zh', '\u8FD9\u662F\u4E3A\u8C01\u8BB0\u5F55\u7684\uFF1F')])), to('logCenterActivity.subjectKindPractitioner', mapOf([to('en', 'A known practitioner'), to('es', 'Un practicante conocido'), to('fr', 'Un pratiquant connu'), to('pt', 'Um praticante conhecido'), to('zh', '\u5DF2\u77E5\u7684\u4ECE\u4E1A\u8005')])), to('logCenterActivity.subjectKindGuest', mapOf([to('en', 'Walk-in guest (no account yet)'), to('es', 'Invitado sin cita previa (a\xFAn sin cuenta)'), to('fr', 'Invit\xE9 sans rendez-vous (pas encore de compte)'), to('pt', 'Visitante sem cadastro (ainda sem conta)'), to('zh', '\u4E34\u65F6\u8BBF\u5BA2\uFF08\u5C1A\u65E0\u8D26\u6237\uFF09')])), to('logCenterActivity.practitionerUserIdLabel', mapOf([to('en', 'Practitioner user ID'), to('es', 'ID de usuario del practicante'), to('fr', 'ID utilisateur du pratiquant'), to('pt', 'ID de usu\xE1rio do praticante'), to('zh', '\u4ECE\u4E1A\u8005\u7528\u6237 ID')])), to('logCenterActivity.guestNameLabel', mapOf([to('en', 'Guest name'), to('es', 'Nombre del invitado'), to('fr', "Nom de l'invit\xE9"), to('pt', 'Nome do visitante'), to('zh', '\u8BBF\u5BA2\u59D3\u540D')])), to('logCenterActivity.guestEmailLabel', mapOf([to('en', 'Guest email'), to('es', 'Correo del invitado'), to('fr', "E-mail de l'invit\xE9"), to('pt', 'E-mail do visitante'), to('zh', '\u8BBF\u5BA2\u90AE\u7BB1')])), to('logCenterActivity.activityTypeLabel', mapOf([to('en', 'Activity type'), to('es', 'Tipo de actividad'), to('fr', "Type d'activit\xE9"), to('pt', 'Tipo de atividade'), to('zh', '\u6D3B\u52A8\u7C7B\u578B')])), to('logCenterActivity.activityTypeScuba', mapOf([to('en', 'Recreational scuba dive'), to('es', 'Buceo recreativo'), to('fr', 'Plong\xE9e sous-marine de loisir'), to('pt', 'Mergulho recreativo'), to('zh', '\u4F11\u95F2\u6C34\u80BA\u6F5C\u6C34')])), to('logCenterActivity.activityTypeStudentPilot', mapOf([to('en', 'Student pilot flight'), to('es', 'Vuelo de piloto en formaci\xF3n'), to('fr', "Vol d'\xE9l\xE8ve pilote"), to('pt', 'Voo de piloto em forma\xE7\xE3o'), to('zh', '\u5B66\u5458\u98DE\u884C\u5458\u98DE\u884C')])), to('logCenterActivity.activityTypeRockClimb', mapOf([to('en', 'Rock climb'), to('es', 'Escalada en roca'), to('fr', 'Escalade'), to('pt', 'Escalada em rocha'), to('zh', '\u6500\u5CA9')])), to('logCenterActivity.startedAtLabel', mapOf([to('en', 'Start date & time'), to('es', 'Fecha y hora de inicio'), to('fr', 'Date et heure de d\xE9but'), to('pt', 'Data e hora de in\xEDcio'), to('zh', '\u5F00\u59CB\u65E5\u671F\u548C\u65F6\u95F4')])), to('logCenterActivity.endedAtLabel', mapOf([to('en', 'End date & time'), to('es', 'Fecha y hora de fin'), to('fr', 'Date et heure de fin'), to('pt', 'Data e hora de t\xE9rmino'), to('zh', '\u7ED3\u675F\u65E5\u671F\u548C\u65F6\u95F4')])), to('logCenterActivity.loggedAtRequiredError', mapOf([to('en', 'Please enter the date and time.'), to('es', 'Introduce la fecha y la hora.'), to('fr', "Veuillez saisir la date et l'heure."), to('pt', 'Informe a data e a hora.'), to('zh', '\u8BF7\u8F93\u5165\u65E5\u671F\u548C\u65F6\u95F4\u3002')])), to('logCenterActivity.loggedAtFutureError', mapOf([to('en', "The date and time can't be in the future."), to('es', 'La fecha y hora no pueden estar en el futuro.'), to('fr', "La date et l'heure ne peuvent pas \xEAtre dans le futur."), to('pt', 'A data e a hora n\xE3o podem estar no futuro.'), to('zh', '\u65E5\u671F\u548C\u65F6\u95F4\u4E0D\u80FD\u662F\u672A\u6765\u65F6\u95F4\u3002')])), to('logCenterActivity.endedBeforeStartedError', mapOf([to('en', "The end time can't be before the start time."), to('es', 'La hora de fin no puede ser anterior a la hora de inicio.'), to('fr', "L'heure de fin ne peut pas \xEAtre ant\xE9rieure \xE0 l'heure de d\xE9but."), to('pt', 'A hora de t\xE9rmino n\xE3o pode ser anterior \xE0 hora de in\xEDcio.'), to('zh', '\u7ED3\u675F\u65F6\u95F4\u4E0D\u80FD\u65E9\u4E8E\u5F00\u59CB\u65F6\u95F4\u3002')])), to('logCenterActivity.locationHeading', mapOf([to('en', 'Location (optional)'), to('es', 'Ubicaci\xF3n (opcional)'), to('fr', 'Emplacement (facultatif)'), to('pt', 'Localiza\xE7\xE3o (opcional)'), to('zh', '\u4F4D\u7F6E\uFF08\u53EF\u9009\uFF09')])), to('logCenterActivity.latitudeLabel', mapOf([to('en', 'Latitude'), to('es', 'Latitud'), to('fr', 'Latitude'), to('pt', 'Latitude'), to('zh', '\u7EAC\u5EA6')])), to('logCenterActivity.longitudeLabel', mapOf([to('en', 'Longitude'), to('es', 'Longitud'), to('fr', 'Longitude'), to('pt', 'Longitude'), to('zh', '\u7ECF\u5EA6')])), to('logCenterActivity.useMyLocationButton', mapOf([to('en', 'Use current location'), to('es', 'Usar ubicaci\xF3n actual'), to('fr', 'Utiliser la position actuelle'), to('pt', 'Usar localiza\xE7\xE3o atual'), to('zh', '\u4F7F\u7528\u5F53\u524D\u4F4D\u7F6E')])), to('logCenterActivity.notesLabel', mapOf([to('en', 'Notes'), to('es', 'Notas'), to('fr', 'Notes'), to('pt', 'Notas'), to('zh', '\u5907\u6CE8')])), to('logCenterActivity.submitButton', mapOf([to('en', 'Log activity'), to('es', 'Registrar actividad'), to('fr', "Enregistrer l'activit\xE9"), to('pt', 'Registrar atividade'), to('zh', '\u8BB0\u5F55\u6D3B\u52A8')])), to('logCenterActivity.loggedSuccess', mapOf([to('en', 'Logged and verified.'), to('es', 'Registrado y verificado.'), to('fr', 'Enregistr\xE9 et v\xE9rifi\xE9.'), to('pt', 'Registrado e verificado.'), to('zh', '\u5DF2\u8BB0\u5F55\u5E76\u9A8C\u8BC1\u3002')])), to('logCenterActivity.unexpectedErrorPrefix', mapOf([to('en', 'Something went wrong: '), to('es', 'Algo sali\xF3 mal: '), to('fr', "Une erreur s'est produite : "), to('pt', 'Algo deu errado: '), to('zh', '\u51FA\u73B0\u95EE\u9898\uFF1A')])), to('login.title', mapOf([to('en', 'Log in'), to('es', 'Iniciar sesi\xF3n'), to('fr', 'Connexion'), to('pt', 'Entrar'), to('zh', '\u767B\u5F55')])), to('login.passkeyHeading', mapOf([to('en', 'Sign in with a passkey'), to('es', 'Iniciar sesi\xF3n con una clave de acceso'), to('fr', "Se connecter avec une cl\xE9 d'acc\xE8s"), to('pt', 'Entrar com uma chave de acesso'), to('zh', '\u4F7F\u7528\u901A\u884C\u5BC6\u94A5\u767B\u5F55')])), to('login.passkeyHint', mapOf([to('en', 'Use Face ID, Touch ID, or a security key \u2014 no password needed.'), to('es', 'Usa Face ID, Touch ID o una llave de seguridad \u2014 no necesitas contrase\xF1a.'), to('fr', 'Utilisez Face ID, Touch ID ou une cl\xE9 de s\xE9curit\xE9 \u2014 aucun mot de passe requis.'), to('pt', 'Use Face ID, Touch ID ou uma chave de seguran\xE7a \u2014 sem necessidade de senha.'), to('zh', '\u4F7F\u7528\u9762\u5BB9ID\u3001\u6307\u7EB9ID\u6216\u5B89\u5168\u5BC6\u94A5\u2014\u2014\u65E0\u9700\u5BC6\u7801\u3002')])), to('login.emailLabel', mapOf([to('en', 'Email'), to('es', 'Correo electr\xF3nico'), to('fr', 'E-mail'), to('pt', 'E-mail'), to('zh', '\u7535\u5B50\u90AE\u7BB1')])), to('login.continueWithPasskey', mapOf([to('en', 'Continue with passkey'), to('es', 'Continuar con clave de acceso'), to('fr', "Continuer avec une cl\xE9 d'acc\xE8s"), to('pt', 'Continuar com chave de acesso'), to('zh', '\u4F7F\u7528\u901A\u884C\u5BC6\u94A5\u7EE7\u7EED')])), to('login.orContinueWith', mapOf([to('en', 'or continue with'), to('es', 'o continuar con'), to('fr', 'ou continuer avec'), to('pt', 'ou continuar com'), to('zh', '\u6216\u4F7F\u7528\u4EE5\u4E0B\u65B9\u5F0F\u7EE7\u7EED')])), to('login.continueWithGoogle', mapOf([to('en', 'Continue with Google'), to('es', 'Continuar con Google'), to('fr', 'Continuer avec Google'), to('pt', 'Continuar com o Google'), to('zh', '\u4F7F\u7528Google\u7EE7\u7EED')])), to('login.continueWithFacebook', mapOf([to('en', 'Continue with Facebook'), to('es', 'Continuar con Facebook'), to('fr', 'Continuer avec Facebook'), to('pt', 'Continuar com o Facebook'), to('zh', '\u4F7F\u7528Facebook\u7EE7\u7EED')])), to('login.passwordSectionHeading', mapOf([to('en', 'Or use your password'), to('es', 'O usa tu contrase\xF1a'), to('fr', 'Ou utilisez votre mot de passe'), to('pt', 'Ou use sua senha'), to('zh', '\u6216\u4F7F\u7528\u5BC6\u7801\u767B\u5F55')])), to('login.passwordLabel', mapOf([to('en', 'Password'), to('es', 'Contrase\xF1a'), to('fr', 'Mot de passe'), to('pt', 'Senha'), to('zh', '\u5BC6\u7801')])), to('login.submitButton', mapOf([to('en', 'Log in'), to('es', 'Iniciar sesi\xF3n'), to('fr', 'Connexion'), to('pt', 'Entrar'), to('zh', '\u767B\u5F55')])), to('login.magicLinkSectionHeading', mapOf([to('en', 'Or email me a link'), to('es', 'O env\xEDame un enlace por correo'), to('fr', 'Ou envoyez-moi un lien par e-mail'), to('pt', 'Ou me envie um link por e-mail'), to('zh', '\u6216\u7ED9\u6211\u53D1\u9001\u767B\u5F55\u94FE\u63A5')])), to('login.sendMagicLinkButton', mapOf([to('en', 'Send me a sign-in link'), to('es', 'Enviarme un enlace de inicio de sesi\xF3n'), to('fr', "M'envoyer un lien de connexion"), to('pt', 'Enviar-me um link de acesso'), to('zh', '\u53D1\u9001\u767B\u5F55\u94FE\u63A5\u7ED9\u6211')])), to('login.genericErrorPrefix', mapOf([to('en', 'Something went wrong: '), to('es', 'Algo sali\xF3 mal: '), to('fr', "Une erreur s'est produite : "), to('pt', 'Algo deu errado: '), to('zh', '\u51FA\u73B0\u95EE\u9898\uFF1A')])), to('login.sessionExpiredMessage', mapOf([to('en', 'Your session has expired. Please log in again.'), to('es', 'Tu sesi\xF3n ha caducado. Por favor, inicia sesi\xF3n de nuevo.'), to('fr', 'Votre session a expir\xE9. Veuillez vous reconnecter.'), to('pt', 'Sua sess\xE3o expirou. Por favor, fa\xE7a login novamente.'), to('zh', '\u60A8\u7684\u4F1A\u8BDD\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55\u3002')])), to('login.passkeySignInFailedPrefix', mapOf([to('en', 'Passkey sign-in failed: '), to('es', 'Error al iniciar sesi\xF3n con la clave de acceso: '), to('fr', "\xC9chec de la connexion avec la cl\xE9 d'acc\xE8s : "), to('pt', 'Falha ao entrar com a chave de acesso: '), to('zh', '\u901A\u884C\u5BC6\u94A5\u767B\u5F55\u5931\u8D25\uFF1A')])), to('login.magicLinkSentMessage', mapOf([to('en', 'If that email has an account, a sign-in link is on its way.'), to('es', 'Si ese correo tiene una cuenta, un enlace de inicio de sesi\xF3n est\xE1 en camino.'), to('fr', 'Si cet e-mail est associ\xE9 \xE0 un compte, un lien de connexion est en route.'), to('pt', 'Se esse e-mail tiver uma conta, um link de acesso est\xE1 a caminho.'), to('zh', '\u5982\u679C\u8BE5\u90AE\u7BB1\u6709\u8D26\u6237\uFF0C\u767B\u5F55\u94FE\u63A5\u5373\u5C06\u53D1\u9001\u3002')])), to('magicLink.title', mapOf([to('en', 'Signing you in\u2026'), to('es', 'Iniciando sesi\xF3n\u2026'), to('fr', 'Connexion en cours\u2026'), to('pt', 'Entrando\u2026'), to('zh', '\u6B63\u5728\u767B\u5F55\u2026')])), to('magicLink.pleaseWait', mapOf([to('en', 'Please wait.'), to('es', 'Por favor, espera.'), to('fr', 'Veuillez patienter.'), to('pt', 'Aguarde, por favor.'), to('zh', '\u8BF7\u7A0D\u5019\u3002')])), to('magicLink.missingToken', mapOf([to('en', 'This link is missing its token. Request a new one from the login page.'), to('es', 'A este enlace le falta el token. Solicita uno nuevo desde la p\xE1gina de inicio de sesi\xF3n.'), to('fr', 'Ce lien ne contient pas de jeton. Demandez-en un nouveau depuis la page de connexion.'), to('pt', 'Este link est\xE1 sem o token. Solicite um novo na p\xE1gina de login.'), to('zh', '\u6B64\u94FE\u63A5\u7F3A\u5C11\u4EE4\u724C\u3002\u8BF7\u4ECE\u767B\u5F55\u9875\u9762\u7533\u8BF7\u4E00\u4E2A\u65B0\u7684\u94FE\u63A5\u3002')])), to('magicLink.expired', mapOf([to('en', 'This link is invalid or has expired.'), to('es', 'Este enlace no es v\xE1lido o ha caducado.'), to('fr', 'Ce lien est invalide ou a expir\xE9.'), to('pt', 'Este link \xE9 inv\xE1lido ou expirou.'), to('zh', '\u6B64\u94FE\u63A5\u65E0\u6548\u6216\u5DF2\u8FC7\u671F\u3002')])), to('magicLink.backToLogin', mapOf([to('en', 'Back to login'), to('es', 'Volver al inicio de sesi\xF3n'), to('fr', 'Retour \xE0 la connexion'), to('pt', 'Voltar para o login'), to('zh', '\u8FD4\u56DE\u767B\u5F55')])), to('magicLink.somethingWentWrong', mapOf([to('en', 'Something went wrong:'), to('es', 'Algo sali\xF3 mal:'), to('fr', "Une erreur s'est produite :"), to('pt', 'Algo deu errado:'), to('zh', '\u51FA\u73B0\u95EE\u9898\uFF1A')])), to('myBitacora.title', mapOf([to('en', 'My bit\xE1cora'), to('es', 'Mi bit\xE1cora'), to('fr', 'Mon bit\xE1cora'), to('pt', 'Minha bit\xE1cora'), to('zh', '\u6211\u7684 bit\xE1cora')])), to('myBitacora.activityLabel', mapOf([to('en', 'Activity'), to('es', 'Actividad'), to('fr', 'Activit\xE9'), to('pt', 'Atividade'), to('zh', '\u6D3B\u52A8')])), to('myBitacora.allActivities', mapOf([to('en', 'All activities'), to('es', 'Todas las actividades'), to('fr', 'Toutes les activit\xE9s'), to('pt', 'Todas as atividades'), to('zh', '\u6240\u6709\u6D3B\u52A8')])), to('myBitacora.fromLabel', mapOf([to('en', 'From'), to('es', 'Desde'), to('fr', 'Du'), to('pt', 'De'), to('zh', '\u4ECE')])), to('myBitacora.toLabel', mapOf([to('en', 'To'), to('es', 'Hasta'), to('fr', 'Au'), to('pt', 'At\xE9'), to('zh', '\u5230')])), to('myBitacora.filterButton', mapOf([to('en', 'Filter'), to('es', 'Filtrar'), to('fr', 'Filtrer'), to('pt', 'Filtrar'), to('zh', '\u7B5B\u9009')])), to('myBitacora.dateRangeInvalidError', mapOf([to('en', "The 'from' date must be on or before the 'to' date."), to('es', "La fecha 'desde' debe ser anterior o igual a la fecha 'hasta'."), to('fr', 'La date \xAB du \xBB doit \xEAtre ant\xE9rieure ou \xE9gale \xE0 la date \xAB au \xBB.'), to('pt', "A data 'de' deve ser anterior ou igual \xE0 data 'at\xE9'."), to('zh', '\u201C\u8D77\u59CB\u201D\u65E5\u671F\u5FC5\u987B\u65E9\u4E8E\u6216\u7B49\u4E8E\u201C\u622A\u6B62\u201D\u65E5\u671F\u3002')])), to('myBitacora.loading', mapOf([to('en', 'Loading\u2026'), to('es', 'Cargando\u2026'), to('fr', 'Chargement\u2026'), to('pt', 'Carregando\u2026'), to('zh', '\u52A0\u8F7D\u4E2D\u2026')])), to('myBitacora.loadError', mapOf([to('en', 'Could not load your bit\xE1cora'), to('es', 'No se pudo cargar tu bit\xE1cora'), to('fr', 'Impossible de charger votre bit\xE1cora'), to('pt', 'N\xE3o foi poss\xEDvel carregar sua bit\xE1cora'), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u60A8\u7684 bit\xE1cora')])), to('myBitacora.noActivities', mapOf([to('en', 'No activities logged for this filter.'), to('es', 'No hay actividades registradas para este filtro.'), to('fr', 'Aucune activit\xE9 enregistr\xE9e pour ce filtre.'), to('pt', 'Nenhuma atividade registrada para este filtro.'), to('zh', '\u6CA1\u6709\u7B26\u5408\u6B64\u7B5B\u9009\u6761\u4EF6\u7684\u6D3B\u52A8\u8BB0\u5F55\u3002')])), to('myBitacora.loggedAtLabel', mapOf([to('en', 'Logged at'), to('es', 'Registrado el'), to('fr', 'Enregistr\xE9 le'), to('pt', 'Registrado em'), to('zh', '\u8BB0\u5F55\u4E8E')])), to('myBitacora.notesLabel', mapOf([to('en', 'Notes'), to('es', 'Notas'), to('fr', 'Notes'), to('pt', 'Notas'), to('zh', '\u5907\u6CE8')])), to('myBitacora.noLocation', mapOf([to('en', 'No location recorded for this entry.'), to('es', 'No hay ubicaci\xF3n registrada para esta entrada.'), to('fr', 'Aucun emplacement enregistr\xE9 pour cette entr\xE9e.'), to('pt', 'Nenhuma localiza\xE7\xE3o registrada para este registro.'), to('zh', '\u6B64\u6761\u76EE\u6CA1\u6709\u8BB0\u5F55\u4F4D\u7F6E\u4FE1\u606F\u3002')])), to('myBitacora.archiveUpsell', mapOf([to('en', 'You have activities older than a year. Unlock full history for a small monthly fee.'), to('es', 'Tienes actividades de hace m\xE1s de un a\xF1o. Desbloquea el historial completo por una peque\xF1a tarifa mensual.'), to('fr', "Vous avez des activit\xE9s de plus d'un an. D\xE9bloquez l'historique complet pour un petit tarif mensuel."), to('pt', 'Voc\xEA tem atividades com mais de um ano. Desbloqueie o hist\xF3rico completo por uma pequena taxa mensal.'), to('zh', '\u60A8\u6709\u4E00\u5E74\u4EE5\u4E0A\u7684\u6D3B\u52A8\u8BB0\u5F55\u3002\u652F\u4ED8\u5C11\u91CF\u6708\u8D39\u5373\u53EF\u89E3\u9501\u5B8C\u6574\u5386\u53F2\u8BB0\u5F55\u3002')])), to('upsell.cta', mapOf([to('en', 'Unlock'), to('es', 'Desbloquear'), to('fr', 'D\xE9bloquer'), to('pt', 'Desbloquear'), to('zh', '\u89E3\u9501')])), to('upsell.errorPrefix', mapOf([to('en', 'Could not start checkout: '), to('es', 'No se pudo iniciar el pago: '), to('fr', 'Impossible de d\xE9marrer le paiement : '), to('pt', 'N\xE3o foi poss\xEDvel iniciar o checkout: '), to('zh', '\u65E0\u6CD5\u5F00\u59CB\u7ED3\u8D26:')])), to('oauthCallback.title', mapOf([to('en', 'Signing you in\u2026'), to('es', 'Iniciando sesi\xF3n\u2026'), to('fr', 'Connexion en cours\u2026'), to('pt', 'Entrando\u2026'), to('zh', '\u6B63\u5728\u767B\u5F55\u2026')])), to('oauthCallback.pleaseWait', mapOf([to('en', 'Please wait.'), to('es', 'Por favor, espera.'), to('fr', 'Veuillez patienter.'), to('pt', 'Aguarde, por favor.'), to('zh', '\u8BF7\u7A0D\u5019\u3002')])), to('oauthCallback.missingHandoff', mapOf([to('en', 'This sign-in link is missing its handoff code.'), to('es', 'A este enlace de inicio de sesi\xF3n le falta el c\xF3digo de traspaso.'), to('fr', 'Ce lien de connexion ne contient pas de code de transfert.'), to('pt', 'Este link de login est\xE1 sem o c\xF3digo de transfer\xEAncia.'), to('zh', '\u6B64\u767B\u5F55\u94FE\u63A5\u7F3A\u5C11\u4EA4\u63A5\u4EE3\u7801\u3002')])), to('oauthCallback.backToLogin', mapOf([to('en', 'Back to login'), to('es', 'Volver al inicio de sesi\xF3n'), to('fr', 'Retour \xE0 la connexion'), to('pt', 'Voltar para o login'), to('zh', '\u8FD4\u56DE\u767B\u5F55')])), to('oauthCallback.signInFailed', mapOf([to('en', 'Sign-in failed'), to('es', 'Error al iniciar sesi\xF3n'), to('fr', '\xC9chec de la connexion'), to('pt', 'Falha ao entrar'), to('zh', '\u767B\u5F55\u5931\u8D25')])), to('oauthCallback.somethingWentWrong', mapOf([to('en', 'Something went wrong'), to('es', 'Algo sali\xF3 mal'), to('fr', 'Une erreur est survenue'), to('pt', 'Algo deu errado'), to('zh', '\u51FA\u4E86\u70B9\u95EE\u9898')])), to('pendingApprovals.title', mapOf([to('en', 'Pending approvals'), to('es', 'Aprobaciones pendientes'), to('fr', 'Approbations en attente'), to('pt', 'Aprova\xE7\xF5es pendentes'), to('zh', '\u5F85\u5BA1\u6279')])), to('pendingApprovals.loading', mapOf([to('en', 'Loading\u2026'), to('es', 'Cargando\u2026'), to('fr', 'Chargement\u2026'), to('pt', 'Carregando\u2026'), to('zh', '\u52A0\u8F7D\u4E2D\u2026')])), to('pendingApprovals.claimInvitationsTitle', mapOf([to('en', 'Claim invitations'), to('es', 'Invitaciones de reclamo'), to('fr', 'Invitations de r\xE9clamation'), to('pt', 'Convites de reivindica\xE7\xE3o'), to('zh', '\u8BA4\u9886\u9080\u8BF7')])), to('pendingApprovals.claimInvitationsDescription', mapOf([to('en', 'Activity centers inviting you to claim a walk-in entry they logged for you.'), to('es', 'Centros de actividad que te invitan a reclamar un registro de entrada directa que anotaron por ti.'), to('fr', "Centres d'activit\xE9 vous invitant \xE0 r\xE9clamer une entr\xE9e sans rendez-vous qu'ils ont enregistr\xE9e pour vous."), to('pt', 'Centros de atividade convidando voc\xEA a reivindicar um registro avulso que fizeram para voc\xEA.'), to('zh', '\u6D3B\u52A8\u4E2D\u5FC3\u9080\u8BF7\u60A8\u8BA4\u9886\u4ED6\u4EEC\u4E3A\u60A8\u8BB0\u5F55\u7684\u4E34\u65F6\u5165\u573A\u8BB0\u5F55\u3002')])), to('pendingApprovals.claimsLoadError', mapOf([to('en', 'Could not load claim invitations: '), to('es', 'No se pudieron cargar las invitaciones de reclamo: '), to('fr', 'Impossible de charger les invitations de r\xE9clamation : '), to('pt', 'N\xE3o foi poss\xEDvel carregar os convites de reivindica\xE7\xE3o: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u8BA4\u9886\u9080\u8BF7\uFF1A')])), to('pendingApprovals.noClaimInvitations', mapOf([to('en', 'No pending claim invitations.'), to('es', 'No hay invitaciones de reclamo pendientes.'), to('fr', 'Aucune invitation de r\xE9clamation en attente.'), to('pt', 'Nenhum convite de reivindica\xE7\xE3o pendente.'), to('zh', '\u6682\u65E0\u5F85\u5904\u7406\u7684\u8BA4\u9886\u9080\u8BF7\u3002')])), to('pendingApprovals.claimInvitationFrom', mapOf([to('en', 'Invitation to claim an activity entry, from company '), to('es', 'Invitaci\xF3n para reclamar un registro de actividad, de la empresa '), to('fr', "Invitation \xE0 r\xE9clamer une entr\xE9e d'activit\xE9, de l'entreprise "), to('pt', 'Convite para reivindicar um registro de atividade, da empresa '), to('zh', '\u8BA4\u9886\u6D3B\u52A8\u8BB0\u5F55\u7684\u9080\u8BF7\uFF0C\u6765\u81EA\u516C\u53F8 ')])), to('pendingApprovals.respondBy', mapOf([to('en', 'Respond by: '), to('es', 'Responder antes de: '), to('fr', 'R\xE9pondre avant le : '), to('pt', 'Responder at\xE9: '), to('zh', '\u56DE\u590D\u622A\u6B62\uFF1A')])), to('pendingApprovals.approve', mapOf([to('en', 'Approve'), to('es', 'Aprobar'), to('fr', 'Approuver'), to('pt', 'Aprovar'), to('zh', '\u6279\u51C6')])), to('pendingApprovals.reject', mapOf([to('en', 'Reject'), to('es', 'Rechazar'), to('fr', 'Rejeter'), to('pt', 'Rejeitar'), to('zh', '\u62D2\u7EDD')])), to('pendingApprovals.pendingLoadError', mapOf([to('en', 'Could not load pending approvals: '), to('es', 'No se pudieron cargar las aprobaciones pendientes: '), to('fr', 'Impossible de charger les approbations en attente : '), to('pt', 'N\xE3o foi poss\xEDvel carregar as aprova\xE7\xF5es pendentes: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u5F85\u5BA1\u6279\u4E8B\u9879\uFF1A')])), to('pendingApprovals.nothingPending', mapOf([to('en', 'Nothing waiting on you right now.'), to('es', 'No hay nada pendiente para ti en este momento.'), to('fr', 'Rien ne vous attend pour le moment.'), to('pt', 'Nada pendente para voc\xEA no momento.'), to('zh', '\u76EE\u524D\u6CA1\u6709\u9700\u8981\u60A8\u5904\u7406\u7684\u4E8B\u9879\u3002')])), to('pendingApprovals.fromUser', mapOf([to('en', 'From: '), to('es', 'De: '), to('fr', 'De : '), to('pt', 'De: '), to('zh', '\u6765\u81EA\uFF1A')])), to('pendingApprovals.unknownGuestName', mapOf([to('en', 'unknown'), to('es', 'desconocido'), to('fr', 'inconnu'), to('pt', 'desconhecido'), to('zh', '\u672A\u77E5')])), to('pendingApprovals.loggedAt', mapOf([to('en', 'Logged at: '), to('es', 'Registrado el: '), to('fr', 'Enregistr\xE9 le : '), to('pt', 'Registrado em: '), to('zh', '\u8BB0\u5F55\u65F6\u95F4\uFF1A')])), to('pendingApprovals.notes', mapOf([to('en', 'Notes: '), to('es', 'Notas: '), to('fr', 'Notes : '), to('pt', 'Notas: '), to('zh', '\u5907\u6CE8\uFF1A')])), to('profile.title', mapOf([to('en', 'Profile'), to('es', 'Perfil'), to('fr', 'Profil'), to('pt', 'Perfil'), to('zh', '\u4E2A\u4EBA\u8D44\u6599')])), to('profile.loading', mapOf([to('en', 'Loading\u2026'), to('es', 'Cargando\u2026'), to('fr', 'Chargement\u2026'), to('pt', 'Carregando\u2026'), to('zh', '\u52A0\u8F7D\u4E2D\u2026')])), to('profile.loadError', mapOf([to('en', 'Could not load your profile: '), to('es', 'No se pudo cargar tu perfil: '), to('fr', 'Impossible de charger votre profil : '), to('pt', 'N\xE3o foi poss\xEDvel carregar seu perfil: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u60A8\u7684\u4E2A\u4EBA\u8D44\u6599\uFF1A')])), to('profile.avatarAlt', mapOf([to('en', 'Avatar'), to('es', 'Avatar'), to('fr', 'Avatar'), to('pt', 'Avatar'), to('zh', '\u5934\u50CF')])), to('profile.emailLabel', mapOf([to('en', 'Email: '), to('es', 'Correo electr\xF3nico: '), to('fr', 'E-mail : '), to('pt', 'E-mail: '), to('zh', '\u7535\u5B50\u90AE\u7BB1\uFF1A')])), to('profile.companyLabel', mapOf([to('en', 'Company: '), to('es', 'Empresa: '), to('fr', 'Entreprise : '), to('pt', 'Empresa: '), to('zh', '\u516C\u53F8\uFF1A')])), to('profile.roleLabel', mapOf([to('en', 'Role: '), to('es', 'Rol: '), to('fr', 'R\xF4le : '), to('pt', 'Fun\xE7\xE3o: '), to('zh', '\u89D2\u8272\uFF1A')])), to('profile.activityPractitioner', mapOf([to('en', 'Activity practitioner'), to('es', 'Practicante de actividad'), to('fr', "Pratiquant d'activit\xE9"), to('pt', 'Praticante de atividade'), to('zh', '\u6D3B\u52A8\u53C2\u4E0E\u8005')])), to('profile.activitiesHeading', mapOf([to('en', 'Activities'), to('es', 'Actividades'), to('fr', 'Activit\xE9s'), to('pt', 'Atividades'), to('zh', '\u6D3B\u52A8')])), to('profile.manageActivitiesLink', mapOf([to('en', 'Manage which activities I practice'), to('es', 'Gestionar las actividades que practico'), to('fr', 'G\xE9rer les activit\xE9s que je pratique'), to('pt', 'Gerenciar as atividades que pratico'), to('zh', '\u7BA1\u7406\u6211\u53C2\u4E0E\u7684\u6D3B\u52A8')])), to('profile.displayNameHeading', mapOf([to('en', 'Display name'), to('es', 'Nombre para mostrar'), to('fr', "Nom d'affichage"), to('pt', 'Nome de exibi\xE7\xE3o'), to('zh', '\u663E\u793A\u540D\u79F0')])), to('profile.saveButton', mapOf([to('en', 'Save'), to('es', 'Guardar'), to('fr', 'Enregistrer'), to('pt', 'Salvar'), to('zh', '\u4FDD\u5B58')])), to('profile.avatarHeading', mapOf([to('en', 'Avatar'), to('es', 'Avatar'), to('fr', 'Avatar'), to('pt', 'Avatar'), to('zh', '\u5934\u50CF')])), to('profile.uploadButton', mapOf([to('en', 'Upload'), to('es', 'Subir'), to('fr', 'T\xE9l\xE9verser'), to('pt', 'Enviar'), to('zh', '\u4E0A\u4F20')])), to('profile.manageOfferingsLink', mapOf([to('en', 'Manage activity offerings'), to('es', 'Gestionar ofertas de actividades'), to('fr', "G\xE9rer les offres d'activit\xE9s"), to('pt', 'Gerenciar ofertas de atividades'), to('zh', '\u7BA1\u7406\u6D3B\u52A8\u9879\u76EE')])), to('profile.logActivityLink', mapOf([to('en', 'Log an activity for a practitioner'), to('es', 'Registrar una actividad para un practicante'), to('fr', 'Enregistrer une activit\xE9 pour un pratiquant'), to('pt', 'Registrar uma atividade para um praticante'), to('zh', '\u4E3A\u53C2\u4E0E\u8005\u8BB0\u5F55\u6D3B\u52A8')])), to('profile.centerActivityLogLink', mapOf([to('en', "This center's activity log"), to('es', 'Registro de actividades de este centro'), to('fr', "Journal d'activit\xE9 de ce centre"), to('pt', 'Registro de atividades deste centro'), to('zh', '\u672C\u4E2D\u5FC3\u7684\u6D3B\u52A8\u8BB0\u5F55')])), to('profile.savedAsPrefix', mapOf([to('en', 'Saved as "'), to('es', 'Guardado como "'), to('fr', 'Enregistr\xE9 sous "'), to('pt', 'Salvo como "'), to('zh', '\u5DF2\u4FDD\u5B58\u4E3A\u201C')])), to('profile.savedAsSuffix', mapOf([to('en', '".'), to('es', '".'), to('fr', '".'), to('pt', '".'), to('zh', '\u201D\u3002')])), to('profile.chooseFileFirst', mapOf([to('en', 'Choose a file first.'), to('es', 'Elige un archivo primero.'), to('fr', "Choisissez d'abord un fichier."), to('pt', 'Escolha um arquivo primeiro.'), to('zh', '\u8BF7\u5148\u9009\u62E9\u4E00\u4E2A\u6587\u4EF6\u3002')])), to('profile.uploadedStatus', mapOf([to('en', 'Uploaded.'), to('es', 'Subido.'), to('fr', 'T\xE9l\xE9vers\xE9.'), to('pt', 'Enviado.'), to('zh', '\u5DF2\u4E0A\u4F20\u3002')])), to('profile.uploadFailedPrefix', mapOf([to('en', 'Upload failed: '), to('es', 'Error al subir: '), to('fr', '\xC9chec du t\xE9l\xE9versement : '), to('pt', 'Falha no envio: '), to('zh', '\u4E0A\u4F20\u5931\u8D25\uFF1A')])), to('profile.somethingWentWrongPrefix', mapOf([to('en', 'Something went wrong: '), to('es', 'Algo sali\xF3 mal: '), to('fr', "Une erreur s'est produite : "), to('pt', 'Algo deu errado: '), to('zh', '\u51FA\u73B0\u9519\u8BEF\uFF1A')])), to('registerCompany.title', mapOf([to('en', 'Register a company'), to('es', 'Registrar una empresa'), to('fr', 'Inscrire une entreprise'), to('pt', 'Registrar uma empresa'), to('zh', '\u6CE8\u518C\u516C\u53F8')])), to('registerCompany.companyTypeLabel', mapOf([to('en', 'Company type'), to('es', 'Tipo de empresa'), to('fr', "Type d'entreprise"), to('pt', 'Tipo de empresa'), to('zh', '\u516C\u53F8\u7C7B\u578B')])), to('registerCompany.typeActivityCenter', mapOf([to('en', 'Activity center'), to('es', 'Centro de actividades'), to('fr', "Centre d'activit\xE9s"), to('pt', 'Centro de atividades'), to('zh', '\u6D3B\u52A8\u4E2D\u5FC3')])), to('registerCompany.typeCertificationIssuer', mapOf([to('en', 'Certification issuer'), to('es', 'Emisor de certificaciones'), to('fr', 'Organisme de certification'), to('pt', 'Emissor de certifica\xE7\xF5es'), to('zh', '\u8BA4\u8BC1\u9881\u53D1\u673A\u6784')])), to('registerCompany.typeMarketer', mapOf([to('en', 'Marketer'), to('es', 'Comercializador'), to('fr', 'Commercialisateur'), to('pt', 'Divulgador'), to('zh', '\u8425\u9500\u65B9')])), to('registerCompany.companyNameLabel', mapOf([to('en', 'Company name'), to('es', 'Nombre de la empresa'), to('fr', "Nom de l'entreprise"), to('pt', 'Nome da empresa'), to('zh', '\u516C\u53F8\u540D\u79F0')])), to('registerCompany.fiscalIdLabel', mapOf([to('en', 'Fiscal ID'), to('es', 'Identificaci\xF3n fiscal'), to('fr', 'Num\xE9ro fiscal'), to('pt', 'Identifica\xE7\xE3o fiscal'), to('zh', '\u7A0E\u52A1\u8BC6\u522B\u53F7')])), to('registerCompany.companyEmailLabel', mapOf([to('en', 'Company email'), to('es', 'Correo electr\xF3nico de la empresa'), to('fr', "E-mail de l'entreprise"), to('pt', 'E-mail da empresa'), to('zh', '\u516C\u53F8\u7535\u5B50\u90AE\u7BB1')])), to('registerCompany.phoneLabel', mapOf([to('en', 'Phone'), to('es', 'Tel\xE9fono'), to('fr', 'T\xE9l\xE9phone'), to('pt', 'Telefone'), to('zh', '\u7535\u8BDD')])), to('registerCompany.addressLabel', mapOf([to('en', 'Address'), to('es', 'Direcci\xF3n'), to('fr', 'Adresse'), to('pt', 'Endere\xE7o'), to('zh', '\u5730\u5740')])), to('registerCompany.websiteLabel', mapOf([to('en', 'Website (optional)'), to('es', 'Sitio web (opcional)'), to('fr', 'Site web (facultatif)'), to('pt', 'Site (opcional)'), to('zh', '\u7F51\u7AD9\uFF08\u53EF\u9009\uFF09')])), to('registerCompany.adminAccountHeading', mapOf([to('en', 'Admin account'), to('es', 'Cuenta de administrador'), to('fr', 'Compte administrateur'), to('pt', 'Conta de administrador'), to('zh', '\u7BA1\u7406\u5458\u8D26\u6237')])), to('registerCompany.adminEmailLabel', mapOf([to('en', 'Admin email'), to('es', 'Correo del administrador'), to('fr', "E-mail de l'administrateur"), to('pt', 'E-mail do administrador'), to('zh', '\u7BA1\u7406\u5458\u7535\u5B50\u90AE\u7BB1')])), to('registerCompany.adminNameLabel', mapOf([to('en', 'Admin name'), to('es', 'Nombre del administrador'), to('fr', "Nom de l'administrateur"), to('pt', 'Nome do administrador'), to('zh', '\u7BA1\u7406\u5458\u59D3\u540D')])), to('registerCompany.submitButton', mapOf([to('en', 'Register company'), to('es', 'Registrar empresa'), to('fr', "Inscrire l'entreprise"), to('pt', 'Registrar empresa'), to('zh', '\u6CE8\u518C\u516C\u53F8')])), to('registerCompany.genericError', mapOf([to('en', 'Something went wrong:'), to('es', 'Algo sali\xF3 mal:'), to('fr', "Une erreur s'est produite :"), to('pt', 'Algo deu errado:'), to('zh', '\u51FA\u9519\u4E86\uFF1A')])), to('registerPractitioner.title', mapOf([to('en', 'Register as a practitioner'), to('es', 'Reg\xEDstrate como practicante'), to('fr', "S'inscrire en tant que pratiquant"), to('pt', 'Cadastre-se como praticante'), to('zh', '\u6CE8\u518C\u4E3A\u7EC3\u4E60\u8005')])), to('registerPractitioner.emailLabel', mapOf([to('en', 'Email'), to('es', 'Correo electr\xF3nico'), to('fr', 'E-mail'), to('pt', 'E-mail'), to('zh', '\u7535\u5B50\u90AE\u4EF6')])), to('registerPractitioner.displayNameLabel', mapOf([to('en', 'Display name'), to('es', 'Nombre para mostrar'), to('fr', "Nom d'affichage"), to('pt', 'Nome de exibi\xE7\xE3o'), to('zh', '\u663E\u793A\u540D\u79F0')])), to('registerPractitioner.registerButton', mapOf([to('en', 'Register'), to('es', 'Registrarse'), to('fr', "S'inscrire"), to('pt', 'Registrar-se'), to('zh', '\u6CE8\u518C')])), to('registerPractitioner.genericErrorPrefix', mapOf([to('en', 'Something went wrong:'), to('es', 'Algo sali\xF3 mal:'), to('fr', "Une erreur s'est produite :"), to('pt', 'Algo deu errado:'), to('zh', '\u51FA\u73B0\u9519\u8BEF\uFF1A')])), to('requestCertVisibility.title', mapOf([to('en', 'Certification visibility requests'), to('es', 'Solicitudes de visibilidad de certificaciones'), to('fr', 'Demandes de visibilit\xE9 des certifications'), to('pt', 'Solicita\xE7\xF5es de visibilidade de certifica\xE7\xF5es'), to('zh', '\u8BA4\u8BC1\u53EF\u89C1\u6027\u8BF7\u6C42')])), to('requestCertVisibility.loading', mapOf([to('en', 'Loading\u2026'), to('es', 'Cargando\u2026'), to('fr', 'Chargement\u2026'), to('pt', 'Carregando\u2026'), to('zh', '\u52A0\u8F7D\u4E2D\u2026')])), to('requestCertVisibility.staffOnly', mapOf([to('en', 'This page is only available to company staff.'), to('es', 'Esta p\xE1gina solo est\xE1 disponible para el personal de la empresa.'), to('fr', "Cette page est r\xE9serv\xE9e au personnel de l'entreprise."), to('pt', 'Esta p\xE1gina est\xE1 dispon\xEDvel apenas para a equipe da empresa.'), to('zh', '\u6B64\u9875\u9762\u4EC5\u4F9B\u516C\u53F8\u5458\u5DE5\u4F7F\u7528\u3002')])), to('requestCertVisibility.profileLoadError', mapOf([to('en', 'Could not load your profile: '), to('es', 'No se pudo cargar tu perfil: '), to('fr', 'Impossible de charger votre profil : '), to('pt', 'N\xE3o foi poss\xEDvel carregar seu perfil: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u60A8\u7684\u4E2A\u4EBA\u8D44\u6599\uFF1A')])), to('requestCertVisibility.offeringsHeading', mapOf([to('en', 'Activities we offer'), to('es', 'Actividades que ofrecemos'), to('fr', 'Activit\xE9s que nous proposons'), to('pt', 'Atividades que oferecemos'), to('zh', '\u6211\u4EEC\u63D0\u4F9B\u7684\u6D3B\u52A8')])), to('requestCertVisibility.saveOfferingsButton', mapOf([to('en', 'Save offerings'), to('es', 'Guardar actividades ofrecidas'), to('fr', 'Enregistrer les activit\xE9s propos\xE9es'), to('pt', 'Salvar atividades oferecidas'), to('zh', '\u4FDD\u5B58\u6D3B\u52A8\u9879\u76EE')])), to('requestCertVisibility.requestHeading', mapOf([to('en', 'Request a certification check'), to('es', 'Solicitar una verificaci\xF3n de certificaci\xF3n'), to('fr', 'Demander une v\xE9rification de certification'), to('pt', 'Solicitar uma verifica\xE7\xE3o de certifica\xE7\xE3o'), to('zh', '\u7533\u8BF7\u8BA4\u8BC1\u6838\u67E5')])), to('requestCertVisibility.activityLabel', mapOf([to('en', 'Activity'), to('es', 'Actividad'), to('fr', 'Activit\xE9'), to('pt', 'Atividade'), to('zh', '\u6D3B\u52A8')])), to('requestCertVisibility.emailsLabel', mapOf([to('en', 'Practitioner emails (one per line \u2014 only emails a practitioner gave you directly)'), to('es', 'Correos electr\xF3nicos de los practicantes (uno por l\xEDnea; solo correos que el practicante te dio directamente)'), to('fr', 'E-mails des praticiens (un par ligne \u2014 uniquement des e-mails fournis directement par le praticien)'), to('pt', 'E-mails dos praticantes (um por linha \u2014 apenas e-mails que o praticante forneceu diretamente a voc\xEA)'), to('zh', '\u4ECE\u4E1A\u8005\u90AE\u7BB1\uFF08\u6BCF\u884C\u4E00\u4E2A\u2014\u2014\u4EC5\u9650\u4ECE\u4E1A\u8005\u76F4\u63A5\u63D0\u4F9B\u7ED9\u60A8\u7684\u90AE\u7BB1\uFF09')])), to('requestCertVisibility.submitButton', mapOf([to('en', 'Request'), to('es', 'Solicitar'), to('fr', 'Demander'), to('pt', 'Solicitar'), to('zh', '\u7533\u8BF7')])), to('requestCertVisibility.sentRequestsHeading', mapOf([to('en', 'Sent requests'), to('es', 'Solicitudes enviadas'), to('fr', 'Demandes envoy\xE9es'), to('pt', 'Solicita\xE7\xF5es enviadas'), to('zh', '\u5DF2\u53D1\u9001\u7684\u8BF7\u6C42')])), to('requestCertVisibility.offeringsLoadError', mapOf([to('en', 'Could not load offerings: '), to('es', 'No se pudieron cargar las actividades ofrecidas: '), to('fr', 'Impossible de charger les activit\xE9s propos\xE9es : '), to('pt', 'N\xE3o foi poss\xEDvel carregar as atividades oferecidas: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u5DF2\u63D0\u4F9B\u7684\u6D3B\u52A8\uFF1A')])), to('requestCertVisibility.noOfferingsOption', mapOf([to('en', 'Set your offered activities above first'), to('es', 'Primero configura las actividades que ofreces arriba'), to('fr', "Configurez d'abord vos activit\xE9s propos\xE9es ci-dessus"), to('pt', 'Primeiro configure as atividades que voc\xEA oferece acima'), to('zh', '\u8BF7\u5148\u5728\u4E0A\u65B9\u8BBE\u7F6E\u60A8\u63D0\u4F9B\u7684\u6D3B\u52A8')])), to('requestCertVisibility.savedStatus', mapOf([to('en', 'Saved.'), to('es', 'Guardado.'), to('fr', 'Enregistr\xE9.'), to('pt', 'Salvo.'), to('zh', '\u5DF2\u4FDD\u5B58\u3002')])), to('requestCertVisibility.selectActivityError', mapOf([to('en', 'Select an activity your center offers.'), to('es', 'Selecciona una actividad que ofrezca tu centro.'), to('fr', 'S\xE9lectionnez une activit\xE9 propos\xE9e par votre centre.'), to('pt', 'Selecione uma atividade que seu centro oferece.'), to('zh', '\u8BF7\u9009\u62E9\u60A8\u4E2D\u5FC3\u63D0\u4F9B\u7684\u4E00\u9879\u6D3B\u52A8\u3002')])), to('requestCertVisibility.enterEmailError', mapOf([to('en', 'Enter at least one practitioner email.'), to('es', 'Ingresa al menos un correo electr\xF3nico de practicante.'), to('fr', 'Saisissez au moins un e-mail de praticien.'), to('pt', 'Insira pelo menos um e-mail de praticante.'), to('zh', '\u8BF7\u81F3\u5C11\u8F93\u5165\u4E00\u4E2A\u4ECE\u4E1A\u8005\u7684\u90AE\u7BB1\u3002')])), to('requestCertVisibility.submittedStatus', mapOf([to('en', 'Submitted.'), to('es', 'Enviado.'), to('fr', 'Envoy\xE9.'), to('pt', 'Enviado.'), to('zh', '\u5DF2\u63D0\u4EA4\u3002')])), to('requestCertVisibility.outcomeCreated', mapOf([to('en', 'request sent'), to('es', 'solicitud enviada'), to('fr', 'demande envoy\xE9e'), to('pt', 'solicita\xE7\xE3o enviada'), to('zh', '\u8BF7\u6C42\u5DF2\u53D1\u9001')])), to('requestCertVisibility.outcomeNoAccount', mapOf([to('en', 'no account found for this email'), to('es', 'no se encontr\xF3 ninguna cuenta para este correo electr\xF3nico'), to('fr', 'aucun compte trouv\xE9 pour cet e-mail'), to('pt', 'nenhuma conta encontrada para este e-mail'), to('zh', '\u672A\u627E\u5230\u4E0E\u6B64\u90AE\u7BB1\u5BF9\u5E94\u7684\u8D26\u6237')])), to('requestCertVisibility.outcomeDuplicatePending', mapOf([to('en', 'a request is already pending for this practitioner and activity'), to('es', 'ya hay una solicitud pendiente para este practicante y esta actividad'), to('fr', 'une demande est d\xE9j\xE0 en attente pour ce praticien et cette activit\xE9'), to('pt', 'j\xE1 existe uma solicita\xE7\xE3o pendente para este praticante e esta atividade'), to('zh', '\u8BE5\u4ECE\u4E1A\u8005\u548C\u6D3B\u52A8\u5DF2\u6709\u5F85\u5904\u7406\u7684\u8BF7\u6C42')])), to('requestCertVisibility.sentRequestsLoadError', mapOf([to('en', 'Could not load sent requests: '), to('es', 'No se pudieron cargar las solicitudes enviadas: '), to('fr', 'Impossible de charger les demandes envoy\xE9es : '), to('pt', 'N\xE3o foi poss\xEDvel carregar as solicita\xE7\xF5es enviadas: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u5DF2\u53D1\u9001\u7684\u8BF7\u6C42\uFF1A')])), to('requestCertVisibility.noRequestsSent', mapOf([to('en', 'No requests sent yet.'), to('es', 'A\xFAn no se han enviado solicitudes.'), to('fr', 'Aucune demande envoy\xE9e pour le moment.'), to('pt', 'Ainda n\xE3o h\xE1 solicita\xE7\xF5es enviadas.'), to('zh', '\u5C1A\u672A\u53D1\u9001\u4EFB\u4F55\u8BF7\u6C42\u3002')])), to('requestCertVisibility.statusPrefix', mapOf([to('en', 'Status: '), to('es', 'Estado: '), to('fr', 'Statut : '), to('pt', 'Status: '), to('zh', '\u72B6\u6001\uFF1A')])), to('requestCertVisibility.viewCertificationsButton', mapOf([to('en', 'View certifications'), to('es', 'Ver certificaciones'), to('fr', 'Voir les certifications'), to('pt', 'Ver certifica\xE7\xF5es'), to('zh', '\u67E5\u770B\u8BA4\u8BC1')])), to('requestCertVisibility.noCertificationsOnFile', mapOf([to('en', 'No certifications on file for this activity.'), to('es', 'No hay certificaciones registradas para esta actividad.'), to('fr', 'Aucune certification enregistr\xE9e pour cette activit\xE9.'), to('pt', 'N\xE3o h\xE1 certifica\xE7\xF5es registradas para esta atividade.'), to('zh', '\u8BE5\u6D3B\u52A8\u5C1A\u65E0\u5B58\u6863\u8BA4\u8BC1\u3002')])), to('requestCertVisibility.certificatePrefix', mapOf([to('en', 'Certificate '), to('es', 'Certificado '), to('fr', 'Certificat '), to('pt', 'Certificado '), to('zh', '\u8BC1\u4E66 ')])), to('requestCertVisibility.certificateIssuedSuffix', mapOf([to('en', ' (issued '), to('es', ' (emitido el '), to('fr', ' (d\xE9livr\xE9 le '), to('pt', ' (emitido em '), to('zh', '\uFF08\u9881\u53D1\u4E8E ')])), to('requestCertVisibility.certificationsLoadError', mapOf([to('en', 'Could not load certifications: '), to('es', 'No se pudieron cargar las certificaciones: '), to('fr', 'Impossible de charger les certifications : '), to('pt', 'N\xE3o foi poss\xEDvel carregar as certifica\xE7\xF5es: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u8BA4\u8BC1\uFF1A')])), to('setup.title', mapOf([to('en', 'Finish setting up your account'), to('es', 'Termina de configurar tu cuenta'), to('fr', 'Terminez la configuration de votre compte'), to('pt', 'Conclua a configura\xE7\xE3o da sua conta'), to('zh', '\u5B8C\u6210\u8D26\u6237\u8BBE\u7F6E')])), to('setup.missingToken', mapOf([to('en', 'This link is missing its token. Request a new one by trying to log in again.'), to('es', 'A este enlace le falta el token. Solicita uno nuevo intentando iniciar sesi\xF3n de nuevo.'), to('fr', 'Ce lien ne contient pas de jeton. Demandez-en un nouveau en essayant de vous reconnecter.'), to('pt', 'Este link est\xE1 sem o token. Solicite um novo tentando fazer login novamente.'), to('zh', '\u6B64\u94FE\u63A5\u7F3A\u5C11\u4EE4\u724C\u3002\u8BF7\u91CD\u65B0\u5C1D\u8BD5\u767B\u5F55\u4EE5\u83B7\u53D6\u65B0\u94FE\u63A5\u3002')])), to('setup.yourName', mapOf([to('en', 'Your name'), to('es', 'Tu nombre'), to('fr', 'Votre nom'), to('pt', 'Seu nome'), to('zh', '\u60A8\u7684\u59D3\u540D')])), to('setup.submitButton', mapOf([to('en', 'Finish setup'), to('es', 'Finalizar configuraci\xF3n'), to('fr', 'Terminer la configuration'), to('pt', 'Concluir configura\xE7\xE3o'), to('zh', '\u5B8C\u6210\u8BBE\u7F6E')])), to('setup.backToLogin', mapOf([to('en', 'Back to login'), to('es', 'Volver al inicio de sesi\xF3n'), to('fr', 'Retour \xE0 la connexion'), to('pt', 'Voltar ao login'), to('zh', '\u8FD4\u56DE\u767B\u5F55')])), to('setup.somethingWentWrong', mapOf([to('en', 'Something went wrong'), to('es', 'Algo sali\xF3 mal'), to('fr', "Une erreur s'est produite"), to('pt', 'Algo deu errado'), to('zh', '\u51FA\u73B0\u4E86\u4E00\u4E9B\u95EE\u9898')])), to('logActivity.activityType.golf', mapOf([to('en', 'Golf round'), to('es', 'Ronda de golf'), to('fr', 'Partie de golf'), to('pt', 'Rodada de golfe'), to('zh', '\u9AD8\u5C14\u592B\u56DE\u5408')])), to('logActivity.activityType.darts', mapOf([to('en', 'Darts match'), to('es', 'Partido de dardos'), to('fr', 'Match de fl\xE9chettes'), to('pt', 'Partida de dardos'), to('zh', '\u98DE\u9556\u6BD4\u8D5B')])), to('logActivity.activityType.javelin', mapOf([to('en', 'Track & field throw (javelin, discus, shot put, hammer)'), to('es', 'Lanzamiento de atletismo (jabalina, disco, peso, martillo)'), to('fr', "Lancer d'athl\xE9tisme (javelot, disque, poids, marteau)"), to('pt', 'Lan\xE7amento de atletismo (dardo, disco, peso, martelo)'), to('zh', '\u7530\u5F84\u6295\u63B7\u9879\u76EE\uFF08\u6807\u67AA\u3001\u94C1\u997C\u3001\u94C5\u7403\u3001\u94FE\u7403\uFF09')])), to('logActivity.activityType.baseball', mapOf([to('en', 'Baseball game'), to('es', 'Partido de b\xE9isbol'), to('fr', 'Match de baseball'), to('pt', 'Jogo de beisebol'), to('zh', '\u68D2\u7403\u6BD4\u8D5B')])), to('logActivity.activityType.billiards', mapOf([to('en', 'Billiards / pool'), to('es', 'Billar'), to('fr', 'Billard'), to('pt', 'Bilhar / sinuca'), to('zh', '\u53F0\u7403')])), to('logActivity.activityType.alpineSki', mapOf([to('en', 'Alpine skiing'), to('es', 'Esqu\xED alpino'), to('fr', 'Ski alpin'), to('pt', 'Esqui alpino'), to('zh', '\u9AD8\u5C71\u6ED1\u96EA')])), to('logActivity.activityType.downhillMtb', mapOf([to('en', 'Downhill mountain biking'), to('es', 'Ciclismo de descenso'), to('fr', 'VTT de descente'), to('pt', 'Mountain bike de descida'), to('zh', '\u5C71\u5730\u81EA\u884C\u8F66\u901F\u964D')])), to('logActivity.activityType.yoga', mapOf([to('en', 'Yoga session'), to('es', 'Sesi\xF3n de yoga'), to('fr', 'S\xE9ance de yoga'), to('pt', 'Sess\xE3o de yoga'), to('zh', '\u745C\u4F3D\u8BFE\u7A0B')])), to('logActivity.activityType.cards', mapOf([to('en', 'Card game'), to('es', 'Juego de cartas'), to('fr', 'Jeu de cartes'), to('pt', 'Jogo de cartas'), to('zh', '\u7EB8\u724C\u6E38\u620F')])), to('logActivity.activityType.raceCar', mapOf([to('en', 'Car track day / racing'), to('es', 'D\xEDa de pista / carreras de autos'), to('fr', 'Journ\xE9e circuit / course automobile'), to('pt', 'Track day / corrida de carros'), to('zh', '\u8D5B\u9053\u65E5/\u8D5B\u8F66')])), to('logActivity.activityType.motorcycle', mapOf([to('en', 'Motorcycle ride'), to('es', 'Salida en moto'), to('fr', 'Balade en moto'), to('pt', 'Passeio de moto'), to('zh', '\u6469\u6258\u8F66\u9A91\u884C')])), to('logActivity.golf.heading', mapOf([to('en', 'Golf details'), to('es', 'Detalles del golf'), to('fr', 'D\xE9tails du golf'), to('pt', 'Detalhes do golfe'), to('zh', '\u9AD8\u5C14\u592B\u8BE6\u60C5')])), to('logActivity.golf.courseName', mapOf([to('en', 'Course name'), to('es', 'Nombre del campo'), to('fr', 'Nom du parcours'), to('pt', 'Nome do campo'), to('zh', '\u7403\u573A\u540D\u79F0')])), to('logActivity.golf.holesPlayed', mapOf([to('en', 'Holes played'), to('es', 'Hoyos jugados'), to('fr', 'Trous jou\xE9s'), to('pt', 'Buracos jogados'), to('zh', '\u6253\u4E86\u51E0\u6D1E')])), to('logActivity.golf.totalStrokes', mapOf([to('en', 'Total strokes'), to('es', 'Golpes totales'), to('fr', 'Coups totaux'), to('pt', 'Total de tacadas'), to('zh', '\u603B\u6746\u6570')])), to('logActivity.golf.coursePar', mapOf([to('en', 'Course par'), to('es', 'Par del campo'), to('fr', 'Par du parcours'), to('pt', 'Par do campo'), to('zh', '\u7403\u573A\u6807\u51C6\u6746')])), to('logActivity.golf.puttsTotal', mapOf([to('en', 'Total putts (optional)'), to('es', 'Putts totales (opcional)'), to('fr', 'Putts totaux (facultatif)'), to('pt', 'Total de tacadas de putt (opcional)'), to('zh', '\u603B\u63A8\u6746\u6570\uFF08\u53EF\u9009\uFF09')])), to('logActivity.golf.fairwaysHit', mapOf([to('en', 'Fairways hit (optional)'), to('es', 'Calles acertadas (opcional)'), to('fr', 'Fairways atteints (facultatif)'), to('pt', 'Fairways atingidos (opcional)'), to('zh', '\u7403\u9053\u547D\u4E2D\u6570\uFF08\u53EF\u9009\uFF09')])), to('logActivity.golf.greensInRegulation', mapOf([to('en', 'Greens in regulation (optional)'), to('es', 'Greens en regulaci\xF3n (opcional)'), to('fr', 'Greens en r\xE9gulation (facultatif)'), to('pt', 'Greens em regula\xE7\xE3o (opcional)'), to('zh', '\u6807\u51C6\u6746\u4E0A\u679C\u5CAD\u6570\uFF08\u53EF\u9009\uFF09')])), to('logActivity.darts.heading', mapOf([to('en', 'Darts details'), to('es', 'Detalles de dardos'), to('fr', 'D\xE9tails des fl\xE9chettes'), to('pt', 'Detalhes dos dardos'), to('zh', '\u98DE\u9556\u8BE6\u60C5')])), to('logActivity.darts.gameFormat', mapOf([to('en', 'Game format (e.g. 501, 301)'), to('es', 'Formato de juego (p. ej. 501, 301)'), to('fr', 'Format de jeu (ex. 501, 301)'), to('pt', 'Formato do jogo (ex. 501, 301)'), to('zh', '\u6BD4\u8D5B\u5236\u5F0F\uFF08\u4F8B\u5982501\u3001301\uFF09')])), to('logActivity.darts.legsWon', mapOf([to('en', 'Legs won'), to('es', 'Mangas ganadas'), to('fr', 'Manches gagn\xE9es'), to('pt', 'Sets vencidos'), to('zh', '\u83B7\u80DC\u5C40\u6570')])), to('logActivity.darts.legsLost', mapOf([to('en', 'Legs lost'), to('es', 'Mangas perdidas'), to('fr', 'Manches perdues'), to('pt', 'Sets perdidos'), to('zh', '\u5931\u5229\u5C40\u6570')])), to('logActivity.darts.highestCheckout', mapOf([to('en', 'Highest checkout (optional)'), to('es', 'Cierre m\xE1s alto (opcional)'), to('fr', 'Meilleure fermeture (facultatif)'), to('pt', 'Maior fechamento (opcional)'), to('zh', '\u6700\u9AD8\u7ED3\u675F\u5206\u6570\uFF08\u53EF\u9009\uFF09')])), to('logActivity.darts.checkoutPercentage', mapOf([to('en', 'Checkout percentage (optional)'), to('es', 'Porcentaje de cierre (opcional)'), to('fr', 'Pourcentage de fermeture (facultatif)'), to('pt', 'Percentual de fechamento (opcional)'), to('zh', '\u7ED3\u675F\u6210\u529F\u7387\uFF08\u53EF\u9009\uFF09')])), to('logActivity.darts.oneEightiesCount', mapOf([to('en', '180s thrown'), to('es', 'Cantidad de 180'), to('fr', 'Nombre de 180'), to('pt', 'Quantidade de 180'), to('zh', '180\u5206\u6B21\u6570')])), to('logActivity.trackThrow.heading', mapOf([to('en', 'Throw details'), to('es', 'Detalles del lanzamiento'), to('fr', 'D\xE9tails du lancer'), to('pt', 'Detalhes do lan\xE7amento'), to('zh', '\u6295\u63B7\u8BE6\u60C5')])), to('logActivity.trackThrow.event', mapOf([to('en', 'Event (e.g. Javelin, Discus, Shot Put, Hammer)'), to('es', 'Prueba (p. ej. jabalina, disco, peso, martillo)'), to('fr', '\xC9preuve (ex. javelot, disque, poids, marteau)'), to('pt', 'Prova (ex. dardo, disco, peso, martelo)'), to('zh', '\u9879\u76EE\uFF08\u4F8B\u5982\u6807\u67AA\u3001\u94C1\u997C\u3001\u94C5\u7403\u3001\u94FE\u7403\uFF09')])), to('logActivity.trackThrow.distanceMeters', mapOf([to('en', 'Distance (m)'), to('es', 'Distancia (m)'), to('fr', 'Distance (m)'), to('pt', 'Dist\xE2ncia (m)'), to('zh', '\u8DDD\u79BB\uFF08\u7C73\uFF09')])), to('logActivity.trackThrow.competitionName', mapOf([to('en', 'Competition name (optional)'), to('es', 'Nombre de la competici\xF3n (opcional)'), to('fr', 'Nom de la comp\xE9tition (facultatif)'), to('pt', 'Nome da competi\xE7\xE3o (opcional)'), to('zh', '\u8D5B\u4E8B\u540D\u79F0\uFF08\u53EF\u9009\uFF09')])), to('logActivity.trackThrow.windSpeed', mapOf([to('en', 'Wind speed (m/s, optional)'), to('es', 'Velocidad del viento (m/s, opcional)'), to('fr', 'Vitesse du vent (m/s, facultatif)'), to('pt', 'Velocidade do vento (m/s, opcional)'), to('zh', '\u98CE\u901F\uFF08\u7C73/\u79D2\uFF0C\u53EF\u9009\uFF09')])), to('logActivity.baseball.heading', mapOf([to('en', 'Baseball details'), to('es', 'Detalles de b\xE9isbol'), to('fr', 'D\xE9tails du baseball'), to('pt', 'Detalhes do beisebol'), to('zh', '\u68D2\u7403\u8BE6\u60C5')])), to('logActivity.baseball.position', mapOf([to('en', 'Position'), to('es', 'Posici\xF3n'), to('fr', 'Poste'), to('pt', 'Posi\xE7\xE3o'), to('zh', '\u4F4D\u7F6E')])), to('logActivity.baseball.opponentTeam', mapOf([to('en', 'Opponent team (optional)'), to('es', 'Equipo rival (opcional)'), to('fr', '\xC9quipe adverse (facultatif)'), to('pt', 'Time advers\xE1rio (opcional)'), to('zh', '\u5BF9\u65B9\u7403\u961F\uFF08\u53EF\u9009\uFF09')])), to('logActivity.baseball.atBats', mapOf([to('en', 'At bats (optional)'), to('es', 'Turnos al bate (opcional)'), to('fr', 'Passages au b\xE2ton (facultatif)'), to('pt', 'Turnos no bast\xE3o (opcional)'), to('zh', '\u6253\u5E2D\u6570\uFF08\u53EF\u9009\uFF09')])), to('logActivity.baseball.hits', mapOf([to('en', 'Hits (optional)'), to('es', 'Hits (opcional)'), to('fr', 'Coups s\xFBrs (facultatif)'), to('pt', 'Rebatidas (opcional)'), to('zh', '\u5B89\u6253\u6570\uFF08\u53EF\u9009\uFF09')])), to('logActivity.baseball.runsBattedIn', mapOf([to('en', 'Runs batted in (optional)'), to('es', 'Carreras impulsadas (opcional)'), to('fr', 'Points produits (facultatif)'), to('pt', 'Corridas impulsionadas (opcional)'), to('zh', '\u6253\u70B9\u6570\uFF08\u53EF\u9009\uFF09')])), to('logActivity.baseball.inningsPitched', mapOf([to('en', 'Innings pitched (optional)'), to('es', 'Entradas lanzadas (opcional)'), to('fr', 'Manches lanc\xE9es (facultatif)'), to('pt', 'Entradas arremessadas (opcional)'), to('zh', '\u6295\u7403\u5C40\u6570\uFF08\u53EF\u9009\uFF09')])), to('logActivity.baseball.strikeoutsPitched', mapOf([to('en', 'Strikeouts pitched (optional)'), to('es', 'Ponches lanzados (opcional)'), to('fr', 'Retraits sur des prises (facultatif)'), to('pt', 'Strikeouts arremessados (opcional)'), to('zh', '\u6295\u7403\u4E09\u632F\u6570\uFF08\u53EF\u9009\uFF09')])), to('logActivity.billiards.heading', mapOf([to('en', 'Billiards details'), to('es', 'Detalles de billar'), to('fr', 'D\xE9tails du billard'), to('pt', 'Detalhes do bilhar'), to('zh', '\u53F0\u7403\u8BE6\u60C5')])), to('logActivity.billiards.gameType', mapOf([to('en', 'Game type (e.g. 8-ball, 9-ball, snooker)'), to('es', 'Tipo de juego (p. ej. 8 bolas, 9 bolas, snooker)'), to('fr', 'Type de jeu (ex. 8 billes, 9 billes, snooker)'), to('pt', 'Tipo de jogo (ex. sinuca 8-ball, 9-ball, snooker)'), to('zh', '\u6E38\u620F\u7C7B\u578B\uFF08\u4F8B\u59828\u7403\u30019\u7403\u3001\u65AF\u8BFA\u514B\uFF09')])), to('logActivity.billiards.framesWon', mapOf([to('en', 'Frames won'), to('es', 'Partidas ganadas'), to('fr', 'Manches gagn\xE9es'), to('pt', 'Partidas vencidas'), to('zh', '\u83B7\u80DC\u5C40\u6570')])), to('logActivity.billiards.framesLost', mapOf([to('en', 'Frames lost'), to('es', 'Partidas perdidas'), to('fr', 'Manches perdues'), to('pt', 'Partidas perdidas'), to('zh', '\u5931\u5229\u5C40\u6570')])), to('logActivity.billiards.highestBreak', mapOf([to('en', 'Highest break (optional)'), to('es', 'Mejor tacada (opcional)'), to('fr', 'Meilleure s\xE9rie (facultatif)'), to('pt', 'Melhor tacada (opcional)'), to('zh', '\u6700\u9AD8\u5355\u6746\u5F97\u5206\uFF08\u53EF\u9009\uFF09')])), to('logActivity.billiards.opponentName', mapOf([to('en', 'Opponent name (optional)'), to('es', 'Nombre del rival (opcional)'), to('fr', "Nom de l'adversaire (facultatif)"), to('pt', 'Nome do advers\xE1rio (opcional)'), to('zh', '\u5BF9\u624B\u59D3\u540D\uFF08\u53EF\u9009\uFF09')])), to('logActivity.alpineSki.heading', mapOf([to('en', 'Ski details'), to('es', 'Detalles del esqu\xED'), to('fr', 'D\xE9tails du ski'), to('pt', 'Detalhes do esqui'), to('zh', '\u6ED1\u96EA\u8BE6\u60C5')])), to('logActivity.alpineSki.resortName', mapOf([to('en', 'Resort name'), to('es', 'Nombre de la estaci\xF3n'), to('fr', 'Nom de la station'), to('pt', 'Nome da esta\xE7\xE3o'), to('zh', '\u5EA6\u5047\u6751\u540D\u79F0')])), to('logActivity.alpineSki.runsCompleted', mapOf([to('en', 'Runs completed'), to('es', 'Bajadas completadas'), to('fr', 'Descentes effectu\xE9es'), to('pt', 'Descidas completadas'), to('zh', '\u5B8C\u6210\u6ED1\u964D\u6B21\u6570')])), to('logActivity.alpineSki.verticalDescent', mapOf([to('en', 'Vertical descent (m)'), to('es', 'Desnivel descendido (m)'), to('fr', 'D\xE9nivel\xE9 n\xE9gatif (m)'), to('pt', 'Desn\xEDvel de descida (m)'), to('zh', '\u5782\u76F4\u4E0B\u964D\u9AD8\u5EA6\uFF08\u7C73\uFF09')])), to('logActivity.alpineSki.maxSpeed', mapOf([to('en', 'Max speed (km/h, optional)'), to('es', 'Velocidad m\xE1xima (km/h, opcional)'), to('fr', 'Vitesse maximale (km/h, facultatif)'), to('pt', 'Velocidade m\xE1xima (km/h, opcional)'), to('zh', '\u6700\u9AD8\u901F\u5EA6\uFF08\u516C\u91CC/\u5C0F\u65F6\uFF0C\u53EF\u9009\uFF09')])), to('logActivity.alpineSki.snowCondition', mapOf([to('en', 'Snow condition (optional)'), to('es', 'Condici\xF3n de la nieve (opcional)'), to('fr', '\xC9tat de la neige (facultatif)'), to('pt', 'Condi\xE7\xE3o da neve (opcional)'), to('zh', '\u96EA\u51B5\uFF08\u53EF\u9009\uFF09')])), to('logActivity.downhillMtb.heading', mapOf([to('en', 'Downhill ride details'), to('es', 'Detalles del descenso'), to('fr', 'D\xE9tails de la descente'), to('pt', 'Detalhes da descida'), to('zh', '\u901F\u964D\u8BE6\u60C5')])), to('logActivity.downhillMtb.trailName', mapOf([to('en', 'Trail name'), to('es', 'Nombre del sendero'), to('fr', 'Nom de la piste'), to('pt', 'Nome da trilha'), to('zh', '\u8D5B\u9053\u540D\u79F0')])), to('logActivity.downhillMtb.verticalDescent', mapOf([to('en', 'Vertical descent (m)'), to('es', 'Desnivel descendido (m)'), to('fr', 'D\xE9nivel\xE9 n\xE9gatif (m)'), to('pt', 'Desn\xEDvel de descida (m)'), to('zh', '\u5782\u76F4\u4E0B\u964D\u9AD8\u5EA6\uFF08\u7C73\uFF09')])), to('logActivity.downhillMtb.distance', mapOf([to('en', 'Distance (m)'), to('es', 'Distancia (m)'), to('fr', 'Distance (m)'), to('pt', 'Dist\xE2ncia (m)'), to('zh', '\u8DDD\u79BB\uFF08\u7C73\uFF09')])), to('logActivity.downhillMtb.duration', mapOf([to('en', 'Duration (seconds)'), to('es', 'Duraci\xF3n (segundos)'), to('fr', 'Dur\xE9e (secondes)'), to('pt', 'Dura\xE7\xE3o (segundos)'), to('zh', '\u6301\u7EED\u65F6\u95F4\uFF08\u79D2\uFF09')])), to('logActivity.downhillMtb.maxSpeed', mapOf([to('en', 'Max speed (km/h, optional)'), to('es', 'Velocidad m\xE1xima (km/h, opcional)'), to('fr', 'Vitesse maximale (km/h, facultatif)'), to('pt', 'Velocidade m\xE1xima (km/h, opcional)'), to('zh', '\u6700\u9AD8\u901F\u5EA6\uFF08\u516C\u91CC/\u5C0F\u65F6\uFF0C\u53EF\u9009\uFF09')])), to('logActivity.yoga.heading', mapOf([to('en', 'Yoga details'), to('es', 'Detalles de yoga'), to('fr', 'D\xE9tails du yoga'), to('pt', 'Detalhes do yoga'), to('zh', '\u745C\u4F3D\u8BE6\u60C5')])), to('logActivity.yoga.style', mapOf([to('en', 'Style (e.g. Vinyasa, Hatha)'), to('es', 'Estilo (p. ej. Vinyasa, Hatha)'), to('fr', 'Style (ex. Vinyasa, Hatha)'), to('pt', 'Estilo (ex. Vinyasa, Hatha)'), to('zh', '\u98CE\u683C\uFF08\u4F8B\u5982\u6D41\u745C\u4F3D\u3001\u54C8\u4ED6\u745C\u4F3D\uFF09')])), to('logActivity.yoga.durationMinutes', mapOf([to('en', 'Duration (minutes)'), to('es', 'Duraci\xF3n (minutos)'), to('fr', 'Dur\xE9e (minutes)'), to('pt', 'Dura\xE7\xE3o (minutos)'), to('zh', '\u6301\u7EED\u65F6\u95F4\uFF08\u5206\u949F\uFF09')])), to('logActivity.yoga.poseSequence', mapOf([to('en', 'Pose sequence (comma-separated, optional)'), to('es', 'Secuencia de posturas (separadas por comas, opcional)'), to('fr', 'S\xE9quence de postures (s\xE9par\xE9es par des virgules, facultatif)'), to('pt', 'Sequ\xEAncia de posturas (separadas por v\xEDrgula, opcional)'), to('zh', '\u4F53\u5F0F\u5E8F\u5217\uFF08\u9017\u53F7\u5206\u9694\uFF0C\u53EF\u9009\uFF09')])), to('logActivity.yoga.instructorName', mapOf([to('en', 'Instructor name (optional)'), to('es', 'Nombre del instructor (opcional)'), to('fr', "Nom de l'instructeur (facultatif)"), to('pt', 'Nome do instrutor (opcional)'), to('zh', '\u6559\u7EC3\u59D3\u540D\uFF08\u53EF\u9009\uFF09')])), to('logActivity.cards.heading', mapOf([to('en', 'Card game details'), to('es', 'Detalles del juego de cartas'), to('fr', 'D\xE9tails du jeu de cartes'), to('pt', 'Detalhes do jogo de cartas'), to('zh', '\u7EB8\u724C\u6E38\u620F\u8BE6\u60C5')])), to('logActivity.cards.gameName', mapOf([to('en', 'Game name (e.g. Poker, Bridge)'), to('es', 'Nombre del juego (p. ej. P\xF3ker, Bridge)'), to('fr', 'Nom du jeu (ex. Poker, Bridge)'), to('pt', 'Nome do jogo (ex. P\xF4quer, Bridge)'), to('zh', '\u6E38\u620F\u540D\u79F0\uFF08\u4F8B\u5982\u6251\u514B\u3001\u6865\u724C\uFF09')])), to('logActivity.cards.result', mapOf([to('en', 'Result (e.g. win, loss, placement)'), to('es', 'Resultado (p. ej. victoria, derrota, posici\xF3n)'), to('fr', 'R\xE9sultat (ex. victoire, d\xE9faite, classement)'), to('pt', 'Resultado (ex. vit\xF3ria, derrota, coloca\xE7\xE3o)'), to('zh', '\u7ED3\u679C\uFF08\u4F8B\u5982\u83B7\u80DC\u3001\u5931\u8D25\u3001\u540D\u6B21\uFF09')])), to('logActivity.cards.score', mapOf([to('en', 'Score (optional)'), to('es', 'Puntuaci\xF3n (opcional)'), to('fr', 'Score (facultatif)'), to('pt', 'Pontua\xE7\xE3o (opcional)'), to('zh', '\u5F97\u5206\uFF08\u53EF\u9009\uFF09')])), to('logActivity.cards.opponents', mapOf([to('en', 'Opponents (comma-separated, optional)'), to('es', 'Rivales (separados por comas, opcional)'), to('fr', 'Adversaires (s\xE9par\xE9s par des virgules, facultatif)'), to('pt', 'Advers\xE1rios (separados por v\xEDrgula, opcional)'), to('zh', '\u5BF9\u624B\uFF08\u9017\u53F7\u5206\u9694\uFF0C\u53EF\u9009\uFF09')])), to('logActivity.raceCar.heading', mapOf([to('en', 'Track day details'), to('es', 'Detalles del d\xEDa de pista'), to('fr', 'D\xE9tails de la journ\xE9e circuit'), to('pt', 'Detalhes do track day'), to('zh', '\u8D5B\u9053\u65E5\u8BE6\u60C5')])), to('logActivity.raceCar.trackName', mapOf([to('en', 'Track name'), to('es', 'Nombre del circuito'), to('fr', 'Nom du circuit'), to('pt', 'Nome do circuito'), to('zh', '\u8D5B\u9053\u540D\u79F0')])), to('logActivity.raceCar.carMakeModel', mapOf([to('en', 'Car make & model'), to('es', 'Marca y modelo del auto'), to('fr', 'Marque et mod\xE8le de la voiture'), to('pt', 'Marca e modelo do carro'), to('zh', '\u6C7D\u8F66\u54C1\u724C\u53CA\u578B\u53F7')])), to('logActivity.raceCar.lapsCompleted', mapOf([to('en', 'Laps completed'), to('es', 'Vueltas completadas'), to('fr', 'Tours effectu\xE9s'), to('pt', 'Voltas completadas'), to('zh', '\u5B8C\u6210\u5708\u6570')])), to('logActivity.raceCar.bestLapTime', mapOf([to('en', 'Best lap time (seconds, optional)'), to('es', 'Mejor tiempo por vuelta (segundos, opcional)'), to('fr', 'Meilleur temps au tour (secondes, facultatif)'), to('pt', 'Melhor tempo de volta (segundos, opcional)'), to('zh', '\u6700\u5FEB\u5708\u901F\uFF08\u79D2\uFF0C\u53EF\u9009\uFF09')])), to('logActivity.raceCar.sessionType', mapOf([to('en', 'Session type (e.g. track day, autocross, race, optional)'), to('es', 'Tipo de sesi\xF3n (p. ej. d\xEDa de pista, autocross, carrera, opcional)'), to('fr', 'Type de session (ex. journ\xE9e circuit, autocross, course, facultatif)'), to('pt', 'Tipo de sess\xE3o (ex. track day, autocross, corrida, opcional)'), to('zh', '\u73AF\u8282\u7C7B\u578B\uFF08\u4F8B\u5982\u8D5B\u9053\u65E5\u3001\u7ADE\u901F\u3001\u6BD4\u8D5B\uFF0C\u53EF\u9009\uFF09')])), to('logActivity.motorcycle.heading', mapOf([to('en', 'Ride details'), to('es', 'Detalles de la salida'), to('fr', 'D\xE9tails de la balade'), to('pt', 'Detalhes do passeio'), to('zh', '\u9A91\u884C\u8BE6\u60C5')])), to('logActivity.motorcycle.routeOrTrackName', mapOf([to('en', 'Route or track name'), to('es', 'Nombre de la ruta o circuito'), to('fr', "Nom de l'itin\xE9raire ou du circuit"), to('pt', 'Nome da rota ou circuito'), to('zh', '\u8DEF\u7EBF\u6216\u8D5B\u9053\u540D\u79F0')])), to('logActivity.motorcycle.motorcycleMakeModel', mapOf([to('en', 'Motorcycle make & model'), to('es', 'Marca y modelo de la moto'), to('fr', 'Marque et mod\xE8le de la moto'), to('pt', 'Marca e modelo da moto'), to('zh', '\u6469\u6258\u8F66\u54C1\u724C\u53CA\u578B\u53F7')])), to('logActivity.motorcycle.distanceKm', mapOf([to('en', 'Distance (km, optional)'), to('es', 'Distancia (km, opcional)'), to('fr', 'Distance (km, facultatif)'), to('pt', 'Dist\xE2ncia (km, opcional)'), to('zh', '\u8DDD\u79BB\uFF08\u516C\u91CC\uFF0C\u53EF\u9009\uFF09')])), to('logActivity.motorcycle.durationMinutes', mapOf([to('en', 'Duration (minutes, optional)'), to('es', 'Duraci\xF3n (minutos, opcional)'), to('fr', 'Dur\xE9e (minutes, facultatif)'), to('pt', 'Dura\xE7\xE3o (minutos, opcional)'), to('zh', '\u6301\u7EED\u65F6\u95F4\uFF08\u5206\u949F\uFF0C\u53EF\u9009\uFF09')])), to('logActivity.motorcycle.maxSpeed', mapOf([to('en', 'Max speed (km/h, optional)'), to('es', 'Velocidad m\xE1xima (km/h, opcional)'), to('fr', 'Vitesse maximale (km/h, facultatif)'), to('pt', 'Velocidade m\xE1xima (km/h, opcional)'), to('zh', '\u6700\u9AD8\u901F\u5EA6\uFF08\u516C\u91CC/\u5C0F\u65F6\uFF0C\u53EF\u9009\uFF09')])), to('logActivity.motorcycle.rideType', mapOf([to('en', 'Ride type (e.g. street, track, off-road, optional)'), to('es', 'Tipo de salida (p. ej. calle, circuito, off-road, opcional)'), to('fr', 'Type de sortie (ex. route, circuit, tout-terrain, facultatif)'), to('pt', 'Tipo de passeio (ex. rua, pista, off-road, opcional)'), to('zh', '\u9A91\u884C\u7C7B\u578B\uFF08\u4F8B\u5982\u516C\u8DEF\u3001\u8D5B\u9053\u3001\u8D8A\u91CE\uFF0C\u53EF\u9009\uFF09')])), to('logActivity.activityType.aerobatic', mapOf_0(to('en', 'Aerobatic / airshow flight'))), to('logActivity.activityType.aircraftMaintenance', mapOf_0(to('en', 'Aircraft maintenance'))), to('logActivity.activityType.alpineMountaineer', mapOf_0(to('en', 'Alpine mountaineering'))), to('logActivity.activityType.apiary', mapOf_0(to('en', 'Apiary inspection'))), to('logActivity.activityType.astronaut', mapOf_0(to('en', 'Astronaut / analog astronaut'))), to('logActivity.activityType.atp', mapOf_0(to('en', 'Airline transport pilot'))), to('logActivity.activityType.backcountrySki', mapOf_0(to('en', 'Backcountry ski tour'))), to('logActivity.activityType.baseJump', mapOf_0(to('en', 'BASE jump'))), to('logActivity.activityType.canyoneer', mapOf_0(to('en', 'Canyoneering'))), to('logActivity.activityType.caving', mapOf_0(to('en', 'Cave expedition'))), to('logActivity.activityType.commercialDive', mapOf_0(to('en', 'Commercial / saturation dive'))), to('logActivity.activityType.crane', mapOf_0(to('en', 'Crane operation'))), to('logActivity.activityType.culinaryApprentice', mapOf_0(to('en', 'Culinary apprenticeship'))), to('logActivity.activityType.cycling', mapOf_0(to('en', 'Cycling session'))), to('logActivity.activityType.drone', mapOf_0(to('en', 'Drone operator'))), to('logActivity.activityType.envField', mapOf_0(to('en', 'Environmental field sampling'))), to('logActivity.activityType.equestrian', mapOf_0(to('en', 'Equestrian session'))), to('logActivity.activityType.falconry', mapOf_0(to('en', 'Falconry session'))), to('logActivity.activityType.flightInstructor', mapOf_0(to('en', 'Flight instructor'))), to('logActivity.activityType.flightSim', mapOf_0(to('en', 'Flight simulator session'))), to('logActivity.activityType.forklift', mapOf_0(to('en', 'Forklift shift'))), to('logActivity.activityType.freedive', mapOf_0(to('en', 'Freedive'))), to('logActivity.activityType.hamRadio', mapOf_0(to('en', 'Ham radio contact'))), to('logActivity.activityType.heavyEquipment', mapOf_0(to('en', 'Heavy equipment operation'))), to('logActivity.activityType.hotAirBalloon', mapOf_0(to('en', 'Hot air balloon pilot'))), to('logActivity.activityType.iceClimb', mapOf_0(to('en', 'Ice climb'))), to('logActivity.activityType.indoorSkydiving', mapOf_0(to('en', 'Indoor skydiving session'))), to('logActivity.activityType.kitesurf', mapOf_0(to('en', 'Kitesurf / windsurf session'))), to('logActivity.activityType.labResearch', mapOf_0(to('en', 'Lab research session'))), to('logActivity.activityType.landSurvey', mapOf_0(to('en', 'Land survey'))), to('logActivity.activityType.lifeguard', mapOf_0(to('en', 'Lifeguard shift'))), to('logActivity.activityType.livestock', mapOf_0(to('en', 'Livestock handling'))), to('logActivity.activityType.merchantMarine', mapOf_0(to('en', 'Merchant marine watch'))), to('logActivity.activityType.parachuteRigger', mapOf_0(to('en', 'Parachute rigging'))), to('logActivity.activityType.paramotor', mapOf_0(to('en', 'Paramotor flight'))), to('logActivity.activityType.physicalTherapy', mapOf_0(to('en', 'Physical therapy session'))), to('logActivity.activityType.powerlifting', mapOf_0(to('en', 'Powerlifting session'))), to('logActivity.activityType.qaTesting', mapOf_0(to('en', 'QA testing session'))), to('logActivity.activityType.railway', mapOf_0(to('en', 'Railway run'))), to('logActivity.activityType.rowing', mapOf_0(to('en', 'Rowing session'))), to('logActivity.activityType.safetyDive', mapOf_0(to('en', 'Public safety dive'))), to('logActivity.activityType.sailing', mapOf_0(to('en', 'Sailing voyage'))), to('logActivity.activityType.sciDive', mapOf_0(to('en', 'Scientific research dive'))), to('logActivity.activityType.scubaService', mapOf_0(to('en', 'Scuba life-support service'))), to('logActivity.activityType.skydive', mapOf_0(to('en', 'Skydive'))), to('logActivity.activityType.soundRecording', mapOf_0(to('en', 'Sound recording session'))), to('logActivity.activityType.spearfishing', mapOf_0(to('en', 'Spearfishing'))), to('logActivity.activityType.speedwing', mapOf_0(to('en', 'Speedwing / proximity flight'))), to('logActivity.activityType.surf', mapOf_0(to('en', 'Surf session'))), to('logActivity.activityType.swimming', mapOf_0(to('en', 'Swimming session'))), to('logActivity.activityType.tattooApprentice', mapOf_0(to('en', 'Tattoo apprenticeship'))), to('logActivity.activityType.techDive', mapOf_0(to('en', 'Technical / deep dive'))), to('logActivity.activityType.thruHike', mapOf_0(to('en', 'Thru-hike'))), to('logActivity.activityType.tradeApprentice', mapOf_0(to('en', 'Trade apprenticeship'))), to('logActivity.activityType.trailRun', mapOf_0(to('en', 'Trail run'))), to('logActivity.activityType.transit', mapOf_0(to('en', 'Transit operator shift'))), to('logActivity.activityType.triathlon', mapOf_0(to('en', 'Triathlon'))), to('logActivity.activityType.truckDriver', mapOf_0(to('en', 'Truck driving shift'))), to('logActivity.activityType.underwaterPhoto', mapOf_0(to('en', 'Underwater photography'))), to('logActivity.activityType.weldingApprentice', mapOf_0(to('en', 'Welding apprenticeship'))), to('logActivity.activityType.whitewaterGuide', mapOf_0(to('en', 'Whitewater guiding'))), to('logActivity.activityType.wingsuit', mapOf_0(to('en', 'Wingsuit flight'))), to('logActivity.activityType.workingDog', mapOf_0(to('en', 'Working dog session'))), to('logActivity.aerobatic.aerobaticCategoryRating', mapOf_0(to('en', 'Aerobatic category rating'))), to('logActivity.aerobatic.airshowWaiverNumber', mapOf_0(to('en', 'Airshow waiver number (optional)'))), to('logActivity.aerobatic.displayBoxFloorAltitudeMeters', mapOf_0(to('en', 'Display box floor altitude (m, optional)'))), to('logActivity.aerobatic.entryAltitudeMeters', mapOf_0(to('en', 'Entry altitude (m, optional)'))), to('logActivity.aerobatic.exitAltitudeMeters', mapOf_0(to('en', 'Exit altitude (m, optional)'))), to('logActivity.aerobatic.heading', mapOf_0(to('en', 'Aerobatic / airshow flight'))), to('logActivity.aerobatic.maneuverSequence', mapOf_0(to('en', 'Maneuver sequence (comma-separated, optional)'))), to('logActivity.aerobatic.negativeGForcePeak', mapOf_0(to('en', 'Negative G-force peak (optional)'))), to('logActivity.aerobatic.positiveGForcePeak', mapOf_0(to('en', 'Positive G-force peak (optional)'))), to('logActivity.aircraftMaintenance.aAndPLicenseNumber', mapOf_0(to('en', 'A&P license number'))), to('logActivity.aircraftMaintenance.aircraftTailNumber', mapOf_0(to('en', 'Aircraft tail number'))), to('logActivity.aircraftMaintenance.airworthinessDirectiveRefs', mapOf_0(to('en', 'Airworthiness directive refs (comma-separated, optional)'))), to('logActivity.aircraftMaintenance.componentSerialNumber', mapOf_0(to('en', 'Component serial number (optional)'))), to('logActivity.aircraftMaintenance.engineCyclesSinceNew', mapOf_0(to('en', 'Engine cycles since new (optional)'))), to('logActivity.aircraftMaintenance.engineModel', mapOf_0(to('en', 'Engine model (optional)'))), to('logActivity.aircraftMaintenance.heading', mapOf_0(to('en', 'Aircraft maintenance'))), to('logActivity.aircraftMaintenance.partsReplaced', mapOf_0(to('en', 'Parts replaced (comma-separated, optional)'))), to('logActivity.aircraftMaintenance.returnToServiceStamp', mapOf_0(to('en', 'Return to service stamp (optional)'))), to('logActivity.aircraftMaintenance.serviceBulletinRefs', mapOf_0(to('en', 'Service bulletin refs (comma-separated, optional)'))), to('logActivity.aircraftMaintenance.timeSinceMajorOverhaulHours', mapOf_0(to('en', 'Time since major overhaul hours (optional)'))), to('logActivity.aircraftMaintenance.totalAirframeHours', mapOf_0(to('en', 'Total airframe hours (optional)'))), to('logActivity.alpineMountaineer.alpineCommitmentGrade', mapOf_0(to('en', 'Alpine commitment grade (optional)'))), to('logActivity.alpineMountaineer.approachTrailLengthKm', mapOf_0(to('en', 'Approach trail length (km, optional)'))), to('logActivity.alpineMountaineer.heading', mapOf_0(to('en', 'Alpine mountaineering'))), to('logActivity.alpineMountaineer.peakElevationMeters', mapOf_0(to('en', 'Peak elevation (m)'))), to('logActivity.alpineMountaineer.routeProtectionStatus', mapOf_0(to('en', 'Route protection status (optional)'))), to('logActivity.alpineMountaineer.summitWindowTime', mapOf_0(to('en', 'Summit window time (optional)'))), to('logActivity.alpineMountaineer.technicalCruxDifficulty', mapOf_0(to('en', 'Technical crux difficulty (optional)'))), to('logActivity.alpineMountaineer.totalElevationGainMeters', mapOf_0(to('en', 'Total elevation gain (m, optional)'))), to('logActivity.alpineMountaineer.totalElevationLossMeters', mapOf_0(to('en', 'Total elevation loss (m, optional)'))), to('logActivity.apiary.broodPatternNotes', mapOf_0(to('en', 'Brood pattern notes (optional)'))), to('logActivity.apiary.diseaseOrPestTreatmentApplied', mapOf_0(to('en', 'Disease or pest treatment applied (optional)'))), to('logActivity.apiary.frameCountHarvested', mapOf_0(to('en', 'Frame count harvested (optional)'))), to('logActivity.apiary.heading', mapOf_0(to('en', 'Apiary inspection'))), to('logActivity.apiary.hiveId', mapOf_0(to('en', 'Hive ID'))), to('logActivity.apiary.queenSurvivalOrLayingStatus', mapOf_0(to('en', 'Queen survival or laying status (optional)'))), to('logActivity.apiary.seasonalHoneyYieldKg', mapOf_0(to('en', 'Seasonal honey yield (kg, optional)'))), to('logActivity.apiary.varroaMiteCount', mapOf_0(to('en', 'Varroa mite count (optional)'))), to('logActivity.astronaut.habitatCoordinates', mapOf_0(to('en', 'Habitat coordinates (optional)'))), to('logActivity.astronaut.heading', mapOf_0(to('en', 'Astronaut / analog astronaut'))), to('logActivity.astronaut.lifeSupportAirMix', mapOf_0(to('en', 'Life support air mix (optional)'))), to('logActivity.astronaut.lifeSupportDurationMinutes', mapOf_0(to('en', 'Life support duration (minutes, optional)'))), to('logActivity.astronaut.missionDesignation', mapOf_0(to('en', 'Mission designation'))), to('logActivity.astronaut.sampleCollectionTags', mapOf_0(to('en', 'Sample collection tags (comma-separated, optional)'))), to('logActivity.astronaut.structuralRepairMilestones', mapOf_0(to('en', 'Structural repair milestones (comma-separated, optional)'))), to('logActivity.astronaut.suitPressurizationMinutes', mapOf_0(to('en', 'Suit pressurization (minutes, optional)'))), to('logActivity.astronaut.vacuumChamberPressureKpa', mapOf_0(to('en', 'Vacuum chamber pressure (kPa, optional)'))), to('logActivity.atp.actualInstrumentHours', mapOf_0(to('en', 'Actual instrument hours (optional)'))), to('logActivity.atp.heading', mapOf_0(to('en', 'Airline transport pilot'))), to('logActivity.atp.heavyAircraftClassification', mapOf_0(to('en', 'Heavy aircraft classification'))), to('logActivity.atp.holdingPatterns', mapOf_0(to('en', 'Holding patterns'))), to('logActivity.atp.multiEngineHours', mapOf_0(to('en', 'Multi engine hours (optional)'))), to('logActivity.atp.nightCrossCountryHours', mapOf_0(to('en', 'Night cross country hours (optional)'))), to('logActivity.atp.nonPrecisionApproaches', mapOf_0(to('en', 'Non precision approaches'))), to('logActivity.atp.picHours', mapOf_0(to('en', 'PIC hours'))), to('logActivity.atp.precisionApproaches', mapOf_0(to('en', 'Precision approaches'))), to('logActivity.atp.sicHours', mapOf_0(to('en', 'SIC hours (optional)'))), to('logActivity.atp.simulatedInstrumentHours', mapOf_0(to('en', 'Simulated instrument hours (optional)'))), to('logActivity.atp.turbineEngineHours', mapOf_0(to('en', 'Turbine engine hours (optional)'))), to('logActivity.backcountrySki.aspect', mapOf_0(to('en', 'Aspect (optional)'))), to('logActivity.backcountrySki.avalancheAirbagDeployed', mapOf_0(to('en', 'Avalanche airbag deployed'))), to('logActivity.backcountrySki.avalancheDangerRating', mapOf_0(to('en', 'Avalanche danger rating'))), to('logActivity.backcountrySki.beaconProbeShovelChecked', mapOf_0(to('en', 'Beacon probe shovel checked'))), to('logActivity.backcountrySki.heading', mapOf_0(to('en', 'Backcountry ski tour'))), to('logActivity.backcountrySki.skinTrackVerticalGainMeters', mapOf_0(to('en', 'Skin track vertical gain (m, optional)'))), to('logActivity.backcountrySki.slopeAngleDegrees', mapOf_0(to('en', 'Slope angle (degrees, optional)'))), to('logActivity.backcountrySki.totalTourDistanceKm', mapOf_0(to('en', 'Total tour distance (km, optional)'))), to('logActivity.backcountrySki.transitionsCount', mapOf_0(to('en', 'Transitions count (optional)'))), to('logActivity.baseJump.canopyHeadingPerformance', mapOf_0(to('en', 'Canopy heading performance (optional)'))), to('logActivity.baseJump.delayDurationSeconds', mapOf_0(to('en', 'Delay duration (seconds, optional)'))), to('logActivity.baseJump.deploymentMethod', mapOf_0(to('en', 'Deployment method'))), to('logActivity.baseJump.heading', mapOf_0(to('en', 'BASE jump'))), to('logActivity.baseJump.landingZoneObstacles', mapOf_0(to('en', 'Landing zone obstacles (optional)'))), to('logActivity.baseJump.objectClassification', mapOf_0(to('en', 'Object classification'))), to('logActivity.baseJump.objectHeightMeters', mapOf_0(to('en', 'Object height (m, optional)'))), to('logActivity.canyoneer.anchorStyle', mapOf_0(to('en', 'Anchor style (optional)'))), to('logActivity.canyoneer.flashFloodRiskForecast', mapOf_0(to('en', 'Flash flood risk forecast (optional)'))), to('logActivity.canyoneer.groupExitTime', mapOf_0(to('en', 'Group exit time (optional)'))), to('logActivity.canyoneer.heading', mapOf_0(to('en', 'Canyoneering'))), to('logActivity.canyoneer.jumpOrSlideHeightsMeters', mapOf_0(to('en', 'Jump or slide heights (m, comma-separated, optional)'))), to('logActivity.canyoneer.poolDepthsMeters', mapOf_0(to('en', 'Pool depths (m, comma-separated, optional)'))), to('logActivity.canyoneer.rappelLengthMeters', mapOf_0(to('en', 'Rappel length (m, optional)'))), to('logActivity.canyoneer.ropeDiameterMm', mapOf_0(to('en', 'Rope diameter (mm, optional)'))), to('logActivity.canyoneer.waterFlowRate', mapOf_0(to('en', 'Water flow rate (optional)'))), to('logActivity.canyoneer.weatherWindow', mapOf_0(to('en', 'Weather window (optional)'))), to('logActivity.caving.ascentDescentDeviceUsed', mapOf_0(to('en', 'Ascent descent device used (optional)'))), to('logActivity.caving.baselineSurveyVectors', mapOf_0(to('en', 'Baseline survey vectors (optional)'))), to('logActivity.caving.calloutExitTime', mapOf_0(to('en', 'Callout exit time (optional)'))), to('logActivity.caving.caveSystemName', mapOf_0(to('en', 'Cave system name'))), to('logActivity.caving.heading', mapOf_0(to('en', 'Cave expedition'))), to('logActivity.caving.passageDimensions', mapOf_0(to('en', 'Passage dimensions (optional)'))), to('logActivity.caving.riggingAnchorPoints', mapOf_0(to('en', 'Rigging anchor points (optional)'))), to('logActivity.caving.ropeDropDepthsMeters', mapOf_0(to('en', 'Rope drop depths (m, comma-separated, optional)'))), to('logActivity.caving.sumpDivingTimeline', mapOf_0(to('en', 'Sump diving timeline (optional)'))), to('logActivity.caving.totalSurveyedLengthMeters', mapOf_0(to('en', 'Total surveyed length (m, optional)'))), to('logActivity.commercialDive.bellLockoutMinutes', mapOf_0(to('en', 'Bell lockout (minutes, optional)'))), to('logActivity.commercialDive.bellRecoveryMinutes', mapOf_0(to('en', 'Bell recovery (minutes, optional)'))), to('logActivity.commercialDive.chamberHumidityPercent', mapOf_0(to('en', 'Chamber humidity (%, optional)'))), to('logActivity.commercialDive.gasReclaimEfficiencyPercent', mapOf_0(to('en', 'Gas reclaim efficiency (%, optional)'))), to('logActivity.commercialDive.heading', mapOf_0(to('en', 'Commercial / saturation dive'))), to('logActivity.commercialDive.hotWaterSuitTempC', mapOf_0(to('en', 'Hot water suit temp (\xB0C, optional)'))), to('logActivity.commercialDive.ndtReadouts', mapOf_0(to('en', 'NDT readouts (optional)'))), to('logActivity.commercialDive.storageDepthPressureBar', mapOf_0(to('en', 'Storage depth pressure (bar, optional)'))), to('logActivity.commercialDive.toolOperatingPressureBar', mapOf_0(to('en', 'Tool operating pressure (bar, optional)'))), to('logActivity.commercialDive.underwaterWeldingArcHours', mapOf_0(to('en', 'Underwater welding arc hours (optional)'))), to('logActivity.crane.boomLengthMeters', mapOf_0(to('en', 'Boom length (m, optional)'))), to('logActivity.crane.counterweightConfiguration', mapOf_0(to('en', 'Counterweight configuration (optional)'))), to('logActivity.crane.heading', mapOf_0(to('en', 'Crane operation'))), to('logActivity.crane.loadChartPercentageUsed', mapOf_0(to('en', 'Load chart percentage used (optional)'))), to('logActivity.crane.loadMassKg', mapOf_0(to('en', 'Load mass (kg)'))), to('logActivity.crane.riggingConfiguration', mapOf_0(to('en', 'Rigging configuration (optional)'))), to('logActivity.crane.signalPersonConfirmed', mapOf_0(to('en', 'Signal person confirmed'))), to('logActivity.crane.visibilityConditions', mapOf_0(to('en', 'Visibility conditions (optional)'))), to('logActivity.crane.windSpeedThresholdKph', mapOf_0(to('en', 'Wind speed threshold (km/h, optional)'))), to('logActivity.culinaryApprentice.apprenticeshipHoursTowardCertification', mapOf_0(to('en', 'Apprenticeship hours toward certification (optional)'))), to('logActivity.culinaryApprentice.executiveChefSignature', mapOf_0(to('en', 'Executive chef signature (optional)'))), to('logActivity.culinaryApprentice.foodSafetyCertification', mapOf_0(to('en', 'Food safety certification (optional)'))), to('logActivity.culinaryApprentice.heading', mapOf_0(to('en', 'Culinary apprenticeship'))), to('logActivity.culinaryApprentice.hoursLogged', mapOf_0(to('en', 'Hours logged (optional)'))), to('logActivity.culinaryApprentice.kitchenStationAssigned', mapOf_0(to('en', 'Kitchen station assigned'))), to('logActivity.culinaryApprentice.knifeSkillsAssessmentResult', mapOf_0(to('en', 'Knife skills assessment result (optional)'))), to('logActivity.culinaryApprentice.recipeExecutionTestResult', mapOf_0(to('en', 'Recipe execution test result (optional)'))), to('logActivity.culinaryApprentice.supervisingChef', mapOf_0(to('en', 'Supervising chef (optional)'))), to('logActivity.cycling.avgHeartRateBpm', mapOf_0(to('en', 'Avg heart rate (bpm, optional)'))), to('logActivity.cycling.avgPowerWatts', mapOf_0(to('en', 'Avg power (watts, optional)'))), to('logActivity.cycling.bikeSetup', mapOf_0(to('en', 'Bike setup (optional)'))), to('logActivity.cycling.cadenceRpm', mapOf_0(to('en', 'Cadence (rpm, optional)'))), to('logActivity.cycling.distanceMeters', mapOf_0(to('en', 'Distance (m)'))), to('logActivity.cycling.ftpTestResultWatts', mapOf_0(to('en', 'FTP test result (watts, optional)'))), to('logActivity.cycling.gearRatio', mapOf_0(to('en', 'Gear ratio (optional)'))), to('logActivity.cycling.heading', mapOf_0(to('en', 'Cycling session'))), to('logActivity.cycling.normalizedPowerWatts', mapOf_0(to('en', 'Normalized power (watts, optional)'))), to('logActivity.cycling.tirePressureBar', mapOf_0(to('en', 'Tire pressure (bar, optional)'))), to('logActivity.drone.airspaceClassification', mapOf_0(to('en', 'Airspace classification'))), to('logActivity.drone.batteryChargeCycles', mapOf_0(to('en', 'Battery charge cycles (optional)'))), to('logActivity.drone.batterySerialNumber', mapOf_0(to('en', 'Battery serial number (optional)'))), to('logActivity.drone.droneModel', mapOf_0(to('en', 'Drone model'))), to('logActivity.drone.heading', mapOf_0(to('en', 'Drone operator'))), to('logActivity.drone.incidentNotes', mapOf_0(to('en', 'Incident notes (optional)'))), to('logActivity.drone.laancAuthorizationNumber', mapOf_0(to('en', 'LAANC authorization number (optional)'))), to('logActivity.drone.maxAltitudeAglMeters', mapOf_0(to('en', 'Max altitude AGL (m, optional)'))), to('logActivity.drone.payloadWeightKg', mapOf_0(to('en', 'Payload weight (kg, optional)'))), to('logActivity.envField.collectorSignature', mapOf_0(to('en', 'Collector signature (optional)'))), to('logActivity.envField.conductivityReading', mapOf_0(to('en', 'Conductivity reading (optional)'))), to('logActivity.envField.gpsCoordinates', mapOf_0(to('en', 'GPS coordinates (optional)'))), to('logActivity.envField.heading', mapOf_0(to('en', 'Environmental field sampling'))), to('logActivity.envField.phReading', mapOf_0(to('en', 'pH reading (optional)'))), to('logActivity.envField.preservationMethod', mapOf_0(to('en', 'Preservation method (optional)'))), to('logActivity.envField.sampleIdBarcode', mapOf_0(to('en', 'Sample ID barcode'))), to('logActivity.envField.transferLog', mapOf_0(to('en', 'Transfer log (optional)'))), to('logActivity.envField.waterOrSoilTempC', mapOf_0(to('en', 'Water or soil temp (\xB0C, optional)'))), to('logActivity.envField.weatherAtCollection', mapOf_0(to('en', 'Weather at collection (optional)'))), to('logActivity.equestrian.competitionScores', mapOf_0(to('en', 'Competition scores (optional)'))), to('logActivity.equestrian.discipline', mapOf_0(to('en', 'Discipline'))), to('logActivity.equestrian.farrierShoeingRotationDate', mapOf_0(to('en', 'Farrier shoeing rotation date (optional)'))), to('logActivity.equestrian.heading', mapOf_0(to('en', 'Equestrian session'))), to('logActivity.equestrian.jumpingCountAndHeights', mapOf_0(to('en', 'Jumping count and heights (optional)'))), to('logActivity.equestrian.lamenessOrSoundnessNotes', mapOf_0(to('en', 'Lameness or soundness notes (optional)'))), to('logActivity.equestrian.ridingRingHours', mapOf_0(to('en', 'Riding ring hours (optional)'))), to('logActivity.equestrian.veterinaryLogEntries', mapOf_0(to('en', 'Veterinary log entries (comma-separated, optional)'))), to('logActivity.falconry.baselineOrFlyingWeightG', mapOf_0(to('en', 'Baseline or flying weight (G, optional)'))), to('logActivity.falconry.dailyFeedingSchedule', mapOf_0(to('en', 'Daily feeding schedule (optional)'))), to('logActivity.falconry.freeFlightAirtimeMinutes', mapOf_0(to('en', 'Free flight airtime (minutes, optional)'))), to('logActivity.falconry.heading', mapOf_0(to('en', 'Falconry session'))), to('logActivity.falconry.jessesTelemetryUnitChecked', mapOf_0(to('en', 'Jesses telemetry unit checked'))), to('logActivity.falconry.mewsHousingConditionNotes', mapOf_0(to('en', 'Mews housing condition notes (optional)'))), to('logActivity.falconry.raptorSpecies', mapOf_0(to('en', 'Raptor species'))), to('logActivity.falconry.wildHuntSuccess', mapOf_0(to('en', 'Wild hunt success'))), to('logActivity.flightInstructor.checkrideReadinessSignOff', mapOf_0(to('en', 'Checkride readiness sign off'))), to('logActivity.flightInstructor.dualFlightInstructionHours', mapOf_0(to('en', 'Dual flight instruction hours (optional)'))), to('logActivity.flightInstructor.groundInstructionHours', mapOf_0(to('en', 'Ground instruction hours (optional)'))), to('logActivity.flightInstructor.heading', mapOf_0(to('en', 'Flight instructor'))), to('logActivity.flightInstructor.knowledgeTestClearanceGiven', mapOf_0(to('en', 'Knowledge test clearance given'))), to('logActivity.flightInstructor.licenseTrack', mapOf_0(to('en', 'License track'))), to('logActivity.flightInstructor.soloEndorsementGiven', mapOf_0(to('en', 'Solo endorsement given'))), to('logActivity.flightInstructor.studentName', mapOf_0(to('en', 'Student name'))), to('logActivity.flightSim.approachCountTowardCurrency', mapOf_0(to('en', 'Approach count toward currency'))), to('logActivity.flightSim.deviceQualificationLevel', mapOf_0(to('en', 'Device qualification level'))), to('logActivity.flightSim.emergencyFailuresIntroduced', mapOf_0(to('en', 'Emergency failures introduced (comma-separated, optional)'))), to('logActivity.flightSim.heading', mapOf_0(to('en', 'Flight simulator session'))), to('logActivity.flightSim.loggedInstrumentHours', mapOf_0(to('en', 'Logged instrument hours (optional)'))), to('logActivity.flightSim.simulatedWeatherMinimums', mapOf_0(to('en', 'Simulated weather minimums (optional)'))), to('logActivity.forklift.aisleOrZoneWorked', mapOf_0(to('en', 'Aisle or zone worked (optional)'))), to('logActivity.forklift.batteryOrPropaneSwapCount', mapOf_0(to('en', 'Battery or propane swap count'))), to('logActivity.forklift.forksAndMastInspectionPassed', mapOf_0(to('en', 'Forks and mast inspection passed'))), to('logActivity.forklift.heading', mapOf_0(to('en', 'Forklift shift'))), to('logActivity.forklift.hornLightsBrakesChecked', mapOf_0(to('en', 'Horn lights brakes checked'))), to('logActivity.forklift.leakOrDamageFlags', mapOf_0(to('en', 'Leak or damage flags (comma-separated, optional)'))), to('logActivity.forklift.loadWeightMovedKg', mapOf_0(to('en', 'Load weight moved (kg, optional)'))), to('logActivity.forklift.nearMissReports', mapOf_0(to('en', 'Near miss reports'))), to('logActivity.forklift.rackCollisionNotes', mapOf_0(to('en', 'Rack collision notes (optional)'))), to('logActivity.freedive.constantWeightDepthMeters', mapOf_0(to('en', 'Constant weight depth (m, optional)'))), to('logActivity.freedive.dynamicHorizontalDistanceMeters', mapOf_0(to('en', 'Dynamic horizontal distance (m, optional)'))), to('logActivity.freedive.heading', mapOf_0(to('en', 'Freedive'))), to('logActivity.freedive.packingBreathCount', mapOf_0(to('en', 'Packing breath count (optional)'))), to('logActivity.freedive.pulseOximetryPercent', mapOf_0(to('en', 'Pulse oximetry (%, optional)'))), to('logActivity.freedive.staticBreathHoldSeconds', mapOf_0(to('en', 'Static breath hold (seconds, optional)'))), to('logActivity.freedive.surfaceRecoverySeconds', mapOf_0(to('en', 'Surface recovery (seconds, optional)'))), to('logActivity.hamRadio.antennaConfiguration', mapOf_0(to('en', 'Antenna configuration (optional)'))), to('logActivity.hamRadio.bandConditions', mapOf_0(to('en', 'Band conditions (optional)'))), to('logActivity.hamRadio.contactCallSign', mapOf_0(to('en', 'Contact call sign'))), to('logActivity.hamRadio.frequencyMhz', mapOf_0(to('en', 'Frequency (MHz)'))), to('logActivity.hamRadio.heading', mapOf_0(to('en', 'Ham radio contact'))), to('logActivity.hamRadio.mode', mapOf_0(to('en', 'Mode'))), to('logActivity.hamRadio.powerOutputWatts', mapOf_0(to('en', 'Power output (watts, optional)'))), to('logActivity.hamRadio.qslCardConfirmed', mapOf_0(to('en', 'QSL card confirmed'))), to('logActivity.hamRadio.signalReportReceived', mapOf_0(to('en', 'Signal report received (optional)'))), to('logActivity.hamRadio.signalReportSent', mapOf_0(to('en', 'Signal report sent (optional)'))), to('logActivity.heavyEquipment.attachmentUsed', mapOf_0(to('en', 'Attachment used (optional)'))), to('logActivity.heavyEquipment.equipmentType', mapOf_0(to('en', 'Equipment type'))), to('logActivity.heavyEquipment.gradeToleranceAchieved', mapOf_0(to('en', 'Grade tolerance achieved (optional)'))), to('logActivity.heavyEquipment.heading', mapOf_0(to('en', 'Heavy equipment operation'))), to('logActivity.heavyEquipment.hourMeterReading', mapOf_0(to('en', 'Hour meter reading (optional)'))), to('logActivity.heavyEquipment.materialMovedCubicYards', mapOf_0(to('en', 'Material moved cubic yards (optional)'))), to('logActivity.heavyEquipment.preShiftInspectionPassed', mapOf_0(to('en', 'Pre shift inspection passed'))), to('logActivity.heavyEquipment.siteLocation', mapOf_0(to('en', 'Site location (optional)'))), to('logActivity.heavyEquipment.spotterPresent', mapOf_0(to('en', 'Spotter present'))), to('logActivity.heavyEquipment.undergroundUtilityLocatesConfirmed', mapOf_0(to('en', 'Underground utility locates confirmed'))), to('logActivity.hotAirBalloon.ambientTemperatureC', mapOf_0(to('en', 'Ambient temperature (\xB0C, optional)'))), to('logActivity.hotAirBalloon.basketSize', mapOf_0(to('en', 'Basket size (optional)'))), to('logActivity.hotAirBalloon.envelopeModel', mapOf_0(to('en', 'Envelope model'))), to('logActivity.hotAirBalloon.heading', mapOf_0(to('en', 'Hot air balloon pilot'))), to('logActivity.hotAirBalloon.landingCoordinates', mapOf_0(to('en', 'Landing coordinates (optional)'))), to('logActivity.hotAirBalloon.launchCoordinates', mapOf_0(to('en', 'Launch coordinates (optional)'))), to('logActivity.hotAirBalloon.postFlightResidualPressureBar', mapOf_0(to('en', 'Post flight residual pressure (bar, optional)'))), to('logActivity.hotAirBalloon.prePropaneVolumeLiters', mapOf_0(to('en', 'Pre propane volume (liters, optional)'))), to('logActivity.hotAirBalloon.surfaceWindSpeedKph', mapOf_0(to('en', 'Surface wind speed (km/h, optional)'))), to('logActivity.hotAirBalloon.totalBurnerHours', mapOf_0(to('en', 'Total burner hours (optional)'))), to('logActivity.iceClimb.alpineIceGrade', mapOf_0(to('en', 'Alpine ice grade (optional)'))), to('logActivity.iceClimb.ambientTemperatureC', mapOf_0(to('en', 'Ambient temperature (\xB0C, optional)'))), to('logActivity.iceClimb.heading', mapOf_0(to('en', 'Ice climb'))), to('logActivity.iceClimb.iceConsistency', mapOf_0(to('en', 'Ice consistency (optional)'))), to('logActivity.iceClimb.iceScrewSizesAndDepths', mapOf_0(to('en', 'Ice screw sizes and depths (comma-separated, optional)'))), to('logActivity.iceClimb.iceThicknessEstimateCm', mapOf_0(to('en', 'Ice thickness estimate (cm, optional)'))), to('logActivity.iceClimb.toolOrCramponModel', mapOf_0(to('en', 'Tool or crampon model (optional)'))), to('logActivity.iceClimb.vThreadAnchorCount', mapOf_0(to('en', 'V-thread anchor count'))), to('logActivity.iceClimb.waterIceGrade', mapOf_0(to('en', 'Water ice grade (optional)'))), to('logActivity.indoorSkydiving.bodyPositionDrills', mapOf_0(to('en', 'Body position drills (comma-separated, optional)'))), to('logActivity.indoorSkydiving.freeflyTransitionAttempts', mapOf_0(to('en', 'Freefly transition attempts (optional)'))), to('logActivity.indoorSkydiving.heading', mapOf_0(to('en', 'Indoor skydiving session'))), to('logActivity.indoorSkydiving.sessionDurationMinutes', mapOf_0(to('en', 'Session duration (minutes, optional)'))), to('logActivity.indoorSkydiving.studentCertificationLevel', mapOf_0(to('en', 'Student certification level (optional)'))), to('logActivity.indoorSkydiving.tunnelFacility', mapOf_0(to('en', 'Tunnel facility'))), to('logActivity.indoorSkydiving.windSpeedKph', mapOf_0(to('en', 'Wind speed (km/h, optional)'))), to('logActivity.kitesurf.boardType', mapOf_0(to('en', 'Board type (optional)'))), to('logActivity.kitesurf.gustFactor', mapOf_0(to('en', 'Gust factor (optional)'))), to('logActivity.kitesurf.heading', mapOf_0(to('en', 'Kitesurf / windsurf session'))), to('logActivity.kitesurf.jumpHeightOrHangtime', mapOf_0(to('en', 'Jump height or hangtime (optional)'))), to('logActivity.kitesurf.kiteOrSailSizeSqM', mapOf_0(to('en', 'Kite or sail size (m\xB2, optional)'))), to('logActivity.kitesurf.lineLengthM', mapOf_0(to('en', 'Line length (m, optional)'))), to('logActivity.kitesurf.selfRescueDrills', mapOf_0(to('en', 'Self rescue drills'))), to('logActivity.kitesurf.trickAttemptsLanded', mapOf_0(to('en', 'Trick attempts landed (optional)'))), to('logActivity.kitesurf.waterState', mapOf_0(to('en', 'Water state (optional)'))), to('logActivity.kitesurf.windSpeedKnots', mapOf_0(to('en', 'Wind speed (knots, optional)'))), to('logActivity.labResearch.experimentProtocolId', mapOf_0(to('en', 'Experiment protocol ID'))), to('logActivity.labResearch.heading', mapOf_0(to('en', 'Lab research session'))), to('logActivity.labResearch.hypothesisStatement', mapOf_0(to('en', 'Hypothesis statement (optional)'))), to('logActivity.labResearch.instrumentCalibrationReference', mapOf_0(to('en', 'Instrument calibration reference (optional)'))), to('logActivity.labResearch.notebookPageReference', mapOf_0(to('en', 'Notebook page reference (optional)'))), to('logActivity.labResearch.pressureKpa', mapOf_0(to('en', 'Pressure (kPa, optional)'))), to('logActivity.labResearch.reactionTimeMinutes', mapOf_0(to('en', 'Reaction time (minutes, optional)'))), to('logActivity.labResearch.reagentLotNumbers', mapOf_0(to('en', 'Reagent lot numbers (comma-separated, optional)'))), to('logActivity.labResearch.temperatureC', mapOf_0(to('en', 'Temperature (\xB0C, optional)'))), to('logActivity.labResearch.witnessOrCoSigner', mapOf_0(to('en', 'Witness or co signer (optional)'))), to('logActivity.labResearch.yieldPercent', mapOf_0(to('en', 'Yield (%, optional)'))), to('logActivity.landSurvey.benchmarkReference', mapOf_0(to('en', 'Benchmark reference (optional)'))), to('logActivity.landSurvey.calibrationDate', mapOf_0(to('en', 'Calibration date (optional)'))), to('logActivity.landSurvey.clientOrProjectNumber', mapOf_0(to('en', 'Client or project number (optional)'))), to('logActivity.landSurvey.gpsRtkCoordinates', mapOf_0(to('en', 'GPS RTK coordinates (optional)'))), to('logActivity.landSurvey.heading', mapOf_0(to('en', 'Land survey'))), to('logActivity.landSurvey.instrumentModel', mapOf_0(to('en', 'Instrument model (optional)'))), to('logActivity.landSurvey.platOrBoundarySketchReference', mapOf_0(to('en', 'Plat or boundary sketch reference (optional)'))), to('logActivity.landSurvey.totalStationReadings', mapOf_0(to('en', 'Total station readings (optional)'))), to('logActivity.lifeguard.heading', mapOf_0(to('en', 'Lifeguard shift'))), to('logActivity.lifeguard.medicalFirstAidTreatments', mapOf_0(to('en', 'Medical first aid treatments'))), to('logActivity.lifeguard.missingPersonSweeps', mapOf_0(to('en', 'Missing person sweeps'))), to('logActivity.lifeguard.poolChlorinePpm', mapOf_0(to('en', 'Pool chlorine (ppm, optional)'))), to('logActivity.lifeguard.poolPhBalance', mapOf_0(to('en', 'Pool pH balance (optional)'))), to('logActivity.lifeguard.ripCurrentRiskLevel', mapOf_0(to('en', 'Rip current risk level (optional)'))), to('logActivity.lifeguard.surfZoneWaveHeightMeters', mapOf_0(to('en', 'Surf zone wave height (m, optional)'))), to('logActivity.lifeguard.swimmerAssists', mapOf_0(to('en', 'Swimmer assists'))), to('logActivity.lifeguard.turnoverFiltrationCycles', mapOf_0(to('en', 'Turnover filtration cycles (optional)'))), to('logActivity.lifeguard.uvIndex', mapOf_0(to('en', 'Uv index (optional)'))), to('logActivity.lifeguard.waterTempC', mapOf_0(to('en', 'Water temp (\xB0C, optional)'))), to('logActivity.livestock.calvingOrLambingRecords', mapOf_0(to('en', 'Calving or lambing records (optional)'))), to('logActivity.livestock.feedRations', mapOf_0(to('en', 'Feed rations (optional)'))), to('logActivity.livestock.headCount', mapOf_0(to('en', 'Head count'))), to('logActivity.livestock.heading', mapOf_0(to('en', 'Livestock handling'))), to('logActivity.livestock.medicationAdministered', mapOf_0(to('en', 'Medication administered (optional)'))), to('logActivity.livestock.pastureRotationDate', mapOf_0(to('en', 'Pasture rotation date (optional)'))), to('logActivity.livestock.tagOrIdNumbers', mapOf_0(to('en', 'Tag or ID numbers (comma-separated, optional)'))), to('logActivity.livestock.vaccinationSchedule', mapOf_0(to('en', 'Vaccination schedule (optional)'))), to('logActivity.livestock.weightGainTrackingKg', mapOf_0(to('en', 'Weight gain tracking (kg, optional)'))), to('logActivity.merchantMarine.cargoConfiguration', mapOf_0(to('en', 'Cargo configuration (optional)'))), to('logActivity.merchantMarine.enginePropulsionHp', mapOf_0(to('en', 'Engine propulsion (hp, optional)'))), to('logActivity.merchantMarine.engineRoomWatchHours', mapOf_0(to('en', 'Engine room watch hours (optional)'))), to('logActivity.merchantMarine.foreignPortsVisited', mapOf_0(to('en', 'Foreign ports visited (comma-separated, optional)'))), to('logActivity.merchantMarine.grossTonnage', mapOf_0(to('en', 'Gross tonnage (optional)'))), to('logActivity.merchantMarine.heading', mapOf_0(to('en', 'Merchant marine watch'))), to('logActivity.merchantMarine.imoNumber', mapOf_0(to('en', 'IMO number (optional)'))), to('logActivity.merchantMarine.lookoutDutyHours', mapOf_0(to('en', 'Lookout duty hours (optional)'))), to('logActivity.merchantMarine.navigationWatchHours', mapOf_0(to('en', 'Navigation watch hours (optional)'))), to('logActivity.merchantMarine.seaDaysLogged', mapOf_0(to('en', 'Sea days logged (optional)'))), to('logActivity.merchantMarine.vesselName', mapOf_0(to('en', 'Vessel name'))), to('logActivity.parachuteRigger.aadBatteryStatus', mapOf_0(to('en', 'AAD battery status (optional)'))), to('logActivity.parachuteRigger.canopyPorosityTestPassed', mapOf_0(to('en', 'Canopy porosity test passed'))), to('logActivity.parachuteRigger.heading', mapOf_0(to('en', 'Parachute rigging'))), to('logActivity.parachuteRigger.lineContinuityCheckPassed', mapOf_0(to('en', 'Line continuity check passed'))), to('logActivity.parachuteRigger.masterRiggerCertificateNumber', mapOf_0(to('en', 'Master rigger certificate number'))), to('logActivity.parachuteRigger.parachuteSerialNumber', mapOf_0(to('en', 'Parachute serial number'))), to('logActivity.parachuteRigger.sealNumberApplied', mapOf_0(to('en', 'Seal number applied (optional)'))), to('logActivity.paramotor.cylinderHeadTempC', mapOf_0(to('en', 'Cylinder head temp (\xB0C, optional)'))), to('logActivity.paramotor.durationSeconds', mapOf_0(to('en', 'Duration (seconds, optional)'))), to('logActivity.paramotor.engineRpmRange', mapOf_0(to('en', 'Engine rpm range (optional)'))), to('logActivity.paramotor.exhaustGasTempC', mapOf_0(to('en', 'Exhaust gas temp (\xB0C, optional)'))), to('logActivity.paramotor.flightRangeKm', mapOf_0(to('en', 'Flight range (km, optional)'))), to('logActivity.paramotor.fuelMixRatio', mapOf_0(to('en', 'Fuel mix ratio (optional)'))), to('logActivity.paramotor.fuelVolumeConsumedLiters', mapOf_0(to('en', 'Fuel volume consumed (liters, optional)'))), to('logActivity.paramotor.heading', mapOf_0(to('en', 'Paramotor flight'))), to('logActivity.paramotor.paramotorFrameModel', mapOf_0(to('en', 'Paramotor frame model'))), to('logActivity.physicalTherapy.exerciseSetsReps', mapOf_0(to('en', 'Exercise sets reps (comma-separated, optional)'))), to('logActivity.physicalTherapy.heading', mapOf_0(to('en', 'Physical therapy session'))), to('logActivity.physicalTherapy.nextMilestoneOrReassessmentDate', mapOf_0(to('en', 'Next milestone or reassessment date (optional)'))), to('logActivity.physicalTherapy.painRatingScale', mapOf_0(to('en', 'Pain rating scale (optional)'))), to('logActivity.physicalTherapy.rangeOfMotionDegrees', mapOf_0(to('en', 'Range of motion (degrees, optional)'))), to('logActivity.physicalTherapy.resistanceOrTissueLoadProgression', mapOf_0(to('en', 'Resistance or tissue load progression (optional)'))), to('logActivity.physicalTherapy.therapistSignature', mapOf_0(to('en', 'Therapist signature (optional)'))), to('logActivity.powerlifting.barVelocityMs', mapOf_0(to('en', 'Bar velocity (m/s, optional)'))), to('logActivity.powerlifting.competitionAttempts', mapOf_0(to('en', 'Competition attempts (comma-separated, optional)'))), to('logActivity.powerlifting.heading', mapOf_0(to('en', 'Powerlifting session'))), to('logActivity.powerlifting.oneRepMaxEstimateKg', mapOf_0(to('en', 'One rep max estimate (kg, optional)'))), to('logActivity.powerlifting.rpe', mapOf_0(to('en', 'RPE (optional)'))), to('logActivity.powerlifting.setsRepsWeightLog', mapOf_0(to('en', 'Sets reps weight log (comma-separated, optional)'))), to('logActivity.powerlifting.totalSessionTonnageKg', mapOf_0(to('en', 'Total session tonnage (kg, optional)'))), to('logActivity.qaTesting.affectedComponent', mapOf_0(to('en', 'Affected component (optional)'))), to('logActivity.qaTesting.bugReplicationSteps', mapOf_0(to('en', 'Bug replication steps (optional)'))), to('logActivity.qaTesting.buildCommitHash', mapOf_0(to('en', 'Build commit hash'))), to('logActivity.qaTesting.cveOrCweReference', mapOf_0(to('en', 'CVE or CWE reference (optional)'))), to('logActivity.qaTesting.environment', mapOf_0(to('en', 'Environment'))), to('logActivity.qaTesting.exploitTimelineNotes', mapOf_0(to('en', 'Exploit timeline notes (optional)'))), to('logActivity.qaTesting.heading', mapOf_0(to('en', 'QA testing session'))), to('logActivity.qaTesting.severityClassification', mapOf_0(to('en', 'Severity classification (optional)'))), to('logActivity.qaTesting.testSuiteVersion', mapOf_0(to('en', 'Test suite version (optional)'))), to('logActivity.qaTesting.vulnerabilityPayloadUsed', mapOf_0(to('en', 'Vulnerability payload used (optional)'))), to('logActivity.railway.brakeTestVerified', mapOf_0(to('en', 'Brake test verified'))), to('logActivity.railway.consistCarCount', mapOf_0(to('en', 'Consist car count (optional)'))), to('logActivity.railway.consistTonnage', mapOf_0(to('en', 'Consist tonnage (optional)'))), to('logActivity.railway.heading', mapOf_0(to('en', 'Railway run'))), to('logActivity.railway.lineRouteSegment', mapOf_0(to('en', 'Line route segment'))), to('logActivity.railway.signalComplianceLog', mapOf_0(to('en', 'Signal compliance log (optional)'))), to('logActivity.railway.speedRestrictionZonesObserved', mapOf_0(to('en', 'Speed restriction zones observed (comma-separated, optional)'))), to('logActivity.railway.trackWarrantAuthorityNumber', mapOf_0(to('en', 'Track warrant authority number (optional)'))), to('logActivity.rowing.avgHeartRateBpm', mapOf_0(to('en', 'Avg heart rate (bpm, optional)'))), to('logActivity.rowing.distanceMeters', mapOf_0(to('en', 'Distance (m)'))), to('logActivity.rowing.heading', mapOf_0(to('en', 'Rowing session'))), to('logActivity.rowing.peakPowerOutputWatts', mapOf_0(to('en', 'Peak power output (watts, optional)'))), to('logActivity.rowing.splitTimePer500mSeconds', mapOf_0(to('en', 'Split time per500m (seconds, optional)'))), to('logActivity.rowing.strokeRateSpm', mapOf_0(to('en', 'Stroke rate (spm, optional)'))), to('logActivity.safetyDive.evidenceBagTrackingNumber', mapOf_0(to('en', 'Evidence bag tracking number (optional)'))), to('logActivity.safetyDive.heading', mapOf_0(to('en', 'Public safety dive'))), to('logActivity.safetyDive.recoveryDepthCoordinates', mapOf_0(to('en', 'Recovery depth coordinates (optional)'))), to('logActivity.safetyDive.searchPatternProfile', mapOf_0(to('en', 'Search pattern profile'))), to('logActivity.safetyDive.visibility', mapOf_0(to('en', 'Visibility (optional)'))), to('logActivity.sailing.barometricPressureHpa', mapOf_0(to('en', 'Barometric pressure (hPa, optional)'))), to('logActivity.sailing.batteryBankVoltage', mapOf_0(to('en', 'Battery bank voltage (optional)'))), to('logActivity.sailing.deadReckoningCoordinates', mapOf_0(to('en', 'Dead reckoning coordinates (optional)'))), to('logActivity.sailing.engineRuntimeHours', mapOf_0(to('en', 'Engine runtime hours (optional)'))), to('logActivity.sailing.gpsWaypoints', mapOf_0(to('en', 'GPS waypoints (comma-separated, optional)'))), to('logActivity.sailing.heading', mapOf_0(to('en', 'Sailing voyage'))), to('logActivity.sailing.magneticVariationDegrees', mapOf_0(to('en', 'Magnetic variation (degrees, optional)'))), to('logActivity.sailing.sailPlanConfiguration', mapOf_0(to('en', 'Sail plan configuration (optional)'))), to('logActivity.sailing.seaStateBeaufort', mapOf_0(to('en', 'Sea state beaufort (optional)'))), to('logActivity.sailing.trueHeadingDegrees', mapOf_0(to('en', 'True heading (degrees, optional)'))), to('logActivity.sailing.windAngleDegrees', mapOf_0(to('en', 'Wind angle (degrees, optional)'))), to('logActivity.sailing.windSpeedKnots', mapOf_0(to('en', 'Wind speed (knots, optional)'))), to('logActivity.sciDive.heading', mapOf_0(to('en', 'Scientific research dive'))), to('logActivity.sciDive.marineLifeCounts', mapOf_0(to('en', 'Marine life counts (optional)'))), to('logActivity.sciDive.quadratGridCoordinates', mapOf_0(to('en', 'Quadrat grid coordinates (optional)'))), to('logActivity.sciDive.sampleCanisterBarcodes', mapOf_0(to('en', 'Sample canister barcodes (comma-separated, optional)'))), to('logActivity.sciDive.sensorDeploymentDepthMeters', mapOf_0(to('en', 'Sensor deployment depth (m, optional)'))), to('logActivity.sciDive.substrateComposition', mapOf_0(to('en', 'Substrate composition (optional)'))), to('logActivity.sciDive.transectLineLengthMeters', mapOf_0(to('en', 'Transect line length (m, optional)'))), to('logActivity.scubaService.componentTeardownChecklist', mapOf_0(to('en', 'Component teardown checklist (comma-separated, optional)'))), to('logActivity.scubaService.crackingOrVenturiEffectCheckPassed', mapOf_0(to('en', 'Cracking or venturi effect check passed'))), to('logActivity.scubaService.heading', mapOf_0(to('en', 'Scuba life-support service'))), to('logActivity.scubaService.intermediatePressureTestReadingBar', mapOf_0(to('en', 'Intermediate pressure test reading (bar, optional)'))), to('logActivity.scubaService.manufacturerWarrantyStatus', mapOf_0(to('en', 'Manufacturer warranty status (optional)'))), to('logActivity.scubaService.partsReplaced', mapOf_0(to('en', 'Parts replaced (comma-separated, optional)'))), to('logActivity.scubaService.regulatorSerialNumber', mapOf_0(to('en', 'Regulator serial number'))), to('logActivity.scubaService.technicianCertificationNumber', mapOf_0(to('en', 'Technician certification number'))), to('logActivity.skydive.aircraftType', mapOf_0(to('en', 'Aircraft type (optional)'))), to('logActivity.skydive.canopySquareFootage', mapOf_0(to('en', 'Canopy square footage (optional)'))), to('logActivity.skydive.deploymentAltitudeMeters', mapOf_0(to('en', 'Deployment altitude (m, optional)'))), to('logActivity.skydive.exitAltitudeAglMeters', mapOf_0(to('en', 'Exit altitude AGL (m, optional)'))), to('logActivity.skydive.freefallTimeSeconds', mapOf_0(to('en', 'Freefall time (seconds, optional)'))), to('logActivity.skydive.heading', mapOf_0(to('en', 'Skydive'))), to('logActivity.skydive.jumpNumber', mapOf_0(to('en', 'Jump number'))), to('logActivity.skydive.landingAccuracyMeters', mapOf_0(to('en', 'Landing accuracy (m, optional)'))), to('logActivity.skydive.mainCanopyModel', mapOf_0(to('en', 'Main canopy model (optional)'))), to('logActivity.skydive.maneuverTypes', mapOf_0(to('en', 'Maneuver types (comma-separated, optional)'))), to('logActivity.skydive.terminalVelocityReachedKph', mapOf_0(to('en', 'Terminal velocity reached (km/h, optional)'))), to('logActivity.skydive.uspaLicenseNumber', mapOf_0(to('en', 'USPA license number (optional)'))), to('logActivity.soundRecording.busRoutingConfiguration', mapOf_0(to('en', 'Bus routing configuration (optional)'))), to('logActivity.soundRecording.compOrKeeperFlag', mapOf_0(to('en', 'Comp or keeper flag'))), to('logActivity.soundRecording.heading', mapOf_0(to('en', 'Sound recording session'))), to('logActivity.soundRecording.key', mapOf_0(to('en', 'Key (optional)'))), to('logActivity.soundRecording.masterExportLoudnessLufs', mapOf_0(to('en', 'Master export loudness (LUFS, optional)'))), to('logActivity.soundRecording.microphoneModelsAndPlacement', mapOf_0(to('en', 'Microphone models and placement (comma-separated, optional)'))), to('logActivity.soundRecording.pluginChainUsed', mapOf_0(to('en', 'Plugin chain used (comma-separated, optional)'))), to('logActivity.soundRecording.preampGainSettingsDb', mapOf_0(to('en', 'Preamp gain settings (dB, optional)'))), to('logActivity.soundRecording.studioOrVenue', mapOf_0(to('en', 'Studio or venue'))), to('logActivity.soundRecording.tempoBpm', mapOf_0(to('en', 'Tempo (bpm, optional)'))), to('logActivity.soundRecording.trackTakeNumber', mapOf_0(to('en', 'Track take number (optional)'))), to('logActivity.spearfishing.breathHoldSeconds', mapOf_0(to('en', 'Breath hold (seconds, optional)'))), to('logActivity.spearfishing.catchBagWeightKg', mapOf_0(to('en', 'Catch bag weight (kg, optional)'))), to('logActivity.spearfishing.depthOfTakesMeters', mapOf_0(to('en', 'Depth of takes (m, optional)'))), to('logActivity.spearfishing.diveBuddyPresent', mapOf_0(to('en', 'Dive buddy present'))), to('logActivity.spearfishing.diveCount', mapOf_0(to('en', 'Dive count (optional)'))), to('logActivity.spearfishing.heading', mapOf_0(to('en', 'Spearfishing'))), to('logActivity.spearfishing.lengthCm', mapOf_0(to('en', 'Length (cm, optional)'))), to('logActivity.spearfishing.spearGunBandConfiguration', mapOf_0(to('en', 'Spear gun band configuration (optional)'))), to('logActivity.spearfishing.speciesCaught', mapOf_0(to('en', 'Species caught (comma-separated, optional)'))), to('logActivity.spearfishing.surfaceSignalingDeviceUsed', mapOf_0(to('en', 'Surface signaling device used'))), to('logActivity.spearfishing.weightKg', mapOf_0(to('en', 'Weight (kg, optional)'))), to('logActivity.speedwing.canopyDistanceFromTerrainMeters', mapOf_0(to('en', 'Canopy distance from terrain (m, optional)'))), to('logActivity.speedwing.footLaunchRollDistanceMeters', mapOf_0(to('en', 'Foot launch roll distance (m, optional)'))), to('logActivity.speedwing.glideRatio', mapOf_0(to('en', 'Glide ratio (optional)'))), to('logActivity.speedwing.heading', mapOf_0(to('en', 'Speedwing / proximity flight'))), to('logActivity.speedwing.maxGroundSpeedKph', mapOf_0(to('en', 'Max ground speed (km/h, optional)'))), to('logActivity.speedwing.mountainSlopeAngleDegrees', mapOf_0(to('en', 'Mountain slope angle (degrees, optional)'))), to('logActivity.surf.boardLengthOrVolume', mapOf_0(to('en', 'Board length or volume (optional)'))), to('logActivity.surf.finSetup', mapOf_0(to('en', 'Fin setup (optional)'))), to('logActivity.surf.heading', mapOf_0(to('en', 'Surf session'))), to('logActivity.surf.leashLengthM', mapOf_0(to('en', 'Leash length (m, optional)'))), to('logActivity.surf.longestRideDurationSeconds', mapOf_0(to('en', 'Longest ride duration (seconds, optional)'))), to('logActivity.surf.maneuverTypesLanded', mapOf_0(to('en', 'Maneuver types landed (comma-separated, optional)'))), to('logActivity.surf.swellHeightMeters', mapOf_0(to('en', 'Swell height (m, optional)'))), to('logActivity.surf.swellPeriodSeconds', mapOf_0(to('en', 'Swell period (seconds, optional)'))), to('logActivity.surf.tideStage', mapOf_0(to('en', 'Tide stage (optional)'))), to('logActivity.surf.waveCount', mapOf_0(to('en', 'Wave count (optional)'))), to('logActivity.surf.windDirection', mapOf_0(to('en', 'Wind direction (optional)'))), to('logActivity.swimming.avgHeartRateBpm', mapOf_0(to('en', 'Avg heart rate (bpm, optional)'))), to('logActivity.swimming.distancePerSetMeters', mapOf_0(to('en', 'Distance per set (m)'))), to('logActivity.swimming.heading', mapOf_0(to('en', 'Swimming session'))), to('logActivity.swimming.pacePer100mSeconds', mapOf_0(to('en', 'Pace per 100m (seconds, optional)'))), to('logActivity.swimming.poolLengthType', mapOf_0(to('en', 'Pool length type (optional)'))), to('logActivity.swimming.restIntervalSeconds', mapOf_0(to('en', 'Rest interval (seconds, optional)'))), to('logActivity.swimming.strokeCountPerLength', mapOf_0(to('en', 'Stroke count per length (optional)'))), to('logActivity.swimming.strokeType', mapOf_0(to('en', 'Stroke type'))), to('logActivity.swimming.suitType', mapOf_0(to('en', 'Suit type (optional)'))), to('logActivity.tattooApprentice.autoclaveSterilizationCycles', mapOf_0(to('en', 'Autoclave sterilization cycles (optional)'))), to('logActivity.tattooApprentice.bloodbornePathogenCertificationDate', mapOf_0(to('en', 'Bloodborne pathogen certification date (optional)'))), to('logActivity.tattooApprentice.crossContaminationExamResult', mapOf_0(to('en', 'Cross contamination exam result (optional)'))), to('logActivity.tattooApprentice.heading', mapOf_0(to('en', 'Tattoo apprenticeship'))), to('logActivity.tattooApprentice.skinCanvasHours', mapOf_0(to('en', 'Skin canvas hours (optional)'))), to('logActivity.tattooApprentice.sporeTestResult', mapOf_0(to('en', 'Spore test result (optional)'))), to('logActivity.tattooApprentice.supervisingArtist', mapOf_0(to('en', 'Supervising artist'))), to('logActivity.techDive.actualDecoRuntimeMinutes', mapOf_0(to('en', 'Actual deco runtime (minutes, optional)'))), to('logActivity.techDive.bottomMixHeliumPercent', mapOf_0(to('en', 'Bottom mix helium (%, optional)'))), to('logActivity.techDive.bottomMixOxygenPercent', mapOf_0(to('en', 'Bottom mix oxygen (%, optional)'))), to('logActivity.techDive.gasMixPercentExceeds100Error', mapOf_0(to('en', "Bottom mix oxygen and helium percentages can't add up to more than 100%."))), to('logActivity.techDive.ccrSetpointPpo2', mapOf_0(to('en', 'CCR setpoint PPO2 (optional)'))), to('logActivity.techDive.decompressionGasChoices', mapOf_0(to('en', 'Decompression gas choices (comma-separated, optional)'))), to('logActivity.techDive.deepStopDepthsMeters', mapOf_0(to('en', 'Deep stop depths (m, comma-separated, optional)'))), to('logActivity.techDive.gasSwitchCheckpointsMeters', mapOf_0(to('en', 'Gas switch checkpoints (m, comma-separated, optional)'))), to('logActivity.techDive.heading', mapOf_0(to('en', 'Technical / deep dive'))), to('logActivity.techDive.plannedDecoRuntimeMinutes', mapOf_0(to('en', 'Planned deco runtime (minutes, optional)'))), to('logActivity.techDive.stageBottleCapacities', mapOf_0(to('en', 'Stage bottle capacities (comma-separated, optional)'))), to('logActivity.techDive.travelMixFractions', mapOf_0(to('en', 'Travel mix fractions (comma-separated, optional)'))), to('logActivity.techDive.twinsetTankPressureBar', mapOf_0(to('en', 'Twinset tank pressure (bar, optional)'))), to('logActivity.thruHike.dailyMileageKm', mapOf_0(to('en', 'Daily mileage (km)'))), to('logActivity.thruHike.elevationGainMeters', mapOf_0(to('en', 'Elevation gain (m, optional)'))), to('logActivity.thruHike.elevationLossMeters', mapOf_0(to('en', 'Elevation loss (m, optional)'))), to('logActivity.thruHike.heading', mapOf_0(to('en', 'Thru-hike'))), to('logActivity.thruHike.packWeightKg', mapOf_0(to('en', 'Pack weight (kg, optional)'))), to('logActivity.thruHike.resupplyStop', mapOf_0(to('en', 'Resupply stop (optional)'))), to('logActivity.thruHike.terrainTypeNotes', mapOf_0(to('en', 'Terrain type notes (optional)'))), to('logActivity.thruHike.trailJunctionMarkers', mapOf_0(to('en', 'Trail junction markers (comma-separated, optional)'))), to('logActivity.thruHike.waterSourceLocations', mapOf_0(to('en', 'Water source locations (comma-separated, optional)'))), to('logActivity.thruHike.weatherEncountered', mapOf_0(to('en', 'Weather encountered (optional)'))), to('logActivity.tradeApprentice.codeExamMilestones', mapOf_0(to('en', 'Code exam milestones (comma-separated, optional)'))), to('logActivity.tradeApprentice.commercialVsResidentialHours', mapOf_0(to('en', 'Commercial vs residential hours (optional)'))), to('logActivity.tradeApprentice.cumulativeHoursTowardLicense', mapOf_0(to('en', 'Cumulative hours toward license (optional)'))), to('logActivity.tradeApprentice.heading', mapOf_0(to('en', 'Trade apprenticeship'))), to('logActivity.tradeApprentice.jobSiteOrProject', mapOf_0(to('en', 'Job site or project'))), to('logActivity.tradeApprentice.masterTradespersonNameOrLicense', mapOf_0(to('en', 'Master tradesperson name or license'))), to('logActivity.tradeApprentice.signOffDate', mapOf_0(to('en', 'Sign off date (optional)'))), to('logActivity.tradeApprentice.taskCategory', mapOf_0(to('en', 'Task category (optional)'))), to('logActivity.trailRun.avgHeartRateBpm', mapOf_0(to('en', 'Avg heart rate (bpm, optional)'))), to('logActivity.trailRun.cadenceSpm', mapOf_0(to('en', 'Cadence (spm, optional)'))), to('logActivity.trailRun.cumulativeShoeMileageKm', mapOf_0(to('en', 'Cumulative shoe mileage (km, optional)'))), to('logActivity.trailRun.distanceMeters', mapOf_0(to('en', 'Distance (m)'))), to('logActivity.trailRun.durationSeconds', mapOf_0(to('en', 'Duration (seconds)'))), to('logActivity.trailRun.elevationGainMeters', mapOf_0(to('en', 'Elevation gain (m, optional)'))), to('logActivity.trailRun.heading', mapOf_0(to('en', 'Trail run'))), to('logActivity.trailRun.paceSecondsPerKm', mapOf_0(to('en', 'Pace (seconds per km, optional)'))), to('logActivity.trailRun.shoeModel', mapOf_0(to('en', 'Shoe model (optional)'))), to('logActivity.transit.brakeAndTireInspectionNotes', mapOf_0(to('en', 'Brake and tire inspection notes (optional)'))), to('logActivity.transit.dailySafetyCheckpointPassed', mapOf_0(to('en', 'Daily safety checkpoint passed'))), to('logActivity.transit.fareOrAdaLiftUsage', mapOf_0(to('en', 'Fare or ADA lift usage (optional)'))), to('logActivity.transit.heading', mapOf_0(to('en', 'Transit operator shift'))), to('logActivity.transit.incidentReports', mapOf_0(to('en', 'Incident reports (comma-separated, optional)'))), to('logActivity.transit.passengerBoardingCount', mapOf_0(to('en', 'Passenger boarding count (optional)'))), to('logActivity.transit.routeNumber', mapOf_0(to('en', 'Route number'))), to('logActivity.transit.stopDelayNotes', mapOf_0(to('en', 'Stop delay notes (optional)'))), to('logActivity.transit.timingLoopAdherence', mapOf_0(to('en', 'Timing loop adherence (optional)'))), to('logActivity.triathlon.bikeSplitSeconds', mapOf_0(to('en', 'Bike split (seconds)'))), to('logActivity.triathlon.heading', mapOf_0(to('en', 'Triathlon'))), to('logActivity.triathlon.nutritionPlanFollowed', mapOf_0(to('en', 'Nutrition plan followed (optional)'))), to('logActivity.triathlon.runSplitSeconds', mapOf_0(to('en', 'Run split (seconds)'))), to('logActivity.triathlon.swimSplitSeconds', mapOf_0(to('en', 'Swim split (seconds)'))), to('logActivity.triathlon.t1DurationSeconds', mapOf_0(to('en', 'T1 duration (seconds, optional)'))), to('logActivity.triathlon.t2DurationSeconds', mapOf_0(to('en', 'T2 duration (seconds, optional)'))), to('logActivity.triathlon.wetsuitBikeRunGearConfiguration', mapOf_0(to('en', 'Wetsuit bike run gear configuration (optional)'))), to('logActivity.truckDriver.drivingHours', mapOf_0(to('en', 'Driving hours'))), to('logActivity.truckDriver.eldDeviceId', mapOf_0(to('en', 'ELD device ID (optional)'))), to('logActivity.truckDriver.fuelStops', mapOf_0(to('en', 'Fuel stops'))), to('logActivity.truckDriver.heading', mapOf_0(to('en', 'Truck driving shift'))), to('logActivity.truckDriver.hosViolationFlags', mapOf_0(to('en', 'HOS violation flags (comma-separated, optional)'))), to('logActivity.truckDriver.odometerEndKm', mapOf_0(to('en', 'Odometer end (km, optional)'))), to('logActivity.truckDriver.odometerStartKm', mapOf_0(to('en', 'Odometer start (km, optional)'))), to('logActivity.truckDriver.onDutyNotDrivingHours', mapOf_0(to('en', 'On duty not driving hours (optional)'))), to('logActivity.truckDriver.postTripInspectionPassed', mapOf_0(to('en', 'Post trip inspection passed'))), to('logActivity.truckDriver.preTripInspectionPassed', mapOf_0(to('en', 'Pre trip inspection passed'))), to('logActivity.truckDriver.routeManifestNumber', mapOf_0(to('en', 'Route manifest number (optional)'))), to('logActivity.truckDriver.sleeperBerthHours', mapOf_0(to('en', 'Sleeper berth hours (optional)'))), to('logActivity.underwaterPhoto.cameraHousingModel', mapOf_0(to('en', 'Camera housing model'))), to('logActivity.underwaterPhoto.depthRatingMeters', mapOf_0(to('en', 'Depth rating (m, optional)'))), to('logActivity.underwaterPhoto.diveSite', mapOf_0(to('en', 'Dive site (optional)'))), to('logActivity.underwaterPhoto.footageDurationOrShotCount', mapOf_0(to('en', 'Footage duration or shot count (optional)'))), to('logActivity.underwaterPhoto.heading', mapOf_0(to('en', 'Underwater photography'))), to('logActivity.underwaterPhoto.strobeSetup', mapOf_0(to('en', 'Strobe setup (optional)'))), to('logActivity.underwaterPhoto.subjectSpeciesOrWreck', mapOf_0(to('en', 'Subject species or wreck (optional)'))), to('logActivity.weldingApprentice.arcHours', mapOf_0(to('en', 'Arc hours (optional)'))), to('logActivity.weldingApprentice.awsCertificationTrack', mapOf_0(to('en', 'AWS certification track (optional)'))), to('logActivity.weldingApprentice.defectRate', mapOf_0(to('en', 'Defect rate (optional)'))), to('logActivity.weldingApprentice.heading', mapOf_0(to('en', 'Welding apprenticeship'))), to('logActivity.weldingApprentice.jointIntegrityTestResult', mapOf_0(to('en', 'Joint integrity test result (optional)'))), to('logActivity.weldingApprentice.metalTypeAndThickness', mapOf_0(to('en', 'Metal type and thickness (optional)'))), to('logActivity.weldingApprentice.supervisingWelderSignOff', mapOf_0(to('en', 'Supervising welder sign off (optional)'))), to('logActivity.weldingApprentice.weldProcess', mapOf_0(to('en', 'Weld process'))), to('logActivity.whitewaterGuide.flipOrWrapIncidents', mapOf_0(to('en', 'Flip or wrap incidents'))), to('logActivity.whitewaterGuide.flowVolumeCfs', mapOf_0(to('en', 'Flow volume (CFS, optional)'))), to('logActivity.whitewaterGuide.gaugeHeightFeet', mapOf_0(to('en', 'Gauge height (ft, optional)'))), to('logActivity.whitewaterGuide.heading', mapOf_0(to('en', 'Whitewater guiding'))), to('logActivity.whitewaterGuide.passengerHeadcount', mapOf_0(to('en', 'Passenger headcount (optional)'))), to('logActivity.whitewaterGuide.rapidClassificationsTraversed', mapOf_0(to('en', 'Rapid classifications traversed (comma-separated, optional)'))), to('logActivity.whitewaterGuide.riverSystemName', mapOf_0(to('en', 'River system name'))), to('logActivity.whitewaterGuide.runSector', mapOf_0(to('en', 'Run sector (optional)'))), to('logActivity.wingsuit.firstFlightCourseCompleted', mapOf_0(to('en', 'First flight course completed'))), to('logActivity.wingsuit.flightTimeBeforeDeploymentSeconds', mapOf_0(to('en', 'Flight time before deployment (seconds, optional)'))), to('logActivity.wingsuit.glideRatioAchieved', mapOf_0(to('en', 'Glide ratio achieved (optional)'))), to('logActivity.wingsuit.heading', mapOf_0(to('en', 'Wingsuit flight'))), to('logActivity.wingsuit.horizontalToVerticalSpeedRatio', mapOf_0(to('en', 'Horizontal to vertical speed ratio (optional)'))), to('logActivity.wingsuit.jumpNumberMilestone', mapOf_0(to('en', 'Jump number milestone (optional)'))), to('logActivity.wingsuit.jumpNumberOnSuit', mapOf_0(to('en', 'Jump number on suit (optional)'))), to('logActivity.wingsuit.wingSurfaceAreaSqM', mapOf_0(to('en', 'Wing surface area (m\xB2, optional)'))), to('logActivity.wingsuit.wingsuitModel', mapOf_0(to('en', 'Wingsuit model'))), to('logActivity.workingDog.certificationLevel', mapOf_0(to('en', 'Certification level (optional)'))), to('logActivity.workingDog.distractionResistanceDrills', mapOf_0(to('en', 'Distraction resistance drills (comma-separated, optional)'))), to('logActivity.workingDog.dummyTargetFindRatio', mapOf_0(to('en', 'Dummy target find ratio (optional)'))), to('logActivity.workingDog.findOutcome', mapOf_0(to('en', 'Find outcome (optional)'))), to('logActivity.workingDog.heading', mapOf_0(to('en', 'Working dog session'))), to('logActivity.workingDog.recertificationDueDate', mapOf_0(to('en', 'Recertification due date (optional)'))), to('logActivity.workingDog.scentTrailTrackingHours', mapOf_0(to('en', 'Scent trail tracking hours (optional)'))), to('logActivity.workingDog.searchAreaOrGrid', mapOf_0(to('en', 'Search area or grid (optional)'))), to('activityCatalog.type.studentPilot', mapOf([to('en', 'Student Pilot'), to('es', 'Piloto Estudiante'), to('fr', '\xC9l\xE8ve Pilote'), to('pt', 'Piloto Estudante'), to('zh', '\u5B66\u5458\u98DE\u884C\u5458')])), to('activityCatalog.type.airlineTransportPilot', mapOf([to('en', 'Airline Transport Pilot'), to('es', 'Piloto de Transporte de L\xEDnea A\xE9rea'), to('fr', 'Pilote de Ligne'), to('pt', 'Piloto de Transporte A\xE9reo'), to('zh', '\u822A\u7EBF\u8FD0\u8F93\u98DE\u884C\u5458')])), to('activityCatalog.type.flightInstructor', mapOf([to('en', 'Flight Instructor'), to('es', 'Instructor de Vuelo'), to('fr', 'Instructeur de Vol'), to('pt', 'Instrutor de Voo'), to('zh', '\u98DE\u884C\u6559\u5458')])), to('activityCatalog.type.aircraftMaintenanceTechnician', mapOf([to('en', 'Aircraft Maintenance Technician'), to('es', 'T\xE9cnico de Mantenimiento de Aeronaves'), to('fr', 'Technicien de Maintenance A\xE9ronautique'), to('pt', 'T\xE9cnico de Manuten\xE7\xE3o de Aeronaves'), to('zh', '\u98DE\u673A\u7EF4\u4FEE\u6280\u5E08')])), to('activityCatalog.type.droneOperator', mapOf([to('en', 'Drone / UAS Operator'), to('es', 'Operador de Drones / UAS'), to('fr', 'Op\xE9rateur de Drones / UAS'), to('pt', 'Operador de Drones / UAS'), to('zh', '\u65E0\u4EBA\u673A\u64CD\u4F5C\u5458')])), to('activityCatalog.type.gliderPilot', mapOf([to('en', 'Glider & Sailplane Pilot'), to('es', 'Piloto de Planeador'), to('fr', 'Pilote de Planeur'), to('pt', 'Piloto de Planador'), to('zh', '\u6ED1\u7FD4\u673A\u98DE\u884C\u5458')])), to('activityCatalog.type.hotAirBalloonPilot', mapOf([to('en', 'Hot Air Balloon Pilot'), to('es', 'Piloto de Globo Aerost\xE1tico'), to('fr', 'Pilote de Montgolfi\xE8re'), to('pt', 'Piloto de Bal\xE3o de Ar Quente'), to('zh', '\u70ED\u6C14\u7403\u98DE\u884C\u5458')])), to('activityCatalog.type.flightSimulatorOperator', mapOf([to('en', 'Flight Simulator Operator'), to('es', 'Operador de Simulador de Vuelo'), to('fr', 'Op\xE9rateur de Simulateur de Vol'), to('pt', 'Operador de Simulador de Voo'), to('zh', '\u98DE\u884C\u6A21\u62DF\u5668\u64CD\u4F5C\u5458')])), to('activityCatalog.type.astronaut', mapOf([to('en', 'Astronaut / Analog Astronaut'), to('es', 'Astronauta / Astronauta An\xE1logo'), to('fr', 'Astronaute / Astronaute Analogique'), to('pt', 'Astronauta / Astronauta An\xE1logo'), to('zh', '\u5B87\u822A\u5458\uFF0F\u6A21\u62DF\u5B87\u822A\u5458')])), to('activityCatalog.type.aerobaticPilot', mapOf([to('en', 'Aerobatic & Airshow Pilot'), to('es', 'Piloto Acrob\xE1tico y de Exhibiciones A\xE9reas'), to('fr', 'Pilote Voltige et Meetings A\xE9riens'), to('pt', 'Piloto Acrob\xE1tico e de Shows A\xE9reos'), to('zh', '\u7279\u6280\u4E0E\u822A\u5C55\u98DE\u884C\u5458')])), to('activityCatalog.type.parachuteRigger', mapOf([to('en', 'Parachute Rigger'), to('es', 'Plegador de Paraca\xEDdas'), to('fr', 'Plieur de Parachutes'), to('pt', 'Dobrador de Paraquedas'), to('zh', '\u4F1E\u5177\u88C5\u914D\u5458')])), to('activityCatalog.type.skydiver', mapOf([to('en', 'Skydiver'), to('es', 'Paracaidista'), to('fr', 'Parachutiste'), to('pt', 'Paraquedista'), to('zh', '\u8DF3\u4F1E\u8FD0\u52A8\u5458')])), to('activityCatalog.type.paraglider', mapOf([to('en', 'Paraglider'), to('es', 'Parapentista'), to('fr', 'Parapentiste'), to('pt', 'Parapentista'), to('zh', '\u6ED1\u7FD4\u4F1E\u8FD0\u52A8\u5458')])), to('activityCatalog.type.hangGlider', mapOf([to('en', 'Hang Glider'), to('es', 'Piloto de Ala Delta'), to('fr', 'Pilote de Deltaplane'), to('pt', 'Piloto de Asa Delta'), to('zh', '\u60AC\u6302\u5F0F\u6ED1\u7FD4\u673A\u98DE\u884C\u5458')])), to('activityCatalog.type.baseJumper', mapOf([to('en', 'BASE Jumper'), to('es', 'Saltador BASE'), to('fr', 'Sauteur BASE'), to('pt', 'Saltador BASE'), to('zh', 'BASE\u8DF3\u4F1E\u8FD0\u52A8\u5458')])), to('activityCatalog.type.paramotorPilot', mapOf([to('en', 'Paramotor (PPG) Pilot'), to('es', 'Piloto de Paramotor (PPG)'), to('fr', 'Pilote de Paramoteur (PPG)'), to('pt', 'Piloto de Paramotor (PPG)'), to('zh', '\u52A8\u529B\u4F1E\uFF08PPG\uFF09\u98DE\u884C\u5458')])), to('activityCatalog.type.speedwingFlyer', mapOf([to('en', 'Speedwing / Proximity Flyer'), to('es', 'Volador de Speedwing / Vuelo de Proximidad'), to('fr', 'Pilote de Speedwing / Vol de Proximit\xE9'), to('pt', 'Piloto de Speedwing / Voo de Proximidade'), to('zh', '\u901F\u964D\u7FFC\uFF0F\u8FD1\u5730\u98DE\u884C\u5458')])), to('activityCatalog.type.wingsuitPilot', mapOf([to('en', 'Wingsuit Pilot'), to('es', 'Piloto de Traje Alar'), to('fr', 'Pilote en Wingsuit'), to('pt', 'Piloto de Wingsuit'), to('zh', '\u7FFC\u88C5\u98DE\u884C\u5458')])), to('activityCatalog.type.indoorSkydivingCoach', mapOf([to('en', 'Indoor Skydiving Coach'), to('es', 'Entrenador de Paracaidismo Indoor'), to('fr', 'Coach de Chute Libre Indoor'), to('pt', 'Instrutor de Paraquedismo Indoor'), to('zh', '\u5BA4\u5185\u8DF3\u4F1E\u6559\u7EC3')])), to('activityCatalog.type.recreationalScubaDiver', mapOf([to('en', 'Recreational Scuba Diver'), to('es', 'Buceador Recreativo'), to('fr', 'Plongeur Loisir'), to('pt', 'Mergulhador Recreativo'), to('zh', '\u4F11\u95F2\u6F5C\u6C34\u5458')])), to('activityCatalog.type.technicalDiver', mapOf([to('en', 'Technical & Deep Diver'), to('es', 'Buceador T\xE9cnico y de Profundidad'), to('fr', 'Plongeur Technique et Profond'), to('pt', 'Mergulhador T\xE9cnico e de Profundidade'), to('zh', '\u6280\u672F\u4E0E\u6DF1\u6F5C\u6F5C\u6C34\u5458')])), to('activityCatalog.type.commercialDiver', mapOf([to('en', 'Commercial & Saturation Diver'), to('es', 'Buceador Comercial y de Saturaci\xF3n'), to('fr', 'Plongeur Commercial et de Saturation'), to('pt', 'Mergulhador Comercial e de Satura\xE7\xE3o'), to('zh', '\u5546\u4E1A\u4E0E\u9971\u548C\u6F5C\u6C34\u5458')])), to('activityCatalog.type.scientificResearchDiver', mapOf([to('en', 'Scientific Research Diver'), to('es', 'Buceador de Investigaci\xF3n Cient\xEDfica'), to('fr', 'Plongeur de Recherche Scientifique'), to('pt', 'Mergulhador de Pesquisa Cient\xEDfica'), to('zh', '\u79D1\u7814\u6F5C\u6C34\u5458')])), to('activityCatalog.type.freediver', mapOf([to('en', 'Freediver'), to('es', 'Apne\xEDsta'), to('fr', 'Apn\xE9iste'), to('pt', 'Apne\xEDsta'), to('zh', '\u81EA\u7531\u6F5C\u6C34\u5458')])), to('activityCatalog.type.publicSafetyDiver', mapOf([to('en', 'Public Safety Diver'), to('es', 'Buceador de Seguridad P\xFAblica'), to('fr', 'Plongeur de S\xE9curit\xE9 Publique'), to('pt', 'Mergulhador de Seguran\xE7a P\xFAblica'), to('zh', '\u516C\u5171\u5B89\u5168\u6F5C\u6C34\u5458')])), to('activityCatalog.type.spearfishingDiver', mapOf([to('en', 'Spearfishing Diver'), to('es', 'Buceador de Pesca Submarina'), to('fr', 'Plongeur Chasse Sous-Marine'), to('pt', 'Mergulhador de Pesca Submarina'), to('zh', '\u6F5C\u6C34\u5C04\u9C7C\u5458')])), to('activityCatalog.type.underwaterPhotographer', mapOf([to('en', 'Underwater Photographer'), to('es', 'Fot\xF3grafo Submarino'), to('fr', 'Photographe Sous-Marin'), to('pt', 'Fot\xF3grafo Subaqu\xE1tico'), to('zh', '\u6C34\u4E0B\u6444\u5F71\u5E08')])), to('activityCatalog.type.merchantMarine', mapOf([to('en', 'Merchant Marine / Commercial Crew'), to('es', 'Marina Mercante / Tripulaci\xF3n Comercial'), to('fr', 'Marine Marchande / \xC9quipage Commercial'), to('pt', 'Marinha Mercante / Tripula\xE7\xE3o Comercial'), to('zh', '\u5546\u8239\u6D77\u5458\uFF0F\u5546\u4E1A\u8239\u5458')])), to('activityCatalog.type.sailingCaptain', mapOf([to('en', 'Sailing & Yachting Captain'), to('es', 'Capit\xE1n de Vela y Yates'), to('fr', 'Capitaine de Voile et Yachting'), to('pt', 'Capit\xE3o de Vela e Iates'), to('zh', '\u5E06\u8239\u4E0E\u6E38\u8247\u8239\u957F')])), to('activityCatalog.type.whitewaterGuide', mapOf([to('en', 'Professional Whitewater Guide'), to('es', 'Gu\xEDa Profesional de Aguas Bravas'), to('fr', "Guide Professionnel d'Eaux Vives"), to('pt', 'Guia Profissional de Corredeiras'), to('zh', '\u4E13\u4E1A\u6FC0\u6D41\u5411\u5BFC')])), to('activityCatalog.type.lifeguard', mapOf([to('en', 'Lifeguard / Open-Water Rescue'), to('es', 'Socorrista / Rescate en Aguas Abiertas'), to('fr', 'Ma\xEEtre-Nageur / Sauvetage en Eau Libre'), to('pt', 'Salva-Vidas / Resgate em \xC1guas Abertas'), to('zh', '\u6551\u751F\u5458\uFF0F\u516C\u5F00\u6C34\u57DF\u6551\u63F4')])), to('activityCatalog.type.rowingAthlete', mapOf([to('en', 'Rowing & Sculling Athlete'), to('es', 'Atleta de Remo'), to('fr', "Athl\xE8te d'Aviron"), to('pt', 'Atleta de Remo'), to('zh', '\u8D5B\u8247\u8FD0\u52A8\u5458')])), to('activityCatalog.type.surfer', mapOf([to('en', 'Surfer / Stand-Up Paddleboarder'), to('es', 'Surfista / Remero de Paddle Surf'), to('fr', 'Surfeur / Pagayeur SUP'), to('pt', 'Surfista / Praticante de Stand-Up Paddle'), to('zh', '\u51B2\u6D6A\u8005\uFF0F\u6868\u677F\u8FD0\u52A8\u5458')])), to('activityCatalog.type.kitesurfer', mapOf([to('en', 'Kitesurfer & Windsurfer'), to('es', 'Kitesurfista y Windsurfista'), to('fr', 'Kitesurfeur et V\xE9liplanchiste'), to('pt', 'Praticante de Kitesurf e Windsurf'), to('zh', '\u98CE\u7B5D\u51B2\u6D6A\u4E0E\u5E06\u677F\u8FD0\u52A8\u5458')])), to('activityCatalog.type.alpineMountaineer', mapOf([to('en', 'Alpine Mountaineer'), to('es', 'Monta\xF1ista Alpino'), to('fr', 'Alpiniste'), to('pt', 'Montanhista Alpino'), to('zh', '\u9AD8\u5C71\u767B\u5C71\u8005')])), to('activityCatalog.type.rockClimber', mapOf([to('en', 'Rock Climber'), to('es', 'Escalador en Roca'), to('fr', 'Grimpeur en Falaise'), to('pt', 'Escalador de Rocha'), to('zh', '\u6500\u5CA9\u8005')])), to('activityCatalog.type.iceClimber', mapOf([to('en', 'Ice Climber'), to('es', 'Escalador en Hielo'), to('fr', 'Grimpeur en Glace'), to('pt', 'Escalador de Gelo'), to('zh', '\u6500\u51B0\u8005')])), to('activityCatalog.type.spelunker', mapOf([to('en', 'Spelunker (Cave Explorer)'), to('es', 'Espele\xF3logo (Explorador de Cuevas)'), to('fr', 'Sp\xE9l\xE9ologue (Explorateur de Grottes)'), to('pt', 'Espele\xF3logo (Explorador de Cavernas)'), to('zh', '\u6D1E\u7A74\u63A2\u9669\u8005')])), to('activityCatalog.type.thruHiker', mapOf([to('en', 'Backcountry & Thru-Hiker'), to('es', 'Excursionista de Backcountry y Larga Distancia'), to('fr', 'Randonneur Hors-Piste et Longue Distance'), to('pt', 'Caminhante de Backcountry e Longa Dist\xE2ncia'), to('zh', '\u8352\u91CE\u4E0E\u957F\u9014\u5F92\u6B65\u8005')])), to('activityCatalog.type.canyoneer', mapOf([to('en', 'Canyoneer'), to('es', 'Practicante de Barranquismo'), to('fr', 'Pratiquant de Canyoning'), to('pt', 'Praticante de Canyoning'), to('zh', '\u6EAF\u6EAA\uFF0F\u5CE1\u8C37\u63A2\u9669\u8005')])), to('activityCatalog.type.backcountrySkier', mapOf([to('en', 'Backcountry & Splitboard Skier'), to('es', 'Esquiador de Backcountry y Splitboard'), to('fr', 'Skieur Hors-Piste et Splitboard'), to('pt', 'Esquiador de Backcountry e Splitboard'), to('zh', '\u8D8A\u91CE\u4E0Esplit board\u6ED1\u96EA\u8005')])), to('activityCatalog.type.cdlTruckDriver', mapOf([to('en', 'Commercial Truck Driver (CDL)'), to('es', 'Conductor de Cami\xF3n Comercial (CDL)'), to('fr', 'Chauffeur Poids Lourd (CDL)'), to('pt', 'Motorista de Caminh\xE3o Comercial (CDL)'), to('zh', '\u5546\u4E1A\u5361\u8F66\u53F8\u673A\uFF08CDL\uFF09')])), to('activityCatalog.type.transitOperator', mapOf([to('en', 'Bus, Transit & Passenger Operator'), to('es', 'Operador de Autob\xFAs y Transporte de Pasajeros'), to('fr', 'Conducteur de Bus et Transport en Commun'), to('pt', 'Operador de \xD4nibus e Transporte de Passageiros'), to('zh', '\u516C\u4EA4\u4E0E\u5BA2\u8FD0\u64CD\u4F5C\u5458')])), to('activityCatalog.type.craneOperator', mapOf([to('en', 'Tower Crane & Rigging Operator'), to('es', 'Operador de Gr\xFAa Torre y Aparejos'), to('fr', 'Grutier et Op\xE9rateur de Levage'), to('pt', 'Operador de Guindaste Torre e Cordas'), to('zh', '\u5854\u540A\u4E0E\u7D22\u5177\u64CD\u4F5C\u5458')])), to('activityCatalog.type.forkliftOperator', mapOf([to('en', 'Forklift & Warehouse Operator'), to('es', 'Operador de Montacargas y Almac\xE9n'), to('fr', "Cariste et Op\xE9rateur d'Entrep\xF4t"), to('pt', 'Operador de Empilhadeira e Armaz\xE9m'), to('zh', '\u53C9\u8F66\u4E0E\u4ED3\u5E93\u64CD\u4F5C\u5458')])), to('activityCatalog.type.railwayConductor', mapOf([to('en', 'Railway Conductor / Engineer'), to('es', 'Conductor / Maquinista de Ferrocarril'), to('fr', 'Conducteur / M\xE9canicien de Train'), to('pt', 'Condutor / Maquinista Ferrovi\xE1rio'), to('zh', '\u94C1\u8DEF\u5217\u8F66\u957F\uFF0F\u53F8\u673A')])), to('activityCatalog.type.heavyEquipmentOperator', mapOf([to('en', 'Heavy Equipment Operator'), to('es', 'Operador de Equipo Pesado'), to('fr', "Op\xE9rateur d'Engins Lourds"), to('pt', 'Operador de Equipamento Pesado'), to('zh', '\u91CD\u578B\u8BBE\u5907\u64CD\u4F5C\u5458')])), to('activityCatalog.type.labResearcher', mapOf([to('en', 'Laboratory Researcher / Chemist'), to('es', 'Investigador de Laboratorio / Qu\xEDmico'), to('fr', 'Chercheur de Laboratoire / Chimiste'), to('pt', 'Pesquisador de Laborat\xF3rio / Qu\xEDmico'), to('zh', '\u5B9E\u9A8C\u5BA4\u7814\u7A76\u5458\uFF0F\u5316\u5B66\u5BB6')])), to('activityCatalog.type.hamRadioOperator', mapOf([to('en', 'Amateur (Ham) Radio Operator'), to('es', 'Radioaficionado'), to('fr', 'Radioamateur'), to('pt', 'Radioamador'), to('zh', '\u4E1A\u4F59\u65E0\u7EBF\u7535\u7231\u597D\u8005')])), to('activityCatalog.type.environmentalFieldCrew', mapOf([to('en', 'Environmental Field Sampling Crew'), to('es', 'Equipo de Muestreo Ambiental de Campo'), to('fr', "\xC9quipe d'\xC9chantillonnage Environnemental de Terrain"), to('pt', 'Equipe de Amostragem Ambiental de Campo'), to('zh', '\u73AF\u5883\u5B9E\u5730\u91C7\u6837\u961F')])), to('activityCatalog.type.softwareQaEngineer', mapOf([to('en', 'Software QA Engineer / Red-Team'), to('es', 'Ingeniero de QA de Software / Red Team'), to('fr', 'Ing\xE9nieur QA Logiciel / Red Team'), to('pt', 'Engenheiro de QA de Software / Red Team'), to('zh', '\u8F6F\u4EF6\u6D4B\u8BD5\u5DE5\u7A0B\u5E08\uFF0F\u7EA2\u961F')])), to('activityCatalog.type.soundEngineer', mapOf([to('en', 'Sound & Recording Engineer'), to('es', 'Ingeniero de Sonido y Grabaci\xF3n'), to('fr', "Ing\xE9nieur du Son et de l'Enregistrement"), to('pt', 'Engenheiro de Som e Grava\xE7\xE3o'), to('zh', '\u97F3\u54CD\u4E0E\u5F55\u97F3\u5DE5\u7A0B\u5E08')])), to('activityCatalog.type.landSurveyor', mapOf([to('en', 'Land & Geodetic Surveyor'), to('es', 'Top\xF3grafo Terrestre y Geod\xE9sico'), to('fr', 'G\xE9om\xE8tre Terrestre et G\xE9od\xE9sien'), to('pt', 'Agrimensor Terrestre e Geod\xE9sico'), to('zh', '\u571F\u5730\u4E0E\u5927\u5730\u6D4B\u91CF\u5458')])), to('activityCatalog.type.powerlifter', mapOf([to('en', 'Powerlifter & Weightlifter'), to('es', 'Powerlifter y Levantador de Pesas'), to('fr', 'Powerlifter et Halt\xE9rophile'), to('pt', 'Powerlifter e Levantador de Peso'), to('zh', '\u529B\u91CF\u4E3E\u91CD\u4E0E\u4E3E\u91CD\u8FD0\u52A8\u5458')])), to('activityCatalog.type.trailRunner', mapOf([to('en', 'Marathon, Ultra & Trail Runner'), to('es', 'Corredor de Marat\xF3n, Ultra y Trail'), to('fr', 'Coureur de Marathon, Ultra et Trail'), to('pt', 'Corredor de Maratona, Ultra e Trail'), to('zh', '\u9A6C\u62C9\u677E\u3001\u8D85\u9A6C\u4E0E\u8D8A\u91CE\u8DD1\u8005')])), to('activityCatalog.type.triathlete', mapOf([to('en', 'Triathlete (Ironman/Multisport)'), to('es', 'Triatleta (Ironman/Multideporte)'), to('fr', 'Triathl\xE8te (Ironman/Multisport)'), to('pt', 'Triatleta (Ironman/Multiesporte)'), to('zh', '\u94C1\u4EBA\u4E09\u9879\u8FD0\u52A8\u5458\uFF08Ironman\uFF0F\u591A\u9879\u8FD0\u52A8\uFF09')])), to('activityCatalog.type.physicalTherapyPatient', mapOf([to('en', 'Physical Therapy & Rehab Patient'), to('es', 'Paciente de Fisioterapia y Rehabilitaci\xF3n'), to('fr', 'Patient en Kin\xE9sith\xE9rapie et R\xE9adaptation'), to('pt', 'Paciente de Fisioterapia e Reabilita\xE7\xE3o'), to('zh', '\u7269\u7406\u6CBB\u7597\u4E0E\u5EB7\u590D\u60A3\u8005')])), to('activityCatalog.type.trackAndFieldThrower', mapOf([to('en', 'Track & Field Thrower'), to('es', 'Lanzador de Atletismo'), to('fr', "Lanceur d'Athl\xE9tisme"), to('pt', 'Arremessador de Atletismo'), to('zh', '\u7530\u5F84\u6295\u63B7\u8FD0\u52A8\u5458')])), to('activityCatalog.type.competitiveCyclist', mapOf([to('en', 'Competitive Cyclist'), to('es', 'Ciclista Competitivo'), to('fr', 'Cycliste de Comp\xE9tition'), to('pt', 'Ciclista Competitivo'), to('zh', '\u7ADE\u6280\u81EA\u884C\u8F66\u8FD0\u52A8\u5458')])), to('activityCatalog.type.competitiveSwimmer', mapOf([to('en', 'Competitive Swimmer'), to('es', 'Nadador Competitivo'), to('fr', 'Nageur de Comp\xE9tition'), to('pt', 'Nadador Competitivo'), to('zh', '\u7ADE\u6280\u6E38\u6CF3\u8FD0\u52A8\u5458')])), to('activityCatalog.type.equestrian', mapOf([to('en', 'Equestrian & Horse Trainer'), to('es', 'Jinete y Entrenador de Caballos'), to('fr', 'Cavalier et Dresseur de Chevaux'), to('pt', 'Cavaleiro e Treinador de Cavalos'), to('zh', '\u9A6C\u672F\u9A91\u624B\u4E0E\u8BAD\u9A6C\u5E08')])), to('activityCatalog.type.workingDogHandler', mapOf([to('en', 'Working Dog Handler (K9/SAR)'), to('es', 'Manejador de Perros de Trabajo (K9/SAR)'), to('fr', 'Ma\xEEtre-Chien de Travail (K9/SAR)'), to('pt', 'Condutor de C\xE3es de Trabalho (K9/SAR)'), to('zh', '\u5DE5\u4F5C\u72AC\u8BAD\u5BFC\u5458\uFF08K9\uFF0F\u641C\u6551\uFF09')])), to('activityCatalog.type.falconer', mapOf([to('en', 'Falconer'), to('es', 'Cetrero'), to('fr', 'Fauconnier'), to('pt', 'Falcoeiro'), to('zh', '\u730E\u9E70\u8BAD\u7EC3\u5E08')])), to('activityCatalog.type.beekeeper', mapOf([to('en', 'Beekeeper (Apiary Manager)'), to('es', 'Apicultor (Gestor de Colmenar)'), to('fr', 'Apiculteur (Gestionnaire de Rucher)'), to('pt', 'Apicultor (Gestor de Api\xE1rio)'), to('zh', '\u517B\u8702\u4EBA\uFF08\u8702\u573A\u7BA1\u7406\u5458\uFF09')])), to('activityCatalog.type.livestockHandler', mapOf([to('en', 'Livestock & Ranch Handler'), to('es', 'Manejador de Ganado y Rancho'), to('fr', '\xC9leveur et Gardien de Ranch'), to('pt', 'Manejador de Gado e Fazenda'), to('zh', '\u7272\u755C\u4E0E\u7267\u573A\u7BA1\u7406\u5458')])), to('activityCatalog.type.tattooApprentice', mapOf([to('en', 'Tattoo & Body Piercing Apprentice'), to('es', 'Aprendiz de Tatuaje y Piercing'), to('fr', 'Apprenti Tatoueur et Perceur'), to('pt', 'Aprendiz de Tatuagem e Piercing'), to('zh', '\u7EB9\u8EAB\u4E0E\u7A7F\u5B54\u5B66\u5F92')])), to('activityCatalog.type.tradeApprentice', mapOf([to('en', 'Electrician/Plumbing/HVAC Apprentice'), to('es', 'Aprendiz de Electricista/Plomer\xEDa/HVAC'), to('fr', 'Apprenti \xC9lectricien/Plombier/CVC'), to('pt', 'Aprendiz de Eletricista/Encanador/HVAC'), to('zh', '\u7535\u5DE5\uFF0F\u7BA1\u9053\uFF0F\u6696\u901A\u5B66\u5F92')])), to('activityCatalog.type.scubaLifeSupportTechnician', mapOf([to('en', 'Scuba Life-Support Repair Technician'), to('es', 'T\xE9cnico de Reparaci\xF3n de Soporte Vital de Buceo'), to('fr', 'Technicien de R\xE9paration des Syst\xE8mes de Survie de Plong\xE9e'), to('pt', 'T\xE9cnico de Reparo de Suporte de Vida de Mergulho'), to('zh', '\u6F5C\u6C34\u751F\u547D\u652F\u6301\u7CFB\u7EDF\u7EF4\u4FEE\u6280\u5E08')])), to('activityCatalog.type.weldingApprentice', mapOf([to('en', 'Welding Apprentice'), to('es', 'Aprendiz de Soldadura'), to('fr', 'Apprenti Soudeur'), to('pt', 'Aprendiz de Solda'), to('zh', '\u710A\u63A5\u5B66\u5F92')])), to('activityCatalog.type.culinaryApprentice', mapOf([to('en', 'Culinary Apprentice'), to('es', 'Aprendiz de Cocina'), to('fr', 'Apprenti Cuisinier'), to('pt', 'Aprendiz de Culin\xE1ria'), to('zh', '\u70F9\u996A\u5B66\u5F92')])), to('activityCatalog.category.aviation', mapOf([to('en', 'Aviation, Aerospace & Spaceflight'), to('es', 'Aviaci\xF3n, Aeroespacial y Vuelo Espacial'), to('fr', 'Aviation, A\xE9rospatiale et Vol Spatial'), to('pt', 'Avia\xE7\xE3o, Aeroespacial e Voo Espacial'), to('zh', '\u822A\u7A7A\u3001\u822A\u5929\u4E0E\u592A\u7A7A\u98DE\u884C')])), to('activityCatalog.category.nonEngineAirSports', mapOf([to('en', 'Non-Engine Air Sports & Freeflight'), to('es', 'Deportes A\xE9reos sin Motor y Vuelo Libre'), to('fr', 'Sports A\xE9riens sans Moteur et Vol Libre'), to('pt', 'Esportes A\xE9reos sem Motor e Voo Livre'), to('zh', '\u65E0\u52A8\u529B\u822A\u7A7A\u8FD0\u52A8\u4E0E\u81EA\u7531\u98DE\u884C')])), to('activityCatalog.category.underwaterSports', mapOf([to('en', 'Underwater Sports, Sciences & Exploration'), to('es', 'Deportes, Ciencias y Exploraci\xF3n Subacu\xE1tica'), to('fr', 'Sports, Sciences et Exploration Sous-Marine'), to('pt', 'Esportes, Ci\xEAncias e Explora\xE7\xE3o Subaqu\xE1tica'), to('zh', '\u6C34\u4E0B\u8FD0\u52A8\u3001\u79D1\u5B66\u4E0E\u63A2\u7D22')])), to('activityCatalog.category.maritime', mapOf([to('en', 'Maritime, Vessel & Water Sports'), to('es', 'Mar\xEDtimo, Embarcaciones y Deportes Acu\xE1ticos'), to('fr', 'Maritime, Navigation et Sports Nautiques'), to('pt', 'Mar\xEDtimo, Embarca\xE7\xF5es e Esportes Aqu\xE1ticos'), to('zh', '\u6D77\u4E8B\u3001\u8239\u8247\u4E0E\u6C34\u4E0A\u8FD0\u52A8')])), to('activityCatalog.category.mountainClimbing', mapOf([to('en', 'Mountain, Climbing & Wilderness Exploration'), to('es', 'Monta\xF1a, Escalada y Exploraci\xF3n Silvestre'), to('fr', 'Montagne, Escalade et Exploration Sauvage'), to('pt', 'Montanha, Escalada e Explora\xE7\xE3o Selvagem'), to('zh', '\u767B\u5C71\u3001\u6500\u5CA9\u4E0E\u91CE\u5916\u63A2\u7D22')])), to('activityCatalog.category.heavyMachinery', mapOf([to('en', 'Heavy Machinery, Transport & Logistics'), to('es', 'Maquinaria Pesada, Transporte y Log\xEDstica'), to('fr', 'Engins Lourds, Transport et Logistique'), to('pt', 'Maquin\xE1rio Pesado, Transporte e Log\xEDstica'), to('zh', '\u91CD\u578B\u673A\u68B0\u3001\u8FD0\u8F93\u4E0E\u7269\u6D41')])), to('activityCatalog.category.technicalTrades', mapOf([to('en', 'Technical Trades, Radio & Lab Sciences'), to('es', 'Oficios T\xE9cnicos, Radio y Ciencias de Laboratorio'), to('fr', 'M\xE9tiers Techniques, Radio et Sciences de Laboratoire'), to('pt', 'Of\xEDcios T\xE9cnicos, R\xE1dio e Ci\xEAncias de Laborat\xF3rio'), to('zh', '\u6280\u672F\u884C\u4E1A\u3001\u65E0\u7EBF\u7535\u4E0E\u5B9E\u9A8C\u5BA4\u79D1\u5B66')])), to('activityCatalog.category.highPerformanceAthletics', mapOf([to('en', 'High-Performance Athletics & Sports Medicine'), to('es', 'Atletismo de Alto Rendimiento y Medicina Deportiva'), to('fr', 'Athl\xE9tisme de Haute Performance et M\xE9decine du Sport'), to('pt', 'Atletismo de Alto Desempenho e Medicina Esportiva'), to('zh', '\u9AD8\u6C34\u5E73\u7ADE\u6280\u8FD0\u52A8\u4E0E\u8FD0\u52A8\u533B\u5B66')])), to('activityCatalog.category.animalHandling', mapOf([to('en', 'Animal Handling, Training & Ecosystems'), to('es', 'Manejo de Animales, Adiestramiento y Ecosistemas'), to('fr', 'Soin des Animaux, Dressage et \xC9cosyst\xE8mes'), to('pt', 'Manejo de Animais, Adestramento e Ecossistemas'), to('zh', '\u52A8\u7269\u62A4\u7406\u3001\u8BAD\u7EC3\u4E0E\u751F\u6001\u7CFB\u7EDF')])), to('activityCatalog.category.vocationalApprenticeships', mapOf([to('en', 'Vocational Apprenticeships & Creative Guilds'), to('es', 'Aprendizajes Vocacionales y Gremios Creativos'), to('fr', 'Apprentissages Professionnels et Guildes Cr\xE9atives'), to('pt', 'Aprendizados Vocacionais e Guildas Criativas'), to('zh', '\u804C\u4E1A\u5B66\u5F92\u4E0E\u521B\u610F\u884C\u4F1A')])), to('activityCatalog.recreational.walker', mapOf([to('en', 'Walker'), to('es', 'Caminante'), to('fr', 'Marcheur'), to('pt', 'Caminhante'), to('zh', '\u6B65\u884C\u8005')])), to('activityCatalog.recreational.runner', mapOf([to('en', 'Runner'), to('es', 'Corredor'), to('fr', 'Coureur'), to('pt', 'Corredor'), to('zh', '\u8DD1\u6B65\u8005')])), to('activityCatalog.recreational.rafter', mapOf([to('en', 'Rafter'), to('es', 'Practicante de Rafting'), to('fr', 'Rafteur'), to('pt', 'Praticante de Rafting'), to('zh', '\u6F02\u6D41\u8005')])), to('activityCatalog.recreational.golfer', mapOf([to('en', 'Golfer'), to('es', 'Golfista'), to('fr', 'Golfeur'), to('pt', 'Golfista'), to('zh', '\u9AD8\u5C14\u592B\u7403\u624B')])), to('activityCatalog.recreational.dartsPlayer', mapOf([to('en', 'Darts Player'), to('es', 'Jugador de Dardos'), to('fr', 'Joueur de Fl\xE9chettes'), to('pt', 'Jogador de Dardos'), to('zh', '\u98DE\u9556\u9009\u624B')])), to('activityCatalog.recreational.baseballPlayer', mapOf([to('en', 'Baseball Player'), to('es', 'Jugador de B\xE9isbol'), to('fr', 'Joueur de Baseball'), to('pt', 'Jogador de Beisebol'), to('zh', '\u68D2\u7403\u8FD0\u52A8\u5458')])), to('activityCatalog.recreational.billiardsPlayer', mapOf([to('en', 'Billiards Player'), to('es', 'Jugador de Billar'), to('fr', 'Joueur de Billard'), to('pt', 'Jogador de Bilhar'), to('zh', '\u53F0\u7403\u9009\u624B')])), to('activityCatalog.recreational.alpineSkier', mapOf([to('en', 'Alpine Skier'), to('es', 'Esquiador Alpino'), to('fr', 'Skieur Alpin'), to('pt', 'Esquiador Alpino'), to('zh', '\u9AD8\u5C71\u6ED1\u96EA\u8005')])), to('activityCatalog.recreational.downhillMountainBiker', mapOf([to('en', 'Downhill Mountain Biker'), to('es', 'Ciclista de Descenso'), to('fr', 'V\xE9t\xE9tiste de Descente'), to('pt', 'Ciclista de Downhill'), to('zh', '\u5C71\u5730\u901F\u964D\u81EA\u884C\u8F66\u624B')])), to('activityCatalog.recreational.yogaPractitioner', mapOf([to('en', 'Yoga Practitioner'), to('es', 'Practicante de Yoga'), to('fr', 'Pratiquant de Yoga'), to('pt', 'Praticante de Yoga'), to('zh', '\u745C\u4F3D\u7EC3\u4E60\u8005')])), to('activityCatalog.recreational.cardPlayer', mapOf([to('en', 'Card Player'), to('es', 'Jugador de Cartas'), to('fr', 'Joueur de Cartes'), to('pt', 'Jogador de Cartas'), to('zh', '\u7EB8\u724C\u73A9\u5BB6')])), to('activityCatalog.recreational.raceCarDriver', mapOf([to('en', 'Race Car Driver'), to('es', 'Piloto de Carreras'), to('fr', 'Pilote de Course'), to('pt', 'Piloto de Corrida'), to('zh', '\u8D5B\u8F66\u624B')])), to('activityCatalog.recreational.motorcycleRider', mapOf([to('en', 'Motorcycle Rider'), to('es', 'Motociclista'), to('fr', 'Motard'), to('pt', 'Motociclista'), to('zh', '\u6469\u6258\u8F66\u9A91\u624B')])), to('confirmDialog.areYouSure', mapOf([to('en', 'Are you sure?'), to('es', '\xBFEst\xE1s seguro?'), to('fr', '\xCAtes-vous s\xFBr ?'), to('pt', 'Tem certeza?'), to('zh', '\u60A8\u786E\u5B9A\u5417\uFF1F')])), to('confirmDialog.cancelButton', mapOf([to('en', 'Cancel'), to('es', 'Cancelar'), to('fr', 'Annuler'), to('pt', 'Cancelar'), to('zh', '\u53D6\u6D88')])), to('confirmDialog.deleteButton', mapOf([to('en', 'Delete'), to('es', 'Eliminar'), to('fr', 'Supprimer'), to('pt', 'Excluir'), to('zh', '\u5220\u9664')])), to('pagination.previous', mapOf([to('en', 'Previous'), to('es', 'Anterior'), to('fr', 'Pr\xE9c\xE9dent'), to('pt', 'Anterior'), to('zh', '\u4E0A\u4E00\u9875')])), to('pagination.next', mapOf([to('en', 'Next'), to('es', 'Siguiente'), to('fr', 'Suivant'), to('pt', 'Pr\xF3xima'), to('zh', '\u4E0B\u4E00\u9875')])), to('pagination.pagePrefix', mapOf([to('en', 'Page '), to('es', 'P\xE1gina '), to('fr', 'Page '), to('pt', 'P\xE1gina '), to('zh', '\u7B2C ')])), to('pagination.pageMiddle', mapOf([to('en', ' of '), to('es', ' de '), to('fr', ' sur '), to('pt', ' de '), to('zh', ' \u9875\uFF0C\u5171 ')])), to('pagination.pageSuffix', mapOf([to('en', ''), to('es', ''), to('fr', ''), to('pt', ''), to('zh', ' \u9875')])), to('adminCompanies.activityCentersTitle', mapOf([to('en', 'Activity Centers'), to('es', 'Centros de Actividad'), to('fr', "Centres d'Activit\xE9"), to('pt', 'Centros de Atividade'), to('zh', '\u6D3B\u52A8\u4E2D\u5FC3')])), to('adminCompanies.certificationIssuersTitle', mapOf([to('en', 'Certification Issuers'), to('es', 'Entidades Certificadoras'), to('fr', 'Organismes de Certification'), to('pt', 'Entidades Certificadoras'), to('zh', '\u8BA4\u8BC1\u673A\u6784')])), to('adminCompanies.marketersTitle', mapOf([to('en', 'Marketers'), to('es', 'Comercializadoras'), to('fr', 'Agences Marketing'), to('pt', 'Comercializadoras'), to('zh', '\u8425\u9500\u5546')])), to('adminCompanies.searchPlaceholder', mapOf([to('en', 'Search name, fiscal ID, or email\u2026'), to('es', 'Buscar por nombre, ID fiscal o correo\u2026'), to('fr', 'Rechercher par nom, identifiant fiscal ou e-mail\u2026'), to('pt', 'Buscar por nome, ID fiscal ou e-mail\u2026'), to('zh', '\u6309\u540D\u79F0\u3001\u7A0E\u53F7\u6216\u90AE\u7BB1\u641C\u7D22\u2026')])), to('adminCompanies.allCountriesPlaceholder', mapOf([to('en', 'All countries'), to('es', 'Todos los pa\xEDses'), to('fr', 'Tous les pays'), to('pt', 'Todos os pa\xEDses'), to('zh', '\u6240\u6709\u56FD\u5BB6')])), to('adminCompanies.showInactiveLabel', mapOf([to('en', 'Show inactive'), to('es', 'Mostrar inactivas'), to('fr', 'Afficher les inactifs'), to('pt', 'Mostrar inativas'), to('zh', '\u663E\u793A\u672A\u6FC0\u6D3B')])), to('adminCompanies.searchButton', mapOf([to('en', 'Search'), to('es', 'Buscar'), to('fr', 'Rechercher'), to('pt', 'Buscar'), to('zh', '\u641C\u7D22')])), to('adminCompanies.nameColumn', mapOf([to('en', 'Name'), to('es', 'Nombre'), to('fr', 'Nom'), to('pt', 'Nome'), to('zh', '\u540D\u79F0')])), to('adminCompanies.fiscalIdColumn', mapOf([to('en', 'Fiscal ID'), to('es', 'ID fiscal'), to('fr', 'Identifiant fiscal'), to('pt', 'ID fiscal'), to('zh', '\u7A0E\u53F7')])), to('adminCompanies.emailColumn', mapOf([to('en', 'Email'), to('es', 'Correo electr\xF3nico'), to('fr', 'E-mail'), to('pt', 'E-mail'), to('zh', '\u90AE\u7BB1')])), to('adminCompanies.countryColumn', mapOf([to('en', 'Country'), to('es', 'Pa\xEDs'), to('fr', 'Pays'), to('pt', 'Pa\xEDs'), to('zh', '\u56FD\u5BB6')])), to('adminCompanies.actionsColumn', mapOf([to('en', 'Actions'), to('es', 'Acciones'), to('fr', 'Actions'), to('pt', 'A\xE7\xF5es'), to('zh', '\u64CD\u4F5C')])), to('adminCompanies.editButton', mapOf([to('en', 'Edit'), to('es', 'Editar'), to('fr', 'Modifier'), to('pt', 'Editar'), to('zh', '\u7F16\u8F91')])), to('adminCompanies.deleteButton', mapOf([to('en', 'Delete'), to('es', 'Eliminar'), to('fr', 'Supprimer'), to('pt', 'Excluir'), to('zh', '\u5220\u9664')])), to('adminCompanies.noCompaniesFound', mapOf([to('en', 'No companies found.'), to('es', 'No se encontraron empresas.'), to('fr', 'Aucune entreprise trouv\xE9e.'), to('pt', 'Nenhuma empresa encontrada.'), to('zh', '\u672A\u627E\u5230\u4EFB\u4F55\u516C\u53F8\u3002')])), to('adminCompanies.loadErrorPrefix', mapOf([to('en', 'Could not load companies: '), to('es', 'No se pudieron cargar las empresas: '), to('fr', 'Impossible de charger les entreprises : '), to('pt', 'N\xE3o foi poss\xEDvel carregar as empresas: '), to('zh', '\u65E0\u6CD5\u52A0\u8F7D\u516C\u53F8\uFF1A')])), to('adminCompanies.deleteConfirmPrefix', mapOf([to('en', 'Delete '), to('es', 'Eliminar '), to('fr', 'Supprimer '), to('pt', 'Excluir '), to('zh', '\u5220\u9664')])), to('adminCompanies.deleteConfirmSuffix', mapOf([to('en', '? It will be deactivated but can be reactivated later.'), to('es', '? Se desactivar\xE1, pero puede reactivarse m\xE1s tarde.'), to('fr', ' ? Elle sera d\xE9sactiv\xE9e mais pourra \xEAtre r\xE9activ\xE9e plus tard.'), to('pt', '? Ser\xE1 desativada, mas pode ser reativada mais tarde.'), to('zh', '\uFF1F\u5B83\u5C06\u88AB\u505C\u7528\uFF0C\u4F46\u4E4B\u540E\u53EF\u4EE5\u91CD\u65B0\u6FC0\u6D3B\u3002')])), to('adminCompanies.removeErrorPrefix', mapOf([to('en', 'Could not remove: '), to('es', 'No se pudo eliminar: '), to('fr', 'Impossible de supprimer : '), to('pt', 'N\xE3o foi poss\xEDvel remover: '), to('zh', '\u65E0\u6CD5\u79FB\u9664\uFF1A')])), to('adminCompanies.editModalDefaultHeading', mapOf([to('en', 'Edit company'), to('es', 'Editar empresa'), to('fr', "Modifier l'entreprise"), to('pt', 'Editar empresa'), to('zh', '\u7F16\u8F91\u516C\u53F8')])), to('adminCompanies.editModalHeadingPrefix', mapOf([to('en', 'Edit '), to('es', 'Editar '), to('fr', 'Modifier '), to('pt', 'Editar '), to('zh', '\u7F16\u8F91')])), to('adminCompanies.nameLabel', mapOf([to('en', 'Name'), to('es', 'Nombre'), to('fr', 'Nom'), to('pt', 'Nome'), to('zh', '\u540D\u79F0')])), to('adminCompanies.fiscalIdLabel', mapOf([to('en', 'Fiscal ID'), to('es', 'ID fiscal'), to('fr', 'Identifiant fiscal'), to('pt', 'ID fiscal'), to('zh', '\u7A0E\u53F7')])), to('adminCompanies.emailLabel', mapOf([to('en', 'Email'), to('es', 'Correo electr\xF3nico'), to('fr', 'E-mail'), to('pt', 'E-mail'), to('zh', '\u90AE\u7BB1')])), to('adminCompanies.phoneLabel', mapOf([to('en', 'Phone'), to('es', 'Tel\xE9fono'), to('fr', 'T\xE9l\xE9phone'), to('pt', 'Telefone'), to('zh', '\u7535\u8BDD')])), to('adminCompanies.addressLabel', mapOf([to('en', 'Address'), to('es', 'Direcci\xF3n'), to('fr', 'Adresse'), to('pt', 'Endere\xE7o'), to('zh', '\u5730\u5740')])), to('adminCompanies.websiteLabel', mapOf([to('en', 'Website'), to('es', 'Sitio web'), to('fr', 'Site web'), to('pt', 'Site'), to('zh', '\u7F51\u7AD9')])), to('adminCompanies.countryLabel', mapOf([to('en', 'Country'), to('es', 'Pa\xEDs'), to('fr', 'Pays'), to('pt', 'Pa\xEDs'), to('zh', '\u56FD\u5BB6')])), to('adminCompanies.activeLabel', mapOf([to('en', 'Active'), to('es', 'Activa'), to('fr', 'Actif'), to('pt', 'Ativa'), to('zh', '\u5DF2\u542F\u7528')])), to('adminCompanies.saveButton', mapOf([to('en', 'Save'), to('es', 'Guardar'), to('fr', 'Enregistrer'), to('pt', 'Salvar'), to('zh', '\u4FDD\u5B58')])), to('adminCompanies.cancelButton', mapOf([to('en', 'Cancel'), to('es', 'Cancelar'), to('fr', 'Annuler'), to('pt', 'Cancelar'), to('zh', '\u53D6\u6D88')])), to('adminCompanies.updatedStatus', mapOf([to('en', 'Updated.'), to('es', 'Actualizada.'), to('fr', 'Mis \xE0 jour.'), to('pt', 'Atualizada.'), to('zh', '\u5DF2\u66F4\u65B0\u3002')])), to('adminCompanies.inactiveBadge', mapOf([to('en', 'Inactive'), to('es', 'Inactiva'), to('fr', 'Inactif'), to('pt', 'Inativa'), to('zh', '\u672A\u6FC0\u6D3B')])), to('adminCompanies.loadingLabel', mapOf([to('en', 'Loading\u2026'), to('es', 'Cargando\u2026'), to('fr', 'Chargement\u2026'), to('pt', 'Carregando\u2026'), to('zh', '\u52A0\u8F7D\u4E2D\u2026')])), to('adminCompanies.unknownCountry', mapOf([to('en', 'Unknown'), to('es', 'Desconocido'), to('fr', 'Inconnu'), to('pt', 'Desconhecido'), to('zh', '\u672A\u77E5')])), to('legal.terms.title', mapOf([to('en', 'Terms and Conditions'), to('es', 'T\xE9rminos y Condiciones'), to('fr', "Conditions G\xE9n\xE9rales d'Utilisation"), to('pt', 'Termos e Condi\xE7\xF5es'), to('zh', '\u670D\u52A1\u6761\u6B3E')])), to('legal.terms.updated', mapOf([to('en', 'Last updated: July 18, 2026'), to('es', '\xDAltima actualizaci\xF3n: 18 de julio de 2026'), to('fr', 'Derni\xE8re mise \xE0 jour : 18 juillet 2026'), to('pt', '\xDAltima atualiza\xE7\xE3o: 18 de julho de 2026'), to('zh', '\u6700\u540E\u66F4\u65B0\u65E5\u671F\uFF1A2026\u5E747\u670818\u65E5')])), to('legal.terms.intro', mapOf([to('en', 'These Terms and Conditions ("Terms") govern your access to and use of Bitakore, the sports and activity logging platform operated by Universaliun S.A.S ("Bitakore", "we", "us", or "our"). Please read them carefully.'), to('es', 'Estos T\xE9rminos y Condiciones ("T\xE9rminos") rigen tu acceso y uso de Bitakore, la plataforma de registro de actividades deportivas operada por Universaliun S.A.S ("Bitakore", "nosotros" o "nuestro"). L\xE9elos con atenci\xF3n.'), to('fr', "Les pr\xE9sentes Conditions G\xE9n\xE9rales d'Utilisation (les \xAB Conditions \xBB) r\xE9gissent votre acc\xE8s \xE0 Bitakore et votre utilisation de cette plateforme de suivi d'activit\xE9s sportives exploit\xE9e par Universaliun S.A.S (\xAB Bitakore \xBB, \xAB nous \xBB). Veuillez les lire attentivement."), to('pt', 'Estes Termos e Condi\xE7\xF5es ("Termos") regem o seu acesso e uso do Bitakore, a plataforma de registro de atividades esportivas operada pela Universaliun S.A.S ("Bitakore", "n\xF3s" ou "nosso"). Leia-os com aten\xE7\xE3o.'), to('zh', '\u672C\u670D\u52A1\u6761\u6B3E\uFF08\u4EE5\u4E0B\u7B80\u79F0"\u6761\u6B3E"\uFF09\u89C4\u8303\u60A8\u8BBF\u95EE\u548C\u4F7F\u7528 Bitakore\uFF08\u7531 Universaliun S.A.S \u8FD0\u8425\u7684\u8FD0\u52A8\u4E0E\u8BAD\u7EC3\u8BB0\u5F55\u5E73\u53F0\uFF0C\u4EE5\u4E0B\u7B80\u79F0"Bitakore"\u3001"\u6211\u4EEC"\uFF09\u7684\u884C\u4E3A\u3002\u8BF7\u4ED4\u7EC6\u9605\u8BFB\u3002')])), to('legal.terms.s1.h', mapOf([to('en', '1. Acceptance of Terms'), to('es', '1. Aceptaci\xF3n de los T\xE9rminos'), to('fr', '1. Acceptation des Conditions'), to('pt', '1. Aceita\xE7\xE3o dos Termos'), to('zh', '1. \u6761\u6B3E\u7684\u63A5\u53D7')])), to('legal.terms.s1.b', mapOf([to('en', 'By registering for an account, logging in, or otherwise using Bitakore, you agree to be bound by these Terms and by our Privacy Policy. If you do not agree, you must not use the service.'), to('es', 'Al registrarte, iniciar sesi\xF3n o utilizar Bitakore de cualquier otra forma, aceptas quedar vinculado por estos T\xE9rminos y por nuestra Pol\xEDtica de Privacidad. Si no est\xE1s de acuerdo, no debes utilizar el servicio.'), to('fr', "En cr\xE9ant un compte, en vous connectant ou en utilisant Bitakore de toute autre mani\xE8re, vous acceptez d'\xEAtre li\xE9 par les pr\xE9sentes Conditions et par notre Politique de Confidentialit\xE9. Si vous n'\xEAtes pas d'accord, vous ne devez pas utiliser le service."), to('pt', 'Ao se cadastrar, fazer login ou usar o Bitakore de qualquer outra forma, voc\xEA concorda em ficar vinculado a estes Termos e \xE0 nossa Pol\xEDtica de Privacidade. Se voc\xEA n\xE3o concordar, n\xE3o deve usar o servi\xE7o.'), to('zh', '\u901A\u8FC7\u6CE8\u518C\u8D26\u6237\u3001\u767B\u5F55\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u4F7F\u7528 Bitakore\uFF0C\u5373\u8868\u793A\u60A8\u540C\u610F\u53D7\u672C\u6761\u6B3E\u53CA\u6211\u4EEC\u7684\u9690\u79C1\u653F\u7B56\u7EA6\u675F\u3002\u5982\u679C\u60A8\u4E0D\u540C\u610F\uFF0C\u8BF7\u52FF\u4F7F\u7528\u672C\u670D\u52A1\u3002')])), to('legal.terms.s2.h', mapOf([to('en', '2. Eligibility and Accounts'), to('es', '2. Elegibilidad y Cuentas'), to('fr', '2. \xC9ligibilit\xE9 et Comptes'), to('pt', '2. Elegibilidade e Contas'), to('zh', '2. \u8D44\u683C\u4E0E\u8D26\u6237')])), to('legal.terms.s2.b', mapOf([to('en', 'You must be able to form a binding contract to use Bitakore, and you are responsible for keeping your login credentials confidential and for all activity that happens under your account. Organizations (activity centers, certification issuers, and marketers) are responsible for the individuals they authorize to act on their behalf.\n\nYou agree to provide accurate information when you register and to keep it up to date.'), to('es', 'Debes tener capacidad legal para celebrar un contrato vinculante para usar Bitakore, y eres responsable de mantener la confidencialidad de tus credenciales de acceso y de toda la actividad que ocurra bajo tu cuenta. Las organizaciones (centros de actividad, entidades certificadoras y comercializadoras) son responsables de las personas que autorizan a actuar en su nombre.\n\nTe comprometes a proporcionar informaci\xF3n precisa al registrarte y a mantenerla actualizada.'), to('fr', "Vous devez avoir la capacit\xE9 de conclure un contrat contraignant pour utiliser Bitakore, et vous \xEAtes responsable de la confidentialit\xE9 de vos identifiants de connexion ainsi que de toute activit\xE9 effectu\xE9e sous votre compte. Les organisations (centres d'activit\xE9, organismes de certification et agences marketing) sont responsables des personnes qu'elles autorisent \xE0 agir en leur nom.\n\nVous vous engagez \xE0 fournir des informations exactes lors de votre inscription et \xE0 les maintenir \xE0 jour."), to('pt', 'Voc\xEA deve ter capacidade legal para celebrar um contrato vinculante para usar o Bitakore, e \xE9 respons\xE1vel por manter suas credenciais de acesso em sigilo e por toda atividade realizada em sua conta. Organiza\xE7\xF5es (centros de atividade, entidades certificadoras e comercializadoras) s\xE3o respons\xE1veis pelas pessoas que autorizam a agir em seu nome.\n\nVoc\xEA concorda em fornecer informa\xE7\xF5es precisas ao se cadastrar e em mant\xEA-las atualizadas.'), to('zh', '\u60A8\u5FC5\u987B\u5177\u5907\u8BA2\u7ACB\u5177\u6709\u7EA6\u675F\u529B\u5408\u540C\u7684\u80FD\u529B\u624D\u80FD\u4F7F\u7528 Bitakore\uFF0C\u5E76\u5BF9\u59A5\u5584\u4FDD\u7BA1\u60A8\u7684\u767B\u5F55\u51ED\u8BC1\u4EE5\u53CA\u8D26\u6237\u4E0B\u53D1\u751F\u7684\u6240\u6709\u6D3B\u52A8\u8D1F\u8D23\u3002\u7EC4\u7EC7\uFF08\u6D3B\u52A8\u4E2D\u5FC3\u3001\u8BA4\u8BC1\u53D1\u653E\u673A\u6784\u548C\u8425\u9500\u673A\u6784\uFF09\u5BF9\u5176\u6388\u6743\u4EE3\u8868\u5176\u884C\u4E8B\u7684\u4EBA\u5458\u8D1F\u8D23\u3002\n\n\u60A8\u540C\u610F\u5728\u6CE8\u518C\u65F6\u63D0\u4F9B\u51C6\u786E\u7684\u4FE1\u606F\uFF0C\u5E76\u53CA\u65F6\u66F4\u65B0\u3002')])), to('legal.terms.s3.h', mapOf([to('en', '3. Description of the Service'), to('es', '3. Descripci\xF3n del Servicio'), to('fr', '3. Description du Service'), to('pt', '3. Descri\xE7\xE3o do Servi\xE7o'), to('zh', '3. \u670D\u52A1\u8BF4\u660E')])), to('legal.terms.s3.b', mapOf([to('en', 'Bitakore lets practitioners log sports and training activities, request and display certifications, and connect third-party fitness devices and services (such as Strava or Garmin) to import activity data. Activity centers, certification issuers, and marketers can manage their own organizational profiles and the practitioners associated with them.\n\nWe may add, change, or remove features at any time, and we do not guarantee that any feature will remain available indefinitely.'), to('es', 'Bitakore permite a los practicantes registrar actividades deportivas y de entrenamiento, solicitar y mostrar certificaciones, y conectar dispositivos o servicios de terceros (como Strava o Garmin) para importar datos de actividad. Los centros de actividad, entidades certificadoras y comercializadoras pueden gestionar sus propios perfiles organizacionales y a los practicantes asociados con ellos.\n\nPodemos agregar, modificar o eliminar funciones en cualquier momento, y no garantizamos que alguna funci\xF3n permanezca disponible de forma indefinida.'), to('fr', "Bitakore permet aux praticiens d'enregistrer leurs activit\xE9s sportives et d'entra\xEEnement, de demander et d'afficher des certifications, et de connecter des appareils ou services tiers (comme Strava ou Garmin) pour importer des donn\xE9es d'activit\xE9. Les centres d'activit\xE9, organismes de certification et agences marketing peuvent g\xE9rer leurs propres profils organisationnels et les praticiens qui y sont associ\xE9s.\n\nNous pouvons ajouter, modifier ou supprimer des fonctionnalit\xE9s \xE0 tout moment, et ne garantissons pas qu'une fonctionnalit\xE9 restera disponible ind\xE9finiment."), to('pt', 'O Bitakore permite que praticantes registrem atividades esportivas e de treinamento, solicitem e exibam certifica\xE7\xF5es, e conectem dispositivos ou servi\xE7os de terceiros (como Strava ou Garmin) para importar dados de atividade. Centros de atividade, entidades certificadoras e comercializadoras podem gerenciar seus pr\xF3prios perfis organizacionais e os praticantes associados a eles.\n\nPodemos adicionar, alterar ou remover funcionalidades a qualquer momento, e n\xE3o garantimos que qualquer funcionalidade permanecer\xE1 dispon\xEDvel indefinidamente.'), to('zh', 'Bitakore \u4F7F\u4ECE\u4E1A\u8005\u80FD\u591F\u8BB0\u5F55\u4F53\u80B2\u4E0E\u8BAD\u7EC3\u6D3B\u52A8\u3001\u7533\u8BF7\u5E76\u5C55\u793A\u8BA4\u8BC1\uFF0C\u5E76\u8FDE\u63A5\u7B2C\u4E09\u65B9\u8BBE\u5907\u6216\u670D\u52A1\uFF08\u5982 Strava \u6216 Garmin\uFF09\u4EE5\u5BFC\u5165\u6D3B\u52A8\u6570\u636E\u3002\u6D3B\u52A8\u4E2D\u5FC3\u3001\u8BA4\u8BC1\u53D1\u653E\u673A\u6784\u548C\u8425\u9500\u673A\u6784\u53EF\u4EE5\u7BA1\u7406\u81EA\u5DF1\u7684\u7EC4\u7EC7\u8D44\u6599\u4EE5\u53CA\u4E0E\u5176\u5173\u8054\u7684\u4ECE\u4E1A\u8005\u3002\n\n\u6211\u4EEC\u53EF\u80FD\u968F\u65F6\u65B0\u589E\u3001\u66F4\u6539\u6216\u79FB\u9664\u529F\u80FD\uFF0C\u4E14\u4E0D\u4FDD\u8BC1\u4EFB\u4F55\u529F\u80FD\u4F1A\u4E00\u76F4\u53EF\u7528\u3002')])), to('legal.terms.s4.h', mapOf([to('en', '4. Your Content and the License You Grant Us'), to('es', '4. Tu Contenido y la Licencia que Nos Otorgas'), to('fr', '4. Votre Contenu et la Licence que Vous Nous Accordez'), to('pt', '4. Seu Conte\xFAdo e a Licen\xE7a que Voc\xEA Nos Concede'), to('zh', '4. \u60A8\u7684\u5185\u5BB9\u4EE5\u53CA\u60A8\u6388\u4E88\u6211\u4EEC\u7684\u8BB8\u53EF')])), to('legal.terms.s4.b', mapOf([to('en', '"Your Content" means any photo, image, text, or other material you upload or submit to Bitakore, including profile and avatar pictures, activity photos, company logos, and certification images.\n\nYou keep full ownership of Your Content. By uploading it, you grant Bitakore a non-exclusive, royalty-free, worldwide license to host, store, and display Your Content on the platform, solely for the purpose of operating and providing the service to you and to the other users you choose to share it with (such as your activity center or certification issuer).\n\nThis license does not give us the right to sell Your Content, transfer it, or hand it over to any third party outside of what is described in our Privacy Policy. We do not license, sublicense, or otherwise make Your Content available for any other company\'s or person\'s independent use. This license ends when you delete Your Content or close your account, except for copies kept briefly in backups or as required by law.'), to('es', '"Tu Contenido" se refiere a cualquier foto, imagen, texto u otro material que subas o env\xEDes a Bitakore, incluidas fotos de perfil o avatar, fotos de actividades, logotipos de empresa e im\xE1genes de certificaciones.\n\nConservas la propiedad total de Tu Contenido. Al subirlo, otorgas a Bitakore una licencia no exclusiva, libre de regal\xEDas y de alcance mundial para alojar, almacenar y mostrar Tu Contenido en la plataforma, \xFAnicamente con el fin de operar y prestarte el servicio a ti y a los dem\xE1s usuarios con quienes decidas compartirlo (como tu centro de actividad o entidad certificadora).\n\nEsta licencia no nos da derecho a vender Tu Contenido, transferirlo ni entregarlo a ning\xFAn tercero fuera de lo descrito en nuestra Pol\xEDtica de Privacidad. No sublicenciamos ni ponemos Tu Contenido a disposici\xF3n para el uso independiente de ninguna otra empresa o persona. Esta licencia termina cuando eliminas Tu Contenido o cierras tu cuenta, salvo por copias conservadas brevemente en respaldos o cuando la ley lo exija.'), to('fr', "\xAB Votre Contenu \xBB d\xE9signe toute photo, image, texte ou autre \xE9l\xE9ment que vous t\xE9l\xE9versez ou soumettez \xE0 Bitakore, y compris les photos de profil ou d'avatar, les photos d'activit\xE9s, les logos d'entreprise et les images de certification.\n\nVous conservez l'enti\xE8re propri\xE9t\xE9 de Votre Contenu. En le t\xE9l\xE9versant, vous accordez \xE0 Bitakore une licence non exclusive, gratuite et mondiale pour h\xE9berger, stocker et afficher Votre Contenu sur la plateforme, uniquement dans le but d'exploiter et de vous fournir le service, ainsi qu'aux autres utilisateurs avec qui vous choisissez de le partager (comme votre centre d'activit\xE9 ou votre organisme de certification).\n\nCette licence ne nous donne pas le droit de vendre Votre Contenu, de le c\xE9der ou de le transmettre \xE0 un tiers en dehors de ce qui est d\xE9crit dans notre Politique de Confidentialit\xE9. Nous ne sous-licencions pas et ne mettons pas Votre Contenu \xE0 disposition pour l'usage ind\xE9pendant d'une autre entreprise ou personne. Cette licence prend fin lorsque vous supprimez Votre Contenu ou fermez votre compte, \xE0 l'exception des copies conserv\xE9es bri\xE8vement dans nos sauvegardes ou lorsque la loi l'exige."), to('pt', '"Seu Conte\xFAdo" significa qualquer foto, imagem, texto ou outro material que voc\xEA envie ao Bitakore, incluindo fotos de perfil ou avatar, fotos de atividades, logotipos de empresas e imagens de certifica\xE7\xF5es.\n\nVoc\xEA mant\xE9m total propriedade sobre o Seu Conte\xFAdo. Ao envi\xE1-lo, voc\xEA concede ao Bitakore uma licen\xE7a n\xE3o exclusiva, gratuita e mundial para hospedar, armazenar e exibir o Seu Conte\xFAdo na plataforma, exclusivamente com o prop\xF3sito de operar e fornecer o servi\xE7o a voc\xEA e aos demais usu\xE1rios com quem voc\xEA escolher compartilh\xE1-lo (como seu centro de atividade ou entidade certificadora).\n\nEsta licen\xE7a n\xE3o nos d\xE1 o direito de vender o Seu Conte\xFAdo, transferi-lo ou repass\xE1-lo a qualquer terceiro fora do que est\xE1 descrito em nossa Pol\xEDtica de Privacidade. N\xE3o sublicenciamos nem disponibilizamos o Seu Conte\xFAdo para uso independente de nenhuma outra empresa ou pessoa. Esta licen\xE7a termina quando voc\xEA exclui o Seu Conte\xFAdo ou encerra sua conta, exceto por c\xF3pias mantidas brevemente em backups ou conforme exigido por lei.'), to('zh', '\u300C\u60A8\u7684\u5185\u5BB9\u300D\u6307\u60A8\u4E0A\u4F20\u6216\u63D0\u4EA4\u7ED9 Bitakore \u7684\u4EFB\u4F55\u7167\u7247\u3001\u56FE\u7247\u3001\u6587\u5B57\u6216\u5176\u4ED6\u6750\u6599\uFF0C\u5305\u62EC\u4E2A\u4EBA\u8D44\u6599\u7167\u7247\u6216\u5934\u50CF\u3001\u6D3B\u52A8\u7167\u7247\u3001\u516C\u53F8\u5FBD\u6807\u4EE5\u53CA\u8BA4\u8BC1\u56FE\u7247\u3002\n\n\u60A8\u5BF9\u60A8\u7684\u5185\u5BB9\u4FDD\u7559\u5168\u90E8\u6240\u6709\u6743\u3002\u4E0A\u4F20\u5373\u8868\u793A\u60A8\u6388\u4E88 Bitakore \u4E00\u9879\u975E\u72EC\u5360\u3001\u514D\u7248\u7A0E\u3001\u8986\u76D6\u5168\u7403\u7684\u8BB8\u53EF\uFF0C\u5141\u8BB8\u6211\u4EEC\u6258\u7BA1\u3001\u5B58\u50A8\u5E76\u5728\u5E73\u53F0\u4E0A\u5C55\u793A\u60A8\u7684\u5185\u5BB9\uFF0C\u76EE\u7684\u4EC5\u9650\u4E8E\u4E3A\u60A8\u4EE5\u53CA\u60A8\u9009\u62E9\u5171\u4EAB\u7ED9\u7684\u5176\u4ED6\u7528\u6237\uFF08\u4F8B\u5982\u60A8\u6240\u5728\u7684\u6D3B\u52A8\u4E2D\u5FC3\u6216\u8BA4\u8BC1\u53D1\u653E\u673A\u6784\uFF09\u8FD0\u8425\u548C\u63D0\u4F9B\u670D\u52A1\u3002\n\n\u8BE5\u8BB8\u53EF\u5E76\u4E0D\u8D4B\u4E88\u6211\u4EEC\u51FA\u552E\u3001\u8F6C\u8BA9\u60A8\u7684\u5185\u5BB9\uFF0C\u6216\u5C06\u5176\u4EA4\u7ED9\u6211\u4EEC\u9690\u79C1\u653F\u7B56\u6240\u8FF0\u8303\u56F4\u4E4B\u5916\u7684\u4EFB\u4F55\u7B2C\u4E09\u65B9\u7684\u6743\u5229\u3002\u6211\u4EEC\u4E0D\u4F1A\u8F6C\u6388\u8BB8\u53EF\uFF0C\u4E5F\u4E0D\u4F1A\u8BA9\u4EFB\u4F55\u5176\u4ED6\u516C\u53F8\u6216\u4E2A\u4EBA\u72EC\u7ACB\u4F7F\u7528\u60A8\u7684\u5185\u5BB9\u3002\u8BE5\u8BB8\u53EF\u5728\u60A8\u5220\u9664\u5185\u5BB9\u6216\u5173\u95ED\u8D26\u6237\u65F6\u7EC8\u6B62\uFF0C\u4F46\u5907\u4EFD\u4E2D\u77ED\u671F\u4FDD\u7559\u7684\u526F\u672C\u6216\u6CD5\u5F8B\u8981\u6C42\u4FDD\u7559\u7684\u9664\u5916\u3002')])), to('legal.terms.s5.h', mapOf([to('en', '5. Your Responsibility for What You Upload'), to('es', '5. Tu Responsabilidad sobre lo que Subes'), to('fr', '5. Votre Responsabilit\xE9 concernant ce que Vous T\xE9l\xE9versez'), to('pt', '5. Sua Responsabilidade pelo que Voc\xEA Envia'), to('zh', '5. \u60A8\u5BF9\u4E0A\u4F20\u5185\u5BB9\u7684\u8D23\u4EFB')])), to('legal.terms.s5.b', mapOf([to('en', "You are solely responsible for Your Content. By uploading it, you confirm that you own it or have all the necessary rights and permissions to upload it, and that it does not infringe any third party's intellectual property, privacy, or other rights.\n\nYou agree to indemnify and hold Bitakore harmless from any claim, damage, or expense arising from Your Content or from your breach of these Terms. We may, but are not obligated to, review, remove, or disable access to any content that we believe violates these Terms or applicable law."), to('es', 'Eres el \xFAnico responsable de Tu Contenido. Al subirlo, confirmas que eres su propietario o que cuentas con todos los derechos y permisos necesarios para hacerlo, y que no infringe los derechos de propiedad intelectual, privacidad u otros derechos de terceros.\n\nAceptas indemnizar y mantener indemne a Bitakore frente a cualquier reclamo, da\xF1o o gasto derivado de Tu Contenido o del incumplimiento de estos T\xE9rminos. Podemos, sin estar obligados a ello, revisar, eliminar o restringir el acceso a cualquier contenido que consideremos que infringe estos T\xE9rminos o la ley aplicable.'), to('fr', "Vous \xEAtes seul responsable de Votre Contenu. En le t\xE9l\xE9versant, vous confirmez en \xEAtre propri\xE9taire ou disposer de tous les droits et autorisations n\xE9cessaires, et qu'il ne porte pas atteinte aux droits de propri\xE9t\xE9 intellectuelle, de vie priv\xE9e ou autres droits d'un tiers.\n\nVous acceptez d'indemniser Bitakore et de la tenir indemne de toute r\xE9clamation, dommage ou d\xE9pense d\xE9coulant de Votre Contenu ou de votre violation des pr\xE9sentes Conditions. Nous pouvons, sans y \xEAtre oblig\xE9s, examiner, supprimer ou restreindre l'acc\xE8s \xE0 tout contenu que nous estimons contraire aux pr\xE9sentes Conditions ou \xE0 la loi applicable."), to('pt', 'Voc\xEA \xE9 o \xFAnico respons\xE1vel pelo Seu Conte\xFAdo. Ao envi\xE1-lo, voc\xEA confirma que \xE9 seu propriet\xE1rio ou possui todos os direitos e permiss\xF5es necess\xE1rios para faz\xEA-lo, e que ele n\xE3o infringe direitos de propriedade intelectual, privacidade ou outros direitos de terceiros.\n\nVoc\xEA concorda em indenizar e isentar o Bitakore de qualquer reclama\xE7\xE3o, dano ou despesa decorrente do Seu Conte\xFAdo ou da sua viola\xE7\xE3o destes Termos. Podemos, sem sermos obrigados, revisar, remover ou restringir o acesso a qualquer conte\xFAdo que consideremos violar estes Termos ou a lei aplic\xE1vel.'), to('zh', '\u60A8\u5BF9\u60A8\u7684\u5185\u5BB9\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002\u4E0A\u4F20\u5373\u8868\u793A\u60A8\u786E\u8BA4\u81EA\u5DF1\u62E5\u6709\u8BE5\u5185\u5BB9\uFF0C\u6216\u5DF2\u83B7\u5F97\u4E0A\u4F20\u6240\u9700\u7684\u5168\u90E8\u6743\u5229\u548C\u8BB8\u53EF\uFF0C\u4E14\u8BE5\u5185\u5BB9\u4E0D\u4FB5\u72AF\u4EFB\u4F55\u7B2C\u4E09\u65B9\u7684\u77E5\u8BC6\u4EA7\u6743\u3001\u9690\u79C1\u6743\u6216\u5176\u4ED6\u6743\u5229\u3002\n\n\u60A8\u540C\u610F\u5C31\u56E0\u60A8\u7684\u5185\u5BB9\u6216\u60A8\u8FDD\u53CD\u672C\u6761\u6B3E\u800C\u4EA7\u751F\u7684\u4EFB\u4F55\u7D22\u8D54\u3001\u635F\u5BB3\u6216\u8D39\u7528\uFF0C\u5BF9 Bitakore \u8FDB\u884C\u8D54\u507F\u5E76\u4F7F\u5176\u514D\u53D7\u635F\u5BB3\u3002\u6211\u4EEC\u53EF\u4EE5\uFF08\u4F46\u6CA1\u6709\u4E49\u52A1\uFF09\u5BA1\u67E5\u3001\u79FB\u9664\u6216\u9650\u5236\u8BBF\u95EE\u6211\u4EEC\u5408\u7406\u8BA4\u4E3A\u8FDD\u53CD\u672C\u6761\u6B3E\u6216\u9002\u7528\u6CD5\u5F8B\u7684\u4EFB\u4F55\u5185\u5BB9\u3002')])), to('legal.terms.s6.h', mapOf([to('en', '6. Prohibited Content and Conduct'), to('es', '6. Contenido y Conducta Prohibidos'), to('fr', '6. Contenu et Comportements Interdits'), to('pt', '6. Conte\xFAdo e Conduta Proibidos'), to('zh', '6. \u7981\u6B62\u7684\u5185\u5BB9\u4E0E\u884C\u4E3A')])), to('legal.terms.s6.b', mapOf([to('en', "You may not upload or share content that is illegal, defamatory, obscene, discriminatory, or that infringes someone else's rights. You may not use Bitakore to impersonate another person, harvest other users' data, interfere with the security or normal operation of the service, or upload malicious code.\n\nWe may suspend or remove content, or restrict your access to the service, if we reasonably believe you have violated this section."), to('es', 'No puedes subir o compartir contenido ilegal, difamatorio, obsceno, discriminatorio o que infrinja los derechos de terceros. No puedes usar Bitakore para suplantar a otra persona, recopilar datos de otros usuarios, interferir con la seguridad o el funcionamiento normal del servicio, ni subir c\xF3digo malicioso.\n\nPodemos suspender o eliminar contenido, o restringir tu acceso al servicio, si tenemos motivos razonables para creer que has infringido esta secci\xF3n.'), to('fr', "Vous ne pouvez pas t\xE9l\xE9verser ou partager de contenu ill\xE9gal, diffamatoire, obsc\xE8ne, discriminatoire ou portant atteinte aux droits d'autrui. Vous ne pouvez pas utiliser Bitakore pour usurper l'identit\xE9 d'une autre personne, collecter les donn\xE9es d'autres utilisateurs, perturber la s\xE9curit\xE9 ou le fonctionnement normal du service, ni t\xE9l\xE9verser de code malveillant.\n\nNous pouvons suspendre ou supprimer du contenu, ou restreindre votre acc\xE8s au service, si nous estimons raisonnablement que vous avez enfreint cette section."), to('pt', 'Voc\xEA n\xE3o pode enviar ou compartilhar conte\xFAdo ilegal, difamat\xF3rio, obsceno, discriminat\xF3rio ou que infrinja direitos de terceiros. Voc\xEA n\xE3o pode usar o Bitakore para se passar por outra pessoa, coletar dados de outros usu\xE1rios, interferir na seguran\xE7a ou no funcionamento normal do servi\xE7o, nem enviar c\xF3digo malicioso.\n\nPodemos suspender ou remover conte\xFAdo, ou restringir seu acesso ao servi\xE7o, se razoavelmente acreditarmos que voc\xEA violou esta se\xE7\xE3o.'), to('zh', '\u60A8\u4E0D\u5F97\u4E0A\u4F20\u6216\u5206\u4EAB\u975E\u6CD5\u3001\u8BFD\u8C24\u6027\u3001\u6DEB\u79FD\u3001\u6B67\u89C6\u6027\u6216\u4FB5\u72AF\u4ED6\u4EBA\u6743\u5229\u7684\u5185\u5BB9\u3002\u60A8\u4E0D\u5F97\u4F7F\u7528 Bitakore \u5192\u5145\u4ED6\u4EBA\u3001\u6536\u96C6\u5176\u4ED6\u7528\u6237\u7684\u6570\u636E\u3001\u5E72\u6270\u670D\u52A1\u7684\u5B89\u5168\u6216\u6B63\u5E38\u8FD0\u884C\uFF0C\u6216\u4E0A\u4F20\u6076\u610F\u4EE3\u7801\u3002\n\n\u5982\u679C\u6211\u4EEC\u6709\u5408\u7406\u7406\u7531\u8BA4\u4E3A\u60A8\u8FDD\u53CD\u4E86\u672C\u8282\u89C4\u5B9A\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u6682\u505C\u6216\u5220\u9664\u5185\u5BB9\uFF0C\u6216\u9650\u5236\u60A8\u5BF9\u670D\u52A1\u7684\u8BBF\u95EE\u3002')])), to('legal.terms.s7.h', mapOf([to('en', '7. Third-Party Services'), to('es', '7. Servicios de Terceros'), to('fr', '7. Services Tiers'), to('pt', '7. Servi\xE7os de Terceiros'), to('zh', '7. \u7B2C\u4E09\u65B9\u670D\u52A1')])), to('legal.terms.s7.b', mapOf([to('en', 'Bitakore lets you sign in with Google and connect device-sync integrations such as Strava and Garmin. Your use of those third-party services is governed by their own terms and privacy policies, which we encourage you to review. We are not responsible for the content, policies, or practices of any third-party service.'), to('es', 'Bitakore te permite iniciar sesi\xF3n con Google y conectar integraciones de sincronizaci\xF3n de dispositivos como Strava y Garmin. El uso de esos servicios de terceros se rige por sus propios t\xE9rminos y pol\xEDticas de privacidad, que te recomendamos revisar. No somos responsables del contenido, las pol\xEDticas ni las pr\xE1cticas de ning\xFAn servicio de terceros.'), to('fr', "Bitakore vous permet de vous connecter avec Google et de connecter des int\xE9grations de synchronisation d'appareils telles que Strava et Garmin. L'utilisation de ces services tiers est r\xE9gie par leurs propres conditions et politiques de confidentialit\xE9, que nous vous encourageons \xE0 consulter. Nous ne sommes pas responsables du contenu, des politiques ou des pratiques d'un service tiers."), to('pt', 'O Bitakore permite que voc\xEA fa\xE7a login com o Google e conecte integra\xE7\xF5es de sincroniza\xE7\xE3o de dispositivos como Strava e Garmin. O uso desses servi\xE7os de terceiros \xE9 regido por seus pr\xF3prios termos e pol\xEDticas de privacidade, que recomendamos que voc\xEA revise. N\xE3o somos respons\xE1veis pelo conte\xFAdo, pol\xEDticas ou pr\xE1ticas de qualquer servi\xE7o de terceiros.'), to('zh', 'Bitakore \u5141\u8BB8\u60A8\u4F7F\u7528 Google \u767B\u5F55\uFF0C\u5E76\u8FDE\u63A5 Strava\u3001Garmin \u7B49\u8BBE\u5907\u540C\u6B65\u96C6\u6210\u670D\u52A1\u3002\u60A8\u5BF9\u8FD9\u4E9B\u7B2C\u4E09\u65B9\u670D\u52A1\u7684\u4F7F\u7528\u53D7\u5176\u81EA\u8EAB\u6761\u6B3E\u548C\u9690\u79C1\u653F\u7B56\u7EA6\u675F\uFF0C\u6211\u4EEC\u5EFA\u8BAE\u60A8\u4ED4\u7EC6\u9605\u8BFB\u3002\u6211\u4EEC\u4E0D\u5BF9\u4EFB\u4F55\u7B2C\u4E09\u65B9\u670D\u52A1\u7684\u5185\u5BB9\u3001\u653F\u7B56\u6216\u505A\u6CD5\u8D1F\u8D23\u3002')])), to('legal.terms.s8.h', mapOf([to('en', '8. Suspension and Termination'), to('es', '8. Suspensi\xF3n y Terminaci\xF3n'), to('fr', '8. Suspension et R\xE9siliation'), to('pt', '8. Suspens\xE3o e Encerramento'), to('zh', '8. \u6682\u505C\u4E0E\u7EC8\u6B62')])), to('legal.terms.s8.b', mapOf([to('en', 'You may stop using Bitakore and close your account at any time. We may suspend or terminate your access if you violate these Terms, if required by law, or if we discontinue the service, in which case we will make reasonable efforts to notify you in advance where practical.'), to('es', 'Puedes dejar de usar Bitakore y cerrar tu cuenta en cualquier momento. Podemos suspender o terminar tu acceso si infringes estos T\xE9rminos, si la ley lo exige, o si discontinuamos el servicio, en cuyo caso haremos esfuerzos razonables para notificarte con antelaci\xF3n cuando sea posible.'), to('fr', "Vous pouvez cesser d'utiliser Bitakore et fermer votre compte \xE0 tout moment. Nous pouvons suspendre ou r\xE9silier votre acc\xE8s si vous enfreignez les pr\xE9sentes Conditions, si la loi l'exige, ou si nous cessons le service, auquel cas nous ferons des efforts raisonnables pour vous en informer \xE0 l'avance lorsque cela est possible."), to('pt', 'Voc\xEA pode parar de usar o Bitakore e encerrar sua conta a qualquer momento. Podemos suspender ou encerrar seu acesso se voc\xEA violar estes Termos, se exigido por lei, ou se descontinuarmos o servi\xE7o, caso em que faremos esfor\xE7os razo\xE1veis para notific\xE1-lo com anteced\xEAncia, quando poss\xEDvel.'), to('zh', '\u60A8\u53EF\u4EE5\u968F\u65F6\u505C\u6B62\u4F7F\u7528 Bitakore \u5E76\u5173\u95ED\u60A8\u7684\u8D26\u6237\u3002\u5982\u679C\u60A8\u8FDD\u53CD\u672C\u6761\u6B3E\u3001\u6CD5\u5F8B\u53E6\u6709\u8981\u6C42\uFF0C\u6216\u6211\u4EEC\u505C\u6B62\u63D0\u4F9B\u670D\u52A1\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u6682\u505C\u6216\u7EC8\u6B62\u60A8\u7684\u8BBF\u95EE\u6743\u9650\uFF1B\u5728\u53EF\u884C\u7684\u60C5\u51B5\u4E0B\uFF0C\u6211\u4EEC\u4F1A\u5408\u7406\u5730\u63D0\u524D\u901A\u77E5\u60A8\u3002')])), to('legal.terms.s9.h', mapOf([to('en', '9. Disclaimers and Limitation of Liability'), to('es', '9. Exenciones de Responsabilidad y Limitaci\xF3n de Responsabilidad'), to('fr', '9. Avertissements et Limitation de Responsabilit\xE9'), to('pt', '9. Isen\xE7\xF5es de Responsabilidade e Limita\xE7\xE3o de Responsabilidade'), to('zh', '9. \u514D\u8D23\u58F0\u660E\u4E0E\u8D23\u4EFB\u9650\u5236')])), to('legal.terms.s9.b', mapOf([to('en', 'Bitakore is provided "as is" and "as available," without warranties of any kind, express or implied. Activity data, certifications, and information displayed by other users are provided by those users and we do not guarantee their accuracy.\n\nTo the fullest extent permitted by law, Universaliun S.A.S will not be liable for any indirect, incidental, or consequential damages arising from your use of the service.'), to('es', 'Bitakore se ofrece "tal cual" y "seg\xFAn disponibilidad", sin garant\xEDas de ning\xFAn tipo, expresas o impl\xEDcitas. Los datos de actividad, certificaciones e informaci\xF3n mostrada por otros usuarios son proporcionados por dichos usuarios y no garantizamos su exactitud.\n\nEn la m\xE1xima medida permitida por la ley, Universaliun S.A.S no ser\xE1 responsable de da\xF1os indirectos, incidentales o consecuentes derivados del uso del servicio.'), to('fr', "Bitakore est fourni \xAB tel quel \xBB et \xAB selon disponibilit\xE9 \xBB, sans garantie d'aucune sorte, expresse ou implicite. Les donn\xE9es d'activit\xE9, les certifications et les informations affich\xE9es par d'autres utilisateurs sont fournies par ces utilisateurs et nous ne garantissons pas leur exactitude.\n\nDans toute la mesure permise par la loi, Universaliun S.A.S ne sera pas responsable des dommages indirects, accessoires ou cons\xE9cutifs d\xE9coulant de votre utilisation du service."), to('pt', 'O Bitakore \xE9 fornecido "como est\xE1" e "conforme dispon\xEDvel", sem garantias de qualquer tipo, expressas ou impl\xEDcitas. Dados de atividade, certifica\xE7\xF5es e informa\xE7\xF5es exibidas por outros usu\xE1rios s\xE3o fornecidos por esses usu\xE1rios, e n\xE3o garantimos sua exatid\xE3o.\n\nNa m\xE1xima extens\xE3o permitida por lei, a Universaliun S.A.S n\xE3o ser\xE1 respons\xE1vel por danos indiretos, incidentais ou consequenciais decorrentes do uso do servi\xE7o.'), to('zh', 'Bitakore \u6309\u300C\u73B0\u72B6\u300D\u548C\u300C\u73B0\u6709\u300D\u57FA\u7840\u63D0\u4F9B\uFF0C\u4E0D\u4F5C\u4EFB\u4F55\u660E\u793A\u6216\u6697\u793A\u7684\u4FDD\u8BC1\u3002\u5176\u4ED6\u7528\u6237\u5C55\u793A\u7684\u6D3B\u52A8\u6570\u636E\u3001\u8BA4\u8BC1\u548C\u4FE1\u606F\u7531\u8BE5\u7528\u6237\u81EA\u884C\u63D0\u4F9B\uFF0C\u6211\u4EEC\u4E0D\u4FDD\u8BC1\u5176\u51C6\u786E\u6027\u3002\n\n\u5728\u6CD5\u5F8B\u5141\u8BB8\u7684\u6700\u5927\u8303\u56F4\u5185\uFF0CUniversaliun S.A.S \u5BF9\u56E0\u4F7F\u7528\u672C\u670D\u52A1\u800C\u4EA7\u751F\u7684\u4EFB\u4F55\u95F4\u63A5\u3001\u9644\u5E26\u6216\u540E\u679C\u6027\u635F\u5BB3\u6982\u4E0D\u8D1F\u8D23\u3002')])), to('legal.terms.s10.h', mapOf([to('en', '10. Changes to These Terms'), to('es', '10. Cambios a Estos T\xE9rminos'), to('fr', '10. Modifications des Pr\xE9sentes Conditions'), to('pt', '10. Altera\xE7\xF5es a Estes Termos'), to('zh', '10. \u672C\u6761\u6B3E\u7684\u53D8\u66F4')])), to('legal.terms.s10.b', mapOf([to('en', 'We may update these Terms from time to time. If we make material changes, we will post the updated Terms on this page with a new "last updated" date and, where appropriate, notify you through the service. Continued use of Bitakore after a change takes effect means you accept the revised Terms.'), to('es', 'Podemos actualizar estos T\xE9rminos peri\xF3dicamente. Si realizamos cambios importantes, publicaremos los T\xE9rminos actualizados en esta p\xE1gina con una nueva fecha de "\xFAltima actualizaci\xF3n" y, cuando corresponda, te notificaremos a trav\xE9s del servicio. El uso continuado de Bitakore despu\xE9s de que un cambio entre en vigor implica la aceptaci\xF3n de los T\xE9rminos revisados.'), to('fr', "Nous pouvons mettre \xE0 jour ces Conditions de temps \xE0 autre. En cas de changement important, nous publierons les Conditions mises \xE0 jour sur cette page avec une nouvelle date de \xAB derni\xE8re mise \xE0 jour \xBB et, le cas \xE9ch\xE9ant, vous en informerons via le service. Poursuivre l'utilisation de Bitakore apr\xE8s l'entr\xE9e en vigueur d'une modification vaut acceptation des Conditions r\xE9vis\xE9es."), to('pt', 'Podemos atualizar estes Termos periodicamente. Caso fa\xE7amos altera\xE7\xF5es significativas, publicaremos os Termos atualizados nesta p\xE1gina com uma nova data de "\xFAltima atualiza\xE7\xE3o" e, quando apropriado, notificaremos voc\xEA pelo servi\xE7o. O uso continuado do Bitakore ap\xF3s uma altera\xE7\xE3o entrar em vigor significa que voc\xEA aceita os Termos revisados.'), to('zh', '\u6211\u4EEC\u53EF\u80FD\u4F1A\u4E0D\u65F6\u66F4\u65B0\u672C\u6761\u6B3E\u3002\u5982\u6709\u91CD\u5927\u53D8\u66F4\uFF0C\u6211\u4EEC\u4F1A\u5728\u672C\u9875\u9762\u53D1\u5E03\u66F4\u65B0\u540E\u7684\u6761\u6B3E\u5E76\u6CE8\u660E\u65B0\u7684\u300C\u6700\u540E\u66F4\u65B0\u65E5\u671F\u300D\uFF0C\u5E76\u5728\u9002\u5F53\u60C5\u51B5\u4E0B\u901A\u8FC7\u670D\u52A1\u901A\u77E5\u60A8\u3002\u53D8\u66F4\u751F\u6548\u540E\u7EE7\u7EED\u4F7F\u7528 Bitakore \u5373\u8868\u793A\u60A8\u63A5\u53D7\u4FEE\u8BA2\u540E\u7684\u6761\u6B3E\u3002')])), to('legal.terms.s11.h', mapOf([to('en', '11. Governing Law'), to('es', '11. Ley Aplicable'), to('fr', '11. Droit Applicable'), to('pt', '11. Lei Aplic\xE1vel'), to('zh', '11. \u9002\u7528\u6CD5\u5F8B')])), to('legal.terms.s11.b', mapOf([to('en', 'These Terms are governed by the laws applicable in Mexico City, Mexico, without regard to its conflict-of-law principles, and any dispute arising from them will be subject to the courts of that jurisdiction, unless applicable local law gives you the right to bring a claim in your own country of residence.'), to('es', 'Estos T\xE9rminos se rigen por las leyes aplicables en la Ciudad de M\xE9xico, M\xE9xico, sin dar efecto a sus principios de conflicto de leyes, y cualquier disputa derivada de ellos estar\xE1 sujeta a los tribunales de esa jurisdicci\xF3n, salvo que la ley local aplicable te otorgue el derecho de presentar un reclamo en tu propio pa\xEDs de residencia.'), to('fr', 'Les pr\xE9sentes Conditions sont r\xE9gies par les lois applicables \xE0 Mexico, au Mexique, sans \xE9gard \xE0 leurs principes de conflits de lois, et tout litige en d\xE9coulant rel\xE8vera des tribunaux de cette juridiction, sauf si la loi locale applicable vous permet de porter une r\xE9clamation dans votre propre pays de r\xE9sidence.'), to('pt', 'Estes Termos s\xE3o regidos pelas leis aplic\xE1veis na Cidade do M\xE9xico, M\xE9xico, sem considerar seus princ\xEDpios de conflito de leis, e qualquer disputa decorrente deles estar\xE1 sujeita aos tribunais dessa jurisdi\xE7\xE3o, salvo se a lei local aplic\xE1vel lhe conceder o direito de apresentar uma reclama\xE7\xE3o em seu pr\xF3prio pa\xEDs de resid\xEAncia.'), to('zh', '\u672C\u6761\u6B3E\u53D7\u58A8\u897F\u54E5\u58A8\u897F\u54E5\u57CE\u9002\u7528\u6CD5\u5F8B\u7BA1\u8F96\uFF0C\u4E0D\u8003\u8651\u5176\u6CD5\u5F8B\u51B2\u7A81\u539F\u5219\uFF1B\u7531\u6B64\u4EA7\u751F\u7684\u4EFB\u4F55\u4E89\u8BAE\u5747\u53D7\u8BE5\u7BA1\u8F96\u533A\u6CD5\u9662\u7BA1\u8F96\uFF0C\u9664\u975E\u9002\u7528\u7684\u5F53\u5730\u6CD5\u5F8B\u8D4B\u4E88\u60A8\u5728\u60A8\u5C45\u4F4F\u56FD\u63D0\u51FA\u7D22\u8D54\u7684\u6743\u5229\u3002')])), to('legal.terms.s12.h', mapOf([to('en', '12. Contact Us'), to('es', '12. Cont\xE1ctanos'), to('fr', '12. Nous Contacter'), to('pt', '12. Fale Conosco'), to('zh', '12. \u8054\u7CFB\u6211\u4EEC')])), to('legal.terms.s12.b', mapOf([to('en', 'If you have questions about these Terms, contact us at contact@ubitakore.com.'), to('es', 'Si tienes preguntas sobre estos T\xE9rminos, cont\xE1ctanos en contact@ubitakore.com.'), to('fr', 'Pour toute question concernant les pr\xE9sentes Conditions, contactez-nous \xE0 contact@ubitakore.com.'), to('pt', 'Se voc\xEA tiver d\xFAvidas sobre estes Termos, entre em contato conosco em contact@ubitakore.com.'), to('zh', '\u5982\u679C\u60A8\u5BF9\u672C\u6761\u6B3E\u6709\u4EFB\u4F55\u7591\u95EE\uFF0C\u8BF7\u901A\u8FC7 contact@ubitakore.com \u4E0E\u6211\u4EEC\u8054\u7CFB\u3002')])), to('legal.privacy.title', mapOf([to('en', 'Privacy Policy'), to('es', 'Pol\xEDtica de Privacidad'), to('fr', 'Politique de Confidentialit\xE9'), to('pt', 'Pol\xEDtica de Privacidade'), to('zh', '\u9690\u79C1\u653F\u7B56')])), to('legal.privacy.updated', mapOf([to('en', 'Last updated: July 18, 2026'), to('es', '\xDAltima actualizaci\xF3n: 18 de julio de 2026'), to('fr', 'Derni\xE8re mise \xE0 jour : 18 juillet 2026'), to('pt', '\xDAltima atualiza\xE7\xE3o: 18 de julho de 2026'), to('zh', '\u6700\u540E\u66F4\u65B0\u65E5\u671F\uFF1A2026\u5E747\u670818\u65E5')])), to('legal.privacy.intro', mapOf([to('en', 'This Privacy Policy explains how Universaliun S.A.S ("Bitakore", "we", "us", or "our") collects, uses, and shares information when you use Bitakore.'), to('es', 'Esta Pol\xEDtica de Privacidad explica c\xF3mo Universaliun S.A.S ("Bitakore", "nosotros" o "nuestro") recopila, utiliza y comparte informaci\xF3n cuando usas Bitakore.'), to('fr', 'Cette Politique de Confidentialit\xE9 explique comment Universaliun S.A.S (\xAB Bitakore \xBB, \xAB nous \xBB) collecte, utilise et partage les informations lorsque vous utilisez Bitakore.'), to('pt', 'Esta Pol\xEDtica de Privacidade explica como a Universaliun S.A.S ("Bitakore", "n\xF3s" ou "nosso") coleta, usa e compartilha informa\xE7\xF5es quando voc\xEA usa o Bitakore.'), to('zh', '\u672C\u9690\u79C1\u653F\u7B56\u8BF4\u660E Universaliun S.A.S\uFF08\u300CBitakore\u300D\u3001\u300C\u6211\u4EEC\u300D\uFF09\u5728\u60A8\u4F7F\u7528 Bitakore \u65F6\u5982\u4F55\u6536\u96C6\u3001\u4F7F\u7528\u548C\u5171\u4EAB\u4FE1\u606F\u3002')])), to('legal.privacy.s1.h', mapOf([to('en', '1. Scope'), to('es', '1. Alcance'), to('fr', "1. Champ d'Application"), to('pt', '1. Escopo'), to('zh', '1. \u9002\u7528\u8303\u56F4')])), to('legal.privacy.s1.b', mapOf([to('en', 'This Policy applies to the Bitakore website and mobile app, and covers information we collect about practitioners, activity centers, certification issuers, and marketers who use the service.'), to('es', 'Esta Pol\xEDtica se aplica al sitio web y la aplicaci\xF3n m\xF3vil de Bitakore, y cubre la informaci\xF3n que recopilamos sobre practicantes, centros de actividad, entidades certificadoras y comercializadoras que usan el servicio.'), to('fr', "Cette Politique s'applique au site web et \xE0 l'application mobile de Bitakore, et couvre les informations que nous collectons sur les praticiens, centres d'activit\xE9, organismes de certification et agences marketing qui utilisent le service."), to('pt', 'Esta Pol\xEDtica se aplica ao site e ao aplicativo m\xF3vel do Bitakore, e cobre as informa\xE7\xF5es que coletamos sobre praticantes, centros de atividade, entidades certificadoras e comercializadoras que usam o servi\xE7o.'), to('zh', '\u672C\u653F\u7B56\u9002\u7528\u4E8E Bitakore \u7F51\u7AD9\u53CA\u79FB\u52A8\u5E94\u7528\uFF0C\u6DB5\u76D6\u6211\u4EEC\u5C31\u4F7F\u7528\u672C\u670D\u52A1\u7684\u4ECE\u4E1A\u8005\u3001\u6D3B\u52A8\u4E2D\u5FC3\u3001\u8BA4\u8BC1\u53D1\u653E\u673A\u6784\u548C\u8425\u9500\u673A\u6784\u6240\u6536\u96C6\u7684\u4FE1\u606F\u3002')])), to('legal.privacy.s2.h', mapOf([to('en', '2. Information We Collect'), to('es', '2. Informaci\xF3n que Recopilamos'), to('fr', '2. Informations que Nous Collectons'), to('pt', '2. Informa\xE7\xF5es que Coletamos'), to('zh', '2. \u6211\u4EEC\u6536\u96C6\u7684\u4FE1\u606F')])), to('legal.privacy.s2.b', mapOf([to('en', 'Account information: your name, email address, password or passkey data, and, if you sign in with Google, the basic profile information that provider shares with us.\n\nProfile and content: your avatar and any activity, certification, or company-logo photos you upload, along with the professional and organizational details you provide (such as certifications, activity centers, and fiscal information for organizations).\n\nActivity data: sports and training activities you log, GPS tracks, and related metrics, either entered directly or imported from a connected device or service such as Strava or Garmin.\n\nDevice-sync credentials: if you connect a third-party fitness account, we store the access tokens needed to sync your data, encrypted at rest.\n\nUsage data: basic technical information such as browser type and how you interact with the service, used to keep it working reliably.'), to('es', 'Informaci\xF3n de la cuenta: tu nombre, correo electr\xF3nico, contrase\xF1a o datos de passkey y, si inicias sesi\xF3n con Google, la informaci\xF3n b\xE1sica de perfil que ese proveedor comparte con nosotros.\n\nPerfil y contenido: tu avatar y las fotos de actividades, certificaciones o logotipos de empresa que subas, junto con los datos profesionales y organizacionales que proporciones (como certificaciones, centros de actividad e informaci\xF3n fiscal de organizaciones).\n\nDatos de actividad: las actividades deportivas y de entrenamiento que registras, rutas GPS y m\xE9tricas relacionadas, ya sea ingresadas directamente o importadas desde un dispositivo o servicio conectado como Strava o Garmin.\n\nCredenciales de sincronizaci\xF3n de dispositivos: si conectas una cuenta de fitness de un tercero, almacenamos los tokens de acceso necesarios para sincronizar tus datos, cifrados en reposo.\n\nDatos de uso: informaci\xF3n t\xE9cnica b\xE1sica, como el tipo de navegador y c\xF3mo interact\xFAas con el servicio, utilizada para mantenerlo funcionando de forma confiable.'), to('fr', "Informations de compte : votre nom, adresse e-mail, mot de passe ou donn\xE9es de cl\xE9 d'acc\xE8s (passkey) et, si vous vous connectez avec Google, les informations de profil de base partag\xE9es par ce fournisseur.\n\nProfil et contenu : votre avatar et les photos d'activit\xE9s, de certifications ou de logos d'entreprise que vous t\xE9l\xE9versez, ainsi que les informations professionnelles et organisationnelles que vous fournissez (comme les certifications, les centres d'activit\xE9 et les informations fiscales des organisations).\n\nDonn\xE9es d'activit\xE9 : les activit\xE9s sportives et d'entra\xEEnement que vous enregistrez, les trac\xE9s GPS et les m\xE9triques associ\xE9es, saisis directement ou import\xE9s depuis un appareil ou service connect\xE9 tel que Strava ou Garmin.\n\nIdentifiants de synchronisation d'appareils : si vous connectez un compte fitness tiers, nous stockons les jetons d'acc\xE8s n\xE9cessaires \xE0 la synchronisation de vos donn\xE9es, chiffr\xE9s au repos.\n\nDonn\xE9es d'utilisation : informations techniques de base, comme le type de navigateur et votre mani\xE8re d'interagir avec le service, utilis\xE9es pour en assurer le bon fonctionnement."), to('pt', 'Informa\xE7\xF5es da conta: seu nome, e-mail, senha ou dados de passkey e, se voc\xEA fizer login com o Google, as informa\xE7\xF5es b\xE1sicas de perfil compartilhadas por esse provedor.\n\nPerfil e conte\xFAdo: seu avatar e as fotos de atividades, certifica\xE7\xF5es ou logotipos de empresas que voc\xEA enviar, junto com os dados profissionais e organizacionais que voc\xEA fornecer (como certifica\xE7\xF5es, centros de atividade e informa\xE7\xF5es fiscais de organiza\xE7\xF5es).\n\nDados de atividade: as atividades esportivas e de treinamento que voc\xEA registra, trajetos GPS e m\xE9tricas relacionadas, inseridos diretamente ou importados de um dispositivo ou servi\xE7o conectado, como Strava ou Garmin.\n\nCredenciais de sincroniza\xE7\xE3o de dispositivos: se voc\xEA conectar uma conta de fitness de terceiros, armazenamos os tokens de acesso necess\xE1rios para sincronizar seus dados, criptografados em repouso.\n\nDados de uso: informa\xE7\xF5es t\xE9cnicas b\xE1sicas, como tipo de navegador e como voc\xEA interage com o servi\xE7o, usadas para mant\xEA-lo funcionando de forma confi\xE1vel.'), to('zh', '\u8D26\u6237\u4FE1\u606F\uFF1A\u60A8\u7684\u59D3\u540D\u3001\u7535\u5B50\u90AE\u7BB1\u3001\u5BC6\u7801\u6216\u901A\u884C\u5BC6\u94A5\u6570\u636E\uFF1B\u5982\u679C\u60A8\u4F7F\u7528 Google \u767B\u5F55\uFF0C\u8FD8\u5305\u62EC\u8BE5\u670D\u52A1\u63D0\u4F9B\u7684\u57FA\u672C\u8D44\u6599\u4FE1\u606F\u3002\n\n\u4E2A\u4EBA\u8D44\u6599\u4E0E\u5185\u5BB9\uFF1A\u60A8\u7684\u5934\u50CF\u4EE5\u53CA\u60A8\u4E0A\u4F20\u7684\u6D3B\u52A8\u3001\u8BA4\u8BC1\u6216\u516C\u53F8\u5FBD\u6807\u7167\u7247\uFF0C\u8FDE\u540C\u60A8\u63D0\u4F9B\u7684\u4E13\u4E1A\u548C\u7EC4\u7EC7\u4FE1\u606F\uFF08\u5982\u8BA4\u8BC1\u3001\u6D3B\u52A8\u4E2D\u5FC3\u4EE5\u53CA\u7EC4\u7EC7\u7684\u8D22\u7A0E\u4FE1\u606F\uFF09\u3002\n\n\u6D3B\u52A8\u6570\u636E\uFF1A\u60A8\u8BB0\u5F55\u7684\u4F53\u80B2\u4E0E\u8BAD\u7EC3\u6D3B\u52A8\u3001GPS \u8F68\u8FF9\u53CA\u76F8\u5173\u6307\u6807\uFF0C\u65E0\u8BBA\u662F\u76F4\u63A5\u8F93\u5165\u8FD8\u662F\u4ECE Strava\u3001Garmin \u7B49\u5DF2\u8FDE\u63A5\u8BBE\u5907\u6216\u670D\u52A1\u5BFC\u5165\u3002\n\n\u8BBE\u5907\u540C\u6B65\u51ED\u8BC1\uFF1A\u5982\u679C\u60A8\u8FDE\u63A5\u4E86\u7B2C\u4E09\u65B9\u5065\u8EAB\u8D26\u6237\uFF0C\u6211\u4EEC\u4F1A\u5B58\u50A8\u540C\u6B65\u6570\u636E\u6240\u9700\u7684\u8BBF\u95EE\u4EE4\u724C\uFF0C\u5E76\u5728\u9759\u6001\u5B58\u50A8\u65F6\u5BF9\u5176\u52A0\u5BC6\u3002\n\n\u4F7F\u7528\u6570\u636E\uFF1A\u57FA\u672C\u6280\u672F\u4FE1\u606F\uFF0C\u4F8B\u5982\u6D4F\u89C8\u5668\u7C7B\u578B\u4EE5\u53CA\u60A8\u4E0E\u670D\u52A1\u7684\u4EA4\u4E92\u65B9\u5F0F\uFF0C\u7528\u4E8E\u4FDD\u969C\u670D\u52A1\u7A33\u5B9A\u8FD0\u884C\u3002')])), to('legal.privacy.s3.h', mapOf([to('en', '3. How We Use Your Information'), to('es', '3. C\xF3mo Usamos tu Informaci\xF3n'), to('fr', '3. Comment Nous Utilisons Vos Informations'), to('pt', '3. Como Usamos Suas Informa\xE7\xF5es'), to('zh', '3. \u6211\u4EEC\u5982\u4F55\u4F7F\u7528\u60A8\u7684\u4FE1\u606F')])), to('legal.privacy.s3.b', mapOf([to('en', 'We use your information to operate and improve Bitakore: to create and manage your account, display your logged activities and certifications to the people you choose to share them with, sync data from connected devices, send you service emails (such as sign-in links and account notifications), and keep the platform secure.'), to('es', 'Usamos tu informaci\xF3n para operar y mejorar Bitakore: crear y gestionar tu cuenta, mostrar tus actividades registradas y certificaciones a las personas con quienes decidas compartirlas, sincronizar datos de dispositivos conectados, enviarte correos del servicio (como enlaces de inicio de sesi\xF3n y notificaciones de cuenta) y mantener la plataforma segura.'), to('fr', 'Nous utilisons vos informations pour exploiter et am\xE9liorer Bitakore : cr\xE9er et g\xE9rer votre compte, afficher vos activit\xE9s enregistr\xE9es et vos certifications aux personnes avec qui vous choisissez de les partager, synchroniser les donn\xE9es des appareils connect\xE9s, vous envoyer des e-mails li\xE9s au service (comme les liens de connexion et les notifications de compte) et assurer la s\xE9curit\xE9 de la plateforme.'), to('pt', 'Usamos suas informa\xE7\xF5es para operar e melhorar o Bitakore: criar e gerenciar sua conta, exibir suas atividades registradas e certifica\xE7\xF5es para as pessoas com quem voc\xEA optar por compartilh\xE1-las, sincronizar dados de dispositivos conectados, enviar e-mails do servi\xE7o (como links de login e notifica\xE7\xF5es de conta) e manter a plataforma segura.'), to('zh', '\u6211\u4EEC\u4F7F\u7528\u60A8\u7684\u4FE1\u606F\u6765\u8FD0\u8425\u548C\u6539\u8FDB Bitakore\uFF1A\u521B\u5EFA\u548C\u7BA1\u7406\u60A8\u7684\u8D26\u6237\u3001\u5411\u60A8\u9009\u62E9\u5171\u4EAB\u7684\u5BF9\u8C61\u5C55\u793A\u60A8\u8BB0\u5F55\u7684\u6D3B\u52A8\u548C\u8BA4\u8BC1\u3001\u540C\u6B65\u5DF2\u8FDE\u63A5\u8BBE\u5907\u7684\u6570\u636E\u3001\u5411\u60A8\u53D1\u9001\u670D\u52A1\u90AE\u4EF6\uFF08\u5982\u767B\u5F55\u94FE\u63A5\u548C\u8D26\u6237\u901A\u77E5\uFF09\uFF0C\u5E76\u4FDD\u969C\u5E73\u53F0\u5B89\u5168\u3002')])), to('legal.privacy.s4.h', mapOf([to('en', '4. How We Share Your Information'), to('es', '4. C\xF3mo Compartimos tu Informaci\xF3n'), to('fr', '4. Comment Nous Partageons Vos Informations'), to('pt', '4. Como Compartilhamos Suas Informa\xE7\xF5es'), to('zh', '4. \u6211\u4EEC\u5982\u4F55\u5171\u4EAB\u60A8\u7684\u4FE1\u606F')])), to('legal.privacy.s4.b', mapOf([to('en', 'We do not sell your personal information or your photos, and we do not give them to third parties for their own marketing or commercial use.\n\nWe share information only: with the other users you choose to share it with within Bitakore (for example, an activity center you register activities with); with service providers who host our infrastructure and storage (such as our cloud hosting and email-delivery providers) strictly to operate the service on our behalf; with third-party fitness platforms (such as Strava or Garmin) only when you actively connect that integration; and when required by law or to protect the rights, safety, or property of Bitakore or others.'), to('es', 'No vendemos tu informaci\xF3n personal ni tus fotos, y no las entregamos a terceros para su propio uso comercial o de marketing.\n\nCompartimos informaci\xF3n \xFAnicamente: con los dem\xE1s usuarios con quienes decidas compartirla dentro de Bitakore (por ejemplo, un centro de actividad donde registras actividades); con proveedores de servicios que alojan nuestra infraestructura y almacenamiento (como nuestros proveedores de hosting en la nube y de env\xEDo de correo electr\xF3nico), estrictamente para operar el servicio en nuestro nombre; con plataformas de fitness de terceros (como Strava o Garmin) \xFAnicamente cuando conectas activamente esa integraci\xF3n; y cuando la ley lo requiera o para proteger los derechos, la seguridad o la propiedad de Bitakore o de terceros.'), to('fr', "Nous ne vendons pas vos informations personnelles ni vos photos, et nous ne les transmettons pas \xE0 des tiers pour leur propre usage commercial ou marketing.\n\nNous partageons des informations uniquement : avec les autres utilisateurs avec qui vous choisissez de les partager au sein de Bitakore (par exemple, un centre d'activit\xE9 aupr\xE8s duquel vous enregistrez des activit\xE9s) ; avec des prestataires de services qui h\xE9bergent notre infrastructure et notre stockage (comme nos fournisseurs d'h\xE9bergement cloud et d'envoi d'e-mails), strictement pour exploiter le service en notre nom ; avec des plateformes fitness tierces (comme Strava ou Garmin) uniquement lorsque vous activez cette int\xE9gration ; et lorsque la loi l'exige ou pour prot\xE9ger les droits, la s\xE9curit\xE9 ou les biens de Bitakore ou d'autrui."), to('pt', 'N\xE3o vendemos suas informa\xE7\xF5es pessoais nem suas fotos, e n\xE3o as entregamos a terceiros para uso comercial ou de marketing pr\xF3prio.\n\nCompartilhamos informa\xE7\xF5es apenas: com os demais usu\xE1rios com quem voc\xEA escolher compartilh\xE1-las dentro do Bitakore (por exemplo, um centro de atividade onde voc\xEA registra atividades); com prestadores de servi\xE7os que hospedam nossa infraestrutura e armazenamento (como nossos provedores de hospedagem em nuvem e envio de e-mail), estritamente para operar o servi\xE7o em nosso nome; com plataformas de fitness de terceiros (como Strava ou Garmin) apenas quando voc\xEA conectar ativamente essa integra\xE7\xE3o; e quando exigido por lei ou para proteger os direitos, a seguran\xE7a ou a propriedade do Bitakore ou de terceiros.'), to('zh', '\u6211\u4EEC\u4E0D\u4F1A\u51FA\u552E\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u6216\u7167\u7247\uFF0C\u4E5F\u4E0D\u4F1A\u5C06\u5176\u63D0\u4F9B\u7ED9\u7B2C\u4E09\u65B9\u7528\u4E8E\u5176\u81EA\u8EAB\u7684\u8425\u9500\u6216\u5546\u4E1A\u7528\u9014\u3002\n\n\u6211\u4EEC\u4EC5\u5728\u4EE5\u4E0B\u60C5\u51B5\u4E0B\u5171\u4EAB\u4FE1\u606F\uFF1A\u4E0E\u60A8\u5728 Bitakore \u5185\u9009\u62E9\u5171\u4EAB\u4FE1\u606F\u7684\u5176\u4ED6\u7528\u6237\u5171\u4EAB\uFF08\u4F8B\u5982\u60A8\u5728\u5176\u4E2D\u8BB0\u5F55\u6D3B\u52A8\u7684\u6D3B\u52A8\u4E2D\u5FC3\uFF09\uFF1B\u4E0E\u6258\u7BA1\u6211\u4EEC\u57FA\u7840\u8BBE\u65BD\u548C\u5B58\u50A8\u7684\u670D\u52A1\u63D0\u4F9B\u5546\uFF08\u5982\u4E91\u6258\u7BA1\u548C\u90AE\u4EF6\u53D1\u9001\u670D\u52A1\u5546\uFF09\u5171\u4EAB\uFF0C\u4EC5\u7528\u4E8E\u4EE3\u8868\u6211\u4EEC\u8FD0\u8425\u670D\u52A1\uFF1B\u4EC5\u5728\u60A8\u4E3B\u52A8\u8FDE\u63A5\u76F8\u5173\u96C6\u6210\u65F6\uFF0C\u4E0E Strava\u3001Garmin \u7B49\u7B2C\u4E09\u65B9\u5065\u8EAB\u5E73\u53F0\u5171\u4EAB\uFF1B\u4EE5\u53CA\u5728\u6CD5\u5F8B\u8981\u6C42\u6216\u4E3A\u4FDD\u62A4 Bitakore \u6216\u4ED6\u4EBA\u7684\u6743\u5229\u3001\u5B89\u5168\u6216\u8D22\u4EA7\u65F6\u5171\u4EAB\u3002')])), to('legal.privacy.s5.h', mapOf([to('en', '5. Cookies and Local Storage'), to('es', '5. Cookies y Almacenamiento Local'), to('fr', '5. Cookies et Stockage Local'), to('pt', '5. Cookies e Armazenamento Local'), to('zh', '5. Cookie \u4E0E\u672C\u5730\u5B58\u50A8')])), to('legal.privacy.s5.b', mapOf([to('en', 'We use a small amount of browser local storage to remember your session and language preference. We do not use third-party advertising trackers.'), to('es', 'Utilizamos una peque\xF1a cantidad de almacenamiento local del navegador para recordar tu sesi\xF3n y preferencia de idioma. No utilizamos rastreadores publicitarios de terceros.'), to('fr', "Nous utilisons une petite quantit\xE9 de stockage local du navigateur pour m\xE9moriser votre session et votre pr\xE9f\xE9rence de langue. Nous n'utilisons pas de traceurs publicitaires tiers."), to('pt', 'Usamos uma pequena quantidade de armazenamento local do navegador para lembrar sua sess\xE3o e prefer\xEAncia de idioma. N\xE3o usamos rastreadores publicit\xE1rios de terceiros.'), to('zh', '\u6211\u4EEC\u4F1A\u4F7F\u7528\u5C11\u91CF\u6D4F\u89C8\u5668\u672C\u5730\u5B58\u50A8\u6765\u8BB0\u4F4F\u60A8\u7684\u767B\u5F55\u72B6\u6001\u548C\u8BED\u8A00\u504F\u597D\u3002\u6211\u4EEC\u4E0D\u4F7F\u7528\u7B2C\u4E09\u65B9\u5E7F\u544A\u8DDF\u8E2A\u6280\u672F\u3002')])), to('legal.privacy.s6.h', mapOf([to('en', '6. Your Rights and Choices'), to('es', '6. Tus Derechos y Opciones'), to('fr', '6. Vos Droits et Choix'), to('pt', '6. Seus Direitos e Escolhas'), to('zh', '6. \u60A8\u7684\u6743\u5229\u4E0E\u9009\u62E9')])), to('legal.privacy.s6.b', mapOf([to('en', 'You can access, update, or delete your profile information and photos from your account settings at any time, and you can disconnect a third-party device integration whenever you like. You may also request that we delete your account and associated data by contacting us; we will honor that request except where we are required to retain certain information by law.'), to('es', 'Puedes acceder, actualizar o eliminar la informaci\xF3n de tu perfil y tus fotos desde la configuraci\xF3n de tu cuenta en cualquier momento, y puedes desconectar una integraci\xF3n de dispositivo de terceros cuando quieras. Tambi\xE9n puedes solicitarnos que eliminemos tu cuenta y los datos asociados contact\xE1ndonos; atenderemos esa solicitud salvo cuando la ley nos exija conservar cierta informaci\xF3n.'), to('fr', "Vous pouvez acc\xE9der \xE0, mettre \xE0 jour ou supprimer les informations de votre profil et vos photos depuis les param\xE8tres de votre compte \xE0 tout moment, et d\xE9connecter une int\xE9gration d'appareil tiers quand vous le souhaitez. Vous pouvez \xE9galement nous demander de supprimer votre compte et les donn\xE9es associ\xE9es en nous contactant ; nous honorerons cette demande sauf lorsque la loi nous oblige \xE0 conserver certaines informations."), to('pt', 'Voc\xEA pode acessar, atualizar ou excluir as informa\xE7\xF5es do seu perfil e suas fotos nas configura\xE7\xF5es da sua conta a qualquer momento, e pode desconectar uma integra\xE7\xE3o de dispositivo de terceiros quando quiser. Voc\xEA tamb\xE9m pode solicitar que excluamos sua conta e os dados associados entrando em contato conosco; atenderemos a essa solicita\xE7\xE3o, exceto quando formos obrigados por lei a reter determinadas informa\xE7\xF5es.'), to('zh', '\u60A8\u53EF\u4EE5\u968F\u65F6\u5728\u8D26\u6237\u8BBE\u7F6E\u4E2D\u8BBF\u95EE\u3001\u66F4\u65B0\u6216\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u8D44\u6599\u4FE1\u606F\u548C\u7167\u7247\uFF0C\u4E5F\u53EF\u4EE5\u968F\u65F6\u65AD\u5F00\u7B2C\u4E09\u65B9\u8BBE\u5907\u96C6\u6210\u3002\u60A8\u8FD8\u53EF\u4EE5\u8054\u7CFB\u6211\u4EEC\uFF0C\u8981\u6C42\u5220\u9664\u60A8\u7684\u8D26\u6237\u53CA\u76F8\u5173\u6570\u636E\uFF1B\u9664\u6CD5\u5F8B\u8981\u6C42\u6211\u4EEC\u4FDD\u7559\u67D0\u4E9B\u4FE1\u606F\u5916\uFF0C\u6211\u4EEC\u5C06\u6267\u884C\u8BE5\u8BF7\u6C42\u3002')])), to('legal.privacy.s7.h', mapOf([to('en', "7. Children's Privacy"), to('es', '7. Privacidad de Menores'), to('fr', '7. Confidentialit\xE9 des Mineurs'), to('pt', '7. Privacidade de Menores'), to('zh', '7. \u513F\u7AE5\u9690\u79C1')])), to('legal.privacy.s7.b', mapOf([to('en', 'Bitakore is not directed at children, and we do not knowingly collect information from anyone under the age required by applicable local law to consent to data processing on their own. If you believe a child has provided us with personal information, please contact us and we will remove it.'), to('es', 'Bitakore no est\xE1 dirigido a menores de edad y no recopilamos conscientemente informaci\xF3n de personas por debajo de la edad requerida por la ley local aplicable para consentir el tratamiento de sus propios datos. Si crees que un menor nos ha proporcionado informaci\xF3n personal, cont\xE1ctanos y la eliminaremos.'), to('fr', "Bitakore ne s'adresse pas aux mineurs, et nous ne collectons pas sciemment d'informations aupr\xE8s de personnes n'ayant pas l'\xE2ge requis par la loi locale applicable pour consentir elles-m\xEAmes au traitement de leurs donn\xE9es. Si vous pensez qu'un mineur nous a communiqu\xE9 des informations personnelles, contactez-nous afin que nous puissions les supprimer."), to('pt', 'O Bitakore n\xE3o \xE9 direcionado a menores de idade, e n\xE3o coletamos conscientemente informa\xE7\xF5es de pessoas abaixo da idade exigida pela lei local aplic\xE1vel para consentir com o tratamento de seus pr\xF3prios dados. Se voc\xEA acredita que um menor nos forneceu informa\xE7\xF5es pessoais, entre em contato conosco para que possamos remov\xEA-las.'), to('zh', 'Bitakore \u5E76\u975E\u9762\u5411\u513F\u7AE5\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u5728\u660E\u77E5\u7684\u60C5\u51B5\u4E0B\u6536\u96C6\u672A\u8FBE\u5230\u9002\u7528\u5F53\u5730\u6CD5\u5F8B\u89C4\u5B9A\u7684\u81EA\u4E3B\u540C\u610F\u6570\u636E\u5904\u7406\u5E74\u9F84\u4E4B\u4EBA\u7684\u4FE1\u606F\u3002\u5982\u679C\u60A8\u8BA4\u4E3A\u513F\u7AE5\u5411\u6211\u4EEC\u63D0\u4F9B\u4E86\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u8BF7\u4E0E\u6211\u4EEC\u8054\u7CFB\uFF0C\u6211\u4EEC\u5C06\u4E88\u4EE5\u5220\u9664\u3002')])), to('legal.privacy.s8.h', mapOf([to('en', '8. Data Retention and Security'), to('es', '8. Conservaci\xF3n y Seguridad de los Datos'), to('fr', '8. Conservation et S\xE9curit\xE9 des Donn\xE9es'), to('pt', '8. Reten\xE7\xE3o e Seguran\xE7a dos Dados'), to('zh', '8. \u6570\u636E\u4FDD\u7559\u4E0E\u5B89\u5168')])), to('legal.privacy.s8.b', mapOf([to('en', "We keep your information for as long as your account is active or as needed to provide the service, and delete or anonymize it once it's no longer needed, except where the law requires us to keep it longer. Device-sync credentials are encrypted at rest, and we use reasonable technical and organizational measures to protect your information, though no system can be guaranteed to be completely secure."), to('es', 'Conservamos tu informaci\xF3n mientras tu cuenta est\xE9 activa o seg\xFAn sea necesario para prestar el servicio, y la eliminamos o anonimizamos cuando ya no es necesaria, salvo que la ley exija conservarla por m\xE1s tiempo. Las credenciales de sincronizaci\xF3n de dispositivos se cifran en reposo, y usamos medidas t\xE9cnicas y organizativas razonables para proteger tu informaci\xF3n, aunque ning\xFAn sistema puede garantizarse como completamente seguro.'), to('fr', "Nous conservons vos informations tant que votre compte est actif ou aussi longtemps que n\xE9cessaire pour fournir le service, puis nous les supprimons ou les anonymisons lorsqu'elles ne sont plus n\xE9cessaires, sauf si la loi impose une conservation plus longue. Les identifiants de synchronisation d'appareils sont chiffr\xE9s au repos, et nous appliquons des mesures techniques et organisationnelles raisonnables pour prot\xE9ger vos informations, bien qu'aucun syst\xE8me ne puisse \xEAtre garanti totalement s\xE9curis\xE9."), to('pt', 'Mantemos suas informa\xE7\xF5es enquanto sua conta estiver ativa ou pelo tempo necess\xE1rio para fornecer o servi\xE7o, e as exclu\xEDmos ou anonimizamos quando n\xE3o forem mais necess\xE1rias, exceto quando a lei exigir reten\xE7\xE3o por mais tempo. As credenciais de sincroniza\xE7\xE3o de dispositivos s\xE3o criptografadas em repouso, e usamos medidas t\xE9cnicas e organizacionais razo\xE1veis para proteger suas informa\xE7\xF5es, embora nenhum sistema possa ser garantido como completamente seguro.'), to('zh', '\u6211\u4EEC\u4F1A\u5728\u60A8\u7684\u8D26\u6237\u5904\u4E8E\u6D3B\u8DC3\u72B6\u6001\u671F\u95F4\uFF0C\u6216\u5728\u63D0\u4F9B\u670D\u52A1\u6240\u9700\u7684\u671F\u9650\u5185\u4FDD\u7559\u60A8\u7684\u4FE1\u606F\uFF0C\u5E76\u5728\u4E0D\u518D\u9700\u8981\u65F6\u4E88\u4EE5\u5220\u9664\u6216\u533F\u540D\u5316\u5904\u7406\uFF0C\u9664\u975E\u6CD5\u5F8B\u8981\u6C42\u5EF6\u957F\u4FDD\u7559\u671F\u9650\u3002\u8BBE\u5907\u540C\u6B65\u51ED\u8BC1\u5728\u9759\u6001\u5B58\u50A8\u65F6\u4F1A\u88AB\u52A0\u5BC6\uFF0C\u6211\u4EEC\u91C7\u53D6\u5408\u7406\u7684\u6280\u672F\u548C\u7EC4\u7EC7\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4FE1\u606F\uFF0C\u4F46\u6CA1\u6709\u4EFB\u4F55\u7CFB\u7EDF\u80FD\u4FDD\u8BC1\u7EDD\u5BF9\u5B89\u5168\u3002')])), to('legal.privacy.s9.h', mapOf([to('en', '9. Changes to This Policy'), to('es', '9. Cambios a esta Pol\xEDtica'), to('fr', '9. Modifications de cette Politique'), to('pt', '9. Altera\xE7\xF5es a esta Pol\xEDtica'), to('zh', '9. \u672C\u653F\u7B56\u7684\u53D8\u66F4')])), to('legal.privacy.s9.b', mapOf([to('en', 'We may update this Privacy Policy from time to time. If we make material changes, we will post the updated policy on this page with a new "last updated" date and, where appropriate, notify you through the service.'), to('es', 'Podemos actualizar esta Pol\xEDtica de Privacidad peri\xF3dicamente. Si realizamos cambios importantes, publicaremos la pol\xEDtica actualizada en esta p\xE1gina con una nueva fecha de "\xFAltima actualizaci\xF3n" y, cuando corresponda, te notificaremos a trav\xE9s del servicio.'), to('fr', 'Nous pouvons mettre \xE0 jour cette Politique de Confidentialit\xE9 de temps \xE0 autre. En cas de changement important, nous publierons la politique mise \xE0 jour sur cette page avec une nouvelle date de \xAB derni\xE8re mise \xE0 jour \xBB et, le cas \xE9ch\xE9ant, vous en informerons via le service.'), to('pt', 'Podemos atualizar esta Pol\xEDtica de Privacidade periodicamente. Caso fa\xE7amos altera\xE7\xF5es significativas, publicaremos a pol\xEDtica atualizada nesta p\xE1gina com uma nova data de "\xFAltima atualiza\xE7\xE3o" e, quando apropriado, notificaremos voc\xEA pelo servi\xE7o.'), to('zh', '\u6211\u4EEC\u53EF\u80FD\u4F1A\u4E0D\u65F6\u66F4\u65B0\u672C\u9690\u79C1\u653F\u7B56\u3002\u5982\u6709\u91CD\u5927\u53D8\u66F4\uFF0C\u6211\u4EEC\u4F1A\u5728\u672C\u9875\u9762\u53D1\u5E03\u66F4\u65B0\u540E\u7684\u653F\u7B56\u5E76\u6CE8\u660E\u65B0\u7684\u300C\u6700\u540E\u66F4\u65B0\u65E5\u671F\u300D\uFF0C\u5E76\u5728\u9002\u5F53\u60C5\u51B5\u4E0B\u901A\u8FC7\u670D\u52A1\u901A\u77E5\u60A8\u3002')])), to('legal.privacy.s10.h', mapOf([to('en', '10. Contact Us'), to('es', '10. Cont\xE1ctanos'), to('fr', '10. Nous Contacter'), to('pt', '10. Fale Conosco'), to('zh', '10. \u8054\u7CFB\u6211\u4EEC')])), to('legal.privacy.s10.b', mapOf([to('en', 'If you have questions about this Privacy Policy or want to exercise any of your rights, contact us at contact@ubitakore.com.'), to('es', 'Si tienes preguntas sobre esta Pol\xEDtica de Privacidad o deseas ejercer alguno de tus derechos, cont\xE1ctanos en contact@ubitakore.com.'), to('fr', 'Pour toute question concernant cette Politique de Confidentialit\xE9 ou pour exercer vos droits, contactez-nous \xE0 contact@ubitakore.com.'), to('pt', 'Se voc\xEA tiver d\xFAvidas sobre esta Pol\xEDtica de Privacidade ou quiser exercer algum dos seus direitos, entre em contato conosco em contact@ubitakore.com.'), to('zh', '\u5982\u679C\u60A8\u5BF9\u672C\u9690\u79C1\u653F\u7B56\u6709\u4EFB\u4F55\u7591\u95EE\uFF0C\u6216\u5E0C\u671B\u884C\u4F7F\u60A8\u7684\u6743\u5229\uFF0C\u8BF7\u901A\u8FC7 contact@ubitakore.com \u4E0E\u6211\u4EEC\u8054\u7CFB\u3002')])), to('footer.terms', mapOf([to('en', 'Terms and Conditions'), to('es', 'T\xE9rminos y Condiciones'), to('fr', 'Conditions G\xE9n\xE9rales'), to('pt', 'Termos e Condi\xE7\xF5es'), to('zh', '\u670D\u52A1\u6761\u6B3E')])), to('footer.privacy', mapOf([to('en', 'Privacy Policy'), to('es', 'Pol\xEDtica de Privacidad'), to('fr', 'Politique de Confidentialit\xE9'), to('pt', 'Pol\xEDtica de Privacidade'), to('zh', '\u9690\u79C1\u653F\u7B56')])), to('footer.contact', mapOf([to('en', 'Contact'), to('es', 'Contacto'), to('fr', 'Contact'), to('pt', 'Contato'), to('zh', '\u8054\u7CFB\u6211\u4EEC')])), to('footer.copyright', mapOf([to('en', '\xA9 {year} Universaliun S.A.S. All rights reserved.'), to('es', '\xA9 {year} Universaliun S.A.S. Todos los derechos reservados.'), to('fr', '\xA9 {year} Universaliun S.A.S. Tous droits r\xE9serv\xE9s.'), to('pt', '\xA9 {year} Universaliun S.A.S. Todos os direitos reservados.'), to('zh', '\xA9 {year} Universaliun S.A.S. \u4FDD\u7559\u6240\u6709\u6743\u5229\u3002')])), to('auth.consentNotice.prefix', mapOf([to('en', 'By using Bitakore, you accept our'), to('es', 'Al usar Bitakore, aceptas nuestros'), to('fr', 'En utilisant Bitakore, vous acceptez nos'), to('pt', 'Ao usar o Bitakore, voc\xEA aceita nossos'), to('zh', '\u4F7F\u7528 Bitakore \u5373\u8868\u793A\u60A8\u540C\u610F\u6211\u4EEC\u7684')])), to('auth.consentNotice.and', mapOf([to('en', 'and'), to('es', 'y'), to('fr', 'et notre'), to('pt', 'e nossa'), to('zh', '\u548C')])), to('analytics.consent.message', mapOf([to('en', 'We use analytics to see which channels bring visitors to Bitakore. No personal data is sold \u2014 you can decline.'), to('es', 'Usamos anal\xEDtica para ver qu\xE9 canales traen visitantes a Bitakore. No vendemos datos personales \u2014 puedes rechazar.'), to('fr', "Nous utilisons des statistiques pour voir quels canaux am\xE8nent des visiteurs sur Bitakore. Aucune donn\xE9e personnelle n'est vendue \u2014 vous pouvez refuser."), to('pt', 'Usamos an\xE1lises para ver quais canais trazem visitantes ao Bitakore. Nenhum dado pessoal \xE9 vendido \u2014 voc\xEA pode recusar.'), to('zh', '\u6211\u4EEC\u4F7F\u7528\u5206\u6790\u5DE5\u5177\u6765\u4E86\u89E3\u54EA\u4E9B\u6E20\u9053\u4E3A Bitakore \u5E26\u6765\u8BBF\u5BA2\u3002\u6211\u4EEC\u4E0D\u4F1A\u51FA\u552E\u4E2A\u4EBA\u6570\u636E\u2014\u2014\u60A8\u53EF\u4EE5\u62D2\u7EDD\u3002')])), to('analytics.consent.accept', mapOf([to('en', 'Accept'), to('es', 'Aceptar'), to('fr', 'Accepter'), to('pt', 'Aceitar'), to('zh', '\u63A5\u53D7')])), to('analytics.consent.decline', mapOf([to('en', 'Decline'), to('es', 'Rechazar'), to('fr', 'Refuser'), to('pt', 'Recusar'), to('zh', '\u62D2\u7EDD')]))]), get_countryTranslations());
  }
  protoOf(I18n).r26 = function () {
    var tmp0_safe_receiver = localStorage.getItem('bitakore.locale');
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = Companion_instance_1.g28(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? detectBrowserLocale(this) : tmp1_elvis_lhs;
  };
  protoOf(I18n).e28 = function (key) {
    var tmp0_safe_receiver = this.k26_1.i2(key);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i2(this.r26().o26_1);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = this.k26_1.i2(key);
      tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.i2('en');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp;
    return tmp3_elvis_lhs == null ? key : tmp3_elvis_lhs;
  };
  protoOf(I18n).l26 = function (code) {
    var tmp0_elvis_lhs = Companion_instance_1.g28(code);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var resolved = tmp;
    _set_locale__t3qkub(this, resolved);
    this.h28();
  };
  protoOf(I18n).h28 = function () {
    var nodeList = document.querySelectorAll('[data-i18n]');
    var inductionVariable = 0;
    var last = nodeList.length;
    if (inductionVariable < last)
      $l$loop_0: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = nodeList.item(i);
        var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var element = tmp_0;
        var tmp1_elvis_lhs = element.getAttribute('data-i18n');
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        var key = tmp_1;
        element.textContent = this.e28(key);
      }
       while (inductionVariable < last);
    var placeholderNodeList = document.querySelectorAll('[data-i18n-placeholder]');
    var inductionVariable_0 = 0;
    var last_0 = placeholderNodeList.length;
    if (inductionVariable_0 < last_0)
      $l$loop_2: do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp_2 = placeholderNodeList.item(i_0);
        var tmp2_elvis_lhs = tmp_2 instanceof HTMLElement ? tmp_2 : null;
        var tmp_3;
        if (tmp2_elvis_lhs == null) {
          continue $l$loop_2;
        } else {
          tmp_3 = tmp2_elvis_lhs;
        }
        var element_0 = tmp_3;
        var tmp3_elvis_lhs = element_0.getAttribute('data-i18n-placeholder');
        var tmp_4;
        if (tmp3_elvis_lhs == null) {
          continue $l$loop_2;
        } else {
          tmp_4 = tmp3_elvis_lhs;
        }
        var key_0 = tmp_4;
        // Inline function 'kotlin.js.asDynamic' call
        element_0.placeholder = this.e28(key_0);
      }
       while (inductionVariable_0 < last_0);
  };
  var I18n_instance;
  function I18n_getInstance() {
    if (I18n_instance == null)
      new I18n();
    return I18n_instance;
  }
  function Locale_ENGLISH_getInstance() {
    Locale_initEntries();
    return Locale_ENGLISH_instance;
  }
  function Locale_SPANISH_getInstance() {
    Locale_initEntries();
    return Locale_SPANISH_instance;
  }
  function Locale_FRENCH_getInstance() {
    Locale_initEntries();
    return Locale_FRENCH_instance;
  }
  function Locale_PORTUGUESE_getInstance() {
    Locale_initEntries();
    return Locale_PORTUGUESE_instance;
  }
  function Locale_CHINESE_getInstance() {
    Locale_initEntries();
    return Locale_CHINESE_instance;
  }
  function main() {
    ApiClient_getInstance().e27_1 = window.location.origin;
    Analytics_instance.o28();
    Analytics_instance.p28();
    CommonModule_instance.x27();
    I18n_getInstance().h28();
    Analytics_instance.q28(window.location.pathname);
    switch (window.location.pathname) {
      case '/legal/terms':
        TermsPageModule_instance.r28();
        break;
      case '/legal/privacy':
        PrivacyPageModule_instance.r28();
        break;
      case '/login':
        LoginPageModule_instance.r28();
        break;
      case '/register':
        RegisterPageModule_instance.r28();
        break;
      case '/forgot-password':
        ForgotPasswordPageModule_instance.r28();
        break;
      case '/reset-password':
        ResetPasswordPageModule_instance.r28();
        break;
      case '/magic-link':
        MagicLinkLandingPageModule_instance.r28();
        break;
      case '/setup':
        SetupPageModule_instance.r28();
        break;
      case '/oauth/callback':
        OAuthCallbackPageModule_instance.r28();
        break;
      case '/invitations/accept':
        AcceptInvitationPageModule_instance.r28();
        break;
      case '/':
        HomePageModule_instance.r28();
        break;
      case '/activities/select':
        ActivitySelectionPageModule_instance.r28();
        break;
      case '/bitacora/mine':
        MyBitacoraPageModule_instance.r28();
        break;
      case '/bitacora/leaderboard':
        LeaderboardPageModule_instance.r28();
        break;
      case '/bitacora/pending':
        PendingApprovalsPageModule_instance.r28();
        break;
      case '/bitacora/claim-invitations':
        ClaimInvitationsPageModule_instance.r28();
        break;
      case '/profile':
        ProfilePageModule_instance.r28();
        break;
      case '/settings':
        SettingsPageModule_instance.r28();
        break;
      case '/discover':
        DiscoverPageModule_instance.r28();
        break;
      case '/bitacora/company/offerings':
        ActivityOfferingsPageModule_instance.r28();
        break;
      case '/bitacora/company/log':
        LogCenterActivityPageModule_instance.r28();
        break;
      case '/bitacora/company/activities':
        CompanyActivityLogPageModule_instance.r28();
        break;
      case '/bitacora/company/team':
        CompanyTeamPageModule_instance.r28();
        break;
      case '/bitacora/company/analytics':
        CompanyAnalyticsPageModule_instance.r28();
        break;
      case '/bitacora/company/visibility':
        RequestCertificationVisibilityPageModule_instance.r28();
        break;
      case '/admin/users':
        AdminUsersPageModule_instance.r28();
        break;
      case '/admin/companies/activity-centers':
        ActivityCentersPageModule_instance.r28();
        break;
      case '/admin/companies/certification-issuers':
        CertificationIssuersPageModule_instance.r28();
        break;
      case '/admin/companies/marketers':
        MarketersPageModule_instance.r28();
        break;
      case '/admin/ad-pricing':
        AdminAdPricingPageModule_instance.r28();
        break;
      case '/bitacora/certifications':
        CertificationTypesPageModule_instance.r28();
        break;
      case '/bitacora/issuing-authorities':
        IssuingAuthoritiesPageModule_instance.r28();
        break;
      case '/bitacora/visibility-requests':
        CertificationVisibilityRequestsPageModule_instance.r28();
        break;
      case '/bitacora/log':
        LogActivityPageModule_instance.r28();
        break;
      case '/bitacora/marketer/advertisements':
        MarketerAdvertisementsPageModule_instance.r28();
        break;
      case '/bitacora/marketer/campaigns':
        MarketerCampaignsPageModule_instance.r28();
        break;
      case '/bitacora/marketer/billing':
        MarketerBillingPageModule_instance.r28();
        break;
      default:
        break;
    }
  }
  function mainWrapper() {
    main();
  }
  var ConsentState_GRANTED_instance;
  var ConsentState_DENIED_instance;
  var ConsentState_UNSET_instance;
  var ConsentState_entriesInitialized;
  function ConsentState_initEntries() {
    if (ConsentState_entriesInitialized)
      return Unit_instance;
    ConsentState_entriesInitialized = true;
    ConsentState_GRANTED_instance = new ConsentState('GRANTED', 0);
    ConsentState_DENIED_instance = new ConsentState('DENIED', 1);
    ConsentState_UNSET_instance = new ConsentState('UNSET', 2);
  }
  function ConsentState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function firstTouchParams($this) {
    var tmp0_safe_receiver = localStorage.getItem('bitakore.firstTouchUtm');
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = parseQueryParams('?' + tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  }
  function loadCloudflareBeacon($this) {
    if (isBlank($this.j28_1))
      return Unit_instance;
    var tmp = document.createElement('script');
    var script = tmp instanceof HTMLScriptElement ? tmp : THROW_CCE();
    script.src = 'https://static.cloudflareinsights.com/beacon.min.js';
    script.setAttribute('defer', '');
    script.setAttribute('data-cf-beacon', '{"token": "' + $this.j28_1 + '"}');
    var tmp0_safe_receiver = document.head;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.appendChild(script);
  }
  function loadGa4($this) {
    if ($this.n28_1 || isBlank($this.k28_1))
      return Unit_instance;
    $this.n28_1 = true;
    var tmp = document.createElement('script');
    var script = tmp instanceof HTMLScriptElement ? tmp : THROW_CCE();
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + $this.k28_1;
    var tmp0_safe_receiver = document.head;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.appendChild(script);
    pushDataLayer($this, ['js', new Date()]);
    pushDataLayer($this, ['config', $this.k28_1, jsObjectOf(mapOf_0(to('anonymize_ip', true)))]);
  }
  function pushDataLayer($this, entry) {
    window.dataLayer = window.dataLayer || [];
    // Inline function 'kotlin.js.asDynamic' call
    window.dataLayer.push(entry);
  }
  function Analytics$captureFirstTouchUtm$lambda(it) {
    return it.e2() + '=' + it.f2();
  }
  function Analytics() {
    this.i28_1 = 'www.ubitakore.com';
    this.j28_1 = '';
    this.k28_1 = '';
    this.l28_1 = 'bitakore.analyticsConsent';
    this.m28_1 = 'bitakore.firstTouchUtm';
    this.n28_1 = false;
  }
  protoOf(Analytics).s28 = function () {
    switch (localStorage.getItem('bitakore.analyticsConsent')) {
      case 'granted':
        return ConsentState_GRANTED_getInstance();
      case 'denied':
        return ConsentState_DENIED_getInstance();
      default:
        return ConsentState_UNSET_getInstance();
    }
  };
  protoOf(Analytics).t28 = function (hostname) {
    if (!(hostname === 'www.ubitakore.com'))
      return Unit_instance;
    loadCloudflareBeacon(this);
    switch (this.s28().t2_1) {
      case 0:
        loadGa4(this);
        break;
      case 1:
        break;
      case 2:
        ConsentBanner_instance.u28();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  };
  protoOf(Analytics).p28 = function (hostname, $super) {
    hostname = hostname === VOID ? window.location.hostname : hostname;
    var tmp;
    if ($super === VOID) {
      this.t28(hostname);
      tmp = Unit_instance;
    } else {
      tmp = $super.t28.call(this, hostname);
    }
    return tmp;
  };
  protoOf(Analytics).v28 = function () {
    localStorage.setItem('bitakore.analyticsConsent', 'granted');
    loadGa4(this);
  };
  protoOf(Analytics).w28 = function () {
    localStorage.setItem('bitakore.analyticsConsent', 'denied');
  };
  protoOf(Analytics).x28 = function (query) {
    if (!(localStorage.getItem('bitakore.firstTouchUtm') == null))
      return Unit_instance;
    // Inline function 'kotlin.collections.filterKeys' call
    var this_0 = parseQueryParams(query);
    var result = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this_0.l2().t();
    while (_iterator__ex2g4s.u()) {
      var entry = _iterator__ex2g4s.v();
      var it = entry.e2();
      switch (it) {
        case 'utm_source':
        case 'utm_medium':
          var tmp$ret$2 = true;
          break;
        default:
          tmp$ret$2 = it === 'utm_campaign';
          break;
      }
      if (tmp$ret$2) {
        result.m2(entry.e2(), entry.f2());
      }
    }
    var captured = result;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!captured.r()) {
      var tmp = localStorage;
      var tmp_0 = captured.l2();
      tmp.setItem('bitakore.firstTouchUtm', joinToString(tmp_0, '&', VOID, VOID, VOID, VOID, Analytics$captureFirstTouchUtm$lambda));
    }
  };
  protoOf(Analytics).o28 = function (query, $super) {
    query = query === VOID ? window.location.search : query;
    var tmp;
    if ($super === VOID) {
      this.x28(query);
      tmp = Unit_instance;
    } else {
      tmp = $super.x28.call(this, query);
    }
    return tmp;
  };
  protoOf(Analytics).q28 = function (path) {
    if (!this.s28().equals(ConsentState_GRANTED_getInstance()))
      return Unit_instance;
    pushDataLayer(this, ['event', 'page_view', jsObjectOf(mapOf_0(to('page_path', path)))]);
  };
  protoOf(Analytics).y28 = function (method) {
    if (!this.s28().equals(ConsentState_GRANTED_getInstance()))
      return Unit_instance;
    var params = plus_0(firstTouchParams(this), to('method', method));
    pushDataLayer(this, ['event', 'sign_up', jsObjectOf(params)]);
  };
  var Analytics_instance;
  function Analytics_getInstance() {
    return Analytics_instance;
  }
  function jsObjectOf(pairs) {
    var obj = {};
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = pairs.l2().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.component1' call
      var key = element.e2();
      // Inline function 'kotlin.collections.component2' call
      var value = element.f2();
      obj[key] = value;
    }
    return obj;
  }
  function parseQueryParams(query) {
    // Inline function 'kotlin.takeIf' call
    var this_0 = removePrefix(query, '?');
    var tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(this_0)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : split(tmp0_safe_receiver, ['&']);
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp1_safe_receiver.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var kv = split(element, ['='], VOID, 2);
        var tmp0_safe_receiver_0 = kv.z() === 2 ? to(kv.a1(0), decodeURIComponent(kv.a1(1))) : null;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.x(tmp0_safe_receiver_0);
        }
      }
      tmp_0 = destination;
    }
    var tmp2_safe_receiver = tmp_0;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toMap(tmp2_safe_receiver);
    return tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs;
  }
  function ConsentState_GRANTED_getInstance() {
    ConsentState_initEntries();
    return ConsentState_GRANTED_instance;
  }
  function ConsentState_DENIED_getInstance() {
    ConsentState_initEntries();
    return ConsentState_DENIED_instance;
  }
  function ConsentState_UNSET_getInstance() {
    ConsentState_initEntries();
    return ConsentState_UNSET_instance;
  }
  function dismiss($this) {
    var tmp = document.getElementById('analyticsConsentBanner');
    var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.remove();
    }
  }
  function ConsentBanner$render$lambda($this$append) {
    // Inline function 'kotlinx.html.div' call
    var classes = 'analytics-consent-banner';
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new DIV(attributesMapOf_0('class', classes), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    set_id(this_0, 'analyticsConsentBanner');
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new P(attributesMapOf_0('class', null), this_0.j1f());
    this_1.j1f().a1h(this_1);
    this_1.n1f(I18n_getInstance().e28('analytics.consent.message'));
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.div' call
    var classes_0 = 'analytics-consent-actions';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new DIV(attributesMapOf_0('class', classes_0), this_0.j1f());
    this_2.j1f().a1h(this_2);
    // Inline function 'kotlinx.html.button' call
    var tmp = null == null ? null : enumEncode(null);
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_2.j1f());
    this_3.j1f().a1h(this_3);
    set_id(this_3, 'analyticsConsentDecline');
    set_onClickFunction(this_3, ConsentBanner$render$lambda$lambda);
    this_3.n1f(I18n_getInstance().e28('analytics.consent.decline'));
    this_3.j1f().b1h(this_3);
    // Inline function 'kotlinx.html.button' call
    var classes_1 = 'btn-primary';
    var tmp_1 = null == null ? null : enumEncode(null);
    var tmp_2 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_4 = new BUTTON(attributesMapOf(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_1]), this_2.j1f());
    this_4.j1f().a1h(this_4);
    set_id(this_4, 'analyticsConsentAccept');
    set_onClickFunction(this_4, ConsentBanner$render$lambda$lambda_0);
    this_4.n1f(I18n_getInstance().e28('analytics.consent.accept'));
    this_4.j1f().b1h(this_4);
    this_2.j1f().b1h(this_2);
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function ConsentBanner$render$lambda$lambda(it) {
    dismiss(ConsentBanner_instance);
    Analytics_instance.w28();
    return Unit_instance;
  }
  function ConsentBanner$render$lambda$lambda_0(it) {
    dismiss(ConsentBanner_instance);
    Analytics_instance.v28();
    return Unit_instance;
  }
  function ConsentBanner() {
  }
  protoOf(ConsentBanner).u28 = function () {
    if (!(document.getElementById('analyticsConsentBanner') == null))
      return Unit_instance;
    var tmp0_safe_receiver = document.body;
    if (tmp0_safe_receiver == null)
      null;
    else {
      append(tmp0_safe_receiver, ConsentBanner$render$lambda);
    }
  };
  var ConsentBanner_instance;
  function ConsentBanner_getInstance() {
    return ConsentBanner_instance;
  }
  function activityTypeLabel(activityType) {
    var tmp0_safe_receiver = get_activityTypeDisplayI18nKeys().i2(activityType.s2_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = I18n_getInstance().e28(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? replace(activityType.s2_1, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(32)) : tmp1_elvis_lhs;
  }
  function activityTypesSortedByCurrentLocale() {
    var tmp = get_ACTIVITY_SCHEMAS();
    var tmp_0 = activityTypesSortedByCurrentLocale$lambda;
    return sortedWith(tmp, new sam$kotlin_Comparator$0_0(tmp_0));
  }
  function appendActivityTypeOptions(_this__u8e3s4) {
    append(_this__u8e3s4, appendActivityTypeOptions$lambda);
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.z28_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).cc = function (a, b) {
    return this.z28_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.cc(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).c3 = function () {
    return this.z28_1;
  };
  protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.c3(), other.c3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
    return hashCode(this.c3());
  };
  function activityTypesSortedByCurrentLocale$lambda(a, b) {
    var labelA = I18n_getInstance().e28(a.u25_1);
    var labelB = I18n_getInstance().e28(b.u25_1);
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = labelA.localeCompare(labelB, I18n_getInstance().r26().o26_1);
    return (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
  }
  function appendActivityTypeOptions$lambda($this$append) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = activityTypesSortedByCurrentLocale().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlinx.html.option' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new OPTION(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.d1m(element.t25_1);
      var tmp0 = this_0.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = element.u25_1;
      tmp0.m2(tmp2, value);
      this_0.n1f(I18n_getInstance().e28(element.u25_1));
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
    }
    return Unit_instance;
  }
  function set_discoverMap(_set____db54di) {
    _init_properties_MapLibreMap_kt__d0he9e();
    discoverMap = _set____db54di;
  }
  function get_discoverMap() {
    _init_properties_MapLibreMap_kt__d0he9e();
    return discoverMap;
  }
  var discoverMap;
  function set_discoverUserMarker(_set____db54di) {
    _init_properties_MapLibreMap_kt__d0he9e();
    discoverUserMarker = _set____db54di;
  }
  var discoverUserMarker;
  function get_discoverCenterMarkers() {
    _init_properties_MapLibreMap_kt__d0he9e();
    return discoverCenterMarkers;
  }
  var discoverCenterMarkers;
  function maplibreLoaded() {
    _init_properties_MapLibreMap_kt__d0he9e();
    // Inline function 'kotlin.js.asDynamic' call
    return window.maplibregl != undefined;
  }
  function emptyStyle() {
    _init_properties_MapLibreMap_kt__d0he9e();
    var style = {};
    style.version = 8;
    style.sources = {};
    style.layers = [];
    return style;
  }
  function newMap(containerId, center, zoom) {
    _init_properties_MapLibreMap_kt__d0he9e();
    var options = {};
    options.container = containerId;
    options.style = emptyStyle();
    options.center = center;
    options.zoom = zoom;
    return new maplibregl.Map(options);
  }
  function addEsriRasterLayer(map) {
    _init_properties_MapLibreMap_kt__d0he9e();
    var source = {};
    source.type = 'raster';
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    source.tiles = ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'];
    source.tileSize = 256;
    source.attribution = 'Tiles &copy; Esri';
    map.addSource('esri-world-imagery', source);
    var layer = {};
    layer.id = 'esri-world-imagery';
    layer.type = 'raster';
    layer.source = 'esri-world-imagery';
    map.addLayer(layer);
  }
  function circleRingCoordinates(lat, lon, radiusKm, segments) {
    segments = segments === VOID ? 64 : segments;
    _init_properties_MapLibreMap_kt__d0he9e();
    var latRad = lat * 3.141592653589793 / 180.0;
    var lonRad = lon * 3.141592653589793 / 180.0;
    var angularDistance = radiusKm / 6371.0;
    var tmp = 0;
    var tmp_0 = segments + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var bearing = 2 * 3.141592653589793 * tmp_2 / segments;
      // Inline function 'kotlin.math.sin' call
      var tmp_3 = Math.sin(latRad);
      // Inline function 'kotlin.math.cos' call
      var tmp_4 = tmp_3 * Math.cos(angularDistance);
      // Inline function 'kotlin.math.cos' call
      var tmp_5 = Math.cos(latRad);
      // Inline function 'kotlin.math.sin' call
      var tmp_6 = tmp_5 * Math.sin(angularDistance);
      // Inline function 'kotlin.math.cos' call
      // Inline function 'kotlin.math.asin' call
      var x = tmp_4 + tmp_6 * Math.cos(bearing);
      var destLatRad = Math.asin(x);
      // Inline function 'kotlin.math.sin' call
      var tmp_7 = Math.sin(bearing);
      // Inline function 'kotlin.math.sin' call
      var tmp_8 = tmp_7 * Math.sin(angularDistance);
      // Inline function 'kotlin.math.cos' call
      var tmp0 = tmp_8 * Math.cos(latRad);
      // Inline function 'kotlin.math.cos' call
      var tmp_9 = Math.cos(angularDistance);
      // Inline function 'kotlin.math.sin' call
      var tmp_10 = Math.sin(latRad);
      // Inline function 'kotlin.math.sin' call
      // Inline function 'kotlin.math.atan2' call
      var x_0 = tmp_9 - tmp_10 * Math.sin(destLatRad);
      var destLonRad = lonRad + Math.atan2(tmp0, x_0);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1[tmp_2] = [destLonRad * 180.0 / 3.141592653589793, destLatRad * 180.0 / 3.141592653589793];
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function addRadiusCircle(map, lat, lon, radiusKm) {
    _init_properties_MapLibreMap_kt__d0he9e();
    var polygon = {};
    polygon.type = 'Polygon';
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    polygon.coordinates = [circleRingCoordinates(lat, lon, radiusKm)];
    var feature = {};
    feature.type = 'Feature';
    feature.geometry = polygon;
    var source = {};
    source.type = 'geojson';
    source.data = feature;
    map.addSource('discover-radius-circle', source);
    var fillLayer = {};
    fillLayer.id = 'discover-radius-circle-fill';
    fillLayer.type = 'fill';
    fillLayer.source = 'discover-radius-circle';
    var fillPaint = {};
    fillPaint['fill-color'] = '#4c8dff';
    fillPaint['fill-opacity'] = 0.1;
    fillLayer.paint = fillPaint;
    map.addLayer(fillLayer);
    var outlineLayer = {};
    outlineLayer.id = 'discover-radius-circle-outline';
    outlineLayer.type = 'line';
    outlineLayer.source = 'discover-radius-circle';
    var outlinePaint = {};
    outlinePaint['line-color'] = '#4c8dff';
    outlinePaint['line-width'] = 2;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    outlinePaint['line-dasharray'] = [2, 2];
    outlineLayer.paint = outlinePaint;
    map.addLayer(outlineLayer);
  }
  function addMarker(map, lat, lon, color, draggable) {
    draggable = draggable === VOID ? false : draggable;
    _init_properties_MapLibreMap_kt__d0he9e();
    var options = {};
    options.color = color;
    options.draggable = draggable;
    var tmp = new maplibregl.Marker(options);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [lon, lat];
    return tmp.setLngLat(tmp$ret$0).addTo(map);
  }
  function updateRadiusCirclePosition(map, lat, lon, radiusKm) {
    _init_properties_MapLibreMap_kt__d0he9e();
    var source = map.getSource('discover-radius-circle');
    if (source == undefined)
      return Unit_instance;
    var polygon = {};
    polygon.type = 'Polygon';
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    polygon.coordinates = [circleRingCoordinates(lat, lon, radiusKm)];
    var feature = {};
    feature.type = 'Feature';
    feature.geometry = polygon;
    source.setData(feature);
  }
  function renderMapLibreMap(containerId, latitude, longitude) {
    _init_properties_MapLibreMap_kt__d0he9e();
    if (!maplibreLoaded())
      return Unit_instance;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [longitude, latitude];
    var map = newMap(containerId, tmp$ret$0, 15);
    map.on('load', renderMapLibreMap$lambda(map, latitude, longitude));
  }
  function renderMapLibreTrackMap(containerId, points) {
    _init_properties_MapLibreMap_kt__d0he9e();
    if (!maplibreLoaded() || points.r())
      return Unit_instance;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(points, 10));
    var _iterator__ex2g4s = points.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var lat = item.g9();
      var lon = item.h9();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [lon, lat];
      destination.x(tmp$ret$2);
    }
    var lngLats = destination;
    var map = newMap(containerId, first(lngLats), points.z() === 1 ? 15 : 3);
    map.on('load', renderMapLibreTrackMap$lambda(map, points, lngLats));
  }
  function renderLocationConfirmMap(containerId, latitude, longitude, onPositionConfirmed) {
    _init_properties_MapLibreMap_kt__d0he9e();
    if (!maplibreLoaded())
      return Unit_instance;
    var tmp = document.getElementById(containerId);
    var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.innerHTML = '';
    }
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [longitude, latitude];
    var map = newMap(containerId, tmp$ret$0, 15);
    map.on('load', renderLocationConfirmMap$lambda(map, longitude, latitude, onPositionConfirmed));
  }
  function renderDiscoverMap(containerId, userLatitude, userLongitude, zoom, showUserMarker, radiusKm, onMoveEnd) {
    zoom = zoom === VOID ? 9 : zoom;
    showUserMarker = showUserMarker === VOID ? true : showUserMarker;
    radiusKm = radiusKm === VOID ? null : radiusKm;
    _init_properties_MapLibreMap_kt__d0he9e();
    if (!maplibreLoaded())
      return Unit_instance;
    var tmp0_safe_receiver = get_discoverMap();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.remove();
    }
    var tmp = document.getElementById(containerId);
    var tmp1_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.innerHTML = '';
    }
    get_discoverCenterMarkers().p2();
    set_discoverUserMarker(null);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [userLongitude, userLatitude];
    var map = newMap(containerId, tmp$ret$0, zoom);
    set_discoverMap(map);
    map.on('load', renderDiscoverMap$lambda(map, showUserMarker, radiusKm, userLatitude, userLongitude, onMoveEnd));
  }
  function renderDiscoverMapPlaceholder(containerId, onMoveEnd) {
    _init_properties_MapLibreMap_kt__d0he9e();
    renderDiscoverMap(containerId, 20.0, 0.0, 1, false, VOID, onMoveEnd);
  }
  function updateDiscoverMapCenters(centers) {
    _init_properties_MapLibreMap_kt__d0he9e();
    var tmp0_elvis_lhs = get_discoverMap();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var map = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = get_discoverCenterMarkers().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      element.remove();
    }
    get_discoverCenterMarkers().p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = centers.t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      var lat = element_0.g9();
      var lon = element_0.h9();
      get_discoverCenterMarkers().x(addMarker(map, lat, lon, '#2563eb'));
    }
  }
  function renderMapLibreMap$lambda($map, $latitude, $longitude) {
    return function (it) {
      addEsriRasterLayer($map);
      addMarker($map, $latitude, $longitude, '#2563eb');
      return Unit_instance;
    };
  }
  function renderMapLibreTrackMap$lambda($map, $points, $lngLats) {
    return function (it) {
      addEsriRasterLayer($map);
      if ($points.z() === 1) {
        var _destruct__k2r9zo = first($points);
        var lat = _destruct__k2r9zo.g9();
        var lon = _destruct__k2r9zo.h9();
        addMarker($map, lat, lon, '#2563eb');
      } else {
        var lineString = {};
        lineString.type = 'LineString';
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = $lngLats;
        lineString.coordinates = copyToArray(this_0);
        var feature = {};
        feature.type = 'Feature';
        feature.geometry = lineString;
        var source = {};
        source.type = 'geojson';
        source.data = feature;
        $map.addSource('track-line', source);
        var paint = {};
        paint['line-color'] = '#2563eb';
        paint['line-width'] = 4;
        var layer = {};
        layer.id = 'track-line';
        layer.type = 'line';
        layer.source = 'track-line';
        layer.paint = paint;
        $map.addLayer(layer);
        var _destruct__k2r9zo_0 = first($points);
        var startLat = _destruct__k2r9zo_0.g9();
        var startLon = _destruct__k2r9zo_0.h9();
        var _destruct__k2r9zo_1 = last($points);
        var endLat = _destruct__k2r9zo_1.g9();
        var endLon = _destruct__k2r9zo_1.h9();
        addMarker($map, startLat, startLon, '#16a34a');
        addMarker($map, endLat, endLon, '#dc2626');
        var minLon = $lngLats.a1(0)[0];
        var maxLon = $lngLats.a1(0)[0];
        var minLat = $lngLats.a1(0)[1];
        var maxLat = $lngLats.a1(0)[1];
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = $lngLats.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          // Inline function 'kotlin.collections.component1' call
          var lon_0 = element[0];
          // Inline function 'kotlin.collections.component2' call
          var lat_0 = element[1];
          if (lon_0 < minLon)
            minLon = lon_0;
          if (lon_0 > maxLon)
            maxLon = lon_0;
          if (lat_0 < minLat)
            minLat = lat_0;
          if (lat_0 > maxLat)
            maxLat = lat_0;
        }
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = [minLon, minLat];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var bounds = [tmp, [maxLon, maxLat]];
        var fitOptions = {};
        fitOptions.padding = 24;
        $map.fitBounds(bounds, fitOptions);
      }
      return Unit_instance;
    };
  }
  function renderLocationConfirmMap$lambda$lambda($marker, $onPositionConfirmed) {
    return function (it) {
      var lngLat = $marker.getLngLat();
      var tmp = lngLat.lat;
      var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
      var tmp_1 = lngLat.lng;
      $onPositionConfirmed(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE());
      return Unit_instance;
    };
  }
  function renderLocationConfirmMap$lambda$lambda_0($marker, $onPositionConfirmed) {
    return function (e) {
      var lngLat = e.lngLat;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = [lngLat.lng, lngLat.lat];
      $marker.setLngLat(tmp$ret$0);
      var tmp = lngLat.lat;
      var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
      var tmp_1 = lngLat.lng;
      $onPositionConfirmed(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE());
      return Unit_instance;
    };
  }
  function renderLocationConfirmMap$lambda($map, $longitude, $latitude, $onPositionConfirmed) {
    return function (it) {
      addEsriRasterLayer($map);
      var options = {};
      options.color = '#2563eb';
      options.draggable = true;
      var tmp = new maplibregl.Marker(options);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = [$longitude, $latitude];
      var marker = tmp.setLngLat(tmp$ret$0).addTo($map);
      marker.on('dragend', renderLocationConfirmMap$lambda$lambda(marker, $onPositionConfirmed));
      $map.on('click', renderLocationConfirmMap$lambda$lambda_0(marker, $onPositionConfirmed));
      return Unit_instance;
    };
  }
  function renderDiscoverMap$lambda$lambda($radiusKm, $marker, $map) {
    return function (it) {
      var tmp;
      if (!($radiusKm == null)) {
        var lngLat = $marker.getLngLat();
        var tmp_0 = lngLat.lat;
        var tmp_1 = (!(tmp_0 == null) ? typeof tmp_0 === 'number' : false) ? tmp_0 : THROW_CCE();
        var tmp_2 = lngLat.lng;
        updateRadiusCirclePosition($map, tmp_1, (!(tmp_2 == null) ? typeof tmp_2 === 'number' : false) ? tmp_2 : THROW_CCE(), $radiusKm);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function renderDiscoverMap$lambda$lambda_0($marker, $onMoveEnd) {
    return function (it) {
      var lngLat = $marker.getLngLat();
      var tmp = lngLat.lat;
      var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
      var tmp_1 = lngLat.lng;
      $onMoveEnd(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE());
      return Unit_instance;
    };
  }
  function renderDiscoverMap$lambda$lambda_1($map, $onMoveEnd) {
    return function (e) {
      var tmp;
      if ((e == null ? null : e.originalEvent) == null) {
        return Unit_instance;
      }
      var center = $map.getCenter();
      var tmp_0 = center.lat;
      var tmp_1 = (!(tmp_0 == null) ? typeof tmp_0 === 'number' : false) ? tmp_0 : THROW_CCE();
      var tmp_2 = center.lng;
      $onMoveEnd(tmp_1, (!(tmp_2 == null) ? typeof tmp_2 === 'number' : false) ? tmp_2 : THROW_CCE());
      return Unit_instance;
    };
  }
  function renderDiscoverMap$lambda($map, $showUserMarker, $radiusKm, $userLatitude, $userLongitude, $onMoveEnd) {
    return function (it) {
      addEsriRasterLayer($map);
      var tmp;
      if ($showUserMarker && !($radiusKm == null)) {
        addRadiusCircle($map, $userLatitude, $userLongitude, $radiusKm);
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($showUserMarker) {
        var marker = addMarker($map, $userLatitude, $userLongitude, '#22c55e', true);
        set_discoverUserMarker(marker);
        marker.on('drag', renderDiscoverMap$lambda$lambda($radiusKm, marker, $map));
        marker.on('dragend', renderDiscoverMap$lambda$lambda_0(marker, $onMoveEnd));
        tmp_0 = Unit_instance;
      }
      $map.on('moveend', renderDiscoverMap$lambda$lambda_1($map, $onMoveEnd));
      return Unit_instance;
    };
  }
  var properties_initialized_MapLibreMap_kt_l4qpjk;
  function _init_properties_MapLibreMap_kt__d0he9e() {
    if (!properties_initialized_MapLibreMap_kt_l4qpjk) {
      properties_initialized_MapLibreMap_kt_l4qpjk = true;
      discoverMap = null;
      discoverUserMarker = null;
      // Inline function 'kotlin.collections.mutableListOf' call
      discoverCenterMarkers = ArrayList_init_$Create$();
    }
  }
  function filterActivityOptions(container, query) {
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var needle = toString(trim(isCharSequence(query) ? query : THROW_CCE())).toLowerCase();
    var cards = container.querySelectorAll('.activity-category-card');
    var inductionVariable = 0;
    var last = cards.length;
    if (inductionVariable < last)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = cards.item(i);
        var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var card = tmp_0;
        var options = card.querySelectorAll('.activity-option');
        var anyVisible = false;
        var inductionVariable_0 = 0;
        var last_0 = options.length;
        if (inductionVariable_0 < last_0)
          $l$loop_0: do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp_1 = options.item(j);
            var tmp1_elvis_lhs = tmp_1 instanceof HTMLElement ? tmp_1 : null;
            var tmp_2;
            if (tmp1_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }
            var option = tmp_2;
            var tmp2_elvis_lhs = option.getAttribute('data-label');
            var optionLabel = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
            var tmp_3;
            // Inline function 'kotlin.text.isEmpty' call
            if (charSequenceLength(needle) === 0) {
              tmp_3 = true;
            } else {
              tmp_3 = contains(optionLabel, needle);
            }
            var matches = tmp_3;
            option.classList.toggle('hidden', !matches);
            if (matches)
              anyVisible = true;
          }
           while (inductionVariable_0 < last_0);
        card.classList.toggle('hidden', !anyVisible);
        var tmp_4;
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(needle) > 0) {
          tmp_4 = anyVisible;
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          // Inline function 'kotlin.js.asDynamic' call
          card.open = true;
        }
      }
       while (inductionVariable < last);
  }
  function selectedActivityTypes(idPrefix) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = flatten(get_activityCatalogByCategory().k2());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp = document.getElementById(idPrefix + '-' + element.s24_1);
      if ((tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).checked) {
        destination.x(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.t();
    while (_iterator__ex2g4s_0.u()) {
      var item = _iterator__ex2g4s_0.v();
      var tmp$ret$5 = valueOf(item.s24_1);
      destination_0.x(tmp$ret$5);
    }
    return toSet(destination_0);
  }
  function setActivityTypeSelection(idPrefix, selected) {
    // Inline function 'kotlin.collections.mutableSetOf' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = LinkedHashSet_init_$Create$();
    var _iterator__ex2g4s = selected.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = item.s2_1;
      destination.x(tmp$ret$2);
    }
    var selectedNames = destination;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = flatten(get_activityCatalogByCategory().k2()).t();
    while (_iterator__ex2g4s_0.u()) {
      var element = _iterator__ex2g4s_0.v();
      var tmp = document.getElementById(idPrefix + '-' + element.s24_1);
      (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).checked = selectedNames.c2(element.s24_1);
    }
  }
  function get_photoRotateMinMs() {
    _init_properties_AdCarousel_kt__ieoyyr();
    return photoRotateMinMs;
  }
  var photoRotateMinMs;
  function get_photoRotateMaxMs() {
    _init_properties_AdCarousel_kt__ieoyyr();
    return photoRotateMaxMs;
  }
  var photoRotateMaxMs;
  function set_photoPool(_set____db54di) {
    _init_properties_AdCarousel_kt__ieoyyr();
    photoPool = _set____db54di;
  }
  function get_photoPool() {
    _init_properties_AdCarousel_kt__ieoyyr();
    return photoPool;
  }
  var photoPool;
  function get_photoSlotTimeoutHandles() {
    _init_properties_AdCarousel_kt__ieoyyr();
    return photoSlotTimeoutHandles;
  }
  var photoSlotTimeoutHandles;
  function get_adDisplayStartedAt() {
    _init_properties_AdCarousel_kt__ieoyyr();
    return adDisplayStartedAt;
  }
  var adDisplayStartedAt;
  function refreshAdCarousel(photosContainerId, adsContainerId, latitude, longitude, radiusKm) {
    _init_properties_AdCarousel_kt__ieoyyr();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, refreshAdCarousel$slambda_0(latitude, longitude, radiusKm, photosContainerId, adsContainerId, null));
  }
  function renderInitialPhotoSlots(containerId) {
    _init_properties_AdCarousel_kt__ieoyyr();
    var tmp = document.getElementById(containerId);
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var container = tmp_0;
    container.innerHTML = '';
    if (get_photoPool().r())
      return Unit_instance;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = get_photoPool().z();
    var slotCount = Math.min(4, b);
    var initial = take_0(shuffled(get_photoPool()), slotCount);
    append(container, renderInitialPhotoSlots$lambda(initial));
    if (get_photoPool().z() > slotCount) {
      // Inline function 'kotlin.collections.forEach' call
      var progression = until(0, slotCount);
      var inductionVariable = progression.j1_1;
      var last = progression.k1_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slotIndex = element;
          scheduleSlotRotation(containerId, slotIndex);
        }
         while (!(element === last));
    }
  }
  function scheduleSlotRotation(containerId, slotIndex) {
    _init_properties_AdCarousel_kt__ieoyyr();
    // Inline function 'kotlin.ranges.random' call
    var this_0 = numberRangeToNumber(get_photoRotateMinMs(), get_photoRotateMaxMs());
    var delayMs = random(this_0, Default_getInstance());
    var tmp = window;
    var handle = tmp.setTimeout(scheduleSlotRotation$lambda(containerId, slotIndex), delayMs);
    get_photoSlotTimeoutHandles().x(handle);
  }
  function rotateSlot(containerId, slotIndex) {
    _init_properties_AdCarousel_kt__ieoyyr();
    if (get_photoPool().r())
      return Unit_instance;
    var tmp = document.getElementById(containerId);
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var container = tmp_0;
    var tmp_1 = container.querySelectorAll('.ad-carousel-slot').item(slotIndex);
    var tmp1_elvis_lhs = tmp_1 instanceof HTMLElement ? tmp_1 : null;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var slot = tmp_2;
    slot.innerHTML = '';
    if (Default_getInstance().ue() >= 0.75)
      return Unit_instance;
    // Inline function 'kotlin.collections.random' call
    var this_0 = get_photoPool();
    var next = random_0(this_0, Default_getInstance());
    append(slot, rotateSlot$lambda(next));
  }
  function stopPhotoRotation() {
    _init_properties_AdCarousel_kt__ieoyyr();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = get_photoSlotTimeoutHandles().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      window.clearTimeout(element);
    }
    get_photoSlotTimeoutHandles().p2();
    flushAdDisplayTimes();
  }
  function renderAds(containerId, pool) {
    _init_properties_AdCarousel_kt__ieoyyr();
    flushAdDisplayTimes();
    var tmp = document.getElementById(containerId);
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var container = tmp_0;
    container.innerHTML = '';
    if (pool.r())
      return Unit_instance;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = pool.z();
    var tmp$ret$0 = Math.min(3, b);
    var chosen = take_0(pool, tmp$ret$0);
    append(container, renderAds$lambda(chosen));
    var now = (new Date()).getTime();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = chosen.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp0_safe_receiver = element.c29_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.collections.set' call
        get_adDisplayStartedAt().m2(tmp0_safe_receiver, now);
      }
    }
    var adElements = container.querySelectorAll('[data-ad-id]');
    var inductionVariable = 0;
    var last = adElements.length;
    if (inductionVariable < last)
      $l$loop_0: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp_1 = adElements.item(i);
        var tmp1_elvis_lhs = tmp_1 instanceof HTMLElement ? tmp_1 : null;
        var tmp_2;
        if (tmp1_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_2 = tmp1_elvis_lhs;
        }
        var element_0 = tmp_2;
        var tmp2_elvis_lhs = element_0.getAttribute('data-ad-id');
        var tmp_3;
        if (tmp2_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_3 = tmp2_elvis_lhs;
        }
        var adId = tmp_3;
        element_0.addEventListener('click', renderAds$lambda_0(adId));
      }
       while (inductionVariable < last);
  }
  function recordAdClick(adId) {
    _init_properties_AdCarousel_kt__ieoyyr();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, recordAdClick$slambda_0(adId, null));
  }
  function flushAdDisplayTimes() {
    _init_properties_AdCarousel_kt__ieoyyr();
    if (get_adDisplayStartedAt().r())
      return Unit_instance;
    var now = (new Date()).getTime();
    var toFlush = toMap_0(get_adDisplayStartedAt());
    get_adDisplayStartedAt().p2();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = toFlush.l2().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      $l$block: {
        // Inline function 'kotlin.collections.component1' call
        var adId = element.e2();
        // Inline function 'kotlin.collections.component2' call
        var startedAt = element.f2();
        var durationMs = numberToLong(now - startedAt);
        if (compare(durationMs, new Long(0, 0)) <= 0) {
          break $l$block;
        }
        var tmp = get_AppScope();
        launch(tmp, VOID, VOID, flushAdDisplayTimes$slambda_0(adId, durationMs, null));
      }
    }
  }
  function sam$kotlin_Comparator$0_1(function_0) {
    this.e29_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_1).cc = function (a, b) {
    return this.e29_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
    return this.cc(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).c3 = function () {
    return this.e29_1;
  };
  protoOf(sam$kotlin_Comparator$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.c3(), other.c3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_1).hashCode = function () {
    return hashCode(this.c3());
  };
  function refreshAdCarousel$slambda$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = a.a29_1;
    var tmp$ret$2 = b.a29_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function refreshAdCarousel$slambda($latitude, $longitude, $radiusKm, $photosContainerId, $adsContainerId, resultContinuation) {
    this.n29_1 = $latitude;
    this.o29_1 = $longitude;
    this.p29_1 = $radiusKm;
    this.q29_1 = $photosContainerId;
    this.r29_1 = $adsContainerId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(refreshAdCarousel$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(refreshAdCarousel$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(refreshAdCarousel$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/discover/photos?lat=' + this.n29_1 + '&lon=' + this.o29_1 + '&radiusKm=' + this.p29_1;
            this.u29_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.u29_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DiscoverPhotoResponse), arrayOf([]), false))]), false));
            tmp_0.t29_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.t29_1 = emptyList();
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var photos = this.t29_1;
            stopPhotoRotation();
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = photos.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (!(element.b29_1 === 'ADVERTISEMENT')) {
                destination.x(element);
              }
            }

            set_photoPool(destination);
            renderInitialPhotoSlots(this.q29_1);
            var destination_0 = ArrayList_init_$Create$();
            var _iterator__ex2g4s_0 = photos.t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              if (element_0.b29_1 === 'ADVERTISEMENT') {
                destination_0.x(element_0);
              }
            }

            var tmp_3 = refreshAdCarousel$slambda$lambda;
            var adPool = sortedWith(destination_0, new sam$kotlin_Comparator$0_1(tmp_3));
            renderAds(this.r29_1, adPool);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(refreshAdCarousel$slambda).h22 = function ($this$launch, completion) {
    var i = new refreshAdCarousel$slambda(this.n29_1, this.o29_1, this.p29_1, this.q29_1, this.r29_1, completion);
    i.s29_1 = $this$launch;
    return i;
  };
  function refreshAdCarousel$slambda_0($latitude, $longitude, $radiusKm, $photosContainerId, $adsContainerId, resultContinuation) {
    var i = new refreshAdCarousel$slambda($latitude, $longitude, $radiusKm, $photosContainerId, $adsContainerId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderInitialPhotoSlots$lambda($initial) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $initial.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = 'ad-carousel-slot';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp4 = element.a29_1;
        // Inline function 'kotlinx.html.img' call
        var classes_0 = 'ad-carousel-image';
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_1 = new IMG(attributesMapOf(['alt', '', 'src', tmp4, 'loading', null == null ? null : enumEncode(null), 'class', classes_0]), this_0.j1f());
        this_1.j1f().a1h(this_1);
        this_1.j1f().b1h(this_1);
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function scheduleSlotRotation$lambda($containerId, $slotIndex) {
    return function () {
      rotateSlot($containerId, $slotIndex);
      scheduleSlotRotation($containerId, $slotIndex);
      return Unit_instance;
    };
  }
  function rotateSlot$lambda($next) {
    return function ($this$append) {
      var tmp4 = $next.a29_1;
      // Inline function 'kotlinx.html.img' call
      var classes = 'ad-carousel-image';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new IMG(attributesMapOf(['alt', '', 'src', tmp4, 'loading', null == null ? null : enumEncode(null), 'class', classes]), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function renderAds$lambda($chosen) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $chosen.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var adId = element.c29_1;
        if (!(element.d29_1 == null) && !(adId == null)) {
          // Inline function 'kotlinx.html.a' call
          var href = element.d29_1;
          // Inline function 'kotlinx.html.visitAndFinalize' call
          // Inline function 'kotlinx.html.visitTagAndFinalize' call
          var this_0 = new A(attributesMapOf(['href', href, 'target', null, 'class', null]), $this$append);
          if (!(this_0.j1f() === $this$append)) {
            throw IllegalArgumentException_init_$Create$('Wrong exception');
          }
          // Inline function 'kotlinx.html.visitTag' call
          this_0.j1f().a1h(this_0);
          // Inline function 'kotlin.collections.set' call
          this_0.l1f().m2('target', '_blank');
          var tmp0 = this_0.l1f();
          // Inline function 'kotlin.collections.set' call
          var value = 'noopener';
          tmp0.m2('rel', value);
          var tmp0_0 = this_0.l1f();
          // Inline function 'kotlin.collections.set' call
          var key = 'data-ad-id';
          tmp0_0.m2(key, adId);
          var tmp4 = element.a29_1;
          // Inline function 'kotlinx.html.img' call
          var classes = 'ad-carousel-image';
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_1 = new IMG(attributesMapOf(['alt', '', 'src', tmp4, 'loading', null == null ? null : enumEncode(null), 'class', classes]), this_0.j1f());
          this_1.j1f().a1h(this_1);
          this_1.j1f().b1h(this_1);
          this_0.j1f().b1h(this_0);
          $this$append.d1h();
        } else {
          var tmp4_0 = element.a29_1;
          // Inline function 'kotlinx.html.img' call
          var classes_0 = 'ad-carousel-image';
          // Inline function 'kotlinx.html.visitAndFinalize' call
          // Inline function 'kotlinx.html.visitTagAndFinalize' call
          var this_2 = new IMG(attributesMapOf(['alt', '', 'src', tmp4_0, 'loading', null == null ? null : enumEncode(null), 'class', classes_0]), $this$append);
          if (!(this_2.j1f() === $this$append)) {
            throw IllegalArgumentException_init_$Create$('Wrong exception');
          }
          // Inline function 'kotlinx.html.visitTag' call
          this_2.j1f().a1h(this_2);
          if (!(adId == null)) {
            var tmp0_1 = this_2.l1f();
            // Inline function 'kotlin.collections.set' call
            var key_0 = 'data-ad-id';
            tmp0_1.m2(key_0, adId);
          }
          this_2.j1f().b1h(this_2);
          $this$append.d1h();
        }
      }
      return Unit_instance;
    };
  }
  function renderAds$lambda_0($adId) {
    return function (it) {
      recordAdClick($adId);
      return Unit_instance;
    };
  }
  function recordAdClick$slambda($adId, resultContinuation) {
    this.d2a_1 = $adId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(recordAdClick$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(recordAdClick$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(recordAdClick$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = ApiClient_getInstance().g27('POST', '/api/v1/bitacora/discover/ads/' + this.d2a_1 + '/click', null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f2a_1 = suspendResult;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof Error) {
              var e = this.w7_1;
              var tmp_1 = this;
              tmp_1.f2a_1 = Unit_instance;
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(recordAdClick$slambda).h22 = function ($this$launch, completion) {
    var i = new recordAdClick$slambda(this.d2a_1, completion);
    i.e2a_1 = $this$launch;
    return i;
  };
  function recordAdClick$slambda_0($adId, resultContinuation) {
    var i = new recordAdClick$slambda($adId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function flushAdDisplayTimes$slambda($adId, $durationMs, resultContinuation) {
    this.o2a_1 = $adId;
    this.p2a_1 = $durationMs;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flushAdDisplayTimes$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(flushAdDisplayTimes$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flushAdDisplayTimes$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/discover/ads/' + this.o2a_1 + '/display-time';
            var body = new RecordAdDisplayTimeRequest(this.p2a_1);
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(RecordAdDisplayTimeRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof Error) {
              var e = this.w7_1;
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(flushAdDisplayTimes$slambda).h22 = function ($this$launch, completion) {
    var i = new flushAdDisplayTimes$slambda(this.o2a_1, this.p2a_1, completion);
    i.q2a_1 = $this$launch;
    return i;
  };
  function flushAdDisplayTimes$slambda_0($adId, $durationMs, resultContinuation) {
    var i = new flushAdDisplayTimes$slambda($adId, $durationMs, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  var properties_initialized_AdCarousel_kt_s1yttx;
  function _init_properties_AdCarousel_kt__ieoyyr() {
    if (!properties_initialized_AdCarousel_kt_s1yttx) {
      properties_initialized_AdCarousel_kt_s1yttx = true;
      photoRotateMinMs = 5000;
      photoRotateMaxMs = 20000;
      photoPool = emptyList();
      // Inline function 'kotlin.collections.mutableListOf' call
      photoSlotTimeoutHandles = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.mutableMapOf' call
      adDisplayStartedAt = LinkedHashMap_init_$Create$();
    }
  }
  function requestConfirmation(dialogId, message, onConfirm) {
    var tmp = document.getElementById(dialogId);
    var dialogEl = tmp instanceof HTMLDialogElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById(dialogId + '-message');
    (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).textContent = message;
    var tmp_1 = document.getElementById(dialogId + '-confirm');
    var confirmBtn = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    // Inline function 'kotlin.js.asDynamic' call
    confirmBtn.onclick = requestConfirmation$lambda(dialogEl, onConfirm);
    var tmp_2 = document.getElementById(dialogId + '-cancel');
    var cancelBtn = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
    // Inline function 'kotlin.js.asDynamic' call
    cancelBtn.onclick = requestConfirmation$lambda_0(dialogEl);
    dialogEl.showModal();
  }
  function requestConfirmation$lambda($dialogEl, $onConfirm) {
    return function () {
      $dialogEl.close();
      $onConfirm();
      return Unit_instance;
    };
  }
  function requestConfirmation$lambda_0($dialogEl) {
    return function () {
      $dialogEl.close();
      return Unit_instance;
    };
  }
  function get_uiIconMarkup() {
    _init_properties_Icons_kt__93b06g();
    return uiIconMarkup;
  }
  var uiIconMarkup;
  function renderUiIcon(_this__u8e3s4, name) {
    _init_properties_Icons_kt__93b06g();
    var tmp0 = _this__u8e3s4.l1f();
    // Inline function 'kotlin.collections.set' call
    var value = '0 0 24 24';
    tmp0.m2('viewBox', value);
    // Inline function 'kotlin.collections.set' call
    _this__u8e3s4.l1f().m2('fill', 'none');
    var tmp0_0 = _this__u8e3s4.l1f();
    // Inline function 'kotlin.collections.set' call
    var value_0 = 'currentColor';
    tmp0_0.m2('stroke', value_0);
    var tmp0_1 = _this__u8e3s4.l1f();
    // Inline function 'kotlin.collections.set' call
    var key = 'stroke-width';
    tmp0_1.m2(key, '1.8');
    var tmp0_2 = _this__u8e3s4.l1f();
    // Inline function 'kotlin.collections.set' call
    var key_0 = 'stroke-linecap';
    tmp0_2.m2(key_0, 'round');
    var tmp0_3 = _this__u8e3s4.l1f();
    // Inline function 'kotlin.collections.set' call
    var key_1 = 'stroke-linejoin';
    tmp0_3.m2(key_1, 'round');
    unsafe(_this__u8e3s4, renderUiIcon$lambda(name));
  }
  function uiIcon(_this__u8e3s4, name, classes) {
    classes = classes === VOID ? 'ui-icon' : classes;
    _init_properties_Icons_kt__93b06g();
    // Inline function 'kotlinx.html.svg' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new SVG(attributesMapOf_0('class', classes), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    renderUiIcon(this_0, name);
    this_0.j1f().b1h(this_0);
  }
  function uiIcon_0(_this__u8e3s4, name, classes) {
    classes = classes === VOID ? 'ui-icon' : classes;
    _init_properties_Icons_kt__93b06g();
    // Inline function 'kotlinx.html.svg' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new SVG(attributesMapOf_0('class', classes), _this__u8e3s4);
    if (!(this_0.j1f() === _this__u8e3s4)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    renderUiIcon(this_0, name);
    this_0.j1f().b1h(this_0);
    return _this__u8e3s4.d1h();
  }
  function renderUiIcon$lambda($name) {
    return function ($this$unsafe) {
      $this$unsafe.q1f(getValue(get_uiIconMarkup(), $name));
      return Unit_instance;
    };
  }
  var properties_initialized_Icons_kt_9ljgxi;
  function _init_properties_Icons_kt__93b06g() {
    if (!properties_initialized_Icons_kt_9ljgxi) {
      properties_initialized_Icons_kt_9ljgxi = true;
      uiIconMarkup = mapOf([to('edit', '<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/>'), to('delete', '<path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/>'), to('settings', '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>'), to('mail', '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 6l10 7 10-7"/>'), to('person', '<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/>'), to('logout', '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="M16 17l5-5-5-5"/><line x1="21" y1="12" x2="9" y2="12"/>'), to('book', '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>'), to('graduation-cap', '<path d="M2 9l10-5 10 5-10 5-10-5z"/><path d="M6 11v5c0 1.5 3 3 6 3s6-1.5 6-3v-5"/><line x1="22" y1="9" x2="22" y2="15"/>'), to('bank', '<line x1="3" y1="21" x2="21" y2="21"/><path d="M4 21V10M9 21V10M15 21V10M20 21V10"/><path d="M2 10l10-6 10 6z"/>'), to('users', '<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c0-3.5 3-5.5 6.5-5.5s6.5 2 6.5 5.5"/><circle cx="18" cy="9" r="2.7"/><path d="M15.5 14.2c2.5.4 4 2.1 4 5.8"/>'), to('building', '<rect x="4" y="3" width="10" height="18" rx="1"/><rect x="14" y="9" width="6" height="12" rx="1"/><line x1="7" y1="7" x2="7" y2="7.01"/><line x1="11" y1="7" x2="11" y2="7.01"/><line x1="7" y1="11" x2="7" y2="11.01"/><line x1="11" y1="11" x2="11" y2="11.01"/><line x1="7" y1="15" x2="7" y2="15.01"/><line x1="11" y1="15" x2="11" y2="15.01"/>'), to('medal', '<circle cx="12" cy="15" r="6"/><path d="M9.5 10.5L7 3h2l3 6.5L15 3h2l-2.5 7.5"/>'), to('trophy', '<path d="M8 21h8"/><path d="M12 17v4"/><path d="M7 4h10v6a5 5 0 0 1-10 0z"/><path d="M7 5H4a1 1 0 0 0-1 1c0 3 2 5 4.5 5.3"/><path d="M17 5h3a1 1 0 0 1 1 1c0 3-2 5-4.5 5.3"/>'), to('megaphone', '<path d="M3 11v2a2 2 0 0 0 2 2h1l3 6h2l-1-6h4l6 4V5l-6 4H6a2 2 0 0 0-2 2z"/>'), to('check', '<path d="M20 6L9 17l-5-5"/>'), to('inbox', '<path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>'), to('outbox', '<path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/><line x1="12" y1="3" x2="12" y2="13"/><path d="M9 6l3-3 3 3"/>'), to('eye', '<path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/>'), to('eye-off', '<path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.5 18.5 0 0 1 5.06-5.94"/><path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/>'), to('search', '<circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>'), to('dollar-sign', '<line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5.5a4 4 0 0 0-4-2.5H10a3.5 3.5 0 0 0 0 7h4a3.5 3.5 0 0 1 0 7h-3a4 4 0 0 1-4-2.5"/>')]);
    }
  }
  var locationSearchTimeoutHandle;
  function fieldId(idPrefix, name) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(idPrefix) === 0) {
      tmp = name;
    } else {
      tmp = idPrefix + '-' + name;
    }
    return tmp;
  }
  function locationSearchPicker(_this__u8e3s4, idPrefix) {
    // Inline function 'kotlinx.html.label' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new LABEL(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'location.searchLabel';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('location.searchLabel'));
    // Inline function 'kotlinx.html.textInput' call
    var tmp = InputType_text_getInstance().q1i_1;
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new INPUT(attributesMapOf(['type', tmp, 'formenctype', tmp_0, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_0.j1f());
    this_1.j1f().a1h(this_1);
    set_id(this_1, fieldId(idPrefix, 'locationSearch'));
    set_onInputFunction(this_1, locationSearchPicker$lambda(idPrefix));
    set_onKeyDownFunction(this_1, locationSearchPicker$lambda_0(idPrefix));
    this_1.j1f().b1h(this_1);
    this_0.j1f().b1h(this_0);
    // Inline function 'kotlinx.html.ul' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new UL(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
    this_2.j1f().a1h(this_2);
    set_id(this_2, fieldId(idPrefix, 'locationSuggestions'));
    this_2.j1f().b1h(this_2);
    // Inline function 'kotlinx.html.input' call
    var tmp0_safe_receiver = InputType_hidden_getInstance();
    var tmp_1 = tmp0_safe_receiver == null ? null : enumEncode(tmp0_safe_receiver);
    var tmp_2 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new INPUT(attributesMapOf(['type', tmp_1, 'formenctype', tmp_2, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), _this__u8e3s4.j1f());
    this_3.j1f().a1h(this_3);
    set_id(this_3, fieldId(idPrefix, 'latitude'));
    this_3.j1f().b1h(this_3);
    // Inline function 'kotlinx.html.input' call
    var tmp0_safe_receiver_0 = InputType_hidden_getInstance();
    var tmp_3 = tmp0_safe_receiver_0 == null ? null : enumEncode(tmp0_safe_receiver_0);
    var tmp_4 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_4 = new INPUT(attributesMapOf(['type', tmp_3, 'formenctype', tmp_4, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), _this__u8e3s4.j1f());
    this_4.j1f().a1h(this_4);
    set_id(this_4, fieldId(idPrefix, 'longitude'));
    this_4.j1f().b1h(this_4);
    // Inline function 'kotlinx.html.input' call
    var tmp0_safe_receiver_1 = InputType_hidden_getInstance();
    var tmp_5 = tmp0_safe_receiver_1 == null ? null : enumEncode(tmp0_safe_receiver_1);
    var tmp_6 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_5 = new INPUT(attributesMapOf(['type', tmp_5, 'formenctype', tmp_6, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), _this__u8e3s4.j1f());
    this_5.j1f().a1h(this_5);
    set_id(this_5, fieldId(idPrefix, 'locationLabel'));
    this_5.j1f().b1h(this_5);
    // Inline function 'kotlinx.html.button' call
    var tmp_7 = null == null ? null : enumEncode(null);
    var tmp_8 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_6 = new BUTTON(attributesMapOf(['formenctype', tmp_7, 'formmethod', tmp_8, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), _this__u8e3s4.j1f());
    this_6.j1f().a1h(this_6);
    this_6.z1j(ButtonType_button_getInstance());
    set_id(this_6, fieldId(idPrefix, 'useMyLocationButton'));
    var tmp0_0 = this_6.l1f();
    var tmp2_0 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value_0 = 'location.useMyLocationButton';
    tmp0_0.m2(tmp2_0, value_0);
    this_6.n1f(I18n_getInstance().e28('location.useMyLocationButton'));
    set_onClickFunction(this_6, locationSearchPicker$lambda_1(idPrefix));
    this_6.j1f().b1h(this_6);
    // Inline function 'kotlinx.html.div' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_7 = new DIV(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
    this_7.j1f().a1h(this_7);
    set_id(this_7, fieldId(idPrefix, 'locationStatus'));
    this_7.j1f().b1h(this_7);
    // Inline function 'kotlinx.html.div' call
    var classes = 'map-container hidden';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_8 = new DIV(attributesMapOf_0('class', classes), _this__u8e3s4.j1f());
    this_8.j1f().a1h(this_8);
    set_id(this_8, fieldId(idPrefix, 'locationMap'));
    this_8.j1f().b1h(this_8);
  }
  function showLocationOnMap(idPrefix, latitude, longitude, label) {
    confirmLocation(idPrefix, latitude, longitude, label);
  }
  function wireLocationSearchPicker(idPrefix) {
    var tmp = document.getElementById(fieldId(idPrefix, 'locationSearch'));
    var searchInput = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
    searchInput.addEventListener('input', wireLocationSearchPicker$lambda(idPrefix));
    searchInput.addEventListener('keydown', wireLocationSearchPicker$lambda_0(idPrefix));
    var tmp0_safe_receiver = document.getElementById(fieldId(idPrefix, 'useMyLocationButton'));
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.addEventListener('click', wireLocationSearchPicker$lambda_1(idPrefix));
    }
  }
  function useMyLocation(idPrefix) {
    var tmp = document.getElementById(fieldId(idPrefix, 'locationStatus'));
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    // Inline function 'kotlin.js.asDynamic' call
    var geolocation = window.navigator.geolocation;
    if (geolocation == undefined) {
      status.textContent = I18n_getInstance().e28('location.geolocationNotSupported');
      return Unit_instance;
    }
    status.textContent = I18n_getInstance().e28('location.locating');
    var tmp_0 = useMyLocation$lambda(idPrefix, status);
    geolocation.getCurrentPosition(tmp_0, useMyLocation$lambda_0(status));
  }
  function onLocationSearchInput(idPrefix) {
    var tmp0_safe_receiver = locationSearchTimeoutHandle;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      window.clearTimeout(tmp0_safe_receiver);
    }
    var tmp = document.getElementById(fieldId(idPrefix, 'locationSearch'));
    var query = (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value;
    if (isBlank(query)) {
      var tmp_0 = document.getElementById(fieldId(idPrefix, 'locationSuggestions'));
      (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).innerHTML = '';
      return Unit_instance;
    }
    var tmp_1 = window;
    locationSearchTimeoutHandle = tmp_1.setTimeout(onLocationSearchInput$lambda(idPrefix, query), 300);
  }
  function onLocationSearchKeyDown(idPrefix, event) {
    var tmp0_elvis_lhs = event instanceof KeyboardEvent ? event : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var keyboardEvent = tmp;
    if (!(keyboardEvent.key === 'Enter'))
      return Unit_instance;
    event.preventDefault();
    var tmp_0 = document.getElementById(fieldId(idPrefix, 'locationSuggestions'));
    var suggestions = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    var tmp_1 = suggestions.firstElementChild;
    var topSuggestion = tmp_1 instanceof HTMLElement ? tmp_1 : null;
    if (!(topSuggestion == null)) {
      topSuggestion.click();
      return Unit_instance;
    }
    var tmp_2 = document.getElementById(fieldId(idPrefix, 'locationSearch'));
    var query = (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value;
    if (isBlank(query))
      return Unit_instance;
    var tmp1_safe_receiver = locationSearchTimeoutHandle;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      window.clearTimeout(tmp1_safe_receiver);
    }
    runLocationSearch(idPrefix, query, true);
  }
  function runLocationSearch(idPrefix, query, confirmTopResult) {
    confirmTopResult = confirmTopResult === VOID ? false : confirmTopResult;
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, runLocationSearch$slambda_0(query, idPrefix, confirmTopResult, null));
  }
  function renderLocationSuggestions(idPrefix, results) {
    var tmp = document.getElementById(fieldId(idPrefix, 'locationSuggestions'));
    var container = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    container.innerHTML = '';
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = results.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var item = document.createElement('li');
      item.textContent = element.r2a_1;
      item.addEventListener('click', renderLocationSuggestions$lambda(idPrefix, element, container));
      container.appendChild(item);
    }
  }
  function updateLocationFields(idPrefix, latitude, longitude, label) {
    label = label === VOID ? null : label;
    var tmp = document.getElementById(fieldId(idPrefix, 'latitude'));
    (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value = latitude.toString();
    var tmp_0 = document.getElementById(fieldId(idPrefix, 'longitude'));
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = longitude.toString();
    if (label == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_1 = document.getElementById(fieldId(idPrefix, 'locationLabel'));
      (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value = label;
      var tmp_2 = document.getElementById(fieldId(idPrefix, 'locationSearch'));
      (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value = label;
    }
  }
  function confirmLocation(idPrefix, latitude, longitude, label) {
    updateLocationFields(idPrefix, latitude, longitude, label);
    var tmp = document.getElementById(fieldId(idPrefix, 'locationMap'));
    var mapContainer = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    mapContainer.classList.remove('hidden');
    var tmp_0 = fieldId(idPrefix, 'locationMap');
    renderLocationConfirmMap(tmp_0, latitude, longitude, confirmLocation$lambda(idPrefix));
  }
  function onMapPositionChanged(idPrefix, latitude, longitude) {
    updateLocationFields(idPrefix, latitude, longitude, formatCoordinates(latitude, longitude));
    resolveLocationLabel(idPrefix, latitude, longitude);
  }
  function resolveLocationLabel(idPrefix, latitude, longitude) {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, resolveLocationLabel$slambda_0(latitude, longitude, idPrefix, null));
  }
  function formatCoordinates(latitude, longitude) {
    var lat = round(latitude * 100000) / 100000;
    var lon = round(longitude * 100000) / 100000;
    return '' + lat + ', ' + lon;
  }
  function locationSearchPicker$lambda($idPrefix) {
    return function (it) {
      onLocationSearchInput($idPrefix);
      return Unit_instance;
    };
  }
  function locationSearchPicker$lambda_0($idPrefix) {
    return function (it) {
      onLocationSearchKeyDown($idPrefix, it);
      return Unit_instance;
    };
  }
  function locationSearchPicker$lambda_1($idPrefix) {
    return function (it) {
      useMyLocation($idPrefix);
      return Unit_instance;
    };
  }
  function wireLocationSearchPicker$lambda($idPrefix) {
    return function (it) {
      onLocationSearchInput($idPrefix);
      return Unit_instance;
    };
  }
  function wireLocationSearchPicker$lambda_0($idPrefix) {
    return function (event) {
      onLocationSearchKeyDown($idPrefix, event);
      return Unit_instance;
    };
  }
  function wireLocationSearchPicker$lambda_1($idPrefix) {
    return function (it) {
      useMyLocation($idPrefix);
      return Unit_instance;
    };
  }
  function useMyLocation$lambda($idPrefix, $status) {
    return function (position) {
      var tmp = position.coords.latitude;
      var latitude = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
      var tmp_0 = position.coords.longitude;
      var longitude = (!(tmp_0 == null) ? typeof tmp_0 === 'number' : false) ? tmp_0 : THROW_CCE();
      confirmLocation($idPrefix, latitude, longitude, formatCoordinates(latitude, longitude));
      $status.textContent = I18n_getInstance().e28('location.locationCaptured');
      resolveLocationLabel($idPrefix, latitude, longitude);
      return Unit_instance;
    };
  }
  function useMyLocation$lambda_0($status) {
    return function (_unused_var__etf5q3) {
      $status.textContent = I18n_getInstance().e28('location.locationError');
      return Unit_instance;
    };
  }
  function onLocationSearchInput$lambda($idPrefix, $query) {
    return function () {
      runLocationSearch($idPrefix, $query);
      return Unit_instance;
    };
  }
  function runLocationSearch$slambda($query, $idPrefix, $confirmTopResult, resultContinuation) {
    this.c2b_1 = $query;
    this.d2b_1 = $idPrefix;
    this.e2b_1 = $confirmTopResult;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(runLocationSearch$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(runLocationSearch$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(runLocationSearch$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/geocode/search?q=' + encodeURIComponent(this.c2b_1);
            this.h2b_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.h2b_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(GeocodeResultResponse), arrayOf([]), false))]), false));
            tmp_0.g2b_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.g2b_1 = emptyList();
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var results = this.g2b_1;
            renderLocationSuggestions(this.d2b_1, results);
            if (this.e2b_1) {
              var tmp_3 = document.getElementById(fieldId(this.d2b_1, 'locationSuggestions'));
              var suggestions = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
              var tmp_4 = suggestions.firstElementChild;
              var tmp0_safe_receiver = tmp_4 instanceof HTMLElement ? tmp_4 : null;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.click();
              }
            }

            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(runLocationSearch$slambda).h22 = function ($this$launch, completion) {
    var i = new runLocationSearch$slambda(this.c2b_1, this.d2b_1, this.e2b_1, completion);
    i.f2b_1 = $this$launch;
    return i;
  };
  function runLocationSearch$slambda_0($query, $idPrefix, $confirmTopResult, resultContinuation) {
    var i = new runLocationSearch$slambda($query, $idPrefix, $confirmTopResult, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderLocationSuggestions$lambda($idPrefix, $result, $container) {
    return function (it) {
      confirmLocation($idPrefix, $result.s2a_1, $result.t2a_1, $result.r2a_1);
      $container.innerHTML = '';
      return Unit_instance;
    };
  }
  function confirmLocation$lambda($idPrefix) {
    return function (lat, lon) {
      onMapPositionChanged($idPrefix, lat, lon);
      return Unit_instance;
    };
  }
  function resolveLocationLabel$slambda($latitude, $longitude, $idPrefix, resultContinuation) {
    this.q2b_1 = $latitude;
    this.r2b_1 = $longitude;
    this.s2b_1 = $idPrefix;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(resolveLocationLabel$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(resolveLocationLabel$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(resolveLocationLabel$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/geocode/reverse?lat=' + this.q2b_1 + '&lon=' + this.r2b_1;
            this.v2b_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.v2b_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(GeocodeResultResponse), arrayOf([]), false));
            tmp_0.u2b_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.u2b_1 = null;
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            var result = this.u2b_1;
            if (result == null)
              null;
            else {
              updateLocationFields(this.s2b_1, this.q2b_1, this.r2b_1, result.r2a_1);
            }

            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(resolveLocationLabel$slambda).h22 = function ($this$launch, completion) {
    var i = new resolveLocationLabel$slambda(this.q2b_1, this.r2b_1, this.s2b_1, completion);
    i.t2b_1 = $this$launch;
    return i;
  };
  function resolveLocationLabel$slambda_0($latitude, $longitude, $idPrefix, resultContinuation) {
    var i = new resolveLocationLabel$slambda($latitude, $longitude, $idPrefix, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function pagination(_this__u8e3s4, idPrefix, currentPage, totalCount, pageSize, onNavigate) {
    // Inline function 'kotlin.math.ceil' call
    var x = totalCount / pageSize;
    var tmp$ret$0 = Math.ceil(x);
    var totalPages = coerceAtLeast(numberToInt(tmp$ret$0), 1);
    // Inline function 'kotlinx.html.div' call
    var classes = 'pagination';
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new DIV(attributesMapOf_0('class', classes), _this__u8e3s4);
    if (!(this_0.j1f() === _this__u8e3s4)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    // Inline function 'kotlinx.html.button' call
    var classes_0 = 'pagination-nav';
    var tmp = null == null ? null : enumEncode(null);
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_0]), this_0.j1f());
    this_1.j1f().a1h(this_1);
    set_id(this_1, idPrefix + 'PrevPage');
    this_1.z1j(ButtonType_button_getInstance());
    this_1.y1j(currentPage <= 1);
    var tmp0 = this_1.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'pagination.previous';
    tmp0.m2(tmp2, value);
    this_1.n1f(I18n_getInstance().e28('pagination.previous'));
    set_onClickFunction(this_1, pagination$lambda(onNavigate));
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.span' call
    var classes_1 = 'pagination-label';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new SPAN(attributesMapOf_0('class', classes_1), this_0.j1f());
    this_2.j1f().a1h(this_2);
    this_2.n1f(I18n_getInstance().e28('pagination.pagePrefix') + currentPage + I18n_getInstance().e28('pagination.pageMiddle') + totalPages + I18n_getInstance().e28('pagination.pageSuffix'));
    this_2.j1f().b1h(this_2);
    // Inline function 'kotlinx.html.button' call
    var classes_2 = 'pagination-nav';
    var tmp_1 = null == null ? null : enumEncode(null);
    var tmp_2 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new BUTTON(attributesMapOf(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_2]), this_0.j1f());
    this_3.j1f().a1h(this_3);
    set_id(this_3, idPrefix + 'NextPage');
    this_3.z1j(ButtonType_button_getInstance());
    this_3.y1j(currentPage >= totalPages);
    var tmp0_0 = this_3.l1f();
    var tmp2_0 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value_0 = 'pagination.next';
    tmp0_0.m2(tmp2_0, value_0);
    this_3.n1f(I18n_getInstance().e28('pagination.next'));
    set_onClickFunction(this_3, pagination$lambda_0(onNavigate));
    this_3.j1f().b1h(this_3);
    this_0.j1f().b1h(this_0);
    _this__u8e3s4.d1h();
  }
  function pagination$lambda($onNavigate) {
    return function (it) {
      $onNavigate(-1);
      return Unit_instance;
    };
  }
  function pagination$lambda_0($onNavigate) {
    return function (it) {
      $onNavigate(1);
      return Unit_instance;
    };
  }
  function upsellBanner(_this__u8e3s4, messageKey, bannerId, tier) {
    tier = tier === VOID ? 'ARCHIVE' : tier;
    var statusId = bannerId + '-status';
    // Inline function 'kotlinx.html.span' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new SPAN(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    set_id(this_0, bannerId + '-wrapper');
    // Inline function 'kotlinx.html.p' call
    var classes = 'upsell-banner';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new P(attributesMapOf_0('class', classes), this_0.j1f());
    this_1.j1f().a1h(this_1);
    var tmp0 = this_1.l1f();
    // Inline function 'kotlin.collections.set' call
    var key = 'data-i18n';
    tmp0.m2(key, messageKey);
    this_1.n1f(I18n_getInstance().e28(messageKey));
    // Inline function 'kotlinx.html.button' call
    var tmp = null == null ? null : enumEncode(null);
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
    this_2.j1f().a1h(this_2);
    set_id(this_2, bannerId + '-cta');
    this_2.z1j(ButtonType_button_getInstance());
    var tmp0_0 = this_2.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'upsell.cta';
    tmp0_0.m2(tmp2, value);
    this_2.n1f(I18n_getInstance().e28('upsell.cta'));
    set_onClickFunction(this_2, upsellBanner$lambda(tier, statusId));
    this_2.j1f().b1h(this_2);
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.span' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new SPAN(attributesMapOf_0('class', null), this_0.j1f());
    this_3.j1f().a1h(this_3);
    set_id(this_3, statusId);
    this_3.j1f().b1h(this_3);
    this_0.j1f().b1h(this_0);
  }
  function startUpsellCheckout(tier, statusId) {
    var tmp = document.getElementById(statusId);
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var status = tmp_0;
    status.textContent = '';
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, startUpsellCheckout$slambda_0(tier, status, null));
  }
  function upsellBanner$lambda($tier, $statusId) {
    return function (it) {
      startUpsellCheckout($tier, $statusId);
      return Unit_instance;
    };
  }
  function startUpsellCheckout$slambda($tier, $status, resultContinuation) {
    this.e2c_1 = $tier;
    this.f2c_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(startUpsellCheckout$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(startUpsellCheckout$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(startUpsellCheckout$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var here = window.location.href;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/finance/subscriptions/checkout';
            var body = new StartSubscriptionCheckoutRequest(this.e2c_1, here, here);
            this.h2c_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(StartSubscriptionCheckoutRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.h2c_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(CheckoutSessionUrlResponse), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            window.location.href = result.i2c_1;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              this.f2c_1.textContent = e.k2c_1;
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                this.f2c_1.textContent = I18n_getInstance().e28('upsell.errorPrefix') + e_0.message;
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(startUpsellCheckout$slambda).h22 = function ($this$launch, completion) {
    var i = new startUpsellCheckout$slambda(this.e2c_1, this.f2c_1, completion);
    i.g2c_1 = $this$launch;
    return i;
  };
  function startUpsellCheckout$slambda_0($tier, $status, resultContinuation) {
    var i = new startUpsellCheckout$slambda($tier, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function showError(_this__u8e3s4, message) {
    _this__u8e3s4.textContent = message;
    _this__u8e3s4.classList.add('status-error');
  }
  function clearStatus(_this__u8e3s4) {
    _this__u8e3s4.textContent = '';
    _this__u8e3s4.classList.remove('status-error');
  }
  function urlParam(key) {
    return (new URLSearchParams(window.location.search)).get(key);
  }
  function ErrorResponse$Companion$$childSerializers$_anonymous__w0ascf() {
    return new LinkedHashMapSerializer(StringSerializer_getInstance(), IntSerializer_getInstance());
  }
  function Companion_1() {
    Companion_instance_2 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m2c_1 = [null, lazy(tmp_0, ErrorResponse$Companion$$childSerializers$_anonymous__w0ascf)];
  }
  var Companion_instance_2;
  function Companion_getInstance_1() {
    if (Companion_instance_2 == null)
      new Companion_1();
    return Companion_instance_2;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.ErrorResponse', this, 2);
    tmp0_serialDesc.tt('error', true);
    tmp0_serialDesc.tt('removedTypeCounts', true);
    this.n2c_1 = tmp0_serialDesc;
  }
  protoOf($serializer).o2c = function (encoder, value) {
    var tmp0_desc = this.n2c_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_1().m2c_1;
    if (tmp1_output.co(tmp0_desc, 0) ? true : !(value.p2c_1 == null)) {
      tmp1_output.yn(tmp0_desc, 0, StringSerializer_getInstance(), value.p2c_1);
    }
    if (tmp1_output.co(tmp0_desc, 1) ? true : !(value.q2c_1 == null)) {
      tmp1_output.yn(tmp0_desc, 1, tmp2_cached[1].f2(), value.q2c_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer).fj = function (encoder, value) {
    return this.o2c(encoder, value instanceof ErrorResponse ? value : THROW_CCE());
  };
  protoOf($serializer).gj = function (decoder) {
    var tmp0_desc = this.n2c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    var tmp7_cached = Companion_getInstance_1().m2c_1;
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.tm(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.tm(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return ErrorResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer).ej = function () {
    return this.n2c_1;
  };
  protoOf($serializer).iu = function () {
    var tmp0_cached = Companion_getInstance_1().m2c_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[1].f2())];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function ErrorResponse_init_$Init$(seen0, error, removedTypeCounts, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance().n2c_1);
    }
    if (0 === (seen0 & 1))
      $this.p2c_1 = null;
    else
      $this.p2c_1 = error;
    if (0 === (seen0 & 2))
      $this.q2c_1 = null;
    else
      $this.q2c_1 = removedTypeCounts;
    return $this;
  }
  function ErrorResponse_init_$Create$(seen0, error, removedTypeCounts, serializationConstructorMarker) {
    return ErrorResponse_init_$Init$(seen0, error, removedTypeCounts, serializationConstructorMarker, objectCreate(protoOf(ErrorResponse)));
  }
  function ErrorResponse(error, removedTypeCounts) {
    Companion_getInstance_1();
    error = error === VOID ? null : error;
    removedTypeCounts = removedTypeCounts === VOID ? null : removedTypeCounts;
    this.p2c_1 = error;
    this.q2c_1 = removedTypeCounts;
  }
  protoOf(ErrorResponse).toString = function () {
    return 'ErrorResponse(error=' + this.p2c_1 + ', removedTypeCounts=' + toString_0(this.q2c_1) + ')';
  };
  protoOf(ErrorResponse).hashCode = function () {
    var result = this.p2c_1 == null ? 0 : getStringHashCode(this.p2c_1);
    result = imul(result, 31) + (this.q2c_1 == null ? 0 : hashCode(this.q2c_1)) | 0;
    return result;
  };
  protoOf(ErrorResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ErrorResponse))
      return false;
    if (!(this.p2c_1 == other.p2c_1))
      return false;
    if (!equals(this.q2c_1, other.q2c_1))
      return false;
    return true;
  };
  function Companion_2() {
  }
  var Companion_instance_3;
  function Companion_getInstance_2() {
    return Companion_instance_3;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.TokenResponse', this, 3);
    tmp0_serialDesc.tt('accessToken', false);
    tmp0_serialDesc.tt('refreshToken', false);
    tmp0_serialDesc.tt('expiresInSeconds', false);
    this.r2c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).s2c = function (encoder, value) {
    var tmp0_desc = this.r2c_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.t2c_1);
    tmp1_output.un(tmp0_desc, 1, value.u2c_1);
    tmp1_output.qn(tmp0_desc, 2, value.v2c_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_0).fj = function (encoder, value) {
    return this.s2c(encoder, value instanceof TokenResponse ? value : THROW_CCE());
  };
  protoOf($serializer_0).gj = function (decoder) {
    var tmp0_desc = this.r2c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return TokenResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_0).ej = function () {
    return this.r2c_1;
  };
  protoOf($serializer_0).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function TokenResponse_init_$Init$(seen0, accessToken, refreshToken, expiresInSeconds, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_0().r2c_1);
    }
    $this.t2c_1 = accessToken;
    $this.u2c_1 = refreshToken;
    $this.v2c_1 = expiresInSeconds;
    return $this;
  }
  function TokenResponse_init_$Create$(seen0, accessToken, refreshToken, expiresInSeconds, serializationConstructorMarker) {
    return TokenResponse_init_$Init$(seen0, accessToken, refreshToken, expiresInSeconds, serializationConstructorMarker, objectCreate(protoOf(TokenResponse)));
  }
  function TokenResponse(accessToken, refreshToken, expiresInSeconds) {
    this.t2c_1 = accessToken;
    this.u2c_1 = refreshToken;
    this.v2c_1 = expiresInSeconds;
  }
  protoOf(TokenResponse).toString = function () {
    return 'TokenResponse(accessToken=' + this.t2c_1 + ', refreshToken=' + this.u2c_1 + ', expiresInSeconds=' + this.v2c_1.toString() + ')';
  };
  protoOf(TokenResponse).hashCode = function () {
    var result = getStringHashCode(this.t2c_1);
    result = imul(result, 31) + getStringHashCode(this.u2c_1) | 0;
    result = imul(result, 31) + this.v2c_1.hashCode() | 0;
    return result;
  };
  protoOf(TokenResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TokenResponse))
      return false;
    if (!(this.t2c_1 === other.t2c_1))
      return false;
    if (!(this.u2c_1 === other.u2c_1))
      return false;
    if (!equalsLong(this.v2c_1, other.v2c_1))
      return false;
    return true;
  };
  function Companion_3() {
  }
  var Companion_instance_4;
  function Companion_getInstance_3() {
    return Companion_instance_4;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.LoginRequest', this, 3);
    tmp0_serialDesc.tt('email', false);
    tmp0_serialDesc.tt('password', false);
    tmp0_serialDesc.tt('deviceInfo', true);
    this.w2c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).x2c = function (encoder, value) {
    var tmp0_desc = this.w2c_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.y2c_1);
    tmp1_output.un(tmp0_desc, 1, value.z2c_1);
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.a2d_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.a2d_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_1).fj = function (encoder, value) {
    return this.x2c(encoder, value instanceof LoginRequest ? value : THROW_CCE());
  };
  protoOf($serializer_1).gj = function (decoder) {
    var tmp0_desc = this.w2c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return LoginRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_1).ej = function () {
    return this.w2c_1;
  };
  protoOf($serializer_1).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function LoginRequest_init_$Init$(seen0, email, password, deviceInfo, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_1().w2c_1);
    }
    $this.y2c_1 = email;
    $this.z2c_1 = password;
    if (0 === (seen0 & 4))
      $this.a2d_1 = null;
    else
      $this.a2d_1 = deviceInfo;
    return $this;
  }
  function LoginRequest_init_$Create$(seen0, email, password, deviceInfo, serializationConstructorMarker) {
    return LoginRequest_init_$Init$(seen0, email, password, deviceInfo, serializationConstructorMarker, objectCreate(protoOf(LoginRequest)));
  }
  function LoginRequest(email, password, deviceInfo) {
    deviceInfo = deviceInfo === VOID ? null : deviceInfo;
    this.y2c_1 = email;
    this.z2c_1 = password;
    this.a2d_1 = deviceInfo;
  }
  protoOf(LoginRequest).toString = function () {
    return 'LoginRequest(email=' + this.y2c_1 + ', password=' + this.z2c_1 + ', deviceInfo=' + this.a2d_1 + ')';
  };
  protoOf(LoginRequest).hashCode = function () {
    var result = getStringHashCode(this.y2c_1);
    result = imul(result, 31) + getStringHashCode(this.z2c_1) | 0;
    result = imul(result, 31) + (this.a2d_1 == null ? 0 : getStringHashCode(this.a2d_1)) | 0;
    return result;
  };
  protoOf(LoginRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoginRequest))
      return false;
    if (!(this.y2c_1 === other.y2c_1))
      return false;
    if (!(this.z2c_1 === other.z2c_1))
      return false;
    if (!(this.a2d_1 == other.a2d_1))
      return false;
    return true;
  };
  function MeResponse$Companion$$childSerializers$_anonymous__cvbqk1() {
    return new ArrayListSerializer(StringSerializer_getInstance());
  }
  function Companion_4() {
    Companion_instance_5 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b2d_1 = [null, null, lazy(tmp_0, MeResponse$Companion$$childSerializers$_anonymous__cvbqk1)];
  }
  var Companion_instance_5;
  function Companion_getInstance_4() {
    if (Companion_instance_5 == null)
      new Companion_4();
    return Companion_instance_5;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.MeResponse', this, 3);
    tmp0_serialDesc.tt('userId', false);
    tmp0_serialDesc.tt('email', false);
    tmp0_serialDesc.tt('roles', false);
    this.c2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).d2d = function (encoder, value) {
    var tmp0_desc = this.c2d_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_4().b2d_1;
    tmp1_output.un(tmp0_desc, 0, value.h27_1);
    tmp1_output.un(tmp0_desc, 1, value.i27_1);
    tmp1_output.wn(tmp0_desc, 2, tmp2_cached[2].f2(), value.j27_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_2).fj = function (encoder, value) {
    return this.d2d(encoder, value instanceof MeResponse ? value : THROW_CCE());
  };
  protoOf($serializer_2).gj = function (decoder) {
    var tmp0_desc = this.c2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    var tmp8_cached = Companion_getInstance_4().b2d_1;
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.rm(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.rm(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return MeResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_2).ej = function () {
    return this.c2d_1;
  };
  protoOf($serializer_2).iu = function () {
    var tmp0_cached = Companion_getInstance_4().b2d_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2()];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function MeResponse_init_$Init$(seen0, userId, email, roles, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_2().c2d_1);
    }
    $this.h27_1 = userId;
    $this.i27_1 = email;
    $this.j27_1 = roles;
    return $this;
  }
  function MeResponse_init_$Create$(seen0, userId, email, roles, serializationConstructorMarker) {
    return MeResponse_init_$Init$(seen0, userId, email, roles, serializationConstructorMarker, objectCreate(protoOf(MeResponse)));
  }
  function MeResponse(userId, email, roles) {
    Companion_getInstance_4();
    this.h27_1 = userId;
    this.i27_1 = email;
    this.j27_1 = roles;
  }
  protoOf(MeResponse).toString = function () {
    return 'MeResponse(userId=' + this.h27_1 + ', email=' + this.i27_1 + ', roles=' + toString(this.j27_1) + ')';
  };
  protoOf(MeResponse).hashCode = function () {
    var result = getStringHashCode(this.h27_1);
    result = imul(result, 31) + getStringHashCode(this.i27_1) | 0;
    result = imul(result, 31) + hashCode(this.j27_1) | 0;
    return result;
  };
  protoOf(MeResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MeResponse))
      return false;
    if (!(this.h27_1 === other.h27_1))
      return false;
    if (!(this.i27_1 === other.i27_1))
      return false;
    if (!equals(this.j27_1, other.j27_1))
      return false;
    return true;
  };
  function Companion_5() {
  }
  var Companion_instance_6;
  function Companion_getInstance_5() {
    return Companion_instance_6;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.PasskeyRegistrationStartResponse', this, 2);
    tmp0_serialDesc.tt('requestId', false);
    tmp0_serialDesc.tt('optionsJson', false);
    this.e2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).f2d = function (encoder, value) {
    var tmp0_desc = this.e2d_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.g2d_1);
    tmp1_output.un(tmp0_desc, 1, value.h2d_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_3).fj = function (encoder, value) {
    return this.f2d(encoder, value instanceof PasskeyRegistrationStartResponse ? value : THROW_CCE());
  };
  protoOf($serializer_3).gj = function (decoder) {
    var tmp0_desc = this.e2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return PasskeyRegistrationStartResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).ej = function () {
    return this.e2d_1;
  };
  protoOf($serializer_3).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function PasskeyRegistrationStartResponse_init_$Init$(seen0, requestId, optionsJson, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_3().e2d_1);
    }
    $this.g2d_1 = requestId;
    $this.h2d_1 = optionsJson;
    return $this;
  }
  function PasskeyRegistrationStartResponse_init_$Create$(seen0, requestId, optionsJson, serializationConstructorMarker) {
    return PasskeyRegistrationStartResponse_init_$Init$(seen0, requestId, optionsJson, serializationConstructorMarker, objectCreate(protoOf(PasskeyRegistrationStartResponse)));
  }
  function PasskeyRegistrationStartResponse(requestId, optionsJson) {
    this.g2d_1 = requestId;
    this.h2d_1 = optionsJson;
  }
  protoOf(PasskeyRegistrationStartResponse).toString = function () {
    return 'PasskeyRegistrationStartResponse(requestId=' + this.g2d_1 + ', optionsJson=' + this.h2d_1 + ')';
  };
  protoOf(PasskeyRegistrationStartResponse).hashCode = function () {
    var result = getStringHashCode(this.g2d_1);
    result = imul(result, 31) + getStringHashCode(this.h2d_1) | 0;
    return result;
  };
  protoOf(PasskeyRegistrationStartResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PasskeyRegistrationStartResponse))
      return false;
    if (!(this.g2d_1 === other.g2d_1))
      return false;
    if (!(this.h2d_1 === other.h2d_1))
      return false;
    return true;
  };
  function Companion_6() {
  }
  var Companion_instance_7;
  function Companion_getInstance_6() {
    return Companion_instance_7;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.PasskeyRegistrationFinishRequest', this, 2);
    tmp0_serialDesc.tt('requestId', false);
    tmp0_serialDesc.tt('credentialJson', false);
    this.i2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).j2d = function (encoder, value) {
    var tmp0_desc = this.i2d_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.k2d_1);
    tmp1_output.un(tmp0_desc, 1, value.l2d_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_4).fj = function (encoder, value) {
    return this.j2d(encoder, value instanceof PasskeyRegistrationFinishRequest ? value : THROW_CCE());
  };
  protoOf($serializer_4).gj = function (decoder) {
    var tmp0_desc = this.i2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return PasskeyRegistrationFinishRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_4).ej = function () {
    return this.i2d_1;
  };
  protoOf($serializer_4).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function PasskeyRegistrationFinishRequest_init_$Init$(seen0, requestId, credentialJson, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_4().i2d_1);
    }
    $this.k2d_1 = requestId;
    $this.l2d_1 = credentialJson;
    return $this;
  }
  function PasskeyRegistrationFinishRequest_init_$Create$(seen0, requestId, credentialJson, serializationConstructorMarker) {
    return PasskeyRegistrationFinishRequest_init_$Init$(seen0, requestId, credentialJson, serializationConstructorMarker, objectCreate(protoOf(PasskeyRegistrationFinishRequest)));
  }
  function PasskeyRegistrationFinishRequest(requestId, credentialJson) {
    this.k2d_1 = requestId;
    this.l2d_1 = credentialJson;
  }
  protoOf(PasskeyRegistrationFinishRequest).toString = function () {
    return 'PasskeyRegistrationFinishRequest(requestId=' + this.k2d_1 + ', credentialJson=' + this.l2d_1 + ')';
  };
  protoOf(PasskeyRegistrationFinishRequest).hashCode = function () {
    var result = getStringHashCode(this.k2d_1);
    result = imul(result, 31) + getStringHashCode(this.l2d_1) | 0;
    return result;
  };
  protoOf(PasskeyRegistrationFinishRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PasskeyRegistrationFinishRequest))
      return false;
    if (!(this.k2d_1 === other.k2d_1))
      return false;
    if (!(this.l2d_1 === other.l2d_1))
      return false;
    return true;
  };
  function Companion_7() {
  }
  var Companion_instance_8;
  function Companion_getInstance_7() {
    return Companion_instance_8;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.PasskeyRegistrationFinishResponse', this, 1);
    tmp0_serialDesc.tt('credentialId', false);
    this.m2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).n2d = function (encoder, value) {
    var tmp0_desc = this.m2d_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.o2d_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_5).fj = function (encoder, value) {
    return this.n2d(encoder, value instanceof PasskeyRegistrationFinishResponse ? value : THROW_CCE());
  };
  protoOf($serializer_5).gj = function (decoder) {
    var tmp0_desc = this.m2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return PasskeyRegistrationFinishResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_5).ej = function () {
    return this.m2d_1;
  };
  protoOf($serializer_5).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function PasskeyRegistrationFinishResponse_init_$Init$(seen0, credentialId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_5().m2d_1);
    }
    $this.o2d_1 = credentialId;
    return $this;
  }
  function PasskeyRegistrationFinishResponse_init_$Create$(seen0, credentialId, serializationConstructorMarker) {
    return PasskeyRegistrationFinishResponse_init_$Init$(seen0, credentialId, serializationConstructorMarker, objectCreate(protoOf(PasskeyRegistrationFinishResponse)));
  }
  function PasskeyRegistrationFinishResponse(credentialId) {
    this.o2d_1 = credentialId;
  }
  protoOf(PasskeyRegistrationFinishResponse).toString = function () {
    return 'PasskeyRegistrationFinishResponse(credentialId=' + this.o2d_1 + ')';
  };
  protoOf(PasskeyRegistrationFinishResponse).hashCode = function () {
    return getStringHashCode(this.o2d_1);
  };
  protoOf(PasskeyRegistrationFinishResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PasskeyRegistrationFinishResponse))
      return false;
    if (!(this.o2d_1 === other.o2d_1))
      return false;
    return true;
  };
  function Companion_8() {
  }
  var Companion_instance_9;
  function Companion_getInstance_8() {
    return Companion_instance_9;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.PasskeyLoginStartRequest', this, 1);
    tmp0_serialDesc.tt('email', false);
    this.p2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).q2d = function (encoder, value) {
    var tmp0_desc = this.p2d_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.r2d_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_6).fj = function (encoder, value) {
    return this.q2d(encoder, value instanceof PasskeyLoginStartRequest ? value : THROW_CCE());
  };
  protoOf($serializer_6).gj = function (decoder) {
    var tmp0_desc = this.p2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return PasskeyLoginStartRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_6).ej = function () {
    return this.p2d_1;
  };
  protoOf($serializer_6).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function PasskeyLoginStartRequest_init_$Init$(seen0, email, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_6().p2d_1);
    }
    $this.r2d_1 = email;
    return $this;
  }
  function PasskeyLoginStartRequest_init_$Create$(seen0, email, serializationConstructorMarker) {
    return PasskeyLoginStartRequest_init_$Init$(seen0, email, serializationConstructorMarker, objectCreate(protoOf(PasskeyLoginStartRequest)));
  }
  function PasskeyLoginStartRequest(email) {
    this.r2d_1 = email;
  }
  protoOf(PasskeyLoginStartRequest).toString = function () {
    return 'PasskeyLoginStartRequest(email=' + this.r2d_1 + ')';
  };
  protoOf(PasskeyLoginStartRequest).hashCode = function () {
    return getStringHashCode(this.r2d_1);
  };
  protoOf(PasskeyLoginStartRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PasskeyLoginStartRequest))
      return false;
    if (!(this.r2d_1 === other.r2d_1))
      return false;
    return true;
  };
  function Companion_9() {
  }
  var Companion_instance_10;
  function Companion_getInstance_9() {
    return Companion_instance_10;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.PasskeyLoginStartResponse', this, 2);
    tmp0_serialDesc.tt('requestId', false);
    tmp0_serialDesc.tt('optionsJson', false);
    this.s2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).t2d = function (encoder, value) {
    var tmp0_desc = this.s2d_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.u2d_1);
    tmp1_output.un(tmp0_desc, 1, value.v2d_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_7).fj = function (encoder, value) {
    return this.t2d(encoder, value instanceof PasskeyLoginStartResponse ? value : THROW_CCE());
  };
  protoOf($serializer_7).gj = function (decoder) {
    var tmp0_desc = this.s2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return PasskeyLoginStartResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_7).ej = function () {
    return this.s2d_1;
  };
  protoOf($serializer_7).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function PasskeyLoginStartResponse_init_$Init$(seen0, requestId, optionsJson, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_7().s2d_1);
    }
    $this.u2d_1 = requestId;
    $this.v2d_1 = optionsJson;
    return $this;
  }
  function PasskeyLoginStartResponse_init_$Create$(seen0, requestId, optionsJson, serializationConstructorMarker) {
    return PasskeyLoginStartResponse_init_$Init$(seen0, requestId, optionsJson, serializationConstructorMarker, objectCreate(protoOf(PasskeyLoginStartResponse)));
  }
  function PasskeyLoginStartResponse(requestId, optionsJson) {
    this.u2d_1 = requestId;
    this.v2d_1 = optionsJson;
  }
  protoOf(PasskeyLoginStartResponse).toString = function () {
    return 'PasskeyLoginStartResponse(requestId=' + this.u2d_1 + ', optionsJson=' + this.v2d_1 + ')';
  };
  protoOf(PasskeyLoginStartResponse).hashCode = function () {
    var result = getStringHashCode(this.u2d_1);
    result = imul(result, 31) + getStringHashCode(this.v2d_1) | 0;
    return result;
  };
  protoOf(PasskeyLoginStartResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PasskeyLoginStartResponse))
      return false;
    if (!(this.u2d_1 === other.u2d_1))
      return false;
    if (!(this.v2d_1 === other.v2d_1))
      return false;
    return true;
  };
  function Companion_10() {
  }
  var Companion_instance_11;
  function Companion_getInstance_10() {
    return Companion_instance_11;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.PasskeyLoginFinishRequest', this, 3);
    tmp0_serialDesc.tt('requestId', false);
    tmp0_serialDesc.tt('credentialJson', false);
    tmp0_serialDesc.tt('deviceInfo', true);
    this.w2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).x2d = function (encoder, value) {
    var tmp0_desc = this.w2d_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.y2d_1);
    tmp1_output.un(tmp0_desc, 1, value.z2d_1);
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.a2e_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.a2e_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_8).fj = function (encoder, value) {
    return this.x2d(encoder, value instanceof PasskeyLoginFinishRequest ? value : THROW_CCE());
  };
  protoOf($serializer_8).gj = function (decoder) {
    var tmp0_desc = this.w2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return PasskeyLoginFinishRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_8).ej = function () {
    return this.w2d_1;
  };
  protoOf($serializer_8).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function PasskeyLoginFinishRequest_init_$Init$(seen0, requestId, credentialJson, deviceInfo, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_8().w2d_1);
    }
    $this.y2d_1 = requestId;
    $this.z2d_1 = credentialJson;
    if (0 === (seen0 & 4))
      $this.a2e_1 = null;
    else
      $this.a2e_1 = deviceInfo;
    return $this;
  }
  function PasskeyLoginFinishRequest_init_$Create$(seen0, requestId, credentialJson, deviceInfo, serializationConstructorMarker) {
    return PasskeyLoginFinishRequest_init_$Init$(seen0, requestId, credentialJson, deviceInfo, serializationConstructorMarker, objectCreate(protoOf(PasskeyLoginFinishRequest)));
  }
  function PasskeyLoginFinishRequest(requestId, credentialJson, deviceInfo) {
    deviceInfo = deviceInfo === VOID ? null : deviceInfo;
    this.y2d_1 = requestId;
    this.z2d_1 = credentialJson;
    this.a2e_1 = deviceInfo;
  }
  protoOf(PasskeyLoginFinishRequest).toString = function () {
    return 'PasskeyLoginFinishRequest(requestId=' + this.y2d_1 + ', credentialJson=' + this.z2d_1 + ', deviceInfo=' + this.a2e_1 + ')';
  };
  protoOf(PasskeyLoginFinishRequest).hashCode = function () {
    var result = getStringHashCode(this.y2d_1);
    result = imul(result, 31) + getStringHashCode(this.z2d_1) | 0;
    result = imul(result, 31) + (this.a2e_1 == null ? 0 : getStringHashCode(this.a2e_1)) | 0;
    return result;
  };
  protoOf(PasskeyLoginFinishRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PasskeyLoginFinishRequest))
      return false;
    if (!(this.y2d_1 === other.y2d_1))
      return false;
    if (!(this.z2d_1 === other.z2d_1))
      return false;
    if (!(this.a2e_1 == other.a2e_1))
      return false;
    return true;
  };
  function Companion_11() {
  }
  var Companion_instance_12;
  function Companion_getInstance_11() {
    return Companion_instance_12;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.MagicLinkRequestRequest', this, 1);
    tmp0_serialDesc.tt('email', false);
    this.b2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).c2e = function (encoder, value) {
    var tmp0_desc = this.b2e_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.d2e_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_9).fj = function (encoder, value) {
    return this.c2e(encoder, value instanceof MagicLinkRequestRequest ? value : THROW_CCE());
  };
  protoOf($serializer_9).gj = function (decoder) {
    var tmp0_desc = this.b2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return MagicLinkRequestRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_9).ej = function () {
    return this.b2e_1;
  };
  protoOf($serializer_9).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_9;
  function $serializer_getInstance_9() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function MagicLinkRequestRequest_init_$Init$(seen0, email, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_9().b2e_1);
    }
    $this.d2e_1 = email;
    return $this;
  }
  function MagicLinkRequestRequest_init_$Create$(seen0, email, serializationConstructorMarker) {
    return MagicLinkRequestRequest_init_$Init$(seen0, email, serializationConstructorMarker, objectCreate(protoOf(MagicLinkRequestRequest)));
  }
  function MagicLinkRequestRequest(email) {
    this.d2e_1 = email;
  }
  protoOf(MagicLinkRequestRequest).toString = function () {
    return 'MagicLinkRequestRequest(email=' + this.d2e_1 + ')';
  };
  protoOf(MagicLinkRequestRequest).hashCode = function () {
    return getStringHashCode(this.d2e_1);
  };
  protoOf(MagicLinkRequestRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MagicLinkRequestRequest))
      return false;
    if (!(this.d2e_1 === other.d2e_1))
      return false;
    return true;
  };
  function Companion_12() {
  }
  var Companion_instance_13;
  function Companion_getInstance_12() {
    return Companion_instance_13;
  }
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.MagicLinkConsumeRequest', this, 2);
    tmp0_serialDesc.tt('token', false);
    tmp0_serialDesc.tt('deviceInfo', true);
    this.e2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).f2e = function (encoder, value) {
    var tmp0_desc = this.e2e_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.g2e_1);
    if (tmp1_output.co(tmp0_desc, 1) ? true : !(value.h2e_1 == null)) {
      tmp1_output.yn(tmp0_desc, 1, StringSerializer_getInstance(), value.h2e_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_10).fj = function (encoder, value) {
    return this.f2e(encoder, value instanceof MagicLinkConsumeRequest ? value : THROW_CCE());
  };
  protoOf($serializer_10).gj = function (decoder) {
    var tmp0_desc = this.e2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return MagicLinkConsumeRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_10).ej = function () {
    return this.e2e_1;
  };
  protoOf($serializer_10).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_10;
  function $serializer_getInstance_10() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function MagicLinkConsumeRequest_init_$Init$(seen0, token, deviceInfo, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_10().e2e_1);
    }
    $this.g2e_1 = token;
    if (0 === (seen0 & 2))
      $this.h2e_1 = null;
    else
      $this.h2e_1 = deviceInfo;
    return $this;
  }
  function MagicLinkConsumeRequest_init_$Create$(seen0, token, deviceInfo, serializationConstructorMarker) {
    return MagicLinkConsumeRequest_init_$Init$(seen0, token, deviceInfo, serializationConstructorMarker, objectCreate(protoOf(MagicLinkConsumeRequest)));
  }
  function MagicLinkConsumeRequest(token, deviceInfo) {
    deviceInfo = deviceInfo === VOID ? null : deviceInfo;
    this.g2e_1 = token;
    this.h2e_1 = deviceInfo;
  }
  protoOf(MagicLinkConsumeRequest).toString = function () {
    return 'MagicLinkConsumeRequest(token=' + this.g2e_1 + ', deviceInfo=' + this.h2e_1 + ')';
  };
  protoOf(MagicLinkConsumeRequest).hashCode = function () {
    var result = getStringHashCode(this.g2e_1);
    result = imul(result, 31) + (this.h2e_1 == null ? 0 : getStringHashCode(this.h2e_1)) | 0;
    return result;
  };
  protoOf(MagicLinkConsumeRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MagicLinkConsumeRequest))
      return false;
    if (!(this.g2e_1 === other.g2e_1))
      return false;
    if (!(this.h2e_1 == other.h2e_1))
      return false;
    return true;
  };
  function Companion_13() {
  }
  var Companion_instance_14;
  function Companion_getInstance_13() {
    return Companion_instance_14;
  }
  function $serializer_11() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.ForgotPasswordRequest', this, 1);
    tmp0_serialDesc.tt('email', false);
    this.i2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).j2e = function (encoder, value) {
    var tmp0_desc = this.i2e_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.k2e_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_11).fj = function (encoder, value) {
    return this.j2e(encoder, value instanceof ForgotPasswordRequest ? value : THROW_CCE());
  };
  protoOf($serializer_11).gj = function (decoder) {
    var tmp0_desc = this.i2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return ForgotPasswordRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_11).ej = function () {
    return this.i2e_1;
  };
  protoOf($serializer_11).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_11;
  function $serializer_getInstance_11() {
    if ($serializer_instance_11 == null)
      new $serializer_11();
    return $serializer_instance_11;
  }
  function ForgotPasswordRequest_init_$Init$(seen0, email, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_11().i2e_1);
    }
    $this.k2e_1 = email;
    return $this;
  }
  function ForgotPasswordRequest_init_$Create$(seen0, email, serializationConstructorMarker) {
    return ForgotPasswordRequest_init_$Init$(seen0, email, serializationConstructorMarker, objectCreate(protoOf(ForgotPasswordRequest)));
  }
  function ForgotPasswordRequest(email) {
    this.k2e_1 = email;
  }
  protoOf(ForgotPasswordRequest).toString = function () {
    return 'ForgotPasswordRequest(email=' + this.k2e_1 + ')';
  };
  protoOf(ForgotPasswordRequest).hashCode = function () {
    return getStringHashCode(this.k2e_1);
  };
  protoOf(ForgotPasswordRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ForgotPasswordRequest))
      return false;
    if (!(this.k2e_1 === other.k2e_1))
      return false;
    return true;
  };
  function Companion_14() {
  }
  var Companion_instance_15;
  function Companion_getInstance_14() {
    return Companion_instance_15;
  }
  function $serializer_12() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.ResetPasswordRequest', this, 3);
    tmp0_serialDesc.tt('token', false);
    tmp0_serialDesc.tt('newPassword', false);
    tmp0_serialDesc.tt('deviceInfo', true);
    this.l2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).m2e = function (encoder, value) {
    var tmp0_desc = this.l2e_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.n2e_1);
    tmp1_output.un(tmp0_desc, 1, value.o2e_1);
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.p2e_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.p2e_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_12).fj = function (encoder, value) {
    return this.m2e(encoder, value instanceof ResetPasswordRequest ? value : THROW_CCE());
  };
  protoOf($serializer_12).gj = function (decoder) {
    var tmp0_desc = this.l2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return ResetPasswordRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_12).ej = function () {
    return this.l2e_1;
  };
  protoOf($serializer_12).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_12;
  function $serializer_getInstance_12() {
    if ($serializer_instance_12 == null)
      new $serializer_12();
    return $serializer_instance_12;
  }
  function ResetPasswordRequest_init_$Init$(seen0, token, newPassword, deviceInfo, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_12().l2e_1);
    }
    $this.n2e_1 = token;
    $this.o2e_1 = newPassword;
    if (0 === (seen0 & 4))
      $this.p2e_1 = null;
    else
      $this.p2e_1 = deviceInfo;
    return $this;
  }
  function ResetPasswordRequest_init_$Create$(seen0, token, newPassword, deviceInfo, serializationConstructorMarker) {
    return ResetPasswordRequest_init_$Init$(seen0, token, newPassword, deviceInfo, serializationConstructorMarker, objectCreate(protoOf(ResetPasswordRequest)));
  }
  function ResetPasswordRequest(token, newPassword, deviceInfo) {
    deviceInfo = deviceInfo === VOID ? null : deviceInfo;
    this.n2e_1 = token;
    this.o2e_1 = newPassword;
    this.p2e_1 = deviceInfo;
  }
  protoOf(ResetPasswordRequest).toString = function () {
    return 'ResetPasswordRequest(token=' + this.n2e_1 + ', newPassword=' + this.o2e_1 + ', deviceInfo=' + this.p2e_1 + ')';
  };
  protoOf(ResetPasswordRequest).hashCode = function () {
    var result = getStringHashCode(this.n2e_1);
    result = imul(result, 31) + getStringHashCode(this.o2e_1) | 0;
    result = imul(result, 31) + (this.p2e_1 == null ? 0 : getStringHashCode(this.p2e_1)) | 0;
    return result;
  };
  protoOf(ResetPasswordRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ResetPasswordRequest))
      return false;
    if (!(this.n2e_1 === other.n2e_1))
      return false;
    if (!(this.o2e_1 === other.o2e_1))
      return false;
    if (!(this.p2e_1 == other.p2e_1))
      return false;
    return true;
  };
  function Companion_15() {
  }
  var Companion_instance_16;
  function Companion_getInstance_15() {
    return Companion_instance_16;
  }
  function $serializer_13() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.SetupRequest', this, 3);
    tmp0_serialDesc.tt('token', false);
    tmp0_serialDesc.tt('password', false);
    tmp0_serialDesc.tt('displayName', false);
    this.q2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_13).r2e = function (encoder, value) {
    var tmp0_desc = this.q2e_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.s2e_1);
    tmp1_output.yn(tmp0_desc, 1, StringSerializer_getInstance(), value.t2e_1);
    tmp1_output.un(tmp0_desc, 2, value.u2e_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_13).fj = function (encoder, value) {
    return this.r2e(encoder, value instanceof SetupRequest ? value : THROW_CCE());
  };
  protoOf($serializer_13).gj = function (decoder) {
    var tmp0_desc = this.q2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return SetupRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_13).ej = function () {
    return this.q2e_1;
  };
  protoOf($serializer_13).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
  };
  var $serializer_instance_13;
  function $serializer_getInstance_13() {
    if ($serializer_instance_13 == null)
      new $serializer_13();
    return $serializer_instance_13;
  }
  function SetupRequest_init_$Init$(seen0, token, password, displayName, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_13().q2e_1);
    }
    $this.s2e_1 = token;
    $this.t2e_1 = password;
    $this.u2e_1 = displayName;
    return $this;
  }
  function SetupRequest_init_$Create$(seen0, token, password, displayName, serializationConstructorMarker) {
    return SetupRequest_init_$Init$(seen0, token, password, displayName, serializationConstructorMarker, objectCreate(protoOf(SetupRequest)));
  }
  function SetupRequest(token, password, displayName) {
    this.s2e_1 = token;
    this.t2e_1 = password;
    this.u2e_1 = displayName;
  }
  protoOf(SetupRequest).toString = function () {
    return 'SetupRequest(token=' + this.s2e_1 + ', password=' + this.t2e_1 + ', displayName=' + this.u2e_1 + ')';
  };
  protoOf(SetupRequest).hashCode = function () {
    var result = getStringHashCode(this.s2e_1);
    result = imul(result, 31) + (this.t2e_1 == null ? 0 : getStringHashCode(this.t2e_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.u2e_1) | 0;
    return result;
  };
  protoOf(SetupRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupRequest))
      return false;
    if (!(this.s2e_1 === other.s2e_1))
      return false;
    if (!(this.t2e_1 == other.t2e_1))
      return false;
    if (!(this.u2e_1 === other.u2e_1))
      return false;
    return true;
  };
  function Companion_16() {
  }
  var Companion_instance_17;
  function Companion_getInstance_16() {
    return Companion_instance_17;
  }
  function $serializer_14() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.OAuthCompleteRequest', this, 1);
    tmp0_serialDesc.tt('handoffCode', false);
    this.v2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_14).w2e = function (encoder, value) {
    var tmp0_desc = this.v2e_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.x2e_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_14).fj = function (encoder, value) {
    return this.w2e(encoder, value instanceof OAuthCompleteRequest ? value : THROW_CCE());
  };
  protoOf($serializer_14).gj = function (decoder) {
    var tmp0_desc = this.v2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return OAuthCompleteRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_14).ej = function () {
    return this.v2e_1;
  };
  protoOf($serializer_14).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_14;
  function $serializer_getInstance_14() {
    if ($serializer_instance_14 == null)
      new $serializer_14();
    return $serializer_instance_14;
  }
  function OAuthCompleteRequest_init_$Init$(seen0, handoffCode, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_14().v2e_1);
    }
    $this.x2e_1 = handoffCode;
    return $this;
  }
  function OAuthCompleteRequest_init_$Create$(seen0, handoffCode, serializationConstructorMarker) {
    return OAuthCompleteRequest_init_$Init$(seen0, handoffCode, serializationConstructorMarker, objectCreate(protoOf(OAuthCompleteRequest)));
  }
  function OAuthCompleteRequest(handoffCode) {
    this.x2e_1 = handoffCode;
  }
  protoOf(OAuthCompleteRequest).toString = function () {
    return 'OAuthCompleteRequest(handoffCode=' + this.x2e_1 + ')';
  };
  protoOf(OAuthCompleteRequest).hashCode = function () {
    return getStringHashCode(this.x2e_1);
  };
  protoOf(OAuthCompleteRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OAuthCompleteRequest))
      return false;
    if (!(this.x2e_1 === other.x2e_1))
      return false;
    return true;
  };
  function Companion_17() {
  }
  var Companion_instance_18;
  function Companion_getInstance_17() {
    return Companion_instance_18;
  }
  function $serializer_15() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.UpdateDisplayNameRequest', this, 1);
    tmp0_serialDesc.tt('displayName', false);
    this.y2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_15).z2e = function (encoder, value) {
    var tmp0_desc = this.y2e_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.a2f_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_15).fj = function (encoder, value) {
    return this.z2e(encoder, value instanceof UpdateDisplayNameRequest ? value : THROW_CCE());
  };
  protoOf($serializer_15).gj = function (decoder) {
    var tmp0_desc = this.y2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return UpdateDisplayNameRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_15).ej = function () {
    return this.y2e_1;
  };
  protoOf($serializer_15).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_15;
  function $serializer_getInstance_15() {
    if ($serializer_instance_15 == null)
      new $serializer_15();
    return $serializer_instance_15;
  }
  function UpdateDisplayNameRequest_init_$Init$(seen0, displayName, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_15().y2e_1);
    }
    $this.a2f_1 = displayName;
    return $this;
  }
  function UpdateDisplayNameRequest_init_$Create$(seen0, displayName, serializationConstructorMarker) {
    return UpdateDisplayNameRequest_init_$Init$(seen0, displayName, serializationConstructorMarker, objectCreate(protoOf(UpdateDisplayNameRequest)));
  }
  function UpdateDisplayNameRequest(displayName) {
    this.a2f_1 = displayName;
  }
  protoOf(UpdateDisplayNameRequest).toString = function () {
    return 'UpdateDisplayNameRequest(displayName=' + this.a2f_1 + ')';
  };
  protoOf(UpdateDisplayNameRequest).hashCode = function () {
    return getStringHashCode(this.a2f_1);
  };
  protoOf(UpdateDisplayNameRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateDisplayNameRequest))
      return false;
    if (!(this.a2f_1 === other.a2f_1))
      return false;
    return true;
  };
  function Companion_18() {
  }
  var Companion_instance_19;
  function Companion_getInstance_18() {
    return Companion_instance_19;
  }
  function $serializer_16() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.UpdateDisplayNameResponse', this, 1);
    tmp0_serialDesc.tt('displayName', false);
    this.b2f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_16).c2f = function (encoder, value) {
    var tmp0_desc = this.b2f_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.d2f_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_16).fj = function (encoder, value) {
    return this.c2f(encoder, value instanceof UpdateDisplayNameResponse ? value : THROW_CCE());
  };
  protoOf($serializer_16).gj = function (decoder) {
    var tmp0_desc = this.b2f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return UpdateDisplayNameResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_16).ej = function () {
    return this.b2f_1;
  };
  protoOf($serializer_16).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_16;
  function $serializer_getInstance_16() {
    if ($serializer_instance_16 == null)
      new $serializer_16();
    return $serializer_instance_16;
  }
  function UpdateDisplayNameResponse_init_$Init$(seen0, displayName, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_16().b2f_1);
    }
    $this.d2f_1 = displayName;
    return $this;
  }
  function UpdateDisplayNameResponse_init_$Create$(seen0, displayName, serializationConstructorMarker) {
    return UpdateDisplayNameResponse_init_$Init$(seen0, displayName, serializationConstructorMarker, objectCreate(protoOf(UpdateDisplayNameResponse)));
  }
  function UpdateDisplayNameResponse(displayName) {
    this.d2f_1 = displayName;
  }
  protoOf(UpdateDisplayNameResponse).toString = function () {
    return 'UpdateDisplayNameResponse(displayName=' + this.d2f_1 + ')';
  };
  protoOf(UpdateDisplayNameResponse).hashCode = function () {
    return getStringHashCode(this.d2f_1);
  };
  protoOf(UpdateDisplayNameResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateDisplayNameResponse))
      return false;
    if (!(this.d2f_1 === other.d2f_1))
      return false;
    return true;
  };
  function UserAdminResponse$Companion$$childSerializers$_anonymous__kax491() {
    return new LinkedHashSetSerializer(StringSerializer_getInstance());
  }
  function Companion_19() {
    Companion_instance_20 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e2f_1 = [null, null, null, lazy(tmp_0, UserAdminResponse$Companion$$childSerializers$_anonymous__kax491), null, null, null];
  }
  var Companion_instance_20;
  function Companion_getInstance_19() {
    if (Companion_instance_20 == null)
      new Companion_19();
    return Companion_instance_20;
  }
  function $serializer_17() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.UserAdminResponse', this, 7);
    tmp0_serialDesc.tt('userId', false);
    tmp0_serialDesc.tt('email', false);
    tmp0_serialDesc.tt('displayName', false);
    tmp0_serialDesc.tt('roles', false);
    tmp0_serialDesc.tt('enabled', false);
    tmp0_serialDesc.tt('emailVerified', false);
    tmp0_serialDesc.tt('createdAt', false);
    this.f2f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_17).g2f = function (encoder, value) {
    var tmp0_desc = this.f2f_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_19().e2f_1;
    tmp1_output.un(tmp0_desc, 0, value.h2f_1);
    tmp1_output.un(tmp0_desc, 1, value.i2f_1);
    tmp1_output.un(tmp0_desc, 2, value.j2f_1);
    tmp1_output.wn(tmp0_desc, 3, tmp2_cached[3].f2(), value.k2f_1);
    tmp1_output.mn(tmp0_desc, 4, value.l2f_1);
    tmp1_output.mn(tmp0_desc, 5, value.m2f_1);
    tmp1_output.un(tmp0_desc, 6, value.n2f_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_17).fj = function (encoder, value) {
    return this.g2f(encoder, value instanceof UserAdminResponse ? value : THROW_CCE());
  };
  protoOf($serializer_17).gj = function (decoder) {
    var tmp0_desc = this.f2f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_input = decoder.fm(tmp0_desc);
    var tmp12_cached = Companion_getInstance_19().e2f_1;
    if (tmp11_input.vm()) {
      tmp4_local0 = tmp11_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.rm(tmp0_desc, 3, tmp12_cached[3].f2(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.hm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.hm(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.pm(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.rm(tmp0_desc, 3, tmp12_cached[3].f2(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.hm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.hm(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.pm(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.gm(tmp0_desc);
    return UserAdminResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_17).ej = function () {
    return this.f2f_1;
  };
  protoOf($serializer_17).iu = function () {
    var tmp0_cached = Companion_getInstance_19().e2f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3].f2(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_17;
  function $serializer_getInstance_17() {
    if ($serializer_instance_17 == null)
      new $serializer_17();
    return $serializer_instance_17;
  }
  function UserAdminResponse_init_$Init$(seen0, userId, email, displayName, roles, enabled, emailVerified, createdAt, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_17().f2f_1);
    }
    $this.h2f_1 = userId;
    $this.i2f_1 = email;
    $this.j2f_1 = displayName;
    $this.k2f_1 = roles;
    $this.l2f_1 = enabled;
    $this.m2f_1 = emailVerified;
    $this.n2f_1 = createdAt;
    return $this;
  }
  function UserAdminResponse_init_$Create$(seen0, userId, email, displayName, roles, enabled, emailVerified, createdAt, serializationConstructorMarker) {
    return UserAdminResponse_init_$Init$(seen0, userId, email, displayName, roles, enabled, emailVerified, createdAt, serializationConstructorMarker, objectCreate(protoOf(UserAdminResponse)));
  }
  function UserAdminResponse(userId, email, displayName, roles, enabled, emailVerified, createdAt) {
    Companion_getInstance_19();
    this.h2f_1 = userId;
    this.i2f_1 = email;
    this.j2f_1 = displayName;
    this.k2f_1 = roles;
    this.l2f_1 = enabled;
    this.m2f_1 = emailVerified;
    this.n2f_1 = createdAt;
  }
  protoOf(UserAdminResponse).toString = function () {
    return 'UserAdminResponse(userId=' + this.h2f_1 + ', email=' + this.i2f_1 + ', displayName=' + this.j2f_1 + ', roles=' + toString(this.k2f_1) + ', enabled=' + this.l2f_1 + ', emailVerified=' + this.m2f_1 + ', createdAt=' + this.n2f_1 + ')';
  };
  protoOf(UserAdminResponse).hashCode = function () {
    var result = getStringHashCode(this.h2f_1);
    result = imul(result, 31) + getStringHashCode(this.i2f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j2f_1) | 0;
    result = imul(result, 31) + hashCode(this.k2f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l2f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m2f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n2f_1) | 0;
    return result;
  };
  protoOf(UserAdminResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserAdminResponse))
      return false;
    if (!(this.h2f_1 === other.h2f_1))
      return false;
    if (!(this.i2f_1 === other.i2f_1))
      return false;
    if (!(this.j2f_1 === other.j2f_1))
      return false;
    if (!equals(this.k2f_1, other.k2f_1))
      return false;
    if (!(this.l2f_1 === other.l2f_1))
      return false;
    if (!(this.m2f_1 === other.m2f_1))
      return false;
    if (!(this.n2f_1 === other.n2f_1))
      return false;
    return true;
  };
  function PagedUsersResponse$Companion$$childSerializers$_anonymous__8zi1ze() {
    return new ArrayListSerializer($serializer_getInstance_17());
  }
  function Companion_20() {
    Companion_instance_21 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o2f_1 = [lazy(tmp_0, PagedUsersResponse$Companion$$childSerializers$_anonymous__8zi1ze), null, null, null];
  }
  var Companion_instance_21;
  function Companion_getInstance_20() {
    if (Companion_instance_21 == null)
      new Companion_20();
    return Companion_instance_21;
  }
  function $serializer_18() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.PagedUsersResponse', this, 4);
    tmp0_serialDesc.tt('items', false);
    tmp0_serialDesc.tt('totalCount', false);
    tmp0_serialDesc.tt('page', false);
    tmp0_serialDesc.tt('pageSize', false);
    this.p2f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_18).q2f = function (encoder, value) {
    var tmp0_desc = this.p2f_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_20().o2f_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.r2f_1);
    tmp1_output.pn(tmp0_desc, 1, value.s2f_1);
    tmp1_output.pn(tmp0_desc, 2, value.t2f_1);
    tmp1_output.pn(tmp0_desc, 3, value.u2f_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_18).fj = function (encoder, value) {
    return this.q2f(encoder, value instanceof PagedUsersResponse ? value : THROW_CCE());
  };
  protoOf($serializer_18).gj = function (decoder) {
    var tmp0_desc = this.p2f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.fm(tmp0_desc);
    var tmp9_cached = Companion_getInstance_20().o2f_1;
    if (tmp8_input.vm()) {
      tmp4_local0 = tmp8_input.rm(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.km(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.km(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.km(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.rm(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.km(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.km(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.km(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.gm(tmp0_desc);
    return PagedUsersResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_18).ej = function () {
    return this.p2f_1;
  };
  protoOf($serializer_18).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_20().o2f_1[0].f2(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_18;
  function $serializer_getInstance_18() {
    if ($serializer_instance_18 == null)
      new $serializer_18();
    return $serializer_instance_18;
  }
  function PagedUsersResponse_init_$Init$(seen0, items, totalCount, page, pageSize, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_18().p2f_1);
    }
    $this.r2f_1 = items;
    $this.s2f_1 = totalCount;
    $this.t2f_1 = page;
    $this.u2f_1 = pageSize;
    return $this;
  }
  function PagedUsersResponse_init_$Create$(seen0, items, totalCount, page, pageSize, serializationConstructorMarker) {
    return PagedUsersResponse_init_$Init$(seen0, items, totalCount, page, pageSize, serializationConstructorMarker, objectCreate(protoOf(PagedUsersResponse)));
  }
  function PagedUsersResponse(items, totalCount, page, pageSize) {
    Companion_getInstance_20();
    this.r2f_1 = items;
    this.s2f_1 = totalCount;
    this.t2f_1 = page;
    this.u2f_1 = pageSize;
  }
  protoOf(PagedUsersResponse).toString = function () {
    return 'PagedUsersResponse(items=' + toString(this.r2f_1) + ', totalCount=' + this.s2f_1 + ', page=' + this.t2f_1 + ', pageSize=' + this.u2f_1 + ')';
  };
  protoOf(PagedUsersResponse).hashCode = function () {
    var result = hashCode(this.r2f_1);
    result = imul(result, 31) + this.s2f_1 | 0;
    result = imul(result, 31) + this.t2f_1 | 0;
    result = imul(result, 31) + this.u2f_1 | 0;
    return result;
  };
  protoOf(PagedUsersResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PagedUsersResponse))
      return false;
    if (!equals(this.r2f_1, other.r2f_1))
      return false;
    if (!(this.s2f_1 === other.s2f_1))
      return false;
    if (!(this.t2f_1 === other.t2f_1))
      return false;
    if (!(this.u2f_1 === other.u2f_1))
      return false;
    return true;
  };
  function UpdateUserAdminRequest$Companion$$childSerializers$_anonymous__clq8oa() {
    return new LinkedHashSetSerializer(StringSerializer_getInstance());
  }
  function Companion_21() {
    Companion_instance_22 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v2f_1 = [null, lazy(tmp_0, UpdateUserAdminRequest$Companion$$childSerializers$_anonymous__clq8oa), null];
  }
  var Companion_instance_22;
  function Companion_getInstance_21() {
    if (Companion_instance_22 == null)
      new Companion_21();
    return Companion_instance_22;
  }
  function $serializer_19() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.UpdateUserAdminRequest', this, 3);
    tmp0_serialDesc.tt('displayName', false);
    tmp0_serialDesc.tt('roles', false);
    tmp0_serialDesc.tt('enabled', false);
    this.w2f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_19).x2f = function (encoder, value) {
    var tmp0_desc = this.w2f_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_21().v2f_1;
    tmp1_output.un(tmp0_desc, 0, value.y2f_1);
    tmp1_output.wn(tmp0_desc, 1, tmp2_cached[1].f2(), value.z2f_1);
    tmp1_output.mn(tmp0_desc, 2, value.a2g_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_19).fj = function (encoder, value) {
    return this.x2f(encoder, value instanceof UpdateUserAdminRequest ? value : THROW_CCE());
  };
  protoOf($serializer_19).gj = function (decoder) {
    var tmp0_desc = this.w2f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.fm(tmp0_desc);
    var tmp8_cached = Companion_getInstance_21().v2f_1;
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.rm(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.rm(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return UpdateUserAdminRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_19).ej = function () {
    return this.w2f_1;
  };
  protoOf($serializer_19).iu = function () {
    var tmp0_cached = Companion_getInstance_21().v2f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1].f2(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_19;
  function $serializer_getInstance_19() {
    if ($serializer_instance_19 == null)
      new $serializer_19();
    return $serializer_instance_19;
  }
  function UpdateUserAdminRequest_init_$Init$(seen0, displayName, roles, enabled, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_19().w2f_1);
    }
    $this.y2f_1 = displayName;
    $this.z2f_1 = roles;
    $this.a2g_1 = enabled;
    return $this;
  }
  function UpdateUserAdminRequest_init_$Create$(seen0, displayName, roles, enabled, serializationConstructorMarker) {
    return UpdateUserAdminRequest_init_$Init$(seen0, displayName, roles, enabled, serializationConstructorMarker, objectCreate(protoOf(UpdateUserAdminRequest)));
  }
  function UpdateUserAdminRequest(displayName, roles, enabled) {
    Companion_getInstance_21();
    this.y2f_1 = displayName;
    this.z2f_1 = roles;
    this.a2g_1 = enabled;
  }
  protoOf(UpdateUserAdminRequest).toString = function () {
    return 'UpdateUserAdminRequest(displayName=' + this.y2f_1 + ', roles=' + toString(this.z2f_1) + ', enabled=' + this.a2g_1 + ')';
  };
  protoOf(UpdateUserAdminRequest).hashCode = function () {
    var result = getStringHashCode(this.y2f_1);
    result = imul(result, 31) + hashCode(this.z2f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a2g_1) | 0;
    return result;
  };
  protoOf(UpdateUserAdminRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateUserAdminRequest))
      return false;
    if (!(this.y2f_1 === other.y2f_1))
      return false;
    if (!equals(this.z2f_1, other.z2f_1))
      return false;
    if (!(this.a2g_1 === other.a2g_1))
      return false;
    return true;
  };
  function RegisterOwnBitacoraEntryRequest$Companion$$childSerializers$_anonymous__htsdtn() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values());
  }
  function Companion_22() {
    Companion_instance_23 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b2g_1 = [null, lazy(tmp_0, RegisterOwnBitacoraEntryRequest$Companion$$childSerializers$_anonymous__htsdtn), null, null, null, null, null, null, null];
  }
  var Companion_instance_23;
  function Companion_getInstance_22() {
    if (Companion_instance_23 == null)
      new Companion_22();
    return Companion_instance_23;
  }
  function $serializer_20() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.RegisterOwnBitacoraEntryRequest', this, 9);
    tmp0_serialDesc.tt('instructorUserId', true);
    tmp0_serialDesc.tt('activityType', false);
    tmp0_serialDesc.tt('startedAt', false);
    tmp0_serialDesc.tt('endedAt', false);
    tmp0_serialDesc.tt('parameters', false);
    tmp0_serialDesc.tt('notes', true);
    tmp0_serialDesc.tt('latitude', true);
    tmp0_serialDesc.tt('longitude', true);
    tmp0_serialDesc.tt('locationLabel', true);
    this.c2g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_20).d2g = function (encoder, value) {
    var tmp0_desc = this.c2g_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_22().b2g_1;
    if (tmp1_output.co(tmp0_desc, 0) ? true : !(value.e2g_1 == null)) {
      tmp1_output.yn(tmp0_desc, 0, StringSerializer_getInstance(), value.e2g_1);
    }
    tmp1_output.wn(tmp0_desc, 1, tmp2_cached[1].f2(), value.f2g_1);
    tmp1_output.un(tmp0_desc, 2, value.g2g_1);
    tmp1_output.un(tmp0_desc, 3, value.h2g_1);
    tmp1_output.wn(tmp0_desc, 4, JsonObjectSerializer_getInstance(), value.i2g_1);
    if (tmp1_output.co(tmp0_desc, 5) ? true : !(value.j2g_1 == null)) {
      tmp1_output.yn(tmp0_desc, 5, StringSerializer_getInstance(), value.j2g_1);
    }
    if (tmp1_output.co(tmp0_desc, 6) ? true : !(value.k2g_1 == null)) {
      tmp1_output.yn(tmp0_desc, 6, DoubleSerializer_getInstance(), value.k2g_1);
    }
    if (tmp1_output.co(tmp0_desc, 7) ? true : !(value.l2g_1 == null)) {
      tmp1_output.yn(tmp0_desc, 7, DoubleSerializer_getInstance(), value.l2g_1);
    }
    if (tmp1_output.co(tmp0_desc, 8) ? true : !(value.m2g_1 == null)) {
      tmp1_output.yn(tmp0_desc, 8, StringSerializer_getInstance(), value.m2g_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_20).fj = function (encoder, value) {
    return this.d2g(encoder, value instanceof RegisterOwnBitacoraEntryRequest ? value : THROW_CCE());
  };
  protoOf($serializer_20).gj = function (decoder) {
    var tmp0_desc = this.c2g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.fm(tmp0_desc);
    var tmp14_cached = Companion_getInstance_22().b2g_1;
    if (tmp13_input.vm()) {
      tmp4_local0 = tmp13_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.rm(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.pm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.rm(tmp0_desc, 4, JsonObjectSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.tm(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.tm(tmp0_desc, 6, DoubleSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.tm(tmp0_desc, 7, DoubleSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.tm(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.rm(tmp0_desc, 1, tmp14_cached[1].f2(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.pm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.rm(tmp0_desc, 4, JsonObjectSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.tm(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.tm(tmp0_desc, 6, DoubleSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.tm(tmp0_desc, 7, DoubleSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.tm(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.gm(tmp0_desc);
    return RegisterOwnBitacoraEntryRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_20).ej = function () {
    return this.c2g_1;
  };
  protoOf($serializer_20).iu = function () {
    var tmp0_cached = Companion_getInstance_22().b2g_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), tmp0_cached[1].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), JsonObjectSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_20;
  function $serializer_getInstance_20() {
    if ($serializer_instance_20 == null)
      new $serializer_20();
    return $serializer_instance_20;
  }
  function RegisterOwnBitacoraEntryRequest_init_$Init$(seen0, instructorUserId, activityType, startedAt, endedAt, parameters, notes, latitude, longitude, locationLabel, serializationConstructorMarker, $this) {
    if (!(30 === (30 & seen0))) {
      throwMissingFieldException(seen0, 30, $serializer_getInstance_20().c2g_1);
    }
    if (0 === (seen0 & 1))
      $this.e2g_1 = null;
    else
      $this.e2g_1 = instructorUserId;
    $this.f2g_1 = activityType;
    $this.g2g_1 = startedAt;
    $this.h2g_1 = endedAt;
    $this.i2g_1 = parameters;
    if (0 === (seen0 & 32))
      $this.j2g_1 = null;
    else
      $this.j2g_1 = notes;
    if (0 === (seen0 & 64))
      $this.k2g_1 = null;
    else
      $this.k2g_1 = latitude;
    if (0 === (seen0 & 128))
      $this.l2g_1 = null;
    else
      $this.l2g_1 = longitude;
    if (0 === (seen0 & 256))
      $this.m2g_1 = null;
    else
      $this.m2g_1 = locationLabel;
    return $this;
  }
  function RegisterOwnBitacoraEntryRequest_init_$Create$(seen0, instructorUserId, activityType, startedAt, endedAt, parameters, notes, latitude, longitude, locationLabel, serializationConstructorMarker) {
    return RegisterOwnBitacoraEntryRequest_init_$Init$(seen0, instructorUserId, activityType, startedAt, endedAt, parameters, notes, latitude, longitude, locationLabel, serializationConstructorMarker, objectCreate(protoOf(RegisterOwnBitacoraEntryRequest)));
  }
  function RegisterOwnBitacoraEntryRequest(instructorUserId, activityType, startedAt, endedAt, parameters, notes, latitude, longitude, locationLabel) {
    Companion_getInstance_22();
    instructorUserId = instructorUserId === VOID ? null : instructorUserId;
    notes = notes === VOID ? null : notes;
    latitude = latitude === VOID ? null : latitude;
    longitude = longitude === VOID ? null : longitude;
    locationLabel = locationLabel === VOID ? null : locationLabel;
    this.e2g_1 = instructorUserId;
    this.f2g_1 = activityType;
    this.g2g_1 = startedAt;
    this.h2g_1 = endedAt;
    this.i2g_1 = parameters;
    this.j2g_1 = notes;
    this.k2g_1 = latitude;
    this.l2g_1 = longitude;
    this.m2g_1 = locationLabel;
  }
  protoOf(RegisterOwnBitacoraEntryRequest).toString = function () {
    return 'RegisterOwnBitacoraEntryRequest(instructorUserId=' + this.e2g_1 + ', activityType=' + this.f2g_1.toString() + ', startedAt=' + this.g2g_1 + ', endedAt=' + this.h2g_1 + ', parameters=' + this.i2g_1.toString() + ', notes=' + this.j2g_1 + ', latitude=' + this.k2g_1 + ', longitude=' + this.l2g_1 + ', locationLabel=' + this.m2g_1 + ')';
  };
  protoOf(RegisterOwnBitacoraEntryRequest).hashCode = function () {
    var result = this.e2g_1 == null ? 0 : getStringHashCode(this.e2g_1);
    result = imul(result, 31) + this.f2g_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.g2g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h2g_1) | 0;
    result = imul(result, 31) + this.i2g_1.hashCode() | 0;
    result = imul(result, 31) + (this.j2g_1 == null ? 0 : getStringHashCode(this.j2g_1)) | 0;
    result = imul(result, 31) + (this.k2g_1 == null ? 0 : getNumberHashCode(this.k2g_1)) | 0;
    result = imul(result, 31) + (this.l2g_1 == null ? 0 : getNumberHashCode(this.l2g_1)) | 0;
    result = imul(result, 31) + (this.m2g_1 == null ? 0 : getStringHashCode(this.m2g_1)) | 0;
    return result;
  };
  protoOf(RegisterOwnBitacoraEntryRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegisterOwnBitacoraEntryRequest))
      return false;
    if (!(this.e2g_1 == other.e2g_1))
      return false;
    if (!this.f2g_1.equals(other.f2g_1))
      return false;
    if (!(this.g2g_1 === other.g2g_1))
      return false;
    if (!(this.h2g_1 === other.h2g_1))
      return false;
    if (!this.i2g_1.equals(other.i2g_1))
      return false;
    if (!(this.j2g_1 == other.j2g_1))
      return false;
    if (!equals(this.k2g_1, other.k2g_1))
      return false;
    if (!equals(this.l2g_1, other.l2g_1))
      return false;
    if (!(this.m2g_1 == other.m2g_1))
      return false;
    return true;
  };
  function VerifyBitacoraEntryRequest$Companion$$childSerializers$_anonymous__2avuu3() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.VerificationDecision', values_0());
  }
  function Companion_23() {
    Companion_instance_24 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.n2g_1 = [lazy(tmp_0, VerifyBitacoraEntryRequest$Companion$$childSerializers$_anonymous__2avuu3), null];
  }
  var Companion_instance_24;
  function Companion_getInstance_23() {
    if (Companion_instance_24 == null)
      new Companion_23();
    return Companion_instance_24;
  }
  function $serializer_21() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.VerifyBitacoraEntryRequest', this, 2);
    tmp0_serialDesc.tt('decision', false);
    tmp0_serialDesc.tt('comment', true);
    this.o2g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_21).p2g = function (encoder, value) {
    var tmp0_desc = this.o2g_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_23().n2g_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.q2g_1);
    if (tmp1_output.co(tmp0_desc, 1) ? true : !(value.r2g_1 == null)) {
      tmp1_output.yn(tmp0_desc, 1, StringSerializer_getInstance(), value.r2g_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_21).fj = function (encoder, value) {
    return this.p2g(encoder, value instanceof VerifyBitacoraEntryRequest ? value : THROW_CCE());
  };
  protoOf($serializer_21).gj = function (decoder) {
    var tmp0_desc = this.o2g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    var tmp7_cached = Companion_getInstance_23().n2g_1;
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return VerifyBitacoraEntryRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_21).ej = function () {
    return this.o2g_1;
  };
  protoOf($serializer_21).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_23().n2g_1[0].f2(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_21;
  function $serializer_getInstance_21() {
    if ($serializer_instance_21 == null)
      new $serializer_21();
    return $serializer_instance_21;
  }
  function VerifyBitacoraEntryRequest_init_$Init$(seen0, decision, comment, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_21().o2g_1);
    }
    $this.q2g_1 = decision;
    if (0 === (seen0 & 2))
      $this.r2g_1 = null;
    else
      $this.r2g_1 = comment;
    return $this;
  }
  function VerifyBitacoraEntryRequest_init_$Create$(seen0, decision, comment, serializationConstructorMarker) {
    return VerifyBitacoraEntryRequest_init_$Init$(seen0, decision, comment, serializationConstructorMarker, objectCreate(protoOf(VerifyBitacoraEntryRequest)));
  }
  function VerifyBitacoraEntryRequest(decision, comment) {
    Companion_getInstance_23();
    comment = comment === VOID ? null : comment;
    this.q2g_1 = decision;
    this.r2g_1 = comment;
  }
  protoOf(VerifyBitacoraEntryRequest).toString = function () {
    return 'VerifyBitacoraEntryRequest(decision=' + this.q2g_1.toString() + ', comment=' + this.r2g_1 + ')';
  };
  protoOf(VerifyBitacoraEntryRequest).hashCode = function () {
    var result = this.q2g_1.hashCode();
    result = imul(result, 31) + (this.r2g_1 == null ? 0 : getStringHashCode(this.r2g_1)) | 0;
    return result;
  };
  protoOf(VerifyBitacoraEntryRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VerifyBitacoraEntryRequest))
      return false;
    if (!this.q2g_1.equals(other.q2g_1))
      return false;
    if (!(this.r2g_1 == other.r2g_1))
      return false;
    return true;
  };
  function $serializer_22() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.TrackPointResponse', this, 6);
    tmp0_serialDesc.tt('timestamp', false);
    tmp0_serialDesc.tt('latitude', false);
    tmp0_serialDesc.tt('longitude', false);
    tmp0_serialDesc.tt('altitudeMeters', true);
    tmp0_serialDesc.tt('heartRateBpm', true);
    tmp0_serialDesc.tt('speedMetersPerSecond', true);
    this.s2g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_22).t2g = function (encoder, value) {
    var tmp0_desc = this.s2g_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.u2g_1);
    tmp1_output.sn(tmp0_desc, 1, value.v2g_1);
    tmp1_output.sn(tmp0_desc, 2, value.w2g_1);
    if (tmp1_output.co(tmp0_desc, 3) ? true : !(value.x2g_1 == null)) {
      tmp1_output.yn(tmp0_desc, 3, DoubleSerializer_getInstance(), value.x2g_1);
    }
    if (tmp1_output.co(tmp0_desc, 4) ? true : !(value.y2g_1 == null)) {
      tmp1_output.yn(tmp0_desc, 4, IntSerializer_getInstance(), value.y2g_1);
    }
    if (tmp1_output.co(tmp0_desc, 5) ? true : !(value.z2g_1 == null)) {
      tmp1_output.yn(tmp0_desc, 5, DoubleSerializer_getInstance(), value.z2g_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_22).fj = function (encoder, value) {
    return this.t2g(encoder, value instanceof TrackPointResponse ? value : THROW_CCE());
  };
  protoOf($serializer_22).gj = function (decoder) {
    var tmp0_desc = this.s2g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.fm(tmp0_desc);
    if (tmp10_input.vm()) {
      tmp4_local0 = tmp10_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.nm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.nm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.tm(tmp0_desc, 3, DoubleSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.tm(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.tm(tmp0_desc, 5, DoubleSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.nm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.nm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.tm(tmp0_desc, 3, DoubleSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.tm(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.tm(tmp0_desc, 5, DoubleSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.gm(tmp0_desc);
    return TrackPointResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_22).ej = function () {
    return this.s2g_1;
  };
  protoOf($serializer_22).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), get_nullable(DoubleSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance())];
  };
  var $serializer_instance_22;
  function $serializer_getInstance_22() {
    if ($serializer_instance_22 == null)
      new $serializer_22();
    return $serializer_instance_22;
  }
  function TrackPointResponse_init_$Init$(seen0, timestamp, latitude, longitude, altitudeMeters, heartRateBpm, speedMetersPerSecond, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_22().s2g_1);
    }
    $this.u2g_1 = timestamp;
    $this.v2g_1 = latitude;
    $this.w2g_1 = longitude;
    if (0 === (seen0 & 8))
      $this.x2g_1 = null;
    else
      $this.x2g_1 = altitudeMeters;
    if (0 === (seen0 & 16))
      $this.y2g_1 = null;
    else
      $this.y2g_1 = heartRateBpm;
    if (0 === (seen0 & 32))
      $this.z2g_1 = null;
    else
      $this.z2g_1 = speedMetersPerSecond;
    return $this;
  }
  function TrackPointResponse_init_$Create$(seen0, timestamp, latitude, longitude, altitudeMeters, heartRateBpm, speedMetersPerSecond, serializationConstructorMarker) {
    return TrackPointResponse_init_$Init$(seen0, timestamp, latitude, longitude, altitudeMeters, heartRateBpm, speedMetersPerSecond, serializationConstructorMarker, objectCreate(protoOf(TrackPointResponse)));
  }
  function TrackPointResponse() {
  }
  protoOf(TrackPointResponse).toString = function () {
    return 'TrackPointResponse(timestamp=' + this.u2g_1 + ', latitude=' + this.v2g_1 + ', longitude=' + this.w2g_1 + ', altitudeMeters=' + this.x2g_1 + ', heartRateBpm=' + this.y2g_1 + ', speedMetersPerSecond=' + this.z2g_1 + ')';
  };
  protoOf(TrackPointResponse).hashCode = function () {
    var result = getStringHashCode(this.u2g_1);
    result = imul(result, 31) + getNumberHashCode(this.v2g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w2g_1) | 0;
    result = imul(result, 31) + (this.x2g_1 == null ? 0 : getNumberHashCode(this.x2g_1)) | 0;
    result = imul(result, 31) + (this.y2g_1 == null ? 0 : this.y2g_1) | 0;
    result = imul(result, 31) + (this.z2g_1 == null ? 0 : getNumberHashCode(this.z2g_1)) | 0;
    return result;
  };
  protoOf(TrackPointResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TrackPointResponse))
      return false;
    if (!(this.u2g_1 === other.u2g_1))
      return false;
    if (!equals(this.v2g_1, other.v2g_1))
      return false;
    if (!equals(this.w2g_1, other.w2g_1))
      return false;
    if (!equals(this.x2g_1, other.x2g_1))
      return false;
    if (!(this.y2g_1 == other.y2g_1))
      return false;
    if (!equals(this.z2g_1, other.z2g_1))
      return false;
    return true;
  };
  function ActivityTrackResponse$Companion$$childSerializers$_anonymous__aeb3il() {
    return new ArrayListSerializer($serializer_getInstance_22());
  }
  function Companion_24() {
    Companion_instance_25 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a2h_1 = [lazy(tmp_0, ActivityTrackResponse$Companion$$childSerializers$_anonymous__aeb3il)];
  }
  var Companion_instance_25;
  function Companion_getInstance_24() {
    if (Companion_instance_25 == null)
      new Companion_24();
    return Companion_instance_25;
  }
  function $serializer_23() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.ActivityTrackResponse', this, 1);
    tmp0_serialDesc.tt('points', false);
    this.b2h_1 = tmp0_serialDesc;
  }
  protoOf($serializer_23).c2h = function (encoder, value) {
    var tmp0_desc = this.b2h_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_24().a2h_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.d2h_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_23).fj = function (encoder, value) {
    return this.c2h(encoder, value instanceof ActivityTrackResponse ? value : THROW_CCE());
  };
  protoOf($serializer_23).gj = function (decoder) {
    var tmp0_desc = this.b2h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    var tmp6_cached = Companion_getInstance_24().a2h_1;
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return ActivityTrackResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_23).ej = function () {
    return this.b2h_1;
  };
  protoOf($serializer_23).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_24().a2h_1[0].f2()];
  };
  var $serializer_instance_23;
  function $serializer_getInstance_23() {
    if ($serializer_instance_23 == null)
      new $serializer_23();
    return $serializer_instance_23;
  }
  function ActivityTrackResponse_init_$Init$(seen0, points, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_23().b2h_1);
    }
    $this.d2h_1 = points;
    return $this;
  }
  function ActivityTrackResponse_init_$Create$(seen0, points, serializationConstructorMarker) {
    return ActivityTrackResponse_init_$Init$(seen0, points, serializationConstructorMarker, objectCreate(protoOf(ActivityTrackResponse)));
  }
  function ActivityTrackResponse() {
  }
  protoOf(ActivityTrackResponse).toString = function () {
    return 'ActivityTrackResponse(points=' + toString(this.d2h_1) + ')';
  };
  protoOf(ActivityTrackResponse).hashCode = function () {
    return hashCode(this.d2h_1);
  };
  protoOf(ActivityTrackResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ActivityTrackResponse))
      return false;
    if (!equals(this.d2h_1, other.d2h_1))
      return false;
    return true;
  };
  function BitacoraEntryResponse$Companion$$childSerializers$_anonymous__3z0b1i() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values());
  }
  function BitacoraEntryResponse$Companion$$childSerializers$_anonymous__3z0b1i_0() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.BitacoraEntryStatus', values_1());
  }
  function BitacoraEntryResponse$Companion$$childSerializers$_anonymous__3z0b1i_1() {
    return new ArrayListSerializer(StringSerializer_getInstance());
  }
  function Companion_25() {
    Companion_instance_26 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, BitacoraEntryResponse$Companion$$childSerializers$_anonymous__3z0b1i);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, BitacoraEntryResponse$Companion$$childSerializers$_anonymous__3z0b1i_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e2h_1 = [null, null, null, null, tmp_1, null, null, null, null, tmp_3, null, null, null, null, null, null, null, lazy(tmp_4, BitacoraEntryResponse$Companion$$childSerializers$_anonymous__3z0b1i_1)];
  }
  var Companion_instance_26;
  function Companion_getInstance_25() {
    if (Companion_instance_26 == null)
      new Companion_25();
    return Companion_instance_26;
  }
  function $serializer_24() {
    $serializer_instance_24 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.BitacoraEntryResponse', this, 18);
    tmp0_serialDesc.tt('id', false);
    tmp0_serialDesc.tt('userId', true);
    tmp0_serialDesc.tt('userDisplayName', true);
    tmp0_serialDesc.tt('verifierUserId', false);
    tmp0_serialDesc.tt('activityType', false);
    tmp0_serialDesc.tt('startedAt', false);
    tmp0_serialDesc.tt('endedAt', false);
    tmp0_serialDesc.tt('parameters', false);
    tmp0_serialDesc.tt('notes', true);
    tmp0_serialDesc.tt('status', false);
    tmp0_serialDesc.tt('companyId', true);
    tmp0_serialDesc.tt('latitude', true);
    tmp0_serialDesc.tt('longitude', true);
    tmp0_serialDesc.tt('locationLabel', true);
    tmp0_serialDesc.tt('guestName', true);
    tmp0_serialDesc.tt('guestEmail', true);
    tmp0_serialDesc.tt('track', true);
    tmp0_serialDesc.tt('photoUrls', true);
    this.f2h_1 = tmp0_serialDesc;
  }
  protoOf($serializer_24).g2h = function (encoder, value) {
    var tmp0_desc = this.f2h_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_25().e2h_1;
    tmp1_output.un(tmp0_desc, 0, value.h2h_1);
    if (tmp1_output.co(tmp0_desc, 1) ? true : !(value.i2h_1 == null)) {
      tmp1_output.yn(tmp0_desc, 1, StringSerializer_getInstance(), value.i2h_1);
    }
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.j2h_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.j2h_1);
    }
    tmp1_output.un(tmp0_desc, 3, value.k2h_1);
    tmp1_output.wn(tmp0_desc, 4, tmp2_cached[4].f2(), value.l2h_1);
    tmp1_output.un(tmp0_desc, 5, value.m2h_1);
    tmp1_output.un(tmp0_desc, 6, value.n2h_1);
    tmp1_output.wn(tmp0_desc, 7, JsonObjectSerializer_getInstance(), value.o2h_1);
    if (tmp1_output.co(tmp0_desc, 8) ? true : !(value.p2h_1 == null)) {
      tmp1_output.yn(tmp0_desc, 8, StringSerializer_getInstance(), value.p2h_1);
    }
    tmp1_output.wn(tmp0_desc, 9, tmp2_cached[9].f2(), value.q2h_1);
    if (tmp1_output.co(tmp0_desc, 10) ? true : !(value.r2h_1 == null)) {
      tmp1_output.yn(tmp0_desc, 10, StringSerializer_getInstance(), value.r2h_1);
    }
    if (tmp1_output.co(tmp0_desc, 11) ? true : !(value.s2h_1 == null)) {
      tmp1_output.yn(tmp0_desc, 11, DoubleSerializer_getInstance(), value.s2h_1);
    }
    if (tmp1_output.co(tmp0_desc, 12) ? true : !(value.t2h_1 == null)) {
      tmp1_output.yn(tmp0_desc, 12, DoubleSerializer_getInstance(), value.t2h_1);
    }
    if (tmp1_output.co(tmp0_desc, 13) ? true : !(value.u2h_1 == null)) {
      tmp1_output.yn(tmp0_desc, 13, StringSerializer_getInstance(), value.u2h_1);
    }
    if (tmp1_output.co(tmp0_desc, 14) ? true : !(value.v2h_1 == null)) {
      tmp1_output.yn(tmp0_desc, 14, StringSerializer_getInstance(), value.v2h_1);
    }
    if (tmp1_output.co(tmp0_desc, 15) ? true : !(value.w2h_1 == null)) {
      tmp1_output.yn(tmp0_desc, 15, StringSerializer_getInstance(), value.w2h_1);
    }
    if (tmp1_output.co(tmp0_desc, 16) ? true : !(value.x2h_1 == null)) {
      tmp1_output.yn(tmp0_desc, 16, $serializer_getInstance_23(), value.x2h_1);
    }
    if (tmp1_output.co(tmp0_desc, 17) ? true : !equals(value.y2h_1, emptyList())) {
      tmp1_output.wn(tmp0_desc, 17, tmp2_cached[17].f2(), value.y2h_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_24).fj = function (encoder, value) {
    return this.g2h(encoder, value instanceof BitacoraEntryResponse ? value : THROW_CCE());
  };
  protoOf($serializer_24).gj = function (decoder) {
    var tmp0_desc = this.f2h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_input = decoder.fm(tmp0_desc);
    var tmp23_cached = Companion_getInstance_25().e2h_1;
    if (tmp22_input.vm()) {
      tmp4_local0 = tmp22_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp22_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp22_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp22_input.pm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp22_input.rm(tmp0_desc, 4, tmp23_cached[4].f2(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp22_input.pm(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp22_input.pm(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp22_input.rm(tmp0_desc, 7, JsonObjectSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp22_input.tm(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp22_input.rm(tmp0_desc, 9, tmp23_cached[9].f2(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp22_input.tm(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp22_input.tm(tmp0_desc, 11, DoubleSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp22_input.tm(tmp0_desc, 12, DoubleSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp22_input.tm(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp22_input.tm(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp22_input.tm(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp22_input.tm(tmp0_desc, 16, $serializer_getInstance_23(), tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp22_input.rm(tmp0_desc, 17, tmp23_cached[17].f2(), tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp22_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp22_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp22_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp22_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp22_input.pm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp22_input.rm(tmp0_desc, 4, tmp23_cached[4].f2(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp22_input.pm(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp22_input.pm(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp22_input.rm(tmp0_desc, 7, JsonObjectSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp22_input.tm(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp22_input.rm(tmp0_desc, 9, tmp23_cached[9].f2(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp22_input.tm(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp22_input.tm(tmp0_desc, 11, DoubleSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp22_input.tm(tmp0_desc, 12, DoubleSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp22_input.tm(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp22_input.tm(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp22_input.tm(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp22_input.tm(tmp0_desc, 16, $serializer_getInstance_23(), tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp22_input.rm(tmp0_desc, 17, tmp23_cached[17].f2(), tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp22_input.gm(tmp0_desc);
    return BitacoraEntryResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, null);
  };
  protoOf($serializer_24).ej = function () {
    return this.f2h_1;
  };
  protoOf($serializer_24).iu = function () {
    var tmp0_cached = Companion_getInstance_25().e2h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[4].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), JsonObjectSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[9].f2(), get_nullable(StringSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_23()), tmp0_cached[17].f2()];
  };
  var $serializer_instance_24;
  function $serializer_getInstance_24() {
    if ($serializer_instance_24 == null)
      new $serializer_24();
    return $serializer_instance_24;
  }
  function BitacoraEntryResponse_init_$Init$(seen0, id, userId, userDisplayName, verifierUserId, activityType, startedAt, endedAt, parameters, notes, status, companyId, latitude, longitude, locationLabel, guestName, guestEmail, track, photoUrls, serializationConstructorMarker, $this) {
    if (!(761 === (761 & seen0))) {
      throwMissingFieldException(seen0, 761, $serializer_getInstance_24().f2h_1);
    }
    $this.h2h_1 = id;
    if (0 === (seen0 & 2))
      $this.i2h_1 = null;
    else
      $this.i2h_1 = userId;
    if (0 === (seen0 & 4))
      $this.j2h_1 = null;
    else
      $this.j2h_1 = userDisplayName;
    $this.k2h_1 = verifierUserId;
    $this.l2h_1 = activityType;
    $this.m2h_1 = startedAt;
    $this.n2h_1 = endedAt;
    $this.o2h_1 = parameters;
    if (0 === (seen0 & 256))
      $this.p2h_1 = null;
    else
      $this.p2h_1 = notes;
    $this.q2h_1 = status;
    if (0 === (seen0 & 1024))
      $this.r2h_1 = null;
    else
      $this.r2h_1 = companyId;
    if (0 === (seen0 & 2048))
      $this.s2h_1 = null;
    else
      $this.s2h_1 = latitude;
    if (0 === (seen0 & 4096))
      $this.t2h_1 = null;
    else
      $this.t2h_1 = longitude;
    if (0 === (seen0 & 8192))
      $this.u2h_1 = null;
    else
      $this.u2h_1 = locationLabel;
    if (0 === (seen0 & 16384))
      $this.v2h_1 = null;
    else
      $this.v2h_1 = guestName;
    if (0 === (seen0 & 32768))
      $this.w2h_1 = null;
    else
      $this.w2h_1 = guestEmail;
    if (0 === (seen0 & 65536))
      $this.x2h_1 = null;
    else
      $this.x2h_1 = track;
    if (0 === (seen0 & 131072))
      $this.y2h_1 = emptyList();
    else
      $this.y2h_1 = photoUrls;
    return $this;
  }
  function BitacoraEntryResponse_init_$Create$(seen0, id, userId, userDisplayName, verifierUserId, activityType, startedAt, endedAt, parameters, notes, status, companyId, latitude, longitude, locationLabel, guestName, guestEmail, track, photoUrls, serializationConstructorMarker) {
    return BitacoraEntryResponse_init_$Init$(seen0, id, userId, userDisplayName, verifierUserId, activityType, startedAt, endedAt, parameters, notes, status, companyId, latitude, longitude, locationLabel, guestName, guestEmail, track, photoUrls, serializationConstructorMarker, objectCreate(protoOf(BitacoraEntryResponse)));
  }
  function BitacoraEntryResponse(id, userId, userDisplayName, verifierUserId, activityType, startedAt, endedAt, parameters, notes, status, companyId, latitude, longitude, locationLabel, guestName, guestEmail, track, photoUrls) {
    Companion_getInstance_25();
    userId = userId === VOID ? null : userId;
    userDisplayName = userDisplayName === VOID ? null : userDisplayName;
    notes = notes === VOID ? null : notes;
    companyId = companyId === VOID ? null : companyId;
    latitude = latitude === VOID ? null : latitude;
    longitude = longitude === VOID ? null : longitude;
    locationLabel = locationLabel === VOID ? null : locationLabel;
    guestName = guestName === VOID ? null : guestName;
    guestEmail = guestEmail === VOID ? null : guestEmail;
    track = track === VOID ? null : track;
    photoUrls = photoUrls === VOID ? emptyList() : photoUrls;
    this.h2h_1 = id;
    this.i2h_1 = userId;
    this.j2h_1 = userDisplayName;
    this.k2h_1 = verifierUserId;
    this.l2h_1 = activityType;
    this.m2h_1 = startedAt;
    this.n2h_1 = endedAt;
    this.o2h_1 = parameters;
    this.p2h_1 = notes;
    this.q2h_1 = status;
    this.r2h_1 = companyId;
    this.s2h_1 = latitude;
    this.t2h_1 = longitude;
    this.u2h_1 = locationLabel;
    this.v2h_1 = guestName;
    this.w2h_1 = guestEmail;
    this.x2h_1 = track;
    this.y2h_1 = photoUrls;
  }
  protoOf(BitacoraEntryResponse).toString = function () {
    return 'BitacoraEntryResponse(id=' + this.h2h_1 + ', userId=' + this.i2h_1 + ', userDisplayName=' + this.j2h_1 + ', verifierUserId=' + this.k2h_1 + ', activityType=' + this.l2h_1.toString() + ', startedAt=' + this.m2h_1 + ', endedAt=' + this.n2h_1 + ', parameters=' + this.o2h_1.toString() + ', notes=' + this.p2h_1 + ', status=' + this.q2h_1.toString() + ', companyId=' + this.r2h_1 + ', latitude=' + this.s2h_1 + ', longitude=' + this.t2h_1 + ', locationLabel=' + this.u2h_1 + ', guestName=' + this.v2h_1 + ', guestEmail=' + this.w2h_1 + ', track=' + toString_0(this.x2h_1) + ', photoUrls=' + toString(this.y2h_1) + ')';
  };
  protoOf(BitacoraEntryResponse).hashCode = function () {
    var result = getStringHashCode(this.h2h_1);
    result = imul(result, 31) + (this.i2h_1 == null ? 0 : getStringHashCode(this.i2h_1)) | 0;
    result = imul(result, 31) + (this.j2h_1 == null ? 0 : getStringHashCode(this.j2h_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.k2h_1) | 0;
    result = imul(result, 31) + this.l2h_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.m2h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n2h_1) | 0;
    result = imul(result, 31) + this.o2h_1.hashCode() | 0;
    result = imul(result, 31) + (this.p2h_1 == null ? 0 : getStringHashCode(this.p2h_1)) | 0;
    result = imul(result, 31) + this.q2h_1.hashCode() | 0;
    result = imul(result, 31) + (this.r2h_1 == null ? 0 : getStringHashCode(this.r2h_1)) | 0;
    result = imul(result, 31) + (this.s2h_1 == null ? 0 : getNumberHashCode(this.s2h_1)) | 0;
    result = imul(result, 31) + (this.t2h_1 == null ? 0 : getNumberHashCode(this.t2h_1)) | 0;
    result = imul(result, 31) + (this.u2h_1 == null ? 0 : getStringHashCode(this.u2h_1)) | 0;
    result = imul(result, 31) + (this.v2h_1 == null ? 0 : getStringHashCode(this.v2h_1)) | 0;
    result = imul(result, 31) + (this.w2h_1 == null ? 0 : getStringHashCode(this.w2h_1)) | 0;
    result = imul(result, 31) + (this.x2h_1 == null ? 0 : this.x2h_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.y2h_1) | 0;
    return result;
  };
  protoOf(BitacoraEntryResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BitacoraEntryResponse))
      return false;
    if (!(this.h2h_1 === other.h2h_1))
      return false;
    if (!(this.i2h_1 == other.i2h_1))
      return false;
    if (!(this.j2h_1 == other.j2h_1))
      return false;
    if (!(this.k2h_1 === other.k2h_1))
      return false;
    if (!this.l2h_1.equals(other.l2h_1))
      return false;
    if (!(this.m2h_1 === other.m2h_1))
      return false;
    if (!(this.n2h_1 === other.n2h_1))
      return false;
    if (!this.o2h_1.equals(other.o2h_1))
      return false;
    if (!(this.p2h_1 == other.p2h_1))
      return false;
    if (!this.q2h_1.equals(other.q2h_1))
      return false;
    if (!(this.r2h_1 == other.r2h_1))
      return false;
    if (!equals(this.s2h_1, other.s2h_1))
      return false;
    if (!equals(this.t2h_1, other.t2h_1))
      return false;
    if (!(this.u2h_1 == other.u2h_1))
      return false;
    if (!(this.v2h_1 == other.v2h_1))
      return false;
    if (!(this.w2h_1 == other.w2h_1))
      return false;
    if (!equals(this.x2h_1, other.x2h_1))
      return false;
    if (!equals(this.y2h_1, other.y2h_1))
      return false;
    return true;
  };
  function TrackImportResponse$Companion$$childSerializers$_anonymous__9sohmh() {
    return new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance());
  }
  function TrackImportResponse$Companion$$childSerializers$_anonymous__9sohmh_0() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values());
  }
  function Companion_26() {
    Companion_instance_27 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, TrackImportResponse$Companion$$childSerializers$_anonymous__9sohmh);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z2h_1 = [null, tmp_1, lazy(tmp_2, TrackImportResponse$Companion$$childSerializers$_anonymous__9sohmh_0)];
  }
  var Companion_instance_27;
  function Companion_getInstance_26() {
    if (Companion_instance_27 == null)
      new Companion_26();
    return Companion_instance_27;
  }
  function $serializer_25() {
    $serializer_instance_25 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.TrackImportResponse', this, 3);
    tmp0_serialDesc.tt('entry', false);
    tmp0_serialDesc.tt('summary', false);
    tmp0_serialDesc.tt('suggestedActivityType', true);
    this.a2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_25).b2i = function (encoder, value) {
    var tmp0_desc = this.a2i_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_26().z2h_1;
    tmp1_output.wn(tmp0_desc, 0, $serializer_getInstance_24(), value.c2i_1);
    tmp1_output.wn(tmp0_desc, 1, tmp2_cached[1].f2(), value.d2i_1);
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.e2i_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, tmp2_cached[2].f2(), value.e2i_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_25).fj = function (encoder, value) {
    return this.b2i(encoder, value instanceof TrackImportResponse ? value : THROW_CCE());
  };
  protoOf($serializer_25).gj = function (decoder) {
    var tmp0_desc = this.a2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    var tmp8_cached = Companion_getInstance_26().z2h_1;
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.rm(tmp0_desc, 0, $serializer_getInstance_24(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.rm(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.rm(tmp0_desc, 0, $serializer_getInstance_24(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.rm(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return TrackImportResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_25).ej = function () {
    return this.a2i_1;
  };
  protoOf($serializer_25).iu = function () {
    var tmp0_cached = Companion_getInstance_26().z2h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_24(), tmp0_cached[1].f2(), get_nullable(tmp0_cached[2].f2())];
  };
  var $serializer_instance_25;
  function $serializer_getInstance_25() {
    if ($serializer_instance_25 == null)
      new $serializer_25();
    return $serializer_instance_25;
  }
  function TrackImportResponse_init_$Init$(seen0, entry, summary, suggestedActivityType, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_25().a2i_1);
    }
    $this.c2i_1 = entry;
    $this.d2i_1 = summary;
    if (0 === (seen0 & 4))
      $this.e2i_1 = null;
    else
      $this.e2i_1 = suggestedActivityType;
    return $this;
  }
  function TrackImportResponse_init_$Create$(seen0, entry, summary, suggestedActivityType, serializationConstructorMarker) {
    return TrackImportResponse_init_$Init$(seen0, entry, summary, suggestedActivityType, serializationConstructorMarker, objectCreate(protoOf(TrackImportResponse)));
  }
  function TrackImportResponse(entry, summary, suggestedActivityType) {
    Companion_getInstance_26();
    suggestedActivityType = suggestedActivityType === VOID ? null : suggestedActivityType;
    this.c2i_1 = entry;
    this.d2i_1 = summary;
    this.e2i_1 = suggestedActivityType;
  }
  protoOf(TrackImportResponse).toString = function () {
    return 'TrackImportResponse(entry=' + this.c2i_1.toString() + ', summary=' + toString(this.d2i_1) + ', suggestedActivityType=' + toString_0(this.e2i_1) + ')';
  };
  protoOf(TrackImportResponse).hashCode = function () {
    var result = this.c2i_1.hashCode();
    result = imul(result, 31) + hashCode(this.d2i_1) | 0;
    result = imul(result, 31) + (this.e2i_1 == null ? 0 : this.e2i_1.hashCode()) | 0;
    return result;
  };
  protoOf(TrackImportResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TrackImportResponse))
      return false;
    if (!this.c2i_1.equals(other.c2i_1))
      return false;
    if (!equals(this.d2i_1, other.d2i_1))
      return false;
    if (!equals(this.e2i_1, other.e2i_1))
      return false;
    return true;
  };
  function SetMyRegisteredActivitiesRequest$Companion$$childSerializers$_anonymous__cl41xk() {
    return new LinkedHashSetSerializer(createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values()));
  }
  function Companion_27() {
    Companion_instance_28 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f2i_1 = [lazy(tmp_0, SetMyRegisteredActivitiesRequest$Companion$$childSerializers$_anonymous__cl41xk), null];
  }
  var Companion_instance_28;
  function Companion_getInstance_27() {
    if (Companion_instance_28 == null)
      new Companion_27();
    return Companion_instance_28;
  }
  function $serializer_26() {
    $serializer_instance_26 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.SetMyRegisteredActivitiesRequest', this, 2);
    tmp0_serialDesc.tt('activityTypes', false);
    tmp0_serialDesc.tt('confirmedDeletions', true);
    this.g2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_26).h2i = function (encoder, value) {
    var tmp0_desc = this.g2i_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_27().f2i_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.i2i_1);
    if (tmp1_output.co(tmp0_desc, 1) ? true : !(value.j2i_1 === false)) {
      tmp1_output.mn(tmp0_desc, 1, value.j2i_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_26).fj = function (encoder, value) {
    return this.h2i(encoder, value instanceof SetMyRegisteredActivitiesRequest ? value : THROW_CCE());
  };
  protoOf($serializer_26).gj = function (decoder) {
    var tmp0_desc = this.g2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.fm(tmp0_desc);
    var tmp7_cached = Companion_getInstance_27().f2i_1;
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.hm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.hm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return SetMyRegisteredActivitiesRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_26).ej = function () {
    return this.g2i_1;
  };
  protoOf($serializer_26).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_27().f2i_1[0].f2(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_26;
  function $serializer_getInstance_26() {
    if ($serializer_instance_26 == null)
      new $serializer_26();
    return $serializer_instance_26;
  }
  function SetMyRegisteredActivitiesRequest_init_$Init$(seen0, activityTypes, confirmedDeletions, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_26().g2i_1);
    }
    $this.i2i_1 = activityTypes;
    if (0 === (seen0 & 2))
      $this.j2i_1 = false;
    else
      $this.j2i_1 = confirmedDeletions;
    return $this;
  }
  function SetMyRegisteredActivitiesRequest_init_$Create$(seen0, activityTypes, confirmedDeletions, serializationConstructorMarker) {
    return SetMyRegisteredActivitiesRequest_init_$Init$(seen0, activityTypes, confirmedDeletions, serializationConstructorMarker, objectCreate(protoOf(SetMyRegisteredActivitiesRequest)));
  }
  function SetMyRegisteredActivitiesRequest(activityTypes, confirmedDeletions) {
    Companion_getInstance_27();
    confirmedDeletions = confirmedDeletions === VOID ? false : confirmedDeletions;
    this.i2i_1 = activityTypes;
    this.j2i_1 = confirmedDeletions;
  }
  protoOf(SetMyRegisteredActivitiesRequest).toString = function () {
    return 'SetMyRegisteredActivitiesRequest(activityTypes=' + toString(this.i2i_1) + ', confirmedDeletions=' + this.j2i_1 + ')';
  };
  protoOf(SetMyRegisteredActivitiesRequest).hashCode = function () {
    var result = hashCode(this.i2i_1);
    result = imul(result, 31) + getBooleanHashCode(this.j2i_1) | 0;
    return result;
  };
  protoOf(SetMyRegisteredActivitiesRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetMyRegisteredActivitiesRequest))
      return false;
    if (!equals(this.i2i_1, other.i2i_1))
      return false;
    if (!(this.j2i_1 === other.j2i_1))
      return false;
    return true;
  };
  function Companion_28() {
  }
  var Companion_instance_29;
  function Companion_getInstance_28() {
    return Companion_instance_29;
  }
  function $serializer_27() {
    $serializer_instance_27 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.InstructorCandidateResponse', this, 2);
    tmp0_serialDesc.tt('userId', false);
    tmp0_serialDesc.tt('displayName', false);
    this.k2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_27).l2i = function (encoder, value) {
    var tmp0_desc = this.k2i_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.m2i_1);
    tmp1_output.un(tmp0_desc, 1, value.n2i_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_27).fj = function (encoder, value) {
    return this.l2i(encoder, value instanceof InstructorCandidateResponse ? value : THROW_CCE());
  };
  protoOf($serializer_27).gj = function (decoder) {
    var tmp0_desc = this.k2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return InstructorCandidateResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_27).ej = function () {
    return this.k2i_1;
  };
  protoOf($serializer_27).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_27;
  function $serializer_getInstance_27() {
    if ($serializer_instance_27 == null)
      new $serializer_27();
    return $serializer_instance_27;
  }
  function InstructorCandidateResponse_init_$Init$(seen0, userId, displayName, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_27().k2i_1);
    }
    $this.m2i_1 = userId;
    $this.n2i_1 = displayName;
    return $this;
  }
  function InstructorCandidateResponse_init_$Create$(seen0, userId, displayName, serializationConstructorMarker) {
    return InstructorCandidateResponse_init_$Init$(seen0, userId, displayName, serializationConstructorMarker, objectCreate(protoOf(InstructorCandidateResponse)));
  }
  function InstructorCandidateResponse(userId, displayName) {
    this.m2i_1 = userId;
    this.n2i_1 = displayName;
  }
  protoOf(InstructorCandidateResponse).toString = function () {
    return 'InstructorCandidateResponse(userId=' + this.m2i_1 + ', displayName=' + this.n2i_1 + ')';
  };
  protoOf(InstructorCandidateResponse).hashCode = function () {
    var result = getStringHashCode(this.m2i_1);
    result = imul(result, 31) + getStringHashCode(this.n2i_1) | 0;
    return result;
  };
  protoOf(InstructorCandidateResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InstructorCandidateResponse))
      return false;
    if (!(this.m2i_1 === other.m2i_1))
      return false;
    if (!(this.n2i_1 === other.n2i_1))
      return false;
    return true;
  };
  function Companion_29() {
  }
  var Companion_instance_30;
  function Companion_getInstance_29() {
    return Companion_instance_30;
  }
  function $serializer_28() {
    $serializer_instance_28 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.InviteToClaimEntryRequest', this, 1);
    tmp0_serialDesc.tt('email', false);
    this.o2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_28).p2i = function (encoder, value) {
    var tmp0_desc = this.o2i_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.q2i_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_28).fj = function (encoder, value) {
    return this.p2i(encoder, value instanceof InviteToClaimEntryRequest ? value : THROW_CCE());
  };
  protoOf($serializer_28).gj = function (decoder) {
    var tmp0_desc = this.o2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return InviteToClaimEntryRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_28).ej = function () {
    return this.o2i_1;
  };
  protoOf($serializer_28).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_28;
  function $serializer_getInstance_28() {
    if ($serializer_instance_28 == null)
      new $serializer_28();
    return $serializer_instance_28;
  }
  function InviteToClaimEntryRequest_init_$Init$(seen0, email, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_28().o2i_1);
    }
    $this.q2i_1 = email;
    return $this;
  }
  function InviteToClaimEntryRequest_init_$Create$(seen0, email, serializationConstructorMarker) {
    return InviteToClaimEntryRequest_init_$Init$(seen0, email, serializationConstructorMarker, objectCreate(protoOf(InviteToClaimEntryRequest)));
  }
  function InviteToClaimEntryRequest(email) {
    this.q2i_1 = email;
  }
  protoOf(InviteToClaimEntryRequest).toString = function () {
    return 'InviteToClaimEntryRequest(email=' + this.q2i_1 + ')';
  };
  protoOf(InviteToClaimEntryRequest).hashCode = function () {
    return getStringHashCode(this.q2i_1);
  };
  protoOf(InviteToClaimEntryRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InviteToClaimEntryRequest))
      return false;
    if (!(this.q2i_1 === other.q2i_1))
      return false;
    return true;
  };
  function Companion_30() {
  }
  var Companion_instance_31;
  function Companion_getInstance_30() {
    return Companion_instance_31;
  }
  function $serializer_29() {
    $serializer_instance_29 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.ClaimInvitationOutcomeResponse', this, 2);
    tmp0_serialDesc.tt('outcome', false);
    tmp0_serialDesc.tt('email', false);
    this.r2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_29).s2i = function (encoder, value) {
    var tmp0_desc = this.r2i_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.t2i_1);
    tmp1_output.un(tmp0_desc, 1, value.u2i_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_29).fj = function (encoder, value) {
    return this.s2i(encoder, value instanceof ClaimInvitationOutcomeResponse ? value : THROW_CCE());
  };
  protoOf($serializer_29).gj = function (decoder) {
    var tmp0_desc = this.r2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return ClaimInvitationOutcomeResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_29).ej = function () {
    return this.r2i_1;
  };
  protoOf($serializer_29).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_29;
  function $serializer_getInstance_29() {
    if ($serializer_instance_29 == null)
      new $serializer_29();
    return $serializer_instance_29;
  }
  function ClaimInvitationOutcomeResponse_init_$Init$(seen0, outcome, email, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_29().r2i_1);
    }
    $this.t2i_1 = outcome;
    $this.u2i_1 = email;
    return $this;
  }
  function ClaimInvitationOutcomeResponse_init_$Create$(seen0, outcome, email, serializationConstructorMarker) {
    return ClaimInvitationOutcomeResponse_init_$Init$(seen0, outcome, email, serializationConstructorMarker, objectCreate(protoOf(ClaimInvitationOutcomeResponse)));
  }
  function ClaimInvitationOutcomeResponse(outcome, email) {
    this.t2i_1 = outcome;
    this.u2i_1 = email;
  }
  protoOf(ClaimInvitationOutcomeResponse).toString = function () {
    return 'ClaimInvitationOutcomeResponse(outcome=' + this.t2i_1 + ', email=' + this.u2i_1 + ')';
  };
  protoOf(ClaimInvitationOutcomeResponse).hashCode = function () {
    var result = getStringHashCode(this.t2i_1);
    result = imul(result, 31) + getStringHashCode(this.u2i_1) | 0;
    return result;
  };
  protoOf(ClaimInvitationOutcomeResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ClaimInvitationOutcomeResponse))
      return false;
    if (!(this.t2i_1 === other.t2i_1))
      return false;
    if (!(this.u2i_1 === other.u2i_1))
      return false;
    return true;
  };
  function RegisterCenterBitacoraEntryRequest$Companion$$childSerializers$_anonymous__2j73cq() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values());
  }
  function Companion_31() {
    Companion_instance_32 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v2i_1 = [null, null, null, lazy(tmp_0, RegisterCenterBitacoraEntryRequest$Companion$$childSerializers$_anonymous__2j73cq), null, null, null, null, null, null, null];
  }
  var Companion_instance_32;
  function Companion_getInstance_31() {
    if (Companion_instance_32 == null)
      new Companion_31();
    return Companion_instance_32;
  }
  function $serializer_30() {
    $serializer_instance_30 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.RegisterCenterBitacoraEntryRequest', this, 11);
    tmp0_serialDesc.tt('practitionerUserId', true);
    tmp0_serialDesc.tt('guestName', true);
    tmp0_serialDesc.tt('guestEmail', true);
    tmp0_serialDesc.tt('activityType', false);
    tmp0_serialDesc.tt('startedAt', false);
    tmp0_serialDesc.tt('endedAt', false);
    tmp0_serialDesc.tt('parameters', false);
    tmp0_serialDesc.tt('notes', true);
    tmp0_serialDesc.tt('latitude', true);
    tmp0_serialDesc.tt('longitude', true);
    tmp0_serialDesc.tt('locationLabel', true);
    this.w2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_30).x2i = function (encoder, value) {
    var tmp0_desc = this.w2i_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_31().v2i_1;
    if (tmp1_output.co(tmp0_desc, 0) ? true : !(value.y2i_1 == null)) {
      tmp1_output.yn(tmp0_desc, 0, StringSerializer_getInstance(), value.y2i_1);
    }
    if (tmp1_output.co(tmp0_desc, 1) ? true : !(value.z2i_1 == null)) {
      tmp1_output.yn(tmp0_desc, 1, StringSerializer_getInstance(), value.z2i_1);
    }
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.a2j_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.a2j_1);
    }
    tmp1_output.wn(tmp0_desc, 3, tmp2_cached[3].f2(), value.b2j_1);
    tmp1_output.un(tmp0_desc, 4, value.c2j_1);
    tmp1_output.un(tmp0_desc, 5, value.d2j_1);
    tmp1_output.wn(tmp0_desc, 6, JsonObjectSerializer_getInstance(), value.e2j_1);
    if (tmp1_output.co(tmp0_desc, 7) ? true : !(value.f2j_1 == null)) {
      tmp1_output.yn(tmp0_desc, 7, StringSerializer_getInstance(), value.f2j_1);
    }
    if (tmp1_output.co(tmp0_desc, 8) ? true : !(value.g2j_1 == null)) {
      tmp1_output.yn(tmp0_desc, 8, DoubleSerializer_getInstance(), value.g2j_1);
    }
    if (tmp1_output.co(tmp0_desc, 9) ? true : !(value.h2j_1 == null)) {
      tmp1_output.yn(tmp0_desc, 9, DoubleSerializer_getInstance(), value.h2j_1);
    }
    if (tmp1_output.co(tmp0_desc, 10) ? true : !(value.i2j_1 == null)) {
      tmp1_output.yn(tmp0_desc, 10, StringSerializer_getInstance(), value.i2j_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_30).fj = function (encoder, value) {
    return this.x2i(encoder, value instanceof RegisterCenterBitacoraEntryRequest ? value : THROW_CCE());
  };
  protoOf($serializer_30).gj = function (decoder) {
    var tmp0_desc = this.w2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.fm(tmp0_desc);
    var tmp16_cached = Companion_getInstance_31().v2i_1;
    if (tmp15_input.vm()) {
      tmp4_local0 = tmp15_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.rm(tmp0_desc, 3, tmp16_cached[3].f2(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.pm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.pm(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.rm(tmp0_desc, 6, JsonObjectSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.tm(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.tm(tmp0_desc, 8, DoubleSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.tm(tmp0_desc, 9, DoubleSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.tm(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.rm(tmp0_desc, 3, tmp16_cached[3].f2(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.pm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.pm(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.rm(tmp0_desc, 6, JsonObjectSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.tm(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.tm(tmp0_desc, 8, DoubleSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.tm(tmp0_desc, 9, DoubleSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.tm(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.gm(tmp0_desc);
    return RegisterCenterBitacoraEntryRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_30).ej = function () {
    return this.w2i_1;
  };
  protoOf($serializer_30).iu = function () {
    var tmp0_cached = Companion_getInstance_31().v2i_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[3].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), JsonObjectSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_30;
  function $serializer_getInstance_30() {
    if ($serializer_instance_30 == null)
      new $serializer_30();
    return $serializer_instance_30;
  }
  function RegisterCenterBitacoraEntryRequest_init_$Init$(seen0, practitionerUserId, guestName, guestEmail, activityType, startedAt, endedAt, parameters, notes, latitude, longitude, locationLabel, serializationConstructorMarker, $this) {
    if (!(120 === (120 & seen0))) {
      throwMissingFieldException(seen0, 120, $serializer_getInstance_30().w2i_1);
    }
    if (0 === (seen0 & 1))
      $this.y2i_1 = null;
    else
      $this.y2i_1 = practitionerUserId;
    if (0 === (seen0 & 2))
      $this.z2i_1 = null;
    else
      $this.z2i_1 = guestName;
    if (0 === (seen0 & 4))
      $this.a2j_1 = null;
    else
      $this.a2j_1 = guestEmail;
    $this.b2j_1 = activityType;
    $this.c2j_1 = startedAt;
    $this.d2j_1 = endedAt;
    $this.e2j_1 = parameters;
    if (0 === (seen0 & 128))
      $this.f2j_1 = null;
    else
      $this.f2j_1 = notes;
    if (0 === (seen0 & 256))
      $this.g2j_1 = null;
    else
      $this.g2j_1 = latitude;
    if (0 === (seen0 & 512))
      $this.h2j_1 = null;
    else
      $this.h2j_1 = longitude;
    if (0 === (seen0 & 1024))
      $this.i2j_1 = null;
    else
      $this.i2j_1 = locationLabel;
    return $this;
  }
  function RegisterCenterBitacoraEntryRequest_init_$Create$(seen0, practitionerUserId, guestName, guestEmail, activityType, startedAt, endedAt, parameters, notes, latitude, longitude, locationLabel, serializationConstructorMarker) {
    return RegisterCenterBitacoraEntryRequest_init_$Init$(seen0, practitionerUserId, guestName, guestEmail, activityType, startedAt, endedAt, parameters, notes, latitude, longitude, locationLabel, serializationConstructorMarker, objectCreate(protoOf(RegisterCenterBitacoraEntryRequest)));
  }
  function RegisterCenterBitacoraEntryRequest(practitionerUserId, guestName, guestEmail, activityType, startedAt, endedAt, parameters, notes, latitude, longitude, locationLabel) {
    Companion_getInstance_31();
    practitionerUserId = practitionerUserId === VOID ? null : practitionerUserId;
    guestName = guestName === VOID ? null : guestName;
    guestEmail = guestEmail === VOID ? null : guestEmail;
    notes = notes === VOID ? null : notes;
    latitude = latitude === VOID ? null : latitude;
    longitude = longitude === VOID ? null : longitude;
    locationLabel = locationLabel === VOID ? null : locationLabel;
    this.y2i_1 = practitionerUserId;
    this.z2i_1 = guestName;
    this.a2j_1 = guestEmail;
    this.b2j_1 = activityType;
    this.c2j_1 = startedAt;
    this.d2j_1 = endedAt;
    this.e2j_1 = parameters;
    this.f2j_1 = notes;
    this.g2j_1 = latitude;
    this.h2j_1 = longitude;
    this.i2j_1 = locationLabel;
  }
  protoOf(RegisterCenterBitacoraEntryRequest).toString = function () {
    return 'RegisterCenterBitacoraEntryRequest(practitionerUserId=' + this.y2i_1 + ', guestName=' + this.z2i_1 + ', guestEmail=' + this.a2j_1 + ', activityType=' + this.b2j_1.toString() + ', startedAt=' + this.c2j_1 + ', endedAt=' + this.d2j_1 + ', parameters=' + this.e2j_1.toString() + ', notes=' + this.f2j_1 + ', latitude=' + this.g2j_1 + ', longitude=' + this.h2j_1 + ', locationLabel=' + this.i2j_1 + ')';
  };
  protoOf(RegisterCenterBitacoraEntryRequest).hashCode = function () {
    var result = this.y2i_1 == null ? 0 : getStringHashCode(this.y2i_1);
    result = imul(result, 31) + (this.z2i_1 == null ? 0 : getStringHashCode(this.z2i_1)) | 0;
    result = imul(result, 31) + (this.a2j_1 == null ? 0 : getStringHashCode(this.a2j_1)) | 0;
    result = imul(result, 31) + this.b2j_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.c2j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d2j_1) | 0;
    result = imul(result, 31) + this.e2j_1.hashCode() | 0;
    result = imul(result, 31) + (this.f2j_1 == null ? 0 : getStringHashCode(this.f2j_1)) | 0;
    result = imul(result, 31) + (this.g2j_1 == null ? 0 : getNumberHashCode(this.g2j_1)) | 0;
    result = imul(result, 31) + (this.h2j_1 == null ? 0 : getNumberHashCode(this.h2j_1)) | 0;
    result = imul(result, 31) + (this.i2j_1 == null ? 0 : getStringHashCode(this.i2j_1)) | 0;
    return result;
  };
  protoOf(RegisterCenterBitacoraEntryRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegisterCenterBitacoraEntryRequest))
      return false;
    if (!(this.y2i_1 == other.y2i_1))
      return false;
    if (!(this.z2i_1 == other.z2i_1))
      return false;
    if (!(this.a2j_1 == other.a2j_1))
      return false;
    if (!this.b2j_1.equals(other.b2j_1))
      return false;
    if (!(this.c2j_1 === other.c2j_1))
      return false;
    if (!(this.d2j_1 === other.d2j_1))
      return false;
    if (!this.e2j_1.equals(other.e2j_1))
      return false;
    if (!(this.f2j_1 == other.f2j_1))
      return false;
    if (!equals(this.g2j_1, other.g2j_1))
      return false;
    if (!equals(this.h2j_1, other.h2j_1))
      return false;
    if (!(this.i2j_1 == other.i2j_1))
      return false;
    return true;
  };
  function Companion_32() {
  }
  var Companion_instance_33;
  function Companion_getInstance_32() {
    return Companion_instance_33;
  }
  function $serializer_31() {
    $serializer_instance_31 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.GeocodeResultResponse', this, 3);
    tmp0_serialDesc.tt('displayName', false);
    tmp0_serialDesc.tt('latitude', false);
    tmp0_serialDesc.tt('longitude', false);
    this.j2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_31).k2j = function (encoder, value) {
    var tmp0_desc = this.j2j_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.r2a_1);
    tmp1_output.sn(tmp0_desc, 1, value.s2a_1);
    tmp1_output.sn(tmp0_desc, 2, value.t2a_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_31).fj = function (encoder, value) {
    return this.k2j(encoder, value instanceof GeocodeResultResponse ? value : THROW_CCE());
  };
  protoOf($serializer_31).gj = function (decoder) {
    var tmp0_desc = this.j2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.nm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.nm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.nm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.nm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return GeocodeResultResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_31).ej = function () {
    return this.j2j_1;
  };
  protoOf($serializer_31).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  var $serializer_instance_31;
  function $serializer_getInstance_31() {
    if ($serializer_instance_31 == null)
      new $serializer_31();
    return $serializer_instance_31;
  }
  function GeocodeResultResponse_init_$Init$(seen0, displayName, latitude, longitude, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_31().j2j_1);
    }
    $this.r2a_1 = displayName;
    $this.s2a_1 = latitude;
    $this.t2a_1 = longitude;
    return $this;
  }
  function GeocodeResultResponse_init_$Create$(seen0, displayName, latitude, longitude, serializationConstructorMarker) {
    return GeocodeResultResponse_init_$Init$(seen0, displayName, latitude, longitude, serializationConstructorMarker, objectCreate(protoOf(GeocodeResultResponse)));
  }
  function GeocodeResultResponse(displayName, latitude, longitude) {
    this.r2a_1 = displayName;
    this.s2a_1 = latitude;
    this.t2a_1 = longitude;
  }
  protoOf(GeocodeResultResponse).toString = function () {
    return 'GeocodeResultResponse(displayName=' + this.r2a_1 + ', latitude=' + this.s2a_1 + ', longitude=' + this.t2a_1 + ')';
  };
  protoOf(GeocodeResultResponse).hashCode = function () {
    var result = getStringHashCode(this.r2a_1);
    result = imul(result, 31) + getNumberHashCode(this.s2a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t2a_1) | 0;
    return result;
  };
  protoOf(GeocodeResultResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GeocodeResultResponse))
      return false;
    if (!(this.r2a_1 === other.r2a_1))
      return false;
    if (!equals(this.s2a_1, other.s2a_1))
      return false;
    if (!equals(this.t2a_1, other.t2a_1))
      return false;
    return true;
  };
  function Companion_33() {
  }
  var Companion_instance_34;
  function Companion_getInstance_33() {
    return Companion_instance_34;
  }
  function $serializer_32() {
    $serializer_instance_32 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.ActivityCenterResponse', this, 6);
    tmp0_serialDesc.tt('companyId', false);
    tmp0_serialDesc.tt('name', false);
    tmp0_serialDesc.tt('address', false);
    tmp0_serialDesc.tt('latitude', false);
    tmp0_serialDesc.tt('longitude', false);
    tmp0_serialDesc.tt('distanceKm', false);
    this.l2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_32).m2j = function (encoder, value) {
    var tmp0_desc = this.l2j_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.n2j_1);
    tmp1_output.un(tmp0_desc, 1, value.o2j_1);
    tmp1_output.un(tmp0_desc, 2, value.p2j_1);
    tmp1_output.sn(tmp0_desc, 3, value.q2j_1);
    tmp1_output.sn(tmp0_desc, 4, value.r2j_1);
    tmp1_output.sn(tmp0_desc, 5, value.s2j_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_32).fj = function (encoder, value) {
    return this.m2j(encoder, value instanceof ActivityCenterResponse ? value : THROW_CCE());
  };
  protoOf($serializer_32).gj = function (decoder) {
    var tmp0_desc = this.l2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0.0;
    var tmp10_input = decoder.fm(tmp0_desc);
    if (tmp10_input.vm()) {
      tmp4_local0 = tmp10_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.nm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.nm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.nm(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.nm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.nm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.nm(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.gm(tmp0_desc);
    return ActivityCenterResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_32).ej = function () {
    return this.l2j_1;
  };
  protoOf($serializer_32).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  var $serializer_instance_32;
  function $serializer_getInstance_32() {
    if ($serializer_instance_32 == null)
      new $serializer_32();
    return $serializer_instance_32;
  }
  function ActivityCenterResponse_init_$Init$(seen0, companyId, name, address, latitude, longitude, distanceKm, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_32().l2j_1);
    }
    $this.n2j_1 = companyId;
    $this.o2j_1 = name;
    $this.p2j_1 = address;
    $this.q2j_1 = latitude;
    $this.r2j_1 = longitude;
    $this.s2j_1 = distanceKm;
    return $this;
  }
  function ActivityCenterResponse_init_$Create$(seen0, companyId, name, address, latitude, longitude, distanceKm, serializationConstructorMarker) {
    return ActivityCenterResponse_init_$Init$(seen0, companyId, name, address, latitude, longitude, distanceKm, serializationConstructorMarker, objectCreate(protoOf(ActivityCenterResponse)));
  }
  function ActivityCenterResponse(companyId, name, address, latitude, longitude, distanceKm) {
    this.n2j_1 = companyId;
    this.o2j_1 = name;
    this.p2j_1 = address;
    this.q2j_1 = latitude;
    this.r2j_1 = longitude;
    this.s2j_1 = distanceKm;
  }
  protoOf(ActivityCenterResponse).toString = function () {
    return 'ActivityCenterResponse(companyId=' + this.n2j_1 + ', name=' + this.o2j_1 + ', address=' + this.p2j_1 + ', latitude=' + this.q2j_1 + ', longitude=' + this.r2j_1 + ', distanceKm=' + this.s2j_1 + ')';
  };
  protoOf(ActivityCenterResponse).hashCode = function () {
    var result = getStringHashCode(this.n2j_1);
    result = imul(result, 31) + getStringHashCode(this.o2j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p2j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q2j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r2j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s2j_1) | 0;
    return result;
  };
  protoOf(ActivityCenterResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ActivityCenterResponse))
      return false;
    if (!(this.n2j_1 === other.n2j_1))
      return false;
    if (!(this.o2j_1 === other.o2j_1))
      return false;
    if (!(this.p2j_1 === other.p2j_1))
      return false;
    if (!equals(this.q2j_1, other.q2j_1))
      return false;
    if (!equals(this.r2j_1, other.r2j_1))
      return false;
    if (!equals(this.s2j_1, other.s2j_1))
      return false;
    return true;
  };
  function Companion_34() {
  }
  var Companion_instance_35;
  function Companion_getInstance_34() {
    return Companion_instance_35;
  }
  function $serializer_33() {
    $serializer_instance_33 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.MyLocationResponse', this, 2);
    tmp0_serialDesc.tt('latitude', false);
    tmp0_serialDesc.tt('longitude', false);
    this.t2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_33).u2j = function (encoder, value) {
    var tmp0_desc = this.t2j_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.sn(tmp0_desc, 0, value.v2j_1);
    tmp1_output.sn(tmp0_desc, 1, value.w2j_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_33).fj = function (encoder, value) {
    return this.u2j(encoder, value instanceof MyLocationResponse ? value : THROW_CCE());
  };
  protoOf($serializer_33).gj = function (decoder) {
    var tmp0_desc = this.t2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.nm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.nm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.nm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.nm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return MyLocationResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_33).ej = function () {
    return this.t2j_1;
  };
  protoOf($serializer_33).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  var $serializer_instance_33;
  function $serializer_getInstance_33() {
    if ($serializer_instance_33 == null)
      new $serializer_33();
    return $serializer_instance_33;
  }
  function MyLocationResponse_init_$Init$(seen0, latitude, longitude, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_33().t2j_1);
    }
    $this.v2j_1 = latitude;
    $this.w2j_1 = longitude;
    return $this;
  }
  function MyLocationResponse_init_$Create$(seen0, latitude, longitude, serializationConstructorMarker) {
    return MyLocationResponse_init_$Init$(seen0, latitude, longitude, serializationConstructorMarker, objectCreate(protoOf(MyLocationResponse)));
  }
  function MyLocationResponse(latitude, longitude) {
    this.v2j_1 = latitude;
    this.w2j_1 = longitude;
  }
  protoOf(MyLocationResponse).toString = function () {
    return 'MyLocationResponse(latitude=' + this.v2j_1 + ', longitude=' + this.w2j_1 + ')';
  };
  protoOf(MyLocationResponse).hashCode = function () {
    var result = getNumberHashCode(this.v2j_1);
    result = imul(result, 31) + getNumberHashCode(this.w2j_1) | 0;
    return result;
  };
  protoOf(MyLocationResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MyLocationResponse))
      return false;
    if (!equals(this.v2j_1, other.v2j_1))
      return false;
    if (!equals(this.w2j_1, other.w2j_1))
      return false;
    return true;
  };
  function Companion_35() {
  }
  var Companion_instance_36;
  function Companion_getInstance_35() {
    return Companion_instance_36;
  }
  function $serializer_34() {
    $serializer_instance_34 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.DiscoverPhotoResponse', this, 4);
    tmp0_serialDesc.tt('url', false);
    tmp0_serialDesc.tt('source', false);
    tmp0_serialDesc.tt('advertisementId', true);
    tmp0_serialDesc.tt('destinationUrl', true);
    this.x2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_34).y2j = function (encoder, value) {
    var tmp0_desc = this.x2j_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.a29_1);
    tmp1_output.un(tmp0_desc, 1, value.b29_1);
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.c29_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.c29_1);
    }
    if (tmp1_output.co(tmp0_desc, 3) ? true : !(value.d29_1 == null)) {
      tmp1_output.yn(tmp0_desc, 3, StringSerializer_getInstance(), value.d29_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_34).fj = function (encoder, value) {
    return this.y2j(encoder, value instanceof DiscoverPhotoResponse ? value : THROW_CCE());
  };
  protoOf($serializer_34).gj = function (decoder) {
    var tmp0_desc = this.x2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.fm(tmp0_desc);
    if (tmp8_input.vm()) {
      tmp4_local0 = tmp8_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.tm(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.tm(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.gm(tmp0_desc);
    return DiscoverPhotoResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_34).ej = function () {
    return this.x2j_1;
  };
  protoOf($serializer_34).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_34;
  function $serializer_getInstance_34() {
    if ($serializer_instance_34 == null)
      new $serializer_34();
    return $serializer_instance_34;
  }
  function DiscoverPhotoResponse_init_$Init$(seen0, url, source, advertisementId, destinationUrl, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_34().x2j_1);
    }
    $this.a29_1 = url;
    $this.b29_1 = source;
    if (0 === (seen0 & 4))
      $this.c29_1 = null;
    else
      $this.c29_1 = advertisementId;
    if (0 === (seen0 & 8))
      $this.d29_1 = null;
    else
      $this.d29_1 = destinationUrl;
    return $this;
  }
  function DiscoverPhotoResponse_init_$Create$(seen0, url, source, advertisementId, destinationUrl, serializationConstructorMarker) {
    return DiscoverPhotoResponse_init_$Init$(seen0, url, source, advertisementId, destinationUrl, serializationConstructorMarker, objectCreate(protoOf(DiscoverPhotoResponse)));
  }
  function DiscoverPhotoResponse(url, source, advertisementId, destinationUrl) {
    advertisementId = advertisementId === VOID ? null : advertisementId;
    destinationUrl = destinationUrl === VOID ? null : destinationUrl;
    this.a29_1 = url;
    this.b29_1 = source;
    this.c29_1 = advertisementId;
    this.d29_1 = destinationUrl;
  }
  protoOf(DiscoverPhotoResponse).toString = function () {
    return 'DiscoverPhotoResponse(url=' + this.a29_1 + ', source=' + this.b29_1 + ', advertisementId=' + this.c29_1 + ', destinationUrl=' + this.d29_1 + ')';
  };
  protoOf(DiscoverPhotoResponse).hashCode = function () {
    var result = getStringHashCode(this.a29_1);
    result = imul(result, 31) + getStringHashCode(this.b29_1) | 0;
    result = imul(result, 31) + (this.c29_1 == null ? 0 : getStringHashCode(this.c29_1)) | 0;
    result = imul(result, 31) + (this.d29_1 == null ? 0 : getStringHashCode(this.d29_1)) | 0;
    return result;
  };
  protoOf(DiscoverPhotoResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscoverPhotoResponse))
      return false;
    if (!(this.a29_1 === other.a29_1))
      return false;
    if (!(this.b29_1 === other.b29_1))
      return false;
    if (!(this.c29_1 == other.c29_1))
      return false;
    if (!(this.d29_1 == other.d29_1))
      return false;
    return true;
  };
  function $serializer_35() {
    $serializer_instance_35 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.LeaderboardEntryResponse', this, 2);
    tmp0_serialDesc.tt('nickname', false);
    tmp0_serialDesc.tt('value', false);
    this.z2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_35).a2k = function (encoder, value) {
    var tmp0_desc = this.z2j_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.b2k_1);
    tmp1_output.sn(tmp0_desc, 1, value.c2k_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_35).fj = function (encoder, value) {
    return this.a2k(encoder, value instanceof LeaderboardEntryResponse ? value : THROW_CCE());
  };
  protoOf($serializer_35).gj = function (decoder) {
    var tmp0_desc = this.z2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_input = decoder.fm(tmp0_desc);
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.nm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.nm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return LeaderboardEntryResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_35).ej = function () {
    return this.z2j_1;
  };
  protoOf($serializer_35).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  var $serializer_instance_35;
  function $serializer_getInstance_35() {
    if ($serializer_instance_35 == null)
      new $serializer_35();
    return $serializer_instance_35;
  }
  function LeaderboardEntryResponse_init_$Init$(seen0, nickname, value, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_35().z2j_1);
    }
    $this.b2k_1 = nickname;
    $this.c2k_1 = value;
    return $this;
  }
  function LeaderboardEntryResponse_init_$Create$(seen0, nickname, value, serializationConstructorMarker) {
    return LeaderboardEntryResponse_init_$Init$(seen0, nickname, value, serializationConstructorMarker, objectCreate(protoOf(LeaderboardEntryResponse)));
  }
  function LeaderboardEntryResponse() {
  }
  protoOf(LeaderboardEntryResponse).toString = function () {
    return 'LeaderboardEntryResponse(nickname=' + this.b2k_1 + ', value=' + this.c2k_1 + ')';
  };
  protoOf(LeaderboardEntryResponse).hashCode = function () {
    var result = getStringHashCode(this.b2k_1);
    result = imul(result, 31) + getNumberHashCode(this.c2k_1) | 0;
    return result;
  };
  protoOf(LeaderboardEntryResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LeaderboardEntryResponse))
      return false;
    if (!(this.b2k_1 === other.b2k_1))
      return false;
    if (!equals(this.c2k_1, other.c2k_1))
      return false;
    return true;
  };
  function LeaderboardPeriodResponse$Companion$$childSerializers$_anonymous__k4en3f() {
    return new ArrayListSerializer($serializer_getInstance_35());
  }
  function LeaderboardPeriodResponse$Companion$$childSerializers$_anonymous__k4en3f_0() {
    return new ArrayListSerializer($serializer_getInstance_35());
  }
  function LeaderboardPeriodResponse$Companion$$childSerializers$_anonymous__k4en3f_1() {
    return new ArrayListSerializer($serializer_getInstance_35());
  }
  function Companion_36() {
    Companion_instance_37 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, LeaderboardPeriodResponse$Companion$$childSerializers$_anonymous__k4en3f);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_3 = lazy(tmp_2, LeaderboardPeriodResponse$Companion$$childSerializers$_anonymous__k4en3f_0);
    var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d2k_1 = [tmp_1, tmp_3, lazy(tmp_4, LeaderboardPeriodResponse$Companion$$childSerializers$_anonymous__k4en3f_1)];
  }
  var Companion_instance_37;
  function Companion_getInstance_36() {
    if (Companion_instance_37 == null)
      new Companion_36();
    return Companion_instance_37;
  }
  function $serializer_36() {
    $serializer_instance_36 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.LeaderboardPeriodResponse', this, 3);
    tmp0_serialDesc.tt('byEventCount', false);
    tmp0_serialDesc.tt('byDistance', true);
    tmp0_serialDesc.tt('byTime', false);
    this.e2k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_36).f2k = function (encoder, value) {
    var tmp0_desc = this.e2k_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_36().d2k_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.g2k_1);
    if (tmp1_output.co(tmp0_desc, 1) ? true : !(value.h2k_1 == null)) {
      tmp1_output.yn(tmp0_desc, 1, tmp2_cached[1].f2(), value.h2k_1);
    }
    tmp1_output.wn(tmp0_desc, 2, tmp2_cached[2].f2(), value.i2k_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_36).fj = function (encoder, value) {
    return this.f2k(encoder, value instanceof LeaderboardPeriodResponse ? value : THROW_CCE());
  };
  protoOf($serializer_36).gj = function (decoder) {
    var tmp0_desc = this.e2k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    var tmp8_cached = Companion_getInstance_36().d2k_1;
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.rm(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.tm(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.rm(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.rm(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.tm(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.rm(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return LeaderboardPeriodResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_36).ej = function () {
    return this.e2k_1;
  };
  protoOf($serializer_36).iu = function () {
    var tmp0_cached = Companion_getInstance_36().d2k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].f2(), get_nullable(tmp0_cached[1].f2()), tmp0_cached[2].f2()];
  };
  var $serializer_instance_36;
  function $serializer_getInstance_36() {
    if ($serializer_instance_36 == null)
      new $serializer_36();
    return $serializer_instance_36;
  }
  function LeaderboardPeriodResponse_init_$Init$(seen0, byEventCount, byDistance, byTime, serializationConstructorMarker, $this) {
    if (!(5 === (5 & seen0))) {
      throwMissingFieldException(seen0, 5, $serializer_getInstance_36().e2k_1);
    }
    $this.g2k_1 = byEventCount;
    if (0 === (seen0 & 2))
      $this.h2k_1 = null;
    else
      $this.h2k_1 = byDistance;
    $this.i2k_1 = byTime;
    return $this;
  }
  function LeaderboardPeriodResponse_init_$Create$(seen0, byEventCount, byDistance, byTime, serializationConstructorMarker) {
    return LeaderboardPeriodResponse_init_$Init$(seen0, byEventCount, byDistance, byTime, serializationConstructorMarker, objectCreate(protoOf(LeaderboardPeriodResponse)));
  }
  function LeaderboardPeriodResponse() {
  }
  protoOf(LeaderboardPeriodResponse).toString = function () {
    return 'LeaderboardPeriodResponse(byEventCount=' + toString(this.g2k_1) + ', byDistance=' + toString_0(this.h2k_1) + ', byTime=' + toString(this.i2k_1) + ')';
  };
  protoOf(LeaderboardPeriodResponse).hashCode = function () {
    var result = hashCode(this.g2k_1);
    result = imul(result, 31) + (this.h2k_1 == null ? 0 : hashCode(this.h2k_1)) | 0;
    result = imul(result, 31) + hashCode(this.i2k_1) | 0;
    return result;
  };
  protoOf(LeaderboardPeriodResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LeaderboardPeriodResponse))
      return false;
    if (!equals(this.g2k_1, other.g2k_1))
      return false;
    if (!equals(this.h2k_1, other.h2k_1))
      return false;
    if (!equals(this.i2k_1, other.i2k_1))
      return false;
    return true;
  };
  function Companion_37() {
  }
  var Companion_instance_38;
  function Companion_getInstance_37() {
    return Companion_instance_38;
  }
  function $serializer_37() {
    $serializer_instance_37 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.LeaderboardResponse', this, 3);
    tmp0_serialDesc.tt('week', false);
    tmp0_serialDesc.tt('month', false);
    tmp0_serialDesc.tt('year', false);
    this.j2k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_37).k2k = function (encoder, value) {
    var tmp0_desc = this.j2k_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.wn(tmp0_desc, 0, $serializer_getInstance_36(), value.l2k_1);
    tmp1_output.wn(tmp0_desc, 1, $serializer_getInstance_36(), value.m2k_1);
    tmp1_output.wn(tmp0_desc, 2, $serializer_getInstance_36(), value.n2k_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_37).fj = function (encoder, value) {
    return this.k2k(encoder, value instanceof LeaderboardResponse ? value : THROW_CCE());
  };
  protoOf($serializer_37).gj = function (decoder) {
    var tmp0_desc = this.j2k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.rm(tmp0_desc, 0, $serializer_getInstance_36(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.rm(tmp0_desc, 1, $serializer_getInstance_36(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.rm(tmp0_desc, 2, $serializer_getInstance_36(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.rm(tmp0_desc, 0, $serializer_getInstance_36(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.rm(tmp0_desc, 1, $serializer_getInstance_36(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.rm(tmp0_desc, 2, $serializer_getInstance_36(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return LeaderboardResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_37).ej = function () {
    return this.j2k_1;
  };
  protoOf($serializer_37).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_36(), $serializer_getInstance_36(), $serializer_getInstance_36()];
  };
  var $serializer_instance_37;
  function $serializer_getInstance_37() {
    if ($serializer_instance_37 == null)
      new $serializer_37();
    return $serializer_instance_37;
  }
  function LeaderboardResponse_init_$Init$(seen0, week, month, year, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_37().j2k_1);
    }
    $this.l2k_1 = week;
    $this.m2k_1 = month;
    $this.n2k_1 = year;
    return $this;
  }
  function LeaderboardResponse_init_$Create$(seen0, week, month, year, serializationConstructorMarker) {
    return LeaderboardResponse_init_$Init$(seen0, week, month, year, serializationConstructorMarker, objectCreate(protoOf(LeaderboardResponse)));
  }
  function LeaderboardResponse(week, month, year) {
    this.l2k_1 = week;
    this.m2k_1 = month;
    this.n2k_1 = year;
  }
  protoOf(LeaderboardResponse).toString = function () {
    return 'LeaderboardResponse(week=' + this.l2k_1.toString() + ', month=' + this.m2k_1.toString() + ', year=' + this.n2k_1.toString() + ')';
  };
  protoOf(LeaderboardResponse).hashCode = function () {
    var result = this.l2k_1.hashCode();
    result = imul(result, 31) + this.m2k_1.hashCode() | 0;
    result = imul(result, 31) + this.n2k_1.hashCode() | 0;
    return result;
  };
  protoOf(LeaderboardResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LeaderboardResponse))
      return false;
    if (!this.l2k_1.equals(other.l2k_1))
      return false;
    if (!this.m2k_1.equals(other.m2k_1))
      return false;
    if (!this.n2k_1.equals(other.n2k_1))
      return false;
    return true;
  };
  function AdvertisementResponse$Companion$$childSerializers$_anonymous__ezlssk() {
    return new LinkedHashSetSerializer(createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values()));
  }
  function Companion_38() {
    Companion_instance_39 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o2k_1 = [null, null, null, lazy(tmp_0, AdvertisementResponse$Companion$$childSerializers$_anonymous__ezlssk), null, null, null, null, null, null];
  }
  var Companion_instance_39;
  function Companion_getInstance_38() {
    if (Companion_instance_39 == null)
      new Companion_38();
    return Companion_instance_39;
  }
  function $serializer_38() {
    $serializer_instance_38 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.AdvertisementResponse', this, 10);
    tmp0_serialDesc.tt('id', false);
    tmp0_serialDesc.tt('marketerCompanyId', false);
    tmp0_serialDesc.tt('imageUrl', false);
    tmp0_serialDesc.tt('activityTypes', false);
    tmp0_serialDesc.tt('latitude', false);
    tmp0_serialDesc.tt('longitude', false);
    tmp0_serialDesc.tt('radiusKm', false);
    tmp0_serialDesc.tt('active', false);
    tmp0_serialDesc.tt('createdAt', false);
    tmp0_serialDesc.tt('destinationUrl', true);
    this.p2k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_38).q2k = function (encoder, value) {
    var tmp0_desc = this.p2k_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_38().o2k_1;
    tmp1_output.un(tmp0_desc, 0, value.r2k_1);
    tmp1_output.un(tmp0_desc, 1, value.s2k_1);
    tmp1_output.un(tmp0_desc, 2, value.t2k_1);
    tmp1_output.wn(tmp0_desc, 3, tmp2_cached[3].f2(), value.u2k_1);
    tmp1_output.sn(tmp0_desc, 4, value.v2k_1);
    tmp1_output.sn(tmp0_desc, 5, value.w2k_1);
    tmp1_output.sn(tmp0_desc, 6, value.x2k_1);
    tmp1_output.mn(tmp0_desc, 7, value.y2k_1);
    tmp1_output.un(tmp0_desc, 8, value.z2k_1);
    if (tmp1_output.co(tmp0_desc, 9) ? true : !(value.a2l_1 == null)) {
      tmp1_output.yn(tmp0_desc, 9, StringSerializer_getInstance(), value.a2l_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_38).fj = function (encoder, value) {
    return this.q2k(encoder, value instanceof AdvertisementResponse ? value : THROW_CCE());
  };
  protoOf($serializer_38).gj = function (decoder) {
    var tmp0_desc = this.p2k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = 0.0;
    var tmp11_local7 = false;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_input = decoder.fm(tmp0_desc);
    var tmp15_cached = Companion_getInstance_38().o2k_1;
    if (tmp14_input.vm()) {
      tmp4_local0 = tmp14_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.rm(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.nm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.nm(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.nm(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.hm(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.pm(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.tm(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.rm(tmp0_desc, 3, tmp15_cached[3].f2(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.nm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.nm(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.nm(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.hm(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.pm(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.tm(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.gm(tmp0_desc);
    return AdvertisementResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_38).ej = function () {
    return this.p2k_1;
  };
  protoOf($serializer_38).iu = function () {
    var tmp0_cached = Companion_getInstance_38().o2k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3].f2(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_38;
  function $serializer_getInstance_38() {
    if ($serializer_instance_38 == null)
      new $serializer_38();
    return $serializer_instance_38;
  }
  function AdvertisementResponse_init_$Init$(seen0, id, marketerCompanyId, imageUrl, activityTypes, latitude, longitude, radiusKm, active, createdAt, destinationUrl, serializationConstructorMarker, $this) {
    if (!(511 === (511 & seen0))) {
      throwMissingFieldException(seen0, 511, $serializer_getInstance_38().p2k_1);
    }
    $this.r2k_1 = id;
    $this.s2k_1 = marketerCompanyId;
    $this.t2k_1 = imageUrl;
    $this.u2k_1 = activityTypes;
    $this.v2k_1 = latitude;
    $this.w2k_1 = longitude;
    $this.x2k_1 = radiusKm;
    $this.y2k_1 = active;
    $this.z2k_1 = createdAt;
    if (0 === (seen0 & 512))
      $this.a2l_1 = null;
    else
      $this.a2l_1 = destinationUrl;
    return $this;
  }
  function AdvertisementResponse_init_$Create$(seen0, id, marketerCompanyId, imageUrl, activityTypes, latitude, longitude, radiusKm, active, createdAt, destinationUrl, serializationConstructorMarker) {
    return AdvertisementResponse_init_$Init$(seen0, id, marketerCompanyId, imageUrl, activityTypes, latitude, longitude, radiusKm, active, createdAt, destinationUrl, serializationConstructorMarker, objectCreate(protoOf(AdvertisementResponse)));
  }
  function AdvertisementResponse(id, marketerCompanyId, imageUrl, activityTypes, latitude, longitude, radiusKm, active, createdAt, destinationUrl) {
    Companion_getInstance_38();
    destinationUrl = destinationUrl === VOID ? null : destinationUrl;
    this.r2k_1 = id;
    this.s2k_1 = marketerCompanyId;
    this.t2k_1 = imageUrl;
    this.u2k_1 = activityTypes;
    this.v2k_1 = latitude;
    this.w2k_1 = longitude;
    this.x2k_1 = radiusKm;
    this.y2k_1 = active;
    this.z2k_1 = createdAt;
    this.a2l_1 = destinationUrl;
  }
  protoOf(AdvertisementResponse).toString = function () {
    return 'AdvertisementResponse(id=' + this.r2k_1 + ', marketerCompanyId=' + this.s2k_1 + ', imageUrl=' + this.t2k_1 + ', activityTypes=' + toString(this.u2k_1) + ', latitude=' + this.v2k_1 + ', longitude=' + this.w2k_1 + ', radiusKm=' + this.x2k_1 + ', active=' + this.y2k_1 + ', createdAt=' + this.z2k_1 + ', destinationUrl=' + this.a2l_1 + ')';
  };
  protoOf(AdvertisementResponse).hashCode = function () {
    var result = getStringHashCode(this.r2k_1);
    result = imul(result, 31) + getStringHashCode(this.s2k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t2k_1) | 0;
    result = imul(result, 31) + hashCode(this.u2k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v2k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w2k_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x2k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y2k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z2k_1) | 0;
    result = imul(result, 31) + (this.a2l_1 == null ? 0 : getStringHashCode(this.a2l_1)) | 0;
    return result;
  };
  protoOf(AdvertisementResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AdvertisementResponse))
      return false;
    if (!(this.r2k_1 === other.r2k_1))
      return false;
    if (!(this.s2k_1 === other.s2k_1))
      return false;
    if (!(this.t2k_1 === other.t2k_1))
      return false;
    if (!equals(this.u2k_1, other.u2k_1))
      return false;
    if (!equals(this.v2k_1, other.v2k_1))
      return false;
    if (!equals(this.w2k_1, other.w2k_1))
      return false;
    if (!equals(this.x2k_1, other.x2k_1))
      return false;
    if (!(this.y2k_1 === other.y2k_1))
      return false;
    if (!(this.z2k_1 === other.z2k_1))
      return false;
    if (!(this.a2l_1 == other.a2l_1))
      return false;
    return true;
  };
  function Companion_39() {
  }
  var Companion_instance_40;
  function Companion_getInstance_39() {
    return Companion_instance_40;
  }
  function $serializer_39() {
    $serializer_instance_39 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.AdCampaignResponse', this, 14);
    tmp0_serialDesc.tt('id', false);
    tmp0_serialDesc.tt('advertisementId', false);
    tmp0_serialDesc.tt('marketerCompanyId', false);
    tmp0_serialDesc.tt('startDate', false);
    tmp0_serialDesc.tt('endDate', true);
    tmp0_serialDesc.tt('budgetId', false);
    tmp0_serialDesc.tt('dailyBudgetCents', true);
    tmp0_serialDesc.tt('size', false);
    tmp0_serialDesc.tt('placementTier', false);
    tmp0_serialDesc.tt('status', false);
    tmp0_serialDesc.tt('createdAt', false);
    tmp0_serialDesc.tt('impressionCount', true);
    tmp0_serialDesc.tt('clickCount', true);
    tmp0_serialDesc.tt('totalDisplayMs', true);
    this.b2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_39).c2l = function (encoder, value) {
    var tmp0_desc = this.b2l_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.d2l_1);
    tmp1_output.un(tmp0_desc, 1, value.e2l_1);
    tmp1_output.un(tmp0_desc, 2, value.f2l_1);
    tmp1_output.un(tmp0_desc, 3, value.g2l_1);
    if (tmp1_output.co(tmp0_desc, 4) ? true : !(value.h2l_1 == null)) {
      tmp1_output.yn(tmp0_desc, 4, StringSerializer_getInstance(), value.h2l_1);
    }
    tmp1_output.un(tmp0_desc, 5, value.i2l_1);
    if (tmp1_output.co(tmp0_desc, 6) ? true : !(value.j2l_1 == null)) {
      tmp1_output.yn(tmp0_desc, 6, LongSerializer_getInstance(), value.j2l_1);
    }
    tmp1_output.un(tmp0_desc, 7, value.k2l_1);
    tmp1_output.un(tmp0_desc, 8, value.l2l_1);
    tmp1_output.un(tmp0_desc, 9, value.m2l_1);
    tmp1_output.un(tmp0_desc, 10, value.n2l_1);
    if (tmp1_output.co(tmp0_desc, 11) ? true : !equalsLong(value.o2l_1, new Long(0, 0))) {
      tmp1_output.qn(tmp0_desc, 11, value.o2l_1);
    }
    if (tmp1_output.co(tmp0_desc, 12) ? true : !equalsLong(value.p2l_1, new Long(0, 0))) {
      tmp1_output.qn(tmp0_desc, 12, value.p2l_1);
    }
    if (tmp1_output.co(tmp0_desc, 13) ? true : !equalsLong(value.q2l_1, new Long(0, 0))) {
      tmp1_output.qn(tmp0_desc, 13, value.q2l_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_39).fj = function (encoder, value) {
    return this.c2l(encoder, value instanceof AdCampaignResponse ? value : THROW_CCE());
  };
  protoOf($serializer_39).gj = function (decoder) {
    var tmp0_desc = this.b2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = new Long(0, 0);
    var tmp16_local12 = new Long(0, 0);
    var tmp17_local13 = new Long(0, 0);
    var tmp18_input = decoder.fm(tmp0_desc);
    if (tmp18_input.vm()) {
      tmp4_local0 = tmp18_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp18_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp18_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp18_input.pm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp18_input.tm(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp18_input.pm(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp18_input.tm(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp18_input.pm(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp18_input.pm(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp18_input.pm(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp18_input.pm(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp18_input.lm(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp18_input.lm(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp18_input.lm(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp18_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp18_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp18_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp18_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp18_input.pm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp18_input.tm(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp18_input.pm(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp18_input.tm(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp18_input.pm(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp18_input.pm(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp18_input.pm(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp18_input.pm(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp18_input.lm(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp18_input.lm(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp18_input.lm(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp18_input.gm(tmp0_desc);
    return AdCampaignResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, null);
  };
  protoOf($serializer_39).ej = function () {
    return this.b2l_1;
  };
  protoOf($serializer_39).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_39;
  function $serializer_getInstance_39() {
    if ($serializer_instance_39 == null)
      new $serializer_39();
    return $serializer_instance_39;
  }
  function AdCampaignResponse_init_$Init$(seen0, id, advertisementId, marketerCompanyId, startDate, endDate, budgetId, dailyBudgetCents, size, placementTier, status, createdAt, impressionCount, clickCount, totalDisplayMs, serializationConstructorMarker, $this) {
    if (!(1967 === (1967 & seen0))) {
      throwMissingFieldException(seen0, 1967, $serializer_getInstance_39().b2l_1);
    }
    $this.d2l_1 = id;
    $this.e2l_1 = advertisementId;
    $this.f2l_1 = marketerCompanyId;
    $this.g2l_1 = startDate;
    if (0 === (seen0 & 16))
      $this.h2l_1 = null;
    else
      $this.h2l_1 = endDate;
    $this.i2l_1 = budgetId;
    if (0 === (seen0 & 64))
      $this.j2l_1 = null;
    else
      $this.j2l_1 = dailyBudgetCents;
    $this.k2l_1 = size;
    $this.l2l_1 = placementTier;
    $this.m2l_1 = status;
    $this.n2l_1 = createdAt;
    if (0 === (seen0 & 2048))
      $this.o2l_1 = new Long(0, 0);
    else
      $this.o2l_1 = impressionCount;
    if (0 === (seen0 & 4096))
      $this.p2l_1 = new Long(0, 0);
    else
      $this.p2l_1 = clickCount;
    if (0 === (seen0 & 8192))
      $this.q2l_1 = new Long(0, 0);
    else
      $this.q2l_1 = totalDisplayMs;
    return $this;
  }
  function AdCampaignResponse_init_$Create$(seen0, id, advertisementId, marketerCompanyId, startDate, endDate, budgetId, dailyBudgetCents, size, placementTier, status, createdAt, impressionCount, clickCount, totalDisplayMs, serializationConstructorMarker) {
    return AdCampaignResponse_init_$Init$(seen0, id, advertisementId, marketerCompanyId, startDate, endDate, budgetId, dailyBudgetCents, size, placementTier, status, createdAt, impressionCount, clickCount, totalDisplayMs, serializationConstructorMarker, objectCreate(protoOf(AdCampaignResponse)));
  }
  function AdCampaignResponse(id, advertisementId, marketerCompanyId, startDate, endDate, budgetId, dailyBudgetCents, size, placementTier, status, createdAt, impressionCount, clickCount, totalDisplayMs) {
    endDate = endDate === VOID ? null : endDate;
    dailyBudgetCents = dailyBudgetCents === VOID ? null : dailyBudgetCents;
    impressionCount = impressionCount === VOID ? new Long(0, 0) : impressionCount;
    clickCount = clickCount === VOID ? new Long(0, 0) : clickCount;
    totalDisplayMs = totalDisplayMs === VOID ? new Long(0, 0) : totalDisplayMs;
    this.d2l_1 = id;
    this.e2l_1 = advertisementId;
    this.f2l_1 = marketerCompanyId;
    this.g2l_1 = startDate;
    this.h2l_1 = endDate;
    this.i2l_1 = budgetId;
    this.j2l_1 = dailyBudgetCents;
    this.k2l_1 = size;
    this.l2l_1 = placementTier;
    this.m2l_1 = status;
    this.n2l_1 = createdAt;
    this.o2l_1 = impressionCount;
    this.p2l_1 = clickCount;
    this.q2l_1 = totalDisplayMs;
  }
  protoOf(AdCampaignResponse).toString = function () {
    return 'AdCampaignResponse(id=' + this.d2l_1 + ', advertisementId=' + this.e2l_1 + ', marketerCompanyId=' + this.f2l_1 + ', startDate=' + this.g2l_1 + ', endDate=' + this.h2l_1 + ', budgetId=' + this.i2l_1 + ', dailyBudgetCents=' + toString_0(this.j2l_1) + ', size=' + this.k2l_1 + ', placementTier=' + this.l2l_1 + ', status=' + this.m2l_1 + ', createdAt=' + this.n2l_1 + ', impressionCount=' + this.o2l_1.toString() + ', clickCount=' + this.p2l_1.toString() + ', totalDisplayMs=' + this.q2l_1.toString() + ')';
  };
  protoOf(AdCampaignResponse).hashCode = function () {
    var result = getStringHashCode(this.d2l_1);
    result = imul(result, 31) + getStringHashCode(this.e2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g2l_1) | 0;
    result = imul(result, 31) + (this.h2l_1 == null ? 0 : getStringHashCode(this.h2l_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.i2l_1) | 0;
    result = imul(result, 31) + (this.j2l_1 == null ? 0 : this.j2l_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.k2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n2l_1) | 0;
    result = imul(result, 31) + this.o2l_1.hashCode() | 0;
    result = imul(result, 31) + this.p2l_1.hashCode() | 0;
    result = imul(result, 31) + this.q2l_1.hashCode() | 0;
    return result;
  };
  protoOf(AdCampaignResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AdCampaignResponse))
      return false;
    if (!(this.d2l_1 === other.d2l_1))
      return false;
    if (!(this.e2l_1 === other.e2l_1))
      return false;
    if (!(this.f2l_1 === other.f2l_1))
      return false;
    if (!(this.g2l_1 === other.g2l_1))
      return false;
    if (!(this.h2l_1 == other.h2l_1))
      return false;
    if (!(this.i2l_1 === other.i2l_1))
      return false;
    if (!equals(this.j2l_1, other.j2l_1))
      return false;
    if (!(this.k2l_1 === other.k2l_1))
      return false;
    if (!(this.l2l_1 === other.l2l_1))
      return false;
    if (!(this.m2l_1 === other.m2l_1))
      return false;
    if (!(this.n2l_1 === other.n2l_1))
      return false;
    if (!equalsLong(this.o2l_1, other.o2l_1))
      return false;
    if (!equalsLong(this.p2l_1, other.p2l_1))
      return false;
    if (!equalsLong(this.q2l_1, other.q2l_1))
      return false;
    return true;
  };
  function Companion_40() {
  }
  var Companion_instance_41;
  function Companion_getInstance_40() {
    return Companion_instance_41;
  }
  function $serializer_40() {
    $serializer_instance_40 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.RecordAdDisplayTimeRequest', this, 1);
    tmp0_serialDesc.tt('durationMs', false);
    this.r2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_40).s2l = function (encoder, value) {
    var tmp0_desc = this.r2l_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.qn(tmp0_desc, 0, value.t2l_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_40).fj = function (encoder, value) {
    return this.s2l(encoder, value instanceof RecordAdDisplayTimeRequest ? value : THROW_CCE());
  };
  protoOf($serializer_40).gj = function (decoder) {
    var tmp0_desc = this.r2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.lm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.lm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return RecordAdDisplayTimeRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_40).ej = function () {
    return this.r2l_1;
  };
  protoOf($serializer_40).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance()];
  };
  var $serializer_instance_40;
  function $serializer_getInstance_40() {
    if ($serializer_instance_40 == null)
      new $serializer_40();
    return $serializer_instance_40;
  }
  function RecordAdDisplayTimeRequest_init_$Init$(seen0, durationMs, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_40().r2l_1);
    }
    $this.t2l_1 = durationMs;
    return $this;
  }
  function RecordAdDisplayTimeRequest_init_$Create$(seen0, durationMs, serializationConstructorMarker) {
    return RecordAdDisplayTimeRequest_init_$Init$(seen0, durationMs, serializationConstructorMarker, objectCreate(protoOf(RecordAdDisplayTimeRequest)));
  }
  function RecordAdDisplayTimeRequest(durationMs) {
    this.t2l_1 = durationMs;
  }
  protoOf(RecordAdDisplayTimeRequest).toString = function () {
    return 'RecordAdDisplayTimeRequest(durationMs=' + this.t2l_1.toString() + ')';
  };
  protoOf(RecordAdDisplayTimeRequest).hashCode = function () {
    return this.t2l_1.hashCode();
  };
  protoOf(RecordAdDisplayTimeRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RecordAdDisplayTimeRequest))
      return false;
    if (!equalsLong(this.t2l_1, other.t2l_1))
      return false;
    return true;
  };
  function Companion_41() {
  }
  var Companion_instance_42;
  function Companion_getInstance_41() {
    return Companion_instance_42;
  }
  function $serializer_41() {
    $serializer_instance_41 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.AllocateAdCampaignBudgetRequest', this, 1);
    tmp0_serialDesc.tt('amountCents', false);
    this.u2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_41).v2l = function (encoder, value) {
    var tmp0_desc = this.u2l_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.qn(tmp0_desc, 0, value.w2l_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_41).fj = function (encoder, value) {
    return this.v2l(encoder, value instanceof AllocateAdCampaignBudgetRequest ? value : THROW_CCE());
  };
  protoOf($serializer_41).gj = function (decoder) {
    var tmp0_desc = this.u2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.lm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.lm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return AllocateAdCampaignBudgetRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_41).ej = function () {
    return this.u2l_1;
  };
  protoOf($serializer_41).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance()];
  };
  var $serializer_instance_41;
  function $serializer_getInstance_41() {
    if ($serializer_instance_41 == null)
      new $serializer_41();
    return $serializer_instance_41;
  }
  function AllocateAdCampaignBudgetRequest_init_$Init$(seen0, amountCents, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_41().u2l_1);
    }
    $this.w2l_1 = amountCents;
    return $this;
  }
  function AllocateAdCampaignBudgetRequest_init_$Create$(seen0, amountCents, serializationConstructorMarker) {
    return AllocateAdCampaignBudgetRequest_init_$Init$(seen0, amountCents, serializationConstructorMarker, objectCreate(protoOf(AllocateAdCampaignBudgetRequest)));
  }
  function AllocateAdCampaignBudgetRequest(amountCents) {
    this.w2l_1 = amountCents;
  }
  protoOf(AllocateAdCampaignBudgetRequest).toString = function () {
    return 'AllocateAdCampaignBudgetRequest(amountCents=' + this.w2l_1.toString() + ')';
  };
  protoOf(AllocateAdCampaignBudgetRequest).hashCode = function () {
    return this.w2l_1.hashCode();
  };
  protoOf(AllocateAdCampaignBudgetRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AllocateAdCampaignBudgetRequest))
      return false;
    if (!equalsLong(this.w2l_1, other.w2l_1))
      return false;
    return true;
  };
  function Companion_42() {
  }
  var Companion_instance_43;
  function Companion_getInstance_42() {
    return Companion_instance_43;
  }
  function $serializer_42() {
    $serializer_instance_42 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.CheckoutSessionUrlResponse', this, 1);
    tmp0_serialDesc.tt('checkoutSessionUrl', false);
    this.x2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_42).y2l = function (encoder, value) {
    var tmp0_desc = this.x2l_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.i2c_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_42).fj = function (encoder, value) {
    return this.y2l(encoder, value instanceof CheckoutSessionUrlResponse ? value : THROW_CCE());
  };
  protoOf($serializer_42).gj = function (decoder) {
    var tmp0_desc = this.x2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return CheckoutSessionUrlResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_42).ej = function () {
    return this.x2l_1;
  };
  protoOf($serializer_42).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_42;
  function $serializer_getInstance_42() {
    if ($serializer_instance_42 == null)
      new $serializer_42();
    return $serializer_instance_42;
  }
  function CheckoutSessionUrlResponse_init_$Init$(seen0, checkoutSessionUrl, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_42().x2l_1);
    }
    $this.i2c_1 = checkoutSessionUrl;
    return $this;
  }
  function CheckoutSessionUrlResponse_init_$Create$(seen0, checkoutSessionUrl, serializationConstructorMarker) {
    return CheckoutSessionUrlResponse_init_$Init$(seen0, checkoutSessionUrl, serializationConstructorMarker, objectCreate(protoOf(CheckoutSessionUrlResponse)));
  }
  function CheckoutSessionUrlResponse(checkoutSessionUrl) {
    this.i2c_1 = checkoutSessionUrl;
  }
  protoOf(CheckoutSessionUrlResponse).toString = function () {
    return 'CheckoutSessionUrlResponse(checkoutSessionUrl=' + this.i2c_1 + ')';
  };
  protoOf(CheckoutSessionUrlResponse).hashCode = function () {
    return getStringHashCode(this.i2c_1);
  };
  protoOf(CheckoutSessionUrlResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CheckoutSessionUrlResponse))
      return false;
    if (!(this.i2c_1 === other.i2c_1))
      return false;
    return true;
  };
  function ActivityTypeTotalResponse$Companion$$childSerializers$_anonymous__c5rkya() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values());
  }
  function Companion_43() {
    Companion_instance_44 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z2l_1 = [lazy(tmp_0, ActivityTypeTotalResponse$Companion$$childSerializers$_anonymous__c5rkya), null, null];
  }
  var Companion_instance_44;
  function Companion_getInstance_43() {
    if (Companion_instance_44 == null)
      new Companion_43();
    return Companion_instance_44;
  }
  function $serializer_43() {
    $serializer_instance_43 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.ActivityTypeTotalResponse', this, 3);
    tmp0_serialDesc.tt('activityType', false);
    tmp0_serialDesc.tt('totalDistanceMeters', false);
    tmp0_serialDesc.tt('entryCount', false);
    this.a2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_43).b2m = function (encoder, value) {
    var tmp0_desc = this.a2m_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_43().z2l_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.c2m_1);
    tmp1_output.sn(tmp0_desc, 1, value.d2m_1);
    tmp1_output.pn(tmp0_desc, 2, value.e2m_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_43).fj = function (encoder, value) {
    return this.b2m(encoder, value instanceof ActivityTypeTotalResponse ? value : THROW_CCE());
  };
  protoOf($serializer_43).gj = function (decoder) {
    var tmp0_desc = this.a2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.fm(tmp0_desc);
    var tmp8_cached = Companion_getInstance_43().z2l_1;
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.rm(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.nm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.km(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.rm(tmp0_desc, 0, tmp8_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.nm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.km(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return ActivityTypeTotalResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_43).ej = function () {
    return this.a2m_1;
  };
  protoOf($serializer_43).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_43().z2l_1[0].f2(), DoubleSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_43;
  function $serializer_getInstance_43() {
    if ($serializer_instance_43 == null)
      new $serializer_43();
    return $serializer_instance_43;
  }
  function ActivityTypeTotalResponse_init_$Init$(seen0, activityType, totalDistanceMeters, entryCount, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_43().a2m_1);
    }
    $this.c2m_1 = activityType;
    $this.d2m_1 = totalDistanceMeters;
    $this.e2m_1 = entryCount;
    return $this;
  }
  function ActivityTypeTotalResponse_init_$Create$(seen0, activityType, totalDistanceMeters, entryCount, serializationConstructorMarker) {
    return ActivityTypeTotalResponse_init_$Init$(seen0, activityType, totalDistanceMeters, entryCount, serializationConstructorMarker, objectCreate(protoOf(ActivityTypeTotalResponse)));
  }
  function ActivityTypeTotalResponse() {
  }
  protoOf(ActivityTypeTotalResponse).toString = function () {
    return 'ActivityTypeTotalResponse(activityType=' + this.c2m_1.toString() + ', totalDistanceMeters=' + this.d2m_1 + ', entryCount=' + this.e2m_1 + ')';
  };
  protoOf(ActivityTypeTotalResponse).hashCode = function () {
    var result = this.c2m_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.d2m_1) | 0;
    result = imul(result, 31) + this.e2m_1 | 0;
    return result;
  };
  protoOf(ActivityTypeTotalResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ActivityTypeTotalResponse))
      return false;
    if (!this.c2m_1.equals(other.c2m_1))
      return false;
    if (!equals(this.d2m_1, other.d2m_1))
      return false;
    if (!(this.e2m_1 === other.e2m_1))
      return false;
    return true;
  };
  function CompanyAnalyticsResponse$Companion$$childSerializers$_anonymous__1tldts() {
    return new ArrayListSerializer($serializer_getInstance_43());
  }
  function Companion_44() {
    Companion_instance_45 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f2m_1 = [null, null, null, lazy(tmp_0, CompanyAnalyticsResponse$Companion$$childSerializers$_anonymous__1tldts)];
  }
  var Companion_instance_45;
  function Companion_getInstance_44() {
    if (Companion_instance_45 == null)
      new Companion_44();
    return Companion_instance_45;
  }
  function $serializer_44() {
    $serializer_instance_44 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.CompanyAnalyticsResponse', this, 4);
    tmp0_serialDesc.tt('totalDistanceMeters', false);
    tmp0_serialDesc.tt('totalEntries', false);
    tmp0_serialDesc.tt('activeMemberCount', false);
    tmp0_serialDesc.tt('byActivityType', false);
    this.g2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_44).h2m = function (encoder, value) {
    var tmp0_desc = this.g2m_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_44().f2m_1;
    tmp1_output.sn(tmp0_desc, 0, value.i2m_1);
    tmp1_output.pn(tmp0_desc, 1, value.j2m_1);
    tmp1_output.pn(tmp0_desc, 2, value.k2m_1);
    tmp1_output.wn(tmp0_desc, 3, tmp2_cached[3].f2(), value.l2m_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_44).fj = function (encoder, value) {
    return this.h2m(encoder, value instanceof CompanyAnalyticsResponse ? value : THROW_CCE());
  };
  protoOf($serializer_44).gj = function (decoder) {
    var tmp0_desc = this.g2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = null;
    var tmp8_input = decoder.fm(tmp0_desc);
    var tmp9_cached = Companion_getInstance_44().f2m_1;
    if (tmp8_input.vm()) {
      tmp4_local0 = tmp8_input.nm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.km(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.km(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.rm(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.nm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.km(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.km(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.rm(tmp0_desc, 3, tmp9_cached[3].f2(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.gm(tmp0_desc);
    return CompanyAnalyticsResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_44).ej = function () {
    return this.g2m_1;
  };
  protoOf($serializer_44).iu = function () {
    var tmp0_cached = Companion_getInstance_44().f2m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[3].f2()];
  };
  var $serializer_instance_44;
  function $serializer_getInstance_44() {
    if ($serializer_instance_44 == null)
      new $serializer_44();
    return $serializer_instance_44;
  }
  function CompanyAnalyticsResponse_init_$Init$(seen0, totalDistanceMeters, totalEntries, activeMemberCount, byActivityType, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_44().g2m_1);
    }
    $this.i2m_1 = totalDistanceMeters;
    $this.j2m_1 = totalEntries;
    $this.k2m_1 = activeMemberCount;
    $this.l2m_1 = byActivityType;
    return $this;
  }
  function CompanyAnalyticsResponse_init_$Create$(seen0, totalDistanceMeters, totalEntries, activeMemberCount, byActivityType, serializationConstructorMarker) {
    return CompanyAnalyticsResponse_init_$Init$(seen0, totalDistanceMeters, totalEntries, activeMemberCount, byActivityType, serializationConstructorMarker, objectCreate(protoOf(CompanyAnalyticsResponse)));
  }
  function CompanyAnalyticsResponse(totalDistanceMeters, totalEntries, activeMemberCount, byActivityType) {
    Companion_getInstance_44();
    this.i2m_1 = totalDistanceMeters;
    this.j2m_1 = totalEntries;
    this.k2m_1 = activeMemberCount;
    this.l2m_1 = byActivityType;
  }
  protoOf(CompanyAnalyticsResponse).toString = function () {
    return 'CompanyAnalyticsResponse(totalDistanceMeters=' + this.i2m_1 + ', totalEntries=' + this.j2m_1 + ', activeMemberCount=' + this.k2m_1 + ', byActivityType=' + toString(this.l2m_1) + ')';
  };
  protoOf(CompanyAnalyticsResponse).hashCode = function () {
    var result = getNumberHashCode(this.i2m_1);
    result = imul(result, 31) + this.j2m_1 | 0;
    result = imul(result, 31) + this.k2m_1 | 0;
    result = imul(result, 31) + hashCode(this.l2m_1) | 0;
    return result;
  };
  protoOf(CompanyAnalyticsResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompanyAnalyticsResponse))
      return false;
    if (!equals(this.i2m_1, other.i2m_1))
      return false;
    if (!(this.j2m_1 === other.j2m_1))
      return false;
    if (!(this.k2m_1 === other.k2m_1))
      return false;
    if (!equals(this.l2m_1, other.l2m_1))
      return false;
    return true;
  };
  function Companion_45() {
  }
  var Companion_instance_46;
  function Companion_getInstance_45() {
    return Companion_instance_46;
  }
  function $serializer_45() {
    $serializer_instance_45 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.RegisterIssuingAuthorityRequest', this, 3);
    tmp0_serialDesc.tt('name', false);
    tmp0_serialDesc.tt('country', true);
    tmp0_serialDesc.tt('website', true);
    this.m2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_45).n2m = function (encoder, value) {
    var tmp0_desc = this.m2m_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.o2m_1);
    if (tmp1_output.co(tmp0_desc, 1) ? true : !(value.p2m_1 == null)) {
      tmp1_output.yn(tmp0_desc, 1, StringSerializer_getInstance(), value.p2m_1);
    }
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.q2m_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.q2m_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_45).fj = function (encoder, value) {
    return this.n2m(encoder, value instanceof RegisterIssuingAuthorityRequest ? value : THROW_CCE());
  };
  protoOf($serializer_45).gj = function (decoder) {
    var tmp0_desc = this.m2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return RegisterIssuingAuthorityRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_45).ej = function () {
    return this.m2m_1;
  };
  protoOf($serializer_45).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_45;
  function $serializer_getInstance_45() {
    if ($serializer_instance_45 == null)
      new $serializer_45();
    return $serializer_instance_45;
  }
  function RegisterIssuingAuthorityRequest_init_$Init$(seen0, name, country, website, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_45().m2m_1);
    }
    $this.o2m_1 = name;
    if (0 === (seen0 & 2))
      $this.p2m_1 = null;
    else
      $this.p2m_1 = country;
    if (0 === (seen0 & 4))
      $this.q2m_1 = null;
    else
      $this.q2m_1 = website;
    return $this;
  }
  function RegisterIssuingAuthorityRequest_init_$Create$(seen0, name, country, website, serializationConstructorMarker) {
    return RegisterIssuingAuthorityRequest_init_$Init$(seen0, name, country, website, serializationConstructorMarker, objectCreate(protoOf(RegisterIssuingAuthorityRequest)));
  }
  function RegisterIssuingAuthorityRequest(name, country, website) {
    country = country === VOID ? null : country;
    website = website === VOID ? null : website;
    this.o2m_1 = name;
    this.p2m_1 = country;
    this.q2m_1 = website;
  }
  protoOf(RegisterIssuingAuthorityRequest).toString = function () {
    return 'RegisterIssuingAuthorityRequest(name=' + this.o2m_1 + ', country=' + this.p2m_1 + ', website=' + this.q2m_1 + ')';
  };
  protoOf(RegisterIssuingAuthorityRequest).hashCode = function () {
    var result = getStringHashCode(this.o2m_1);
    result = imul(result, 31) + (this.p2m_1 == null ? 0 : getStringHashCode(this.p2m_1)) | 0;
    result = imul(result, 31) + (this.q2m_1 == null ? 0 : getStringHashCode(this.q2m_1)) | 0;
    return result;
  };
  protoOf(RegisterIssuingAuthorityRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegisterIssuingAuthorityRequest))
      return false;
    if (!(this.o2m_1 === other.o2m_1))
      return false;
    if (!(this.p2m_1 == other.p2m_1))
      return false;
    if (!(this.q2m_1 == other.q2m_1))
      return false;
    return true;
  };
  function Companion_46() {
  }
  var Companion_instance_47;
  function Companion_getInstance_46() {
    return Companion_instance_47;
  }
  function $serializer_46() {
    $serializer_instance_46 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.UpdateIssuingAuthorityRequest', this, 4);
    tmp0_serialDesc.tt('name', false);
    tmp0_serialDesc.tt('country', true);
    tmp0_serialDesc.tt('website', true);
    tmp0_serialDesc.tt('active', false);
    this.r2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_46).s2m = function (encoder, value) {
    var tmp0_desc = this.r2m_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.t2m_1);
    if (tmp1_output.co(tmp0_desc, 1) ? true : !(value.u2m_1 == null)) {
      tmp1_output.yn(tmp0_desc, 1, StringSerializer_getInstance(), value.u2m_1);
    }
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.v2m_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.v2m_1);
    }
    tmp1_output.mn(tmp0_desc, 3, value.w2m_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_46).fj = function (encoder, value) {
    return this.s2m(encoder, value instanceof UpdateIssuingAuthorityRequest ? value : THROW_CCE());
  };
  protoOf($serializer_46).gj = function (decoder) {
    var tmp0_desc = this.r2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_input = decoder.fm(tmp0_desc);
    if (tmp8_input.vm()) {
      tmp4_local0 = tmp8_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.hm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.hm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.gm(tmp0_desc);
    return UpdateIssuingAuthorityRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_46).ej = function () {
    return this.r2m_1;
  };
  protoOf($serializer_46).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_46;
  function $serializer_getInstance_46() {
    if ($serializer_instance_46 == null)
      new $serializer_46();
    return $serializer_instance_46;
  }
  function UpdateIssuingAuthorityRequest_init_$Init$(seen0, name, country, website, active, serializationConstructorMarker, $this) {
    if (!(9 === (9 & seen0))) {
      throwMissingFieldException(seen0, 9, $serializer_getInstance_46().r2m_1);
    }
    $this.t2m_1 = name;
    if (0 === (seen0 & 2))
      $this.u2m_1 = null;
    else
      $this.u2m_1 = country;
    if (0 === (seen0 & 4))
      $this.v2m_1 = null;
    else
      $this.v2m_1 = website;
    $this.w2m_1 = active;
    return $this;
  }
  function UpdateIssuingAuthorityRequest_init_$Create$(seen0, name, country, website, active, serializationConstructorMarker) {
    return UpdateIssuingAuthorityRequest_init_$Init$(seen0, name, country, website, active, serializationConstructorMarker, objectCreate(protoOf(UpdateIssuingAuthorityRequest)));
  }
  function UpdateIssuingAuthorityRequest(name, country, website, active) {
    country = country === VOID ? null : country;
    website = website === VOID ? null : website;
    this.t2m_1 = name;
    this.u2m_1 = country;
    this.v2m_1 = website;
    this.w2m_1 = active;
  }
  protoOf(UpdateIssuingAuthorityRequest).toString = function () {
    return 'UpdateIssuingAuthorityRequest(name=' + this.t2m_1 + ', country=' + this.u2m_1 + ', website=' + this.v2m_1 + ', active=' + this.w2m_1 + ')';
  };
  protoOf(UpdateIssuingAuthorityRequest).hashCode = function () {
    var result = getStringHashCode(this.t2m_1);
    result = imul(result, 31) + (this.u2m_1 == null ? 0 : getStringHashCode(this.u2m_1)) | 0;
    result = imul(result, 31) + (this.v2m_1 == null ? 0 : getStringHashCode(this.v2m_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w2m_1) | 0;
    return result;
  };
  protoOf(UpdateIssuingAuthorityRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateIssuingAuthorityRequest))
      return false;
    if (!(this.t2m_1 === other.t2m_1))
      return false;
    if (!(this.u2m_1 == other.u2m_1))
      return false;
    if (!(this.v2m_1 == other.v2m_1))
      return false;
    if (!(this.w2m_1 === other.w2m_1))
      return false;
    return true;
  };
  function Companion_47() {
  }
  var Companion_instance_48;
  function Companion_getInstance_47() {
    return Companion_instance_48;
  }
  function $serializer_47() {
    $serializer_instance_47 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.IssuingAuthorityResponse', this, 5);
    tmp0_serialDesc.tt('id', false);
    tmp0_serialDesc.tt('name', false);
    tmp0_serialDesc.tt('country', true);
    tmp0_serialDesc.tt('website', true);
    tmp0_serialDesc.tt('active', true);
    this.x2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_47).y2m = function (encoder, value) {
    var tmp0_desc = this.x2m_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.z2m_1);
    tmp1_output.un(tmp0_desc, 1, value.a2n_1);
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.b2n_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.b2n_1);
    }
    if (tmp1_output.co(tmp0_desc, 3) ? true : !(value.c2n_1 == null)) {
      tmp1_output.yn(tmp0_desc, 3, StringSerializer_getInstance(), value.c2n_1);
    }
    if (tmp1_output.co(tmp0_desc, 4) ? true : !(value.d2n_1 === true)) {
      tmp1_output.mn(tmp0_desc, 4, value.d2n_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_47).fj = function (encoder, value) {
    return this.y2m(encoder, value instanceof IssuingAuthorityResponse ? value : THROW_CCE());
  };
  protoOf($serializer_47).gj = function (decoder) {
    var tmp0_desc = this.x2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_input = decoder.fm(tmp0_desc);
    if (tmp9_input.vm()) {
      tmp4_local0 = tmp9_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.tm(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.tm(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.gm(tmp0_desc);
    return IssuingAuthorityResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_47).ej = function () {
    return this.x2m_1;
  };
  protoOf($serializer_47).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_47;
  function $serializer_getInstance_47() {
    if ($serializer_instance_47 == null)
      new $serializer_47();
    return $serializer_instance_47;
  }
  function IssuingAuthorityResponse_init_$Init$(seen0, id, name, country, website, active, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_47().x2m_1);
    }
    $this.z2m_1 = id;
    $this.a2n_1 = name;
    if (0 === (seen0 & 4))
      $this.b2n_1 = null;
    else
      $this.b2n_1 = country;
    if (0 === (seen0 & 8))
      $this.c2n_1 = null;
    else
      $this.c2n_1 = website;
    if (0 === (seen0 & 16))
      $this.d2n_1 = true;
    else
      $this.d2n_1 = active;
    return $this;
  }
  function IssuingAuthorityResponse_init_$Create$(seen0, id, name, country, website, active, serializationConstructorMarker) {
    return IssuingAuthorityResponse_init_$Init$(seen0, id, name, country, website, active, serializationConstructorMarker, objectCreate(protoOf(IssuingAuthorityResponse)));
  }
  function IssuingAuthorityResponse(id, name, country, website, active) {
    country = country === VOID ? null : country;
    website = website === VOID ? null : website;
    active = active === VOID ? true : active;
    this.z2m_1 = id;
    this.a2n_1 = name;
    this.b2n_1 = country;
    this.c2n_1 = website;
    this.d2n_1 = active;
  }
  protoOf(IssuingAuthorityResponse).toString = function () {
    return 'IssuingAuthorityResponse(id=' + this.z2m_1 + ', name=' + this.a2n_1 + ', country=' + this.b2n_1 + ', website=' + this.c2n_1 + ', active=' + this.d2n_1 + ')';
  };
  protoOf(IssuingAuthorityResponse).hashCode = function () {
    var result = getStringHashCode(this.z2m_1);
    result = imul(result, 31) + getStringHashCode(this.a2n_1) | 0;
    result = imul(result, 31) + (this.b2n_1 == null ? 0 : getStringHashCode(this.b2n_1)) | 0;
    result = imul(result, 31) + (this.c2n_1 == null ? 0 : getStringHashCode(this.c2n_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d2n_1) | 0;
    return result;
  };
  protoOf(IssuingAuthorityResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IssuingAuthorityResponse))
      return false;
    if (!(this.z2m_1 === other.z2m_1))
      return false;
    if (!(this.a2n_1 === other.a2n_1))
      return false;
    if (!(this.b2n_1 == other.b2n_1))
      return false;
    if (!(this.c2n_1 == other.c2n_1))
      return false;
    if (!(this.d2n_1 === other.d2n_1))
      return false;
    return true;
  };
  function CreateCertificationTypeRequest$Companion$$childSerializers$_anonymous__pjedot() {
    return new LinkedHashSetSerializer(createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values()));
  }
  function Companion_48() {
    Companion_instance_49 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e2n_1 = [null, null, lazy(tmp_0, CreateCertificationTypeRequest$Companion$$childSerializers$_anonymous__pjedot)];
  }
  var Companion_instance_49;
  function Companion_getInstance_48() {
    if (Companion_instance_49 == null)
      new Companion_48();
    return Companion_instance_49;
  }
  function $serializer_48() {
    $serializer_instance_48 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.CreateCertificationTypeRequest', this, 3);
    tmp0_serialDesc.tt('issuingAuthorityId', false);
    tmp0_serialDesc.tt('name', false);
    tmp0_serialDesc.tt('validatedActivityTypes', false);
    this.f2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_48).g2n = function (encoder, value) {
    var tmp0_desc = this.f2n_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_48().e2n_1;
    tmp1_output.un(tmp0_desc, 0, value.h2n_1);
    tmp1_output.un(tmp0_desc, 1, value.i2n_1);
    tmp1_output.wn(tmp0_desc, 2, tmp2_cached[2].f2(), value.j2n_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_48).fj = function (encoder, value) {
    return this.g2n(encoder, value instanceof CreateCertificationTypeRequest ? value : THROW_CCE());
  };
  protoOf($serializer_48).gj = function (decoder) {
    var tmp0_desc = this.f2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    var tmp8_cached = Companion_getInstance_48().e2n_1;
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.rm(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.rm(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return CreateCertificationTypeRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_48).ej = function () {
    return this.f2n_1;
  };
  protoOf($serializer_48).iu = function () {
    var tmp0_cached = Companion_getInstance_48().e2n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2()];
  };
  var $serializer_instance_48;
  function $serializer_getInstance_48() {
    if ($serializer_instance_48 == null)
      new $serializer_48();
    return $serializer_instance_48;
  }
  function CreateCertificationTypeRequest_init_$Init$(seen0, issuingAuthorityId, name, validatedActivityTypes, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_48().f2n_1);
    }
    $this.h2n_1 = issuingAuthorityId;
    $this.i2n_1 = name;
    $this.j2n_1 = validatedActivityTypes;
    return $this;
  }
  function CreateCertificationTypeRequest_init_$Create$(seen0, issuingAuthorityId, name, validatedActivityTypes, serializationConstructorMarker) {
    return CreateCertificationTypeRequest_init_$Init$(seen0, issuingAuthorityId, name, validatedActivityTypes, serializationConstructorMarker, objectCreate(protoOf(CreateCertificationTypeRequest)));
  }
  function CreateCertificationTypeRequest(issuingAuthorityId, name, validatedActivityTypes) {
    Companion_getInstance_48();
    this.h2n_1 = issuingAuthorityId;
    this.i2n_1 = name;
    this.j2n_1 = validatedActivityTypes;
  }
  protoOf(CreateCertificationTypeRequest).toString = function () {
    return 'CreateCertificationTypeRequest(issuingAuthorityId=' + this.h2n_1 + ', name=' + this.i2n_1 + ', validatedActivityTypes=' + toString(this.j2n_1) + ')';
  };
  protoOf(CreateCertificationTypeRequest).hashCode = function () {
    var result = getStringHashCode(this.h2n_1);
    result = imul(result, 31) + getStringHashCode(this.i2n_1) | 0;
    result = imul(result, 31) + hashCode(this.j2n_1) | 0;
    return result;
  };
  protoOf(CreateCertificationTypeRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CreateCertificationTypeRequest))
      return false;
    if (!(this.h2n_1 === other.h2n_1))
      return false;
    if (!(this.i2n_1 === other.i2n_1))
      return false;
    if (!equals(this.j2n_1, other.j2n_1))
      return false;
    return true;
  };
  function UpdateCertificationTypeRequest$Companion$$childSerializers$_anonymous__9s2fs6() {
    return new LinkedHashSetSerializer(createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values()));
  }
  function Companion_49() {
    Companion_instance_50 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k2n_1 = [null, lazy(tmp_0, UpdateCertificationTypeRequest$Companion$$childSerializers$_anonymous__9s2fs6), null];
  }
  var Companion_instance_50;
  function Companion_getInstance_49() {
    if (Companion_instance_50 == null)
      new Companion_49();
    return Companion_instance_50;
  }
  function $serializer_49() {
    $serializer_instance_49 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.UpdateCertificationTypeRequest', this, 3);
    tmp0_serialDesc.tt('name', false);
    tmp0_serialDesc.tt('validatedActivityTypes', false);
    tmp0_serialDesc.tt('active', false);
    this.l2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_49).m2n = function (encoder, value) {
    var tmp0_desc = this.l2n_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_49().k2n_1;
    tmp1_output.un(tmp0_desc, 0, value.n2n_1);
    tmp1_output.wn(tmp0_desc, 1, tmp2_cached[1].f2(), value.o2n_1);
    tmp1_output.mn(tmp0_desc, 2, value.p2n_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_49).fj = function (encoder, value) {
    return this.m2n(encoder, value instanceof UpdateCertificationTypeRequest ? value : THROW_CCE());
  };
  protoOf($serializer_49).gj = function (decoder) {
    var tmp0_desc = this.l2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.fm(tmp0_desc);
    var tmp8_cached = Companion_getInstance_49().k2n_1;
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.rm(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.rm(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return UpdateCertificationTypeRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_49).ej = function () {
    return this.l2n_1;
  };
  protoOf($serializer_49).iu = function () {
    var tmp0_cached = Companion_getInstance_49().k2n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1].f2(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_49;
  function $serializer_getInstance_49() {
    if ($serializer_instance_49 == null)
      new $serializer_49();
    return $serializer_instance_49;
  }
  function UpdateCertificationTypeRequest_init_$Init$(seen0, name, validatedActivityTypes, active, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_49().l2n_1);
    }
    $this.n2n_1 = name;
    $this.o2n_1 = validatedActivityTypes;
    $this.p2n_1 = active;
    return $this;
  }
  function UpdateCertificationTypeRequest_init_$Create$(seen0, name, validatedActivityTypes, active, serializationConstructorMarker) {
    return UpdateCertificationTypeRequest_init_$Init$(seen0, name, validatedActivityTypes, active, serializationConstructorMarker, objectCreate(protoOf(UpdateCertificationTypeRequest)));
  }
  function UpdateCertificationTypeRequest(name, validatedActivityTypes, active) {
    Companion_getInstance_49();
    this.n2n_1 = name;
    this.o2n_1 = validatedActivityTypes;
    this.p2n_1 = active;
  }
  protoOf(UpdateCertificationTypeRequest).toString = function () {
    return 'UpdateCertificationTypeRequest(name=' + this.n2n_1 + ', validatedActivityTypes=' + toString(this.o2n_1) + ', active=' + this.p2n_1 + ')';
  };
  protoOf(UpdateCertificationTypeRequest).hashCode = function () {
    var result = getStringHashCode(this.n2n_1);
    result = imul(result, 31) + hashCode(this.o2n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p2n_1) | 0;
    return result;
  };
  protoOf(UpdateCertificationTypeRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateCertificationTypeRequest))
      return false;
    if (!(this.n2n_1 === other.n2n_1))
      return false;
    if (!equals(this.o2n_1, other.o2n_1))
      return false;
    if (!(this.p2n_1 === other.p2n_1))
      return false;
    return true;
  };
  function CertificationTypeResponse$Companion$$childSerializers$_anonymous__pm8dmd() {
    return new LinkedHashSetSerializer(createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values()));
  }
  function Companion_50() {
    Companion_instance_51 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q2n_1 = [null, null, null, lazy(tmp_0, CertificationTypeResponse$Companion$$childSerializers$_anonymous__pm8dmd), null];
  }
  var Companion_instance_51;
  function Companion_getInstance_50() {
    if (Companion_instance_51 == null)
      new Companion_50();
    return Companion_instance_51;
  }
  function $serializer_50() {
    $serializer_instance_50 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.CertificationTypeResponse', this, 5);
    tmp0_serialDesc.tt('id', false);
    tmp0_serialDesc.tt('issuingAuthorityId', false);
    tmp0_serialDesc.tt('name', false);
    tmp0_serialDesc.tt('validatedActivityTypes', false);
    tmp0_serialDesc.tt('active', true);
    this.r2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_50).s2n = function (encoder, value) {
    var tmp0_desc = this.r2n_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_50().q2n_1;
    tmp1_output.un(tmp0_desc, 0, value.t2n_1);
    tmp1_output.un(tmp0_desc, 1, value.u2n_1);
    tmp1_output.un(tmp0_desc, 2, value.v2n_1);
    tmp1_output.wn(tmp0_desc, 3, tmp2_cached[3].f2(), value.w2n_1);
    if (tmp1_output.co(tmp0_desc, 4) ? true : !(value.x2n_1 === true)) {
      tmp1_output.mn(tmp0_desc, 4, value.x2n_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_50).fj = function (encoder, value) {
    return this.s2n(encoder, value instanceof CertificationTypeResponse ? value : THROW_CCE());
  };
  protoOf($serializer_50).gj = function (decoder) {
    var tmp0_desc = this.r2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_input = decoder.fm(tmp0_desc);
    var tmp10_cached = Companion_getInstance_50().q2n_1;
    if (tmp9_input.vm()) {
      tmp4_local0 = tmp9_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.rm(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.rm(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.gm(tmp0_desc);
    return CertificationTypeResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_50).ej = function () {
    return this.r2n_1;
  };
  protoOf($serializer_50).iu = function () {
    var tmp0_cached = Companion_getInstance_50().q2n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3].f2(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_50;
  function $serializer_getInstance_50() {
    if ($serializer_instance_50 == null)
      new $serializer_50();
    return $serializer_instance_50;
  }
  function CertificationTypeResponse_init_$Init$(seen0, id, issuingAuthorityId, name, validatedActivityTypes, active, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_50().r2n_1);
    }
    $this.t2n_1 = id;
    $this.u2n_1 = issuingAuthorityId;
    $this.v2n_1 = name;
    $this.w2n_1 = validatedActivityTypes;
    if (0 === (seen0 & 16))
      $this.x2n_1 = true;
    else
      $this.x2n_1 = active;
    return $this;
  }
  function CertificationTypeResponse_init_$Create$(seen0, id, issuingAuthorityId, name, validatedActivityTypes, active, serializationConstructorMarker) {
    return CertificationTypeResponse_init_$Init$(seen0, id, issuingAuthorityId, name, validatedActivityTypes, active, serializationConstructorMarker, objectCreate(protoOf(CertificationTypeResponse)));
  }
  function CertificationTypeResponse(id, issuingAuthorityId, name, validatedActivityTypes, active) {
    Companion_getInstance_50();
    active = active === VOID ? true : active;
    this.t2n_1 = id;
    this.u2n_1 = issuingAuthorityId;
    this.v2n_1 = name;
    this.w2n_1 = validatedActivityTypes;
    this.x2n_1 = active;
  }
  protoOf(CertificationTypeResponse).toString = function () {
    return 'CertificationTypeResponse(id=' + this.t2n_1 + ', issuingAuthorityId=' + this.u2n_1 + ', name=' + this.v2n_1 + ', validatedActivityTypes=' + toString(this.w2n_1) + ', active=' + this.x2n_1 + ')';
  };
  protoOf(CertificationTypeResponse).hashCode = function () {
    var result = getStringHashCode(this.t2n_1);
    result = imul(result, 31) + getStringHashCode(this.u2n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v2n_1) | 0;
    result = imul(result, 31) + hashCode(this.w2n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x2n_1) | 0;
    return result;
  };
  protoOf(CertificationTypeResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CertificationTypeResponse))
      return false;
    if (!(this.t2n_1 === other.t2n_1))
      return false;
    if (!(this.u2n_1 === other.u2n_1))
      return false;
    if (!(this.v2n_1 === other.v2n_1))
      return false;
    if (!equals(this.w2n_1, other.w2n_1))
      return false;
    if (!(this.x2n_1 === other.x2n_1))
      return false;
    return true;
  };
  function Companion_51() {
  }
  var Companion_instance_52;
  function Companion_getInstance_51() {
    return Companion_instance_52;
  }
  function $serializer_51() {
    $serializer_instance_51 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.CredentialResponse', this, 6);
    tmp0_serialDesc.tt('id', false);
    tmp0_serialDesc.tt('holderUserId', false);
    tmp0_serialDesc.tt('certificationTypeId', false);
    tmp0_serialDesc.tt('certificateNumber', false);
    tmp0_serialDesc.tt('issuedAt', false);
    tmp0_serialDesc.tt('expiresAt', true);
    this.y2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_51).z2n = function (encoder, value) {
    var tmp0_desc = this.y2n_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.a2o_1);
    tmp1_output.un(tmp0_desc, 1, value.b2o_1);
    tmp1_output.un(tmp0_desc, 2, value.c2o_1);
    tmp1_output.un(tmp0_desc, 3, value.d2o_1);
    tmp1_output.un(tmp0_desc, 4, value.e2o_1);
    if (tmp1_output.co(tmp0_desc, 5) ? true : !(value.f2o_1 == null)) {
      tmp1_output.yn(tmp0_desc, 5, StringSerializer_getInstance(), value.f2o_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_51).fj = function (encoder, value) {
    return this.z2n(encoder, value instanceof CredentialResponse ? value : THROW_CCE());
  };
  protoOf($serializer_51).gj = function (decoder) {
    var tmp0_desc = this.y2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.fm(tmp0_desc);
    if (tmp10_input.vm()) {
      tmp4_local0 = tmp10_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.pm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.pm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.tm(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.pm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.pm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.tm(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.gm(tmp0_desc);
    return CredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_51).ej = function () {
    return this.y2n_1;
  };
  protoOf($serializer_51).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_51;
  function $serializer_getInstance_51() {
    if ($serializer_instance_51 == null)
      new $serializer_51();
    return $serializer_instance_51;
  }
  function CredentialResponse_init_$Init$(seen0, id, holderUserId, certificationTypeId, certificateNumber, issuedAt, expiresAt, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_51().y2n_1);
    }
    $this.a2o_1 = id;
    $this.b2o_1 = holderUserId;
    $this.c2o_1 = certificationTypeId;
    $this.d2o_1 = certificateNumber;
    $this.e2o_1 = issuedAt;
    if (0 === (seen0 & 32))
      $this.f2o_1 = null;
    else
      $this.f2o_1 = expiresAt;
    return $this;
  }
  function CredentialResponse_init_$Create$(seen0, id, holderUserId, certificationTypeId, certificateNumber, issuedAt, expiresAt, serializationConstructorMarker) {
    return CredentialResponse_init_$Init$(seen0, id, holderUserId, certificationTypeId, certificateNumber, issuedAt, expiresAt, serializationConstructorMarker, objectCreate(protoOf(CredentialResponse)));
  }
  function CredentialResponse(id, holderUserId, certificationTypeId, certificateNumber, issuedAt, expiresAt) {
    expiresAt = expiresAt === VOID ? null : expiresAt;
    this.a2o_1 = id;
    this.b2o_1 = holderUserId;
    this.c2o_1 = certificationTypeId;
    this.d2o_1 = certificateNumber;
    this.e2o_1 = issuedAt;
    this.f2o_1 = expiresAt;
  }
  protoOf(CredentialResponse).toString = function () {
    return 'CredentialResponse(id=' + this.a2o_1 + ', holderUserId=' + this.b2o_1 + ', certificationTypeId=' + this.c2o_1 + ', certificateNumber=' + this.d2o_1 + ', issuedAt=' + this.e2o_1 + ', expiresAt=' + this.f2o_1 + ')';
  };
  protoOf(CredentialResponse).hashCode = function () {
    var result = getStringHashCode(this.a2o_1);
    result = imul(result, 31) + getStringHashCode(this.b2o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c2o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d2o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e2o_1) | 0;
    result = imul(result, 31) + (this.f2o_1 == null ? 0 : getStringHashCode(this.f2o_1)) | 0;
    return result;
  };
  protoOf(CredentialResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CredentialResponse))
      return false;
    if (!(this.a2o_1 === other.a2o_1))
      return false;
    if (!(this.b2o_1 === other.b2o_1))
      return false;
    if (!(this.c2o_1 === other.c2o_1))
      return false;
    if (!(this.d2o_1 === other.d2o_1))
      return false;
    if (!(this.e2o_1 === other.e2o_1))
      return false;
    if (!(this.f2o_1 == other.f2o_1))
      return false;
    return true;
  };
  function SetCompanyActivityOfferingsRequest$Companion$$childSerializers$_anonymous__ho6ao2() {
    return new LinkedHashSetSerializer(createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values()));
  }
  function Companion_52() {
    Companion_instance_53 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g2o_1 = [lazy(tmp_0, SetCompanyActivityOfferingsRequest$Companion$$childSerializers$_anonymous__ho6ao2), null];
  }
  var Companion_instance_53;
  function Companion_getInstance_52() {
    if (Companion_instance_53 == null)
      new Companion_52();
    return Companion_instance_53;
  }
  function $serializer_52() {
    $serializer_instance_52 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.SetCompanyActivityOfferingsRequest', this, 2);
    tmp0_serialDesc.tt('activityTypes', false);
    tmp0_serialDesc.tt('confirmedDeletions', true);
    this.h2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_52).i2o = function (encoder, value) {
    var tmp0_desc = this.h2o_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_52().g2o_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.j2o_1);
    if (tmp1_output.co(tmp0_desc, 1) ? true : !(value.k2o_1 === false)) {
      tmp1_output.mn(tmp0_desc, 1, value.k2o_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_52).fj = function (encoder, value) {
    return this.i2o(encoder, value instanceof SetCompanyActivityOfferingsRequest ? value : THROW_CCE());
  };
  protoOf($serializer_52).gj = function (decoder) {
    var tmp0_desc = this.h2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.fm(tmp0_desc);
    var tmp7_cached = Companion_getInstance_52().g2o_1;
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.hm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.hm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return SetCompanyActivityOfferingsRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_52).ej = function () {
    return this.h2o_1;
  };
  protoOf($serializer_52).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_52().g2o_1[0].f2(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_52;
  function $serializer_getInstance_52() {
    if ($serializer_instance_52 == null)
      new $serializer_52();
    return $serializer_instance_52;
  }
  function SetCompanyActivityOfferingsRequest_init_$Init$(seen0, activityTypes, confirmedDeletions, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_52().h2o_1);
    }
    $this.j2o_1 = activityTypes;
    if (0 === (seen0 & 2))
      $this.k2o_1 = false;
    else
      $this.k2o_1 = confirmedDeletions;
    return $this;
  }
  function SetCompanyActivityOfferingsRequest_init_$Create$(seen0, activityTypes, confirmedDeletions, serializationConstructorMarker) {
    return SetCompanyActivityOfferingsRequest_init_$Init$(seen0, activityTypes, confirmedDeletions, serializationConstructorMarker, objectCreate(protoOf(SetCompanyActivityOfferingsRequest)));
  }
  function SetCompanyActivityOfferingsRequest(activityTypes, confirmedDeletions) {
    Companion_getInstance_52();
    confirmedDeletions = confirmedDeletions === VOID ? false : confirmedDeletions;
    this.j2o_1 = activityTypes;
    this.k2o_1 = confirmedDeletions;
  }
  protoOf(SetCompanyActivityOfferingsRequest).toString = function () {
    return 'SetCompanyActivityOfferingsRequest(activityTypes=' + toString(this.j2o_1) + ', confirmedDeletions=' + this.k2o_1 + ')';
  };
  protoOf(SetCompanyActivityOfferingsRequest).hashCode = function () {
    var result = hashCode(this.j2o_1);
    result = imul(result, 31) + getBooleanHashCode(this.k2o_1) | 0;
    return result;
  };
  protoOf(SetCompanyActivityOfferingsRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetCompanyActivityOfferingsRequest))
      return false;
    if (!equals(this.j2o_1, other.j2o_1))
      return false;
    if (!(this.k2o_1 === other.k2o_1))
      return false;
    return true;
  };
  function CompanyActivityOfferingsResponse$Companion$$childSerializers$_anonymous__vdviso() {
    return new LinkedHashSetSerializer(createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values()));
  }
  function Companion_53() {
    Companion_instance_54 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l2o_1 = [lazy(tmp_0, CompanyActivityOfferingsResponse$Companion$$childSerializers$_anonymous__vdviso)];
  }
  var Companion_instance_54;
  function Companion_getInstance_53() {
    if (Companion_instance_54 == null)
      new Companion_53();
    return Companion_instance_54;
  }
  function $serializer_53() {
    $serializer_instance_53 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.CompanyActivityOfferingsResponse', this, 1);
    tmp0_serialDesc.tt('activityTypes', false);
    this.m2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_53).n2o = function (encoder, value) {
    var tmp0_desc = this.m2o_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_53().l2o_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.o2o_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_53).fj = function (encoder, value) {
    return this.n2o(encoder, value instanceof CompanyActivityOfferingsResponse ? value : THROW_CCE());
  };
  protoOf($serializer_53).gj = function (decoder) {
    var tmp0_desc = this.m2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    var tmp6_cached = Companion_getInstance_53().l2o_1;
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return CompanyActivityOfferingsResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_53).ej = function () {
    return this.m2o_1;
  };
  protoOf($serializer_53).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_53().l2o_1[0].f2()];
  };
  var $serializer_instance_53;
  function $serializer_getInstance_53() {
    if ($serializer_instance_53 == null)
      new $serializer_53();
    return $serializer_instance_53;
  }
  function CompanyActivityOfferingsResponse_init_$Init$(seen0, activityTypes, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_53().m2o_1);
    }
    $this.o2o_1 = activityTypes;
    return $this;
  }
  function CompanyActivityOfferingsResponse_init_$Create$(seen0, activityTypes, serializationConstructorMarker) {
    return CompanyActivityOfferingsResponse_init_$Init$(seen0, activityTypes, serializationConstructorMarker, objectCreate(protoOf(CompanyActivityOfferingsResponse)));
  }
  function CompanyActivityOfferingsResponse(activityTypes) {
    Companion_getInstance_53();
    this.o2o_1 = activityTypes;
  }
  protoOf(CompanyActivityOfferingsResponse).toString = function () {
    return 'CompanyActivityOfferingsResponse(activityTypes=' + toString(this.o2o_1) + ')';
  };
  protoOf(CompanyActivityOfferingsResponse).hashCode = function () {
    return hashCode(this.o2o_1);
  };
  protoOf(CompanyActivityOfferingsResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompanyActivityOfferingsResponse))
      return false;
    if (!equals(this.o2o_1, other.o2o_1))
      return false;
    return true;
  };
  function RequestCertificationVisibilityRequest$Companion$$childSerializers$_anonymous__mdbafc() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values());
  }
  function RequestCertificationVisibilityRequest$Companion$$childSerializers$_anonymous__mdbafc_0() {
    return new ArrayListSerializer(StringSerializer_getInstance());
  }
  function Companion_54() {
    Companion_instance_55 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RequestCertificationVisibilityRequest$Companion$$childSerializers$_anonymous__mdbafc);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p2o_1 = [tmp_1, lazy(tmp_2, RequestCertificationVisibilityRequest$Companion$$childSerializers$_anonymous__mdbafc_0)];
  }
  var Companion_instance_55;
  function Companion_getInstance_54() {
    if (Companion_instance_55 == null)
      new Companion_54();
    return Companion_instance_55;
  }
  function $serializer_54() {
    $serializer_instance_54 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.RequestCertificationVisibilityRequest', this, 2);
    tmp0_serialDesc.tt('activityType', false);
    tmp0_serialDesc.tt('practitionerEmails', false);
    this.q2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_54).r2o = function (encoder, value) {
    var tmp0_desc = this.q2o_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_54().p2o_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.s2o_1);
    tmp1_output.wn(tmp0_desc, 1, tmp2_cached[1].f2(), value.t2o_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_54).fj = function (encoder, value) {
    return this.r2o(encoder, value instanceof RequestCertificationVisibilityRequest ? value : THROW_CCE());
  };
  protoOf($serializer_54).gj = function (decoder) {
    var tmp0_desc = this.q2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    var tmp7_cached = Companion_getInstance_54().p2o_1;
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.rm(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.rm(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return RequestCertificationVisibilityRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_54).ej = function () {
    return this.q2o_1;
  };
  protoOf($serializer_54).iu = function () {
    var tmp0_cached = Companion_getInstance_54().p2o_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].f2(), tmp0_cached[1].f2()];
  };
  var $serializer_instance_54;
  function $serializer_getInstance_54() {
    if ($serializer_instance_54 == null)
      new $serializer_54();
    return $serializer_instance_54;
  }
  function RequestCertificationVisibilityRequest_init_$Init$(seen0, activityType, practitionerEmails, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_54().q2o_1);
    }
    $this.s2o_1 = activityType;
    $this.t2o_1 = practitionerEmails;
    return $this;
  }
  function RequestCertificationVisibilityRequest_init_$Create$(seen0, activityType, practitionerEmails, serializationConstructorMarker) {
    return RequestCertificationVisibilityRequest_init_$Init$(seen0, activityType, practitionerEmails, serializationConstructorMarker, objectCreate(protoOf(RequestCertificationVisibilityRequest)));
  }
  function RequestCertificationVisibilityRequest(activityType, practitionerEmails) {
    Companion_getInstance_54();
    this.s2o_1 = activityType;
    this.t2o_1 = practitionerEmails;
  }
  protoOf(RequestCertificationVisibilityRequest).toString = function () {
    return 'RequestCertificationVisibilityRequest(activityType=' + this.s2o_1.toString() + ', practitionerEmails=' + toString(this.t2o_1) + ')';
  };
  protoOf(RequestCertificationVisibilityRequest).hashCode = function () {
    var result = this.s2o_1.hashCode();
    result = imul(result, 31) + hashCode(this.t2o_1) | 0;
    return result;
  };
  protoOf(RequestCertificationVisibilityRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestCertificationVisibilityRequest))
      return false;
    if (!this.s2o_1.equals(other.s2o_1))
      return false;
    if (!equals(this.t2o_1, other.t2o_1))
      return false;
    return true;
  };
  function RespondToCertificationVisibilityRequestRequest$Companion$$childSerializers$_anonymous__mgpro2() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.VisibilityDecision', values_2());
  }
  function Companion_55() {
    Companion_instance_56 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u2o_1 = [lazy(tmp_0, RespondToCertificationVisibilityRequestRequest$Companion$$childSerializers$_anonymous__mgpro2)];
  }
  var Companion_instance_56;
  function Companion_getInstance_55() {
    if (Companion_instance_56 == null)
      new Companion_55();
    return Companion_instance_56;
  }
  function $serializer_55() {
    $serializer_instance_55 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.RespondToCertificationVisibilityRequestRequest', this, 1);
    tmp0_serialDesc.tt('decision', false);
    this.v2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_55).w2o = function (encoder, value) {
    var tmp0_desc = this.v2o_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_55().u2o_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.x2o_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_55).fj = function (encoder, value) {
    return this.w2o(encoder, value instanceof RespondToCertificationVisibilityRequestRequest ? value : THROW_CCE());
  };
  protoOf($serializer_55).gj = function (decoder) {
    var tmp0_desc = this.v2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    var tmp6_cached = Companion_getInstance_55().u2o_1;
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return RespondToCertificationVisibilityRequestRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_55).ej = function () {
    return this.v2o_1;
  };
  protoOf($serializer_55).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_55().u2o_1[0].f2()];
  };
  var $serializer_instance_55;
  function $serializer_getInstance_55() {
    if ($serializer_instance_55 == null)
      new $serializer_55();
    return $serializer_instance_55;
  }
  function RespondToCertificationVisibilityRequestRequest_init_$Init$(seen0, decision, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_55().v2o_1);
    }
    $this.x2o_1 = decision;
    return $this;
  }
  function RespondToCertificationVisibilityRequestRequest_init_$Create$(seen0, decision, serializationConstructorMarker) {
    return RespondToCertificationVisibilityRequestRequest_init_$Init$(seen0, decision, serializationConstructorMarker, objectCreate(protoOf(RespondToCertificationVisibilityRequestRequest)));
  }
  function RespondToCertificationVisibilityRequestRequest(decision) {
    Companion_getInstance_55();
    this.x2o_1 = decision;
  }
  protoOf(RespondToCertificationVisibilityRequestRequest).toString = function () {
    return 'RespondToCertificationVisibilityRequestRequest(decision=' + this.x2o_1.toString() + ')';
  };
  protoOf(RespondToCertificationVisibilityRequestRequest).hashCode = function () {
    return this.x2o_1.hashCode();
  };
  protoOf(RespondToCertificationVisibilityRequestRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RespondToCertificationVisibilityRequestRequest))
      return false;
    if (!this.x2o_1.equals(other.x2o_1))
      return false;
    return true;
  };
  function CertificationVisibilityRequestResponse$Companion$$childSerializers$_anonymous__iunccm() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ActivityType', values());
  }
  function Companion_56() {
    Companion_instance_57 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y2o_1 = [null, null, null, null, lazy(tmp_0, CertificationVisibilityRequestResponse$Companion$$childSerializers$_anonymous__iunccm), null, null, null, null, null];
  }
  var Companion_instance_57;
  function Companion_getInstance_56() {
    if (Companion_instance_57 == null)
      new Companion_56();
    return Companion_instance_57;
  }
  function $serializer_56() {
    $serializer_instance_56 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.CertificationVisibilityRequestResponse', this, 10);
    tmp0_serialDesc.tt('id', false);
    tmp0_serialDesc.tt('practitionerUserId', false);
    tmp0_serialDesc.tt('requestingCompanyId', false);
    tmp0_serialDesc.tt('requestedByUserId', false);
    tmp0_serialDesc.tt('activityType', false);
    tmp0_serialDesc.tt('status', false);
    tmp0_serialDesc.tt('requestedAt', false);
    tmp0_serialDesc.tt('respondsBy', false);
    tmp0_serialDesc.tt('respondedAt', true);
    tmp0_serialDesc.tt('viewableUntil', true);
    this.z2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_56).a2p = function (encoder, value) {
    var tmp0_desc = this.z2o_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_56().y2o_1;
    tmp1_output.un(tmp0_desc, 0, value.b2p_1);
    tmp1_output.un(tmp0_desc, 1, value.c2p_1);
    tmp1_output.un(tmp0_desc, 2, value.d2p_1);
    tmp1_output.un(tmp0_desc, 3, value.e2p_1);
    tmp1_output.wn(tmp0_desc, 4, tmp2_cached[4].f2(), value.f2p_1);
    tmp1_output.un(tmp0_desc, 5, value.g2p_1);
    tmp1_output.un(tmp0_desc, 6, value.h2p_1);
    tmp1_output.un(tmp0_desc, 7, value.i2p_1);
    if (tmp1_output.co(tmp0_desc, 8) ? true : !(value.j2p_1 == null)) {
      tmp1_output.yn(tmp0_desc, 8, StringSerializer_getInstance(), value.j2p_1);
    }
    if (tmp1_output.co(tmp0_desc, 9) ? true : !(value.k2p_1 == null)) {
      tmp1_output.yn(tmp0_desc, 9, StringSerializer_getInstance(), value.k2p_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_56).fj = function (encoder, value) {
    return this.a2p(encoder, value instanceof CertificationVisibilityRequestResponse ? value : THROW_CCE());
  };
  protoOf($serializer_56).gj = function (decoder) {
    var tmp0_desc = this.z2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_input = decoder.fm(tmp0_desc);
    var tmp15_cached = Companion_getInstance_56().y2o_1;
    if (tmp14_input.vm()) {
      tmp4_local0 = tmp14_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.pm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.rm(tmp0_desc, 4, tmp15_cached[4].f2(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.pm(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.pm(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.pm(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.tm(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.tm(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.pm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.rm(tmp0_desc, 4, tmp15_cached[4].f2(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.pm(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.pm(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.pm(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.tm(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.tm(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.gm(tmp0_desc);
    return CertificationVisibilityRequestResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_56).ej = function () {
    return this.z2o_1;
  };
  protoOf($serializer_56).iu = function () {
    var tmp0_cached = Companion_getInstance_56().y2o_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_56;
  function $serializer_getInstance_56() {
    if ($serializer_instance_56 == null)
      new $serializer_56();
    return $serializer_instance_56;
  }
  function CertificationVisibilityRequestResponse_init_$Init$(seen0, id, practitionerUserId, requestingCompanyId, requestedByUserId, activityType, status, requestedAt, respondsBy, respondedAt, viewableUntil, serializationConstructorMarker, $this) {
    if (!(255 === (255 & seen0))) {
      throwMissingFieldException(seen0, 255, $serializer_getInstance_56().z2o_1);
    }
    $this.b2p_1 = id;
    $this.c2p_1 = practitionerUserId;
    $this.d2p_1 = requestingCompanyId;
    $this.e2p_1 = requestedByUserId;
    $this.f2p_1 = activityType;
    $this.g2p_1 = status;
    $this.h2p_1 = requestedAt;
    $this.i2p_1 = respondsBy;
    if (0 === (seen0 & 256))
      $this.j2p_1 = null;
    else
      $this.j2p_1 = respondedAt;
    if (0 === (seen0 & 512))
      $this.k2p_1 = null;
    else
      $this.k2p_1 = viewableUntil;
    return $this;
  }
  function CertificationVisibilityRequestResponse_init_$Create$(seen0, id, practitionerUserId, requestingCompanyId, requestedByUserId, activityType, status, requestedAt, respondsBy, respondedAt, viewableUntil, serializationConstructorMarker) {
    return CertificationVisibilityRequestResponse_init_$Init$(seen0, id, practitionerUserId, requestingCompanyId, requestedByUserId, activityType, status, requestedAt, respondsBy, respondedAt, viewableUntil, serializationConstructorMarker, objectCreate(protoOf(CertificationVisibilityRequestResponse)));
  }
  function CertificationVisibilityRequestResponse(id, practitionerUserId, requestingCompanyId, requestedByUserId, activityType, status, requestedAt, respondsBy, respondedAt, viewableUntil) {
    Companion_getInstance_56();
    respondedAt = respondedAt === VOID ? null : respondedAt;
    viewableUntil = viewableUntil === VOID ? null : viewableUntil;
    this.b2p_1 = id;
    this.c2p_1 = practitionerUserId;
    this.d2p_1 = requestingCompanyId;
    this.e2p_1 = requestedByUserId;
    this.f2p_1 = activityType;
    this.g2p_1 = status;
    this.h2p_1 = requestedAt;
    this.i2p_1 = respondsBy;
    this.j2p_1 = respondedAt;
    this.k2p_1 = viewableUntil;
  }
  protoOf(CertificationVisibilityRequestResponse).toString = function () {
    return 'CertificationVisibilityRequestResponse(id=' + this.b2p_1 + ', practitionerUserId=' + this.c2p_1 + ', requestingCompanyId=' + this.d2p_1 + ', requestedByUserId=' + this.e2p_1 + ', activityType=' + this.f2p_1.toString() + ', status=' + this.g2p_1 + ', requestedAt=' + this.h2p_1 + ', respondsBy=' + this.i2p_1 + ', respondedAt=' + this.j2p_1 + ', viewableUntil=' + this.k2p_1 + ')';
  };
  protoOf(CertificationVisibilityRequestResponse).hashCode = function () {
    var result = getStringHashCode(this.b2p_1);
    result = imul(result, 31) + getStringHashCode(this.c2p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d2p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e2p_1) | 0;
    result = imul(result, 31) + this.f2p_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.g2p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h2p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i2p_1) | 0;
    result = imul(result, 31) + (this.j2p_1 == null ? 0 : getStringHashCode(this.j2p_1)) | 0;
    result = imul(result, 31) + (this.k2p_1 == null ? 0 : getStringHashCode(this.k2p_1)) | 0;
    return result;
  };
  protoOf(CertificationVisibilityRequestResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CertificationVisibilityRequestResponse))
      return false;
    if (!(this.b2p_1 === other.b2p_1))
      return false;
    if (!(this.c2p_1 === other.c2p_1))
      return false;
    if (!(this.d2p_1 === other.d2p_1))
      return false;
    if (!(this.e2p_1 === other.e2p_1))
      return false;
    if (!this.f2p_1.equals(other.f2p_1))
      return false;
    if (!(this.g2p_1 === other.g2p_1))
      return false;
    if (!(this.h2p_1 === other.h2p_1))
      return false;
    if (!(this.i2p_1 === other.i2p_1))
      return false;
    if (!(this.j2p_1 == other.j2p_1))
      return false;
    if (!(this.k2p_1 == other.k2p_1))
      return false;
    return true;
  };
  function Companion_57() {
  }
  var Companion_instance_58;
  function Companion_getInstance_57() {
    return Companion_instance_58;
  }
  function $serializer_57() {
    $serializer_instance_57 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.VisibilityRequestOutcomeResponse', this, 3);
    tmp0_serialDesc.tt('email', false);
    tmp0_serialDesc.tt('outcome', false);
    tmp0_serialDesc.tt('request', true);
    this.l2p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_57).m2p = function (encoder, value) {
    var tmp0_desc = this.l2p_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.n2p_1);
    tmp1_output.un(tmp0_desc, 1, value.o2p_1);
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.p2p_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, $serializer_getInstance_56(), value.p2p_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_57).fj = function (encoder, value) {
    return this.m2p(encoder, value instanceof VisibilityRequestOutcomeResponse ? value : THROW_CCE());
  };
  protoOf($serializer_57).gj = function (decoder) {
    var tmp0_desc = this.l2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, $serializer_getInstance_56(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, $serializer_getInstance_56(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return VisibilityRequestOutcomeResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_57).ej = function () {
    return this.l2p_1;
  };
  protoOf($serializer_57).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_56())];
  };
  var $serializer_instance_57;
  function $serializer_getInstance_57() {
    if ($serializer_instance_57 == null)
      new $serializer_57();
    return $serializer_instance_57;
  }
  function VisibilityRequestOutcomeResponse_init_$Init$(seen0, email, outcome, request, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_57().l2p_1);
    }
    $this.n2p_1 = email;
    $this.o2p_1 = outcome;
    if (0 === (seen0 & 4))
      $this.p2p_1 = null;
    else
      $this.p2p_1 = request;
    return $this;
  }
  function VisibilityRequestOutcomeResponse_init_$Create$(seen0, email, outcome, request, serializationConstructorMarker) {
    return VisibilityRequestOutcomeResponse_init_$Init$(seen0, email, outcome, request, serializationConstructorMarker, objectCreate(protoOf(VisibilityRequestOutcomeResponse)));
  }
  function VisibilityRequestOutcomeResponse(email, outcome, request) {
    request = request === VOID ? null : request;
    this.n2p_1 = email;
    this.o2p_1 = outcome;
    this.p2p_1 = request;
  }
  protoOf(VisibilityRequestOutcomeResponse).toString = function () {
    return 'VisibilityRequestOutcomeResponse(email=' + this.n2p_1 + ', outcome=' + this.o2p_1 + ', request=' + toString_0(this.p2p_1) + ')';
  };
  protoOf(VisibilityRequestOutcomeResponse).hashCode = function () {
    var result = getStringHashCode(this.n2p_1);
    result = imul(result, 31) + getStringHashCode(this.o2p_1) | 0;
    result = imul(result, 31) + (this.p2p_1 == null ? 0 : this.p2p_1.hashCode()) | 0;
    return result;
  };
  protoOf(VisibilityRequestOutcomeResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VisibilityRequestOutcomeResponse))
      return false;
    if (!(this.n2p_1 === other.n2p_1))
      return false;
    if (!(this.o2p_1 === other.o2p_1))
      return false;
    if (!equals(this.p2p_1, other.p2p_1))
      return false;
    return true;
  };
  function RespondToClaimRequestRequest$Companion$$childSerializers$_anonymous__pw1ece() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.bitacora.ClaimDecision', values_3());
  }
  function Companion_58() {
    Companion_instance_59 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q2p_1 = [lazy(tmp_0, RespondToClaimRequestRequest$Companion$$childSerializers$_anonymous__pw1ece)];
  }
  var Companion_instance_59;
  function Companion_getInstance_58() {
    if (Companion_instance_59 == null)
      new Companion_58();
    return Companion_instance_59;
  }
  function $serializer_58() {
    $serializer_instance_58 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.RespondToClaimRequestRequest', this, 1);
    tmp0_serialDesc.tt('decision', false);
    this.r2p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_58).s2p = function (encoder, value) {
    var tmp0_desc = this.r2p_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_58().q2p_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.t2p_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_58).fj = function (encoder, value) {
    return this.s2p(encoder, value instanceof RespondToClaimRequestRequest ? value : THROW_CCE());
  };
  protoOf($serializer_58).gj = function (decoder) {
    var tmp0_desc = this.r2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    var tmp6_cached = Companion_getInstance_58().q2p_1;
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return RespondToClaimRequestRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_58).ej = function () {
    return this.r2p_1;
  };
  protoOf($serializer_58).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_58().q2p_1[0].f2()];
  };
  var $serializer_instance_58;
  function $serializer_getInstance_58() {
    if ($serializer_instance_58 == null)
      new $serializer_58();
    return $serializer_instance_58;
  }
  function RespondToClaimRequestRequest_init_$Init$(seen0, decision, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_58().r2p_1);
    }
    $this.t2p_1 = decision;
    return $this;
  }
  function RespondToClaimRequestRequest_init_$Create$(seen0, decision, serializationConstructorMarker) {
    return RespondToClaimRequestRequest_init_$Init$(seen0, decision, serializationConstructorMarker, objectCreate(protoOf(RespondToClaimRequestRequest)));
  }
  function RespondToClaimRequestRequest(decision) {
    Companion_getInstance_58();
    this.t2p_1 = decision;
  }
  protoOf(RespondToClaimRequestRequest).toString = function () {
    return 'RespondToClaimRequestRequest(decision=' + this.t2p_1.toString() + ')';
  };
  protoOf(RespondToClaimRequestRequest).hashCode = function () {
    return this.t2p_1.hashCode();
  };
  protoOf(RespondToClaimRequestRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RespondToClaimRequestRequest))
      return false;
    if (!this.t2p_1.equals(other.t2p_1))
      return false;
    return true;
  };
  function Companion_59() {
  }
  var Companion_instance_60;
  function Companion_getInstance_59() {
    return Companion_instance_60;
  }
  function $serializer_59() {
    $serializer_instance_59 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.BitacoraEntryClaimRequestResponse', this, 10);
    tmp0_serialDesc.tt('id', false);
    tmp0_serialDesc.tt('bitacoraEntryId', false);
    tmp0_serialDesc.tt('invitedUserId', false);
    tmp0_serialDesc.tt('requestingCompanyId', false);
    tmp0_serialDesc.tt('requestingCompanyName', true);
    tmp0_serialDesc.tt('requestedByUserId', false);
    tmp0_serialDesc.tt('status', false);
    tmp0_serialDesc.tt('requestedAt', false);
    tmp0_serialDesc.tt('respondsBy', false);
    tmp0_serialDesc.tt('respondedAt', true);
    this.u2p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_59).v2p = function (encoder, value) {
    var tmp0_desc = this.u2p_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.w2p_1);
    tmp1_output.un(tmp0_desc, 1, value.x2p_1);
    tmp1_output.un(tmp0_desc, 2, value.y2p_1);
    tmp1_output.un(tmp0_desc, 3, value.z2p_1);
    if (tmp1_output.co(tmp0_desc, 4) ? true : !(value.a2q_1 == null)) {
      tmp1_output.yn(tmp0_desc, 4, StringSerializer_getInstance(), value.a2q_1);
    }
    tmp1_output.un(tmp0_desc, 5, value.b2q_1);
    tmp1_output.un(tmp0_desc, 6, value.c2q_1);
    tmp1_output.un(tmp0_desc, 7, value.d2q_1);
    tmp1_output.un(tmp0_desc, 8, value.e2q_1);
    if (tmp1_output.co(tmp0_desc, 9) ? true : !(value.f2q_1 == null)) {
      tmp1_output.yn(tmp0_desc, 9, StringSerializer_getInstance(), value.f2q_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_59).fj = function (encoder, value) {
    return this.v2p(encoder, value instanceof BitacoraEntryClaimRequestResponse ? value : THROW_CCE());
  };
  protoOf($serializer_59).gj = function (decoder) {
    var tmp0_desc = this.u2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_input = decoder.fm(tmp0_desc);
    if (tmp14_input.vm()) {
      tmp4_local0 = tmp14_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.pm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.tm(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.pm(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.pm(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.pm(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.pm(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.tm(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.pm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.tm(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.pm(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.pm(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.pm(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.pm(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.tm(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.gm(tmp0_desc);
    return BitacoraEntryClaimRequestResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_59).ej = function () {
    return this.u2p_1;
  };
  protoOf($serializer_59).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_59;
  function $serializer_getInstance_59() {
    if ($serializer_instance_59 == null)
      new $serializer_59();
    return $serializer_instance_59;
  }
  function BitacoraEntryClaimRequestResponse_init_$Init$(seen0, id, bitacoraEntryId, invitedUserId, requestingCompanyId, requestingCompanyName, requestedByUserId, status, requestedAt, respondsBy, respondedAt, serializationConstructorMarker, $this) {
    if (!(495 === (495 & seen0))) {
      throwMissingFieldException(seen0, 495, $serializer_getInstance_59().u2p_1);
    }
    $this.w2p_1 = id;
    $this.x2p_1 = bitacoraEntryId;
    $this.y2p_1 = invitedUserId;
    $this.z2p_1 = requestingCompanyId;
    if (0 === (seen0 & 16))
      $this.a2q_1 = null;
    else
      $this.a2q_1 = requestingCompanyName;
    $this.b2q_1 = requestedByUserId;
    $this.c2q_1 = status;
    $this.d2q_1 = requestedAt;
    $this.e2q_1 = respondsBy;
    if (0 === (seen0 & 512))
      $this.f2q_1 = null;
    else
      $this.f2q_1 = respondedAt;
    return $this;
  }
  function BitacoraEntryClaimRequestResponse_init_$Create$(seen0, id, bitacoraEntryId, invitedUserId, requestingCompanyId, requestingCompanyName, requestedByUserId, status, requestedAt, respondsBy, respondedAt, serializationConstructorMarker) {
    return BitacoraEntryClaimRequestResponse_init_$Init$(seen0, id, bitacoraEntryId, invitedUserId, requestingCompanyId, requestingCompanyName, requestedByUserId, status, requestedAt, respondsBy, respondedAt, serializationConstructorMarker, objectCreate(protoOf(BitacoraEntryClaimRequestResponse)));
  }
  function BitacoraEntryClaimRequestResponse(id, bitacoraEntryId, invitedUserId, requestingCompanyId, requestingCompanyName, requestedByUserId, status, requestedAt, respondsBy, respondedAt) {
    requestingCompanyName = requestingCompanyName === VOID ? null : requestingCompanyName;
    respondedAt = respondedAt === VOID ? null : respondedAt;
    this.w2p_1 = id;
    this.x2p_1 = bitacoraEntryId;
    this.y2p_1 = invitedUserId;
    this.z2p_1 = requestingCompanyId;
    this.a2q_1 = requestingCompanyName;
    this.b2q_1 = requestedByUserId;
    this.c2q_1 = status;
    this.d2q_1 = requestedAt;
    this.e2q_1 = respondsBy;
    this.f2q_1 = respondedAt;
  }
  protoOf(BitacoraEntryClaimRequestResponse).toString = function () {
    return 'BitacoraEntryClaimRequestResponse(id=' + this.w2p_1 + ', bitacoraEntryId=' + this.x2p_1 + ', invitedUserId=' + this.y2p_1 + ', requestingCompanyId=' + this.z2p_1 + ', requestingCompanyName=' + this.a2q_1 + ', requestedByUserId=' + this.b2q_1 + ', status=' + this.c2q_1 + ', requestedAt=' + this.d2q_1 + ', respondsBy=' + this.e2q_1 + ', respondedAt=' + this.f2q_1 + ')';
  };
  protoOf(BitacoraEntryClaimRequestResponse).hashCode = function () {
    var result = getStringHashCode(this.w2p_1);
    result = imul(result, 31) + getStringHashCode(this.x2p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y2p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z2p_1) | 0;
    result = imul(result, 31) + (this.a2q_1 == null ? 0 : getStringHashCode(this.a2q_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.b2q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c2q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d2q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e2q_1) | 0;
    result = imul(result, 31) + (this.f2q_1 == null ? 0 : getStringHashCode(this.f2q_1)) | 0;
    return result;
  };
  protoOf(BitacoraEntryClaimRequestResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BitacoraEntryClaimRequestResponse))
      return false;
    if (!(this.w2p_1 === other.w2p_1))
      return false;
    if (!(this.x2p_1 === other.x2p_1))
      return false;
    if (!(this.y2p_1 === other.y2p_1))
      return false;
    if (!(this.z2p_1 === other.z2p_1))
      return false;
    if (!(this.a2q_1 == other.a2q_1))
      return false;
    if (!(this.b2q_1 === other.b2q_1))
      return false;
    if (!(this.c2q_1 === other.c2q_1))
      return false;
    if (!(this.d2q_1 === other.d2q_1))
      return false;
    if (!(this.e2q_1 === other.e2q_1))
      return false;
    if (!(this.f2q_1 == other.f2q_1))
      return false;
    return true;
  };
  function Companion_60() {
  }
  var Companion_instance_61;
  function Companion_getInstance_60() {
    return Companion_instance_61;
  }
  function $serializer_60() {
    $serializer_instance_60 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.DeviceSyncConnectResponse', this, 1);
    tmp0_serialDesc.tt('authorizationUrl', false);
    this.g2q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_60).h2q = function (encoder, value) {
    var tmp0_desc = this.g2q_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.i2q_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_60).fj = function (encoder, value) {
    return this.h2q(encoder, value instanceof DeviceSyncConnectResponse ? value : THROW_CCE());
  };
  protoOf($serializer_60).gj = function (decoder) {
    var tmp0_desc = this.g2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return DeviceSyncConnectResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_60).ej = function () {
    return this.g2q_1;
  };
  protoOf($serializer_60).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_60;
  function $serializer_getInstance_60() {
    if ($serializer_instance_60 == null)
      new $serializer_60();
    return $serializer_instance_60;
  }
  function DeviceSyncConnectResponse_init_$Init$(seen0, authorizationUrl, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_60().g2q_1);
    }
    $this.i2q_1 = authorizationUrl;
    return $this;
  }
  function DeviceSyncConnectResponse_init_$Create$(seen0, authorizationUrl, serializationConstructorMarker) {
    return DeviceSyncConnectResponse_init_$Init$(seen0, authorizationUrl, serializationConstructorMarker, objectCreate(protoOf(DeviceSyncConnectResponse)));
  }
  function DeviceSyncConnectResponse(authorizationUrl) {
    this.i2q_1 = authorizationUrl;
  }
  protoOf(DeviceSyncConnectResponse).toString = function () {
    return 'DeviceSyncConnectResponse(authorizationUrl=' + this.i2q_1 + ')';
  };
  protoOf(DeviceSyncConnectResponse).hashCode = function () {
    return getStringHashCode(this.i2q_1);
  };
  protoOf(DeviceSyncConnectResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeviceSyncConnectResponse))
      return false;
    if (!(this.i2q_1 === other.i2q_1))
      return false;
    return true;
  };
  function Companion_61() {
  }
  var Companion_instance_62;
  function Companion_getInstance_61() {
    return Companion_instance_62;
  }
  function $serializer_61() {
    $serializer_instance_61 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.DeviceSyncConnectionResponse', this, 3);
    tmp0_serialDesc.tt('provider', false);
    tmp0_serialDesc.tt('status', false);
    tmp0_serialDesc.tt('lastSyncedAt', false);
    this.j2q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_61).k2q = function (encoder, value) {
    var tmp0_desc = this.j2q_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.l2q_1);
    tmp1_output.un(tmp0_desc, 1, value.m2q_1);
    tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.n2q_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_61).fj = function (encoder, value) {
    return this.k2q(encoder, value instanceof DeviceSyncConnectionResponse ? value : THROW_CCE());
  };
  protoOf($serializer_61).gj = function (decoder) {
    var tmp0_desc = this.j2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return DeviceSyncConnectionResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_61).ej = function () {
    return this.j2q_1;
  };
  protoOf($serializer_61).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_61;
  function $serializer_getInstance_61() {
    if ($serializer_instance_61 == null)
      new $serializer_61();
    return $serializer_instance_61;
  }
  function DeviceSyncConnectionResponse_init_$Init$(seen0, provider, status, lastSyncedAt, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_61().j2q_1);
    }
    $this.l2q_1 = provider;
    $this.m2q_1 = status;
    $this.n2q_1 = lastSyncedAt;
    return $this;
  }
  function DeviceSyncConnectionResponse_init_$Create$(seen0, provider, status, lastSyncedAt, serializationConstructorMarker) {
    return DeviceSyncConnectionResponse_init_$Init$(seen0, provider, status, lastSyncedAt, serializationConstructorMarker, objectCreate(protoOf(DeviceSyncConnectionResponse)));
  }
  function DeviceSyncConnectionResponse(provider, status, lastSyncedAt) {
    this.l2q_1 = provider;
    this.m2q_1 = status;
    this.n2q_1 = lastSyncedAt;
  }
  protoOf(DeviceSyncConnectionResponse).toString = function () {
    return 'DeviceSyncConnectionResponse(provider=' + this.l2q_1 + ', status=' + this.m2q_1 + ', lastSyncedAt=' + this.n2q_1 + ')';
  };
  protoOf(DeviceSyncConnectionResponse).hashCode = function () {
    var result = getStringHashCode(this.l2q_1);
    result = imul(result, 31) + getStringHashCode(this.m2q_1) | 0;
    result = imul(result, 31) + (this.n2q_1 == null ? 0 : getStringHashCode(this.n2q_1)) | 0;
    return result;
  };
  protoOf(DeviceSyncConnectionResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeviceSyncConnectionResponse))
      return false;
    if (!(this.l2q_1 === other.l2q_1))
      return false;
    if (!(this.m2q_1 === other.m2q_1))
      return false;
    if (!(this.n2q_1 == other.n2q_1))
      return false;
    return true;
  };
  function Companion_62() {
  }
  var Companion_instance_63;
  function Companion_getInstance_62() {
    return Companion_instance_63;
  }
  function $serializer_62() {
    $serializer_instance_62 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.StartSubscriptionCheckoutRequest', this, 3);
    tmp0_serialDesc.tt('tier', false);
    tmp0_serialDesc.tt('successUrl', false);
    tmp0_serialDesc.tt('cancelUrl', false);
    this.o2q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_62).p2q = function (encoder, value) {
    var tmp0_desc = this.o2q_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.q2q_1);
    tmp1_output.un(tmp0_desc, 1, value.r2q_1);
    tmp1_output.un(tmp0_desc, 2, value.s2q_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_62).fj = function (encoder, value) {
    return this.p2q(encoder, value instanceof StartSubscriptionCheckoutRequest ? value : THROW_CCE());
  };
  protoOf($serializer_62).gj = function (decoder) {
    var tmp0_desc = this.o2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return StartSubscriptionCheckoutRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_62).ej = function () {
    return this.o2q_1;
  };
  protoOf($serializer_62).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_62;
  function $serializer_getInstance_62() {
    if ($serializer_instance_62 == null)
      new $serializer_62();
    return $serializer_instance_62;
  }
  function StartSubscriptionCheckoutRequest_init_$Init$(seen0, tier, successUrl, cancelUrl, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_62().o2q_1);
    }
    $this.q2q_1 = tier;
    $this.r2q_1 = successUrl;
    $this.s2q_1 = cancelUrl;
    return $this;
  }
  function StartSubscriptionCheckoutRequest_init_$Create$(seen0, tier, successUrl, cancelUrl, serializationConstructorMarker) {
    return StartSubscriptionCheckoutRequest_init_$Init$(seen0, tier, successUrl, cancelUrl, serializationConstructorMarker, objectCreate(protoOf(StartSubscriptionCheckoutRequest)));
  }
  function StartSubscriptionCheckoutRequest(tier, successUrl, cancelUrl) {
    this.q2q_1 = tier;
    this.r2q_1 = successUrl;
    this.s2q_1 = cancelUrl;
  }
  protoOf(StartSubscriptionCheckoutRequest).toString = function () {
    return 'StartSubscriptionCheckoutRequest(tier=' + this.q2q_1 + ', successUrl=' + this.r2q_1 + ', cancelUrl=' + this.s2q_1 + ')';
  };
  protoOf(StartSubscriptionCheckoutRequest).hashCode = function () {
    var result = getStringHashCode(this.q2q_1);
    result = imul(result, 31) + getStringHashCode(this.r2q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s2q_1) | 0;
    return result;
  };
  protoOf(StartSubscriptionCheckoutRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StartSubscriptionCheckoutRequest))
      return false;
    if (!(this.q2q_1 === other.q2q_1))
      return false;
    if (!(this.r2q_1 === other.r2q_1))
      return false;
    if (!(this.s2q_1 === other.s2q_1))
      return false;
    return true;
  };
  function Companion_63() {
  }
  var Companion_instance_64;
  function Companion_getInstance_63() {
    return Companion_instance_64;
  }
  function $serializer_63() {
    $serializer_instance_63 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.AdSizeRateResponse', this, 3);
    tmp0_serialDesc.tt('country', false);
    tmp0_serialDesc.tt('size', false);
    tmp0_serialDesc.tt('baseCostPerImpressionCents', false);
    this.t2q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_63).u2q = function (encoder, value) {
    var tmp0_desc = this.t2q_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.v2q_1);
    tmp1_output.un(tmp0_desc, 1, value.w2q_1);
    tmp1_output.qn(tmp0_desc, 2, value.x2q_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_63).fj = function (encoder, value) {
    return this.u2q(encoder, value instanceof AdSizeRateResponse ? value : THROW_CCE());
  };
  protoOf($serializer_63).gj = function (decoder) {
    var tmp0_desc = this.t2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return AdSizeRateResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_63).ej = function () {
    return this.t2q_1;
  };
  protoOf($serializer_63).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_63;
  function $serializer_getInstance_63() {
    if ($serializer_instance_63 == null)
      new $serializer_63();
    return $serializer_instance_63;
  }
  function AdSizeRateResponse_init_$Init$(seen0, country, size, baseCostPerImpressionCents, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_63().t2q_1);
    }
    $this.v2q_1 = country;
    $this.w2q_1 = size;
    $this.x2q_1 = baseCostPerImpressionCents;
    return $this;
  }
  function AdSizeRateResponse_init_$Create$(seen0, country, size, baseCostPerImpressionCents, serializationConstructorMarker) {
    return AdSizeRateResponse_init_$Init$(seen0, country, size, baseCostPerImpressionCents, serializationConstructorMarker, objectCreate(protoOf(AdSizeRateResponse)));
  }
  function AdSizeRateResponse(country, size, baseCostPerImpressionCents) {
    this.v2q_1 = country;
    this.w2q_1 = size;
    this.x2q_1 = baseCostPerImpressionCents;
  }
  protoOf(AdSizeRateResponse).toString = function () {
    return 'AdSizeRateResponse(country=' + this.v2q_1 + ', size=' + this.w2q_1 + ', baseCostPerImpressionCents=' + this.x2q_1.toString() + ')';
  };
  protoOf(AdSizeRateResponse).hashCode = function () {
    var result = getStringHashCode(this.v2q_1);
    result = imul(result, 31) + getStringHashCode(this.w2q_1) | 0;
    result = imul(result, 31) + this.x2q_1.hashCode() | 0;
    return result;
  };
  protoOf(AdSizeRateResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AdSizeRateResponse))
      return false;
    if (!(this.v2q_1 === other.v2q_1))
      return false;
    if (!(this.w2q_1 === other.w2q_1))
      return false;
    if (!equalsLong(this.x2q_1, other.x2q_1))
      return false;
    return true;
  };
  function Companion_64() {
  }
  var Companion_instance_65;
  function Companion_getInstance_64() {
    return Companion_instance_65;
  }
  function $serializer_64() {
    $serializer_instance_64 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.AdTierSurchargeResponse', this, 3);
    tmp0_serialDesc.tt('country', false);
    tmp0_serialDesc.tt('tierKey', false);
    tmp0_serialDesc.tt('surchargeCents', false);
    this.y2q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_64).z2q = function (encoder, value) {
    var tmp0_desc = this.y2q_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.a2r_1);
    tmp1_output.un(tmp0_desc, 1, value.b2r_1);
    tmp1_output.qn(tmp0_desc, 2, value.c2r_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_64).fj = function (encoder, value) {
    return this.z2q(encoder, value instanceof AdTierSurchargeResponse ? value : THROW_CCE());
  };
  protoOf($serializer_64).gj = function (decoder) {
    var tmp0_desc = this.y2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return AdTierSurchargeResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_64).ej = function () {
    return this.y2q_1;
  };
  protoOf($serializer_64).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_64;
  function $serializer_getInstance_64() {
    if ($serializer_instance_64 == null)
      new $serializer_64();
    return $serializer_instance_64;
  }
  function AdTierSurchargeResponse_init_$Init$(seen0, country, tierKey, surchargeCents, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_64().y2q_1);
    }
    $this.a2r_1 = country;
    $this.b2r_1 = tierKey;
    $this.c2r_1 = surchargeCents;
    return $this;
  }
  function AdTierSurchargeResponse_init_$Create$(seen0, country, tierKey, surchargeCents, serializationConstructorMarker) {
    return AdTierSurchargeResponse_init_$Init$(seen0, country, tierKey, surchargeCents, serializationConstructorMarker, objectCreate(protoOf(AdTierSurchargeResponse)));
  }
  function AdTierSurchargeResponse(country, tierKey, surchargeCents) {
    this.a2r_1 = country;
    this.b2r_1 = tierKey;
    this.c2r_1 = surchargeCents;
  }
  protoOf(AdTierSurchargeResponse).toString = function () {
    return 'AdTierSurchargeResponse(country=' + this.a2r_1 + ', tierKey=' + this.b2r_1 + ', surchargeCents=' + this.c2r_1.toString() + ')';
  };
  protoOf(AdTierSurchargeResponse).hashCode = function () {
    var result = getStringHashCode(this.a2r_1);
    result = imul(result, 31) + getStringHashCode(this.b2r_1) | 0;
    result = imul(result, 31) + this.c2r_1.hashCode() | 0;
    return result;
  };
  protoOf(AdTierSurchargeResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AdTierSurchargeResponse))
      return false;
    if (!(this.a2r_1 === other.a2r_1))
      return false;
    if (!(this.b2r_1 === other.b2r_1))
      return false;
    if (!equalsLong(this.c2r_1, other.c2r_1))
      return false;
    return true;
  };
  function AdPricingResponse$Companion$$childSerializers$_anonymous__8d1q7a() {
    return new ArrayListSerializer($serializer_getInstance_63());
  }
  function AdPricingResponse$Companion$$childSerializers$_anonymous__8d1q7a_0() {
    return new ArrayListSerializer($serializer_getInstance_64());
  }
  function Companion_65() {
    Companion_instance_66 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, AdPricingResponse$Companion$$childSerializers$_anonymous__8d1q7a);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d2r_1 = [tmp_1, lazy(tmp_2, AdPricingResponse$Companion$$childSerializers$_anonymous__8d1q7a_0)];
  }
  var Companion_instance_66;
  function Companion_getInstance_65() {
    if (Companion_instance_66 == null)
      new Companion_65();
    return Companion_instance_66;
  }
  function $serializer_65() {
    $serializer_instance_65 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.AdPricingResponse', this, 2);
    tmp0_serialDesc.tt('sizeRates', false);
    tmp0_serialDesc.tt('tierSurcharges', false);
    this.e2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_65).f2r = function (encoder, value) {
    var tmp0_desc = this.e2r_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_65().d2r_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.g2r_1);
    tmp1_output.wn(tmp0_desc, 1, tmp2_cached[1].f2(), value.h2r_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_65).fj = function (encoder, value) {
    return this.f2r(encoder, value instanceof AdPricingResponse ? value : THROW_CCE());
  };
  protoOf($serializer_65).gj = function (decoder) {
    var tmp0_desc = this.e2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.fm(tmp0_desc);
    var tmp7_cached = Companion_getInstance_65().d2r_1;
    if (tmp6_input.vm()) {
      tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.rm(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.rm(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.gm(tmp0_desc);
    return AdPricingResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_65).ej = function () {
    return this.e2r_1;
  };
  protoOf($serializer_65).iu = function () {
    var tmp0_cached = Companion_getInstance_65().d2r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0].f2(), tmp0_cached[1].f2()];
  };
  var $serializer_instance_65;
  function $serializer_getInstance_65() {
    if ($serializer_instance_65 == null)
      new $serializer_65();
    return $serializer_instance_65;
  }
  function AdPricingResponse_init_$Init$(seen0, sizeRates, tierSurcharges, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_65().e2r_1);
    }
    $this.g2r_1 = sizeRates;
    $this.h2r_1 = tierSurcharges;
    return $this;
  }
  function AdPricingResponse_init_$Create$(seen0, sizeRates, tierSurcharges, serializationConstructorMarker) {
    return AdPricingResponse_init_$Init$(seen0, sizeRates, tierSurcharges, serializationConstructorMarker, objectCreate(protoOf(AdPricingResponse)));
  }
  function AdPricingResponse(sizeRates, tierSurcharges) {
    Companion_getInstance_65();
    this.g2r_1 = sizeRates;
    this.h2r_1 = tierSurcharges;
  }
  protoOf(AdPricingResponse).toString = function () {
    return 'AdPricingResponse(sizeRates=' + toString(this.g2r_1) + ', tierSurcharges=' + toString(this.h2r_1) + ')';
  };
  protoOf(AdPricingResponse).hashCode = function () {
    var result = hashCode(this.g2r_1);
    result = imul(result, 31) + hashCode(this.h2r_1) | 0;
    return result;
  };
  protoOf(AdPricingResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AdPricingResponse))
      return false;
    if (!equals(this.g2r_1, other.g2r_1))
      return false;
    if (!equals(this.h2r_1, other.h2r_1))
      return false;
    return true;
  };
  function Companion_66() {
  }
  var Companion_instance_67;
  function Companion_getInstance_66() {
    return Companion_instance_67;
  }
  function $serializer_66() {
    $serializer_instance_66 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.SetAdSizeRateRequest', this, 3);
    tmp0_serialDesc.tt('country', false);
    tmp0_serialDesc.tt('size', false);
    tmp0_serialDesc.tt('baseCostPerImpressionCents', false);
    this.i2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_66).j2r = function (encoder, value) {
    var tmp0_desc = this.i2r_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.k2r_1);
    tmp1_output.un(tmp0_desc, 1, value.l2r_1);
    tmp1_output.qn(tmp0_desc, 2, value.m2r_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_66).fj = function (encoder, value) {
    return this.j2r(encoder, value instanceof SetAdSizeRateRequest ? value : THROW_CCE());
  };
  protoOf($serializer_66).gj = function (decoder) {
    var tmp0_desc = this.i2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return SetAdSizeRateRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_66).ej = function () {
    return this.i2r_1;
  };
  protoOf($serializer_66).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_66;
  function $serializer_getInstance_66() {
    if ($serializer_instance_66 == null)
      new $serializer_66();
    return $serializer_instance_66;
  }
  function SetAdSizeRateRequest_init_$Init$(seen0, country, size, baseCostPerImpressionCents, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_66().i2r_1);
    }
    $this.k2r_1 = country;
    $this.l2r_1 = size;
    $this.m2r_1 = baseCostPerImpressionCents;
    return $this;
  }
  function SetAdSizeRateRequest_init_$Create$(seen0, country, size, baseCostPerImpressionCents, serializationConstructorMarker) {
    return SetAdSizeRateRequest_init_$Init$(seen0, country, size, baseCostPerImpressionCents, serializationConstructorMarker, objectCreate(protoOf(SetAdSizeRateRequest)));
  }
  function SetAdSizeRateRequest(country, size, baseCostPerImpressionCents) {
    this.k2r_1 = country;
    this.l2r_1 = size;
    this.m2r_1 = baseCostPerImpressionCents;
  }
  protoOf(SetAdSizeRateRequest).toString = function () {
    return 'SetAdSizeRateRequest(country=' + this.k2r_1 + ', size=' + this.l2r_1 + ', baseCostPerImpressionCents=' + this.m2r_1.toString() + ')';
  };
  protoOf(SetAdSizeRateRequest).hashCode = function () {
    var result = getStringHashCode(this.k2r_1);
    result = imul(result, 31) + getStringHashCode(this.l2r_1) | 0;
    result = imul(result, 31) + this.m2r_1.hashCode() | 0;
    return result;
  };
  protoOf(SetAdSizeRateRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetAdSizeRateRequest))
      return false;
    if (!(this.k2r_1 === other.k2r_1))
      return false;
    if (!(this.l2r_1 === other.l2r_1))
      return false;
    if (!equalsLong(this.m2r_1, other.m2r_1))
      return false;
    return true;
  };
  function Companion_67() {
  }
  var Companion_instance_68;
  function Companion_getInstance_67() {
    return Companion_instance_68;
  }
  function $serializer_67() {
    $serializer_instance_67 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.SetAdTierSurchargeRequest', this, 3);
    tmp0_serialDesc.tt('country', false);
    tmp0_serialDesc.tt('tierKey', false);
    tmp0_serialDesc.tt('surchargeCents', false);
    this.n2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_67).o2r = function (encoder, value) {
    var tmp0_desc = this.n2r_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.p2r_1);
    tmp1_output.un(tmp0_desc, 1, value.q2r_1);
    tmp1_output.qn(tmp0_desc, 2, value.r2r_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_67).fj = function (encoder, value) {
    return this.o2r(encoder, value instanceof SetAdTierSurchargeRequest ? value : THROW_CCE());
  };
  protoOf($serializer_67).gj = function (decoder) {
    var tmp0_desc = this.n2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return SetAdTierSurchargeRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_67).ej = function () {
    return this.n2r_1;
  };
  protoOf($serializer_67).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_67;
  function $serializer_getInstance_67() {
    if ($serializer_instance_67 == null)
      new $serializer_67();
    return $serializer_instance_67;
  }
  function SetAdTierSurchargeRequest_init_$Init$(seen0, country, tierKey, surchargeCents, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_67().n2r_1);
    }
    $this.p2r_1 = country;
    $this.q2r_1 = tierKey;
    $this.r2r_1 = surchargeCents;
    return $this;
  }
  function SetAdTierSurchargeRequest_init_$Create$(seen0, country, tierKey, surchargeCents, serializationConstructorMarker) {
    return SetAdTierSurchargeRequest_init_$Init$(seen0, country, tierKey, surchargeCents, serializationConstructorMarker, objectCreate(protoOf(SetAdTierSurchargeRequest)));
  }
  function SetAdTierSurchargeRequest(country, tierKey, surchargeCents) {
    this.p2r_1 = country;
    this.q2r_1 = tierKey;
    this.r2r_1 = surchargeCents;
  }
  protoOf(SetAdTierSurchargeRequest).toString = function () {
    return 'SetAdTierSurchargeRequest(country=' + this.p2r_1 + ', tierKey=' + this.q2r_1 + ', surchargeCents=' + this.r2r_1.toString() + ')';
  };
  protoOf(SetAdTierSurchargeRequest).hashCode = function () {
    var result = getStringHashCode(this.p2r_1);
    result = imul(result, 31) + getStringHashCode(this.q2r_1) | 0;
    result = imul(result, 31) + this.r2r_1.hashCode() | 0;
    return result;
  };
  protoOf(SetAdTierSurchargeRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetAdTierSurchargeRequest))
      return false;
    if (!(this.p2r_1 === other.p2r_1))
      return false;
    if (!(this.q2r_1 === other.q2r_1))
      return false;
    if (!equalsLong(this.r2r_1, other.r2r_1))
      return false;
    return true;
  };
  function RegisterCompanyRequest$Companion$$childSerializers$_anonymous__oepj6d() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.company.CompanyType', values_4());
  }
  function Companion_68() {
    Companion_instance_69 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s2r_1 = [lazy(tmp_0, RegisterCompanyRequest$Companion$$childSerializers$_anonymous__oepj6d), null, null, null, null, null, null, null, null, null, null];
  }
  var Companion_instance_69;
  function Companion_getInstance_68() {
    if (Companion_instance_69 == null)
      new Companion_68();
    return Companion_instance_69;
  }
  function $serializer_68() {
    $serializer_instance_68 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.RegisterCompanyRequest', this, 11);
    tmp0_serialDesc.tt('type', false);
    tmp0_serialDesc.tt('name', false);
    tmp0_serialDesc.tt('fiscalId', false);
    tmp0_serialDesc.tt('companyEmail', false);
    tmp0_serialDesc.tt('phone', false);
    tmp0_serialDesc.tt('address', false);
    tmp0_serialDesc.tt('website', true);
    tmp0_serialDesc.tt('country', false);
    tmp0_serialDesc.tt('adminEmail', false);
    tmp0_serialDesc.tt('adminName', false);
    tmp0_serialDesc.tt('adminPassword', false);
    this.t2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_68).u2r = function (encoder, value) {
    var tmp0_desc = this.t2r_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_68().s2r_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.v2r_1);
    tmp1_output.un(tmp0_desc, 1, value.w2r_1);
    tmp1_output.un(tmp0_desc, 2, value.x2r_1);
    tmp1_output.un(tmp0_desc, 3, value.y2r_1);
    tmp1_output.un(tmp0_desc, 4, value.z2r_1);
    tmp1_output.un(tmp0_desc, 5, value.a2s_1);
    if (tmp1_output.co(tmp0_desc, 6) ? true : !(value.b2s_1 == null)) {
      tmp1_output.yn(tmp0_desc, 6, StringSerializer_getInstance(), value.b2s_1);
    }
    tmp1_output.un(tmp0_desc, 7, value.c2s_1);
    tmp1_output.un(tmp0_desc, 8, value.d2s_1);
    tmp1_output.un(tmp0_desc, 9, value.e2s_1);
    tmp1_output.yn(tmp0_desc, 10, StringSerializer_getInstance(), value.f2s_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_68).fj = function (encoder, value) {
    return this.u2r(encoder, value instanceof RegisterCompanyRequest ? value : THROW_CCE());
  };
  protoOf($serializer_68).gj = function (decoder) {
    var tmp0_desc = this.t2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.fm(tmp0_desc);
    var tmp16_cached = Companion_getInstance_68().s2r_1;
    if (tmp15_input.vm()) {
      tmp4_local0 = tmp15_input.rm(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.pm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.pm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.pm(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.tm(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.pm(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.pm(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.pm(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.tm(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.rm(tmp0_desc, 0, tmp16_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.pm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.pm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.pm(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.tm(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.pm(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.pm(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.pm(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.tm(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.gm(tmp0_desc);
    return RegisterCompanyRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_68).ej = function () {
    return this.t2r_1;
  };
  protoOf($serializer_68).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_68().s2r_1[0].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_68;
  function $serializer_getInstance_68() {
    if ($serializer_instance_68 == null)
      new $serializer_68();
    return $serializer_instance_68;
  }
  function RegisterCompanyRequest_init_$Init$(seen0, type, name, fiscalId, companyEmail, phone, address, website, country, adminEmail, adminName, adminPassword, serializationConstructorMarker, $this) {
    if (!(1983 === (1983 & seen0))) {
      throwMissingFieldException(seen0, 1983, $serializer_getInstance_68().t2r_1);
    }
    $this.v2r_1 = type;
    $this.w2r_1 = name;
    $this.x2r_1 = fiscalId;
    $this.y2r_1 = companyEmail;
    $this.z2r_1 = phone;
    $this.a2s_1 = address;
    if (0 === (seen0 & 64))
      $this.b2s_1 = null;
    else
      $this.b2s_1 = website;
    $this.c2s_1 = country;
    $this.d2s_1 = adminEmail;
    $this.e2s_1 = adminName;
    $this.f2s_1 = adminPassword;
    return $this;
  }
  function RegisterCompanyRequest_init_$Create$(seen0, type, name, fiscalId, companyEmail, phone, address, website, country, adminEmail, adminName, adminPassword, serializationConstructorMarker) {
    return RegisterCompanyRequest_init_$Init$(seen0, type, name, fiscalId, companyEmail, phone, address, website, country, adminEmail, adminName, adminPassword, serializationConstructorMarker, objectCreate(protoOf(RegisterCompanyRequest)));
  }
  function RegisterCompanyRequest(type, name, fiscalId, companyEmail, phone, address, website, country, adminEmail, adminName, adminPassword) {
    Companion_getInstance_68();
    website = website === VOID ? null : website;
    this.v2r_1 = type;
    this.w2r_1 = name;
    this.x2r_1 = fiscalId;
    this.y2r_1 = companyEmail;
    this.z2r_1 = phone;
    this.a2s_1 = address;
    this.b2s_1 = website;
    this.c2s_1 = country;
    this.d2s_1 = adminEmail;
    this.e2s_1 = adminName;
    this.f2s_1 = adminPassword;
  }
  protoOf(RegisterCompanyRequest).toString = function () {
    return 'RegisterCompanyRequest(type=' + this.v2r_1.toString() + ', name=' + this.w2r_1 + ', fiscalId=' + this.x2r_1 + ', companyEmail=' + this.y2r_1 + ', phone=' + this.z2r_1 + ', address=' + this.a2s_1 + ', website=' + this.b2s_1 + ', country=' + this.c2s_1 + ', adminEmail=' + this.d2s_1 + ', adminName=' + this.e2s_1 + ', adminPassword=' + this.f2s_1 + ')';
  };
  protoOf(RegisterCompanyRequest).hashCode = function () {
    var result = this.v2r_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.w2r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x2r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y2r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z2r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a2s_1) | 0;
    result = imul(result, 31) + (this.b2s_1 == null ? 0 : getStringHashCode(this.b2s_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.c2s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d2s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e2s_1) | 0;
    result = imul(result, 31) + (this.f2s_1 == null ? 0 : getStringHashCode(this.f2s_1)) | 0;
    return result;
  };
  protoOf(RegisterCompanyRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegisterCompanyRequest))
      return false;
    if (!this.v2r_1.equals(other.v2r_1))
      return false;
    if (!(this.w2r_1 === other.w2r_1))
      return false;
    if (!(this.x2r_1 === other.x2r_1))
      return false;
    if (!(this.y2r_1 === other.y2r_1))
      return false;
    if (!(this.z2r_1 === other.z2r_1))
      return false;
    if (!(this.a2s_1 === other.a2s_1))
      return false;
    if (!(this.b2s_1 == other.b2s_1))
      return false;
    if (!(this.c2s_1 === other.c2s_1))
      return false;
    if (!(this.d2s_1 === other.d2s_1))
      return false;
    if (!(this.e2s_1 === other.e2s_1))
      return false;
    if (!(this.f2s_1 == other.f2s_1))
      return false;
    return true;
  };
  function Companion_69() {
  }
  var Companion_instance_70;
  function Companion_getInstance_69() {
    return Companion_instance_70;
  }
  function $serializer_69() {
    $serializer_instance_69 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.RegisterCompanyResponse', this, 5);
    tmp0_serialDesc.tt('companyId', false);
    tmp0_serialDesc.tt('displayId', false);
    tmp0_serialDesc.tt('accessToken', false);
    tmp0_serialDesc.tt('refreshToken', false);
    tmp0_serialDesc.tt('expiresInSeconds', false);
    this.g2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_69).h2s = function (encoder, value) {
    var tmp0_desc = this.g2s_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.i2s_1);
    tmp1_output.pn(tmp0_desc, 1, value.j2s_1);
    tmp1_output.un(tmp0_desc, 2, value.k2s_1);
    tmp1_output.un(tmp0_desc, 3, value.l2s_1);
    tmp1_output.qn(tmp0_desc, 4, value.m2s_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_69).fj = function (encoder, value) {
    return this.h2s(encoder, value instanceof RegisterCompanyResponse ? value : THROW_CCE());
  };
  protoOf($serializer_69).gj = function (decoder) {
    var tmp0_desc = this.g2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_input = decoder.fm(tmp0_desc);
    if (tmp9_input.vm()) {
      tmp4_local0 = tmp9_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.km(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.pm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.lm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.km(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.pm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.lm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.gm(tmp0_desc);
    return RegisterCompanyResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_69).ej = function () {
    return this.g2s_1;
  };
  protoOf($serializer_69).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_69;
  function $serializer_getInstance_69() {
    if ($serializer_instance_69 == null)
      new $serializer_69();
    return $serializer_instance_69;
  }
  function RegisterCompanyResponse_init_$Init$(seen0, companyId, displayId, accessToken, refreshToken, expiresInSeconds, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_69().g2s_1);
    }
    $this.i2s_1 = companyId;
    $this.j2s_1 = displayId;
    $this.k2s_1 = accessToken;
    $this.l2s_1 = refreshToken;
    $this.m2s_1 = expiresInSeconds;
    return $this;
  }
  function RegisterCompanyResponse_init_$Create$(seen0, companyId, displayId, accessToken, refreshToken, expiresInSeconds, serializationConstructorMarker) {
    return RegisterCompanyResponse_init_$Init$(seen0, companyId, displayId, accessToken, refreshToken, expiresInSeconds, serializationConstructorMarker, objectCreate(protoOf(RegisterCompanyResponse)));
  }
  function RegisterCompanyResponse(companyId, displayId, accessToken, refreshToken, expiresInSeconds) {
    this.i2s_1 = companyId;
    this.j2s_1 = displayId;
    this.k2s_1 = accessToken;
    this.l2s_1 = refreshToken;
    this.m2s_1 = expiresInSeconds;
  }
  protoOf(RegisterCompanyResponse).toString = function () {
    return 'RegisterCompanyResponse(companyId=' + this.i2s_1 + ', displayId=' + this.j2s_1 + ', accessToken=' + this.k2s_1 + ', refreshToken=' + this.l2s_1 + ', expiresInSeconds=' + this.m2s_1.toString() + ')';
  };
  protoOf(RegisterCompanyResponse).hashCode = function () {
    var result = getStringHashCode(this.i2s_1);
    result = imul(result, 31) + this.j2s_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.k2s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l2s_1) | 0;
    result = imul(result, 31) + this.m2s_1.hashCode() | 0;
    return result;
  };
  protoOf(RegisterCompanyResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegisterCompanyResponse))
      return false;
    if (!(this.i2s_1 === other.i2s_1))
      return false;
    if (!(this.j2s_1 === other.j2s_1))
      return false;
    if (!(this.k2s_1 === other.k2s_1))
      return false;
    if (!(this.l2s_1 === other.l2s_1))
      return false;
    if (!equalsLong(this.m2s_1, other.m2s_1))
      return false;
    return true;
  };
  function Companion_70() {
  }
  var Companion_instance_71;
  function Companion_getInstance_70() {
    return Companion_instance_71;
  }
  function $serializer_70() {
    $serializer_instance_70 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.RegisterPractitionerRequest', this, 3);
    tmp0_serialDesc.tt('email', false);
    tmp0_serialDesc.tt('password', false);
    tmp0_serialDesc.tt('displayName', false);
    this.n2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_70).o2s = function (encoder, value) {
    var tmp0_desc = this.n2s_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.p2s_1);
    tmp1_output.yn(tmp0_desc, 1, StringSerializer_getInstance(), value.q2s_1);
    tmp1_output.un(tmp0_desc, 2, value.r2s_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_70).fj = function (encoder, value) {
    return this.o2s(encoder, value instanceof RegisterPractitionerRequest ? value : THROW_CCE());
  };
  protoOf($serializer_70).gj = function (decoder) {
    var tmp0_desc = this.n2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.tm(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return RegisterPractitionerRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_70).ej = function () {
    return this.n2s_1;
  };
  protoOf($serializer_70).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
  };
  var $serializer_instance_70;
  function $serializer_getInstance_70() {
    if ($serializer_instance_70 == null)
      new $serializer_70();
    return $serializer_instance_70;
  }
  function RegisterPractitionerRequest_init_$Init$(seen0, email, password, displayName, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_70().n2s_1);
    }
    $this.p2s_1 = email;
    $this.q2s_1 = password;
    $this.r2s_1 = displayName;
    return $this;
  }
  function RegisterPractitionerRequest_init_$Create$(seen0, email, password, displayName, serializationConstructorMarker) {
    return RegisterPractitionerRequest_init_$Init$(seen0, email, password, displayName, serializationConstructorMarker, objectCreate(protoOf(RegisterPractitionerRequest)));
  }
  function RegisterPractitionerRequest(email, password, displayName) {
    this.p2s_1 = email;
    this.q2s_1 = password;
    this.r2s_1 = displayName;
  }
  protoOf(RegisterPractitionerRequest).toString = function () {
    return 'RegisterPractitionerRequest(email=' + this.p2s_1 + ', password=' + this.q2s_1 + ', displayName=' + this.r2s_1 + ')';
  };
  protoOf(RegisterPractitionerRequest).hashCode = function () {
    var result = getStringHashCode(this.p2s_1);
    result = imul(result, 31) + (this.q2s_1 == null ? 0 : getStringHashCode(this.q2s_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.r2s_1) | 0;
    return result;
  };
  protoOf(RegisterPractitionerRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegisterPractitionerRequest))
      return false;
    if (!(this.p2s_1 === other.p2s_1))
      return false;
    if (!(this.q2s_1 == other.q2s_1))
      return false;
    if (!(this.r2s_1 === other.r2s_1))
      return false;
    return true;
  };
  function Companion_71() {
  }
  var Companion_instance_72;
  function Companion_getInstance_71() {
    return Companion_instance_72;
  }
  function $serializer_71() {
    $serializer_instance_71 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.RegisterPractitionerResponse', this, 3);
    tmp0_serialDesc.tt('accessToken', false);
    tmp0_serialDesc.tt('refreshToken', false);
    tmp0_serialDesc.tt('expiresInSeconds', false);
    this.s2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_71).t2s = function (encoder, value) {
    var tmp0_desc = this.s2s_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.u2s_1);
    tmp1_output.un(tmp0_desc, 1, value.v2s_1);
    tmp1_output.qn(tmp0_desc, 2, value.w2s_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_71).fj = function (encoder, value) {
    return this.t2s(encoder, value instanceof RegisterPractitionerResponse ? value : THROW_CCE());
  };
  protoOf($serializer_71).gj = function (decoder) {
    var tmp0_desc = this.s2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.lm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return RegisterPractitionerResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_71).ej = function () {
    return this.s2s_1;
  };
  protoOf($serializer_71).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_71;
  function $serializer_getInstance_71() {
    if ($serializer_instance_71 == null)
      new $serializer_71();
    return $serializer_instance_71;
  }
  function RegisterPractitionerResponse_init_$Init$(seen0, accessToken, refreshToken, expiresInSeconds, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_71().s2s_1);
    }
    $this.u2s_1 = accessToken;
    $this.v2s_1 = refreshToken;
    $this.w2s_1 = expiresInSeconds;
    return $this;
  }
  function RegisterPractitionerResponse_init_$Create$(seen0, accessToken, refreshToken, expiresInSeconds, serializationConstructorMarker) {
    return RegisterPractitionerResponse_init_$Init$(seen0, accessToken, refreshToken, expiresInSeconds, serializationConstructorMarker, objectCreate(protoOf(RegisterPractitionerResponse)));
  }
  function RegisterPractitionerResponse(accessToken, refreshToken, expiresInSeconds) {
    this.u2s_1 = accessToken;
    this.v2s_1 = refreshToken;
    this.w2s_1 = expiresInSeconds;
  }
  protoOf(RegisterPractitionerResponse).toString = function () {
    return 'RegisterPractitionerResponse(accessToken=' + this.u2s_1 + ', refreshToken=' + this.v2s_1 + ', expiresInSeconds=' + this.w2s_1.toString() + ')';
  };
  protoOf(RegisterPractitionerResponse).hashCode = function () {
    var result = getStringHashCode(this.u2s_1);
    result = imul(result, 31) + getStringHashCode(this.v2s_1) | 0;
    result = imul(result, 31) + this.w2s_1.hashCode() | 0;
    return result;
  };
  protoOf(RegisterPractitionerResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegisterPractitionerResponse))
      return false;
    if (!(this.u2s_1 === other.u2s_1))
      return false;
    if (!(this.v2s_1 === other.v2s_1))
      return false;
    if (!equalsLong(this.w2s_1, other.w2s_1))
      return false;
    return true;
  };
  function Companion_72() {
  }
  var Companion_instance_73;
  function Companion_getInstance_72() {
    return Companion_instance_73;
  }
  function $serializer_72() {
    $serializer_instance_72 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.AcceptInvitationRequest', this, 3);
    tmp0_serialDesc.tt('code', false);
    tmp0_serialDesc.tt('displayName', false);
    tmp0_serialDesc.tt('password', false);
    this.x2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_72).y2s = function (encoder, value) {
    var tmp0_desc = this.x2s_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.z2s_1);
    tmp1_output.un(tmp0_desc, 1, value.a2t_1);
    tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.b2t_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_72).fj = function (encoder, value) {
    return this.y2s(encoder, value instanceof AcceptInvitationRequest ? value : THROW_CCE());
  };
  protoOf($serializer_72).gj = function (decoder) {
    var tmp0_desc = this.x2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return AcceptInvitationRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_72).ej = function () {
    return this.x2s_1;
  };
  protoOf($serializer_72).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_72;
  function $serializer_getInstance_72() {
    if ($serializer_instance_72 == null)
      new $serializer_72();
    return $serializer_instance_72;
  }
  function AcceptInvitationRequest_init_$Init$(seen0, code, displayName, password, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_72().x2s_1);
    }
    $this.z2s_1 = code;
    $this.a2t_1 = displayName;
    $this.b2t_1 = password;
    return $this;
  }
  function AcceptInvitationRequest_init_$Create$(seen0, code, displayName, password, serializationConstructorMarker) {
    return AcceptInvitationRequest_init_$Init$(seen0, code, displayName, password, serializationConstructorMarker, objectCreate(protoOf(AcceptInvitationRequest)));
  }
  function AcceptInvitationRequest(code, displayName, password) {
    this.z2s_1 = code;
    this.a2t_1 = displayName;
    this.b2t_1 = password;
  }
  protoOf(AcceptInvitationRequest).toString = function () {
    return 'AcceptInvitationRequest(code=' + this.z2s_1 + ', displayName=' + this.a2t_1 + ', password=' + this.b2t_1 + ')';
  };
  protoOf(AcceptInvitationRequest).hashCode = function () {
    var result = getStringHashCode(this.z2s_1);
    result = imul(result, 31) + getStringHashCode(this.a2t_1) | 0;
    result = imul(result, 31) + (this.b2t_1 == null ? 0 : getStringHashCode(this.b2t_1)) | 0;
    return result;
  };
  protoOf(AcceptInvitationRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AcceptInvitationRequest))
      return false;
    if (!(this.z2s_1 === other.z2s_1))
      return false;
    if (!(this.a2t_1 === other.a2t_1))
      return false;
    if (!(this.b2t_1 == other.b2t_1))
      return false;
    return true;
  };
  function MyProfileResponse$Companion$$childSerializers$_anonymous__kvg78s() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.company.CompanyMemberRole', values_5());
  }
  function Companion_73() {
    Companion_instance_74 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c2t_1 = [null, null, null, null, null, null, null, lazy(tmp_0, MyProfileResponse$Companion$$childSerializers$_anonymous__kvg78s), null];
  }
  var Companion_instance_74;
  function Companion_getInstance_73() {
    if (Companion_instance_74 == null)
      new Companion_73();
    return Companion_instance_74;
  }
  function $serializer_73() {
    $serializer_instance_73 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.MyProfileResponse', this, 9);
    tmp0_serialDesc.tt('kind', false);
    tmp0_serialDesc.tt('displayName', false);
    tmp0_serialDesc.tt('email', false);
    tmp0_serialDesc.tt('displayId', false);
    tmp0_serialDesc.tt('avatarUrl', true);
    tmp0_serialDesc.tt('companyId', true);
    tmp0_serialDesc.tt('companyName', true);
    tmp0_serialDesc.tt('role', true);
    tmp0_serialDesc.tt('nickname', true);
    this.d2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_73).e2t = function (encoder, value) {
    var tmp0_desc = this.d2t_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_73().c2t_1;
    tmp1_output.un(tmp0_desc, 0, value.x25_1);
    tmp1_output.un(tmp0_desc, 1, value.y25_1);
    tmp1_output.un(tmp0_desc, 2, value.z25_1);
    tmp1_output.pn(tmp0_desc, 3, value.a26_1);
    if (tmp1_output.co(tmp0_desc, 4) ? true : !(value.b26_1 == null)) {
      tmp1_output.yn(tmp0_desc, 4, StringSerializer_getInstance(), value.b26_1);
    }
    if (tmp1_output.co(tmp0_desc, 5) ? true : !(value.c26_1 == null)) {
      tmp1_output.yn(tmp0_desc, 5, StringSerializer_getInstance(), value.c26_1);
    }
    if (tmp1_output.co(tmp0_desc, 6) ? true : !(value.d26_1 == null)) {
      tmp1_output.yn(tmp0_desc, 6, StringSerializer_getInstance(), value.d26_1);
    }
    if (tmp1_output.co(tmp0_desc, 7) ? true : !(value.e26_1 == null)) {
      tmp1_output.yn(tmp0_desc, 7, tmp2_cached[7].f2(), value.e26_1);
    }
    if (tmp1_output.co(tmp0_desc, 8) ? true : !(value.f26_1 == null)) {
      tmp1_output.yn(tmp0_desc, 8, StringSerializer_getInstance(), value.f26_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_73).fj = function (encoder, value) {
    return this.e2t(encoder, value instanceof MyProfileResponse ? value : THROW_CCE());
  };
  protoOf($serializer_73).gj = function (decoder) {
    var tmp0_desc = this.d2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.fm(tmp0_desc);
    var tmp14_cached = Companion_getInstance_73().c2t_1;
    if (tmp13_input.vm()) {
      tmp4_local0 = tmp13_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.km(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.tm(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.tm(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.tm(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.tm(tmp0_desc, 7, tmp14_cached[7].f2(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.tm(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.km(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.tm(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.tm(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.tm(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.tm(tmp0_desc, 7, tmp14_cached[7].f2(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.tm(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.gm(tmp0_desc);
    return MyProfileResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_73).ej = function () {
    return this.d2t_1;
  };
  protoOf($serializer_73).iu = function () {
    var tmp0_cached = Companion_getInstance_73().c2t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[7].f2()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_73;
  function $serializer_getInstance_73() {
    if ($serializer_instance_73 == null)
      new $serializer_73();
    return $serializer_instance_73;
  }
  function MyProfileResponse_init_$Init$(seen0, kind, displayName, email, displayId, avatarUrl, companyId, companyName, role, nickname, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_73().d2t_1);
    }
    $this.x25_1 = kind;
    $this.y25_1 = displayName;
    $this.z25_1 = email;
    $this.a26_1 = displayId;
    if (0 === (seen0 & 16))
      $this.b26_1 = null;
    else
      $this.b26_1 = avatarUrl;
    if (0 === (seen0 & 32))
      $this.c26_1 = null;
    else
      $this.c26_1 = companyId;
    if (0 === (seen0 & 64))
      $this.d26_1 = null;
    else
      $this.d26_1 = companyName;
    if (0 === (seen0 & 128))
      $this.e26_1 = null;
    else
      $this.e26_1 = role;
    if (0 === (seen0 & 256))
      $this.f26_1 = null;
    else
      $this.f26_1 = nickname;
    return $this;
  }
  function MyProfileResponse_init_$Create$(seen0, kind, displayName, email, displayId, avatarUrl, companyId, companyName, role, nickname, serializationConstructorMarker) {
    return MyProfileResponse_init_$Init$(seen0, kind, displayName, email, displayId, avatarUrl, companyId, companyName, role, nickname, serializationConstructorMarker, objectCreate(protoOf(MyProfileResponse)));
  }
  function MyProfileResponse(kind, displayName, email, displayId, avatarUrl, companyId, companyName, role, nickname) {
    Companion_getInstance_73();
    avatarUrl = avatarUrl === VOID ? null : avatarUrl;
    companyId = companyId === VOID ? null : companyId;
    companyName = companyName === VOID ? null : companyName;
    role = role === VOID ? null : role;
    nickname = nickname === VOID ? null : nickname;
    this.x25_1 = kind;
    this.y25_1 = displayName;
    this.z25_1 = email;
    this.a26_1 = displayId;
    this.b26_1 = avatarUrl;
    this.c26_1 = companyId;
    this.d26_1 = companyName;
    this.e26_1 = role;
    this.f26_1 = nickname;
  }
  protoOf(MyProfileResponse).toString = function () {
    return 'MyProfileResponse(kind=' + this.x25_1 + ', displayName=' + this.y25_1 + ', email=' + this.z25_1 + ', displayId=' + this.a26_1 + ', avatarUrl=' + this.b26_1 + ', companyId=' + this.c26_1 + ', companyName=' + this.d26_1 + ', role=' + toString_0(this.e26_1) + ', nickname=' + this.f26_1 + ')';
  };
  protoOf(MyProfileResponse).hashCode = function () {
    var result = getStringHashCode(this.x25_1);
    result = imul(result, 31) + getStringHashCode(this.y25_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z25_1) | 0;
    result = imul(result, 31) + this.a26_1 | 0;
    result = imul(result, 31) + (this.b26_1 == null ? 0 : getStringHashCode(this.b26_1)) | 0;
    result = imul(result, 31) + (this.c26_1 == null ? 0 : getStringHashCode(this.c26_1)) | 0;
    result = imul(result, 31) + (this.d26_1 == null ? 0 : getStringHashCode(this.d26_1)) | 0;
    result = imul(result, 31) + (this.e26_1 == null ? 0 : this.e26_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f26_1 == null ? 0 : getStringHashCode(this.f26_1)) | 0;
    return result;
  };
  protoOf(MyProfileResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MyProfileResponse))
      return false;
    if (!(this.x25_1 === other.x25_1))
      return false;
    if (!(this.y25_1 === other.y25_1))
      return false;
    if (!(this.z25_1 === other.z25_1))
      return false;
    if (!(this.a26_1 === other.a26_1))
      return false;
    if (!(this.b26_1 == other.b26_1))
      return false;
    if (!(this.c26_1 == other.c26_1))
      return false;
    if (!(this.d26_1 == other.d26_1))
      return false;
    if (!equals(this.e26_1, other.e26_1))
      return false;
    if (!(this.f26_1 == other.f26_1))
      return false;
    return true;
  };
  function Companion_74() {
  }
  var Companion_instance_75;
  function Companion_getInstance_74() {
    return Companion_instance_75;
  }
  function $serializer_74() {
    $serializer_instance_74 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.UpdateMyNicknameRequest', this, 1);
    tmp0_serialDesc.tt('nickname', false);
    this.f2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_74).g2t = function (encoder, value) {
    var tmp0_desc = this.f2t_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.h2t_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_74).fj = function (encoder, value) {
    return this.g2t(encoder, value instanceof UpdateMyNicknameRequest ? value : THROW_CCE());
  };
  protoOf($serializer_74).gj = function (decoder) {
    var tmp0_desc = this.f2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return UpdateMyNicknameRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_74).ej = function () {
    return this.f2t_1;
  };
  protoOf($serializer_74).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_74;
  function $serializer_getInstance_74() {
    if ($serializer_instance_74 == null)
      new $serializer_74();
    return $serializer_instance_74;
  }
  function UpdateMyNicknameRequest_init_$Init$(seen0, nickname, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_74().f2t_1);
    }
    $this.h2t_1 = nickname;
    return $this;
  }
  function UpdateMyNicknameRequest_init_$Create$(seen0, nickname, serializationConstructorMarker) {
    return UpdateMyNicknameRequest_init_$Init$(seen0, nickname, serializationConstructorMarker, objectCreate(protoOf(UpdateMyNicknameRequest)));
  }
  function UpdateMyNicknameRequest(nickname) {
    this.h2t_1 = nickname;
  }
  protoOf(UpdateMyNicknameRequest).toString = function () {
    return 'UpdateMyNicknameRequest(nickname=' + this.h2t_1 + ')';
  };
  protoOf(UpdateMyNicknameRequest).hashCode = function () {
    return getStringHashCode(this.h2t_1);
  };
  protoOf(UpdateMyNicknameRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateMyNicknameRequest))
      return false;
    if (!(this.h2t_1 === other.h2t_1))
      return false;
    return true;
  };
  function Companion_75() {
  }
  var Companion_instance_76;
  function Companion_getInstance_75() {
    return Companion_instance_76;
  }
  function $serializer_75() {
    $serializer_instance_75 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.UpdateMyNicknameResponse', this, 1);
    tmp0_serialDesc.tt('nickname', false);
    this.i2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_75).j2t = function (encoder, value) {
    var tmp0_desc = this.i2t_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.k2t_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_75).fj = function (encoder, value) {
    return this.j2t(encoder, value instanceof UpdateMyNicknameResponse ? value : THROW_CCE());
  };
  protoOf($serializer_75).gj = function (decoder) {
    var tmp0_desc = this.i2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return UpdateMyNicknameResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_75).ej = function () {
    return this.i2t_1;
  };
  protoOf($serializer_75).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_75;
  function $serializer_getInstance_75() {
    if ($serializer_instance_75 == null)
      new $serializer_75();
    return $serializer_instance_75;
  }
  function UpdateMyNicknameResponse_init_$Init$(seen0, nickname, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_75().i2t_1);
    }
    $this.k2t_1 = nickname;
    return $this;
  }
  function UpdateMyNicknameResponse_init_$Create$(seen0, nickname, serializationConstructorMarker) {
    return UpdateMyNicknameResponse_init_$Init$(seen0, nickname, serializationConstructorMarker, objectCreate(protoOf(UpdateMyNicknameResponse)));
  }
  function UpdateMyNicknameResponse(nickname) {
    this.k2t_1 = nickname;
  }
  protoOf(UpdateMyNicknameResponse).toString = function () {
    return 'UpdateMyNicknameResponse(nickname=' + this.k2t_1 + ')';
  };
  protoOf(UpdateMyNicknameResponse).hashCode = function () {
    return getStringHashCode(this.k2t_1);
  };
  protoOf(UpdateMyNicknameResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateMyNicknameResponse))
      return false;
    if (!(this.k2t_1 === other.k2t_1))
      return false;
    return true;
  };
  function Companion_76() {
  }
  var Companion_instance_77;
  function Companion_getInstance_76() {
    return Companion_instance_77;
  }
  function $serializer_76() {
    $serializer_instance_76 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.UploadResponse', this, 1);
    tmp0_serialDesc.tt('url', false);
    this.l2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_76).m2t = function (encoder, value) {
    var tmp0_desc = this.l2t_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.n2t_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_76).fj = function (encoder, value) {
    return this.m2t(encoder, value instanceof UploadResponse ? value : THROW_CCE());
  };
  protoOf($serializer_76).gj = function (decoder) {
    var tmp0_desc = this.l2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return UploadResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_76).ej = function () {
    return this.l2t_1;
  };
  protoOf($serializer_76).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_76;
  function $serializer_getInstance_76() {
    if ($serializer_instance_76 == null)
      new $serializer_76();
    return $serializer_instance_76;
  }
  function UploadResponse_init_$Init$(seen0, url, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_76().l2t_1);
    }
    $this.n2t_1 = url;
    return $this;
  }
  function UploadResponse_init_$Create$(seen0, url, serializationConstructorMarker) {
    return UploadResponse_init_$Init$(seen0, url, serializationConstructorMarker, objectCreate(protoOf(UploadResponse)));
  }
  function UploadResponse(url) {
    this.n2t_1 = url;
  }
  protoOf(UploadResponse).toString = function () {
    return 'UploadResponse(url=' + this.n2t_1 + ')';
  };
  protoOf(UploadResponse).hashCode = function () {
    return getStringHashCode(this.n2t_1);
  };
  protoOf(UploadResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UploadResponse))
      return false;
    if (!(this.n2t_1 === other.n2t_1))
      return false;
    return true;
  };
  function CompanyResponse$Companion$$childSerializers$_anonymous__acn898() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.company.CompanyType', values_4());
  }
  function Companion_77() {
    Companion_instance_78 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o2t_1 = [null, null, lazy(tmp_0, CompanyResponse$Companion$$childSerializers$_anonymous__acn898), null, null, null, null, null, null, null, null, null, null, null, null];
  }
  var Companion_instance_78;
  function Companion_getInstance_77() {
    if (Companion_instance_78 == null)
      new Companion_77();
    return Companion_instance_78;
  }
  function $serializer_77() {
    $serializer_instance_77 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.CompanyResponse', this, 15);
    tmp0_serialDesc.tt('companyId', false);
    tmp0_serialDesc.tt('displayId', false);
    tmp0_serialDesc.tt('type', false);
    tmp0_serialDesc.tt('name', false);
    tmp0_serialDesc.tt('fiscalId', false);
    tmp0_serialDesc.tt('email', false);
    tmp0_serialDesc.tt('phone', false);
    tmp0_serialDesc.tt('address', false);
    tmp0_serialDesc.tt('website', true);
    tmp0_serialDesc.tt('logoUrl', true);
    tmp0_serialDesc.tt('latitude', true);
    tmp0_serialDesc.tt('longitude', true);
    tmp0_serialDesc.tt('locationLabel', true);
    tmp0_serialDesc.tt('country', true);
    tmp0_serialDesc.tt('active', true);
    this.p2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_77).q2t = function (encoder, value) {
    var tmp0_desc = this.p2t_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_77().o2t_1;
    tmp1_output.un(tmp0_desc, 0, value.r2t_1);
    tmp1_output.pn(tmp0_desc, 1, value.s2t_1);
    tmp1_output.wn(tmp0_desc, 2, tmp2_cached[2].f2(), value.t2t_1);
    tmp1_output.un(tmp0_desc, 3, value.u2t_1);
    tmp1_output.un(tmp0_desc, 4, value.v2t_1);
    tmp1_output.un(tmp0_desc, 5, value.w2t_1);
    tmp1_output.un(tmp0_desc, 6, value.x2t_1);
    tmp1_output.un(tmp0_desc, 7, value.y2t_1);
    if (tmp1_output.co(tmp0_desc, 8) ? true : !(value.z2t_1 == null)) {
      tmp1_output.yn(tmp0_desc, 8, StringSerializer_getInstance(), value.z2t_1);
    }
    if (tmp1_output.co(tmp0_desc, 9) ? true : !(value.a2u_1 == null)) {
      tmp1_output.yn(tmp0_desc, 9, StringSerializer_getInstance(), value.a2u_1);
    }
    if (tmp1_output.co(tmp0_desc, 10) ? true : !(value.b2u_1 == null)) {
      tmp1_output.yn(tmp0_desc, 10, DoubleSerializer_getInstance(), value.b2u_1);
    }
    if (tmp1_output.co(tmp0_desc, 11) ? true : !(value.c2u_1 == null)) {
      tmp1_output.yn(tmp0_desc, 11, DoubleSerializer_getInstance(), value.c2u_1);
    }
    if (tmp1_output.co(tmp0_desc, 12) ? true : !(value.d2u_1 == null)) {
      tmp1_output.yn(tmp0_desc, 12, StringSerializer_getInstance(), value.d2u_1);
    }
    if (tmp1_output.co(tmp0_desc, 13) ? true : !(value.e2u_1 == null)) {
      tmp1_output.yn(tmp0_desc, 13, StringSerializer_getInstance(), value.e2u_1);
    }
    if (tmp1_output.co(tmp0_desc, 14) ? true : !(value.f2u_1 === true)) {
      tmp1_output.mn(tmp0_desc, 14, value.f2u_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_77).fj = function (encoder, value) {
    return this.q2t(encoder, value instanceof CompanyResponse ? value : THROW_CCE());
  };
  protoOf($serializer_77).gj = function (decoder) {
    var tmp0_desc = this.p2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = false;
    var tmp19_input = decoder.fm(tmp0_desc);
    var tmp20_cached = Companion_getInstance_77().o2t_1;
    if (tmp19_input.vm()) {
      tmp4_local0 = tmp19_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp19_input.km(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp19_input.rm(tmp0_desc, 2, tmp20_cached[2].f2(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp19_input.pm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp19_input.pm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp19_input.pm(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp19_input.pm(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp19_input.pm(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp19_input.tm(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp19_input.tm(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp19_input.tm(tmp0_desc, 10, DoubleSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp19_input.tm(tmp0_desc, 11, DoubleSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp19_input.tm(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp19_input.tm(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp19_input.hm(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp19_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp19_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp19_input.km(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp19_input.rm(tmp0_desc, 2, tmp20_cached[2].f2(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp19_input.pm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp19_input.pm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp19_input.pm(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp19_input.pm(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp19_input.pm(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp19_input.tm(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp19_input.tm(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp19_input.tm(tmp0_desc, 10, DoubleSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp19_input.tm(tmp0_desc, 11, DoubleSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp19_input.tm(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp19_input.tm(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp19_input.hm(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp19_input.gm(tmp0_desc);
    return CompanyResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
  };
  protoOf($serializer_77).ej = function () {
    return this.p2t_1;
  };
  protoOf($serializer_77).iu = function () {
    var tmp0_cached = Companion_getInstance_77().o2t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[2].f2(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_77;
  function $serializer_getInstance_77() {
    if ($serializer_instance_77 == null)
      new $serializer_77();
    return $serializer_instance_77;
  }
  function CompanyResponse_init_$Init$(seen0, companyId, displayId, type, name, fiscalId, email, phone, address, website, logoUrl, latitude, longitude, locationLabel, country, active, serializationConstructorMarker, $this) {
    if (!(255 === (255 & seen0))) {
      throwMissingFieldException(seen0, 255, $serializer_getInstance_77().p2t_1);
    }
    $this.r2t_1 = companyId;
    $this.s2t_1 = displayId;
    $this.t2t_1 = type;
    $this.u2t_1 = name;
    $this.v2t_1 = fiscalId;
    $this.w2t_1 = email;
    $this.x2t_1 = phone;
    $this.y2t_1 = address;
    if (0 === (seen0 & 256))
      $this.z2t_1 = null;
    else
      $this.z2t_1 = website;
    if (0 === (seen0 & 512))
      $this.a2u_1 = null;
    else
      $this.a2u_1 = logoUrl;
    if (0 === (seen0 & 1024))
      $this.b2u_1 = null;
    else
      $this.b2u_1 = latitude;
    if (0 === (seen0 & 2048))
      $this.c2u_1 = null;
    else
      $this.c2u_1 = longitude;
    if (0 === (seen0 & 4096))
      $this.d2u_1 = null;
    else
      $this.d2u_1 = locationLabel;
    if (0 === (seen0 & 8192))
      $this.e2u_1 = null;
    else
      $this.e2u_1 = country;
    if (0 === (seen0 & 16384))
      $this.f2u_1 = true;
    else
      $this.f2u_1 = active;
    return $this;
  }
  function CompanyResponse_init_$Create$(seen0, companyId, displayId, type, name, fiscalId, email, phone, address, website, logoUrl, latitude, longitude, locationLabel, country, active, serializationConstructorMarker) {
    return CompanyResponse_init_$Init$(seen0, companyId, displayId, type, name, fiscalId, email, phone, address, website, logoUrl, latitude, longitude, locationLabel, country, active, serializationConstructorMarker, objectCreate(protoOf(CompanyResponse)));
  }
  function CompanyResponse(companyId, displayId, type, name, fiscalId, email, phone, address, website, logoUrl, latitude, longitude, locationLabel, country, active) {
    Companion_getInstance_77();
    website = website === VOID ? null : website;
    logoUrl = logoUrl === VOID ? null : logoUrl;
    latitude = latitude === VOID ? null : latitude;
    longitude = longitude === VOID ? null : longitude;
    locationLabel = locationLabel === VOID ? null : locationLabel;
    country = country === VOID ? null : country;
    active = active === VOID ? true : active;
    this.r2t_1 = companyId;
    this.s2t_1 = displayId;
    this.t2t_1 = type;
    this.u2t_1 = name;
    this.v2t_1 = fiscalId;
    this.w2t_1 = email;
    this.x2t_1 = phone;
    this.y2t_1 = address;
    this.z2t_1 = website;
    this.a2u_1 = logoUrl;
    this.b2u_1 = latitude;
    this.c2u_1 = longitude;
    this.d2u_1 = locationLabel;
    this.e2u_1 = country;
    this.f2u_1 = active;
  }
  protoOf(CompanyResponse).toString = function () {
    return 'CompanyResponse(companyId=' + this.r2t_1 + ', displayId=' + this.s2t_1 + ', type=' + this.t2t_1.toString() + ', name=' + this.u2t_1 + ', fiscalId=' + this.v2t_1 + ', email=' + this.w2t_1 + ', phone=' + this.x2t_1 + ', address=' + this.y2t_1 + ', website=' + this.z2t_1 + ', logoUrl=' + this.a2u_1 + ', latitude=' + this.b2u_1 + ', longitude=' + this.c2u_1 + ', locationLabel=' + this.d2u_1 + ', country=' + this.e2u_1 + ', active=' + this.f2u_1 + ')';
  };
  protoOf(CompanyResponse).hashCode = function () {
    var result = getStringHashCode(this.r2t_1);
    result = imul(result, 31) + this.s2t_1 | 0;
    result = imul(result, 31) + this.t2t_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.u2t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v2t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w2t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x2t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y2t_1) | 0;
    result = imul(result, 31) + (this.z2t_1 == null ? 0 : getStringHashCode(this.z2t_1)) | 0;
    result = imul(result, 31) + (this.a2u_1 == null ? 0 : getStringHashCode(this.a2u_1)) | 0;
    result = imul(result, 31) + (this.b2u_1 == null ? 0 : getNumberHashCode(this.b2u_1)) | 0;
    result = imul(result, 31) + (this.c2u_1 == null ? 0 : getNumberHashCode(this.c2u_1)) | 0;
    result = imul(result, 31) + (this.d2u_1 == null ? 0 : getStringHashCode(this.d2u_1)) | 0;
    result = imul(result, 31) + (this.e2u_1 == null ? 0 : getStringHashCode(this.e2u_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f2u_1) | 0;
    return result;
  };
  protoOf(CompanyResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompanyResponse))
      return false;
    if (!(this.r2t_1 === other.r2t_1))
      return false;
    if (!(this.s2t_1 === other.s2t_1))
      return false;
    if (!this.t2t_1.equals(other.t2t_1))
      return false;
    if (!(this.u2t_1 === other.u2t_1))
      return false;
    if (!(this.v2t_1 === other.v2t_1))
      return false;
    if (!(this.w2t_1 === other.w2t_1))
      return false;
    if (!(this.x2t_1 === other.x2t_1))
      return false;
    if (!(this.y2t_1 === other.y2t_1))
      return false;
    if (!(this.z2t_1 == other.z2t_1))
      return false;
    if (!(this.a2u_1 == other.a2u_1))
      return false;
    if (!equals(this.b2u_1, other.b2u_1))
      return false;
    if (!equals(this.c2u_1, other.c2u_1))
      return false;
    if (!(this.d2u_1 == other.d2u_1))
      return false;
    if (!(this.e2u_1 == other.e2u_1))
      return false;
    if (!(this.f2u_1 === other.f2u_1))
      return false;
    return true;
  };
  function Companion_78() {
  }
  var Companion_instance_79;
  function Companion_getInstance_78() {
    return Companion_instance_79;
  }
  function $serializer_78() {
    $serializer_instance_78 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.UpdateCompanyAdminRequest', this, 8);
    tmp0_serialDesc.tt('name', false);
    tmp0_serialDesc.tt('fiscalId', false);
    tmp0_serialDesc.tt('email', false);
    tmp0_serialDesc.tt('phone', false);
    tmp0_serialDesc.tt('address', false);
    tmp0_serialDesc.tt('website', true);
    tmp0_serialDesc.tt('country', true);
    tmp0_serialDesc.tt('active', false);
    this.g2u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_78).h2u = function (encoder, value) {
    var tmp0_desc = this.g2u_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.i2u_1);
    tmp1_output.un(tmp0_desc, 1, value.j2u_1);
    tmp1_output.un(tmp0_desc, 2, value.k2u_1);
    tmp1_output.un(tmp0_desc, 3, value.l2u_1);
    tmp1_output.un(tmp0_desc, 4, value.m2u_1);
    if (tmp1_output.co(tmp0_desc, 5) ? true : !(value.n2u_1 == null)) {
      tmp1_output.yn(tmp0_desc, 5, StringSerializer_getInstance(), value.n2u_1);
    }
    if (tmp1_output.co(tmp0_desc, 6) ? true : !(value.o2u_1 == null)) {
      tmp1_output.yn(tmp0_desc, 6, StringSerializer_getInstance(), value.o2u_1);
    }
    tmp1_output.mn(tmp0_desc, 7, value.p2u_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_78).fj = function (encoder, value) {
    return this.h2u(encoder, value instanceof UpdateCompanyAdminRequest ? value : THROW_CCE());
  };
  protoOf($serializer_78).gj = function (decoder) {
    var tmp0_desc = this.g2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_input = decoder.fm(tmp0_desc);
    if (tmp12_input.vm()) {
      tmp4_local0 = tmp12_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.pm(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.pm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.tm(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.tm(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.hm(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.pm(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.pm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.tm(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.tm(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.hm(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.gm(tmp0_desc);
    return UpdateCompanyAdminRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_78).ej = function () {
    return this.g2u_1;
  };
  protoOf($serializer_78).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_78;
  function $serializer_getInstance_78() {
    if ($serializer_instance_78 == null)
      new $serializer_78();
    return $serializer_instance_78;
  }
  function UpdateCompanyAdminRequest_init_$Init$(seen0, name, fiscalId, email, phone, address, website, country, active, serializationConstructorMarker, $this) {
    if (!(159 === (159 & seen0))) {
      throwMissingFieldException(seen0, 159, $serializer_getInstance_78().g2u_1);
    }
    $this.i2u_1 = name;
    $this.j2u_1 = fiscalId;
    $this.k2u_1 = email;
    $this.l2u_1 = phone;
    $this.m2u_1 = address;
    if (0 === (seen0 & 32))
      $this.n2u_1 = null;
    else
      $this.n2u_1 = website;
    if (0 === (seen0 & 64))
      $this.o2u_1 = null;
    else
      $this.o2u_1 = country;
    $this.p2u_1 = active;
    return $this;
  }
  function UpdateCompanyAdminRequest_init_$Create$(seen0, name, fiscalId, email, phone, address, website, country, active, serializationConstructorMarker) {
    return UpdateCompanyAdminRequest_init_$Init$(seen0, name, fiscalId, email, phone, address, website, country, active, serializationConstructorMarker, objectCreate(protoOf(UpdateCompanyAdminRequest)));
  }
  function UpdateCompanyAdminRequest(name, fiscalId, email, phone, address, website, country, active) {
    website = website === VOID ? null : website;
    country = country === VOID ? null : country;
    this.i2u_1 = name;
    this.j2u_1 = fiscalId;
    this.k2u_1 = email;
    this.l2u_1 = phone;
    this.m2u_1 = address;
    this.n2u_1 = website;
    this.o2u_1 = country;
    this.p2u_1 = active;
  }
  protoOf(UpdateCompanyAdminRequest).toString = function () {
    return 'UpdateCompanyAdminRequest(name=' + this.i2u_1 + ', fiscalId=' + this.j2u_1 + ', email=' + this.k2u_1 + ', phone=' + this.l2u_1 + ', address=' + this.m2u_1 + ', website=' + this.n2u_1 + ', country=' + this.o2u_1 + ', active=' + this.p2u_1 + ')';
  };
  protoOf(UpdateCompanyAdminRequest).hashCode = function () {
    var result = getStringHashCode(this.i2u_1);
    result = imul(result, 31) + getStringHashCode(this.j2u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k2u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l2u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m2u_1) | 0;
    result = imul(result, 31) + (this.n2u_1 == null ? 0 : getStringHashCode(this.n2u_1)) | 0;
    result = imul(result, 31) + (this.o2u_1 == null ? 0 : getStringHashCode(this.o2u_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p2u_1) | 0;
    return result;
  };
  protoOf(UpdateCompanyAdminRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateCompanyAdminRequest))
      return false;
    if (!(this.i2u_1 === other.i2u_1))
      return false;
    if (!(this.j2u_1 === other.j2u_1))
      return false;
    if (!(this.k2u_1 === other.k2u_1))
      return false;
    if (!(this.l2u_1 === other.l2u_1))
      return false;
    if (!(this.m2u_1 === other.m2u_1))
      return false;
    if (!(this.n2u_1 == other.n2u_1))
      return false;
    if (!(this.o2u_1 == other.o2u_1))
      return false;
    if (!(this.p2u_1 === other.p2u_1))
      return false;
    return true;
  };
  function Companion_79() {
  }
  var Companion_instance_80;
  function Companion_getInstance_79() {
    return Companion_instance_80;
  }
  function $serializer_79() {
    $serializer_instance_79 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.SetCompanyLocationRequest', this, 3);
    tmp0_serialDesc.tt('latitude', false);
    tmp0_serialDesc.tt('longitude', false);
    tmp0_serialDesc.tt('locationLabel', true);
    this.q2u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_79).r2u = function (encoder, value) {
    var tmp0_desc = this.q2u_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.sn(tmp0_desc, 0, value.s2u_1);
    tmp1_output.sn(tmp0_desc, 1, value.t2u_1);
    if (tmp1_output.co(tmp0_desc, 2) ? true : !(value.u2u_1 == null)) {
      tmp1_output.yn(tmp0_desc, 2, StringSerializer_getInstance(), value.u2u_1);
    }
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_79).fj = function (encoder, value) {
    return this.r2u(encoder, value instanceof SetCompanyLocationRequest ? value : THROW_CCE());
  };
  protoOf($serializer_79).gj = function (decoder) {
    var tmp0_desc = this.q2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.nm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.nm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.nm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.nm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.tm(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return SetCompanyLocationRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_79).ej = function () {
    return this.q2u_1;
  };
  protoOf($serializer_79).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_79;
  function $serializer_getInstance_79() {
    if ($serializer_instance_79 == null)
      new $serializer_79();
    return $serializer_instance_79;
  }
  function SetCompanyLocationRequest_init_$Init$(seen0, latitude, longitude, locationLabel, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_79().q2u_1);
    }
    $this.s2u_1 = latitude;
    $this.t2u_1 = longitude;
    if (0 === (seen0 & 4))
      $this.u2u_1 = null;
    else
      $this.u2u_1 = locationLabel;
    return $this;
  }
  function SetCompanyLocationRequest_init_$Create$(seen0, latitude, longitude, locationLabel, serializationConstructorMarker) {
    return SetCompanyLocationRequest_init_$Init$(seen0, latitude, longitude, locationLabel, serializationConstructorMarker, objectCreate(protoOf(SetCompanyLocationRequest)));
  }
  function SetCompanyLocationRequest(latitude, longitude, locationLabel) {
    locationLabel = locationLabel === VOID ? null : locationLabel;
    this.s2u_1 = latitude;
    this.t2u_1 = longitude;
    this.u2u_1 = locationLabel;
  }
  protoOf(SetCompanyLocationRequest).toString = function () {
    return 'SetCompanyLocationRequest(latitude=' + this.s2u_1 + ', longitude=' + this.t2u_1 + ', locationLabel=' + this.u2u_1 + ')';
  };
  protoOf(SetCompanyLocationRequest).hashCode = function () {
    var result = getNumberHashCode(this.s2u_1);
    result = imul(result, 31) + getNumberHashCode(this.t2u_1) | 0;
    result = imul(result, 31) + (this.u2u_1 == null ? 0 : getStringHashCode(this.u2u_1)) | 0;
    return result;
  };
  protoOf(SetCompanyLocationRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetCompanyLocationRequest))
      return false;
    if (!equals(this.s2u_1, other.s2u_1))
      return false;
    if (!equals(this.t2u_1, other.t2u_1))
      return false;
    if (!(this.u2u_1 == other.u2u_1))
      return false;
    return true;
  };
  function PagedCompaniesResponse$Companion$$childSerializers$_anonymous__fdeyar() {
    return new ArrayListSerializer($serializer_getInstance_77());
  }
  function Companion_80() {
    Companion_instance_81 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v2u_1 = [lazy(tmp_0, PagedCompaniesResponse$Companion$$childSerializers$_anonymous__fdeyar), null, null, null];
  }
  var Companion_instance_81;
  function Companion_getInstance_80() {
    if (Companion_instance_81 == null)
      new Companion_80();
    return Companion_instance_81;
  }
  function $serializer_80() {
    $serializer_instance_80 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.PagedCompaniesResponse', this, 4);
    tmp0_serialDesc.tt('items', false);
    tmp0_serialDesc.tt('totalCount', false);
    tmp0_serialDesc.tt('page', false);
    tmp0_serialDesc.tt('pageSize', false);
    this.w2u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_80).x2u = function (encoder, value) {
    var tmp0_desc = this.w2u_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_80().v2u_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.y2u_1);
    tmp1_output.pn(tmp0_desc, 1, value.z2u_1);
    tmp1_output.pn(tmp0_desc, 2, value.a2v_1);
    tmp1_output.pn(tmp0_desc, 3, value.b2v_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_80).fj = function (encoder, value) {
    return this.x2u(encoder, value instanceof PagedCompaniesResponse ? value : THROW_CCE());
  };
  protoOf($serializer_80).gj = function (decoder) {
    var tmp0_desc = this.w2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.fm(tmp0_desc);
    var tmp9_cached = Companion_getInstance_80().v2u_1;
    if (tmp8_input.vm()) {
      tmp4_local0 = tmp8_input.rm(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.km(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.km(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.km(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.rm(tmp0_desc, 0, tmp9_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.km(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.km(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.km(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.gm(tmp0_desc);
    return PagedCompaniesResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_80).ej = function () {
    return this.w2u_1;
  };
  protoOf($serializer_80).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_80().v2u_1[0].f2(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_80;
  function $serializer_getInstance_80() {
    if ($serializer_instance_80 == null)
      new $serializer_80();
    return $serializer_instance_80;
  }
  function PagedCompaniesResponse_init_$Init$(seen0, items, totalCount, page, pageSize, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_80().w2u_1);
    }
    $this.y2u_1 = items;
    $this.z2u_1 = totalCount;
    $this.a2v_1 = page;
    $this.b2v_1 = pageSize;
    return $this;
  }
  function PagedCompaniesResponse_init_$Create$(seen0, items, totalCount, page, pageSize, serializationConstructorMarker) {
    return PagedCompaniesResponse_init_$Init$(seen0, items, totalCount, page, pageSize, serializationConstructorMarker, objectCreate(protoOf(PagedCompaniesResponse)));
  }
  function PagedCompaniesResponse(items, totalCount, page, pageSize) {
    Companion_getInstance_80();
    this.y2u_1 = items;
    this.z2u_1 = totalCount;
    this.a2v_1 = page;
    this.b2v_1 = pageSize;
  }
  protoOf(PagedCompaniesResponse).toString = function () {
    return 'PagedCompaniesResponse(items=' + toString(this.y2u_1) + ', totalCount=' + this.z2u_1 + ', page=' + this.a2v_1 + ', pageSize=' + this.b2v_1 + ')';
  };
  protoOf(PagedCompaniesResponse).hashCode = function () {
    var result = hashCode(this.y2u_1);
    result = imul(result, 31) + this.z2u_1 | 0;
    result = imul(result, 31) + this.a2v_1 | 0;
    result = imul(result, 31) + this.b2v_1 | 0;
    return result;
  };
  protoOf(PagedCompaniesResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PagedCompaniesResponse))
      return false;
    if (!equals(this.y2u_1, other.y2u_1))
      return false;
    if (!(this.z2u_1 === other.z2u_1))
      return false;
    if (!(this.a2v_1 === other.a2v_1))
      return false;
    if (!(this.b2v_1 === other.b2v_1))
      return false;
    return true;
  };
  function InviteCompanyMemberRequest$Companion$$childSerializers$_anonymous__5mvlp3() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.company.CompanyMemberRole', values_5());
  }
  function Companion_81() {
    Companion_instance_82 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c2v_1 = [null, null, lazy(tmp_0, InviteCompanyMemberRequest$Companion$$childSerializers$_anonymous__5mvlp3)];
  }
  var Companion_instance_82;
  function Companion_getInstance_81() {
    if (Companion_instance_82 == null)
      new Companion_81();
    return Companion_instance_82;
  }
  function $serializer_81() {
    $serializer_instance_81 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.InviteCompanyMemberRequest', this, 3);
    tmp0_serialDesc.tt('targetEmail', false);
    tmp0_serialDesc.tt('targetName', false);
    tmp0_serialDesc.tt('role', false);
    this.d2v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_81).e2v = function (encoder, value) {
    var tmp0_desc = this.d2v_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_81().c2v_1;
    tmp1_output.un(tmp0_desc, 0, value.f2v_1);
    tmp1_output.un(tmp0_desc, 1, value.g2v_1);
    tmp1_output.wn(tmp0_desc, 2, tmp2_cached[2].f2(), value.h2v_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_81).fj = function (encoder, value) {
    return this.e2v(encoder, value instanceof InviteCompanyMemberRequest ? value : THROW_CCE());
  };
  protoOf($serializer_81).gj = function (decoder) {
    var tmp0_desc = this.d2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    var tmp8_cached = Companion_getInstance_81().c2v_1;
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.rm(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.rm(tmp0_desc, 2, tmp8_cached[2].f2(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return InviteCompanyMemberRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_81).ej = function () {
    return this.d2v_1;
  };
  protoOf($serializer_81).iu = function () {
    var tmp0_cached = Companion_getInstance_81().c2v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2].f2()];
  };
  var $serializer_instance_81;
  function $serializer_getInstance_81() {
    if ($serializer_instance_81 == null)
      new $serializer_81();
    return $serializer_instance_81;
  }
  function InviteCompanyMemberRequest_init_$Init$(seen0, targetEmail, targetName, role, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_81().d2v_1);
    }
    $this.f2v_1 = targetEmail;
    $this.g2v_1 = targetName;
    $this.h2v_1 = role;
    return $this;
  }
  function InviteCompanyMemberRequest_init_$Create$(seen0, targetEmail, targetName, role, serializationConstructorMarker) {
    return InviteCompanyMemberRequest_init_$Init$(seen0, targetEmail, targetName, role, serializationConstructorMarker, objectCreate(protoOf(InviteCompanyMemberRequest)));
  }
  function InviteCompanyMemberRequest(targetEmail, targetName, role) {
    Companion_getInstance_81();
    this.f2v_1 = targetEmail;
    this.g2v_1 = targetName;
    this.h2v_1 = role;
  }
  protoOf(InviteCompanyMemberRequest).toString = function () {
    return 'InviteCompanyMemberRequest(targetEmail=' + this.f2v_1 + ', targetName=' + this.g2v_1 + ', role=' + this.h2v_1.toString() + ')';
  };
  protoOf(InviteCompanyMemberRequest).hashCode = function () {
    var result = getStringHashCode(this.f2v_1);
    result = imul(result, 31) + getStringHashCode(this.g2v_1) | 0;
    result = imul(result, 31) + this.h2v_1.hashCode() | 0;
    return result;
  };
  protoOf(InviteCompanyMemberRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InviteCompanyMemberRequest))
      return false;
    if (!(this.f2v_1 === other.f2v_1))
      return false;
    if (!(this.g2v_1 === other.g2v_1))
      return false;
    if (!this.h2v_1.equals(other.h2v_1))
      return false;
    return true;
  };
  function CompanyMemberResponse$Companion$$childSerializers$_anonymous__92wfiq() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.company.CompanyMemberRole', values_5());
  }
  function Companion_82() {
    Companion_instance_83 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i2v_1 = [null, null, null, lazy(tmp_0, CompanyMemberResponse$Companion$$childSerializers$_anonymous__92wfiq), null];
  }
  var Companion_instance_83;
  function Companion_getInstance_82() {
    if (Companion_instance_83 == null)
      new Companion_82();
    return Companion_instance_83;
  }
  function $serializer_82() {
    $serializer_instance_82 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.CompanyMemberResponse', this, 5);
    tmp0_serialDesc.tt('userId', false);
    tmp0_serialDesc.tt('email', false);
    tmp0_serialDesc.tt('displayName', false);
    tmp0_serialDesc.tt('role', false);
    tmp0_serialDesc.tt('active', false);
    this.j2v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_82).k2v = function (encoder, value) {
    var tmp0_desc = this.j2v_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_82().i2v_1;
    tmp1_output.un(tmp0_desc, 0, value.l2v_1);
    tmp1_output.un(tmp0_desc, 1, value.m2v_1);
    tmp1_output.un(tmp0_desc, 2, value.n2v_1);
    tmp1_output.wn(tmp0_desc, 3, tmp2_cached[3].f2(), value.o2v_1);
    tmp1_output.mn(tmp0_desc, 4, value.p2v_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_82).fj = function (encoder, value) {
    return this.k2v(encoder, value instanceof CompanyMemberResponse ? value : THROW_CCE());
  };
  protoOf($serializer_82).gj = function (decoder) {
    var tmp0_desc = this.j2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_input = decoder.fm(tmp0_desc);
    var tmp10_cached = Companion_getInstance_82().i2v_1;
    if (tmp9_input.vm()) {
      tmp4_local0 = tmp9_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.rm(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hm(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.rm(tmp0_desc, 3, tmp10_cached[3].f2(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hm(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.gm(tmp0_desc);
    return CompanyMemberResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_82).ej = function () {
    return this.j2v_1;
  };
  protoOf($serializer_82).iu = function () {
    var tmp0_cached = Companion_getInstance_82().i2v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3].f2(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_82;
  function $serializer_getInstance_82() {
    if ($serializer_instance_82 == null)
      new $serializer_82();
    return $serializer_instance_82;
  }
  function CompanyMemberResponse_init_$Init$(seen0, userId, email, displayName, role, active, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_82().j2v_1);
    }
    $this.l2v_1 = userId;
    $this.m2v_1 = email;
    $this.n2v_1 = displayName;
    $this.o2v_1 = role;
    $this.p2v_1 = active;
    return $this;
  }
  function CompanyMemberResponse_init_$Create$(seen0, userId, email, displayName, role, active, serializationConstructorMarker) {
    return CompanyMemberResponse_init_$Init$(seen0, userId, email, displayName, role, active, serializationConstructorMarker, objectCreate(protoOf(CompanyMemberResponse)));
  }
  function CompanyMemberResponse(userId, email, displayName, role, active) {
    Companion_getInstance_82();
    this.l2v_1 = userId;
    this.m2v_1 = email;
    this.n2v_1 = displayName;
    this.o2v_1 = role;
    this.p2v_1 = active;
  }
  protoOf(CompanyMemberResponse).toString = function () {
    return 'CompanyMemberResponse(userId=' + this.l2v_1 + ', email=' + this.m2v_1 + ', displayName=' + this.n2v_1 + ', role=' + this.o2v_1.toString() + ', active=' + this.p2v_1 + ')';
  };
  protoOf(CompanyMemberResponse).hashCode = function () {
    var result = getStringHashCode(this.l2v_1);
    result = imul(result, 31) + getStringHashCode(this.m2v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n2v_1) | 0;
    result = imul(result, 31) + this.o2v_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p2v_1) | 0;
    return result;
  };
  protoOf(CompanyMemberResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompanyMemberResponse))
      return false;
    if (!(this.l2v_1 === other.l2v_1))
      return false;
    if (!(this.m2v_1 === other.m2v_1))
      return false;
    if (!(this.n2v_1 === other.n2v_1))
      return false;
    if (!this.o2v_1.equals(other.o2v_1))
      return false;
    if (!(this.p2v_1 === other.p2v_1))
      return false;
    return true;
  };
  function UpdateCompanyMemberRoleRequest$Companion$$childSerializers$_anonymous__7hw5j3() {
    return createSimpleEnumSerializer('com.universaliun.bitakore.common.domain.company.CompanyMemberRole', values_5());
  }
  function Companion_83() {
    Companion_instance_84 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q2v_1 = [lazy(tmp_0, UpdateCompanyMemberRoleRequest$Companion$$childSerializers$_anonymous__7hw5j3)];
  }
  var Companion_instance_84;
  function Companion_getInstance_83() {
    if (Companion_instance_84 == null)
      new Companion_83();
    return Companion_instance_84;
  }
  function $serializer_83() {
    $serializer_instance_83 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.UpdateCompanyMemberRoleRequest', this, 1);
    tmp0_serialDesc.tt('role', false);
    this.r2v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_83).s2v = function (encoder, value) {
    var tmp0_desc = this.r2v_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    var tmp2_cached = Companion_getInstance_83().q2v_1;
    tmp1_output.wn(tmp0_desc, 0, tmp2_cached[0].f2(), value.t2v_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_83).fj = function (encoder, value) {
    return this.s2v(encoder, value instanceof UpdateCompanyMemberRoleRequest ? value : THROW_CCE());
  };
  protoOf($serializer_83).gj = function (decoder) {
    var tmp0_desc = this.r2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.fm(tmp0_desc);
    var tmp6_cached = Companion_getInstance_83().q2v_1;
    if (tmp5_input.vm()) {
      tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0].f2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.gm(tmp0_desc);
    return UpdateCompanyMemberRoleRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_83).ej = function () {
    return this.r2v_1;
  };
  protoOf($serializer_83).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_83().q2v_1[0].f2()];
  };
  var $serializer_instance_83;
  function $serializer_getInstance_83() {
    if ($serializer_instance_83 == null)
      new $serializer_83();
    return $serializer_instance_83;
  }
  function UpdateCompanyMemberRoleRequest_init_$Init$(seen0, role, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_83().r2v_1);
    }
    $this.t2v_1 = role;
    return $this;
  }
  function UpdateCompanyMemberRoleRequest_init_$Create$(seen0, role, serializationConstructorMarker) {
    return UpdateCompanyMemberRoleRequest_init_$Init$(seen0, role, serializationConstructorMarker, objectCreate(protoOf(UpdateCompanyMemberRoleRequest)));
  }
  function UpdateCompanyMemberRoleRequest(role) {
    Companion_getInstance_83();
    this.t2v_1 = role;
  }
  protoOf(UpdateCompanyMemberRoleRequest).toString = function () {
    return 'UpdateCompanyMemberRoleRequest(role=' + this.t2v_1.toString() + ')';
  };
  protoOf(UpdateCompanyMemberRoleRequest).hashCode = function () {
    return this.t2v_1.hashCode();
  };
  protoOf(UpdateCompanyMemberRoleRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateCompanyMemberRoleRequest))
      return false;
    if (!this.t2v_1.equals(other.t2v_1))
      return false;
    return true;
  };
  function Companion_84() {
  }
  var Companion_instance_85;
  function Companion_getInstance_84() {
    return Companion_instance_85;
  }
  function $serializer_84() {
    $serializer_instance_84 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.universaliun.bitakore.frontend.dto.CompanyPhotoResponse', this, 3);
    tmp0_serialDesc.tt('id', false);
    tmp0_serialDesc.tt('url', false);
    tmp0_serialDesc.tt('createdAt', false);
    this.u2v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_84).v2v = function (encoder, value) {
    var tmp0_desc = this.u2v_1;
    var tmp1_output = encoder.fm(tmp0_desc);
    tmp1_output.un(tmp0_desc, 0, value.w2v_1);
    tmp1_output.un(tmp0_desc, 1, value.x2v_1);
    tmp1_output.un(tmp0_desc, 2, value.y2v_1);
    tmp1_output.gm(tmp0_desc);
  };
  protoOf($serializer_84).fj = function (encoder, value) {
    return this.v2v(encoder, value instanceof CompanyPhotoResponse ? value : THROW_CCE());
  };
  protoOf($serializer_84).gj = function (decoder) {
    var tmp0_desc = this.u2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.fm(tmp0_desc);
    if (tmp7_input.vm()) {
      tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.pm(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.wm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.pm(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.pm(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.pm(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.gm(tmp0_desc);
    return CompanyPhotoResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_84).ej = function () {
    return this.u2v_1;
  };
  protoOf($serializer_84).iu = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_84;
  function $serializer_getInstance_84() {
    if ($serializer_instance_84 == null)
      new $serializer_84();
    return $serializer_instance_84;
  }
  function CompanyPhotoResponse_init_$Init$(seen0, id, url, createdAt, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_84().u2v_1);
    }
    $this.w2v_1 = id;
    $this.x2v_1 = url;
    $this.y2v_1 = createdAt;
    return $this;
  }
  function CompanyPhotoResponse_init_$Create$(seen0, id, url, createdAt, serializationConstructorMarker) {
    return CompanyPhotoResponse_init_$Init$(seen0, id, url, createdAt, serializationConstructorMarker, objectCreate(protoOf(CompanyPhotoResponse)));
  }
  function CompanyPhotoResponse(id, url, createdAt) {
    this.w2v_1 = id;
    this.x2v_1 = url;
    this.y2v_1 = createdAt;
  }
  protoOf(CompanyPhotoResponse).toString = function () {
    return 'CompanyPhotoResponse(id=' + this.w2v_1 + ', url=' + this.x2v_1 + ', createdAt=' + this.y2v_1 + ')';
  };
  protoOf(CompanyPhotoResponse).hashCode = function () {
    var result = getStringHashCode(this.w2v_1);
    result = imul(result, 31) + getStringHashCode(this.x2v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y2v_1) | 0;
    return result;
  };
  protoOf(CompanyPhotoResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompanyPhotoResponse))
      return false;
    if (!(this.w2v_1 === other.w2v_1))
      return false;
    if (!(this.x2v_1 === other.x2v_1))
      return false;
    if (!(this.y2v_1 === other.y2v_1))
      return false;
    return true;
  };
  function get_sessionExpiredNavigateTo() {
    _init_properties_ApiClient_kt__14qtcj();
    return sessionExpiredNavigateTo;
  }
  var sessionExpiredNavigateTo;
  function ApiException(status, error, removedTypeCounts) {
    removedTypeCounts = removedTypeCounts === VOID ? null : removedTypeCounts;
    Exception_init_$Init$('HTTP ' + status + ': ' + error, this);
    captureStack(this, ApiException);
    this.j2c_1 = status;
    this.k2c_1 = error;
    this.l2c_1 = removedTypeCounts;
  }
  function defaultSessionExpiredNavigateTo(path) {
    _init_properties_ApiClient_kt__14qtcj();
    window.location.href = path;
  }
  function ApiClient$json$lambda($this$Json) {
    $this$Json.a14_1 = true;
    $this$Json.y13_1 = true;
    return Unit_instance;
  }
  function $deleteNoContentCOROUTINE$(_this__u8e3s4, path, authenticated, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h2w_1 = _this__u8e3s4;
    this.i2w_1 = path;
    this.j2w_1 = authenticated;
  }
  protoOf($deleteNoContentCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = this.h2w_1.g27('DELETE', this.i2w_1, null, this.j2w_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 2) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  function $rawRequestCOROUTINE$(_this__u8e3s4, method, path, body, authenticated, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s2w_1 = _this__u8e3s4;
    this.t2w_1 = method;
    this.u2w_1 = path;
    this.v2w_1 = body;
    this.w2w_1 = authenticated;
  }
  protoOf($rawRequestCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            var headers = new Headers();
            headers.append('Content-Type', 'application/json');
            if (this.w2w_1) {
              var tmp0_safe_receiver = AuthState_instance.y2w();
              if (tmp0_safe_receiver == null)
                null;
              else {
                headers.append('Authorization', 'Bearer ' + tmp0_safe_receiver);
              }
            }

            var init = {};
            init.method = this.t2w_1;
            init.headers = headers;
            if (!(this.v2w_1 == null)) {
              init.body = this.v2w_1;
            }

            this.t7_1 = 1;
            suspendResult = await_0(window.fetch(this.s2w_1.e27_1 + this.u2w_1, init), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x2w_1 = suspendResult;
            this.t7_1 = 2;
            suspendResult = await_0(this.x2w_1.text(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var text = suspendResult;
            if (!this.x2w_1.ok) {
              this.s2w_1.z2w(this.x2w_1.status, this.w2w_1);
              var this_0 = this.s2w_1;
              var tmp_0;
              try {
                var this_1 = this_0.f27_1;
                var this_2 = this_1.um();
                var this_3 = serializer(this_2, createKType(getKClass(ErrorResponse), arrayOf([]), false));
                var value = this_1.i13(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), text);
                tmp_0 = _Result___init__impl__xyqfz8(value);
              } catch ($p) {
                var tmp_1;
                if ($p instanceof Error) {
                  var e = $p;
                  tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
                } else {
                  throw $p;
                }
                tmp_0 = tmp_1;
              }
              var this_4 = tmp_0;
              var parsed = _Result___get_isFailure__impl__jpiriv(this_4) ? null : _Result___get_value__impl__bjfvqg(this_4);
              var tmp_2 = this.x2w_1.status;
              var tmp2_elvis_lhs = parsed == null ? null : parsed.p2c_1;
              var tmp_3;
              if (tmp2_elvis_lhs == null) {
                var tmp_4;
                if (isBlank(text)) {
                  tmp_4 = 'Request failed';
                } else {
                  tmp_4 = text;
                }
                tmp_3 = tmp_4;
              } else {
                tmp_3 = tmp2_elvis_lhs;
              }
              var tmp_5 = tmp_3;
              throw new ApiException(tmp_2, tmp_5, parsed == null ? null : parsed.q2c_1);
            }

            return text;
          case 3:
            throw this.w7_1;
        }
      } catch ($p_0) {
        var e_0 = $p_0;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  function ApiClient() {
    ApiClient_instance = this;
    this.e27_1 = '';
    var tmp = this;
    tmp.f27_1 = Json(VOID, ApiClient$json$lambda);
  }
  protoOf(ApiClient).z2w = function (status, authenticated) {
    if (status === 401 && authenticated) {
      AuthState_instance.p2();
      get_sessionExpiredNavigateTo()('/login?sessionExpired=true');
    }
  };
  protoOf(ApiClient).a2x = function (path, authenticated, $completion) {
    var tmp = new $deleteNoContentCOROUTINE$(this, path, authenticated, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(ApiClient).g27 = function (method, path, body, authenticated, $completion) {
    var tmp = new $rawRequestCOROUTINE$(this, method, path, body, authenticated, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  var ApiClient_instance;
  function ApiClient_getInstance() {
    if (ApiClient_instance == null)
      new ApiClient();
    return ApiClient_instance;
  }
  function defaultSessionExpiredNavigateTo$ref() {
    return constructCallableReference(function (p0) {
      defaultSessionExpiredNavigateTo(p0);
      return Unit_instance;
    }, 1, 0, 12, 'defaultSessionExpiredNavigateTo');
  }
  var properties_initialized_ApiClient_kt_hvyiqd;
  function _init_properties_ApiClient_kt__14qtcj() {
    if (!properties_initialized_ApiClient_kt_hvyiqd) {
      properties_initialized_ApiClient_kt_hvyiqd = true;
      sessionExpiredNavigateTo = defaultSessionExpiredNavigateTo$ref();
    }
  }
  function attachPasskeyToCurrentAccount($completion) {
    var tmp = new $attachPasskeyToCurrentAccountCOROUTINE$($completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function loginWithPasskey(email, $completion) {
    var tmp = new $loginWithPasskeyCOROUTINE$(email, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function $attachPasskeyToCurrentAccountCOROUTINE$(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($attachPasskeyToCurrentAccountCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/auth/passkey/register/start';
            this.l2x_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('POST', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.l2x_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(PasskeyRegistrationStartResponse), arrayOf([]), false));
            tmp_0.k2x_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.t7_1 = 2;
            suspendResult = createPasskeyCredential(this.k2x_1.h2d_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var credentialJson = suspendResult;
            var tmp0_0 = ApiClient_getInstance();
            var tmp2_0 = '/api/auth/passkey/register/finish';
            var body = new PasskeyRegistrationFinishRequest(this.k2x_1.g2d_1, credentialJson);
            this.j2x_1 = tmp0_0.f27_1;
            this.t7_1 = 3;
            var this_3 = tmp0_0.f27_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(PasskeyRegistrationFinishRequest), arrayOf([]), false));
            suspendResult = tmp0_0.g27('POST', tmp2_0, this_3.h13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp2_1 = suspendResult;
            var this_6 = this.j2x_1;
            var this_7 = this_6.um();
            var this_8 = serializer(this_7, createKType(getKClass(PasskeyRegistrationFinishResponse), arrayOf([]), false));
            this_6.i13(isInterface(this_8, KSerializer) ? this_8 : THROW_CCE(), tmp2_1);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 4) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  function $loginWithPasskeyCOROUTINE$(email, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u2x_1 = email;
  }
  protoOf($loginWithPasskeyCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/auth/passkey/login/start';
            var body = new PasskeyLoginStartRequest(this.u2x_1);
            this.x2x_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(PasskeyLoginStartRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var tmp_0 = this;
            var this_3 = this.x2x_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(PasskeyLoginStartResponse), arrayOf([]), false));
            tmp_0.w2x_1 = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            this.t7_1 = 2;
            suspendResult = getPasskeyAssertion(this.w2x_1.v2d_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var credentialJson = suspendResult;
            var tmp0_0 = ApiClient_getInstance();
            var tmp2_1 = '/api/auth/passkey/login/finish';
            var body_0 = new PasskeyLoginFinishRequest(this.w2x_1.u2d_1, credentialJson);
            this.v2x_1 = tmp0_0.f27_1;
            this.t7_1 = 3;
            var this_6 = tmp0_0.f27_1;
            var this_7 = this_6.um();
            var this_8 = serializer(this_7, createKType(getKClass(PasskeyLoginFinishRequest), arrayOf([]), false));
            suspendResult = tmp0_0.g27('POST', tmp2_1, this_6.h13(isInterface(this_8, KSerializer) ? this_8 : THROW_CCE(), body_0), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp2_2 = suspendResult;
            var this_9 = this.v2x_1;
            var this_10 = this_9.um();
            var this_11 = serializer(this_10, createKType(getKClass(TokenResponse), arrayOf([]), false));
            return this_9.i13(isInterface(this_11, KSerializer) ? this_11 : THROW_CCE(), tmp2_2);
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 4) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  function AcceptInvitationPageModule$init$lambda($code) {
    return function (event) {
      event.preventDefault();
      submitAcceptInvitation($code);
      return Unit_instance;
    };
  }
  function AcceptInvitationPageModule() {
  }
  protoOf(AcceptInvitationPageModule).r28 = function () {
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('code');
    var code = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    if (isBlank(code)) {
      var tmp = document.getElementById('acceptInvitationMissingCode');
      (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('hidden');
      return Unit_instance;
    }
    var tmp_0 = document.getElementById('acceptForm');
    (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.remove('hidden');
    wireAuthMethodPicker();
    var tmp_1 = document.getElementById('acceptForm');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('submit', AcceptInvitationPageModule$init$lambda(code));
  };
  var AcceptInvitationPageModule_instance;
  function AcceptInvitationPageModule_getInstance() {
    return AcceptInvitationPageModule_instance;
  }
  function submitAcceptInvitation(code) {
    var tmp = document.getElementById('formError');
    var errorBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    errorBox.textContent = '';
    var methodError = authMethodValidationError();
    if (!(methodError == null)) {
      errorBox.textContent = methodError;
      return Unit_instance;
    }
    var tmp_0 = document.getElementById('displayName');
    var displayName = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var password = selectedPassword();
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, submitAcceptInvitation$slambda_0(code, displayName, password, errorBox, null));
  }
  function submitAcceptInvitation$slambda($code, $displayName, $password, $errorBox, resultContinuation) {
    this.g2y_1 = $code;
    this.h2y_1 = $displayName;
    this.i2y_1 = $password;
    this.j2y_1 = $errorBox;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitAcceptInvitation$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitAcceptInvitation$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitAcceptInvitation$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 5;
            this.u7_1 = 4;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/members/invitations/accept';
            var body = new AcceptInvitationRequest(this.g2y_1, this.h2y_1, this.i2y_1);
            this.l2y_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(AcceptInvitationRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.l2y_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(TokenResponse), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            AuthState_instance.m2y(result.t2c_1, result.u2c_1);
            this.t7_1 = 2;
            suspendResult = attachPasskeyIfSelected(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.t7_1 = 3;
            suspendResult = navigateAfterAuth(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.u7_1 = 5;
            this.t7_1 = 6;
            continue $sm;
          case 4:
            this.u7_1 = 5;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              this.j2y_1.textContent = e.k2c_1;
              this.t7_1 = 6;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                this.j2y_1.textContent = 'Something went wrong: ' + e_0.message;
                this.t7_1 = 6;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 5:
            throw this.w7_1;
          case 6:
            this.u7_1 = 5;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 5) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitAcceptInvitation$slambda).h22 = function ($this$launch, completion) {
    var i = new submitAcceptInvitation$slambda(this.g2y_1, this.h2y_1, this.i2y_1, this.j2y_1, completion);
    i.k2y_1 = $this$launch;
    return i;
  };
  function submitAcceptInvitation$slambda_0($code, $displayName, $password, $errorBox, resultContinuation) {
    var i = new submitAcceptInvitation$slambda($code, $displayName, $password, $errorBox, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  var currentCompanyId;
  function loadOfferings(companyId) {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, loadOfferings$slambda_0(companyId, null));
  }
  function submitOfferings(confirmedDeletions) {
    var tmp = document.getElementById('offeringsStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var activityTypes = selectedActivityTypes('offering');
    var companyId = currentCompanyId;
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, submitOfferings$slambda_0(companyId, activityTypes, confirmedDeletions, status, null));
  }
  function loadCompanyPhotos(companyId) {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, loadCompanyPhotos$slambda_0(companyId, null));
  }
  function renderCompanyPhotosList(companyId, photos) {
    var tmp = document.getElementById('companyPhotosList');
    var list = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    list.innerHTML = '';
    append(list, renderCompanyPhotosList$lambda(photos));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = photos.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp_0 = document.getElementById('deleteCompanyPhoto-' + element.w2v_1);
      var tmp_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
      tmp_1.addEventListener('click', renderCompanyPhotosList$lambda_0(companyId, element));
    }
  }
  function submitCompanyPhotoUpload(companyId) {
    var tmp = document.getElementById('companyPhotosStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('companyPhotoFile');
    var fileInput = tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.js.asDynamic' call
    var file = fileInput.files[0];
    if (file == undefined) {
      showError(status, I18n_getInstance().e28('companyPhotos.selectFileError'));
      return Unit_instance;
    }
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, submitCompanyPhotoUpload$slambda_0(companyId, file, fileInput, status, null));
  }
  function deleteCompanyPhoto(companyId, photoId) {
    var tmp = document.getElementById('companyPhotosStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, deleteCompanyPhoto$slambda_0(companyId, photoId, status, null));
  }
  function renderPendingRemovalWarning(status, removedTypeCounts) {
    append(status, renderPendingRemovalWarning$lambda(removedTypeCounts));
    var tmp = document.getElementById('confirmOfferingRemovalButton');
    var tmp_0 = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    tmp_0.addEventListener('click', renderPendingRemovalWarning$lambda_0);
  }
  function ActivityOfferingsPageModule$init$lambda(event) {
    var tmp = document.getElementById('offeringsCheckboxes');
    var checkboxes = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = event.target;
    filterActivityOptions(checkboxes, (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value);
    return Unit_instance;
  }
  function ActivityOfferingsPageModule$init$lambda_0(event) {
    event.preventDefault();
    submitOfferings(false);
    return Unit_instance;
  }
  function ActivityOfferingsPageModule$init$lambda_1($companyId) {
    return function (it) {
      submitCompanyPhotoUpload($companyId);
      return Unit_instance;
    };
  }
  function ActivityOfferingsPageModule() {
  }
  protoOf(ActivityOfferingsPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('companyId');
    var companyId = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    if (isBlank(companyId)) {
      var tmp = document.getElementById('offeringsMissingCompany');
      (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('hidden');
      var tmp_0 = document.getElementById('offeringsContent');
      (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.add('hidden');
      return Unit_instance;
    }
    currentCompanyId = companyId;
    var tmp_1 = document.getElementById('offeringsSearchInput');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('input', ActivityOfferingsPageModule$init$lambda);
    var tmp_3 = document.getElementById('offeringsForm');
    var tmp_4 = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
    tmp_4.addEventListener('submit', ActivityOfferingsPageModule$init$lambda_0);
    var tmp_5 = document.getElementById('uploadCompanyPhotoButton');
    var tmp_6 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
    tmp_6.addEventListener('click', ActivityOfferingsPageModule$init$lambda_1(companyId));
    loadOfferings(companyId);
    loadCompanyPhotos(companyId);
  };
  var ActivityOfferingsPageModule_instance;
  function ActivityOfferingsPageModule_getInstance() {
    return ActivityOfferingsPageModule_instance;
  }
  function loadOfferings$slambda($companyId, resultContinuation) {
    this.v2y_1 = $companyId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadOfferings$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadOfferings$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadOfferings$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/companies/' + this.v2y_1 + '/activity-offerings';
            this.x2y_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.x2y_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(CompanyActivityOfferingsResponse), arrayOf([]), false));
            var offerings = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            setActivityTypeSelection('offering', offerings.o2o_1);
            var _iterator__ex2g4s = offerings.o2o_1.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              var tmp_0 = document.getElementById('offering-' + element.toString());
              var tmp0_safe_receiver = tmp_0 instanceof HTMLInputElement ? tmp_0 : null;
              var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.closest('.activity-category-card');
              var tmp_1;
              if (tmp1_safe_receiver == null) {
                tmp_1 = null;
              } else {
                tmp_1 = tmp1_safe_receiver;
              }
              var tmp2_safe_receiver = tmp_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                tmp2_safe_receiver.open = true;
              }
            }

            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_2 = this.w7_1;
            if (tmp_2 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_3 = document.getElementById('offeringsStatus');
              var status = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
              showError(status, I18n_getInstance().e28('activityOfferings.loadOfferingsErrorPrefix') + e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadOfferings$slambda).h22 = function ($this$launch, completion) {
    var i = new loadOfferings$slambda(this.v2y_1, completion);
    i.w2y_1 = $this$launch;
    return i;
  };
  function loadOfferings$slambda_0($companyId, resultContinuation) {
    var i = new loadOfferings$slambda($companyId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitOfferings$slambda($companyId, $activityTypes, $confirmedDeletions, $status, resultContinuation) {
    this.g2z_1 = $companyId;
    this.h2z_1 = $activityTypes;
    this.i2z_1 = $confirmedDeletions;
    this.j2z_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitOfferings$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitOfferings$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitOfferings$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/companies/' + this.g2z_1 + '/activity-offerings';
            var body = new SetCompanyActivityOfferingsRequest(this.h2z_1, this.i2z_1);
            this.l2z_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(SetCompanyActivityOfferingsRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('PUT', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.l2z_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(CompanyActivityOfferingsResponse), arrayOf([]), false));
            this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            get_moduleNavigateTo()('/profile');
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              if (e.j2c_1 === 422 && !(e.l2c_1 == null)) {
                renderPendingRemovalWarning(this.j2z_1, e.l2c_1);
              } else {
                showError(this.j2z_1, e.k2c_1);
              }
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitOfferings$slambda).h22 = function ($this$launch, completion) {
    var i = new submitOfferings$slambda(this.g2z_1, this.h2z_1, this.i2z_1, this.j2z_1, completion);
    i.k2z_1 = $this$launch;
    return i;
  };
  function submitOfferings$slambda_0($companyId, $activityTypes, $confirmedDeletions, $status, resultContinuation) {
    var i = new submitOfferings$slambda($companyId, $activityTypes, $confirmedDeletions, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function loadCompanyPhotos$slambda($companyId, resultContinuation) {
    this.u2z_1 = $companyId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadCompanyPhotos$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadCompanyPhotos$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadCompanyPhotos$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/members/companies/' + this.u2z_1 + '/photos';
            this.x2z_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.x2z_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CompanyPhotoResponse), arrayOf([]), false))]), false));
            tmp_0.w2z_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.w2z_1 = emptyList();
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var photos = this.w2z_1;
            renderCompanyPhotosList(this.u2z_1, photos);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadCompanyPhotos$slambda).h22 = function ($this$launch, completion) {
    var i = new loadCompanyPhotos$slambda(this.u2z_1, completion);
    i.v2z_1 = $this$launch;
    return i;
  };
  function loadCompanyPhotos$slambda_0($companyId, resultContinuation) {
    var i = new loadCompanyPhotos$slambda($companyId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderCompanyPhotosList$lambda($photos) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $photos.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = 'photo-preview-item';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp4 = element.x2v_1;
        // Inline function 'kotlinx.html.img' call
        var classes_0 = 'photo-preview-thumb';
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_1 = new IMG(attributesMapOf(['alt', '', 'src', tmp4, 'loading', null == null ? null : enumEncode(null), 'class', classes_0]), this_0.j1f());
        this_1.j1f().a1h(this_1);
        this_1.j1f().b1h(this_1);
        // Inline function 'kotlinx.html.button' call
        var classes_1 = 'icon-button icon-button-danger';
        var tmp = null == null ? null : enumEncode(null);
        var tmp_0 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_2 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_1]), this_0.j1f());
        this_2.j1f().a1h(this_2);
        this_2.z1j(ButtonType_button_getInstance());
        set_id(this_2, 'deleteCompanyPhoto-' + element.w2v_1);
        var tmp0 = this_2.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = 'companyPhotos.deleteButton';
        tmp0.m2(tmp2, value);
        this_2.n1f(I18n_getInstance().e28('companyPhotos.deleteButton'));
        this_2.j1f().b1h(this_2);
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function renderCompanyPhotosList$lambda_0($companyId, $photo) {
    return function (it) {
      deleteCompanyPhoto($companyId, $photo.w2v_1);
      return Unit_instance;
    };
  }
  function submitCompanyPhotoUpload$slambda($companyId, $file, $fileInput, $status, resultContinuation) {
    this.g30_1 = $companyId;
    this.h30_1 = $file;
    this.i30_1 = $fileInput;
    this.j30_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitCompanyPhotoUpload$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitCompanyPhotoUpload$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitCompanyPhotoUpload$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 3;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/members/companies/' + this.g30_1 + '/photos';
            var tmp6 = this.h30_1;
            this.l30_1 = tmp0;
            var formData = new FormData();
            formData.append('file', tmp6);
            var headers = new Headers();
            var tmp0_safe_receiver = AuthState_instance.y2w();
            if (tmp0_safe_receiver == null)
              null;
            else {
              headers.append('Authorization', 'Bearer ' + tmp0_safe_receiver);
            }

            var init = {};
            init.method = 'PUT';
            init.headers = headers;
            init.body = formData;
            this.t7_1 = 1;
            suspendResult = await_0(window.fetch(this.l30_1.e27_1 + tmp2, init), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.m30_1 = suspendResult;
            this.t7_1 = 2;
            suspendResult = await_0(this.m30_1.text(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var text = suspendResult;
            if (!this.m30_1.ok) {
              this.l30_1.z2w(this.m30_1.status, true);
              var this_0 = this.l30_1;
              var tmp_0;
              try {
                var this_1 = this_0.f27_1;
                var this_2 = this_1.um();
                var this_3 = serializer(this_2, createKType(getKClass(ErrorResponse), arrayOf([]), false));
                var value = this_1.i13(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), text);
                tmp_0 = _Result___init__impl__xyqfz8(value);
              } catch ($p) {
                var tmp_1;
                if ($p instanceof Error) {
                  var e = $p;
                  tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
                } else {
                  throw $p;
                }
                tmp_0 = tmp_1;
              }
              var this_4 = tmp_0;
              var parsed = _Result___get_isFailure__impl__jpiriv(this_4) ? null : _Result___get_value__impl__bjfvqg(this_4);
              var tmp_2 = this.m30_1.status;
              var tmp2_elvis_lhs = parsed == null ? null : parsed.p2c_1;
              var tmp_3;
              if (tmp2_elvis_lhs == null) {
                var tmp_4;
                if (isBlank(text)) {
                  tmp_4 = 'Upload failed';
                } else {
                  tmp_4 = text;
                }
                tmp_3 = tmp_4;
              } else {
                tmp_3 = tmp2_elvis_lhs;
              }
              var tmp_5 = tmp_3;
              throw new ApiException(tmp_2, tmp_5, parsed == null ? null : parsed.q2c_1);
            }

            var this_5 = this.l30_1.f27_1;
            var this_6 = this_5.um();
            var this_7 = serializer(this_6, createKType(getKClass(CompanyPhotoResponse), arrayOf([]), false));
            this_5.i13(isInterface(this_7, KSerializer) ? this_7 : THROW_CCE(), text);
            this.i30_1.value = '';
            loadCompanyPhotos(this.g30_1);
            this.u7_1 = 4;
            this.t7_1 = 5;
            continue $sm;
          case 3:
            this.u7_1 = 4;
            var tmp_6 = this.w7_1;
            if (tmp_6 instanceof ApiException) {
              var e_0 = this.w7_1;
              showError(this.j30_1, e_0.k2c_1);
              this.t7_1 = 5;
              continue $sm;
            } else {
              var tmp_7 = this.w7_1;
              if (tmp_7 instanceof Error) {
                var e_1 = this.w7_1;
                showError(this.j30_1, I18n_getInstance().e28('companyPhotos.genericErrorPrefix') + e_1.message);
                this.t7_1 = 5;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 4:
            throw this.w7_1;
          case 5:
            this.u7_1 = 4;
            return Unit_instance;
        }
      } catch ($p_0) {
        var e_2 = $p_0;
        if (this.u7_1 === 4) {
          throw e_2;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_2;
        }
      }
     while (true);
  };
  protoOf(submitCompanyPhotoUpload$slambda).h22 = function ($this$launch, completion) {
    var i = new submitCompanyPhotoUpload$slambda(this.g30_1, this.h30_1, this.i30_1, this.j30_1, completion);
    i.k30_1 = $this$launch;
    return i;
  };
  function submitCompanyPhotoUpload$slambda_0($companyId, $file, $fileInput, $status, resultContinuation) {
    var i = new submitCompanyPhotoUpload$slambda($companyId, $file, $fileInput, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function deleteCompanyPhoto$slambda($companyId, $photoId, $status, resultContinuation) {
    this.v30_1 = $companyId;
    this.w30_1 = $photoId;
    this.x30_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(deleteCompanyPhoto$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(deleteCompanyPhoto$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(deleteCompanyPhoto$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = ApiClient_getInstance().a2x('/api/v1/members/companies/' + this.v30_1 + '/photos/' + this.w30_1, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            loadCompanyPhotos(this.v30_1);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.x30_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(deleteCompanyPhoto$slambda).h22 = function ($this$launch, completion) {
    var i = new deleteCompanyPhoto$slambda(this.v30_1, this.w30_1, this.x30_1, completion);
    i.y30_1 = $this$launch;
    return i;
  };
  function deleteCompanyPhoto$slambda_0($companyId, $photoId, $status, resultContinuation) {
    var i = new deleteCompanyPhoto$slambda($companyId, $photoId, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderPendingRemovalWarning$lambda$lambda(it) {
    return activityTypeLabel(valueOf(it));
  }
  function renderPendingRemovalWarning$lambda($removedTypeCounts) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.div' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new DIV(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new P(attributesMapOf_0('class', null), this_0.j1f());
      this_1.j1f().a1h(this_1);
      var tmp = I18n_getInstance().e28('activityOfferings.removeWarningPrefix');
      var tmp_0 = $removedTypeCounts.j2();
      this_1.n1f(tmp + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, renderPendingRemovalWarning$lambda$lambda) + I18n_getInstance().e28('activityOfferings.removeWarningMiddle') + sum($removedTypeCounts.k2()) + I18n_getInstance().e28('activityOfferings.removeWarningSuffix'));
      this_1.j1f().b1h(this_1);
      // Inline function 'kotlinx.html.button' call
      var tmp_1 = null == null ? null : enumEncode(null);
      var tmp_2 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new BUTTON(attributesMapOf(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_0.j1f());
      this_2.j1f().a1h(this_2);
      this_2.z1j(ButtonType_button_getInstance());
      set_id(this_2, 'confirmOfferingRemovalButton');
      var tmp0 = this_2.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'activityOfferings.confirmRemovalButton';
      tmp0.m2(tmp2, value);
      this_2.n1f(I18n_getInstance().e28('activityOfferings.confirmRemovalButton'));
      this_2.j1f().b1h(this_2);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function renderPendingRemovalWarning$lambda_0(it) {
    submitOfferings(true);
    return Unit_instance;
  }
  function set_pendingRemovedTypeCounts(_set____db54di) {
    _init_properties_ActivitySelectionPage_kt__92ar5y();
    pendingRemovedTypeCounts = _set____db54di;
  }
  var pendingRemovedTypeCounts;
  function set_afterActivitySelectionNavigateTo(_set____db54di) {
    _init_properties_ActivitySelectionPage_kt__92ar5y();
    afterActivitySelectionNavigateTo = _set____db54di;
  }
  function get_afterActivitySelectionNavigateTo() {
    _init_properties_ActivitySelectionPage_kt__92ar5y();
    return afterActivitySelectionNavigateTo;
  }
  var afterActivitySelectionNavigateTo;
  function loadRegisteredActivities() {
    _init_properties_ActivitySelectionPage_kt__92ar5y();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, loadRegisteredActivities$slambda_0(null));
  }
  function submitActivitySelection(confirmedDeletions) {
    _init_properties_ActivitySelectionPage_kt__92ar5y();
    var tmp = document.getElementById('activitySelectionStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var activityTypes = selectedActivityTypes('activity');
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, submitActivitySelection$slambda_0(activityTypes, confirmedDeletions, status, null));
  }
  function renderPendingDeletionWarning(status, removedTypeCounts) {
    _init_properties_ActivitySelectionPage_kt__92ar5y();
    append(status, renderPendingDeletionWarning$lambda(removedTypeCounts));
    var tmp = document.getElementById('confirmDeregistrationButton');
    var tmp_0 = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    tmp_0.addEventListener('click', renderPendingDeletionWarning$lambda_0);
  }
  function ActivitySelectionPageModule$init$lambda(it) {
    get_moduleNavigateTo()(it);
    return Unit_instance;
  }
  function ActivitySelectionPageModule$init$lambda_0(event) {
    var tmp = document.getElementById('activitySelectionCheckboxes');
    var checkboxes = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = event.target;
    filterActivityOptions(checkboxes, (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value);
    return Unit_instance;
  }
  function ActivitySelectionPageModule$init$lambda_1(event) {
    event.preventDefault();
    submitActivitySelection(false);
    return Unit_instance;
  }
  function ActivitySelectionPageModule() {
  }
  protoOf(ActivitySelectionPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    set_pendingRemovedTypeCounts(null);
    set_afterActivitySelectionNavigateTo(ActivitySelectionPageModule$init$lambda);
    var tmp = document.getElementById('activitySearchInput');
    var tmp_0 = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
    tmp_0.addEventListener('input', ActivitySelectionPageModule$init$lambda_0);
    var tmp_1 = document.getElementById('activitySelectionForm');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('submit', ActivitySelectionPageModule$init$lambda_1);
    loadRegisteredActivities();
  };
  var ActivitySelectionPageModule_instance;
  function ActivitySelectionPageModule_getInstance() {
    return ActivitySelectionPageModule_instance;
  }
  function afterActivitySelectionNavigateTo$lambda(it) {
    _init_properties_ActivitySelectionPage_kt__92ar5y();
    return Unit_instance;
  }
  function loadRegisteredActivities$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadRegisteredActivities$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadRegisteredActivities$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadRegisteredActivities$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/my-registered-activities';
            this.i31_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.i31_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtSet), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().da(), arrayOf([]), false))]), false));
            var registered = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var _iterator__ex2g4s = registered.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              l$ret$1: do {
                var tmp_0 = document.getElementById('activity-' + element);
                var tmp0_elvis_lhs = tmp_0 instanceof HTMLInputElement ? tmp_0 : null;
                var tmp_1;
                if (tmp0_elvis_lhs == null) {
                  break l$ret$1;
                } else {
                  tmp_1 = tmp0_elvis_lhs;
                }
                var checkbox = tmp_1;
                checkbox.checked = true;
                var tmp1_safe_receiver = checkbox.closest('.activity-category-card');
                var tmp_2;
                if (tmp1_safe_receiver == null) {
                  tmp_2 = null;
                } else {
                  tmp_2 = tmp1_safe_receiver;
                }
                var tmp2_safe_receiver = tmp_2;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  tmp2_safe_receiver.open = true;
                }
              }
               while (false);
            }

            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_3 = this.w7_1;
            if (tmp_3 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_4 = document.getElementById('activitySelectionStatus');
              var status = tmp_4 instanceof HTMLElement ? tmp_4 : THROW_CCE();
              showError(status, I18n_getInstance().e28('activitySelection.loadErrorPrefix') + e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadRegisteredActivities$slambda).h22 = function ($this$launch, completion) {
    var i = new loadRegisteredActivities$slambda(completion);
    i.h31_1 = $this$launch;
    return i;
  };
  function loadRegisteredActivities$slambda_0(resultContinuation) {
    var i = new loadRegisteredActivities$slambda(resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitActivitySelection$slambda($activityTypes, $confirmedDeletions, $status, resultContinuation) {
    this.r31_1 = $activityTypes;
    this.s31_1 = $confirmedDeletions;
    this.t31_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitActivitySelection$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitActivitySelection$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitActivitySelection$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/my-registered-activities';
            var body = new SetMyRegisteredActivitiesRequest(this.r31_1, this.s31_1);
            this.v31_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(SetMyRegisteredActivitiesRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('PUT', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.v31_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(KtSet), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().da(), arrayOf([]), false))]), false));
            this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            get_afterActivitySelectionNavigateTo()('/discover');
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              if (e.j2c_1 === 422 && !(e.l2c_1 == null)) {
                set_pendingRemovedTypeCounts(e.l2c_1);
                renderPendingDeletionWarning(this.t31_1, e.l2c_1);
              } else {
                showError(this.t31_1, e.k2c_1);
              }
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitActivitySelection$slambda).h22 = function ($this$launch, completion) {
    var i = new submitActivitySelection$slambda(this.r31_1, this.s31_1, this.t31_1, completion);
    i.u31_1 = $this$launch;
    return i;
  };
  function submitActivitySelection$slambda_0($activityTypes, $confirmedDeletions, $status, resultContinuation) {
    var i = new submitActivitySelection$slambda($activityTypes, $confirmedDeletions, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderPendingDeletionWarning$lambda$lambda(it) {
    _init_properties_ActivitySelectionPage_kt__92ar5y();
    return activityTypeLabel(valueOf(it));
  }
  function renderPendingDeletionWarning$lambda($removedTypeCounts) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.div' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new DIV(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new P(attributesMapOf_0('class', null), this_0.j1f());
      this_1.j1f().a1h(this_1);
      var tmp = I18n_getInstance().e28('activitySelection.removeWarningPrefix');
      var tmp_0 = $removedTypeCounts.j2();
      this_1.n1f(tmp + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, renderPendingDeletionWarning$lambda$lambda) + I18n_getInstance().e28('activitySelection.removeWarningMiddle') + sum($removedTypeCounts.k2()) + I18n_getInstance().e28('activitySelection.removeWarningSuffix'));
      this_1.j1f().b1h(this_1);
      // Inline function 'kotlinx.html.button' call
      var tmp_1 = null == null ? null : enumEncode(null);
      var tmp_2 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new BUTTON(attributesMapOf(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_0.j1f());
      this_2.j1f().a1h(this_2);
      this_2.z1j(ButtonType_button_getInstance());
      set_id(this_2, 'confirmDeregistrationButton');
      var tmp0 = this_2.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'activitySelection.confirmDeleteButton';
      tmp0.m2(tmp2, value);
      this_2.n1f(I18n_getInstance().e28('activitySelection.confirmDeleteButton'));
      this_2.j1f().b1h(this_2);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function renderPendingDeletionWarning$lambda_0(it) {
    _init_properties_ActivitySelectionPage_kt__92ar5y();
    submitActivitySelection(true);
    return Unit_instance;
  }
  var properties_initialized_ActivitySelectionPage_kt_v3tkv8;
  function _init_properties_ActivitySelectionPage_kt__92ar5y() {
    if (!properties_initialized_ActivitySelectionPage_kt_v3tkv8) {
      properties_initialized_ActivitySelectionPage_kt_v3tkv8 = true;
      pendingRemovedTypeCounts = null;
      afterActivitySelectionNavigateTo = afterActivitySelectionNavigateTo$lambda;
    }
  }
  function loadAdPricing() {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, loadAdPricing$slambda_0(null));
  }
  function renderSizeRatesTable(rates) {
    var tmp = document.getElementById('adPricingSizeRatesTable');
    var container = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    container.innerHTML = '';
    if (rates.r()) {
      append(container, renderSizeRatesTable$lambda);
      return Unit_instance;
    }
    append(container, renderSizeRatesTable$lambda_0(rates));
  }
  function renderTierSurchargesTable(surcharges) {
    var tmp = document.getElementById('adPricingTierSurchargesTable');
    var container = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    container.innerHTML = '';
    if (surcharges.r()) {
      append(container, renderTierSurchargesTable$lambda);
      return Unit_instance;
    }
    append(container, renderTierSurchargesTable$lambda_0(surcharges));
  }
  function sizeLabel(size) {
    switch (size) {
      case 'LARGE':
        return I18n_getInstance().e28('marketerCampaigns.size.large');
      case 'MEDIUM':
        return I18n_getInstance().e28('marketerCampaigns.size.medium');
      default:
        return I18n_getInstance().e28('marketerCampaigns.size.small');
    }
  }
  function placementLabel(tierKey) {
    return tierKey === 'FEATURED' ? I18n_getInstance().e28('marketerCampaigns.placement.featured') : I18n_getInstance().e28('marketerCampaigns.placement.standard');
  }
  function submitSizeRate() {
    var tmp = document.getElementById('adPricingSizeRateStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var country = countryInputValue('adPricingSizeRateCountry');
    if (country == null) {
      showError(status, I18n_getInstance().e28('adminAdPricing.selectCountryError'));
      return Unit_instance;
    }
    var tmp_0 = document.getElementById('adPricingSize');
    var size = (tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('adPricingSizeRateCostCents');
    var costCents = toLongOrNull((tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value);
    if (costCents == null || compare(costCents, new Long(0, 0)) < 0) {
      showError(status, I18n_getInstance().e28('adminAdPricing.invalidCostError'));
      return Unit_instance;
    }
    var tmp_2 = get_AppScope();
    launch(tmp_2, VOID, VOID, submitSizeRate$slambda_0(country, size, costCents, status, null));
  }
  function AdminAdPricingPageModule$init$lambda(event) {
    event.preventDefault();
    submitSizeRate();
    return Unit_instance;
  }
  function AdminAdPricingPageModule$init$lambda_0(event) {
    event.preventDefault();
    submitTierSurcharge();
    return Unit_instance;
  }
  function AdminAdPricingPageModule() {
  }
  protoOf(AdminAdPricingPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    wireCountryPicker('adPricingSizeRateCountry');
    wireCountryPicker('adPricingTierSurchargeCountry');
    renderCountryOptions('adPricingSizeRateCountry');
    renderCountryOptions('adPricingTierSurchargeCountry');
    var tmp = document.getElementById('adPricingSizeRateForm');
    var tmp_0 = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    tmp_0.addEventListener('submit', AdminAdPricingPageModule$init$lambda);
    var tmp_1 = document.getElementById('adPricingTierSurchargeForm');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('submit', AdminAdPricingPageModule$init$lambda_0);
    loadAdPricing();
  };
  var AdminAdPricingPageModule_instance;
  function AdminAdPricingPageModule_getInstance() {
    return AdminAdPricingPageModule_instance;
  }
  function submitTierSurcharge() {
    var tmp = document.getElementById('adPricingTierSurchargeStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var country = countryInputValue('adPricingTierSurchargeCountry');
    if (country == null) {
      showError(status, I18n_getInstance().e28('adminAdPricing.selectCountryError'));
      return Unit_instance;
    }
    var tmp_0 = document.getElementById('adPricingTierKey');
    var tierKey = (tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('adPricingTierSurchargeCents');
    var surchargeCents = toLongOrNull((tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value);
    if (surchargeCents == null || compare(surchargeCents, new Long(0, 0)) < 0) {
      showError(status, I18n_getInstance().e28('adminAdPricing.invalidCostError'));
      return Unit_instance;
    }
    var tmp_2 = get_AppScope();
    launch(tmp_2, VOID, VOID, submitTierSurcharge$slambda_0(country, tierKey, surchargeCents, status, null));
  }
  function loadAdPricing$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadAdPricing$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadAdPricing$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadAdPricing$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/finance/ad-pricing';
            this.f32_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.f32_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(AdPricingResponse), arrayOf([]), false));
            var result = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            renderSizeRatesTable(result.g2r_1);
            renderTierSurchargesTable(result.h2r_1);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_1 = document.getElementById('adPricingSizeRatesTable');
              showError(tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE(), e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadAdPricing$slambda).h22 = function ($this$launch, completion) {
    var i = new loadAdPricing$slambda(completion);
    i.e32_1 = $this$launch;
    return i;
  };
  function loadAdPricing$slambda_0(resultContinuation) {
    var i = new loadAdPricing$slambda(resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderSizeRatesTable$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'adminAdPricing.noRatesYet';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('adminAdPricing.noRatesYet'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderSizeRatesTable$lambda$lambda(it) {
    return countryDisplayName(it.v2q_1);
  }
  function renderSizeRatesTable$lambda$lambda_0(it) {
    return it.w2q_1;
  }
  function renderSizeRatesTable$lambda_0($rates) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.table' call
      var classes = 'listing-table';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new TABLE(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.tr' call
      var classes_0 = 'listing-table-head-row';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new TR(attributesMapOf_0('class', classes_0), this_0.j1f());
      this_1.j1f().a1h(this_1);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_2.j1f().a1h(this_2);
      var tmp0 = this_2.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'adminAdPricing.countryLabel';
      tmp0.m2(tmp2, value);
      this_2.n1f(I18n_getInstance().e28('adminAdPricing.countryLabel'));
      this_2.j1f().b1h(this_2);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_3.j1f().a1h(this_3);
      var tmp0_0 = this_3.l1f();
      var tmp2_0 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_0 = 'marketerCampaigns.sizeLabel';
      tmp0_0.m2(tmp2_0, value_0);
      this_3.n1f(I18n_getInstance().e28('marketerCampaigns.sizeLabel'));
      this_3.j1f().b1h(this_3);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_4 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_4.j1f().a1h(this_4);
      var tmp0_1 = this_4.l1f();
      var tmp2_1 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_1 = 'adminAdPricing.costCentsLabel';
      tmp0_1.m2(tmp2_1, value_1);
      this_4.n1f(I18n_getInstance().e28('adminAdPricing.costCentsLabel'));
      this_4.j1f().b1h(this_4);
      this_1.j1f().b1h(this_1);
      var tmp = renderSizeRatesTable$lambda$lambda;
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = sortedWith($rates, compareBy([tmp, renderSizeRatesTable$lambda$lambda_0])).t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.tr' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_5 = new TR(attributesMapOf_0('class', null), this_0.j1f());
        this_5.j1f().a1h(this_5);
        // Inline function 'kotlinx.html.td' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_6 = new TD(attributesMapOf_0('class', null), this_5.j1f());
        this_6.j1f().a1h(this_6);
        this_6.n1f(countryDisplayName(element.v2q_1));
        this_6.j1f().b1h(this_6);
        // Inline function 'kotlinx.html.td' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_7 = new TD(attributesMapOf_0('class', null), this_5.j1f());
        this_7.j1f().a1h(this_7);
        this_7.n1f(sizeLabel(element.w2q_1));
        this_7.j1f().b1h(this_7);
        // Inline function 'kotlinx.html.td' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_8 = new TD(attributesMapOf_0('class', null), this_5.j1f());
        this_8.j1f().a1h(this_8);
        this_8.n1f(element.x2q_1.toString());
        this_8.j1f().b1h(this_8);
        this_5.j1f().b1h(this_5);
      }
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function renderTierSurchargesTable$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'adminAdPricing.noSurchargesYet';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('adminAdPricing.noSurchargesYet'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderTierSurchargesTable$lambda$lambda(it) {
    return countryDisplayName(it.a2r_1);
  }
  function renderTierSurchargesTable$lambda$lambda_0(it) {
    return it.b2r_1;
  }
  function renderTierSurchargesTable$lambda_0($surcharges) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.table' call
      var classes = 'listing-table';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new TABLE(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.tr' call
      var classes_0 = 'listing-table-head-row';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new TR(attributesMapOf_0('class', classes_0), this_0.j1f());
      this_1.j1f().a1h(this_1);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_2.j1f().a1h(this_2);
      var tmp0 = this_2.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'adminAdPricing.countryLabel';
      tmp0.m2(tmp2, value);
      this_2.n1f(I18n_getInstance().e28('adminAdPricing.countryLabel'));
      this_2.j1f().b1h(this_2);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_3.j1f().a1h(this_3);
      var tmp0_0 = this_3.l1f();
      var tmp2_0 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_0 = 'marketerCampaigns.placementLabel';
      tmp0_0.m2(tmp2_0, value_0);
      this_3.n1f(I18n_getInstance().e28('marketerCampaigns.placementLabel'));
      this_3.j1f().b1h(this_3);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_4 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_4.j1f().a1h(this_4);
      var tmp0_1 = this_4.l1f();
      var tmp2_1 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_1 = 'adminAdPricing.surchargeCentsLabel';
      tmp0_1.m2(tmp2_1, value_1);
      this_4.n1f(I18n_getInstance().e28('adminAdPricing.surchargeCentsLabel'));
      this_4.j1f().b1h(this_4);
      this_1.j1f().b1h(this_1);
      var tmp = renderTierSurchargesTable$lambda$lambda;
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = sortedWith($surcharges, compareBy([tmp, renderTierSurchargesTable$lambda$lambda_0])).t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.tr' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_5 = new TR(attributesMapOf_0('class', null), this_0.j1f());
        this_5.j1f().a1h(this_5);
        // Inline function 'kotlinx.html.td' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_6 = new TD(attributesMapOf_0('class', null), this_5.j1f());
        this_6.j1f().a1h(this_6);
        this_6.n1f(countryDisplayName(element.a2r_1));
        this_6.j1f().b1h(this_6);
        // Inline function 'kotlinx.html.td' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_7 = new TD(attributesMapOf_0('class', null), this_5.j1f());
        this_7.j1f().a1h(this_7);
        this_7.n1f(placementLabel(element.b2r_1));
        this_7.j1f().b1h(this_7);
        // Inline function 'kotlinx.html.td' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_8 = new TD(attributesMapOf_0('class', null), this_5.j1f());
        this_8.j1f().a1h(this_8);
        this_8.n1f(element.c2r_1.toString());
        this_8.j1f().b1h(this_8);
        this_5.j1f().b1h(this_5);
      }
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function submitSizeRate$slambda($country, $size, $costCents, $status, resultContinuation) {
    this.o32_1 = $country;
    this.p32_1 = $size;
    this.q32_1 = $costCents;
    this.r32_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitSizeRate$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitSizeRate$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitSizeRate$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/finance/ad-pricing/size-rates';
            var body = new SetAdSizeRateRequest(this.o32_1, this.p32_1, this.q32_1);
            this.t32_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(SetAdSizeRateRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('PUT', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.t32_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(AdSizeRateResponse), arrayOf([]), false));
            this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            loadAdPricing();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.r32_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.r32_1, I18n_getInstance().e28('adminAdPricing.genericErrorPrefix') + e_0.message);
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitSizeRate$slambda).h22 = function ($this$launch, completion) {
    var i = new submitSizeRate$slambda(this.o32_1, this.p32_1, this.q32_1, this.r32_1, completion);
    i.s32_1 = $this$launch;
    return i;
  };
  function submitSizeRate$slambda_0($country, $size, $costCents, $status, resultContinuation) {
    var i = new submitSizeRate$slambda($country, $size, $costCents, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitTierSurcharge$slambda($country, $tierKey, $surchargeCents, $status, resultContinuation) {
    this.c33_1 = $country;
    this.d33_1 = $tierKey;
    this.e33_1 = $surchargeCents;
    this.f33_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitTierSurcharge$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitTierSurcharge$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitTierSurcharge$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/finance/ad-pricing/tier-surcharges';
            var body = new SetAdTierSurchargeRequest(this.c33_1, this.d33_1, this.e33_1);
            this.h33_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(SetAdTierSurchargeRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('PUT', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.h33_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(AdTierSurchargeResponse), arrayOf([]), false));
            this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            loadAdPricing();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.f33_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.f33_1, I18n_getInstance().e28('adminAdPricing.genericErrorPrefix') + e_0.message);
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitTierSurcharge$slambda).h22 = function ($this$launch, completion) {
    var i = new submitTierSurcharge$slambda(this.c33_1, this.d33_1, this.e33_1, this.f33_1, completion);
    i.g33_1 = $this$launch;
    return i;
  };
  function submitTierSurcharge$slambda_0($country, $tierKey, $surchargeCents, $status, resultContinuation) {
    var i = new submitTierSurcharge$slambda($country, $tierKey, $surchargeCents, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  var currentPage;
  var currentCompanyType;
  var editingCompanyId;
  function loadAdminCompanyCountries() {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, loadAdminCompanyCountries$slambda_0(null));
  }
  function loadAdminCompanies() {
    var tmp = document.getElementById('adminCompaniesStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    status.textContent = I18n_getInstance().e28('adminCompanies.loadingLabel');
    var tmp_0 = document.getElementById('adminCompaniesQuery');
    // Inline function 'kotlin.text.ifBlank' call
    var this_0 = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1;
    if (isBlank(this_0)) {
      tmp_1 = null;
    } else {
      tmp_1 = this_0;
    }
    var query = tmp_1;
    var country = countryInputValue('adminCompaniesCountry');
    var companyType = currentCompanyType;
    var tmp_2 = document.getElementById('adminCompaniesIncludeInactive');
    var includeInactive = (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).checked;
    var tmp_3 = get_AppScope();
    launch(tmp_3, VOID, VOID, loadAdminCompanies$slambda_0(query, country, includeInactive, companyType, status, null));
  }
  function renderAdminCompaniesResults(result) {
    var tmp = document.getElementById('adminCompaniesResults');
    var container = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    container.innerHTML = '';
    if (result.y2u_1.r()) {
      append(container, renderAdminCompaniesResults$lambda);
      return Unit_instance;
    }
    append(container, renderAdminCompaniesResults$lambda_0(result));
  }
  function companyRow(_this__u8e3s4, company) {
    // Inline function 'kotlinx.html.tr' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new TR(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_1.j1f().a1h(this_1);
    this_1.n1f(company.u2t_1);
    if (!company.f2u_1) {
      // Inline function 'kotlinx.html.span' call
      var classes = 'badge badge-rejected';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new SPAN(attributesMapOf_0('class', classes), this_1.j1f());
      this_2.j1f().a1h(this_2);
      var tmp0 = this_2.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'adminCompanies.inactiveBadge';
      tmp0.m2(tmp2, value);
      this_2.n1f(I18n_getInstance().e28('adminCompanies.inactiveBadge'));
      this_2.j1f().b1h(this_2);
    }
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_3.j1f().a1h(this_3);
    this_3.n1f(company.v2t_1);
    this_3.j1f().b1h(this_3);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_4 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_4.j1f().a1h(this_4);
    this_4.n1f(company.w2t_1);
    this_4.j1f().b1h(this_4);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_5 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_5.j1f().a1h(this_5);
    var tmp0_safe_receiver = company.e2u_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = countryDisplayName(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    this_5.n1f(tmp1_elvis_lhs == null ? I18n_getInstance().e28('adminCompanies.unknownCountry') : tmp1_elvis_lhs);
    this_5.j1f().b1h(this_5);
    // Inline function 'kotlinx.html.td' call
    var classes_0 = 'table-row-actions';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_6 = new TD(attributesMapOf_0('class', classes_0), this_0.j1f());
    this_6.j1f().a1h(this_6);
    // Inline function 'kotlinx.html.button' call
    var classes_1 = 'icon-button';
    var tmp_0 = null == null ? null : enumEncode(null);
    var tmp_1 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_7 = new BUTTON(attributesMapOf(['formenctype', tmp_0, 'formmethod', tmp_1, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_1]), this_6.j1f());
    this_7.j1f().a1h(this_7);
    var tmp0_0 = this_7.l1f();
    // Inline function 'kotlin.collections.set' call
    var value_0 = I18n_getInstance().e28('adminCompanies.editButton');
    tmp0_0.m2('title', value_0);
    var tmp0_1 = this_7.l1f();
    var tmp2_0 = 'aria-label';
    // Inline function 'kotlin.collections.set' call
    var value_1 = I18n_getInstance().e28('adminCompanies.editButton');
    tmp0_1.m2(tmp2_0, value_1);
    set_onClickFunction(this_7, companyRow$lambda(company));
    uiIcon(this_7, 'edit');
    this_7.j1f().b1h(this_7);
    if (company.f2u_1) {
      // Inline function 'kotlinx.html.button' call
      var classes_2 = 'icon-button icon-button-danger';
      var tmp_2 = null == null ? null : enumEncode(null);
      var tmp_3 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_8 = new BUTTON(attributesMapOf(['formenctype', tmp_2, 'formmethod', tmp_3, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_2]), this_6.j1f());
      this_8.j1f().a1h(this_8);
      var tmp0_2 = this_8.l1f();
      // Inline function 'kotlin.collections.set' call
      var value_2 = I18n_getInstance().e28('adminCompanies.deleteButton');
      tmp0_2.m2('title', value_2);
      var tmp0_3 = this_8.l1f();
      var tmp2_1 = 'aria-label';
      // Inline function 'kotlin.collections.set' call
      var value_3 = I18n_getInstance().e28('adminCompanies.deleteButton');
      tmp0_3.m2(tmp2_1, value_3);
      set_onClickFunction(this_8, companyRow$lambda_0(company));
      uiIcon(this_8, 'delete');
      this_8.j1f().b1h(this_8);
    }
    this_6.j1f().b1h(this_6);
    this_0.j1f().b1h(this_0);
  }
  function renderAdminCompaniesPagination(result) {
    var tmp = document.getElementById('adminCompaniesPagination');
    var container = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    container.innerHTML = '';
    append(container, renderAdminCompaniesPagination$lambda(result));
  }
  function changeAdminCompaniesPage(delta) {
    currentPage = currentPage + delta | 0;
    loadAdminCompanies();
  }
  function startEditingCompany(company) {
    editingCompanyId = company.r2t_1;
    var tmp = document.getElementById('companyFormHeading');
    (tmp instanceof HTMLElement ? tmp : THROW_CCE()).textContent = I18n_getInstance().e28('adminCompanies.editModalHeadingPrefix') + '"' + company.u2t_1 + '"';
    var tmp_0 = document.getElementById('companyName');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = company.u2t_1;
    var tmp_1 = document.getElementById('companyFiscalId');
    (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value = company.v2t_1;
    var tmp_2 = document.getElementById('companyEmail');
    (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value = company.w2t_1;
    var tmp_3 = document.getElementById('companyPhone');
    (tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).value = company.x2t_1;
    var tmp_4 = document.getElementById('companyAddress');
    (tmp_4 instanceof HTMLInputElement ? tmp_4 : THROW_CCE()).value = company.y2t_1;
    var tmp_5 = document.getElementById('companyWebsite');
    var tmp_6 = tmp_5 instanceof HTMLInputElement ? tmp_5 : THROW_CCE();
    var tmp0_elvis_lhs = company.z2t_1;
    tmp_6.value = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    setCountryInputValue('companyCountry', company.e2u_1);
    var tmp_7 = document.getElementById('companyActive');
    (tmp_7 instanceof HTMLInputElement ? tmp_7 : THROW_CCE()).checked = company.f2u_1;
    var tmp_8 = document.getElementById('companyModal');
    (tmp_8 instanceof HTMLDialogElement ? tmp_8 : THROW_CCE()).showModal();
  }
  function resetCompanyForm() {
    editingCompanyId = null;
    var tmp = document.getElementById('companyFormHeading');
    (tmp instanceof HTMLElement ? tmp : THROW_CCE()).textContent = I18n_getInstance().e28('adminCompanies.editModalDefaultHeading');
    var tmp_0 = document.getElementById('companyName');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = '';
    var tmp_1 = document.getElementById('companyFiscalId');
    (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value = '';
    var tmp_2 = document.getElementById('companyEmail');
    (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value = '';
    var tmp_3 = document.getElementById('companyPhone');
    (tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).value = '';
    var tmp_4 = document.getElementById('companyAddress');
    (tmp_4 instanceof HTMLInputElement ? tmp_4 : THROW_CCE()).value = '';
    var tmp_5 = document.getElementById('companyWebsite');
    (tmp_5 instanceof HTMLInputElement ? tmp_5 : THROW_CCE()).value = '';
    var tmp_6 = document.getElementById('companyCountry');
    (tmp_6 instanceof HTMLInputElement ? tmp_6 : THROW_CCE()).value = '';
    var tmp_7 = document.getElementById('companyActive');
    (tmp_7 instanceof HTMLInputElement ? tmp_7 : THROW_CCE()).checked = true;
    var tmp_8 = document.getElementById('companyStatus');
    clearStatus(tmp_8 instanceof HTMLElement ? tmp_8 : THROW_CCE());
  }
  function submitCompanyForm() {
    var tmp = document.getElementById('companyStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp0_elvis_lhs = editingCompanyId;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var companyId = tmp_0;
    var tmp_1 = document.getElementById('companyName');
    var name = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    var tmp_2 = document.getElementById('companyFiscalId');
    var fiscalId = (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value;
    var tmp_3 = document.getElementById('companyEmail');
    var email = (tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).value;
    var tmp_4 = document.getElementById('companyPhone');
    var phone = (tmp_4 instanceof HTMLInputElement ? tmp_4 : THROW_CCE()).value;
    var tmp_5 = document.getElementById('companyAddress');
    var address = (tmp_5 instanceof HTMLInputElement ? tmp_5 : THROW_CCE()).value;
    var tmp_6 = document.getElementById('companyWebsite');
    // Inline function 'kotlin.text.ifBlank' call
    var this_0 = (tmp_6 instanceof HTMLInputElement ? tmp_6 : THROW_CCE()).value;
    var tmp_7;
    if (isBlank(this_0)) {
      tmp_7 = null;
    } else {
      tmp_7 = this_0;
    }
    var website = tmp_7;
    var country = countryInputValue('companyCountry');
    var tmp_8 = document.getElementById('companyActive');
    var active = (tmp_8 instanceof HTMLInputElement ? tmp_8 : THROW_CCE()).checked;
    var tmp_9 = get_AppScope();
    launch(tmp_9, VOID, VOID, submitCompanyForm$slambda_0(companyId, name, fiscalId, email, phone, address, website, country, active, status, null));
  }
  function removeCompany(company) {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, removeCompany$slambda_0(company, null));
  }
  function initAdminCompaniesPage(companyType) {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    currentPage = 1;
    currentCompanyType = companyType;
    editingCompanyId = null;
    var tmp = document.getElementById('companyModal');
    var companyModal = tmp instanceof HTMLDialogElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('cancelCompanyModalButton');
    var tmp_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    tmp_1.addEventListener('click', initAdminCompaniesPage$lambda(companyModal));
    companyModal.addEventListener('close', initAdminCompaniesPage$lambda_0);
    var tmp_2 = document.getElementById('companyForm');
    var tmp_3 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
    tmp_3.addEventListener('submit', initAdminCompaniesPage$lambda_1);
    var tmp_4 = document.getElementById('adminCompaniesSearchForm');
    var tmp_5 = tmp_4 instanceof HTMLElement ? tmp_4 : THROW_CCE();
    tmp_5.addEventListener('submit', initAdminCompaniesPage$lambda_2);
    var tmp_6 = document.getElementById('adminCompaniesIncludeInactive');
    var tmp_7 = tmp_6 instanceof HTMLElement ? tmp_6 : THROW_CCE();
    tmp_7.addEventListener('change', initAdminCompaniesPage$lambda_3);
    wireCountryPicker('companyCountry');
    wireCountryPicker('adminCompaniesCountry');
    renderCountryOptions('companyCountry');
    loadAdminCompanyCountries();
    loadAdminCompanies();
  }
  function ActivityCentersPageModule() {
  }
  protoOf(ActivityCentersPageModule).r28 = function () {
    return initAdminCompaniesPage('ACTIVITY_CENTER');
  };
  var ActivityCentersPageModule_instance;
  function ActivityCentersPageModule_getInstance() {
    return ActivityCentersPageModule_instance;
  }
  function CertificationIssuersPageModule() {
  }
  protoOf(CertificationIssuersPageModule).r28 = function () {
    return initAdminCompaniesPage('CERTIFICATION_ISSUER');
  };
  var CertificationIssuersPageModule_instance;
  function CertificationIssuersPageModule_getInstance() {
    return CertificationIssuersPageModule_instance;
  }
  function MarketersPageModule() {
  }
  protoOf(MarketersPageModule).r28 = function () {
    return initAdminCompaniesPage('MARKETER');
  };
  var MarketersPageModule_instance;
  function MarketersPageModule_getInstance() {
    return MarketersPageModule_instance;
  }
  function loadAdminCompanyCountries$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadAdminCompanyCountries$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadAdminCompanyCountries$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadAdminCompanyCountries$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/members/company-countries';
            this.s33_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.s33_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().da(), arrayOf([]), false))]), false));
            tmp_0.r33_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.r33_1 = emptyList();
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var countries = this.r33_1;
            renderCountryOptions('adminCompaniesCountry', countries);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadAdminCompanyCountries$slambda).h22 = function ($this$launch, completion) {
    var i = new loadAdminCompanyCountries$slambda(completion);
    i.q33_1 = $this$launch;
    return i;
  };
  function loadAdminCompanyCountries$slambda_0(resultContinuation) {
    var i = new loadAdminCompanyCountries$slambda(resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function loadAdminCompanies$slambda($query, $country, $includeInactive, $companyType, $status, resultContinuation) {
    this.b34_1 = $query;
    this.c34_1 = $country;
    this.d34_1 = $includeInactive;
    this.e34_1 = $companyType;
    this.f34_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadAdminCompanies$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadAdminCompanies$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadAdminCompanies$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0_safe_receiver = this.b34_1;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = '&query=' + encodeURIComponent(tmp0_safe_receiver);
            }

            var tmp1_elvis_lhs = tmp_0;
            var queryParam = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
            var tmp2_safe_receiver = this.c34_1;
            var tmp_1;
            if (tmp2_safe_receiver == null) {
              tmp_1 = null;
            } else {
              tmp_1 = '&country=' + encodeURIComponent(tmp2_safe_receiver);
            }

            var tmp3_elvis_lhs = tmp_1;
            var countryParam = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
            var includeInactiveParam = this.d34_1 ? '&includeInactive=true' : '';
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/members/companies?page=' + currentPage + '&pageSize=25&type=' + this.e34_1 + queryParam + countryParam + includeInactiveParam;
            this.h34_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.h34_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(PagedCompaniesResponse), arrayOf([]), false));
            var result = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.f34_1.textContent = '';
            renderAdminCompaniesResults(result);
            renderAdminCompaniesPagination(result);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_2 = this.w7_1;
            if (tmp_2 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.f34_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_3 = this.w7_1;
              if (tmp_3 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.f34_1, I18n_getInstance().e28('adminCompanies.loadErrorPrefix') + e_0.message);
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(loadAdminCompanies$slambda).h22 = function ($this$launch, completion) {
    var i = new loadAdminCompanies$slambda(this.b34_1, this.c34_1, this.d34_1, this.e34_1, this.f34_1, completion);
    i.g34_1 = $this$launch;
    return i;
  };
  function loadAdminCompanies$slambda_0($query, $country, $includeInactive, $companyType, $status, resultContinuation) {
    var i = new loadAdminCompanies$slambda($query, $country, $includeInactive, $companyType, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderAdminCompaniesResults$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'adminCompanies.noCompaniesFound';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('adminCompanies.noCompaniesFound'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderAdminCompaniesResults$lambda_0($result) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.table' call
      var classes = 'listing-table';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new TABLE(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.tr' call
      var classes_0 = 'listing-table-head-row';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new TR(attributesMapOf_0('class', classes_0), this_0.j1f());
      this_1.j1f().a1h(this_1);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_2.j1f().a1h(this_2);
      var tmp0 = this_2.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'adminCompanies.nameColumn';
      tmp0.m2(tmp2, value);
      this_2.n1f(I18n_getInstance().e28('adminCompanies.nameColumn'));
      this_2.j1f().b1h(this_2);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_3.j1f().a1h(this_3);
      var tmp0_0 = this_3.l1f();
      var tmp2_0 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_0 = 'adminCompanies.fiscalIdColumn';
      tmp0_0.m2(tmp2_0, value_0);
      this_3.n1f(I18n_getInstance().e28('adminCompanies.fiscalIdColumn'));
      this_3.j1f().b1h(this_3);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_4 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_4.j1f().a1h(this_4);
      var tmp0_1 = this_4.l1f();
      var tmp2_1 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_1 = 'adminCompanies.emailColumn';
      tmp0_1.m2(tmp2_1, value_1);
      this_4.n1f(I18n_getInstance().e28('adminCompanies.emailColumn'));
      this_4.j1f().b1h(this_4);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_5 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_5.j1f().a1h(this_5);
      var tmp0_2 = this_5.l1f();
      var tmp2_2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_2 = 'adminCompanies.countryColumn';
      tmp0_2.m2(tmp2_2, value_2);
      this_5.n1f(I18n_getInstance().e28('adminCompanies.countryColumn'));
      this_5.j1f().b1h(this_5);
      // Inline function 'kotlinx.html.th' call
      var classes_1 = 'table-row-actions';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_6 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', classes_1]), this_1.j1f());
      this_6.j1f().a1h(this_6);
      var tmp0_3 = this_6.l1f();
      var tmp2_3 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_3 = 'adminCompanies.actionsColumn';
      tmp0_3.m2(tmp2_3, value_3);
      this_6.n1f(I18n_getInstance().e28('adminCompanies.actionsColumn'));
      this_6.j1f().b1h(this_6);
      this_1.j1f().b1h(this_1);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $result.y2u_1.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        companyRow(this_0, element);
      }
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function companyRow$lambda($company) {
    return function (it) {
      startEditingCompany($company);
      return Unit_instance;
    };
  }
  function companyRow$lambda$lambda($company) {
    return function () {
      removeCompany($company);
      return Unit_instance;
    };
  }
  function companyRow$lambda_0($company) {
    return function (it) {
      var tmp = I18n_getInstance().e28('adminCompanies.deleteConfirmPrefix') + $company.u2t_1 + I18n_getInstance().e28('adminCompanies.deleteConfirmSuffix');
      requestConfirmation('deleteCompanyConfirm', tmp, companyRow$lambda$lambda($company));
      return Unit_instance;
    };
  }
  function renderAdminCompaniesPagination$lambda$lambda(delta) {
    changeAdminCompaniesPage(delta);
    return Unit_instance;
  }
  function renderAdminCompaniesPagination$lambda($result) {
    return function ($this$append) {
      var tmp = currentPage;
      pagination($this$append, 'adminCompanies', tmp, $result.z2u_1, $result.b2v_1, renderAdminCompaniesPagination$lambda$lambda);
      return Unit_instance;
    };
  }
  function submitCompanyForm$slambda($companyId, $name, $fiscalId, $email, $phone, $address, $website, $country, $active, $status, resultContinuation) {
    this.q34_1 = $companyId;
    this.r34_1 = $name;
    this.s34_1 = $fiscalId;
    this.t34_1 = $email;
    this.u34_1 = $phone;
    this.v34_1 = $address;
    this.w34_1 = $website;
    this.x34_1 = $country;
    this.y34_1 = $active;
    this.z34_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitCompanyForm$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitCompanyForm$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitCompanyForm$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/members/companies/' + this.q34_1;
            var body = new UpdateCompanyAdminRequest(this.r34_1, this.s34_1, this.t34_1, this.u34_1, this.v34_1, this.w34_1, this.x34_1, this.y34_1);
            this.b35_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(UpdateCompanyAdminRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('PUT', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.b35_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(CompanyResponse), arrayOf([]), false));
            this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            this.z34_1.textContent = I18n_getInstance().e28('adminCompanies.updatedStatus');
            loadAdminCompanies();
            var tmp_0 = document.getElementById('companyModal');
            (tmp_0 instanceof HTMLDialogElement ? tmp_0 : THROW_CCE()).close();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.z34_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitCompanyForm$slambda).h22 = function ($this$launch, completion) {
    var i = new submitCompanyForm$slambda(this.q34_1, this.r34_1, this.s34_1, this.t34_1, this.u34_1, this.v34_1, this.w34_1, this.x34_1, this.y34_1, this.z34_1, completion);
    i.a35_1 = $this$launch;
    return i;
  };
  function submitCompanyForm$slambda_0($companyId, $name, $fiscalId, $email, $phone, $address, $website, $country, $active, $status, resultContinuation) {
    var i = new submitCompanyForm$slambda($companyId, $name, $fiscalId, $email, $phone, $address, $website, $country, $active, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function removeCompany$slambda($company, resultContinuation) {
    this.k35_1 = $company;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(removeCompany$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(removeCompany$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(removeCompany$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = ApiClient_getInstance().a2x('/api/v1/members/companies/' + this.k35_1.r2t_1, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            loadAdminCompanies();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_1 = document.getElementById('adminCompaniesStatus');
              showError(tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE(), I18n_getInstance().e28('adminCompanies.removeErrorPrefix') + e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(removeCompany$slambda).h22 = function ($this$launch, completion) {
    var i = new removeCompany$slambda(this.k35_1, completion);
    i.l35_1 = $this$launch;
    return i;
  };
  function removeCompany$slambda_0($company, resultContinuation) {
    var i = new removeCompany$slambda($company, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function initAdminCompaniesPage$lambda($companyModal) {
    return function (it) {
      $companyModal.close();
      return Unit_instance;
    };
  }
  function initAdminCompaniesPage$lambda_0(it) {
    resetCompanyForm();
    return Unit_instance;
  }
  function initAdminCompaniesPage$lambda_1(event) {
    event.preventDefault();
    submitCompanyForm();
    return Unit_instance;
  }
  function initAdminCompaniesPage$lambda_2(event) {
    event.preventDefault();
    currentPage = 1;
    loadAdminCompanies();
    return Unit_instance;
  }
  function initAdminCompaniesPage$lambda_3(it) {
    currentPage = 1;
    loadAdminCompanies();
    return Unit_instance;
  }
  function set_currentPage(_set____db54di) {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    currentPage_0 = _set____db54di;
  }
  function get_currentPage() {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    return currentPage_0;
  }
  var currentPage_0;
  function get_ASSIGNABLE_ROLES() {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    return ASSIGNABLE_ROLES;
  }
  var ASSIGNABLE_ROLES;
  function set_editingUserId(_set____db54di) {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    editingUserId = _set____db54di;
  }
  function get_editingUserId() {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    return editingUserId;
  }
  var editingUserId;
  function loadAdminUsers() {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    var tmp = document.getElementById('adminUsersStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    status.textContent = 'Loading\u2026';
    var tmp_0 = document.getElementById('adminUsersQuery');
    // Inline function 'kotlin.text.ifBlank' call
    var this_0 = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1;
    if (isBlank(this_0)) {
      tmp_1 = null;
    } else {
      tmp_1 = this_0;
    }
    var query = tmp_1;
    var tmp_2 = document.getElementById('adminUsersIncludeInactive');
    var includeInactive = (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).checked;
    var tmp_3 = get_AppScope();
    launch(tmp_3, VOID, VOID, loadAdminUsers$slambda_0(query, includeInactive, status, null));
  }
  function renderAdminUsersResults(result) {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    var tmp = document.getElementById('adminUsersResults');
    var container = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    container.innerHTML = '';
    if (result.r2f_1.r()) {
      append(container, renderAdminUsersResults$lambda);
      return Unit_instance;
    }
    append(container, renderAdminUsersResults$lambda_0(result));
  }
  function userRow(_this__u8e3s4, user) {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    // Inline function 'kotlinx.html.tr' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new TR(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_1.j1f().a1h(this_1);
    this_1.n1f(user.j2f_1);
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_2.j1f().a1h(this_2);
    this_2.n1f(user.i2f_1);
    this_2.j1f().b1h(this_2);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_3.j1f().a1h(this_3);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = user.k2f_1.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlinx.html.span' call
      var classes = 'badge badge-role';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_4 = new SPAN(attributesMapOf_0('class', classes), this_3.j1f());
      this_4.j1f().a1h(this_4);
      this_4.n1f(element);
      this_4.j1f().b1h(this_4);
    }
    this_3.j1f().b1h(this_3);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_5 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_5.j1f().a1h(this_5);
    statusBadge(this_5, user);
    this_5.j1f().b1h(this_5);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_6 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_6.j1f().a1h(this_6);
    this_6.n1f(substringBefore(user.n2f_1, 'T'));
    this_6.j1f().b1h(this_6);
    // Inline function 'kotlinx.html.td' call
    var classes_0 = 'table-row-actions';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_7 = new TD(attributesMapOf_0('class', classes_0), this_0.j1f());
    this_7.j1f().a1h(this_7);
    // Inline function 'kotlinx.html.button' call
    var classes_1 = 'icon-button';
    var tmp = null == null ? null : enumEncode(null);
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_8 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_1]), this_7.j1f());
    this_8.j1f().a1h(this_8);
    // Inline function 'kotlin.collections.set' call
    this_8.l1f().m2('title', 'Edit');
    var tmp0 = this_8.l1f();
    // Inline function 'kotlin.collections.set' call
    var key = 'aria-label';
    tmp0.m2(key, 'Edit');
    set_onClickFunction(this_8, userRow$lambda(user));
    uiIcon(this_8, 'edit');
    this_8.j1f().b1h(this_8);
    if (user.l2f_1) {
      // Inline function 'kotlinx.html.button' call
      var classes_2 = 'icon-button icon-button-danger';
      var tmp_1 = null == null ? null : enumEncode(null);
      var tmp_2 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_9 = new BUTTON(attributesMapOf(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_2]), this_7.j1f());
      this_9.j1f().a1h(this_9);
      // Inline function 'kotlin.collections.set' call
      this_9.l1f().m2('title', 'Delete');
      var tmp0_0 = this_9.l1f();
      // Inline function 'kotlin.collections.set' call
      var key_0 = 'aria-label';
      tmp0_0.m2(key_0, 'Delete');
      set_onClickFunction(this_9, userRow$lambda_0(user));
      uiIcon(this_9, 'delete');
      this_9.j1f().b1h(this_9);
    }
    this_7.j1f().b1h(this_7);
    this_0.j1f().b1h(this_0);
  }
  function statusBadge(_this__u8e3s4, user) {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    var _destruct__k2r9zo = !user.l2f_1 ? to('Disabled', 'badge-rejected') : !user.m2f_1 ? to('Unverified', 'badge-pending') : to('Active', 'badge-verified');
    var label = _destruct__k2r9zo.g9();
    var modifier = _destruct__k2r9zo.h9();
    // Inline function 'kotlinx.html.span' call
    var classes = 'badge ' + modifier;
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new SPAN(attributesMapOf_0('class', classes), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    this_0.n1f(label);
    this_0.j1f().b1h(this_0);
  }
  function renderAdminUsersPagination(result) {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    var tmp = document.getElementById('adminUsersPagination');
    var container = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    container.innerHTML = '';
    append(container, renderAdminUsersPagination$lambda(result));
  }
  function changeAdminUsersPage(delta) {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    set_currentPage(get_currentPage() + delta | 0);
    loadAdminUsers();
  }
  function startEditingUser(user) {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    set_editingUserId(user.h2f_1);
    var tmp = document.getElementById('userFormHeading');
    (tmp instanceof HTMLElement ? tmp : THROW_CCE()).textContent = 'Edit "' + user.j2f_1 + '"';
    var tmp_0 = document.getElementById('userDisplayName');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = user.j2f_1;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = get_ASSIGNABLE_ROLES().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp_1 = document.getElementById('userRole-' + element);
      (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).checked = user.k2f_1.c2(element);
    }
    var tmp_2 = document.getElementById('userActive');
    (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).checked = user.l2f_1;
    var tmp_3 = document.getElementById('userModal');
    (tmp_3 instanceof HTMLDialogElement ? tmp_3 : THROW_CCE()).showModal();
  }
  function resetUserForm() {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    set_editingUserId(null);
    var tmp = document.getElementById('userFormHeading');
    (tmp instanceof HTMLElement ? tmp : THROW_CCE()).textContent = 'Edit user';
    var tmp_0 = document.getElementById('userDisplayName');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = '';
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = get_ASSIGNABLE_ROLES().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp_1 = document.getElementById('userRole-' + element);
      (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).checked = false;
    }
    var tmp_2 = document.getElementById('userActive');
    (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).checked = true;
    var tmp_3 = document.getElementById('userStatus');
    clearStatus(tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE());
  }
  function submitUserForm() {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    var tmp = document.getElementById('userStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp0_elvis_lhs = get_editingUserId();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var userId = tmp_0;
    var tmp_1 = document.getElementById('userDisplayName');
    var displayName = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_ASSIGNABLE_ROLES();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp_2 = document.getElementById('userRole-' + element);
      if ((tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).checked) {
        destination.x(element);
      }
    }
    var roles = toSet(destination);
    var tmp_3 = document.getElementById('userActive');
    var active = (tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).checked;
    var tmp_4 = get_AppScope();
    launch(tmp_4, VOID, VOID, submitUserForm$slambda_0(userId, displayName, roles, active, status, null));
  }
  function removeUser(user) {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, removeUser$slambda_0(user, null));
  }
  function AdminUsersPageModule$init$lambda($userModal) {
    return function (it) {
      $userModal.close();
      return Unit_instance;
    };
  }
  function AdminUsersPageModule$init$lambda_0(it) {
    resetUserForm();
    return Unit_instance;
  }
  function AdminUsersPageModule$init$lambda_1(event) {
    event.preventDefault();
    submitUserForm();
    return Unit_instance;
  }
  function AdminUsersPageModule$init$lambda_2(event) {
    event.preventDefault();
    set_currentPage(1);
    loadAdminUsers();
    return Unit_instance;
  }
  function AdminUsersPageModule() {
  }
  protoOf(AdminUsersPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    set_currentPage(1);
    set_editingUserId(null);
    var tmp = document.getElementById('userModal');
    var userModal = tmp instanceof HTMLDialogElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('cancelUserModalButton');
    var tmp_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    tmp_1.addEventListener('click', AdminUsersPageModule$init$lambda(userModal));
    userModal.addEventListener('close', AdminUsersPageModule$init$lambda_0);
    var tmp_2 = document.getElementById('userForm');
    var tmp_3 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
    tmp_3.addEventListener('submit', AdminUsersPageModule$init$lambda_1);
    var tmp_4 = document.getElementById('adminUsersSearchForm');
    var tmp_5 = tmp_4 instanceof HTMLElement ? tmp_4 : THROW_CCE();
    tmp_5.addEventListener('submit', AdminUsersPageModule$init$lambda_2);
    loadAdminUsers();
  };
  var AdminUsersPageModule_instance;
  function AdminUsersPageModule_getInstance() {
    return AdminUsersPageModule_instance;
  }
  function loadAdminUsers$slambda($query, $includeInactive, $status, resultContinuation) {
    this.u35_1 = $query;
    this.v35_1 = $includeInactive;
    this.w35_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadAdminUsers$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadAdminUsers$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadAdminUsers$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0_safe_receiver = this.u35_1;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = '&query=' + encodeURIComponent(tmp0_safe_receiver);
            }

            var tmp1_elvis_lhs = tmp_0;
            var queryParam = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
            var includeInactiveParam = this.v35_1 ? '&includeInactive=true' : '';
            var tmp0 = ApiClient_getInstance();
            var path = '/api/auth/users?page=' + get_currentPage() + '&pageSize=25' + queryParam + includeInactiveParam;
            this.y35_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.y35_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(PagedUsersResponse), arrayOf([]), false));
            var result = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.w35_1.textContent = '';
            renderAdminUsersResults(result);
            renderAdminUsersPagination(result);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.w35_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_2 = this.w7_1;
              if (tmp_2 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.w35_1, 'Could not load users: ' + e_0.message);
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(loadAdminUsers$slambda).h22 = function ($this$launch, completion) {
    var i = new loadAdminUsers$slambda(this.u35_1, this.v35_1, this.w35_1, completion);
    i.x35_1 = $this$launch;
    return i;
  };
  function loadAdminUsers$slambda_0($query, $includeInactive, $status, resultContinuation) {
    var i = new loadAdminUsers$slambda($query, $includeInactive, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderAdminUsersResults$lambda($this$append) {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    this_0.n1f('No users found.');
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderAdminUsersResults$lambda_0($result) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.table' call
      var classes = 'listing-table';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new TABLE(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.tr' call
      var classes_0 = 'listing-table-head-row';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new TR(attributesMapOf_0('class', classes_0), this_0.j1f());
      this_1.j1f().a1h(this_1);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_2.j1f().a1h(this_2);
      this_2.n1f('Name');
      this_2.j1f().b1h(this_2);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_3.j1f().a1h(this_3);
      this_3.n1f('Email');
      this_3.j1f().b1h(this_3);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_4 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_4.j1f().a1h(this_4);
      this_4.n1f('Roles');
      this_4.j1f().b1h(this_4);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_5 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_5.j1f().a1h(this_5);
      this_5.n1f('Status');
      this_5.j1f().b1h(this_5);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_6 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_6.j1f().a1h(this_6);
      this_6.n1f('Joined');
      this_6.j1f().b1h(this_6);
      // Inline function 'kotlinx.html.th' call
      var classes_1 = 'table-row-actions';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_7 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', classes_1]), this_1.j1f());
      this_7.j1f().a1h(this_7);
      this_7.n1f('Actions');
      this_7.j1f().b1h(this_7);
      this_1.j1f().b1h(this_1);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $result.r2f_1.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        userRow(this_0, element);
      }
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function userRow$lambda($user) {
    return function (it) {
      startEditingUser($user);
      return Unit_instance;
    };
  }
  function userRow$lambda$lambda($user) {
    return function () {
      removeUser($user);
      return Unit_instance;
    };
  }
  function userRow$lambda_0($user) {
    return function (it) {
      var tmp = 'Delete ' + $user.j2f_1 + '? Their account will be disabled but can be reactivated later.';
      requestConfirmation('deleteUserConfirm', tmp, userRow$lambda$lambda($user));
      return Unit_instance;
    };
  }
  function renderAdminUsersPagination$lambda$lambda(delta) {
    _init_properties_AdminUsersPage_kt__6p5ugo();
    changeAdminUsersPage(delta);
    return Unit_instance;
  }
  function renderAdminUsersPagination$lambda($result) {
    return function ($this$append) {
      var tmp = get_currentPage();
      pagination($this$append, 'adminUsers', tmp, $result.s2f_1, $result.u2f_1, renderAdminUsersPagination$lambda$lambda);
      return Unit_instance;
    };
  }
  function submitUserForm$slambda($userId, $displayName, $roles, $active, $status, resultContinuation) {
    this.h36_1 = $userId;
    this.i36_1 = $displayName;
    this.j36_1 = $roles;
    this.k36_1 = $active;
    this.l36_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitUserForm$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitUserForm$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitUserForm$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/auth/users/' + this.h36_1;
            var body = new UpdateUserAdminRequest(this.i36_1, this.j36_1, this.k36_1);
            this.n36_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(UpdateUserAdminRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('PUT', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.n36_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(UserAdminResponse), arrayOf([]), false));
            this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            this.l36_1.textContent = 'Updated.';
            loadAdminUsers();
            var tmp_0 = document.getElementById('userModal');
            (tmp_0 instanceof HTMLDialogElement ? tmp_0 : THROW_CCE()).close();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.l36_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitUserForm$slambda).h22 = function ($this$launch, completion) {
    var i = new submitUserForm$slambda(this.h36_1, this.i36_1, this.j36_1, this.k36_1, this.l36_1, completion);
    i.m36_1 = $this$launch;
    return i;
  };
  function submitUserForm$slambda_0($userId, $displayName, $roles, $active, $status, resultContinuation) {
    var i = new submitUserForm$slambda($userId, $displayName, $roles, $active, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function removeUser$slambda($user, resultContinuation) {
    this.w36_1 = $user;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(removeUser$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(removeUser$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(removeUser$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = ApiClient_getInstance().a2x('/api/auth/users/' + this.w36_1.h2f_1, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            loadAdminUsers();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_1 = document.getElementById('adminUsersStatus');
              showError(tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE(), 'Could not remove: ' + e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(removeUser$slambda).h22 = function ($this$launch, completion) {
    var i = new removeUser$slambda(this.w36_1, completion);
    i.x36_1 = $this$launch;
    return i;
  };
  function removeUser$slambda_0($user, resultContinuation) {
    var i = new removeUser$slambda($user, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  var properties_initialized_AdminUsersPage_kt_wsyega;
  function _init_properties_AdminUsersPage_kt__6p5ugo() {
    if (!properties_initialized_AdminUsersPage_kt_wsyega) {
      properties_initialized_AdminUsersPage_kt_wsyega = true;
      currentPage_0 = 1;
      ASSIGNABLE_ROLES = listOf(['SUPER_ADMIN', 'ADMIN', 'USER']);
      editingUserId = null;
    }
  }
  function authMethodPicker(_this__u8e3s4) {
    // Inline function 'kotlinx.html.div' call
    var classes = 'auth-method-picker';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new DIV(attributesMapOf_0('class', classes), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new P(attributesMapOf_0('class', null), this_0.j1f());
    this_1.j1f().a1h(this_1);
    this_1.n1f('How should this account sign in?');
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.div' call
    var classes_0 = 'auth-method-options';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new DIV(attributesMapOf_0('class', classes_0), this_0.j1f());
    this_2.j1f().a1h(this_2);
    authMethodOption(this_2, 'authMethodPasskey', 'Passkey', 'Face ID, Touch ID, or a security key \u2014 recommended, nothing to type or leak', true);
    authMethodOption(this_2, 'authMethodPassword', 'Password', 'Sign in with an email and password instead', false);
    this_2.j1f().b1h(this_2);
    // Inline function 'kotlinx.html.div' call
    var classes_1 = 'field-warning';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new DIV(attributesMapOf_0('class', classes_1), this_0.j1f());
    this_3.j1f().a1h(this_3);
    set_id(this_3, 'authMethodWarning');
    this_3.j1f().b1h(this_3);
    // Inline function 'kotlinx.html.div' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_4 = new DIV(attributesMapOf_0('class', null), this_0.j1f());
    this_4.j1f().a1h(this_4);
    set_id(this_4, 'authPasswordField');
    set_classes(this_4, setOf(['hidden', 'auth-password-fields']));
    // Inline function 'kotlinx.html.label' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_5 = new LABEL(attributesMapOf_0('class', null), this_4.j1f());
    this_5.j1f().a1h(this_5);
    this_5.n1f('Password');
    // Inline function 'kotlinx.html.div' call
    var classes_2 = 'password-field-row';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_6 = new DIV(attributesMapOf_0('class', classes_2), this_5.j1f());
    this_6.j1f().a1h(this_6);
    // Inline function 'kotlinx.html.passwordInput' call
    var tmp = InputType_password_getInstance().q1i_1;
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_7 = new INPUT(attributesMapOf(['type', tmp, 'formenctype', tmp_0, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_6.j1f());
    this_7.j1f().a1h(this_7);
    set_id(this_7, 'authPasswordInput');
    set_onInputFunction(this_7, authMethodPicker$lambda);
    this_7.j1f().b1h(this_7);
    passwordVisibilityToggle(this_6);
    this_6.j1f().b1h(this_6);
    this_5.j1f().b1h(this_5);
    // Inline function 'kotlinx.html.label' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_8 = new LABEL(attributesMapOf_0('class', null), this_4.j1f());
    this_8.j1f().a1h(this_8);
    this_8.n1f('Confirm password');
    // Inline function 'kotlinx.html.passwordInput' call
    var tmp_1 = InputType_password_getInstance().q1i_1;
    var tmp_2 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_9 = new INPUT(attributesMapOf(['type', tmp_1, 'formenctype', tmp_2, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_8.j1f());
    this_9.j1f().a1h(this_9);
    set_id(this_9, 'authPasswordConfirmInput');
    set_onInputFunction(this_9, authMethodPicker$lambda_0);
    this_9.j1f().b1h(this_9);
    this_8.j1f().b1h(this_8);
    // Inline function 'kotlinx.html.div' call
    var classes_3 = 'field-warning';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_10 = new DIV(attributesMapOf_0('class', classes_3), this_4.j1f());
    this_10.j1f().a1h(this_10);
    set_id(this_10, 'authPasswordMismatchWarning');
    this_10.j1f().b1h(this_10);
    this_4.j1f().b1h(this_4);
    this_0.j1f().b1h(this_0);
  }
  function authMethodOption(_this__u8e3s4, id, title, description, active) {
    var tmp5 = ButtonType_button_getInstance();
    // Inline function 'kotlinx.html.button' call
    var classes = 'auth-method-option' + (active ? ' active' : '');
    var tmp = null == null ? null : enumEncode(null);
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', tmp5 == null ? null : enumEncode(tmp5), 'class', classes]), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    set_id(this_0, id);
    var tmp0 = this_0.l1f();
    var tmp2 = 'aria-pressed';
    // Inline function 'kotlin.collections.set' call
    var value = active.toString();
    tmp0.m2(tmp2, value);
    set_onClickFunction(this_0, authMethodOption$lambda(id));
    // Inline function 'kotlinx.html.span' call
    var classes_0 = 'auth-method-option-title';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new SPAN(attributesMapOf_0('class', classes_0), this_0.j1f());
    this_1.j1f().a1h(this_1);
    this_1.n1f(title);
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.span' call
    var classes_1 = 'auth-method-option-desc';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new SPAN(attributesMapOf_0('class', classes_1), this_0.j1f());
    this_2.j1f().a1h(this_2);
    this_2.n1f(description);
    this_2.j1f().b1h(this_2);
    this_0.j1f().b1h(this_0);
  }
  function passwordVisibilityToggle(_this__u8e3s4) {
    var tmp5 = ButtonType_button_getInstance();
    // Inline function 'kotlinx.html.button' call
    var classes = 'password-visibility-toggle';
    var tmp = null == null ? null : enumEncode(null);
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', tmp5 == null ? null : enumEncode(tmp5), 'class', classes]), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    set_id(this_0, 'authPasswordVisibilityToggle');
    var tmp0 = this_0.l1f();
    // Inline function 'kotlin.collections.set' call
    var key = 'aria-pressed';
    tmp0.m2(key, 'false');
    var tmp0_0 = this_0.l1f();
    var tmp2 = 'aria-label';
    // Inline function 'kotlin.collections.set' call
    var value = 'Show password';
    tmp0_0.m2(tmp2, value);
    set_onClickFunction(this_0, passwordVisibilityToggle$lambda);
    uiIcon(this_0, 'eye');
    this_0.j1f().b1h(this_0);
  }
  function toggleAuthMethod(optionId) {
    setAuthMethodActive(optionId, !isAuthMethodActive(optionId));
    enforceAtLeastOneAuthMethod(optionId);
    setAuthPasswordFieldVisible(isPasswordSelected());
  }
  function isAuthMethodActive(optionId) {
    var tmp = document.getElementById(optionId);
    return (tmp instanceof HTMLButtonElement ? tmp : THROW_CCE()).classList.contains('active');
  }
  function setAuthMethodActive(optionId, active) {
    var tmp = document.getElementById(optionId);
    var button = tmp instanceof HTMLButtonElement ? tmp : THROW_CCE();
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', active.toString());
  }
  function isPasskeySelected() {
    return isAuthMethodActive('authMethodPasskey');
  }
  function isPasswordSelected() {
    return isAuthMethodActive('authMethodPassword');
  }
  function enforceAtLeastOneAuthMethod(justChangedId) {
    var tmp = document.getElementById('authMethodWarning');
    var warning = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    if (!isPasskeySelected() && !isPasswordSelected()) {
      setAuthMethodActive(justChangedId, true);
      warning.textContent = 'Choose at least one sign-in method.';
    } else {
      warning.textContent = '';
    }
  }
  function wireAuthMethodPicker() {
    var tmp = document.getElementById('authMethodPasskey');
    var tmp_0 = tmp instanceof HTMLButtonElement ? tmp : THROW_CCE();
    tmp_0.addEventListener('click', wireAuthMethodPicker$lambda);
    var tmp_1 = document.getElementById('authMethodPassword');
    var tmp_2 = tmp_1 instanceof HTMLButtonElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('click', wireAuthMethodPicker$lambda_0);
    var tmp_3 = document.getElementById('authPasswordVisibilityToggle');
    var tmp_4 = tmp_3 instanceof HTMLButtonElement ? tmp_3 : THROW_CCE();
    tmp_4.addEventListener('click', wireAuthMethodPicker$lambda_1);
    var tmp_5 = document.getElementById('authPasswordInput');
    var tmp_6 = tmp_5 instanceof HTMLInputElement ? tmp_5 : THROW_CCE();
    tmp_6.addEventListener('input', wireAuthMethodPicker$lambda_2);
    var tmp_7 = document.getElementById('authPasswordConfirmInput');
    var tmp_8 = tmp_7 instanceof HTMLInputElement ? tmp_7 : THROW_CCE();
    tmp_8.addEventListener('input', wireAuthMethodPicker$lambda_3);
  }
  function wantsPasskey() {
    return isPasskeySelected();
  }
  function attachPasskeyIfSelected($completion) {
    var tmp = new $attachPasskeyIfSelectedCOROUTINE$($completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function selectedPassword() {
    if (!isPasswordSelected())
      return null;
    var tmp = document.getElementById('authPasswordInput');
    return (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value;
  }
  function authMethodValidationError() {
    if (!isPasswordSelected())
      return null;
    var tmp = document.getElementById('authPasswordInput');
    var password = (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value;
    var tmp_0 = document.getElementById('authPasswordConfirmInput');
    var confirm = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    return !(password === confirm) ? "Passwords don't match." : null;
  }
  function updatePasswordMismatchWarning() {
    var tmp = document.getElementById('authPasswordMismatchWarning');
    var warning = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('authPasswordInput');
    var password = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('authPasswordConfirmInput');
    var confirm = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    var tmp_2;
    var tmp_3;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(confirm) > 0) {
      tmp_3 = !(password === confirm);
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = "Passwords don't match.";
    } else {
      tmp_2 = '';
    }
    warning.textContent = tmp_2;
  }
  function togglePasswordVisibility() {
    var tmp = document.getElementById('authPasswordVisibilityToggle');
    var toggle = tmp instanceof HTMLButtonElement ? tmp : THROW_CCE();
    var show = !(toggle.getAttribute('aria-pressed') === 'true');
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = listOf(['authPasswordInput', 'authPasswordConfirmInput']).t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp_0 = document.getElementById(element);
      (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).type = show ? 'text' : 'password';
    }
    toggle.setAttribute('aria-pressed', show.toString());
    toggle.innerHTML = '';
    append(toggle, togglePasswordVisibility$lambda(show));
  }
  function setAuthPasswordFieldVisible(visible) {
    var tmp = document.getElementById('authPasswordField');
    var field = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('authPasswordInput');
    var input = tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE();
    var tmp_1 = document.getElementById('authPasswordConfirmInput');
    var confirm = tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE();
    field.classList.toggle('hidden', !visible);
    input.required = visible;
    confirm.required = visible;
  }
  function authMethodPicker$lambda(it) {
    updatePasswordMismatchWarning();
    return Unit_instance;
  }
  function authMethodPicker$lambda_0(it) {
    updatePasswordMismatchWarning();
    return Unit_instance;
  }
  function authMethodOption$lambda($id) {
    return function (it) {
      toggleAuthMethod($id);
      return Unit_instance;
    };
  }
  function passwordVisibilityToggle$lambda(it) {
    togglePasswordVisibility();
    return Unit_instance;
  }
  function wireAuthMethodPicker$lambda(it) {
    toggleAuthMethod('authMethodPasskey');
    return Unit_instance;
  }
  function wireAuthMethodPicker$lambda_0(it) {
    toggleAuthMethod('authMethodPassword');
    return Unit_instance;
  }
  function wireAuthMethodPicker$lambda_1(it) {
    togglePasswordVisibility();
    return Unit_instance;
  }
  function wireAuthMethodPicker$lambda_2(it) {
    updatePasswordMismatchWarning();
    return Unit_instance;
  }
  function wireAuthMethodPicker$lambda_3(it) {
    updatePasswordMismatchWarning();
    return Unit_instance;
  }
  function togglePasswordVisibility$lambda($show) {
    return function ($this$append) {
      uiIcon_0($this$append, $show ? 'eye-off' : 'eye');
      return Unit_instance;
    };
  }
  function $attachPasskeyIfSelectedCOROUTINE$(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($attachPasskeyIfSelectedCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            if (!wantsPasskey())
              return Unit_instance;
            this.u7_1 = 2;
            this.h37_1 = Companion_instance;
            this.t7_1 = 1;
            suspendResult = attachPasskeyToCurrentAccount(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            this.h37_1;
            tmp_0.g37_1 = _Result___init__impl__xyqfz8(Unit_instance);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.g37_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  function set_editingCertificationTypeId(_set____db54di) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    editingCertificationTypeId = _set____db54di;
  }
  function get_editingCertificationTypeId() {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    return editingCertificationTypeId;
  }
  var editingCertificationTypeId;
  function set_loadedAuthorities(_set____db54di) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    loadedAuthorities = _set____db54di;
  }
  function get_loadedAuthorities() {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    return loadedAuthorities;
  }
  var loadedAuthorities;
  function set_loadedCertificationTypes(_set____db54di) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    loadedCertificationTypes = _set____db54di;
  }
  function get_loadedCertificationTypes() {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    return loadedCertificationTypes;
  }
  var loadedCertificationTypes;
  function loadAuthorities() {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    var tmp = document.getElementById('authorityLoadStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadAuthorities$slambda_0(status, null));
  }
  function renderAuthorityOptions(authorities) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    var tmp = document.getElementById('issuingAuthorityOptions');
    var dataListEl = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    dataListEl.innerHTML = '';
    append(dataListEl, renderAuthorityOptions$lambda(authorities));
  }
  function resetAuthorityForm() {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    var tmp = document.getElementById('authorityName');
    (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value = '';
    var tmp_0 = document.getElementById('authorityCountry');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = '';
    var tmp_1 = document.getElementById('authorityWebsite');
    (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value = '';
    var tmp_2 = document.getElementById('authorityStatus');
    clearStatus(tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE());
  }
  function submitNewAuthority() {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    var tmp = document.getElementById('authorityStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('authorityName');
    var name = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var country = countryInputValue('authorityCountry');
    var tmp_1 = document.getElementById('authorityWebsite');
    // Inline function 'kotlin.text.ifBlank' call
    var this_0 = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    var tmp_2;
    if (isBlank(this_0)) {
      tmp_2 = null;
    } else {
      tmp_2 = this_0;
    }
    var website = tmp_2;
    var tmp_3 = get_AppScope();
    launch(tmp_3, VOID, VOID, submitNewAuthority$slambda_0(name, country, website, status, null));
  }
  function loadCertificationTypes() {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    var tmp = document.getElementById('certificationList');
    var listEl = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('certificationTypesIncludeInactive');
    var includeInactive = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).checked;
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, loadCertificationTypes$slambda_0(includeInactive, listEl, null));
  }
  function applyCertificationFilters() {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    var tmp = document.getElementById('certificationList');
    var listEl = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('certificationTypesQuery');
    // Inline function 'kotlin.text.trim' call
    var this_0 = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var query = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())).toLowerCase();
    var tmp_1;
    if (isBlank(query)) {
      tmp_1 = get_loadedCertificationTypes();
    } else {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = get_loadedCertificationTypes();
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var tmp_2;
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$6 = element.v2n_1.toLowerCase();
        if (contains(tmp$ret$6, query)) {
          tmp_2 = true;
        } else {
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$8 = authorityName(element.u2n_1).toLowerCase();
          tmp_2 = contains(tmp$ret$8, query);
        }
        if (tmp_2) {
          destination.x(element);
        }
      }
      tmp_1 = destination;
    }
    var filtered = tmp_1;
    var tmp_3;
    if (filtered.r()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_3 = !get_loadedCertificationTypes().r();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      listEl.innerHTML = '';
      append(listEl, applyCertificationFilters$lambda);
    } else {
      renderCertificationList(listEl, filtered);
    }
  }
  function renderCertificationList(listEl, certTypes) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    listEl.innerHTML = '';
    if (certTypes.r()) {
      append(listEl, renderCertificationList$lambda);
      return Unit_instance;
    }
    append(listEl, renderCertificationList$lambda_0(certTypes));
  }
  function certificationRow(_this__u8e3s4, certType) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    // Inline function 'kotlinx.html.tr' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new TR(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_1.j1f().a1h(this_1);
    this_1.n1f(certType.v2n_1);
    if (!certType.x2n_1) {
      // Inline function 'kotlinx.html.span' call
      var classes = 'badge badge-rejected';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new SPAN(attributesMapOf_0('class', classes), this_1.j1f());
      this_2.j1f().a1h(this_2);
      var tmp0 = this_2.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'certificationTypes.inactiveBadge';
      tmp0.m2(tmp2, value);
      this_2.n1f(I18n_getInstance().e28('certificationTypes.inactiveBadge'));
      this_2.j1f().b1h(this_2);
    }
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_3.j1f().a1h(this_3);
    this_3.n1f(authorityName(certType.u2n_1));
    this_3.j1f().b1h(this_3);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_4 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_4.j1f().a1h(this_4);
    this_4.n1f(joinToString(certType.w2n_1, ', ', VOID, VOID, VOID, VOID, certificationRow$lambda));
    this_4.j1f().b1h(this_4);
    // Inline function 'kotlinx.html.td' call
    var classes_0 = 'table-row-actions';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_5 = new TD(attributesMapOf_0('class', classes_0), this_0.j1f());
    this_5.j1f().a1h(this_5);
    // Inline function 'kotlinx.html.button' call
    var classes_1 = 'icon-button';
    var tmp = null == null ? null : enumEncode(null);
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_6 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_1]), this_5.j1f());
    this_6.j1f().a1h(this_6);
    var tmp0_0 = this_6.l1f();
    // Inline function 'kotlin.collections.set' call
    var value_0 = I18n_getInstance().e28('certificationTypes.editButton');
    tmp0_0.m2('title', value_0);
    var tmp0_1 = this_6.l1f();
    var tmp2_0 = 'aria-label';
    // Inline function 'kotlin.collections.set' call
    var value_1 = I18n_getInstance().e28('certificationTypes.editButton');
    tmp0_1.m2(tmp2_0, value_1);
    set_onClickFunction(this_6, certificationRow$lambda_0(certType));
    uiIcon(this_6, 'edit');
    this_6.j1f().b1h(this_6);
    if (certType.x2n_1) {
      // Inline function 'kotlinx.html.button' call
      var classes_2 = 'icon-button icon-button-danger';
      var tmp_1 = null == null ? null : enumEncode(null);
      var tmp_2 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_7 = new BUTTON(attributesMapOf(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_2]), this_5.j1f());
      this_7.j1f().a1h(this_7);
      var tmp0_2 = this_7.l1f();
      // Inline function 'kotlin.collections.set' call
      var value_2 = I18n_getInstance().e28('certificationTypes.removeButton');
      tmp0_2.m2('title', value_2);
      var tmp0_3 = this_7.l1f();
      var tmp2_1 = 'aria-label';
      // Inline function 'kotlin.collections.set' call
      var value_3 = I18n_getInstance().e28('certificationTypes.removeButton');
      tmp0_3.m2(tmp2_1, value_3);
      set_onClickFunction(this_7, certificationRow$lambda_1(certType));
      uiIcon(this_7, 'delete');
      this_7.j1f().b1h(this_7);
    }
    this_5.j1f().b1h(this_5);
    this_0.j1f().b1h(this_0);
  }
  function authorityName(issuingAuthorityId) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    var tmp0 = get_loadedAuthorities();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.z2m_1 === issuingAuthorityId) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var tmp0_safe_receiver = tmp$ret$0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a2n_1;
    return tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
  }
  function removeCertificationType(certType) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, removeCertificationType$slambda_0(certType, null));
  }
  function startEditingCertification(certType) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    set_editingCertificationTypeId(certType.t2n_1);
    var tmp = document.getElementById('certificationFormHeading');
    (tmp instanceof HTMLElement ? tmp : THROW_CCE()).textContent = I18n_getInstance().e28('certificationTypes.editCertificationPrefix') + '"' + certType.v2n_1 + '"';
    var tmp_0 = document.getElementById('certificationName');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = certType.v2n_1;
    var tmp_1 = document.getElementById('certificationAuthorityInput');
    var tmp_2 = tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE();
    var tmp0 = get_loadedAuthorities();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.z2m_1 === certType.u2n_1) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    var tmp0_safe_receiver = tmp$ret$0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a2n_1;
    tmp_2.value = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    setActivityTypeSelection('activity-validated', certType.w2n_1);
    var tmp_3 = document.getElementById('certificationActive');
    (tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).checked = certType.x2n_1;
    var tmp_4 = document.getElementById('certificationModal');
    (tmp_4 instanceof HTMLDialogElement ? tmp_4 : THROW_CCE()).showModal();
  }
  function resetCertificationForm() {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    set_editingCertificationTypeId(null);
    var tmp = document.getElementById('certificationFormHeading');
    (tmp instanceof HTMLElement ? tmp : THROW_CCE()).textContent = I18n_getInstance().e28('certificationTypes.newCertificationHeading');
    var tmp_0 = document.getElementById('certificationName');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = '';
    var tmp_1 = document.getElementById('certificationAuthorityInput');
    (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value = '';
    var tmp_2 = document.getElementById('certificationStatus');
    clearStatus(tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE());
    setActivityTypeSelection('activity-validated', emptySet());
    var tmp_3 = document.getElementById('certificationActive');
    (tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).checked = true;
  }
  function submitCertificationForm() {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    var tmp = document.getElementById('certificationStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('certificationName');
    var name = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('certificationAuthorityInput');
    // Inline function 'kotlin.text.trim' call
    var this_0 = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    var authorityName = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    var tmp0 = get_loadedAuthorities();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.a2n_1 === authorityName) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    var authorityId = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z2m_1;
    var validatedActivityTypes = selectedActivityTypes('activity-validated');
    var tmp_2 = document.getElementById('certificationActive');
    var active = (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).checked;
    if (validatedActivityTypes.r()) {
      showError(status, I18n_getInstance().e28('certificationTypes.selectAtLeastOneActivityError'));
      return Unit_instance;
    }
    if (authorityId == null) {
      showError(status, I18n_getInstance().e28('certificationTypes.unknownAuthorityError'));
      return Unit_instance;
    }
    var currentEditId = get_editingCertificationTypeId();
    var tmp_3 = get_AppScope();
    launch(tmp_3, VOID, VOID, submitCertificationForm$slambda_0(currentEditId, authorityId, name, validatedActivityTypes, status, active, null));
  }
  function CertificationTypesPageModule$init$lambda($authorityModal) {
    return function (it) {
      $authorityModal.showModal();
      return Unit_instance;
    };
  }
  function CertificationTypesPageModule$init$lambda_0($authorityModal) {
    return function (it) {
      $authorityModal.close();
      return Unit_instance;
    };
  }
  function CertificationTypesPageModule$init$lambda_1(it) {
    resetAuthorityForm();
    return Unit_instance;
  }
  function CertificationTypesPageModule$init$lambda_2($certificationModal) {
    return function (it) {
      resetCertificationForm();
      $certificationModal.showModal();
      return Unit_instance;
    };
  }
  function CertificationTypesPageModule$init$lambda_3($certificationModal) {
    return function (it) {
      $certificationModal.close();
      return Unit_instance;
    };
  }
  function CertificationTypesPageModule$init$lambda_4(it) {
    resetCertificationForm();
    return Unit_instance;
  }
  function CertificationTypesPageModule$init$lambda_5(event) {
    event.preventDefault();
    submitNewAuthority();
    return Unit_instance;
  }
  function CertificationTypesPageModule$init$lambda_6(event) {
    event.preventDefault();
    submitCertificationForm();
    return Unit_instance;
  }
  function CertificationTypesPageModule$init$lambda_7(it) {
    loadCertificationTypes();
    return Unit_instance;
  }
  function CertificationTypesPageModule$init$lambda_8(event) {
    event.preventDefault();
    return Unit_instance;
  }
  function CertificationTypesPageModule$init$lambda_9(it) {
    applyCertificationFilters();
    return Unit_instance;
  }
  function CertificationTypesPageModule$init$lambda_10(event) {
    var tmp = document.getElementById('validatedActivityCheckboxes');
    var checkboxes = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = event.target;
    filterActivityOptions(checkboxes, (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value);
    return Unit_instance;
  }
  function CertificationTypesPageModule() {
  }
  protoOf(CertificationTypesPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    set_editingCertificationTypeId(null);
    var tmp = document.getElementById('authorityModal');
    var authorityModal = tmp instanceof HTMLDialogElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('certificationModal');
    var certificationModal = tmp_0 instanceof HTMLDialogElement ? tmp_0 : THROW_CCE();
    var tmp_1 = document.getElementById('openAuthorityModalButton');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('click', CertificationTypesPageModule$init$lambda(authorityModal));
    var tmp_3 = document.getElementById('cancelAuthorityModalButton');
    var tmp_4 = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
    tmp_4.addEventListener('click', CertificationTypesPageModule$init$lambda_0(authorityModal));
    authorityModal.addEventListener('close', CertificationTypesPageModule$init$lambda_1);
    var tmp_5 = document.getElementById('openCertificationModalButton');
    var tmp_6 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
    tmp_6.addEventListener('click', CertificationTypesPageModule$init$lambda_2(certificationModal));
    var tmp_7 = document.getElementById('cancelCertificationModalButton');
    var tmp_8 = tmp_7 instanceof HTMLElement ? tmp_7 : THROW_CCE();
    tmp_8.addEventListener('click', CertificationTypesPageModule$init$lambda_3(certificationModal));
    certificationModal.addEventListener('close', CertificationTypesPageModule$init$lambda_4);
    var tmp_9 = document.getElementById('authorityForm');
    var tmp_10 = tmp_9 instanceof HTMLElement ? tmp_9 : THROW_CCE();
    tmp_10.addEventListener('submit', CertificationTypesPageModule$init$lambda_5);
    var tmp_11 = document.getElementById('certificationForm');
    var tmp_12 = tmp_11 instanceof HTMLElement ? tmp_11 : THROW_CCE();
    tmp_12.addEventListener('submit', CertificationTypesPageModule$init$lambda_6);
    var tmp_13 = document.getElementById('certificationTypesIncludeInactive');
    var tmp_14 = tmp_13 instanceof HTMLElement ? tmp_13 : THROW_CCE();
    tmp_14.addEventListener('change', CertificationTypesPageModule$init$lambda_7);
    var tmp_15 = document.getElementById('certificationTypesFilterForm');
    var tmp_16 = tmp_15 instanceof HTMLElement ? tmp_15 : THROW_CCE();
    tmp_16.addEventListener('submit', CertificationTypesPageModule$init$lambda_8);
    var tmp_17 = document.getElementById('certificationTypesQuery');
    var tmp_18 = tmp_17 instanceof HTMLElement ? tmp_17 : THROW_CCE();
    tmp_18.addEventListener('input', CertificationTypesPageModule$init$lambda_9);
    var tmp_19 = document.getElementById('validatedActivitySearchInput');
    var tmp_20 = tmp_19 instanceof HTMLElement ? tmp_19 : THROW_CCE();
    tmp_20.addEventListener('input', CertificationTypesPageModule$init$lambda_10);
    wireCountryPicker('authorityCountry');
    renderCountryOptions('authorityCountry');
    loadAuthorities();
    loadCertificationTypes();
  };
  var CertificationTypesPageModule_instance;
  function CertificationTypesPageModule_getInstance() {
    return CertificationTypesPageModule_instance;
  }
  function loadAuthorities$slambda($status, resultContinuation) {
    this.q37_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadAuthorities$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadAuthorities$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadAuthorities$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/issuing-authorities';
            this.s37_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.s37_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(IssuingAuthorityResponse), arrayOf([]), false))]), false));
            var authorities = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            set_loadedAuthorities(authorities);
            this.q37_1.textContent = '';
            renderAuthorityOptions(authorities);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.q37_1, I18n_getInstance().e28('certificationTypes.loadAuthoritiesErrorPrefix') + e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadAuthorities$slambda).h22 = function ($this$launch, completion) {
    var i = new loadAuthorities$slambda(this.q37_1, completion);
    i.r37_1 = $this$launch;
    return i;
  };
  function loadAuthorities$slambda_0($status, resultContinuation) {
    var i = new loadAuthorities$slambda($status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderAuthorityOptions$lambda($authorities) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $authorities.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.option' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new OPTION(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        this_0.d1m(element.a2n_1);
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function submitNewAuthority$slambda($name, $country, $website, $status, resultContinuation) {
    this.b38_1 = $name;
    this.c38_1 = $country;
    this.d38_1 = $website;
    this.e38_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitNewAuthority$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitNewAuthority$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitNewAuthority$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/issuing-authorities';
            var body = new RegisterIssuingAuthorityRequest(this.b38_1, this.c38_1, this.d38_1);
            this.g38_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(RegisterIssuingAuthorityRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.g38_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(IssuingAuthorityResponse), arrayOf([]), false));
            this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            this.e38_1.textContent = I18n_getInstance().e28('certificationTypes.authorityAddedStatus');
            loadAuthorities();
            var tmp_0 = document.getElementById('authorityModal');
            (tmp_0 instanceof HTMLDialogElement ? tmp_0 : THROW_CCE()).close();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.e38_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitNewAuthority$slambda).h22 = function ($this$launch, completion) {
    var i = new submitNewAuthority$slambda(this.b38_1, this.c38_1, this.d38_1, this.e38_1, completion);
    i.f38_1 = $this$launch;
    return i;
  };
  function submitNewAuthority$slambda_0($name, $country, $website, $status, resultContinuation) {
    var i = new submitNewAuthority$slambda($name, $country, $website, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function loadCertificationTypes$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('certificationTypes.loadCertificationsErrorPrefix') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadCertificationTypes$slambda($includeInactive, $listEl, resultContinuation) {
    this.p38_1 = $includeInactive;
    this.q38_1 = $listEl;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadCertificationTypes$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadCertificationTypes$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadCertificationTypes$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var includeInactiveParam = this.p38_1 ? '?includeInactive=true' : '';
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/certification-types' + includeInactiveParam;
            this.t38_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.t38_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CertificationTypeResponse), arrayOf([]), false))]), false));
            var certTypes = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            set_loadedCertificationTypes(certTypes);
            var tmp_0 = this;
            applyCertificationFilters();
            tmp_0.s38_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.q38_1.innerHTML = '';
              tmp_2.s38_1 = append(this.q38_1, loadCertificationTypes$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadCertificationTypes$slambda).h22 = function ($this$launch, completion) {
    var i = new loadCertificationTypes$slambda(this.p38_1, this.q38_1, completion);
    i.r38_1 = $this$launch;
    return i;
  };
  function loadCertificationTypes$slambda_0($includeInactive, $listEl, resultContinuation) {
    var i = new loadCertificationTypes$slambda($includeInactive, $listEl, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function applyCertificationFilters$lambda($this$append) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'certificationTypes.noMatchingCertifications';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('certificationTypes.noMatchingCertifications'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderCertificationList$lambda($this$append) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    this_0.n1f(I18n_getInstance().e28('certificationTypes.noCertificationsYet'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderCertificationList$lambda_0($certTypes) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.table' call
      var classes = 'listing-table';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new TABLE(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.tr' call
      var classes_0 = 'listing-table-head-row';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new TR(attributesMapOf_0('class', classes_0), this_0.j1f());
      this_1.j1f().a1h(this_1);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_2.j1f().a1h(this_2);
      var tmp0 = this_2.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'certificationTypes.nameColumn';
      tmp0.m2(tmp2, value);
      this_2.n1f(I18n_getInstance().e28('certificationTypes.nameColumn'));
      this_2.j1f().b1h(this_2);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_3.j1f().a1h(this_3);
      var tmp0_0 = this_3.l1f();
      var tmp2_0 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_0 = 'certificationTypes.issuingAuthorityColumn';
      tmp0_0.m2(tmp2_0, value_0);
      this_3.n1f(I18n_getInstance().e28('certificationTypes.issuingAuthorityColumn'));
      this_3.j1f().b1h(this_3);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_4 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_4.j1f().a1h(this_4);
      var tmp0_1 = this_4.l1f();
      var tmp2_1 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_1 = 'certificationTypes.validatesColumn';
      tmp0_1.m2(tmp2_1, value_1);
      this_4.n1f(I18n_getInstance().e28('certificationTypes.validatesColumn'));
      this_4.j1f().b1h(this_4);
      // Inline function 'kotlinx.html.th' call
      var classes_1 = 'table-row-actions';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_5 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', classes_1]), this_1.j1f());
      this_5.j1f().a1h(this_5);
      var tmp0_2 = this_5.l1f();
      var tmp2_2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_2 = 'certificationTypes.actionsColumn';
      tmp0_2.m2(tmp2_2, value_2);
      this_5.n1f(I18n_getInstance().e28('certificationTypes.actionsColumn'));
      this_5.j1f().b1h(this_5);
      this_1.j1f().b1h(this_1);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $certTypes.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        certificationRow(this_0, element);
      }
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function certificationRow$lambda(it) {
    _init_properties_CertificationTypesPage_kt__uibkb6();
    return activityTypeLabel(it);
  }
  function certificationRow$lambda_0($certType) {
    return function (it) {
      startEditingCertification($certType);
      return Unit_instance;
    };
  }
  function certificationRow$lambda$lambda($certType) {
    return function () {
      removeCertificationType($certType);
      return Unit_instance;
    };
  }
  function certificationRow$lambda_1($certType) {
    return function (it) {
      var tmp = I18n_getInstance().e28('certificationTypes.deleteConfirmPrefix') + '"' + $certType.v2n_1 + '"' + I18n_getInstance().e28('certificationTypes.deleteConfirmSuffix');
      requestConfirmation('deleteCertificationConfirm', tmp, certificationRow$lambda$lambda($certType));
      return Unit_instance;
    };
  }
  function removeCertificationType$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('certificationTypes.removeErrorPrefix') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function removeCertificationType$slambda($certType, resultContinuation) {
    this.c39_1 = $certType;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(removeCertificationType$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(removeCertificationType$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(removeCertificationType$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = ApiClient_getInstance().a2x('/api/v1/bitacora/certification-types/' + this.c39_1.t2n_1, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            loadCertificationTypes();
            tmp_0.e39_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              var tmp_3 = document.getElementById('certificationList');
              var it = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
              tmp_2.e39_1 = append(it, removeCertificationType$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(removeCertificationType$slambda).h22 = function ($this$launch, completion) {
    var i = new removeCertificationType$slambda(this.c39_1, completion);
    i.d39_1 = $this$launch;
    return i;
  };
  function removeCertificationType$slambda_0($certType, resultContinuation) {
    var i = new removeCertificationType$slambda($certType, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitCertificationForm$slambda($currentEditId, $authorityId, $name, $validatedActivityTypes, $status, $active, resultContinuation) {
    this.n39_1 = $currentEditId;
    this.o39_1 = $authorityId;
    this.p39_1 = $name;
    this.q39_1 = $validatedActivityTypes;
    this.r39_1 = $status;
    this.s39_1 = $active;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitCertificationForm$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitCertificationForm$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitCertificationForm$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 5;
            this.u7_1 = 4;
            if (this.n39_1 == null) {
              var tmp0 = ApiClient_getInstance();
              var tmp2 = '/api/v1/bitacora/certification-types';
              var body = new CreateCertificationTypeRequest(this.o39_1, this.p39_1, this.q39_1);
              this.u39_1 = tmp0.f27_1;
              this.t7_1 = 2;
              var this_0 = tmp0.f27_1;
              var this_1 = this_0.um();
              var this_2 = serializer(this_1, createKType(getKClass(CreateCertificationTypeRequest), arrayOf([]), false));
              suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp0_0 = ApiClient_getInstance();
              var tmp2_0 = '/api/v1/bitacora/certification-types/' + this.n39_1;
              var body_0 = new UpdateCertificationTypeRequest(this.p39_1, this.q39_1, this.s39_1);
              this.v39_1 = tmp0_0.f27_1;
              this.t7_1 = 1;
              var this_3 = tmp0_0.f27_1;
              var this_4 = this_3.um();
              var this_5 = serializer(this_4, createKType(getKClass(UpdateCertificationTypeRequest), arrayOf([]), false));
              suspendResult = tmp0_0.g27('PUT', tmp2_0, this_3.h13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), body_0), true, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp2_1 = suspendResult;
            var this_6 = this.v39_1;
            var this_7 = this_6.um();
            var this_8 = serializer(this_7, createKType(getKClass(CertificationTypeResponse), arrayOf([]), false));
            this_6.i13(isInterface(this_8, KSerializer) ? this_8 : THROW_CCE(), tmp2_1);
            this.r39_1.textContent = I18n_getInstance().e28('certificationTypes.certificationUpdatedStatus');
            this.t7_1 = 3;
            continue $sm;
          case 2:
            var tmp2_2 = suspendResult;
            var this_9 = this.u39_1;
            var this_10 = this_9.um();
            var this_11 = serializer(this_10, createKType(getKClass(CertificationTypeResponse), arrayOf([]), false));
            this_9.i13(isInterface(this_11, KSerializer) ? this_11 : THROW_CCE(), tmp2_2);
            this.r39_1.textContent = I18n_getInstance().e28('certificationTypes.certificationCreatedStatus');
            this.t7_1 = 3;
            continue $sm;
          case 3:
            loadCertificationTypes();
            var tmp_0 = document.getElementById('certificationModal');
            (tmp_0 instanceof HTMLDialogElement ? tmp_0 : THROW_CCE()).close();
            this.u7_1 = 5;
            this.t7_1 = 6;
            continue $sm;
          case 4:
            this.u7_1 = 5;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.r39_1, e.k2c_1);
              this.t7_1 = 6;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 5:
            throw this.w7_1;
          case 6:
            this.u7_1 = 5;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 5) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitCertificationForm$slambda).h22 = function ($this$launch, completion) {
    var i = new submitCertificationForm$slambda(this.n39_1, this.o39_1, this.p39_1, this.q39_1, this.r39_1, this.s39_1, completion);
    i.t39_1 = $this$launch;
    return i;
  };
  function submitCertificationForm$slambda_0($currentEditId, $authorityId, $name, $validatedActivityTypes, $status, $active, resultContinuation) {
    var i = new submitCertificationForm$slambda($currentEditId, $authorityId, $name, $validatedActivityTypes, $status, $active, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  var properties_initialized_CertificationTypesPage_kt_5fm374;
  function _init_properties_CertificationTypesPage_kt__uibkb6() {
    if (!properties_initialized_CertificationTypesPage_kt_5fm374) {
      properties_initialized_CertificationTypesPage_kt_5fm374 = true;
      editingCertificationTypeId = null;
      loadedAuthorities = emptyList();
      loadedCertificationTypes = emptyList();
    }
  }
  function loadPending() {
    var tmp = document.getElementById('visibilityRequestList');
    var content = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadPending$slambda_0(content, null));
  }
  function renderList(content, requests) {
    content.innerHTML = '';
    append(content, renderList$lambda(requests));
  }
  function decide(requestId, decision) {
    var tmp = document.getElementById('visibility-status-' + requestId);
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, decide$slambda_0(requestId, decision, status, null));
  }
  function CertificationVisibilityRequestsPageModule() {
  }
  protoOf(CertificationVisibilityRequestsPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    loadPending();
  };
  var CertificationVisibilityRequestsPageModule_instance;
  function CertificationVisibilityRequestsPageModule_getInstance() {
    return CertificationVisibilityRequestsPageModule_instance;
  }
  function loadPending$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('certVisibilityRequests.loadError') + ' ' + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadPending$slambda($content, resultContinuation) {
    this.e3a_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadPending$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadPending$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadPending$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/visibility-requests/pending-for-me';
            this.h3a_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.h3a_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CertificationVisibilityRequestResponse), arrayOf([]), false))]), false));
            var requests = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            renderList(this.e3a_1, requests);
            tmp_0.g3a_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.e3a_1.innerHTML = '';
              tmp_2.g3a_1 = append(this.e3a_1, loadPending$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadPending$slambda).h22 = function ($this$launch, completion) {
    var i = new loadPending$slambda(this.e3a_1, completion);
    i.f3a_1 = $this$launch;
    return i;
  };
  function loadPending$slambda_0($content, resultContinuation) {
    var i = new loadPending$slambda($content, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderList$lambda$lambda($request) {
    return function (it) {
      decide($request.b2p_1, VisibilityDecision_APPROVED_getInstance());
      return Unit_instance;
    };
  }
  function renderList$lambda$lambda_0($request) {
    return function (it) {
      decide($request.b2p_1, VisibilityDecision_REJECTED_getInstance());
      return Unit_instance;
    };
  }
  function renderList$lambda($requests) {
    return function ($this$append) {
      var tmp;
      if ($requests.r()) {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp0 = this_0.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = 'certVisibilityRequests.noPendingRequests';
        tmp0.m2(tmp2, value);
        this_0.n1f(I18n_getInstance().e28('certVisibilityRequests.noPendingRequests'));
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $requests.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = 'entry-card';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_1 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_1.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_1.j1f().a1h(this_1);
        // Inline function 'kotlinx.html.h3' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_2 = new H3(attributesMapOf_0('class', null), this_1.j1f());
        this_2.j1f().a1h(this_2);
        this_2.n1f(activityTypeLabel(element.f2p_1));
        this_2.j1f().b1h(this_2);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_3 = new P(attributesMapOf_0('class', null), this_1.j1f());
        this_3.j1f().a1h(this_3);
        this_3.n1f(I18n_getInstance().e28('certVisibilityRequests.respondBy') + ' ' + element.i2p_1);
        this_3.j1f().b1h(this_3);
        // Inline function 'kotlinx.html.button' call
        var tmp_0 = null == null ? null : enumEncode(null);
        var tmp_1 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_4 = new BUTTON(attributesMapOf(['formenctype', tmp_0, 'formmethod', tmp_1, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
        this_4.j1f().a1h(this_4);
        set_onClickFunction(this_4, renderList$lambda$lambda(element));
        var tmp0_0 = this_4.l1f();
        var tmp2_0 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value_0 = 'certVisibilityRequests.approveButton';
        tmp0_0.m2(tmp2_0, value_0);
        this_4.n1f(I18n_getInstance().e28('certVisibilityRequests.approveButton'));
        this_4.j1f().b1h(this_4);
        // Inline function 'kotlinx.html.button' call
        var tmp_2 = null == null ? null : enumEncode(null);
        var tmp_3 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_5 = new BUTTON(attributesMapOf(['formenctype', tmp_2, 'formmethod', tmp_3, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
        this_5.j1f().a1h(this_5);
        set_onClickFunction(this_5, renderList$lambda$lambda_0(element));
        var tmp0_1 = this_5.l1f();
        var tmp2_1 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value_1 = 'certVisibilityRequests.rejectButton';
        tmp0_1.m2(tmp2_1, value_1);
        this_5.n1f(I18n_getInstance().e28('certVisibilityRequests.rejectButton'));
        this_5.j1f().b1h(this_5);
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_6 = new DIV(attributesMapOf_0('class', null), this_1.j1f());
        this_6.j1f().a1h(this_6);
        set_id(this_6, 'visibility-status-' + element.b2p_1);
        this_6.j1f().b1h(this_6);
        this_1.j1f().b1h(this_1);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function decide$slambda($requestId, $decision, $status, resultContinuation) {
    this.q3a_1 = $requestId;
    this.r3a_1 = $decision;
    this.s3a_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(decide$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(decide$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(decide$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/visibility-requests/' + this.q3a_1 + '/respond';
            var body = new RespondToCertificationVisibilityRequestRequest(this.r3a_1);
            this.u3a_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(RespondToCertificationVisibilityRequestRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.u3a_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(CertificationVisibilityRequestResponse), arrayOf([]), false));
            this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            loadPending();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.s3a_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(decide$slambda).h22 = function ($this$launch, completion) {
    var i = new decide$slambda(this.q3a_1, this.r3a_1, this.s3a_1, completion);
    i.t3a_1 = $this$launch;
    return i;
  };
  function decide$slambda_0($requestId, $decision, $status, resultContinuation) {
    var i = new decide$slambda($requestId, $decision, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function ClaimInvitationsPageModule() {
  }
  protoOf(ClaimInvitationsPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    loadPendingClaims();
  };
  var ClaimInvitationsPageModule_instance;
  function ClaimInvitationsPageModule_getInstance() {
    return ClaimInvitationsPageModule_instance;
  }
  function loadPendingClaims() {
    var tmp = document.getElementById('pendingClaimsList');
    var content = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadPendingClaims$slambda_0(content, null));
  }
  function renderPendingClaimsList(content, claims) {
    content.innerHTML = '';
    append(content, renderPendingClaimsList$lambda(claims));
  }
  function decideClaim(claimRequestId, decision) {
    var tmp = document.getElementById('claim-status-' + claimRequestId);
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, decideClaim$slambda_0(claimRequestId, decision, status, null));
  }
  function loadPendingClaims$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('pendingApprovals.claimsLoadError') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadPendingClaims$slambda($content, resultContinuation) {
    this.d3b_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadPendingClaims$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadPendingClaims$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadPendingClaims$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/entry-claims/pending-for-me';
            this.g3b_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.g3b_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(BitacoraEntryClaimRequestResponse), arrayOf([]), false))]), false));
            var claims = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            renderPendingClaimsList(this.d3b_1, claims);
            tmp_0.f3b_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.d3b_1.innerHTML = '';
              tmp_2.f3b_1 = append(this.d3b_1, loadPendingClaims$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadPendingClaims$slambda).h22 = function ($this$launch, completion) {
    var i = new loadPendingClaims$slambda(this.d3b_1, completion);
    i.e3b_1 = $this$launch;
    return i;
  };
  function loadPendingClaims$slambda_0($content, resultContinuation) {
    var i = new loadPendingClaims$slambda($content, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderPendingClaimsList$lambda$lambda($claim) {
    return function (it) {
      decideClaim($claim.w2p_1, ClaimDecision_APPROVED_getInstance());
      return Unit_instance;
    };
  }
  function renderPendingClaimsList$lambda$lambda_0($claim) {
    return function (it) {
      decideClaim($claim.w2p_1, ClaimDecision_REJECTED_getInstance());
      return Unit_instance;
    };
  }
  function renderPendingClaimsList$lambda($claims) {
    return function ($this$append) {
      var tmp;
      if ($claims.r()) {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp0 = this_0.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = 'pendingApprovals.noClaimInvitations';
        tmp0.m2(tmp2, value);
        this_0.n1f(I18n_getInstance().e28('pendingApprovals.noClaimInvitations'));
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $claims.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = 'entry-card';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_1 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_1.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_1.j1f().a1h(this_1);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_2 = new P(attributesMapOf_0('class', null), this_1.j1f());
        this_2.j1f().a1h(this_2);
        var tmp_0 = I18n_getInstance().e28('pendingApprovals.claimInvitationFrom');
        var tmp0_elvis_lhs = element.a2q_1;
        this_2.n1f(tmp_0 + (tmp0_elvis_lhs == null ? element.z2p_1 : tmp0_elvis_lhs));
        this_2.j1f().b1h(this_2);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_3 = new P(attributesMapOf_0('class', null), this_1.j1f());
        this_3.j1f().a1h(this_3);
        this_3.n1f(I18n_getInstance().e28('pendingApprovals.respondBy') + element.e2q_1);
        this_3.j1f().b1h(this_3);
        // Inline function 'kotlinx.html.div' call
        var classes_0 = 'entry-actions';
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_4 = new DIV(attributesMapOf_0('class', classes_0), this_1.j1f());
        this_4.j1f().a1h(this_4);
        // Inline function 'kotlinx.html.button' call
        var classes_1 = 'btn-approve';
        var tmp_1 = null == null ? null : enumEncode(null);
        var tmp_2 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_5 = new BUTTON(attributesMapOf(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_1]), this_4.j1f());
        this_5.j1f().a1h(this_5);
        set_onClickFunction(this_5, renderPendingClaimsList$lambda$lambda(element));
        var tmp0_0 = this_5.l1f();
        var tmp2_0 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value_0 = 'pendingApprovals.approve';
        tmp0_0.m2(tmp2_0, value_0);
        this_5.n1f(I18n_getInstance().e28('pendingApprovals.approve'));
        this_5.j1f().b1h(this_5);
        // Inline function 'kotlinx.html.button' call
        var classes_2 = 'btn-reject';
        var tmp_3 = null == null ? null : enumEncode(null);
        var tmp_4 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_6 = new BUTTON(attributesMapOf(['formenctype', tmp_3, 'formmethod', tmp_4, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_2]), this_4.j1f());
        this_6.j1f().a1h(this_6);
        set_onClickFunction(this_6, renderPendingClaimsList$lambda$lambda_0(element));
        var tmp0_1 = this_6.l1f();
        var tmp2_1 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value_1 = 'pendingApprovals.reject';
        tmp0_1.m2(tmp2_1, value_1);
        this_6.n1f(I18n_getInstance().e28('pendingApprovals.reject'));
        this_6.j1f().b1h(this_6);
        this_4.j1f().b1h(this_4);
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_7 = new DIV(attributesMapOf_0('class', null), this_1.j1f());
        this_7.j1f().a1h(this_7);
        set_id(this_7, 'claim-status-' + element.w2p_1);
        this_7.j1f().b1h(this_7);
        this_1.j1f().b1h(this_1);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function decideClaim$slambda($claimRequestId, $decision, $status, resultContinuation) {
    this.p3b_1 = $claimRequestId;
    this.q3b_1 = $decision;
    this.r3b_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(decideClaim$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(decideClaim$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(decideClaim$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/entry-claims/' + this.p3b_1 + '/respond';
            var body = new RespondToClaimRequestRequest(this.q3b_1);
            this.t3b_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(RespondToClaimRequestRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.t3b_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(BitacoraEntryClaimRequestResponse), arrayOf([]), false));
            this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            loadPendingClaims();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.r3b_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(decideClaim$slambda).h22 = function ($this$launch, completion) {
    var i = new decideClaim$slambda(this.p3b_1, this.q3b_1, this.r3b_1, completion);
    i.s3b_1 = $this$launch;
    return i;
  };
  function decideClaim$slambda_0($claimRequestId, $decision, $status, resultContinuation) {
    var i = new decideClaim$slambda($claimRequestId, $decision, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function set_currentActivitiesCompanyId(_set____db54di) {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    currentActivitiesCompanyId = _set____db54di;
  }
  function get_currentActivitiesCompanyId() {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    return currentActivitiesCompanyId;
  }
  var currentActivitiesCompanyId;
  function set_expandedCenterEntryId(_set____db54di) {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    expandedCenterEntryId = _set____db54di;
  }
  function get_expandedCenterEntryId() {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    return expandedCenterEntryId;
  }
  var expandedCenterEntryId;
  function set_lastLoadedCenterEntries(_set____db54di) {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    lastLoadedCenterEntries = _set____db54di;
  }
  function get_lastLoadedCenterEntries() {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    return lastLoadedCenterEntries;
  }
  var lastLoadedCenterEntries;
  function loadCompanyEntries(companyId) {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    var tmp = document.getElementById('companyActivityList');
    var content = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('companyFilterActivityType');
    var activityType = (tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('companyFilterFrom');
    var from = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    var tmp_2 = document.getElementById('companyFilterTo');
    var to = (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value;
    var tmp_3;
    var tmp_4;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(from)) {
      // Inline function 'kotlin.text.isNotBlank' call
      tmp_4 = !isBlank(to);
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = compareTo(from, to) > 0;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      content.innerHTML = '';
      append(content, loadCompanyEntries$lambda);
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(activityType)) {
      this_0.x('activityType=' + activityType);
    }
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(from)) {
      this_0.x('from=' + from + 'T00:00:00Z');
    }
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(to)) {
      this_0.x('to=' + to + 'T23:59:59Z');
    }
    var tmp$ret$2 = this_0.s4();
    // Inline function 'kotlin.let' call
    var it = joinToString(tmp$ret$2, '&');
    var query = isBlank(it) ? '' : '?' + it;
    var tmp_5 = get_AppScope();
    launch(tmp_5, VOID, VOID, loadCompanyEntries$slambda_0(companyId, query, content, null));
  }
  function renderCompanyEntries(content, entries) {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    set_lastLoadedCenterEntries(entries);
    content.innerHTML = '';
    append(content, renderCompanyEntries$lambda(entries));
  }
  function toggleCenterEntryDetail(entryId) {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    var wasExpanded = get_expandedCenterEntryId() === entryId;
    set_expandedCenterEntryId(wasExpanded ? null : entryId);
    var tmp = document.getElementById('center-entry-detail-' + entryId);
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var detail = tmp_0;
    if (wasExpanded) {
      detail.classList.add('hidden');
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.find' call
    var tmp0 = get_lastLoadedCenterEntries();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.h2h_1 === entryId) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp1_elvis_lhs = tmp$ret$1;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var entry = tmp_1;
    detail.innerHTML = '';
    append(detail, toggleCenterEntryDetail$lambda(entry, entryId));
    detail.classList.remove('hidden');
    if (!(entry.s2h_1 == null) && !(entry.t2h_1 == null)) {
      renderMapLibreMap('center-map-' + entryId, entry.s2h_1, entry.t2h_1);
    }
    if (entry.i2h_1 == null) {
      var tmp_2 = document.getElementById('claimInviteForm-' + entryId);
      var tmp_3 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
      tmp_3.addEventListener('submit', toggleCenterEntryDetail$lambda_0(entryId));
    }
  }
  function submitClaimInvite(entryId) {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    var tmp = document.getElementById('claimInviteStatus-' + entryId);
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('claimInviteEmail-' + entryId);
    var email = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var companyId = get_currentActivitiesCompanyId();
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, submitClaimInvite$slambda_0(companyId, entryId, email, status, null));
  }
  function CompanyActivityLogPageModule$init$lambda($companyId) {
    return function (event) {
      event.preventDefault();
      loadCompanyEntries($companyId);
      return Unit_instance;
    };
  }
  function CompanyActivityLogPageModule() {
  }
  protoOf(CompanyActivityLogPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('companyId');
    var companyId = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    if (isBlank(companyId)) {
      var tmp = document.getElementById('companyActivityLogMissingCompany');
      (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('hidden');
      var tmp_0 = document.getElementById('companyActivityLogContent');
      (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.add('hidden');
      return Unit_instance;
    }
    set_currentActivitiesCompanyId(companyId);
    set_expandedCenterEntryId(null);
    var tmp_1 = document.getElementById('companyActivityFilterForm');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('submit', CompanyActivityLogPageModule$init$lambda(companyId));
    loadCompanyEntries(companyId);
  };
  var CompanyActivityLogPageModule_instance;
  function CompanyActivityLogPageModule_getInstance() {
    return CompanyActivityLogPageModule_instance;
  }
  function loadCompanyEntries$lambda($this$append) {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    // Inline function 'kotlinx.html.p' call
    var classes = 'status-error';
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    this_0.n1f(I18n_getInstance().e28('companyActivityLog.dateRangeInvalidError'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function loadCompanyEntries$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('companyActivityLog.loadError') + ' ' + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadCompanyEntries$slambda($companyId, $query, $content, resultContinuation) {
    this.c3c_1 = $companyId;
    this.d3c_1 = $query;
    this.e3c_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadCompanyEntries$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadCompanyEntries$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadCompanyEntries$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/companies/' + this.c3c_1 + '/entries' + this.d3c_1;
            this.h3c_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.h3c_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(BitacoraEntryResponse), arrayOf([]), false))]), false));
            var entries = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            renderCompanyEntries(this.e3c_1, entries);
            tmp_0.g3c_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.e3c_1.innerHTML = '';
              tmp_2.g3c_1 = append(this.e3c_1, loadCompanyEntries$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadCompanyEntries$slambda).h22 = function ($this$launch, completion) {
    var i = new loadCompanyEntries$slambda(this.c3c_1, this.d3c_1, this.e3c_1, completion);
    i.f3c_1 = $this$launch;
    return i;
  };
  function loadCompanyEntries$slambda_0($companyId, $query, $content, resultContinuation) {
    var i = new loadCompanyEntries$slambda($companyId, $query, $content, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function sam$kotlin_Comparator$0_2(function_0) {
    this.i3c_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_2).cc = function (a, b) {
    return this.i3c_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_2).compare = function (a, b) {
    return this.cc(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_2).c3 = function () {
    return this.i3c_1;
  };
  protoOf(sam$kotlin_Comparator$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.c3(), other.c3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_2).hashCode = function () {
    return hashCode(this.c3());
  };
  function renderCompanyEntries$lambda$lambda(a, b) {
    _init_properties_CompanyActivityLogPage_kt__3utp53();
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.m2h_1;
    var tmp$ret$2 = a.m2h_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function renderCompanyEntries$lambda$lambda_0($entry) {
    return function (it) {
      toggleCenterEntryDetail($entry.h2h_1);
      return Unit_instance;
    };
  }
  function renderCompanyEntries$lambda($entries) {
    return function ($this$append) {
      var tmp;
      if ($entries.r()) {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp0 = this_0.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = 'companyActivityLog.noActivitiesForFilter';
        tmp0.m2(tmp2, value);
        this_0.n1f(I18n_getInstance().e28('companyActivityLog.noActivitiesForFilter'));
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      // Inline function 'kotlin.collections.sortedByDescending' call
      var this_1 = $entries;
      // Inline function 'kotlin.comparisons.compareByDescending' call
      var tmp_0 = renderCompanyEntries$lambda$lambda;
      var tmp$ret$8 = new sam$kotlin_Comparator$0_2(tmp_0);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = sortedWith(this_1, tmp$ret$8).t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = 'entry-card';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_2 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_2.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_2.j1f().a1h(this_2);
        set_onClickFunction(this_2, renderCompanyEntries$lambda$lambda_0(element));
        // Inline function 'kotlinx.html.h3' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_3 = new H3(attributesMapOf_0('class', null), this_2.j1f());
        this_3.j1f().a1h(this_3);
        this_3.n1f(activityTypeLabel(element.l2h_1));
        this_3.j1f().b1h(this_3);
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlinx.html.span' call
        var classes_0 = 'badge badge-' + element.q2h_1.s2_1.toLowerCase();
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_4 = new SPAN(attributesMapOf_0('class', classes_0), this_2.j1f());
        this_4.j1f().a1h(this_4);
        this_4.n1f(element.q2h_1.s2_1);
        this_4.j1f().b1h(this_4);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_5 = new P(attributesMapOf_0('class', null), this_2.j1f());
        this_5.j1f().a1h(this_5);
        this_5.n1f(I18n_getInstance().e28('companyActivityLog.loggedAtLabel') + ' ' + element.m2h_1);
        this_5.j1f().b1h(this_5);
        if (element.i2h_1 == null) {
          // Inline function 'kotlinx.html.p' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_6 = new P(attributesMapOf_0('class', null), this_2.j1f());
          this_6.j1f().a1h(this_6);
          var tmp_1 = I18n_getInstance().e28('companyActivityLog.walkInGuestLabel') + ' ';
          var tmp0_elvis_lhs = element.v2h_1;
          var tmp_2 = (tmp0_elvis_lhs == null ? I18n_getInstance().e28('companyActivityLog.unknownGuestName') : tmp0_elvis_lhs) + ' ';
          var tmp1_elvis_lhs = element.w2h_1;
          this_6.n1f(tmp_1 + tmp_2 + ('(' + (tmp1_elvis_lhs == null ? I18n_getInstance().e28('companyActivityLog.noEmailFallback') : tmp1_elvis_lhs) + ')'));
          this_6.j1f().b1h(this_6);
        }
        if (!(element.p2h_1 == null)) {
          // Inline function 'kotlinx.html.p' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_7 = new P(attributesMapOf_0('class', null), this_2.j1f());
          this_7.j1f().a1h(this_7);
          this_7.n1f(I18n_getInstance().e28('companyActivityLog.notesLabel') + ' ' + element.p2h_1);
          this_7.j1f().b1h(this_7);
        }
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_8 = new DIV(attributesMapOf_0('class', 'hidden'), this_2.j1f());
        this_8.j1f().a1h(this_8);
        set_id(this_8, 'center-entry-detail-' + element.h2h_1);
        this_8.j1f().b1h(this_8);
        this_2.j1f().b1h(this_2);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function toggleCenterEntryDetail$lambda($entry, $entryId) {
    return function ($this$append) {
      var tmp;
      if (!($entry.s2h_1 == null) && !($entry.t2h_1 == null)) {
        // Inline function 'kotlinx.html.div' call
        var classes = 'map-container';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        set_id(this_0, 'center-map-' + $entryId);
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      var tmp_0;
      if ($entry.i2h_1 == null) {
        // Inline function 'kotlinx.html.form' call
        var tmp_1 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_1 = new FORM(attributesMapOf(['action', null, 'enctype', tmp_1, 'method', null == null ? null : enumEncode(null), 'class', null]), $this$append);
        if (!(this_1.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_1.j1f().a1h(this_1);
        set_id(this_1, 'claimInviteForm-' + $entryId);
        // Inline function 'kotlinx.html.label' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_2 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
        this_2.j1f().a1h(this_2);
        var tmp0 = this_2.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = 'companyActivityLog.inviteLabel';
        tmp0.m2(tmp2, value);
        this_2.n1f(I18n_getInstance().e28('companyActivityLog.inviteLabel'));
        // Inline function 'kotlinx.html.emailInput' call
        var tmp_2 = InputType_email_getInstance().q1i_1;
        var tmp_3 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_3 = new INPUT(attributesMapOf(['type', tmp_2, 'formenctype', tmp_3, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_2.j1f());
        this_3.j1f().a1h(this_3);
        set_id(this_3, 'claimInviteEmail-' + $entryId);
        this_3.c1m(true);
        this_3.j1f().b1h(this_3);
        this_2.j1f().b1h(this_2);
        // Inline function 'kotlinx.html.button' call
        var tmp_4 = null == null ? null : enumEncode(null);
        var tmp_5 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_4 = new BUTTON(attributesMapOf(['formenctype', tmp_4, 'formmethod', tmp_5, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
        this_4.j1f().a1h(this_4);
        this_4.z1j(ButtonType_submit_getInstance());
        var tmp0_0 = this_4.l1f();
        var tmp2_0 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value_0 = 'companyActivityLog.sendInviteButton';
        tmp0_0.m2(tmp2_0, value_0);
        this_4.n1f(I18n_getInstance().e28('companyActivityLog.sendInviteButton'));
        this_4.j1f().b1h(this_4);
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_5 = new DIV(attributesMapOf_0('class', null), this_1.j1f());
        this_5.j1f().a1h(this_5);
        set_id(this_5, 'claimInviteStatus-' + $entryId);
        this_5.j1f().b1h(this_5);
        this_1.j1f().b1h(this_1);
        $this$append.d1h();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function toggleCenterEntryDetail$lambda_0($entryId) {
    return function (event) {
      event.preventDefault();
      submitClaimInvite($entryId);
      return Unit_instance;
    };
  }
  function submitClaimInvite$slambda($companyId, $entryId, $email, $status, resultContinuation) {
    this.r3c_1 = $companyId;
    this.s3c_1 = $entryId;
    this.t3c_1 = $email;
    this.u3c_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitClaimInvite$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitClaimInvite$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitClaimInvite$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/companies/' + this.r3c_1 + '/entries/' + this.s3c_1 + '/claim-invitations';
            var body = new InviteToClaimEntryRequest(this.t3c_1);
            this.w3c_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(InviteToClaimEntryRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.w3c_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(ClaimInvitationOutcomeResponse), arrayOf([]), false));
            var outcome = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            var tmp0_subject = outcome.t2i_1;
            this.u3c_1.textContent = tmp0_subject === 'CREATED' ? I18n_getInstance().e28('companyActivityLog.inviteSentPrefix') + ' ' + this.t3c_1 + '.' : tmp0_subject === 'NO_ACCOUNT' ? I18n_getInstance().e28('companyActivityLog.noAccountPrefix') + ' ' + this.t3c_1 + ' ' + I18n_getInstance().e28('companyActivityLog.noAccountSuffix') : tmp0_subject === 'DUPLICATE_PENDING' ? I18n_getInstance().e28('companyActivityLog.duplicatePendingPrefix') + ' ' + this.t3c_1 + '.' : outcome.t2i_1;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.u3c_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitClaimInvite$slambda).h22 = function ($this$launch, completion) {
    var i = new submitClaimInvite$slambda(this.r3c_1, this.s3c_1, this.t3c_1, this.u3c_1, completion);
    i.v3c_1 = $this$launch;
    return i;
  };
  function submitClaimInvite$slambda_0($companyId, $entryId, $email, $status, resultContinuation) {
    var i = new submitClaimInvite$slambda($companyId, $entryId, $email, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  var properties_initialized_CompanyActivityLogPage_kt_pjaxe1;
  function _init_properties_CompanyActivityLogPage_kt__3utp53() {
    if (!properties_initialized_CompanyActivityLogPage_kt_pjaxe1) {
      properties_initialized_CompanyActivityLogPage_kt_pjaxe1 = true;
      currentActivitiesCompanyId = '';
      expandedCenterEntryId = null;
      lastLoadedCenterEntries = emptyList();
    }
  }
  function loadCompanyAnalytics(companyId, period) {
    var tmp = document.getElementById('companyAnalyticsContent');
    var content = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    content.innerHTML = '';
    append(content, loadCompanyAnalytics$lambda);
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadCompanyAnalytics$slambda_0(companyId, period, content, null));
  }
  function renderCompanyAnalyticsResult(content, result) {
    content.innerHTML = '';
    if (result.j2m_1 === 0) {
      append(content, renderCompanyAnalyticsResult$lambda);
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.maxOf' call
    var iterator = result.l2m_1.t();
    if (!iterator.u())
      throw NoSuchElementException_init_$Create$();
    var maxValue = iterator.v().e2m_1;
    while (iterator.u()) {
      var v = iterator.v().e2m_1;
      if (compareTo(maxValue, v) < 0) {
        maxValue = v;
      }
    }
    var maxEntryCount = maxValue;
    append(content, renderCompanyAnalyticsResult$lambda_0(result, maxEntryCount));
  }
  function analyticsSummaryCard(_this__u8e3s4, labelKey, value) {
    // Inline function 'kotlinx.html.div' call
    var classes = 'analytics-summary-card';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new DIV(attributesMapOf_0('class', classes), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    // Inline function 'kotlinx.html.span' call
    var classes_0 = 'analytics-summary-value';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new SPAN(attributesMapOf_0('class', classes_0), this_0.j1f());
    this_1.j1f().a1h(this_1);
    this_1.n1f(value);
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.span' call
    var classes_1 = 'analytics-summary-label';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new SPAN(attributesMapOf_0('class', classes_1), this_0.j1f());
    this_2.j1f().a1h(this_2);
    var tmp0 = this_2.l1f();
    // Inline function 'kotlin.collections.set' call
    var key = 'data-i18n';
    tmp0.m2(key, labelKey);
    this_2.n1f(I18n_getInstance().e28(labelKey));
    this_2.j1f().b1h(this_2);
    this_0.j1f().b1h(this_0);
  }
  function analyticsBarRow(_this__u8e3s4, total, maxEntryCount) {
    var widthPercent = maxEntryCount === 0 ? 0 : imul(total.e2m_1, 100) / maxEntryCount | 0;
    // Inline function 'kotlinx.html.div' call
    var classes = 'analytics-bar-row';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new DIV(attributesMapOf_0('class', classes), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    // Inline function 'kotlinx.html.span' call
    var classes_0 = 'analytics-bar-label';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new SPAN(attributesMapOf_0('class', classes_0), this_0.j1f());
    this_1.j1f().a1h(this_1);
    this_1.n1f(activityTypeLabel(total.c2m_1));
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.div' call
    var classes_1 = 'budget-bar';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new DIV(attributesMapOf_0('class', classes_1), this_0.j1f());
    this_2.j1f().a1h(this_2);
    // Inline function 'kotlinx.html.div' call
    var classes_2 = 'budget-bar-fill';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new DIV(attributesMapOf_0('class', classes_2), this_2.j1f());
    this_3.j1f().a1h(this_3);
    var tmp0 = this_3.l1f();
    // Inline function 'kotlin.collections.set' call
    var value = 'width: ' + widthPercent + '%';
    tmp0.m2('style', value);
    this_3.j1f().b1h(this_3);
    this_2.j1f().b1h(this_2);
    // Inline function 'kotlinx.html.span' call
    var classes_3 = 'analytics-bar-value';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_4 = new SPAN(attributesMapOf_0('class', classes_3), this_0.j1f());
    this_4.j1f().a1h(this_4);
    this_4.n1f('' + total.e2m_1 + ' \xB7 ' + formatKm(total.d2m_1));
    this_4.j1f().b1h(this_4);
    this_0.j1f().b1h(this_0);
  }
  function formatKm(meters) {
    var hundredthsOfKm = numberToLong(round(meters / 10.0));
    // Inline function 'kotlin.Long.div' call
    var whole = divide(hundredthsOfKm, fromInt(100));
    // Inline function 'kotlin.Long.rem' call
    var tmp$ret$1 = modulo(hundredthsOfKm, fromInt(100));
    var fraction = padStart(tmp$ret$1.toString(), 2, _Char___init__impl__6a9atx(48));
    return whole.toString() + '.' + fraction + ' km';
  }
  function CompanyAnalyticsPageModule$init$lambda($companyId, $periodSelect) {
    return function (it) {
      loadCompanyAnalytics($companyId, $periodSelect.value);
      return Unit_instance;
    };
  }
  function CompanyAnalyticsPageModule() {
  }
  protoOf(CompanyAnalyticsPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('companyId');
    var companyId = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    if (isBlank(companyId)) {
      var tmp = document.getElementById('companyAnalyticsMissingCompany');
      (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('hidden');
      var tmp_0 = document.getElementById('companyAnalyticsContentWrapper');
      (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.add('hidden');
      return Unit_instance;
    }
    var tmp_1 = document.getElementById('companyAnalyticsPeriod');
    var periodSelect = tmp_1 instanceof HTMLSelectElement ? tmp_1 : THROW_CCE();
    var reload = CompanyAnalyticsPageModule$init$lambda(companyId, periodSelect);
    periodSelect.onchange = reload;
    loadCompanyAnalytics(companyId, periodSelect.value);
  };
  var CompanyAnalyticsPageModule_instance;
  function CompanyAnalyticsPageModule_getInstance() {
    return CompanyAnalyticsPageModule_instance;
  }
  function loadCompanyAnalytics$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    this_0.n1f('\u2026');
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function loadCompanyAnalytics$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f($e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadCompanyAnalytics$slambda$lambda_0($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('companyAnalytics.loadError') + ': ' + $e.message);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadCompanyAnalytics$slambda($companyId, $period, $content, resultContinuation) {
    this.f3d_1 = $companyId;
    this.g3d_1 = $period;
    this.h3d_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadCompanyAnalytics$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadCompanyAnalytics$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadCompanyAnalytics$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/companies/' + this.f3d_1 + '/analytics?period=' + this.g3d_1;
            this.k3d_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.k3d_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(CompanyAnalyticsResponse), arrayOf([]), false));
            var result = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            renderCompanyAnalyticsResult(this.h3d_1, result);
            tmp_0.j3d_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.h3d_1.innerHTML = '';
              tmp_2.j3d_1 = append(this.h3d_1, loadCompanyAnalytics$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_3 = this.w7_1;
              if (tmp_3 instanceof Error) {
                var e_0 = this.w7_1;
                var tmp_4 = this;
                this.h3d_1.innerHTML = '';
                tmp_4.j3d_1 = append(this.h3d_1, loadCompanyAnalytics$slambda$lambda_0(e_0));
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(loadCompanyAnalytics$slambda).h22 = function ($this$launch, completion) {
    var i = new loadCompanyAnalytics$slambda(this.f3d_1, this.g3d_1, this.h3d_1, completion);
    i.i3d_1 = $this$launch;
    return i;
  };
  function loadCompanyAnalytics$slambda_0($companyId, $period, $content, resultContinuation) {
    var i = new loadCompanyAnalytics$slambda($companyId, $period, $content, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderCompanyAnalyticsResult$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'companyAnalytics.empty';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('companyAnalytics.empty'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderCompanyAnalyticsResult$lambda_0($result, $maxEntryCount) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.div' call
      var classes = 'analytics-summary';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new DIV(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      analyticsSummaryCard(this_0, 'companyAnalytics.totalDistance', formatKm($result.i2m_1));
      analyticsSummaryCard(this_0, 'companyAnalytics.totalEntries', $result.j2m_1.toString());
      analyticsSummaryCard(this_0, 'companyAnalytics.activeMembers', $result.k2m_1.toString());
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      // Inline function 'kotlinx.html.h3' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_1 = new H3(attributesMapOf_0('class', null), $this$append);
      if (!(this_1.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_1.j1f().a1h(this_1);
      var tmp0 = this_1.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'companyAnalytics.byActivityHeading';
      tmp0.m2(tmp2, value);
      this_1.n1f(I18n_getInstance().e28('companyAnalytics.byActivityHeading'));
      this_1.j1f().b1h(this_1);
      $this$append.d1h();
      // Inline function 'kotlinx.html.div' call
      var classes_0 = 'analytics-bars';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_2 = new DIV(attributesMapOf_0('class', classes_0), $this$append);
      if (!(this_2.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_2.j1f().a1h(this_2);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $result.l2m_1.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        analyticsBarRow(this_2, element, $maxEntryCount);
      }
      this_2.j1f().b1h(this_2);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  var currentTeamCompanyId;
  var editingMemberUserId;
  function submitInviteMember() {
    var tmp = document.getElementById('inviteMemberStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('inviteMemberEmail');
    var email = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('inviteMemberName');
    var name = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    var tmp_2 = document.getElementById('inviteMemberRole');
    var role = valueOf_0((tmp_2 instanceof HTMLSelectElement ? tmp_2 : THROW_CCE()).value);
    var companyId = currentTeamCompanyId;
    var tmp_3 = get_AppScope();
    launch(tmp_3, VOID, VOID, submitInviteMember$slambda_0(companyId, email, name, role, status, null));
  }
  function loadTeamMembers() {
    var tmp = document.getElementById('teamMembersStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    status.textContent = 'Loading\u2026';
    var companyId = currentTeamCompanyId;
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadTeamMembers$slambda_0(companyId, status, null));
  }
  function renderTeamMembers(members) {
    var tmp = document.getElementById('teamMembersResults');
    var container = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    container.innerHTML = '';
    if (members.r()) {
      append(container, renderTeamMembers$lambda);
      return Unit_instance;
    }
    append(container, renderTeamMembers$lambda_0(members));
  }
  function memberRow(_this__u8e3s4, member) {
    // Inline function 'kotlinx.html.tr' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new TR(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_1.j1f().a1h(this_1);
    this_1.n1f(member.n2v_1);
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_2.j1f().a1h(this_2);
    this_2.n1f(member.m2v_1);
    this_2.j1f().b1h(this_2);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_3.j1f().a1h(this_3);
    // Inline function 'kotlinx.html.span' call
    var classes = 'badge badge-role';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_4 = new SPAN(attributesMapOf_0('class', classes), this_3.j1f());
    this_4.j1f().a1h(this_4);
    this_4.n1f(member.o2v_1.s2_1);
    this_4.j1f().b1h(this_4);
    this_3.j1f().b1h(this_3);
    // Inline function 'kotlinx.html.td' call
    var classes_0 = 'table-row-actions';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_5 = new TD(attributesMapOf_0('class', classes_0), this_0.j1f());
    this_5.j1f().a1h(this_5);
    // Inline function 'kotlinx.html.button' call
    var classes_1 = 'icon-button';
    var tmp = null == null ? null : enumEncode(null);
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_6 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_1]), this_5.j1f());
    this_6.j1f().a1h(this_6);
    var tmp0 = this_6.l1f();
    // Inline function 'kotlin.collections.set' call
    var value = 'Edit role';
    tmp0.m2('title', value);
    var tmp0_0 = this_6.l1f();
    var tmp2 = 'aria-label';
    // Inline function 'kotlin.collections.set' call
    var value_0 = 'Edit role';
    tmp0_0.m2(tmp2, value_0);
    set_onClickFunction(this_6, memberRow$lambda(member));
    uiIcon(this_6, 'edit');
    this_6.j1f().b1h(this_6);
    // Inline function 'kotlinx.html.button' call
    var classes_2 = 'icon-button icon-button-danger';
    var tmp_1 = null == null ? null : enumEncode(null);
    var tmp_2 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_7 = new BUTTON(attributesMapOf(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_2]), this_5.j1f());
    this_7.j1f().a1h(this_7);
    // Inline function 'kotlin.collections.set' call
    this_7.l1f().m2('title', 'Remove');
    var tmp0_1 = this_7.l1f();
    // Inline function 'kotlin.collections.set' call
    var key = 'aria-label';
    tmp0_1.m2(key, 'Remove');
    set_onClickFunction(this_7, memberRow$lambda_0(member));
    uiIcon(this_7, 'delete');
    this_7.j1f().b1h(this_7);
    this_5.j1f().b1h(this_5);
    this_0.j1f().b1h(this_0);
  }
  function startEditingMemberRole(member) {
    editingMemberUserId = member.l2v_1;
    var tmp = document.getElementById('memberRoleModalHeading');
    (tmp instanceof HTMLElement ? tmp : THROW_CCE()).textContent = 'Edit role for "' + member.n2v_1 + '"';
    var tmp_0 = document.getElementById('memberRoleSelect');
    (tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE()).value = member.o2v_1.s2_1;
    var tmp_1 = document.getElementById('memberRoleStatus');
    clearStatus(tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE());
    var tmp_2 = document.getElementById('memberRoleModal');
    (tmp_2 instanceof HTMLDialogElement ? tmp_2 : THROW_CCE()).showModal();
  }
  function submitMemberRoleForm() {
    var tmp = document.getElementById('memberRoleStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp0_elvis_lhs = editingMemberUserId;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var userId = tmp_0;
    var tmp_1 = document.getElementById('memberRoleSelect');
    var role = valueOf_0((tmp_1 instanceof HTMLSelectElement ? tmp_1 : THROW_CCE()).value);
    var companyId = currentTeamCompanyId;
    var tmp_2 = get_AppScope();
    launch(tmp_2, VOID, VOID, submitMemberRoleForm$slambda_0(companyId, userId, role, status, null));
  }
  function removeMember(member) {
    var companyId = currentTeamCompanyId;
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, removeMember$slambda_0(companyId, member, null));
  }
  function CompanyTeamPageModule$init$lambda($roleModal) {
    return function (it) {
      $roleModal.close();
      return Unit_instance;
    };
  }
  function CompanyTeamPageModule$init$lambda_0(it) {
    editingMemberUserId = null;
    return Unit_instance;
  }
  function CompanyTeamPageModule$init$lambda_1(event) {
    event.preventDefault();
    submitMemberRoleForm();
    return Unit_instance;
  }
  function CompanyTeamPageModule$init$lambda_2(event) {
    event.preventDefault();
    submitInviteMember();
    return Unit_instance;
  }
  function CompanyTeamPageModule() {
  }
  protoOf(CompanyTeamPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('companyId');
    var companyId = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    if (isBlank(companyId)) {
      var tmp = document.getElementById('companyTeamMissingCompany');
      (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('hidden');
      var tmp_0 = document.getElementById('companyTeamContent');
      (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.add('hidden');
      return Unit_instance;
    }
    currentTeamCompanyId = companyId;
    editingMemberUserId = null;
    var tmp_1 = document.getElementById('memberRoleModal');
    var roleModal = tmp_1 instanceof HTMLDialogElement ? tmp_1 : THROW_CCE();
    var tmp_2 = document.getElementById('cancelMemberRoleModalButton');
    var tmp_3 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
    tmp_3.addEventListener('click', CompanyTeamPageModule$init$lambda(roleModal));
    roleModal.addEventListener('close', CompanyTeamPageModule$init$lambda_0);
    var tmp_4 = document.getElementById('memberRoleForm');
    var tmp_5 = tmp_4 instanceof HTMLElement ? tmp_4 : THROW_CCE();
    tmp_5.addEventListener('submit', CompanyTeamPageModule$init$lambda_1);
    var tmp_6 = document.getElementById('inviteMemberForm');
    var tmp_7 = tmp_6 instanceof HTMLElement ? tmp_6 : THROW_CCE();
    tmp_7.addEventListener('submit', CompanyTeamPageModule$init$lambda_2);
    loadTeamMembers();
  };
  var CompanyTeamPageModule_instance;
  function CompanyTeamPageModule_getInstance() {
    return CompanyTeamPageModule_instance;
  }
  function submitInviteMember$slambda($companyId, $email, $name, $role, $status, resultContinuation) {
    this.t3d_1 = $companyId;
    this.u3d_1 = $email;
    this.v3d_1 = $name;
    this.w3d_1 = $role;
    this.x3d_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitInviteMember$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitInviteMember$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitInviteMember$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/members/companies/' + this.t3d_1 + '/invitations';
            var body = new InviteCompanyMemberRequest(this.u3d_1, this.v3d_1, this.w3d_1);
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(InviteCompanyMemberRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x3d_1.textContent = 'Invitation sent to ' + this.u3d_1 + '.';
            var tmp_0 = document.getElementById('inviteMemberForm');
            (tmp_0 instanceof HTMLFormElement ? tmp_0 : THROW_CCE()).reset();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.x3d_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_2 = this.w7_1;
              if (tmp_2 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.x3d_1, 'Something went wrong: ' + e_0.message);
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitInviteMember$slambda).h22 = function ($this$launch, completion) {
    var i = new submitInviteMember$slambda(this.t3d_1, this.u3d_1, this.v3d_1, this.w3d_1, this.x3d_1, completion);
    i.y3d_1 = $this$launch;
    return i;
  };
  function submitInviteMember$slambda_0($companyId, $email, $name, $role, $status, resultContinuation) {
    var i = new submitInviteMember$slambda($companyId, $email, $name, $role, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function loadTeamMembers$slambda($companyId, $status, resultContinuation) {
    this.h3e_1 = $companyId;
    this.i3e_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadTeamMembers$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadTeamMembers$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadTeamMembers$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/members/companies/' + this.h3e_1 + '/members';
            this.k3e_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.k3e_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CompanyMemberResponse), arrayOf([]), false))]), false));
            var members = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.i3e_1.textContent = '';
            renderTeamMembers(members);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.i3e_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.i3e_1, 'Could not load team members: ' + e_0.message);
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(loadTeamMembers$slambda).h22 = function ($this$launch, completion) {
    var i = new loadTeamMembers$slambda(this.h3e_1, this.i3e_1, completion);
    i.j3e_1 = $this$launch;
    return i;
  };
  function loadTeamMembers$slambda_0($companyId, $status, resultContinuation) {
    var i = new loadTeamMembers$slambda($companyId, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderTeamMembers$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    this_0.n1f('No members found.');
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderTeamMembers$lambda_0($members) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.table' call
      var classes = 'listing-table';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new TABLE(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.tr' call
      var classes_0 = 'listing-table-head-row';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new TR(attributesMapOf_0('class', classes_0), this_0.j1f());
      this_1.j1f().a1h(this_1);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_2.j1f().a1h(this_2);
      this_2.n1f('Name');
      this_2.j1f().b1h(this_2);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_3.j1f().a1h(this_3);
      this_3.n1f('Email');
      this_3.j1f().b1h(this_3);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_4 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_4.j1f().a1h(this_4);
      this_4.n1f('Role');
      this_4.j1f().b1h(this_4);
      // Inline function 'kotlinx.html.th' call
      var classes_1 = 'table-row-actions';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_5 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', classes_1]), this_1.j1f());
      this_5.j1f().a1h(this_5);
      this_5.n1f('Actions');
      this_5.j1f().b1h(this_5);
      this_1.j1f().b1h(this_1);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $members.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        memberRow(this_0, element);
      }
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function memberRow$lambda($member) {
    return function (it) {
      startEditingMemberRole($member);
      return Unit_instance;
    };
  }
  function memberRow$lambda$lambda($member) {
    return function () {
      removeMember($member);
      return Unit_instance;
    };
  }
  function memberRow$lambda_0($member) {
    return function (it) {
      var tmp = 'Remove ' + $member.n2v_1 + ' from this company?';
      requestConfirmation('removeMemberConfirm', tmp, memberRow$lambda$lambda($member));
      return Unit_instance;
    };
  }
  function submitMemberRoleForm$slambda($companyId, $userId, $role, $status, resultContinuation) {
    this.t3e_1 = $companyId;
    this.u3e_1 = $userId;
    this.v3e_1 = $role;
    this.w3e_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitMemberRoleForm$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitMemberRoleForm$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitMemberRoleForm$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/members/companies/' + this.t3e_1 + '/members/' + this.u3e_1;
            var body = new UpdateCompanyMemberRoleRequest(this.v3e_1);
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(UpdateCompanyMemberRoleRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('PUT', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = document.getElementById('memberRoleModal');
            (tmp_0 instanceof HTMLDialogElement ? tmp_0 : THROW_CCE()).close();
            loadTeamMembers();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.w3e_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_2 = this.w7_1;
              if (tmp_2 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.w3e_1, 'Something went wrong: ' + e_0.message);
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitMemberRoleForm$slambda).h22 = function ($this$launch, completion) {
    var i = new submitMemberRoleForm$slambda(this.t3e_1, this.u3e_1, this.v3e_1, this.w3e_1, completion);
    i.x3e_1 = $this$launch;
    return i;
  };
  function submitMemberRoleForm$slambda_0($companyId, $userId, $role, $status, resultContinuation) {
    var i = new submitMemberRoleForm$slambda($companyId, $userId, $role, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function removeMember$slambda($companyId, $member, resultContinuation) {
    this.g3f_1 = $companyId;
    this.h3f_1 = $member;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(removeMember$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(removeMember$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(removeMember$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = ApiClient_getInstance().a2x('/api/v1/members/companies/' + this.g3f_1 + '/members/' + this.h3f_1.l2v_1, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            loadTeamMembers();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_1 = document.getElementById('teamMembersStatus');
              showError(tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE(), 'Could not remove: ' + e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(removeMember$slambda).h22 = function ($this$launch, completion) {
    var i = new removeMember$slambda(this.g3f_1, this.h3f_1, completion);
    i.i3f_1 = $this$launch;
    return i;
  };
  function removeMember$slambda_0($companyId, $member, resultContinuation) {
    var i = new removeMember$slambda($companyId, $member, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function set_registeredActivityTypesForFilter(_set____db54di) {
    _init_properties_DiscoverPage_kt__qya3so();
    registeredActivityTypesForFilter = _set____db54di;
  }
  function get_registeredActivityTypesForFilter() {
    _init_properties_DiscoverPage_kt__qya3so();
    return registeredActivityTypesForFilter;
  }
  var registeredActivityTypesForFilter;
  function set_discoverMoveDebounceHandle(_set____db54di) {
    _init_properties_DiscoverPage_kt__qya3so();
    discoverMoveDebounceHandle = _set____db54di;
  }
  function get_discoverMoveDebounceHandle() {
    _init_properties_DiscoverPage_kt__qya3so();
    return discoverMoveDebounceHandle;
  }
  var discoverMoveDebounceHandle;
  function set_activityTypeExplicitlySelected(_set____db54di) {
    _init_properties_DiscoverPage_kt__qya3so();
    activityTypeExplicitlySelected = _set____db54di;
  }
  function get_activityTypeExplicitlySelected() {
    _init_properties_DiscoverPage_kt__qya3so();
    return activityTypeExplicitlySelected;
  }
  var activityTypeExplicitlySelected;
  function wireDiscoverPage() {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp0_safe_receiver = document.body;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.classList;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.add('discover-fit-viewport');
    }
    var tmp = document.getElementById('discoverSearchModal');
    var modal = tmp instanceof HTMLDialogElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('discoverLensButton');
    var tmp_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    tmp_1.addEventListener('click', wireDiscoverPage$lambda(modal));
    var tmp_2 = document.getElementById('discoverSearchModalCancel');
    var tmp_3 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
    tmp_3.addEventListener('click', wireDiscoverPage$lambda_0(modal));
    var tmp_4 = document.getElementById('discoverForm');
    var tmp_5 = tmp_4 instanceof HTMLElement ? tmp_4 : THROW_CCE();
    tmp_5.addEventListener('submit', wireDiscoverPage$lambda_1(modal));
    var tmp_6 = document.getElementById('discoverActivityType');
    var tmp_7 = tmp_6 instanceof HTMLSelectElement ? tmp_6 : THROW_CCE();
    tmp_7.addEventListener('change', wireDiscoverPage$lambda_2);
    renderDiscoverMapPlaceholder('discoverMap', wireDiscoverPage$lambda_3);
    loadRegisteredActivitiesForFilter();
    initializeMapCenter();
  }
  function DiscoverPageModule$init$lambda(it) {
    toggleDiscoverActivityTypeFilter();
    return Unit_instance;
  }
  function DiscoverPageModule() {
  }
  protoOf(DiscoverPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    var tmp = document.getElementById('discoverActivityType');
    appendActivityTypeOptions(tmp instanceof HTMLSelectElement ? tmp : THROW_CCE());
    var tmp_0 = document.getElementById('discoverActivityTypeShowAll');
    var tmp_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    tmp_1.addEventListener('click', DiscoverPageModule$init$lambda);
    wireLocationSearchPicker('discover');
    wireDiscoverPage();
  };
  var DiscoverPageModule_instance;
  function DiscoverPageModule_getInstance() {
    return DiscoverPageModule_instance;
  }
  function loadRegisteredActivitiesForFilter() {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, loadRegisteredActivitiesForFilter$slambda_0(null));
  }
  function toggleDiscoverActivityTypeFilter() {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp = document.getElementById('discoverActivityTypeShowAll');
    var button = tmp instanceof HTMLButtonElement ? tmp : THROW_CCE();
    if (button.disabled)
      return Unit_instance;
    setDiscoverActivityTypeShowAll(!(button.getAttribute('aria-pressed') === 'true'));
  }
  function setDiscoverActivityTypeShowAll(showAll) {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp = document.getElementById('discoverActivityTypeShowAll');
    var button = tmp instanceof HTMLButtonElement ? tmp : THROW_CCE();
    button.setAttribute('aria-pressed', showAll.toString());
    var tmp_0 = document.getElementById('discoverActivityTypeShowAllMine');
    var mineLabel = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    var tmp_1 = document.getElementById('discoverActivityTypeShowAllAll');
    var allLabel = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    mineLabel.classList.toggle('mine-all-toggle-button-label-inactive', showAll);
    allLabel.classList.toggle('mine-all-toggle-button-label-inactive', !showAll);
    var tmp_2 = document.getElementById('discoverActivityType');
    var select = tmp_2 instanceof HTMLSelectElement ? tmp_2 : THROW_CCE();
    var inductionVariable = 0;
    var last = select.options.length;
    if (inductionVariable < last)
      $l$loop_0: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp_3 = select.options.item(i);
        var tmp0_elvis_lhs = tmp_3 instanceof HTMLOptionElement ? tmp_3 : null;
        var tmp_4;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_4 = tmp0_elvis_lhs;
        }
        var option = tmp_4;
        if (isBlank(option.value))
          continue $l$loop_0;
        option.hidden = (!showAll && !get_registeredActivityTypesForFilter().c2(option.value));
      }
       while (inductionVariable < last);
  }
  function initializeMapCenter() {
    _init_properties_DiscoverPage_kt__qya3so();
    // Inline function 'kotlin.js.asDynamic' call
    var geolocation = window.navigator.geolocation;
    if (geolocation != undefined) {
      var tmp = initializeMapCenter$lambda;
      geolocation.getCurrentPosition(tmp, initializeMapCenter$lambda_0);
    } else {
      fallbackToCloudFrontLocation();
    }
  }
  function fallbackToCloudFrontLocation() {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, fallbackToCloudFrontLocation$slambda_0(null));
  }
  function currentRadiusKm() {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp = document.getElementById('discoverRadiusKm');
    var tmp0_safe_receiver = toDoubleOrNull((tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : coerceAtMost(tmp0_safe_receiver, 200.0);
    return tmp1_elvis_lhs == null ? 10.0 : tmp1_elvis_lhs;
  }
  function zoomForRadiusKm(radiusKm) {
    _init_properties_DiscoverPage_kt__qya3so();
    // Inline function 'kotlin.math.log2' call
    var x = 50.0 / radiusKm;
    var tmp$ret$0 = log2(x);
    return roundToInt(9 + tmp$ret$0);
  }
  function onInitialLocationKnown(latitude, longitude) {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp = document.getElementById('discover-latitude');
    (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value = latitude.toString();
    var tmp_0 = document.getElementById('discover-longitude');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = longitude.toString();
    var radiusKm = currentRadiusKm();
    var tmp_1 = zoomForRadiusKm(radiusKm);
    renderDiscoverMap('discoverMap', latitude, longitude, tmp_1, VOID, radiusKm, onInitialLocationKnown$lambda);
    runDiscoverSearch(false);
  }
  function recenterMapFromFields() {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp = document.getElementById('discover-latitude');
    var tmp0_elvis_lhs = toDoubleOrNull((tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var latitude = tmp_0;
    var tmp_1 = document.getElementById('discover-longitude');
    var tmp1_elvis_lhs = toDoubleOrNull((tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value);
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var longitude = tmp_2;
    var radiusKm = currentRadiusKm();
    var tmp_3 = zoomForRadiusKm(radiusKm);
    renderDiscoverMap('discoverMap', latitude, longitude, tmp_3, VOID, radiusKm, recenterMapFromFields$lambda);
  }
  function onDiscoverMapMoved(latitude, longitude) {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp = document.getElementById('discover-latitude');
    (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value = latitude.toString();
    var tmp_0 = document.getElementById('discover-longitude');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = longitude.toString();
    var tmp0_safe_receiver = get_discoverMoveDebounceHandle();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      window.clearTimeout(tmp0_safe_receiver);
    }
    var tmp_1 = window;
    set_discoverMoveDebounceHandle(tmp_1.setTimeout(onDiscoverMapMoved$lambda, 400));
  }
  function runDiscoverSearch(showValidationErrors) {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp = document.getElementById('discoverStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('discoverActivityType');
    var selectedActivityType = (tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1;
    if (get_activityTypeExplicitlySelected()) {
      // Inline function 'kotlin.takeIf' call
      var tmp_2;
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(selectedActivityType)) {
        tmp_2 = selectedActivityType;
      } else {
        tmp_2 = null;
      }
      var tmp$ret$0 = tmp_2;
      tmp_1 = listOfNotNull(tmp$ret$0);
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!get_registeredActivityTypesForFilter().r()) {
        tmp_1 = toList_0(get_registeredActivityTypesForFilter());
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_3;
        // Inline function 'kotlin.text.isNotBlank' call
        if (!isBlank(selectedActivityType)) {
          tmp_3 = selectedActivityType;
        } else {
          tmp_3 = null;
        }
        var tmp$ret$4 = tmp_3;
        tmp_1 = listOfNotNull(tmp$ret$4);
      }
    }
    var activityTypes = tmp_1;
    if (activityTypes.r()) {
      if (showValidationErrors) {
        showError(status, I18n_getInstance().e28('discover.selectActivityTypeError'));
      }
      return Unit_instance;
    }
    var tmp_4 = document.getElementById('discover-latitude');
    var latitude = toDoubleOrNull((tmp_4 instanceof HTMLInputElement ? tmp_4 : THROW_CCE()).value);
    var tmp_5 = document.getElementById('discover-longitude');
    var longitude = toDoubleOrNull((tmp_5 instanceof HTMLInputElement ? tmp_5 : THROW_CCE()).value);
    if (latitude == null || longitude == null) {
      if (showValidationErrors) {
        showError(status, I18n_getInstance().e28('discover.selectLocationError'));
      }
      return Unit_instance;
    }
    var radiusKm = currentRadiusKm();
    var tmp_6 = get_AppScope();
    launch(tmp_6, VOID, VOID, runDiscoverSearch$slambda_0(activityTypes, latitude, longitude, radiusKm, status, null));
  }
  function fetchActivityCenters(activityType, latitude, longitude, radiusKm, $completion) {
    var tmp = new $fetchActivityCentersCOROUTINE$(activityType, latitude, longitude, radiusKm, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function renderDiscoverResultsStatus(status, centers) {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp;
    if (centers.r()) {
      tmp = I18n_getInstance().e28('discover.noResults');
    } else {
      tmp = I18n_getInstance().e28('discover.resultsFoundPrefix') + centers.z() + I18n_getInstance().e28('discover.resultsFoundSuffix');
    }
    status.textContent = tmp;
  }
  function wireDiscoverPage$lambda($modal) {
    return function (it) {
      $modal.showModal();
      return Unit_instance;
    };
  }
  function wireDiscoverPage$lambda_0($modal) {
    return function (it) {
      $modal.close();
      return Unit_instance;
    };
  }
  function wireDiscoverPage$lambda_1($modal) {
    return function (event) {
      event.preventDefault();
      $modal.close();
      recenterMapFromFields();
      runDiscoverSearch(true);
      return Unit_instance;
    };
  }
  function wireDiscoverPage$lambda_2(it) {
    _init_properties_DiscoverPage_kt__qya3so();
    set_activityTypeExplicitlySelected(true);
    return Unit_instance;
  }
  function wireDiscoverPage$lambda_3(lat, lon) {
    _init_properties_DiscoverPage_kt__qya3so();
    onDiscoverMapMoved(lat, lon);
    return Unit_instance;
  }
  function loadRegisteredActivitiesForFilter$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadRegisteredActivitiesForFilter$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadRegisteredActivitiesForFilter$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadRegisteredActivitiesForFilter$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/my-registered-activities';
            this.g3g_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.g3g_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtSet), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().da(), arrayOf([]), false))]), false));
            tmp_0.f3g_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.f3g_1 = emptySet();
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var registered = this.f3g_1;
            set_registeredActivityTypesForFilter(registered);
            var tmp_3 = document.getElementById('discoverActivityTypeShowAll');
            (tmp_3 instanceof HTMLButtonElement ? tmp_3 : THROW_CCE()).disabled = registered.r();
            setDiscoverActivityTypeShowAll(registered.r());
            var tmp0_safe_receiver = firstOrNull(registered);
            if (tmp0_safe_receiver == null)
              null;
            else {
              var tmp_4 = document.getElementById('discoverActivityType');
              (tmp_4 instanceof HTMLSelectElement ? tmp_4 : THROW_CCE()).value = tmp0_safe_receiver;
            }

            runDiscoverSearch(false);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadRegisteredActivitiesForFilter$slambda).h22 = function ($this$launch, completion) {
    var i = new loadRegisteredActivitiesForFilter$slambda(completion);
    i.e3g_1 = $this$launch;
    return i;
  };
  function loadRegisteredActivitiesForFilter$slambda_0(resultContinuation) {
    var i = new loadRegisteredActivitiesForFilter$slambda(resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function initializeMapCenter$lambda(position) {
    _init_properties_DiscoverPage_kt__qya3so();
    var tmp = position.coords.latitude;
    var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
    var tmp_1 = position.coords.longitude;
    onInitialLocationKnown(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE());
    return Unit_instance;
  }
  function initializeMapCenter$lambda_0(_unused_var__etf5q3) {
    _init_properties_DiscoverPage_kt__qya3so();
    fallbackToCloudFrontLocation();
    return Unit_instance;
  }
  function fallbackToCloudFrontLocation$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(fallbackToCloudFrontLocation$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(fallbackToCloudFrontLocation$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(fallbackToCloudFrontLocation$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/discover/my-location';
            this.r3g_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.r3g_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(MyLocationResponse), arrayOf([]), true));
            tmp_0.q3g_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.q3g_1 = null;
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            var location = this.q3g_1;
            if (location == null)
              null;
            else {
              onInitialLocationKnown(location.v2j_1, location.w2j_1);
            }

            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(fallbackToCloudFrontLocation$slambda).h22 = function ($this$launch, completion) {
    var i = new fallbackToCloudFrontLocation$slambda(completion);
    i.p3g_1 = $this$launch;
    return i;
  };
  function fallbackToCloudFrontLocation$slambda_0(resultContinuation) {
    var i = new fallbackToCloudFrontLocation$slambda(resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function onInitialLocationKnown$lambda(lat, lon) {
    _init_properties_DiscoverPage_kt__qya3so();
    onDiscoverMapMoved(lat, lon);
    return Unit_instance;
  }
  function recenterMapFromFields$lambda(lat, lon) {
    _init_properties_DiscoverPage_kt__qya3so();
    onDiscoverMapMoved(lat, lon);
    return Unit_instance;
  }
  function onDiscoverMapMoved$lambda() {
    _init_properties_DiscoverPage_kt__qya3so();
    runDiscoverSearch(false);
    return Unit_instance;
  }
  function runDiscoverSearch$slambda($activityTypes, $latitude, $longitude, $radiusKm, $status, resultContinuation) {
    this.a3h_1 = $activityTypes;
    this.b3h_1 = $latitude;
    this.c3h_1 = $longitude;
    this.d3h_1 = $radiusKm;
    this.e3h_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(runDiscoverSearch$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(runDiscoverSearch$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(runDiscoverSearch$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 5;
            this.u7_1 = 4;
            var tmp0 = this.a3h_1;
            this.g3h_1 = ArrayList_init_$Create$();
            this.h3h_1 = tmp0.t();
            this.t7_1 = 1;
            continue $sm;
          case 1:
            if (!this.h3h_1.u()) {
              this.t7_1 = 3;
              continue $sm;
            }

            var element = this.h3h_1.v();
            this.t7_1 = 2;
            suspendResult = fetchActivityCenters(element, this.b3h_1, this.c3h_1, this.d3h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var list = suspendResult;
            addAll(this.g3h_1, list);
            this.t7_1 = 1;
            continue $sm;
          case 3:
            var this_0 = this.g3h_1;
            var set = HashSet_init_$Create$();
            var list_0 = ArrayList_init_$Create$();
            var _iterator__ex2g4s = this_0.t();
            while (_iterator__ex2g4s.u()) {
              var e = _iterator__ex2g4s.v();
              var key = e.n2j_1;
              if (set.x(key)) {
                list_0.x(e);
              }
            }

            var centers = list_0;
            renderDiscoverResultsStatus(this.e3h_1, centers);
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(centers, 10));
            var _iterator__ex2g4s_0 = centers.t();
            while (_iterator__ex2g4s_0.u()) {
              var item = _iterator__ex2g4s_0.v();
              destination.x(to(item.q2j_1, item.r2j_1));
            }

            updateDiscoverMapCenters(destination);
            refreshAdCarousel('discoverPhotosColumn', 'discoverAdsColumn', this.b3h_1, this.c3h_1, this.d3h_1);
            this.u7_1 = 5;
            this.t7_1 = 6;
            continue $sm;
          case 4:
            this.u7_1 = 5;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e_0 = this.w7_1;
              showError(this.e3h_1, e_0.k2c_1);
              this.t7_1 = 6;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_1 = this.w7_1;
                showError(this.e3h_1, I18n_getInstance().e28('discover.genericErrorPrefix') + e_1.message);
                this.t7_1 = 6;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 5:
            throw this.w7_1;
          case 6:
            this.u7_1 = 5;
            return Unit_instance;
        }
      } catch ($p) {
        var e_2 = $p;
        if (this.u7_1 === 5) {
          throw e_2;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_2;
        }
      }
     while (true);
  };
  protoOf(runDiscoverSearch$slambda).h22 = function ($this$launch, completion) {
    var i = new runDiscoverSearch$slambda(this.a3h_1, this.b3h_1, this.c3h_1, this.d3h_1, this.e3h_1, completion);
    i.f3h_1 = $this$launch;
    return i;
  };
  function runDiscoverSearch$slambda_0($activityTypes, $latitude, $longitude, $radiusKm, $status, resultContinuation) {
    var i = new runDiscoverSearch$slambda($activityTypes, $latitude, $longitude, $radiusKm, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function $fetchActivityCentersCOROUTINE$(activityType, latitude, longitude, radiusKm, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r3f_1 = activityType;
    this.s3f_1 = latitude;
    this.t3f_1 = longitude;
    this.u3f_1 = radiusKm;
  }
  protoOf($fetchActivityCentersCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/discover/activity-centers?activityType=' + this.r3f_1 + '&lat=' + this.s3f_1 + '&lon=' + this.t3f_1 + '&radiusKm=' + this.u3f_1;
            this.v3f_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.v3f_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ActivityCenterResponse), arrayOf([]), false))]), false));
            return this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
          case 2:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 2) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_DiscoverPage_kt_w6e6e2;
  function _init_properties_DiscoverPage_kt__qya3so() {
    if (!properties_initialized_DiscoverPage_kt_w6e6e2) {
      properties_initialized_DiscoverPage_kt_w6e6e2 = true;
      registeredActivityTypesForFilter = emptySet();
      discoverMoveDebounceHandle = null;
      activityTypeExplicitlySelected = false;
    }
  }
  function ForgotPasswordPageModule$init$lambda(event) {
    event.preventDefault();
    submitForgotPasswordRequest();
    return Unit_instance;
  }
  function ForgotPasswordPageModule() {
  }
  protoOf(ForgotPasswordPageModule).r28 = function () {
    var tmp = document.getElementById('forgotPasswordForm');
    var tmp_0 = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    tmp_0.addEventListener('submit', ForgotPasswordPageModule$init$lambda);
  };
  var ForgotPasswordPageModule_instance;
  function ForgotPasswordPageModule_getInstance() {
    return ForgotPasswordPageModule_instance;
  }
  function submitForgotPasswordRequest() {
    var tmp = document.getElementById('forgotPasswordStatus');
    var statusBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    statusBox.textContent = '';
    var tmp_0 = document.getElementById('forgotPasswordEmail');
    var email = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, submitForgotPasswordRequest$slambda_0(email, statusBox, null));
  }
  function submitForgotPasswordRequest$slambda($email, $statusBox, resultContinuation) {
    this.q3h_1 = $email;
    this.r3h_1 = $statusBox;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitForgotPasswordRequest$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitForgotPasswordRequest$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitForgotPasswordRequest$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/auth/forgot-password';
            var body = new ForgotPasswordRequest(this.q3h_1);
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(ForgotPasswordRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.r3h_1.textContent = 'If that email has an account, a password reset link is on its way.';
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof Error) {
              var e = this.w7_1;
              this.r3h_1.textContent = 'If that email has an account, a password reset link is on its way.';
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitForgotPasswordRequest$slambda).h22 = function ($this$launch, completion) {
    var i = new submitForgotPasswordRequest$slambda(this.q3h_1, this.r3h_1, completion);
    i.s3h_1 = $this$launch;
    return i;
  };
  function submitForgotPasswordRequest$slambda_0($email, $statusBox, resultContinuation) {
    var i = new submitForgotPasswordRequest$slambda($email, $statusBox, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function HomePageModule() {
  }
  protoOf(HomePageModule).r28 = function () {
    if (AuthState_instance.y27()) {
      get_moduleNavigateTo()('/discover');
    }
  };
  var HomePageModule_instance;
  function HomePageModule_getInstance() {
    return HomePageModule_instance;
  }
  function set_editingAuthorityId(_set____db54di) {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    editingAuthorityId = _set____db54di;
  }
  function get_editingAuthorityId() {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    return editingAuthorityId;
  }
  var editingAuthorityId;
  function set_loadedAuthorities_0(_set____db54di) {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    loadedAuthorities_0 = _set____db54di;
  }
  function get_loadedAuthorities_0() {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    return loadedAuthorities_0;
  }
  var loadedAuthorities_0;
  function loadAuthorities_0() {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    var tmp = document.getElementById('issuingAuthorityList');
    var listEl = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('issuingAuthoritiesIncludeInactive');
    var includeInactive = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).checked;
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, loadAuthorities$slambda_2(includeInactive, listEl, null));
  }
  function applyAuthorityFilters() {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    var tmp = document.getElementById('issuingAuthorityList');
    var listEl = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('issuingAuthoritiesQuery');
    // Inline function 'kotlin.text.trim' call
    var this_0 = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var query = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE())).toLowerCase();
    var country = countryInputValue('issuingAuthoritiesCountryFilter');
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_loadedAuthorities_0();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp_1;
      var tmp_2;
      if (isBlank(query)) {
        tmp_2 = true;
      } else {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$6 = element.a2n_1.toLowerCase();
        tmp_2 = contains(tmp$ret$6, query);
      }
      if (tmp_2) {
        tmp_1 = country == null || element.b2n_1 == country;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        destination.x(element);
      }
    }
    var filtered = destination;
    var tmp_3;
    if (filtered.r()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_3 = !get_loadedAuthorities_0().r();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      listEl.innerHTML = '';
      append(listEl, applyAuthorityFilters$lambda);
    } else {
      renderAuthorityList(listEl, filtered);
    }
  }
  function renderAuthorityList(listEl, authorities) {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    listEl.innerHTML = '';
    if (authorities.r()) {
      append(listEl, renderAuthorityList$lambda);
      return Unit_instance;
    }
    append(listEl, renderAuthorityList$lambda_0(authorities));
  }
  function authorityRow(_this__u8e3s4, authority) {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    // Inline function 'kotlinx.html.tr' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new TR(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_1.j1f().a1h(this_1);
    this_1.n1f(authority.a2n_1);
    if (!authority.d2n_1) {
      // Inline function 'kotlinx.html.span' call
      var classes = 'badge badge-rejected';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new SPAN(attributesMapOf_0('class', classes), this_1.j1f());
      this_2.j1f().a1h(this_2);
      var tmp0 = this_2.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'issuingAuthorities.inactiveBadge';
      tmp0.m2(tmp2, value);
      this_2.n1f(I18n_getInstance().e28('issuingAuthorities.inactiveBadge'));
      this_2.j1f().b1h(this_2);
    }
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_3.j1f().a1h(this_3);
    var tmp0_safe_receiver = authority.b2n_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = countryDisplayName(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    this_3.n1f(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
    this_3.j1f().b1h(this_3);
    // Inline function 'kotlinx.html.td' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_4 = new TD(attributesMapOf_0('class', null), this_0.j1f());
    this_4.j1f().a1h(this_4);
    var tmp0_elvis_lhs = authority.c2n_1;
    this_4.n1f(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
    this_4.j1f().b1h(this_4);
    // Inline function 'kotlinx.html.td' call
    var classes_0 = 'table-row-actions';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_5 = new TD(attributesMapOf_0('class', classes_0), this_0.j1f());
    this_5.j1f().a1h(this_5);
    // Inline function 'kotlinx.html.button' call
    var classes_1 = 'icon-button';
    var tmp_0 = null == null ? null : enumEncode(null);
    var tmp_1 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_6 = new BUTTON(attributesMapOf(['formenctype', tmp_0, 'formmethod', tmp_1, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_1]), this_5.j1f());
    this_6.j1f().a1h(this_6);
    var tmp0_0 = this_6.l1f();
    // Inline function 'kotlin.collections.set' call
    var value_0 = I18n_getInstance().e28('issuingAuthorities.editButton');
    tmp0_0.m2('title', value_0);
    var tmp0_1 = this_6.l1f();
    var tmp2_0 = 'aria-label';
    // Inline function 'kotlin.collections.set' call
    var value_1 = I18n_getInstance().e28('issuingAuthorities.editButton');
    tmp0_1.m2(tmp2_0, value_1);
    set_onClickFunction(this_6, authorityRow$lambda(authority));
    uiIcon(this_6, 'edit');
    this_6.j1f().b1h(this_6);
    if (authority.d2n_1) {
      // Inline function 'kotlinx.html.button' call
      var classes_2 = 'icon-button icon-button-danger';
      var tmp_2 = null == null ? null : enumEncode(null);
      var tmp_3 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_7 = new BUTTON(attributesMapOf(['formenctype', tmp_2, 'formmethod', tmp_3, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_2]), this_5.j1f());
      this_7.j1f().a1h(this_7);
      var tmp0_2 = this_7.l1f();
      // Inline function 'kotlin.collections.set' call
      var value_2 = I18n_getInstance().e28('issuingAuthorities.removeButton');
      tmp0_2.m2('title', value_2);
      var tmp0_3 = this_7.l1f();
      var tmp2_1 = 'aria-label';
      // Inline function 'kotlin.collections.set' call
      var value_3 = I18n_getInstance().e28('issuingAuthorities.removeButton');
      tmp0_3.m2(tmp2_1, value_3);
      set_onClickFunction(this_7, authorityRow$lambda_0(authority));
      uiIcon(this_7, 'delete');
      this_7.j1f().b1h(this_7);
    }
    this_5.j1f().b1h(this_5);
    this_0.j1f().b1h(this_0);
  }
  function removeAuthority(authority) {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, removeAuthority$slambda_0(authority, null));
  }
  function startEditingAuthority(authority) {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    set_editingAuthorityId(authority.z2m_1);
    var tmp = document.getElementById('authorityFormHeading');
    (tmp instanceof HTMLElement ? tmp : THROW_CCE()).textContent = I18n_getInstance().e28('issuingAuthorities.editAuthorityPrefix') + '"' + authority.a2n_1 + '"';
    var tmp_0 = document.getElementById('authorityName');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = authority.a2n_1;
    setCountryInputValue('authorityCountry', authority.b2n_1);
    var tmp_1 = document.getElementById('authorityWebsite');
    var tmp_2 = tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE();
    var tmp0_elvis_lhs = authority.c2n_1;
    tmp_2.value = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var tmp_3 = document.getElementById('authorityActive');
    (tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).checked = authority.d2n_1;
    var tmp_4 = document.getElementById('authorityModal');
    (tmp_4 instanceof HTMLDialogElement ? tmp_4 : THROW_CCE()).showModal();
  }
  function resetAuthorityForm_0() {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    set_editingAuthorityId(null);
    var tmp = document.getElementById('authorityFormHeading');
    (tmp instanceof HTMLElement ? tmp : THROW_CCE()).textContent = I18n_getInstance().e28('issuingAuthorities.newAuthorityHeading');
    var tmp_0 = document.getElementById('authorityName');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = '';
    var tmp_1 = document.getElementById('authorityCountry');
    (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value = '';
    var tmp_2 = document.getElementById('authorityWebsite');
    (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value = '';
    var tmp_3 = document.getElementById('authorityActive');
    (tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).checked = true;
    var tmp_4 = document.getElementById('authorityStatus');
    clearStatus(tmp_4 instanceof HTMLElement ? tmp_4 : THROW_CCE());
  }
  function submitAuthorityForm() {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    var tmp = document.getElementById('authorityStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('authorityName');
    var name = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var country = countryInputValue('authorityCountry');
    var tmp_1 = document.getElementById('authorityWebsite');
    // Inline function 'kotlin.text.ifBlank' call
    var this_0 = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    var tmp_2;
    if (isBlank(this_0)) {
      tmp_2 = null;
    } else {
      tmp_2 = this_0;
    }
    var website = tmp_2;
    var tmp_3 = document.getElementById('authorityActive');
    var active = (tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).checked;
    var currentEditId = get_editingAuthorityId();
    var tmp_4 = get_AppScope();
    launch(tmp_4, VOID, VOID, submitAuthorityForm$slambda_0(currentEditId, name, country, website, status, active, null));
  }
  function IssuingAuthoritiesPageModule$init$lambda($authorityModal) {
    return function (it) {
      resetAuthorityForm_0();
      $authorityModal.showModal();
      return Unit_instance;
    };
  }
  function IssuingAuthoritiesPageModule$init$lambda_0($authorityModal) {
    return function (it) {
      $authorityModal.close();
      return Unit_instance;
    };
  }
  function IssuingAuthoritiesPageModule$init$lambda_1(it) {
    resetAuthorityForm_0();
    return Unit_instance;
  }
  function IssuingAuthoritiesPageModule$init$lambda_2(event) {
    event.preventDefault();
    submitAuthorityForm();
    return Unit_instance;
  }
  function IssuingAuthoritiesPageModule$init$lambda_3(event) {
    event.preventDefault();
    applyAuthorityFilters();
    return Unit_instance;
  }
  function IssuingAuthoritiesPageModule$init$lambda_4(it) {
    applyAuthorityFilters();
    return Unit_instance;
  }
  function IssuingAuthoritiesPageModule$init$lambda_5(it) {
    loadAuthorities_0();
    return Unit_instance;
  }
  function IssuingAuthoritiesPageModule() {
  }
  protoOf(IssuingAuthoritiesPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    set_editingAuthorityId(null);
    var tmp = document.getElementById('authorityModal');
    var authorityModal = tmp instanceof HTMLDialogElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('openAuthorityModalButton');
    var tmp_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    tmp_1.addEventListener('click', IssuingAuthoritiesPageModule$init$lambda(authorityModal));
    var tmp_2 = document.getElementById('cancelAuthorityModalButton');
    var tmp_3 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
    tmp_3.addEventListener('click', IssuingAuthoritiesPageModule$init$lambda_0(authorityModal));
    authorityModal.addEventListener('close', IssuingAuthoritiesPageModule$init$lambda_1);
    var tmp_4 = document.getElementById('authorityForm');
    var tmp_5 = tmp_4 instanceof HTMLElement ? tmp_4 : THROW_CCE();
    tmp_5.addEventListener('submit', IssuingAuthoritiesPageModule$init$lambda_2);
    var tmp_6 = document.getElementById('issuingAuthoritiesFilterForm');
    var tmp_7 = tmp_6 instanceof HTMLElement ? tmp_6 : THROW_CCE();
    tmp_7.addEventListener('submit', IssuingAuthoritiesPageModule$init$lambda_3);
    var tmp_8 = document.getElementById('issuingAuthoritiesQuery');
    var tmp_9 = tmp_8 instanceof HTMLElement ? tmp_8 : THROW_CCE();
    tmp_9.addEventListener('input', IssuingAuthoritiesPageModule$init$lambda_4);
    var tmp_10 = document.getElementById('issuingAuthoritiesIncludeInactive');
    var tmp_11 = tmp_10 instanceof HTMLElement ? tmp_10 : THROW_CCE();
    tmp_11.addEventListener('change', IssuingAuthoritiesPageModule$init$lambda_5);
    wireCountryPicker('authorityCountry');
    wireCountryPicker('issuingAuthoritiesCountryFilter');
    renderCountryOptions('authorityCountry');
    renderCountryOptions('issuingAuthoritiesCountryFilter');
    loadAuthorities_0();
  };
  var IssuingAuthoritiesPageModule_instance;
  function IssuingAuthoritiesPageModule_getInstance() {
    return IssuingAuthoritiesPageModule_instance;
  }
  function loadAuthorities$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('issuingAuthorities.loadErrorPrefix') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadAuthorities$slambda$lambda_0($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      var tmp = I18n_getInstance().e28('issuingAuthorities.loadErrorPrefix');
      var tmp0_elvis_lhs = $e.message;
      this_0.n1f(tmp + (tmp0_elvis_lhs == null ? $e.toString() : tmp0_elvis_lhs));
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadAuthorities$slambda_1($includeInactive, $listEl, resultContinuation) {
    this.b3i_1 = $includeInactive;
    this.c3i_1 = $listEl;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadAuthorities$slambda_1).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadAuthorities$slambda_1).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadAuthorities$slambda_1).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var includeInactiveParam = this.b3i_1 ? '?includeInactive=true' : '';
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/issuing-authorities' + includeInactiveParam;
            this.f3i_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.f3i_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(IssuingAuthorityResponse), arrayOf([]), false))]), false));
            var authorities = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            set_loadedAuthorities_0(authorities);
            var tmp_0 = this;
            applyAuthorityFilters();
            tmp_0.e3i_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.c3i_1.innerHTML = '';
              tmp_2.e3i_1 = append(this.c3i_1, loadAuthorities$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_3 = this.w7_1;
              if (tmp_3 instanceof Error) {
                var e_0 = this.w7_1;
                var tmp_4 = this;
                this.c3i_1.innerHTML = '';
                tmp_4.e3i_1 = append(this.c3i_1, loadAuthorities$slambda$lambda_0(e_0));
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(loadAuthorities$slambda_1).h22 = function ($this$launch, completion) {
    var i = new loadAuthorities$slambda_1(this.b3i_1, this.c3i_1, completion);
    i.d3i_1 = $this$launch;
    return i;
  };
  function loadAuthorities$slambda_2($includeInactive, $listEl, resultContinuation) {
    var i = new loadAuthorities$slambda_1($includeInactive, $listEl, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function applyAuthorityFilters$lambda($this$append) {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'issuingAuthorities.noMatchingAuthorities';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('issuingAuthorities.noMatchingAuthorities'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderAuthorityList$lambda($this$append) {
    _init_properties_IssuingAuthoritiesPage_kt__iteh6u();
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'issuingAuthorities.noAuthoritiesYet';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('issuingAuthorities.noAuthoritiesYet'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderAuthorityList$lambda_0($authorities) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.table' call
      var classes = 'listing-table';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new TABLE(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.tr' call
      var classes_0 = 'listing-table-head-row';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new TR(attributesMapOf_0('class', classes_0), this_0.j1f());
      this_1.j1f().a1h(this_1);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_2.j1f().a1h(this_2);
      var tmp0 = this_2.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'issuingAuthorities.nameColumn';
      tmp0.m2(tmp2, value);
      this_2.n1f(I18n_getInstance().e28('issuingAuthorities.nameColumn'));
      this_2.j1f().b1h(this_2);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_3.j1f().a1h(this_3);
      var tmp0_0 = this_3.l1f();
      var tmp2_0 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_0 = 'issuingAuthorities.countryColumn';
      tmp0_0.m2(tmp2_0, value_0);
      this_3.n1f(I18n_getInstance().e28('issuingAuthorities.countryColumn'));
      this_3.j1f().b1h(this_3);
      // Inline function 'kotlinx.html.th' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_4 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_4.j1f().a1h(this_4);
      var tmp0_1 = this_4.l1f();
      var tmp2_1 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_1 = 'issuingAuthorities.websiteColumn';
      tmp0_1.m2(tmp2_1, value_1);
      this_4.n1f(I18n_getInstance().e28('issuingAuthorities.websiteColumn'));
      this_4.j1f().b1h(this_4);
      // Inline function 'kotlinx.html.th' call
      var classes_1 = 'table-row-actions';
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_5 = new TH(attributesMapOf(['scope', null == null ? null : enumEncode(null), 'class', classes_1]), this_1.j1f());
      this_5.j1f().a1h(this_5);
      var tmp0_2 = this_5.l1f();
      var tmp2_2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value_2 = 'issuingAuthorities.actionsColumn';
      tmp0_2.m2(tmp2_2, value_2);
      this_5.n1f(I18n_getInstance().e28('issuingAuthorities.actionsColumn'));
      this_5.j1f().b1h(this_5);
      this_1.j1f().b1h(this_1);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $authorities.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        authorityRow(this_0, element);
      }
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function authorityRow$lambda($authority) {
    return function (it) {
      startEditingAuthority($authority);
      return Unit_instance;
    };
  }
  function authorityRow$lambda$lambda($authority) {
    return function () {
      removeAuthority($authority);
      return Unit_instance;
    };
  }
  function authorityRow$lambda_0($authority) {
    return function (it) {
      var tmp = I18n_getInstance().e28('issuingAuthorities.deleteConfirmPrefix') + '"' + $authority.a2n_1 + '"' + I18n_getInstance().e28('issuingAuthorities.deleteConfirmSuffix');
      requestConfirmation('deleteAuthorityConfirm', tmp, authorityRow$lambda$lambda($authority));
      return Unit_instance;
    };
  }
  function removeAuthority$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('issuingAuthorities.removeErrorPrefix') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function removeAuthority$slambda($authority, resultContinuation) {
    this.o3i_1 = $authority;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(removeAuthority$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(removeAuthority$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(removeAuthority$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = ApiClient_getInstance().a2x('/api/v1/bitacora/issuing-authorities/' + this.o3i_1.z2m_1, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            loadAuthorities_0();
            tmp_0.q3i_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              var tmp_3 = document.getElementById('issuingAuthorityList');
              var tmp_4 = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
              tmp_2.q3i_1 = append(tmp_4, removeAuthority$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(removeAuthority$slambda).h22 = function ($this$launch, completion) {
    var i = new removeAuthority$slambda(this.o3i_1, completion);
    i.p3i_1 = $this$launch;
    return i;
  };
  function removeAuthority$slambda_0($authority, resultContinuation) {
    var i = new removeAuthority$slambda($authority, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitAuthorityForm$slambda($currentEditId, $name, $country, $website, $status, $active, resultContinuation) {
    this.z3i_1 = $currentEditId;
    this.a3j_1 = $name;
    this.b3j_1 = $country;
    this.c3j_1 = $website;
    this.d3j_1 = $status;
    this.e3j_1 = $active;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitAuthorityForm$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitAuthorityForm$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitAuthorityForm$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 5;
            this.u7_1 = 4;
            if (this.z3i_1 == null) {
              var tmp0 = ApiClient_getInstance();
              var tmp2 = '/api/v1/bitacora/issuing-authorities';
              var body = new RegisterIssuingAuthorityRequest(this.a3j_1, this.b3j_1, this.c3j_1);
              this.g3j_1 = tmp0.f27_1;
              this.t7_1 = 2;
              var this_0 = tmp0.f27_1;
              var this_1 = this_0.um();
              var this_2 = serializer(this_1, createKType(getKClass(RegisterIssuingAuthorityRequest), arrayOf([]), false));
              suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp0_0 = ApiClient_getInstance();
              var tmp2_0 = '/api/v1/bitacora/issuing-authorities/' + this.z3i_1;
              var body_0 = new UpdateIssuingAuthorityRequest(this.a3j_1, this.b3j_1, this.c3j_1, this.e3j_1);
              this.h3j_1 = tmp0_0.f27_1;
              this.t7_1 = 1;
              var this_3 = tmp0_0.f27_1;
              var this_4 = this_3.um();
              var this_5 = serializer(this_4, createKType(getKClass(UpdateIssuingAuthorityRequest), arrayOf([]), false));
              suspendResult = tmp0_0.g27('PUT', tmp2_0, this_3.h13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), body_0), true, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp2_1 = suspendResult;
            var this_6 = this.h3j_1;
            var this_7 = this_6.um();
            var this_8 = serializer(this_7, createKType(getKClass(IssuingAuthorityResponse), arrayOf([]), false));
            this_6.i13(isInterface(this_8, KSerializer) ? this_8 : THROW_CCE(), tmp2_1);
            this.d3j_1.textContent = I18n_getInstance().e28('issuingAuthorities.authorityUpdatedStatus');
            this.t7_1 = 3;
            continue $sm;
          case 2:
            var tmp2_2 = suspendResult;
            var this_9 = this.g3j_1;
            var this_10 = this_9.um();
            var this_11 = serializer(this_10, createKType(getKClass(IssuingAuthorityResponse), arrayOf([]), false));
            this_9.i13(isInterface(this_11, KSerializer) ? this_11 : THROW_CCE(), tmp2_2);
            this.d3j_1.textContent = I18n_getInstance().e28('issuingAuthorities.authorityAddedStatus');
            this.t7_1 = 3;
            continue $sm;
          case 3:
            loadAuthorities_0();
            var tmp_0 = document.getElementById('authorityModal');
            (tmp_0 instanceof HTMLDialogElement ? tmp_0 : THROW_CCE()).close();
            this.u7_1 = 5;
            this.t7_1 = 6;
            continue $sm;
          case 4:
            this.u7_1 = 5;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.d3j_1, e.k2c_1);
              this.t7_1 = 6;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 5:
            throw this.w7_1;
          case 6:
            this.u7_1 = 5;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 5) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitAuthorityForm$slambda).h22 = function ($this$launch, completion) {
    var i = new submitAuthorityForm$slambda(this.z3i_1, this.a3j_1, this.b3j_1, this.c3j_1, this.d3j_1, this.e3j_1, completion);
    i.f3j_1 = $this$launch;
    return i;
  };
  function submitAuthorityForm$slambda_0($currentEditId, $name, $country, $website, $status, $active, resultContinuation) {
    var i = new submitAuthorityForm$slambda($currentEditId, $name, $country, $website, $status, $active, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  var properties_initialized_IssuingAuthoritiesPage_kt_187spw;
  function _init_properties_IssuingAuthoritiesPage_kt__iteh6u() {
    if (!properties_initialized_IssuingAuthoritiesPage_kt_187spw) {
      properties_initialized_IssuingAuthoritiesPage_kt_187spw = true;
      editingAuthorityId = null;
      loadedAuthorities_0 = emptyList();
    }
  }
  function LeaderboardPageModule() {
  }
  protoOf(LeaderboardPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    loadRegisteredActivitiesForLeaderboard();
  };
  var LeaderboardPageModule_instance;
  function LeaderboardPageModule_getInstance() {
    return LeaderboardPageModule_instance;
  }
  function loadRegisteredActivitiesForLeaderboard() {
    var tmp = document.getElementById('leaderboardControls');
    var controls = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('leaderboardContent');
    var content = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, loadRegisteredActivitiesForLeaderboard$slambda_0(controls, content, null));
  }
  function loadLeaderboard(activityType) {
    var tmp = document.getElementById('leaderboardContent');
    var content = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    content.innerHTML = '';
    append(content, loadLeaderboard$lambda);
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadLeaderboard$slambda_0(activityType, content, null));
  }
  function isEmpty(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.g2k_1.r() && _this__u8e3s4.i2k_1.r()) {
      var tmp0_safe_receiver = _this__u8e3s4.h2k_1;
      tmp = !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r()) === false);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function renderLeaderboardResult(content, result) {
    content.innerHTML = '';
    var periods = listOf([to('leaderboard.period.week', result.l2k_1), to('leaderboard.period.month', result.m2k_1), to('leaderboard.period.year', result.n2k_1)]);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(periods, Collection)) {
        tmp = periods.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = periods.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var snapshot = element.h9();
        if (!isEmpty(snapshot)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    if (tmp$ret$0) {
      append(content, renderLeaderboardResult$lambda);
      return Unit_instance;
    }
    append(content, renderLeaderboardResult$lambda_0(periods));
  }
  function formatKm_0(meters) {
    var hundredthsOfKm = numberToLong(round(meters / 10.0));
    // Inline function 'kotlin.Long.div' call
    var whole = divide(hundredthsOfKm, fromInt(100));
    // Inline function 'kotlin.Long.rem' call
    var tmp$ret$1 = modulo(hundredthsOfKm, fromInt(100));
    var fraction = padStart(tmp$ret$1.toString(), 2, _Char___init__impl__6a9atx(48));
    return whole.toString() + '.' + fraction + ' km';
  }
  function formatDurationSeconds(totalSeconds) {
    var seconds = numberToInt(totalSeconds);
    var hours = seconds / 3600 | 0;
    var minutes = (seconds % 3600 | 0) / 60 | 0;
    return hours > 0 ? '' + hours + 'h ' + minutes + 'm' : '' + minutes + 'm';
  }
  function sam$kotlin_Comparator$0_3(function_0) {
    this.i3j_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_3).cc = function (a, b) {
    return this.i3j_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_3).compare = function (a, b) {
    return this.cc(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_3).c3 = function () {
    return this.i3j_1;
  };
  protoOf(sam$kotlin_Comparator$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.c3(), other.c3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_3).hashCode = function () {
    return hashCode(this.c3());
  };
  function loadRegisteredActivitiesForLeaderboard$slambda$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'leaderboard.noRegisteredActivities';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('leaderboard.noRegisteredActivities'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function loadRegisteredActivitiesForLeaderboard$slambda$lambda$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = activityTypeLabel(valueOf(a));
    var tmp$ret$2 = activityTypeLabel(valueOf(b));
    return compareValues(tmp, tmp$ret$2);
  }
  function loadRegisteredActivitiesForLeaderboard$slambda$lambda_0($registered) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.label' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new LABEL(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.span' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new SPAN(attributesMapOf_0('class', null), this_0.j1f());
      this_1.j1f().a1h(this_1);
      var tmp0 = this_1.l1f();
      var tmp2 = 'data-i18n';
      // Inline function 'kotlin.collections.set' call
      var value = 'leaderboard.activityType';
      tmp0.m2(tmp2, value);
      this_1.n1f(I18n_getInstance().e28('leaderboard.activityType'));
      this_1.j1f().b1h(this_1);
      // Inline function 'kotlinx.html.select' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new SELECT(attributesMapOf_0('class', null), this_0.j1f());
      this_2.j1f().a1h(this_2);
      set_id(this_2, 'leaderboardActivityType');
      // Inline function 'kotlin.collections.sortedBy' call
      var this_3 = $registered;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp = loadRegisteredActivitiesForLeaderboard$slambda$lambda$lambda;
      var tmp$ret$18 = new sam$kotlin_Comparator$0_3(tmp);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = sortedWith(this_3, tmp$ret$18).t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.option' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_4 = new OPTION(attributesMapOf_0('class', null), this_2.j1f());
        this_4.j1f().a1h(this_4);
        this_4.d1m(element);
        this_4.n1f(activityTypeLabel(valueOf(element)));
        this_4.j1f().b1h(this_4);
      }
      this_2.j1f().b1h(this_2);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadRegisteredActivitiesForLeaderboard$slambda$lambda_1($activityTypeSelect) {
    return function (it) {
      loadLeaderboard($activityTypeSelect.value);
      return Unit_instance;
    };
  }
  function loadRegisteredActivitiesForLeaderboard$slambda($controls, $content, resultContinuation) {
    this.r3j_1 = $controls;
    this.s3j_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadRegisteredActivitiesForLeaderboard$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadRegisteredActivitiesForLeaderboard$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadRegisteredActivitiesForLeaderboard$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/my-registered-activities';
            this.v3j_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.v3j_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtSet), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().da(), arrayOf([]), false))]), false));
            var ARGUMENT = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u3j_1 = toList_0(ARGUMENT);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof Error) {
              var e = this.w7_1;
              var tmp_1 = this;
              tmp_1.u3j_1 = emptyList();
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var registered = this.u3j_1;
            if (registered.r()) {
              this.r3j_1.innerHTML = '';
              this.s3j_1.innerHTML = '';
              append(this.s3j_1, loadRegisteredActivitiesForLeaderboard$slambda$lambda);
              return Unit_instance;
            }

            this.r3j_1.innerHTML = '';
            append(this.r3j_1, loadRegisteredActivitiesForLeaderboard$slambda$lambda_0(registered));
            var tmp_2 = document.getElementById('leaderboardActivityType');
            var activityTypeSelect = tmp_2 instanceof HTMLSelectElement ? tmp_2 : THROW_CCE();
            var reload = loadRegisteredActivitiesForLeaderboard$slambda$lambda_1(activityTypeSelect);
            activityTypeSelect.onchange = reload;
            loadLeaderboard(activityTypeSelect.value);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadRegisteredActivitiesForLeaderboard$slambda).h22 = function ($this$launch, completion) {
    var i = new loadRegisteredActivitiesForLeaderboard$slambda(this.r3j_1, this.s3j_1, completion);
    i.t3j_1 = $this$launch;
    return i;
  };
  function loadRegisteredActivitiesForLeaderboard$slambda_0($controls, $content, resultContinuation) {
    var i = new loadRegisteredActivitiesForLeaderboard$slambda($controls, $content, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function loadLeaderboard$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    this_0.n1f('\u2026');
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function loadLeaderboard$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f($e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadLeaderboard$slambda$lambda_0($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f('Could not load the leaderboard: ' + $e.message);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadLeaderboard$slambda($activityType, $content, resultContinuation) {
    this.e3k_1 = $activityType;
    this.f3k_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadLeaderboard$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadLeaderboard$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadLeaderboard$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/leaderboard?activityType=' + this.e3k_1;
            this.i3k_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.i3k_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(LeaderboardResponse), arrayOf([]), false));
            var result = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            renderLeaderboardResult(this.f3k_1, result);
            tmp_0.h3k_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.f3k_1.innerHTML = '';
              tmp_2.h3k_1 = append(this.f3k_1, loadLeaderboard$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_3 = this.w7_1;
              if (tmp_3 instanceof Error) {
                var e_0 = this.w7_1;
                var tmp_4 = this;
                this.f3k_1.innerHTML = '';
                tmp_4.h3k_1 = append(this.f3k_1, loadLeaderboard$slambda$lambda_0(e_0));
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(loadLeaderboard$slambda).h22 = function ($this$launch, completion) {
    var i = new loadLeaderboard$slambda(this.e3k_1, this.f3k_1, completion);
    i.g3k_1 = $this$launch;
    return i;
  };
  function loadLeaderboard$slambda_0($activityType, $content, resultContinuation) {
    var i = new loadLeaderboard$slambda($activityType, $content, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderLeaderboardResult$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'leaderboard.empty';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('leaderboard.empty'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderLeaderboardResult$lambda_0($periods) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $periods.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var periodLabelKey = element.g9();
        var snapshot = element.h9();
        // Inline function 'kotlinx.html.div' call
        var classes = 'leaderboard-period';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        // Inline function 'kotlinx.html.h3' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_1 = new H3(attributesMapOf_0('class', null), this_0.j1f());
        this_1.j1f().a1h(this_1);
        var tmp0 = this_1.l1f();
        // Inline function 'kotlin.collections.set' call
        var key = 'data-i18n';
        tmp0.m2(key, periodLabelKey);
        this_1.n1f(I18n_getInstance().e28(periodLabelKey));
        this_1.j1f().b1h(this_1);
        if (isEmpty(snapshot)) {
          // Inline function 'kotlinx.html.p' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_2 = new P(attributesMapOf_0('class', null), this_0.j1f());
          this_2.j1f().a1h(this_2);
          var tmp0_0 = this_2.l1f();
          var tmp2 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value = 'leaderboard.empty';
          tmp0_0.m2(tmp2, value);
          this_2.n1f(I18n_getInstance().e28('leaderboard.empty'));
          this_2.j1f().b1h(this_2);
        } else {
          // Inline function 'kotlinx.html.div' call
          var classes_0 = 'leaderboard-columns';
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_3 = new DIV(attributesMapOf_0('class', classes_0), this_0.j1f());
          this_3.j1f().a1h(this_3);
          // Inline function 'kotlinx.html.div' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_4 = new DIV(attributesMapOf_0('class', null), this_3.j1f());
          this_4.j1f().a1h(this_4);
          // Inline function 'kotlinx.html.h4' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_5 = new H4(attributesMapOf_0('class', null), this_4.j1f());
          this_5.j1f().a1h(this_5);
          var tmp0_1 = this_5.l1f();
          var tmp2_0 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value_0 = 'leaderboard.byEventCount';
          tmp0_1.m2(tmp2_0, value_0);
          this_5.n1f(I18n_getInstance().e28('leaderboard.byEventCount'));
          this_5.j1f().b1h(this_5);
          // Inline function 'kotlinx.html.ol' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_6 = new OL(attributesMapOf_0('class', null), this_4.j1f());
          this_6.j1f().a1h(this_6);
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = snapshot.g2k_1.t();
          while (_iterator__ex2g4s_0.u()) {
            var element_0 = _iterator__ex2g4s_0.v();
            // Inline function 'kotlinx.html.li' call
            // Inline function 'kotlinx.html.visit' call
            // Inline function 'kotlinx.html.visitTag' call
            var this_7 = new LI(attributesMapOf_0('class', null), this_6.j1f());
            this_7.j1f().a1h(this_7);
            this_7.n1f(element_0.b2k_1 + ' \u2014 ' + numberToInt(element_0.c2k_1));
            this_7.j1f().b1h(this_7);
          }
          this_6.j1f().b1h(this_6);
          this_4.j1f().b1h(this_4);
          if (!(snapshot.h2k_1 == null)) {
            // Inline function 'kotlinx.html.div' call
            // Inline function 'kotlinx.html.visit' call
            // Inline function 'kotlinx.html.visitTag' call
            var this_8 = new DIV(attributesMapOf_0('class', null), this_3.j1f());
            this_8.j1f().a1h(this_8);
            // Inline function 'kotlinx.html.h4' call
            // Inline function 'kotlinx.html.visit' call
            // Inline function 'kotlinx.html.visitTag' call
            var this_9 = new H4(attributesMapOf_0('class', null), this_8.j1f());
            this_9.j1f().a1h(this_9);
            var tmp0_2 = this_9.l1f();
            var tmp2_1 = 'data-i18n';
            // Inline function 'kotlin.collections.set' call
            var value_1 = 'leaderboard.byDistance';
            tmp0_2.m2(tmp2_1, value_1);
            this_9.n1f(I18n_getInstance().e28('leaderboard.byDistance'));
            this_9.j1f().b1h(this_9);
            // Inline function 'kotlinx.html.ol' call
            // Inline function 'kotlinx.html.visit' call
            // Inline function 'kotlinx.html.visitTag' call
            var this_10 = new OL(attributesMapOf_0('class', null), this_8.j1f());
            this_10.j1f().a1h(this_10);
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s_1 = snapshot.h2k_1.t();
            while (_iterator__ex2g4s_1.u()) {
              var element_1 = _iterator__ex2g4s_1.v();
              // Inline function 'kotlinx.html.li' call
              // Inline function 'kotlinx.html.visit' call
              // Inline function 'kotlinx.html.visitTag' call
              var this_11 = new LI(attributesMapOf_0('class', null), this_10.j1f());
              this_11.j1f().a1h(this_11);
              this_11.n1f(element_1.b2k_1 + ' \u2014 ' + formatKm_0(element_1.c2k_1));
              this_11.j1f().b1h(this_11);
            }
            this_10.j1f().b1h(this_10);
            this_8.j1f().b1h(this_8);
          }
          // Inline function 'kotlinx.html.div' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_12 = new DIV(attributesMapOf_0('class', null), this_3.j1f());
          this_12.j1f().a1h(this_12);
          // Inline function 'kotlinx.html.h4' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_13 = new H4(attributesMapOf_0('class', null), this_12.j1f());
          this_13.j1f().a1h(this_13);
          var tmp0_3 = this_13.l1f();
          var tmp2_2 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value_2 = 'leaderboard.byTime';
          tmp0_3.m2(tmp2_2, value_2);
          this_13.n1f(I18n_getInstance().e28('leaderboard.byTime'));
          this_13.j1f().b1h(this_13);
          // Inline function 'kotlinx.html.ol' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_14 = new OL(attributesMapOf_0('class', null), this_12.j1f());
          this_14.j1f().a1h(this_14);
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_2 = snapshot.i2k_1.t();
          while (_iterator__ex2g4s_2.u()) {
            var element_2 = _iterator__ex2g4s_2.v();
            // Inline function 'kotlinx.html.li' call
            // Inline function 'kotlinx.html.visit' call
            // Inline function 'kotlinx.html.visitTag' call
            var this_15 = new LI(attributesMapOf_0('class', null), this_14.j1f());
            this_15.j1f().a1h(this_15);
            this_15.n1f(element_2.b2k_1 + ' \u2014 ' + formatDurationSeconds(element_2.c2k_1));
            this_15.j1f().b1h(this_15);
          }
          this_14.j1f().b1h(this_14);
          this_12.j1f().b1h(this_12);
          this_3.j1f().b1h(this_3);
        }
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function set_registeredActivityTypesForFilter_0(_set____db54di) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    registeredActivityTypesForFilter_0 = _set____db54di;
  }
  function get_registeredActivityTypesForFilter_0() {
    _init_properties_LogActivityPage_kt__ihwpyo();
    return registeredActivityTypesForFilter_0;
  }
  var registeredActivityTypesForFilter_0;
  function set_instructorSearchTimeoutHandle(_set____db54di) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    instructorSearchTimeoutHandle = _set____db54di;
  }
  function get_instructorSearchTimeoutHandle() {
    _init_properties_LogActivityPage_kt__ihwpyo();
    return instructorSearchTimeoutHandle;
  }
  var instructorSearchTimeoutHandle;
  function onEntryPhotosSelected() {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp = document.getElementById('logActivityStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('entryPhotos');
    var input = tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE();
    var tmp_1 = document.getElementById('entryPhotosPreview');
    var preview = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    preview.innerHTML = '';
    var files = input.files;
    if (files == null || files.length === 0)
      return Unit_instance;
    if (files.length > 5) {
      showError(status, I18n_getInstance().e28('logActivity.tooManyPhotosError'));
      input.value = '';
      return Unit_instance;
    }
    clearStatus(status);
    var inductionVariable = 0;
    var last = files.length;
    if (inductionVariable < last)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = files.item(i);
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var file = tmp_2;
        append(preview, onEntryPhotosSelected$lambda(file));
      }
       while (inductionVariable < last);
  }
  function loadRegisteredActivitiesForFilter_0() {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, loadRegisteredActivitiesForFilter$slambda_2(null));
  }
  function applyActivityTypeFilter() {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp = document.getElementById('activityTypeShowAll');
    var showAll = (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).checked;
    var tmp_0 = document.getElementById('activityType');
    var select = tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE();
    var inductionVariable = 0;
    var last = select.options.length;
    if (inductionVariable < last)
      $l$loop_0: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp_1 = select.options.item(i);
        var tmp0_elvis_lhs = tmp_1 instanceof HTMLOptionElement ? tmp_1 : null;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var option = tmp_2;
        if (isBlank(option.value))
          continue $l$loop_0;
        option.hidden = (!showAll && !get_registeredActivityTypesForFilter_0().c2(option.value));
      }
       while (inductionVariable < last);
  }
  function minAttributeValue(field, alternate) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp;
    if (field.l25_1) {
      tmp = 1.0E-4;
    } else if (!field.k25_1) {
      var tmp0_elvis_lhs = alternate ? field.p25_1 : field.o25_1;
      tmp = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    } else {
      tmp = alternate ? field.p25_1 : field.o25_1;
    }
    return tmp;
  }
  function showFieldsFor(activityType) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var schema = isBlank(activityType) ? null : activitySchema(activityType);
    var tmp1_safe_receiver = schema == null ? null : schema.v25_1;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_safe_receiver, 10));
      var _iterator__ex2g4s = tmp1_safe_receiver.t();
      while (_iterator__ex2g4s.u()) {
        var item = _iterator__ex2g4s.v();
        var tmp$ret$2 = item.q25_1;
        destination.x(tmp$ret$2);
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toSet(tmp2_safe_receiver);
    var visibleKeys = tmp3_elvis_lhs == null ? emptySet() : tmp3_elvis_lhs;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = get_ACTIVITY_FIELD_GROUPS().t();
    while (_iterator__ex2g4s_0.u()) {
      var element = _iterator__ex2g4s_0.v();
      var tmp_0 = document.getElementById('fields-' + element.q25_1);
      var element_0 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
      var isVisible = visibleKeys.c2(element.q25_1);
      if (isVisible) {
        element_0.classList.remove('hidden');
      } else {
        element_0.classList.add('hidden');
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_1 = element.s25_1.t();
      while (_iterator__ex2g4s_1.u()) {
        var element_1 = _iterator__ex2g4s_1.v();
        $l$block: {
          if (element_1.f25_1.equals(OutputMode_FIXED_getInstance())) {
            break $l$block;
          }
          var tmp_1 = document.getElementById(element_1.c25_1);
          var input = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.js.asDynamic' call
          input.disabled = !isVisible;
          if (element_1.h25_1) {
            // Inline function 'kotlin.js.asDynamic' call
            input.required = isVisible;
          }
          if (element_1.n25_1 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp_2 = document.getElementById(element_1.c25_1 + 'Unit');
            // Inline function 'kotlin.js.asDynamic' call
            (tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE()).disabled = !isVisible;
          }
        }
      }
    }
    var tmp5_elvis_lhs = schema == null ? null : schema.w25_1;
    var requiresInstructor = tmp5_elvis_lhs == null ? false : tmp5_elvis_lhs;
    var tmp_3 = document.getElementById('instructorField');
    var instructorField = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
    var tmp_4 = document.getElementById('instructorUserId');
    var instructorInput = tmp_4 instanceof HTMLInputElement ? tmp_4 : THROW_CCE();
    if (requiresInstructor) {
      instructorField.classList.remove('hidden');
    } else {
      instructorField.classList.add('hidden');
    }
    instructorInput.disabled = !requiresInstructor;
    instructorInput.required = requiresInstructor;
    resetInstructorSelection();
  }
  function resetInstructorSelection() {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp = document.getElementById('instructorSearch');
    (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value = '';
    var tmp_0 = document.getElementById('instructorUserId');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = '';
    var tmp_1 = document.getElementById('instructorSuggestions');
    (tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE()).innerHTML = '';
  }
  function onInstructorSearchInput() {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp0_safe_receiver = get_instructorSearchTimeoutHandle();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      window.clearTimeout(tmp0_safe_receiver);
    }
    var tmp = document.getElementById('activityType');
    var activityType = (tmp instanceof HTMLSelectElement ? tmp : THROW_CCE()).value;
    var tmp_0 = document.getElementById('instructorSearch');
    var query = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    if (isBlank(activityType))
      return Unit_instance;
    var tmp_1 = window;
    set_instructorSearchTimeoutHandle(tmp_1.setTimeout(onInstructorSearchInput$lambda(activityType, query), 300));
  }
  function runInstructorSearch(activityType, query) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, runInstructorSearch$slambda_0(activityType, query, null));
  }
  function renderInstructorSuggestions(results) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp = document.getElementById('instructorSuggestions');
    var container = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    container.innerHTML = '';
    if (results.r()) {
      var item = document.createElement('li');
      item.textContent = I18n_getInstance().e28('logActivity.noInstructorCandidates');
      container.appendChild(item);
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = results.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var item_0 = document.createElement('li');
      item_0.textContent = element.n2i_1;
      item_0.addEventListener('click', renderInstructorSuggestions$lambda(element, container));
      container.appendChild(item_0);
    }
  }
  function nowAsDateTimeLocal() {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var iso = (new Date()).toISOString();
    return substring(iso, 0, 16);
  }
  function textOf(id) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp = document.getElementById(id);
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = (tmp instanceof HTMLElement ? tmp : THROW_CCE()).value;
    return (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
  }
  function numberOrNull(id) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    return toDoubleOrNull(textOf(id));
  }
  function intOrNull(id) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    return toIntOrNull(textOf(id));
  }
  function isAlternateUnitSelected(field) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp;
    if (!(field.n25_1 == null)) {
      var tmp_0 = document.getElementById(field.c25_1 + 'Unit');
      var tmp0_safe_receiver = tmp_0 instanceof HTMLSelectElement ? tmp_0 : null;
      tmp = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.value) === 'alternate';
    } else {
      tmp = false;
    }
    return tmp;
  }
  function convertedNumberOrNull(field) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp0_elvis_lhs = numberOrNull(field.c25_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var raw = tmp;
    var tmp1_elvis_lhs = field.n25_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return raw;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var dimension = tmp_0;
    return isAlternateUnitSelected(field) ? dimension.b25_1(raw) : raw;
  }
  function convertedIntOrNull(field) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp0_elvis_lhs = intOrNull(field.c25_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var raw = tmp;
    var tmp1_elvis_lhs = field.n25_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return raw;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var dimension = tmp_0;
    return isAlternateUnitSelected(field) ? roundToInt(dimension.b25_1(raw)) : raw;
  }
  function listFromCsv(id) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    // Inline function 'kotlin.collections.map' call
    var this_0 = split(textOf(id), [',']);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$2 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
      destination.x(tmp$ret$2);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.t();
    while (_iterator__ex2g4s_0.u()) {
      var element = _iterator__ex2g4s_0.v();
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination_0.x(element);
      }
    }
    return destination_0;
  }
  function numberListFromCsv(id) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = split(textOf(id), [',']);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$5 = toString(trim(isCharSequence(element) ? element : THROW_CCE()));
      var tmp0_safe_receiver = toDoubleOrNull(tmp$ret$5);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.x(tmp0_safe_receiver);
      }
    }
    return destination;
  }
  function checkedOf(id) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp = document.getElementById(id);
    return (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).checked;
  }
  function buildParameters(activityType) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var schema = activitySchema(activityType);
    // Inline function 'kotlinx.serialization.json.buildJsonObject' call
    var builder = new JsonObjectBuilder();
    put(builder, 'type', activityType);
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = schema.v25_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var list = element.s25_1;
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      switch (element_0.f25_1.t2_1) {
        case 5:
          var tmp1_elvis_lhs = element_0.j25_1;
          put_0(builder, element_0.g25_1, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs);
          break;
        case 1:
          put(builder, element_0.g25_1, textOf(element_0.c25_1));
          break;
        case 2:
          if (element_0.e25_1.equals(FieldKind_INT_getInstance())) {
            var tmp2_elvis_lhs = convertedIntOrNull(element_0);
            put_0(builder, element_0.g25_1, tmp2_elvis_lhs == null ? numberToInt(element_0.i25_1) : tmp2_elvis_lhs);
          } else {
            var tmp3_elvis_lhs = convertedNumberOrNull(element_0);
            put_0(builder, element_0.g25_1, tmp3_elvis_lhs == null ? element_0.i25_1 : tmp3_elvis_lhs);
          }

          break;
        case 3:
          if (element_0.e25_1.equals(FieldKind_CSV_NUMBER_LIST_getInstance())) {
            // Inline function 'kotlin.collections.map' call
            var this_0 = numberListFromCsv(element_0.c25_1);
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s_1 = this_0.t();
            while (_iterator__ex2g4s_1.u()) {
              var item = _iterator__ex2g4s_1.v();
              var tmp$ret$9 = JsonPrimitive_0(item);
              destination_0.x(tmp$ret$9);
            }
            builder.w15(element_0.g25_1, new JsonArray(destination_0));
          } else {
            // Inline function 'kotlin.collections.map' call
            var this_1 = listFromCsv(element_0.c25_1);
            // Inline function 'kotlin.collections.mapTo' call
            var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s_2 = this_1.t();
            while (_iterator__ex2g4s_2.u()) {
              var item_0 = _iterator__ex2g4s_2.v();
              var tmp$ret$12 = JsonPrimitive(item_0);
              destination_1.x(tmp$ret$12);
            }
            builder.w15(element_0.g25_1, new JsonArray(destination_1));
          }

          break;
        case 4:
          put_1(builder, element_0.g25_1, checkedOf(element_0.c25_1));
          break;
        case 0:
          switch (element_0.e25_1.t2_1) {
            case 1:
              var tmp5_safe_receiver = convertedNumberOrNull(element_0);
              if (tmp5_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                put_0(builder, element_0.g25_1, tmp5_safe_receiver);
              }

              break;
            case 2:
              var tmp6_safe_receiver = convertedIntOrNull(element_0);
              if (tmp6_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                put_0(builder, element_0.g25_1, tmp6_safe_receiver);
              }

              break;
            default:
              // Inline function 'kotlin.text.ifBlank' call

              var this_2 = textOf(element_0.c25_1);
              var tmp;
              if (isBlank(this_2)) {
                tmp = null;
              } else {
                tmp = this_2;
              }

              var tmp7_safe_receiver = tmp;
              if (tmp7_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                put(builder, element_0.g25_1, tmp7_safe_receiver);
              }

              break;
          }

          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
    return builder.q14();
  }
  function deviceTrackFormatFromFileName(name) {
    _init_properties_LogActivityPage_kt__ihwpyo();
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    switch (substringAfterLast(name, _Char___init__impl__6a9atx(46), '').toLowerCase()) {
      case 'gpx':
        return 'GPX';
      case 'tcx':
        return 'TCX';
      case 'igc':
        return 'IGC';
      case 'uddf':
        return 'UDDF';
      case 'fit':
        return 'FIT';
      default:
        return null;
    }
  }
  function submitLogActivity() {
    _init_properties_LogActivityPage_kt__ihwpyo();
    var tmp = document.getElementById('logActivityStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('activityType');
    var activityType = (tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE()).value;
    if (isBlank(activityType)) {
      showError(status, I18n_getInstance().e28('logActivity.selectActivityTypeError'));
      return Unit_instance;
    }
    var tmp_1;
    if (activitySchema(activityType).w25_1) {
      var selected = textOf('instructorUserId');
      if (isBlank(selected)) {
        showError(status, I18n_getInstance().e28('logActivity.selectInstructorError'));
        return Unit_instance;
      }
      tmp_1 = selected;
    } else {
      tmp_1 = null;
    }
    var instructorUserId = tmp_1;
    var tmp_2 = document.getElementById('startedAt');
    var startedAt = (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value;
    var tmp_3 = document.getElementById('endedAt');
    var endedAt = (tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).value;
    if (isBlank(startedAt) || isBlank(endedAt)) {
      showError(status, I18n_getInstance().e28('logActivity.loggedAtRequiredError'));
      return Unit_instance;
    }
    if (compareTo(endedAt, nowAsDateTimeLocal()) > 0) {
      showError(status, I18n_getInstance().e28('logActivity.loggedAtFutureError'));
      return Unit_instance;
    }
    if (compareTo(endedAt, startedAt) < 0) {
      showError(status, I18n_getInstance().e28('logActivity.endedBeforeStartedError'));
      return Unit_instance;
    }
    if (activityType === 'TECHNICAL_DIVER') {
      var tmp0_elvis_lhs = numberOrNull('bottomMixOxygenPercent');
      var oxygenPercent = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = numberOrNull('bottomMixHeliumPercent');
      var heliumPercent = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
      if (oxygenPercent + heliumPercent > 100.0) {
        showError(status, I18n_getInstance().e28('logActivity.techDive.gasMixPercentExceeds100Error'));
        return Unit_instance;
      }
    }
    var tmp_4 = document.getElementById('notes');
    // Inline function 'kotlin.text.ifBlank' call
    var this_0 = (tmp_4 instanceof HTMLTextAreaElement ? tmp_4 : THROW_CCE()).value;
    var tmp_5;
    if (isBlank(this_0)) {
      tmp_5 = null;
    } else {
      tmp_5 = this_0;
    }
    var notes = tmp_5;
    var tmp_6 = document.getElementById('trackFile');
    var tmp2_safe_receiver = (tmp_6 instanceof HTMLInputElement ? tmp_6 : THROW_CCE()).files;
    var tmp_7;
    if (tmp2_safe_receiver == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_7 = tmp2_safe_receiver.length > 0 ? tmp2_safe_receiver.item(0) : null;
    }
    var trackFile = tmp_7;
    var tmp_8;
    if (trackFile == null) {
      tmp_8 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_8 = deviceTrackFormatFromFileName(trackFile.name);
    }
    var trackFormat = tmp_8;
    if (!(trackFile == null) && trackFormat == null) {
      showError(status, I18n_getInstance().e28('logActivity.unrecognizedTrackFileType'));
      return Unit_instance;
    }
    var tmp_9 = document.getElementById('entryPhotos');
    var photoFiles = (tmp_9 instanceof HTMLInputElement ? tmp_9 : THROW_CCE()).files;
    var tmp_10 = get_AppScope();
    launch(tmp_10, VOID, VOID, submitLogActivity$slambda_0(instructorUserId, activityType, startedAt, endedAt, notes, status, trackFile, trackFormat, photoFiles, null));
  }
  function importTrackFile(entryId, format, file, $completion) {
    var tmp = new $importTrackFileCOROUTINE$(entryId, format, file, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function LogActivityPageModule$init$lambda(event) {
    var tmp = event.target;
    showFieldsFor((tmp instanceof HTMLSelectElement ? tmp : THROW_CCE()).value);
    return Unit_instance;
  }
  function LogActivityPageModule$init$lambda_0(it) {
    applyActivityTypeFilter();
    return Unit_instance;
  }
  function LogActivityPageModule$init$lambda_1(it) {
    onInstructorSearchInput();
    return Unit_instance;
  }
  function LogActivityPageModule$init$lambda_2(it) {
    onEntryPhotosSelected();
    return Unit_instance;
  }
  function LogActivityPageModule$init$lambda_3($field) {
    return function (event) {
      var tmp = document.getElementById($field.c25_1);
      var numberInput = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
      var tmp_0 = event.target;
      var isAlternate = (tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE()).value === 'alternate';
      var min = minAttributeValue($field, isAlternate);
      var tmp_1;
      if (!(min == null)) {
        numberInput.min = min.toString();
        tmp_1 = Unit_instance;
      } else {
        numberInput.removeAttribute('min');
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function LogActivityPageModule$init$lambda_4(event) {
    event.preventDefault();
    submitLogActivity();
    return Unit_instance;
  }
  function LogActivityPageModule() {
  }
  protoOf(LogActivityPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    var tmp = document.getElementById('activityType');
    appendActivityTypeOptions(tmp instanceof HTMLSelectElement ? tmp : THROW_CCE());
    var tmp_0 = document.getElementById('startedAt');
    (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = nowAsDateTimeLocal();
    var tmp_1 = document.getElementById('endedAt');
    (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value = nowAsDateTimeLocal();
    showFieldsFor('');
    var tmp_2 = document.getElementById('activityType');
    var tmp_3 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
    tmp_3.addEventListener('change', LogActivityPageModule$init$lambda);
    var tmp_4 = document.getElementById('activityTypeShowAll');
    var tmp_5 = tmp_4 instanceof HTMLElement ? tmp_4 : THROW_CCE();
    tmp_5.addEventListener('change', LogActivityPageModule$init$lambda_0);
    var tmp_6 = document.getElementById('instructorSearch');
    var tmp_7 = tmp_6 instanceof HTMLElement ? tmp_6 : THROW_CCE();
    tmp_7.addEventListener('input', LogActivityPageModule$init$lambda_1);
    var tmp_8 = document.getElementById('entryPhotos');
    var tmp_9 = tmp_8 instanceof HTMLElement ? tmp_8 : THROW_CCE();
    tmp_9.addEventListener('change', LogActivityPageModule$init$lambda_2);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = get_ACTIVITY_FIELD_GROUPS().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = element.s25_1.t();
      while (_iterator__ex2g4s_0.u()) {
        var element_0 = _iterator__ex2g4s_0.v();
        $l$block: {
          if (element_0.n25_1 == null) {
            break $l$block;
          }
          var tmp_10 = document.getElementById(element_0.c25_1 + 'Unit');
          var unitSelect = tmp_10 instanceof HTMLElement ? tmp_10 : THROW_CCE();
          unitSelect.addEventListener('change', LogActivityPageModule$init$lambda_3(element_0));
        }
      }
    }
    wireLocationSearchPicker('');
    var tmp_11 = document.getElementById('logActivityForm');
    var tmp_12 = tmp_11 instanceof HTMLElement ? tmp_11 : THROW_CCE();
    tmp_12.addEventListener('submit', LogActivityPageModule$init$lambda_4);
    loadRegisteredActivitiesForFilter_0();
  };
  var LogActivityPageModule_instance;
  function LogActivityPageModule_getInstance() {
    return LogActivityPageModule_instance;
  }
  function uploadEntryPhotos(entryId, files, $completion) {
    var tmp = new $uploadEntryPhotosCOROUTINE$(entryId, files, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function onEntryPhotosSelected$lambda($file) {
    return function ($this$append) {
      var tmp4 = URL.createObjectURL($file);
      // Inline function 'kotlinx.html.img' call
      var classes = 'photo-preview-thumb';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new IMG(attributesMapOf(['alt', '', 'src', tmp4, 'loading', null == null ? null : enumEncode(null), 'class', classes]), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadRegisteredActivitiesForFilter$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadRegisteredActivitiesForFilter$slambda_1).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadRegisteredActivitiesForFilter$slambda_1).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadRegisteredActivitiesForFilter$slambda_1).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/my-registered-activities';
            this.y3l_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.y3l_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtSet), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().da(), arrayOf([]), false))]), false));
            tmp_0.x3l_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.x3l_1 = emptySet();
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var registered = this.x3l_1;
            set_registeredActivityTypesForFilter_0(registered);
            var tmp_3 = document.getElementById('activityTypeShowAll');
            var showAllCheckbox = tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE();
            showAllCheckbox.checked = registered.r();
            showAllCheckbox.disabled = registered.r();
            applyActivityTypeFilter();
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadRegisteredActivitiesForFilter$slambda_1).h22 = function ($this$launch, completion) {
    var i = new loadRegisteredActivitiesForFilter$slambda_1(completion);
    i.w3l_1 = $this$launch;
    return i;
  };
  function loadRegisteredActivitiesForFilter$slambda_2(resultContinuation) {
    var i = new loadRegisteredActivitiesForFilter$slambda_1(resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function onInstructorSearchInput$lambda($activityType, $query) {
    return function () {
      runInstructorSearch($activityType, $query);
      return Unit_instance;
    };
  }
  function runInstructorSearch$slambda($activityType, $query, resultContinuation) {
    this.h3m_1 = $activityType;
    this.i3m_1 = $query;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(runInstructorSearch$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(runInstructorSearch$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(runInstructorSearch$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/instructors?activityType=' + this.h3m_1 + '&query=' + encodeURIComponent(this.i3m_1);
            this.l3m_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.l3m_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(InstructorCandidateResponse), arrayOf([]), false))]), false));
            tmp_0.k3m_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.k3m_1 = emptyList();
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var results = this.k3m_1;
            renderInstructorSuggestions(results);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(runInstructorSearch$slambda).h22 = function ($this$launch, completion) {
    var i = new runInstructorSearch$slambda(this.h3m_1, this.i3m_1, completion);
    i.j3m_1 = $this$launch;
    return i;
  };
  function runInstructorSearch$slambda_0($activityType, $query, resultContinuation) {
    var i = new runInstructorSearch$slambda($activityType, $query, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderInstructorSuggestions$lambda($candidate, $container) {
    return function (it) {
      var tmp = document.getElementById('instructorUserId');
      (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value = $candidate.m2i_1;
      var tmp_0 = document.getElementById('instructorSearch');
      (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = $candidate.n2i_1;
      $container.innerHTML = '';
      return Unit_instance;
    };
  }
  function submitLogActivity$slambda($instructorUserId, $activityType, $startedAt, $endedAt, $notes, $status, $trackFile, $trackFormat, $photoFiles, resultContinuation) {
    this.u3m_1 = $instructorUserId;
    this.v3m_1 = $activityType;
    this.w3m_1 = $startedAt;
    this.x3m_1 = $endedAt;
    this.y3m_1 = $notes;
    this.z3m_1 = $status;
    this.a3n_1 = $trackFile;
    this.b3n_1 = $trackFormat;
    this.c3n_1 = $photoFiles;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitLogActivity$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitLogActivity$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitLogActivity$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 7;
            this.u7_1 = 6;
            var tmp_0 = valueOf(this.v3m_1);
            var tmp_1 = this.w3m_1 + ':00Z';
            var tmp_2 = this.x3m_1 + ':00Z';
            var tmp_3 = buildParameters(this.v3m_1);
            var tmp_4 = numberOrNull('latitude');
            var tmp_5 = numberOrNull('longitude');
            var this_0 = textOf('locationLabel');
            var tmp_6;
            if (isBlank(this_0)) {
              tmp_6 = null;
            } else {
              tmp_6 = this_0;
            }

            var request = new RegisterOwnBitacoraEntryRequest(this.u3m_1, tmp_0, tmp_1, tmp_2, tmp_3, this.y3m_1, tmp_4, tmp_5, tmp_6);
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/entries';
            this.f3n_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_1 = tmp0.f27_1;
            var this_2 = this_1.um();
            var this_3 = serializer(this_2, createKType(getKClass(RegisterOwnBitacoraEntryRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', path, this_1.h13(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), request), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_7 = this;
            var this_4 = this.f3n_1;
            var this_5 = this_4.um();
            var this_6 = serializer(this_5, createKType(getKClass(BitacoraEntryResponse), arrayOf([]), false));
            tmp_7.e3n_1 = this_4.i13(isInterface(this_6, KSerializer) ? this_6 : THROW_CCE(), tmp2);
            this.z3m_1.textContent = I18n_getInstance().e28('logActivity.submittedAwaitingApproval');
            if (!(this.a3n_1 == null) && !(this.b3n_1 == null)) {
              this.t7_1 = 2;
              suspendResult = importTrackFile(this.e3n_1.h2h_1, this.b3n_1, this.a3n_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.t7_1 = 3;
              continue $sm;
            }

          case 2:
            this.t7_1 = 3;
            continue $sm;
          case 3:
            if (!(this.c3n_1 == null) && this.c3n_1.length > 0) {
              this.t7_1 = 4;
              suspendResult = uploadEntryPhotos(this.e3n_1.h2h_1, this.c3n_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.t7_1 = 5;
              continue $sm;
            }

          case 4:
            this.t7_1 = 5;
            continue $sm;
          case 5:
            this.u7_1 = 7;
            this.t7_1 = 8;
            continue $sm;
          case 6:
            this.u7_1 = 7;
            var tmp_8 = this.w7_1;
            if (tmp_8 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.z3m_1, e.k2c_1);
              this.t7_1 = 8;
              continue $sm;
            } else {
              var tmp_9 = this.w7_1;
              if (tmp_9 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.z3m_1, I18n_getInstance().e28('logActivity.genericErrorPrefix') + e_0.message);
                this.t7_1 = 8;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 7:
            throw this.w7_1;
          case 8:
            this.u7_1 = 7;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 7) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitLogActivity$slambda).h22 = function ($this$launch, completion) {
    var i = new submitLogActivity$slambda(this.u3m_1, this.v3m_1, this.w3m_1, this.x3m_1, this.y3m_1, this.z3m_1, this.a3n_1, this.b3n_1, this.c3n_1, completion);
    i.d3n_1 = $this$launch;
    return i;
  };
  function submitLogActivity$slambda_0($instructorUserId, $activityType, $startedAt, $endedAt, $notes, $status, $trackFile, $trackFormat, $photoFiles, resultContinuation) {
    var i = new submitLogActivity$slambda($instructorUserId, $activityType, $startedAt, $endedAt, $notes, $status, $trackFile, $trackFormat, $photoFiles, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function importTrackFile$lambda($imported) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      var tmp = I18n_getInstance().e28('logActivity.trackProcessedPrefix');
      var tmp0_safe_receiver = $imported.c2i_1.x2h_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d2h_1;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.z();
      this_0.n1f(tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) + I18n_getInstance().e28('logActivity.trackProcessedSuffix'));
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      var tmp_0;
      if (!$imported.d2i_1.r()) {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_1 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_1.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_1.j1f().a1h(this_1);
        var tmp0 = this_1.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = 'logActivity.fromFileHeading';
        tmp0.m2(tmp2, value);
        this_1.n1f(I18n_getInstance().e28('logActivity.fromFileHeading'));
        this_1.j1f().b1h(this_1);
        $this$append.d1h();
        // Inline function 'kotlinx.html.ul' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_2 = new UL(attributesMapOf_0('class', null), $this$append);
        if (!(this_2.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_2.j1f().a1h(this_2);
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = $imported.d2i_1.l2().t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          // Inline function 'kotlin.collections.component1' call
          var key = element.e2();
          // Inline function 'kotlin.collections.component2' call
          var value_0 = element.f2();
          // Inline function 'kotlinx.html.li' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_3 = new LI(attributesMapOf_0('class', null), this_2.j1f());
          this_3.j1f().a1h(this_3);
          this_3.n1f(key + ': ' + value_0);
          this_3.j1f().b1h(this_3);
        }
        this_2.j1f().b1h(this_2);
        $this$append.d1h();
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      var tmp0_safe_receiver_0 = $imported.c2i_1.x2h_1;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.d2h_1;
      var tmp2_elvis_lhs_0 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.z();
      if ((tmp2_elvis_lhs_0 == null ? 0 : tmp2_elvis_lhs_0) > 0) {
        // Inline function 'kotlinx.html.div' call
        var classes = 'map-container';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_4 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_4.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_4.j1f().a1h(this_4);
        set_id(this_4, 'importedTrackMap');
        this_4.j1f().b1h(this_4);
        $this$append.d1h();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function importTrackFile$lambda_0($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('logActivity.trackProcessingFailedPrefix') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function uploadEntryPhotos$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('logActivity.photoUploadFailedPrefix') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function $importTrackFileCOROUTINE$(entryId, format, file, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r3k_1 = entryId;
    this.s3k_1 = format;
    this.t3k_1 = file;
  }
  protoOf($importTrackFileCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            var tmp_0 = this;
            var tmp_1 = document.getElementById('logActivityStatus');
            tmp_0.v3k_1 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
            this.u7_1 = 3;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/entries/' + this.r3k_1 + '/track?format=' + this.s3k_1;
            var tmp4 = this.t3k_1;
            this.w3k_1 = tmp0;
            this.y3k_1 = true;
            var headers = new Headers();
            if (this.y3k_1) {
              var tmp0_safe_receiver = AuthState_instance.y2w();
              if (tmp0_safe_receiver == null)
                null;
              else {
                headers.append('Authorization', 'Bearer ' + tmp0_safe_receiver);
              }
            }

            var init = {};
            init.method = 'PUT';
            init.headers = headers;
            init.body = tmp4;
            this.t7_1 = 1;
            suspendResult = await_0(window.fetch(this.w3k_1.e27_1 + tmp2, init), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x3k_1 = suspendResult;
            this.t7_1 = 2;
            suspendResult = await_0(this.x3k_1.text(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var text = suspendResult;
            if (!this.x3k_1.ok) {
              this.w3k_1.z2w(this.x3k_1.status, this.y3k_1);
              var this_0 = this.w3k_1;
              var tmp_2;
              try {
                var this_1 = this_0.f27_1;
                var this_2 = this_1.um();
                var this_3 = serializer(this_2, createKType(getKClass(ErrorResponse), arrayOf([]), false));
                var value = this_1.i13(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), text);
                tmp_2 = _Result___init__impl__xyqfz8(value);
              } catch ($p) {
                var tmp_3;
                if ($p instanceof Error) {
                  var e = $p;
                  tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
                } else {
                  throw $p;
                }
                tmp_2 = tmp_3;
              }
              var this_4 = tmp_2;
              var parsed = _Result___get_isFailure__impl__jpiriv(this_4) ? null : _Result___get_value__impl__bjfvqg(this_4);
              var tmp_4 = this.x3k_1.status;
              var tmp2_elvis_lhs = parsed == null ? null : parsed.p2c_1;
              var tmp_5;
              if (tmp2_elvis_lhs == null) {
                var tmp_6;
                if (isBlank(text)) {
                  tmp_6 = 'Upload failed';
                } else {
                  tmp_6 = text;
                }
                tmp_5 = tmp_6;
              } else {
                tmp_5 = tmp2_elvis_lhs;
              }
              var tmp_7 = tmp_5;
              throw new ApiException(tmp_4, tmp_7, parsed == null ? null : parsed.q2c_1);
            }

            var this_5 = this.w3k_1.f27_1;
            var this_6 = this_5.um();
            var this_7 = serializer(this_6, createKType(getKClass(TrackImportResponse), arrayOf([]), false));
            var imported = this_5.i13(isInterface(this_7, KSerializer) ? this_7 : THROW_CCE(), text);
            append(this.v3k_1, importTrackFile$lambda(imported));
            var tmp_8 = this;
            var tmp0_safe_receiver_0 = imported.c2i_1.x2h_1;
            var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.d2h_1;
            var tmp_9;
            if (tmp1_safe_receiver == null) {
              tmp_9 = null;
            } else {
              var tmp_10;
              if (!tmp1_safe_receiver.r()) {
                tmp_10 = tmp1_safe_receiver;
              } else {
                tmp_10 = null;
              }
              tmp_9 = tmp_10;
            }

            var tmp2_safe_receiver = tmp_9;
            var tmp_11;
            if (tmp2_safe_receiver == null) {
              tmp_11 = null;
            } else {
              var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_safe_receiver, 10));
              var _iterator__ex2g4s = tmp2_safe_receiver.t();
              while (_iterator__ex2g4s.u()) {
                var item = _iterator__ex2g4s.v();
                destination.x(to(item.v2g_1, item.w2g_1));
              }
              renderMapLibreTrackMap('importedTrackMap', destination);
              tmp_11 = Unit_instance;
            }

            tmp_8.u3k_1 = tmp_11;
            this.u7_1 = 4;
            this.t7_1 = 5;
            continue $sm;
          case 3:
            this.u7_1 = 4;
            var tmp_12 = this.w7_1;
            if (tmp_12 instanceof ApiException) {
              var e_0 = this.w7_1;
              var tmp_13 = this;
              tmp_13.u3k_1 = append(this.v3k_1, importTrackFile$lambda_0(e_0));
              this.t7_1 = 5;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 4:
            throw this.w7_1;
          case 5:
            this.u7_1 = 4;
            return Unit_instance;
        }
      } catch ($p_0) {
        var e_1 = $p_0;
        if (this.u7_1 === 4) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  function $uploadEntryPhotosCOROUTINE$(entryId, files, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h3l_1 = entryId;
    this.i3l_1 = files;
  }
  protoOf($uploadEntryPhotosCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 7;
            var tmp_0 = this;
            var tmp_1 = document.getElementById('logActivityStatus');
            tmp_0.k3l_1 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
            var tmp_2 = this.i3l_1.length;
            var count = (!(tmp_2 == null) ? typeof tmp_2 === 'number' : false) ? tmp_2 : THROW_CCE();
            this.n3l_1 = until(0, count).t();
            this.t7_1 = 1;
            continue $sm;
          case 1:
            if (!this.n3l_1.u()) {
              this.t7_1 = 6;
              continue $sm;
            }

            var i = this.n3l_1.v();
            var file = this.i3l_1[i];
            this.u7_1 = 4;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/entries/' + this.h3l_1 + '/photos';
            this.l3l_1 = tmp0;
            var formData = new FormData();
            formData.append('file', file);
            var headers = new Headers();
            var tmp0_safe_receiver = AuthState_instance.y2w();
            if (tmp0_safe_receiver == null)
              null;
            else {
              headers.append('Authorization', 'Bearer ' + tmp0_safe_receiver);
            }

            var init = {};
            init.method = 'PUT';
            init.headers = headers;
            init.body = formData;
            this.t7_1 = 2;
            suspendResult = await_0(window.fetch(this.l3l_1.e27_1 + tmp2, init), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.m3l_1 = suspendResult;
            this.t7_1 = 3;
            suspendResult = await_0(this.m3l_1.text(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var text = suspendResult;
            if (!this.m3l_1.ok) {
              this.l3l_1.z2w(this.m3l_1.status, true);
              var this_0 = this.l3l_1;
              var tmp_3;
              try {
                var this_1 = this_0.f27_1;
                var this_2 = this_1.um();
                var this_3 = serializer(this_2, createKType(getKClass(ErrorResponse), arrayOf([]), false));
                var value = this_1.i13(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), text);
                tmp_3 = _Result___init__impl__xyqfz8(value);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof Error) {
                  var e = $p;
                  tmp_4 = _Result___init__impl__xyqfz8(createFailure(e));
                } else {
                  throw $p;
                }
                tmp_3 = tmp_4;
              }
              var this_4 = tmp_3;
              var parsed = _Result___get_isFailure__impl__jpiriv(this_4) ? null : _Result___get_value__impl__bjfvqg(this_4);
              var tmp_5 = this.m3l_1.status;
              var tmp2_elvis_lhs = parsed == null ? null : parsed.p2c_1;
              var tmp_6;
              if (tmp2_elvis_lhs == null) {
                var tmp_7;
                if (isBlank(text)) {
                  tmp_7 = 'Upload failed';
                } else {
                  tmp_7 = text;
                }
                tmp_6 = tmp_7;
              } else {
                tmp_6 = tmp2_elvis_lhs;
              }
              var tmp_8 = tmp_6;
              throw new ApiException(tmp_5, tmp_8, parsed == null ? null : parsed.q2c_1);
            }

            var tmp_9 = this;
            var this_5 = this.l3l_1.f27_1;
            var this_6 = this_5.um();
            var this_7 = serializer(this_6, createKType(getKClass(BitacoraEntryResponse), arrayOf([]), false));
            tmp_9.j3l_1 = this_5.i13(isInterface(this_7, KSerializer) ? this_7 : THROW_CCE(), text);
            this.u7_1 = 7;
            this.t7_1 = 5;
            continue $sm;
          case 4:
            this.u7_1 = 7;
            var tmp_10 = this.w7_1;
            if (tmp_10 instanceof ApiException) {
              var e_0 = this.w7_1;
              var tmp_11 = this;
              tmp_11.j3l_1 = append(this.k3l_1, uploadEntryPhotos$lambda(e_0));
              this.t7_1 = 5;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 5:
            this.u7_1 = 7;
            this.t7_1 = 1;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.w7_1;
        }
      } catch ($p_0) {
        var e_1 = $p_0;
        if (this.u7_1 === 7) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  var properties_initialized_LogActivityPage_kt_7pgzhq;
  function _init_properties_LogActivityPage_kt__ihwpyo() {
    if (!properties_initialized_LogActivityPage_kt_7pgzhq) {
      properties_initialized_LogActivityPage_kt_7pgzhq = true;
      registeredActivityTypesForFilter_0 = emptySet();
      instructorSearchTimeoutHandle = null;
    }
  }
  function set_currentCenterCompanyId(_set____db54di) {
    _init_properties_LogCenterActivityPage_kt__8wpzrv();
    currentCenterCompanyId = _set____db54di;
  }
  var currentCenterCompanyId;
  function get_centerActivityTypes() {
    _init_properties_LogCenterActivityPage_kt__8wpzrv();
    return centerActivityTypes;
  }
  var centerActivityTypes;
  function useMyLocationForCenter() {
    _init_properties_LogCenterActivityPage_kt__8wpzrv();
    var tmp = document.getElementById('locationStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    // Inline function 'kotlin.js.asDynamic' call
    var geolocation = window.navigator.geolocation;
    if (geolocation == undefined) {
      status.textContent = I18n_getInstance().e28('location.geolocationNotSupported');
      return Unit_instance;
    }
    status.textContent = I18n_getInstance().e28('location.locating');
    var tmp_0 = useMyLocationForCenter$lambda(status);
    geolocation.getCurrentPosition(tmp_0, useMyLocationForCenter$lambda_0(status));
  }
  function onCenterEntryPhotosSelected() {
    _init_properties_LogCenterActivityPage_kt__8wpzrv();
    var tmp = document.getElementById('logCenterActivityStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('centerEntryPhotos');
    var input = tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE();
    var tmp_1 = document.getElementById('centerEntryPhotosPreview');
    var preview = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    preview.innerHTML = '';
    var files = input.files;
    if (files == null || files.length === 0)
      return Unit_instance;
    if (files.length > 5) {
      showError(status, I18n_getInstance().e28('logActivity.tooManyPhotosError'));
      input.value = '';
      return Unit_instance;
    }
    clearStatus(status);
    var inductionVariable = 0;
    var last = files.length;
    if (inductionVariable < last)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = files.item(i);
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var file = tmp_2;
        append(preview, onCenterEntryPhotosSelected$lambda(file));
      }
       while (inductionVariable < last);
  }
  function showCenterActivityFieldsFor(activityType) {
    _init_properties_LogCenterActivityPage_kt__8wpzrv();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = get_centerActivityTypes().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp = document.getElementById('fields-' + element);
      var element_0 = tmp instanceof HTMLElement ? tmp : THROW_CCE();
      if (element === activityType) {
        element_0.classList.remove('hidden');
      } else {
        element_0.classList.add('hidden');
      }
    }
  }
  function showSubjectFieldsFor(kind) {
    _init_properties_LogCenterActivityPage_kt__8wpzrv();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = listOf(['PRACTITIONER', 'GUEST']).t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp = document.getElementById('subjectFields-' + element);
      var group = tmp instanceof HTMLElement ? tmp : THROW_CCE();
      if (element === kind) {
        group.classList.remove('hidden');
      } else {
        group.classList.add('hidden');
      }
    }
  }
  function submitLogCenterActivity(companyId) {
    _init_properties_LogCenterActivityPage_kt__8wpzrv();
    var tmp = document.getElementById('logCenterActivityStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('subjectKind');
    var subjectKind = (tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('activityType');
    var activityType = (tmp_1 instanceof HTMLSelectElement ? tmp_1 : THROW_CCE()).value;
    var tmp_2 = document.getElementById('startedAt');
    var startedAt = (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value;
    var tmp_3 = document.getElementById('endedAt');
    var endedAt = (tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).value;
    if (isBlank(startedAt) || isBlank(endedAt)) {
      showError(status, I18n_getInstance().e28('logCenterActivity.loggedAtRequiredError'));
      return Unit_instance;
    }
    if (compareTo(endedAt, nowAsDateTimeLocal()) > 0) {
      showError(status, I18n_getInstance().e28('logCenterActivity.loggedAtFutureError'));
      return Unit_instance;
    }
    if (compareTo(endedAt, startedAt) < 0) {
      showError(status, I18n_getInstance().e28('logCenterActivity.endedBeforeStartedError'));
      return Unit_instance;
    }
    var tmp_4 = document.getElementById('notes');
    // Inline function 'kotlin.text.ifBlank' call
    var this_0 = (tmp_4 instanceof HTMLTextAreaElement ? tmp_4 : THROW_CCE()).value;
    var tmp_5;
    if (isBlank(this_0)) {
      tmp_5 = null;
    } else {
      tmp_5 = this_0;
    }
    var notes = tmp_5;
    var tmp_6;
    if (subjectKind === 'PRACTITIONER') {
      // Inline function 'kotlin.text.ifBlank' call
      var this_1 = textOf('practitionerUserId');
      var tmp_7;
      if (isBlank(this_1)) {
        tmp_7 = null;
      } else {
        tmp_7 = this_1;
      }
      tmp_6 = tmp_7;
    } else {
      tmp_6 = null;
    }
    var practitionerUserId = tmp_6;
    var tmp_8;
    if (subjectKind === 'GUEST') {
      // Inline function 'kotlin.text.ifBlank' call
      var this_2 = textOf('guestName');
      var tmp_9;
      if (isBlank(this_2)) {
        tmp_9 = null;
      } else {
        tmp_9 = this_2;
      }
      tmp_8 = tmp_9;
    } else {
      tmp_8 = null;
    }
    var guestName = tmp_8;
    var tmp_10;
    if (subjectKind === 'GUEST') {
      // Inline function 'kotlin.text.ifBlank' call
      var this_3 = textOf('guestEmail');
      var tmp_11;
      if (isBlank(this_3)) {
        tmp_11 = null;
      } else {
        tmp_11 = this_3;
      }
      tmp_10 = tmp_11;
    } else {
      tmp_10 = null;
    }
    var guestEmail = tmp_10;
    var tmp_12 = document.getElementById('centerEntryPhotos');
    var photoFiles = (tmp_12 instanceof HTMLInputElement ? tmp_12 : THROW_CCE()).files;
    var tmp_13 = get_AppScope();
    launch(tmp_13, VOID, VOID, submitLogCenterActivity$slambda_0(practitionerUserId, guestName, guestEmail, activityType, startedAt, endedAt, notes, companyId, status, photoFiles, null));
  }
  function uploadCenterEntryPhotos(entryId, files, $completion) {
    var tmp = new $uploadCenterEntryPhotosCOROUTINE$(entryId, files, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function LogCenterActivityPageModule$init$lambda(event) {
    var tmp = event.target;
    showSubjectFieldsFor((tmp instanceof HTMLSelectElement ? tmp : THROW_CCE()).value);
    return Unit_instance;
  }
  function LogCenterActivityPageModule$init$lambda_0(event) {
    var tmp = event.target;
    showCenterActivityFieldsFor((tmp instanceof HTMLSelectElement ? tmp : THROW_CCE()).value);
    return Unit_instance;
  }
  function LogCenterActivityPageModule$init$lambda_1(it) {
    onCenterEntryPhotosSelected();
    return Unit_instance;
  }
  function LogCenterActivityPageModule$init$lambda_2($field) {
    return function (event) {
      var tmp = document.getElementById($field.c25_1);
      var numberInput = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
      var tmp_0 = event.target;
      var isAlternate = (tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE()).value === 'alternate';
      var min = minAttributeValue($field, isAlternate);
      var tmp_1;
      if (!(min == null)) {
        numberInput.min = min.toString();
        tmp_1 = Unit_instance;
      } else {
        numberInput.removeAttribute('min');
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function LogCenterActivityPageModule$init$lambda_3($companyId) {
    return function (event) {
      event.preventDefault();
      submitLogCenterActivity($companyId);
      return Unit_instance;
    };
  }
  function LogCenterActivityPageModule$init$lambda_4(it) {
    useMyLocationForCenter();
    return Unit_instance;
  }
  function LogCenterActivityPageModule() {
  }
  protoOf(LogCenterActivityPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('companyId');
    var companyId = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    if (isBlank(companyId)) {
      var tmp = document.getElementById('logCenterActivityMissingCompany');
      (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('hidden');
      var tmp_0 = document.getElementById('logCenterActivityContent');
      (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.add('hidden');
      return Unit_instance;
    }
    set_currentCenterCompanyId(companyId);
    var tmp_1 = document.getElementById('startedAt');
    (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value = nowAsDateTimeLocal();
    var tmp_2 = document.getElementById('endedAt');
    (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value = nowAsDateTimeLocal();
    var tmp_3 = document.getElementById('subjectKind');
    var tmp_4 = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
    tmp_4.addEventListener('change', LogCenterActivityPageModule$init$lambda);
    var tmp_5 = document.getElementById('activityType');
    var tmp_6 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
    tmp_6.addEventListener('change', LogCenterActivityPageModule$init$lambda_0);
    var tmp_7 = document.getElementById('centerEntryPhotos');
    var tmp_8 = tmp_7 instanceof HTMLElement ? tmp_7 : THROW_CCE();
    tmp_8.addEventListener('change', LogCenterActivityPageModule$init$lambda_1);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = get_centerActivityTypes().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = first(activitySchema(element).v25_1).s25_1.t();
      while (_iterator__ex2g4s_0.u()) {
        var element_0 = _iterator__ex2g4s_0.v();
        $l$block: {
          if (element_0.n25_1 == null) {
            break $l$block;
          }
          var tmp_9 = document.getElementById(element_0.c25_1 + 'Unit');
          var unitSelect = tmp_9 instanceof HTMLElement ? tmp_9 : THROW_CCE();
          unitSelect.addEventListener('change', LogCenterActivityPageModule$init$lambda_2(element_0));
        }
      }
    }
    var tmp_10 = document.getElementById('logCenterActivityForm');
    var tmp_11 = tmp_10 instanceof HTMLElement ? tmp_10 : THROW_CCE();
    tmp_11.addEventListener('submit', LogCenterActivityPageModule$init$lambda_3(companyId));
    var tmp_12 = document.getElementById('useMyLocationButton');
    var tmp_13 = tmp_12 instanceof HTMLElement ? tmp_12 : THROW_CCE();
    tmp_13.addEventListener('click', LogCenterActivityPageModule$init$lambda_4);
  };
  var LogCenterActivityPageModule_instance;
  function LogCenterActivityPageModule_getInstance() {
    return LogCenterActivityPageModule_instance;
  }
  function useMyLocationForCenter$lambda($status) {
    return function (position) {
      var tmp = document.getElementById('latitude');
      (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value = toString(position.coords.latitude);
      var tmp_0 = document.getElementById('longitude');
      (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value = toString(position.coords.longitude);
      $status.textContent = I18n_getInstance().e28('location.locationCaptured');
      return Unit_instance;
    };
  }
  function useMyLocationForCenter$lambda_0($status) {
    return function (_unused_var__etf5q3) {
      $status.textContent = I18n_getInstance().e28('location.locationError');
      return Unit_instance;
    };
  }
  function onCenterEntryPhotosSelected$lambda($file) {
    return function ($this$append) {
      var tmp4 = URL.createObjectURL($file);
      // Inline function 'kotlinx.html.img' call
      var classes = 'photo-preview-thumb';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new IMG(attributesMapOf(['alt', '', 'src', tmp4, 'loading', null == null ? null : enumEncode(null), 'class', classes]), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function submitLogCenterActivity$slambda($practitionerUserId, $guestName, $guestEmail, $activityType, $startedAt, $endedAt, $notes, $companyId, $status, $photoFiles, resultContinuation) {
    this.d3o_1 = $practitionerUserId;
    this.e3o_1 = $guestName;
    this.f3o_1 = $guestEmail;
    this.g3o_1 = $activityType;
    this.h3o_1 = $startedAt;
    this.i3o_1 = $endedAt;
    this.j3o_1 = $notes;
    this.k3o_1 = $companyId;
    this.l3o_1 = $status;
    this.m3o_1 = $photoFiles;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitLogCenterActivity$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitLogCenterActivity$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitLogCenterActivity$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 5;
            this.u7_1 = 4;
            var request = new RegisterCenterBitacoraEntryRequest(this.d3o_1, this.e3o_1, this.f3o_1, valueOf(this.g3o_1), this.h3o_1 + ':00Z', this.i3o_1 + ':00Z', buildParameters(this.g3o_1), this.j3o_1, numberOrNull('latitude'), numberOrNull('longitude'));
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/companies/' + this.k3o_1 + '/entries';
            this.o3o_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(RegisterCenterBitacoraEntryRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', path, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), request), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_3 = this.o3o_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(BitacoraEntryResponse), arrayOf([]), false));
            var created = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2);
            this.l3o_1.textContent = I18n_getInstance().e28('logCenterActivity.loggedSuccess');
            if (!(this.m3o_1 == null) && this.m3o_1.length > 0) {
              this.t7_1 = 2;
              suspendResult = uploadCenterEntryPhotos(created.h2h_1, this.m3o_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.t7_1 = 3;
              continue $sm;
            }

          case 2:
            this.t7_1 = 3;
            continue $sm;
          case 3:
            this.u7_1 = 5;
            this.t7_1 = 6;
            continue $sm;
          case 4:
            this.u7_1 = 5;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.l3o_1, e.k2c_1);
              this.t7_1 = 6;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.l3o_1, I18n_getInstance().e28('logCenterActivity.unexpectedErrorPrefix') + e_0.message);
                this.t7_1 = 6;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 5:
            throw this.w7_1;
          case 6:
            this.u7_1 = 5;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 5) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitLogCenterActivity$slambda).h22 = function ($this$launch, completion) {
    var i = new submitLogCenterActivity$slambda(this.d3o_1, this.e3o_1, this.f3o_1, this.g3o_1, this.h3o_1, this.i3o_1, this.j3o_1, this.k3o_1, this.l3o_1, this.m3o_1, completion);
    i.n3o_1 = $this$launch;
    return i;
  };
  function submitLogCenterActivity$slambda_0($practitionerUserId, $guestName, $guestEmail, $activityType, $startedAt, $endedAt, $notes, $companyId, $status, $photoFiles, resultContinuation) {
    var i = new submitLogCenterActivity$slambda($practitionerUserId, $guestName, $guestEmail, $activityType, $startedAt, $endedAt, $notes, $companyId, $status, $photoFiles, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function uploadCenterEntryPhotos$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('logActivity.photoUploadFailedPrefix') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function $uploadCenterEntryPhotosCOROUTINE$(entryId, files, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o3n_1 = entryId;
    this.p3n_1 = files;
  }
  protoOf($uploadCenterEntryPhotosCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 7;
            var tmp_0 = this;
            var tmp_1 = document.getElementById('logCenterActivityStatus');
            tmp_0.r3n_1 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
            var tmp_2 = this.p3n_1.length;
            var count = (!(tmp_2 == null) ? typeof tmp_2 === 'number' : false) ? tmp_2 : THROW_CCE();
            this.u3n_1 = until(0, count).t();
            this.t7_1 = 1;
            continue $sm;
          case 1:
            if (!this.u3n_1.u()) {
              this.t7_1 = 6;
              continue $sm;
            }

            var i = this.u3n_1.v();
            var file = this.p3n_1[i];
            this.u7_1 = 4;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/entries/' + this.o3n_1 + '/photos';
            this.s3n_1 = tmp0;
            var formData = new FormData();
            formData.append('file', file);
            var headers = new Headers();
            var tmp0_safe_receiver = AuthState_instance.y2w();
            if (tmp0_safe_receiver == null)
              null;
            else {
              headers.append('Authorization', 'Bearer ' + tmp0_safe_receiver);
            }

            var init = {};
            init.method = 'PUT';
            init.headers = headers;
            init.body = formData;
            this.t7_1 = 2;
            suspendResult = await_0(window.fetch(this.s3n_1.e27_1 + tmp2, init), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.t3n_1 = suspendResult;
            this.t7_1 = 3;
            suspendResult = await_0(this.t3n_1.text(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var text = suspendResult;
            if (!this.t3n_1.ok) {
              this.s3n_1.z2w(this.t3n_1.status, true);
              var this_0 = this.s3n_1;
              var tmp_3;
              try {
                var this_1 = this_0.f27_1;
                var this_2 = this_1.um();
                var this_3 = serializer(this_2, createKType(getKClass(ErrorResponse), arrayOf([]), false));
                var value = this_1.i13(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), text);
                tmp_3 = _Result___init__impl__xyqfz8(value);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof Error) {
                  var e = $p;
                  tmp_4 = _Result___init__impl__xyqfz8(createFailure(e));
                } else {
                  throw $p;
                }
                tmp_3 = tmp_4;
              }
              var this_4 = tmp_3;
              var parsed = _Result___get_isFailure__impl__jpiriv(this_4) ? null : _Result___get_value__impl__bjfvqg(this_4);
              var tmp_5 = this.t3n_1.status;
              var tmp2_elvis_lhs = parsed == null ? null : parsed.p2c_1;
              var tmp_6;
              if (tmp2_elvis_lhs == null) {
                var tmp_7;
                if (isBlank(text)) {
                  tmp_7 = 'Upload failed';
                } else {
                  tmp_7 = text;
                }
                tmp_6 = tmp_7;
              } else {
                tmp_6 = tmp2_elvis_lhs;
              }
              var tmp_8 = tmp_6;
              throw new ApiException(tmp_5, tmp_8, parsed == null ? null : parsed.q2c_1);
            }

            var tmp_9 = this;
            var this_5 = this.s3n_1.f27_1;
            var this_6 = this_5.um();
            var this_7 = serializer(this_6, createKType(getKClass(BitacoraEntryResponse), arrayOf([]), false));
            tmp_9.q3n_1 = this_5.i13(isInterface(this_7, KSerializer) ? this_7 : THROW_CCE(), text);
            this.u7_1 = 7;
            this.t7_1 = 5;
            continue $sm;
          case 4:
            this.u7_1 = 7;
            var tmp_10 = this.w7_1;
            if (tmp_10 instanceof ApiException) {
              var e_0 = this.w7_1;
              var tmp_11 = this;
              tmp_11.q3n_1 = append(this.r3n_1, uploadCenterEntryPhotos$lambda(e_0));
              this.t7_1 = 5;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 5:
            this.u7_1 = 7;
            this.t7_1 = 1;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.w7_1;
        }
      } catch ($p_0) {
        var e_1 = $p_0;
        if (this.u7_1 === 7) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  var properties_initialized_LogCenterActivityPage_kt_epqy3r;
  function _init_properties_LogCenterActivityPage_kt__8wpzrv() {
    if (!properties_initialized_LogCenterActivityPage_kt_epqy3r) {
      properties_initialized_LogCenterActivityPage_kt_epqy3r = true;
      currentCenterCompanyId = '';
      centerActivityTypes = listOf(['RECREATIONAL_SCUBA_DIVER', 'STUDENT_PILOT', 'ROCK_CLIMBER']);
    }
  }
  var CUBE_TOP_LEFT;
  var CUBE_TOP_RIGHT;
  var CUBE_BOTTOM_LEFT;
  var CUBE_BOTTOM_RIGHT;
  function CubeFaces(front, back, left, right, top, bottom) {
    this.p3o_1 = front;
    this.q3o_1 = back;
    this.r3o_1 = left;
    this.s3o_1 = right;
    this.t3o_1 = top;
    this.u3o_1 = bottom;
  }
  function LoginPageModule$init$lambda(event) {
    event.preventDefault();
    submitPasswordLogin();
    return Unit_instance;
  }
  function LoginPageModule$init$lambda_0(event) {
    event.preventDefault();
    submitPasskeyLogin();
    return Unit_instance;
  }
  function LoginPageModule$init$lambda_1(event) {
    event.preventDefault();
    submitMagicLinkRequest();
    return Unit_instance;
  }
  function LoginPageModule$init$lambda_2(it) {
    window.location.href = ApiClient_getInstance().e27_1 + '/api/auth/oauth/google/start';
    return Unit_instance;
  }
  function LoginPageModule$init$lambda_3(it) {
    window.location.href = ApiClient_getInstance().e27_1 + '/api/auth/oauth/facebook/start';
    return Unit_instance;
  }
  function LoginPageModule() {
  }
  protoOf(LoginPageModule).r28 = function () {
    var oauthError = urlParam('oauthError');
    // Inline function 'kotlin.text.isNullOrBlank' call
    if (!(oauthError == null || isBlank(oauthError))) {
      var tmp = document.getElementById('oauthError');
      // Inline function 'kotlin.apply' call
      var this_0 = tmp instanceof HTMLElement ? tmp : THROW_CCE();
      this_0.classList.remove('hidden');
      this_0.textContent = oauthError;
    }
    if (!(urlParam('sessionExpired') == null)) {
      var tmp_0 = document.getElementById('sessionExpiredNotice');
      // Inline function 'kotlin.apply' call
      var this_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
      this_1.classList.remove('hidden');
      this_1.textContent = I18n_getInstance().e28('login.sessionExpiredMessage');
    }
    var tmp_1 = document.getElementById('passwordLoginForm');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('submit', LoginPageModule$init$lambda);
    var tmp_3 = document.getElementById('passkeyLoginForm');
    var tmp_4 = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
    tmp_4.addEventListener('submit', LoginPageModule$init$lambda_0);
    var tmp_5 = document.getElementById('magicLinkForm');
    var tmp_6 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
    tmp_6.addEventListener('submit', LoginPageModule$init$lambda_1);
    var tmp0_safe_receiver = document.getElementById('oauthGoogleButton');
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.addEventListener('click', LoginPageModule$init$lambda_2);
    }
    var tmp1_safe_receiver = document.getElementById('oauthFacebookButton');
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.addEventListener('click', LoginPageModule$init$lambda_3);
    }
  };
  var LoginPageModule_instance;
  function LoginPageModule_getInstance() {
    return LoginPageModule_instance;
  }
  function submitPasswordLogin() {
    _init_properties_LoginPage_kt__xdpl7q();
    var tmp = document.getElementById('passwordLoginError');
    var errorBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    errorBox.textContent = '';
    var tmp_0 = document.getElementById('pwEmail');
    var email = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('pwPassword');
    var password = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    var tmp_2 = get_AppScope();
    launch(tmp_2, VOID, VOID, submitPasswordLogin$slambda_0(email, password, errorBox, null));
  }
  function submitPasskeyLogin() {
    _init_properties_LoginPage_kt__xdpl7q();
    var tmp = document.getElementById('passkeyLoginError');
    var errorBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    errorBox.textContent = '';
    var tmp_0 = document.getElementById('passkeyEmail');
    var email = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, submitPasskeyLogin$slambda_0(email, errorBox, null));
  }
  function submitMagicLinkRequest() {
    _init_properties_LoginPage_kt__xdpl7q();
    var tmp = document.getElementById('magicLinkStatus');
    var statusBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    statusBox.textContent = '';
    var tmp_0 = document.getElementById('magicLinkEmail');
    var email = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, submitMagicLinkRequest$slambda_0(email, statusBox, null));
  }
  function submitPasswordLogin$slambda($email, $password, $errorBox, resultContinuation) {
    this.d3p_1 = $email;
    this.e3p_1 = $password;
    this.f3p_1 = $errorBox;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitPasswordLogin$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitPasswordLogin$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitPasswordLogin$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 3;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/auth/login';
            var body = new LoginRequest(this.d3p_1, this.e3p_1);
            this.h3p_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(LoginRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.h3p_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(TokenResponse), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            AuthState_instance.m2y(result.t2c_1, result.u2c_1);
            this.t7_1 = 2;
            suspendResult = navigateAfterAuth(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.u7_1 = 4;
            this.t7_1 = 5;
            continue $sm;
          case 3:
            this.u7_1 = 4;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              this.f3p_1.textContent = e.k2c_1;
              this.t7_1 = 5;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                this.f3p_1.textContent = 'Something went wrong: ' + e_0.message;
                this.t7_1 = 5;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 4:
            throw this.w7_1;
          case 5:
            this.u7_1 = 4;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 4) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitPasswordLogin$slambda).h22 = function ($this$launch, completion) {
    var i = new submitPasswordLogin$slambda(this.d3p_1, this.e3p_1, this.f3p_1, completion);
    i.g3p_1 = $this$launch;
    return i;
  };
  function submitPasswordLogin$slambda_0($email, $password, $errorBox, resultContinuation) {
    var i = new submitPasswordLogin$slambda($email, $password, $errorBox, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitPasskeyLogin$slambda($email, $errorBox, resultContinuation) {
    this.q3p_1 = $email;
    this.r3p_1 = $errorBox;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitPasskeyLogin$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitPasskeyLogin$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitPasskeyLogin$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 3;
            this.t7_1 = 1;
            suspendResult = loginWithPasskey(this.q3p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            AuthState_instance.m2y(result.t2c_1, result.u2c_1);
            this.t7_1 = 2;
            suspendResult = navigateAfterAuth(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.u7_1 = 4;
            this.t7_1 = 5;
            continue $sm;
          case 3:
            this.u7_1 = 4;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              this.r3p_1.textContent = e.k2c_1;
              this.t7_1 = 5;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                this.r3p_1.textContent = 'Passkey sign-in failed: ' + e_0.message;
                this.t7_1 = 5;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 4:
            throw this.w7_1;
          case 5:
            this.u7_1 = 4;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 4) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitPasskeyLogin$slambda).h22 = function ($this$launch, completion) {
    var i = new submitPasskeyLogin$slambda(this.q3p_1, this.r3p_1, completion);
    i.s3p_1 = $this$launch;
    return i;
  };
  function submitPasskeyLogin$slambda_0($email, $errorBox, resultContinuation) {
    var i = new submitPasskeyLogin$slambda($email, $errorBox, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitMagicLinkRequest$slambda($email, $statusBox, resultContinuation) {
    this.b3q_1 = $email;
    this.c3q_1 = $statusBox;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitMagicLinkRequest$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitMagicLinkRequest$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitMagicLinkRequest$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/auth/magic-link/request';
            var body = new MagicLinkRequestRequest(this.b3q_1);
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(MagicLinkRequestRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.c3q_1.textContent = 'If that email has an account, a sign-in link is on its way.';
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof Error) {
              var e = this.w7_1;
              this.c3q_1.textContent = 'If that email has an account, a sign-in link is on its way.';
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitMagicLinkRequest$slambda).h22 = function ($this$launch, completion) {
    var i = new submitMagicLinkRequest$slambda(this.b3q_1, this.c3q_1, completion);
    i.d3q_1 = $this$launch;
    return i;
  };
  function submitMagicLinkRequest$slambda_0($email, $statusBox, resultContinuation) {
    var i = new submitMagicLinkRequest$slambda($email, $statusBox, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  var properties_initialized_LoginPage_kt_f8beew;
  function _init_properties_LoginPage_kt__xdpl7q() {
    if (!properties_initialized_LoginPage_kt_f8beew) {
      properties_initialized_LoginPage_kt_f8beew = true;
      CUBE_TOP_LEFT = new CubeFaces('surf', 'escalada', 'rafting', 'esqui', 'paracaidismo', 'wingsuit');
      CUBE_TOP_RIGHT = new CubeFaces('parapente', 'aladelta', 'remo', 'buceo1', 'interrogacion', 'futbol');
      CUBE_BOTTOM_LEFT = new CubeFaces('espeleologia', 'trekking', 'mountainbike', 'billar', 'helicoptero', 'dardos');
      CUBE_BOTTOM_RIGHT = new CubeFaces('golf', 'correr', 'yoga', 'buceo2', 'basket', 'canyoning');
    }
  }
  function MagicLinkLandingPageModule() {
  }
  protoOf(MagicLinkLandingPageModule).r28 = function () {
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('token');
    var tmp$ret$0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    consumeMagicLink(tmp$ret$0, '/login');
  };
  var MagicLinkLandingPageModule_instance;
  function MagicLinkLandingPageModule_getInstance() {
    return MagicLinkLandingPageModule_instance;
  }
  function consumeMagicLink(token, loginLinkHref) {
    var tmp = document.getElementById('magicLinkStatus');
    var statusBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    if (isBlank(token)) {
      statusBox.innerHTML = '';
      statusBox.classList.add('status-error');
      append(statusBox, consumeMagicLink$lambda);
      return Unit_instance;
    }
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, consumeMagicLink$slambda_0(token, statusBox, loginLinkHref, null));
  }
  function consumeMagicLink$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    this_0.n1f('This link is missing its token. Request a new one from the login page.');
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function consumeMagicLink$slambda$lambda($loginLinkHref) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f('This link is invalid or has expired.');
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_1 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), $this$append);
      if (!(this_1.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_1.j1f().a1h(this_1);
      this_1.q1j($loginLinkHref);
      this_1.n1f('Back to login');
      this_1.j1f().b1h(this_1);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function consumeMagicLink$slambda$lambda_0($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f('Something went wrong: ' + $e.message);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function consumeMagicLink$slambda($token, $statusBox, $loginLinkHref, resultContinuation) {
    this.m3q_1 = $token;
    this.n3q_1 = $statusBox;
    this.o3q_1 = $loginLinkHref;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(consumeMagicLink$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(consumeMagicLink$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(consumeMagicLink$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 3;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/auth/magic-link/consume';
            var body = new MagicLinkConsumeRequest(this.m3q_1);
            this.r3q_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(MagicLinkConsumeRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.r3q_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(TokenResponse), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            AuthState_instance.m2y(result.t2c_1, result.u2c_1);
            this.t7_1 = 2;
            suspendResult = navigateAfterAuth(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_0 = this;
            tmp_0.q3q_1 = Unit_instance;
            this.u7_1 = 4;
            this.t7_1 = 5;
            continue $sm;
          case 3:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.n3q_1.innerHTML = '';
              this.n3q_1.classList.add('status-error');
              tmp_2.q3q_1 = append(this.n3q_1, consumeMagicLink$slambda$lambda(this.o3q_1));
              this.t7_1 = 5;
              continue $sm;
            } else {
              var tmp_3 = this.w7_1;
              if (tmp_3 instanceof Error) {
                var e_0 = this.w7_1;
                var tmp_4 = this;
                this.n3q_1.innerHTML = '';
                this.n3q_1.classList.add('status-error');
                tmp_4.q3q_1 = append(this.n3q_1, consumeMagicLink$slambda$lambda_0(e_0));
                this.t7_1 = 5;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 4:
            throw this.w7_1;
          case 5:
            this.u7_1 = 4;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 4) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(consumeMagicLink$slambda).h22 = function ($this$launch, completion) {
    var i = new consumeMagicLink$slambda(this.m3q_1, this.n3q_1, this.o3q_1, completion);
    i.p3q_1 = $this$launch;
    return i;
  };
  function consumeMagicLink$slambda_0($token, $statusBox, $loginLinkHref, resultContinuation) {
    var i = new consumeMagicLink$slambda($token, $statusBox, $loginLinkHref, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitAdvertisement(companyId) {
    var tmp = document.getElementById('advertisementFormStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('advertisementImage');
    var fileInput = tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.js.asDynamic' call
    var file = fileInput.files[0];
    if (file == undefined) {
      showError(status, I18n_getInstance().e28('marketerAds.selectImageError'));
      return Unit_instance;
    }
    var activityTypes = selectedActivityTypes('ad');
    if (activityTypes.r()) {
      showError(status, I18n_getInstance().e28('marketerAds.selectActivityTypeError'));
      return Unit_instance;
    }
    var tmp_1 = document.getElementById('ad-latitude');
    var latitude = toDoubleOrNull((tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value);
    var tmp_2 = document.getElementById('ad-longitude');
    var longitude = toDoubleOrNull((tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value);
    if (latitude == null || longitude == null) {
      showError(status, I18n_getInstance().e28('marketerAds.selectLocationError'));
      return Unit_instance;
    }
    var tmp_3 = document.getElementById('adRadiusKm');
    var tmp0_safe_receiver = toDoubleOrNull((tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).value);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : coerceAtMost(tmp0_safe_receiver, 200.0);
    var radiusKm = tmp1_elvis_lhs == null ? 50.0 : tmp1_elvis_lhs;
    var tmp_4 = document.getElementById('adDestinationUrl');
    var destinationUrl = (tmp_4 instanceof HTMLInputElement ? tmp_4 : THROW_CCE()).value;
    var tmp_5 = get_AppScope();
    launch(tmp_5, VOID, VOID, submitAdvertisement$slambda_0(activityTypes, destinationUrl, companyId, latitude, longitude, radiusKm, file, fileInput, status, null));
  }
  function loadAdvertisements(companyId) {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, loadAdvertisements$slambda_0(companyId, null));
  }
  function renderAdvertisementsList(companyId, ads) {
    var tmp = document.getElementById('advertisementsList');
    var list = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    list.innerHTML = '';
    if (ads.r()) {
      append(list, renderAdvertisementsList$lambda);
      return Unit_instance;
    }
    append(list, renderAdvertisementsList$lambda_0(ads));
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = ads.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (element.y2k_1) {
        destination.x(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      var tmp_0 = document.getElementById('deactivateAd-' + element_0.r2k_1);
      var tmp_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
      tmp_1.addEventListener('click', renderAdvertisementsList$lambda_1(companyId, element_0));
    }
  }
  function deactivateAdvertisement(companyId, advertisementId) {
    var tmp = document.getElementById('advertisementFormStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, deactivateAdvertisement$slambda_0(companyId, advertisementId, status, null));
  }
  function MarketerAdvertisementsPageModule$init$lambda($companyId) {
    return function (event) {
      event.preventDefault();
      submitAdvertisement($companyId);
      return Unit_instance;
    };
  }
  function MarketerAdvertisementsPageModule() {
  }
  protoOf(MarketerAdvertisementsPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('companyId');
    var companyId = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    if (isBlank(companyId)) {
      var tmp = document.getElementById('marketerAdsMissingCompany');
      (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('hidden');
      var tmp_0 = document.getElementById('marketerAdsContent');
      (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.add('hidden');
      return Unit_instance;
    }
    wireLocationSearchPicker('ad');
    var tmp_1 = document.getElementById('advertisementForm');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('submit', MarketerAdvertisementsPageModule$init$lambda(companyId));
    loadAdvertisements(companyId);
  };
  var MarketerAdvertisementsPageModule_instance;
  function MarketerAdvertisementsPageModule_getInstance() {
    return MarketerAdvertisementsPageModule_instance;
  }
  function submitAdvertisement$slambda($activityTypes, $destinationUrl, $companyId, $latitude, $longitude, $radiusKm, $file, $fileInput, $status, resultContinuation) {
    this.a3r_1 = $activityTypes;
    this.b3r_1 = $destinationUrl;
    this.c3r_1 = $companyId;
    this.d3r_1 = $latitude;
    this.e3r_1 = $longitude;
    this.f3r_1 = $radiusKm;
    this.g3r_1 = $file;
    this.h3r_1 = $fileInput;
    this.i3r_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitAdvertisement$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitAdvertisement$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitAdvertisement$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 3;
            var activityTypesParam = joinToString(this.a3r_1, ',');
            var tmp_0;
            var this_0 = this.b3r_1;
            if (!isBlank(this_0)) {
              tmp_0 = '&destinationUrl=' + encodeURIComponent(this.b3r_1);
            } else {
              tmp_0 = '';
            }

            var destinationUrlParam = tmp_0;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/marketers/' + this.c3r_1 + '/advertisements' + ('?activityTypes=' + activityTypesParam + '&lat=' + this.d3r_1 + '&lon=' + this.e3r_1 + '&radiusKm=' + this.f3r_1 + destinationUrlParam);
            var tmp6 = this.g3r_1;
            this.k3r_1 = tmp0;
            var formData = new FormData();
            formData.append('file', tmp6);
            var headers = new Headers();
            var tmp0_safe_receiver = AuthState_instance.y2w();
            if (tmp0_safe_receiver == null)
              null;
            else {
              headers.append('Authorization', 'Bearer ' + tmp0_safe_receiver);
            }

            var init = {};
            init.method = 'PUT';
            init.headers = headers;
            init.body = formData;
            this.t7_1 = 1;
            suspendResult = await_0(window.fetch(this.k3r_1.e27_1 + tmp2, init), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.l3r_1 = suspendResult;
            this.t7_1 = 2;
            suspendResult = await_0(this.l3r_1.text(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var text = suspendResult;
            if (!this.l3r_1.ok) {
              this.k3r_1.z2w(this.l3r_1.status, true);
              var this_1 = this.k3r_1;
              var tmp_1;
              try {
                var this_2 = this_1.f27_1;
                var this_3 = this_2.um();
                var this_4 = serializer(this_3, createKType(getKClass(ErrorResponse), arrayOf([]), false));
                var value = this_2.i13(isInterface(this_4, KSerializer) ? this_4 : THROW_CCE(), text);
                tmp_1 = _Result___init__impl__xyqfz8(value);
              } catch ($p) {
                var tmp_2;
                if ($p instanceof Error) {
                  var e = $p;
                  tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
                } else {
                  throw $p;
                }
                tmp_1 = tmp_2;
              }
              var this_5 = tmp_1;
              var parsed = _Result___get_isFailure__impl__jpiriv(this_5) ? null : _Result___get_value__impl__bjfvqg(this_5);
              var tmp_3 = this.l3r_1.status;
              var tmp2_elvis_lhs = parsed == null ? null : parsed.p2c_1;
              var tmp_4;
              if (tmp2_elvis_lhs == null) {
                var tmp_5;
                if (isBlank(text)) {
                  tmp_5 = 'Upload failed';
                } else {
                  tmp_5 = text;
                }
                tmp_4 = tmp_5;
              } else {
                tmp_4 = tmp2_elvis_lhs;
              }
              var tmp_6 = tmp_4;
              throw new ApiException(tmp_3, tmp_6, parsed == null ? null : parsed.q2c_1);
            }

            var this_6 = this.k3r_1.f27_1;
            var this_7 = this_6.um();
            var this_8 = serializer(this_7, createKType(getKClass(AdvertisementResponse), arrayOf([]), false));
            this_6.i13(isInterface(this_8, KSerializer) ? this_8 : THROW_CCE(), text);
            this.h3r_1.value = '';
            loadAdvertisements(this.c3r_1);
            this.u7_1 = 4;
            this.t7_1 = 5;
            continue $sm;
          case 3:
            this.u7_1 = 4;
            var tmp_7 = this.w7_1;
            if (tmp_7 instanceof ApiException) {
              var e_0 = this.w7_1;
              showError(this.i3r_1, e_0.k2c_1);
              this.t7_1 = 5;
              continue $sm;
            } else {
              var tmp_8 = this.w7_1;
              if (tmp_8 instanceof Error) {
                var e_1 = this.w7_1;
                showError(this.i3r_1, I18n_getInstance().e28('marketerAds.genericErrorPrefix') + e_1.message);
                this.t7_1 = 5;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 4:
            throw this.w7_1;
          case 5:
            this.u7_1 = 4;
            return Unit_instance;
        }
      } catch ($p_0) {
        var e_2 = $p_0;
        if (this.u7_1 === 4) {
          throw e_2;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_2;
        }
      }
     while (true);
  };
  protoOf(submitAdvertisement$slambda).h22 = function ($this$launch, completion) {
    var i = new submitAdvertisement$slambda(this.a3r_1, this.b3r_1, this.c3r_1, this.d3r_1, this.e3r_1, this.f3r_1, this.g3r_1, this.h3r_1, this.i3r_1, completion);
    i.j3r_1 = $this$launch;
    return i;
  };
  function submitAdvertisement$slambda_0($activityTypes, $destinationUrl, $companyId, $latitude, $longitude, $radiusKm, $file, $fileInput, $status, resultContinuation) {
    var i = new submitAdvertisement$slambda($activityTypes, $destinationUrl, $companyId, $latitude, $longitude, $radiusKm, $file, $fileInput, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function loadAdvertisements$slambda($companyId, resultContinuation) {
    this.u3r_1 = $companyId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadAdvertisements$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadAdvertisements$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadAdvertisements$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/marketers/' + this.u3r_1 + '/advertisements';
            this.x3r_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.x3r_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(AdvertisementResponse), arrayOf([]), false))]), false));
            tmp_0.w3r_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.w3r_1 = emptyList();
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var ads = this.w3r_1;
            renderAdvertisementsList(this.u3r_1, ads);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadAdvertisements$slambda).h22 = function ($this$launch, completion) {
    var i = new loadAdvertisements$slambda(this.u3r_1, completion);
    i.v3r_1 = $this$launch;
    return i;
  };
  function loadAdvertisements$slambda_0($companyId, resultContinuation) {
    var i = new loadAdvertisements$slambda($companyId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderAdvertisementsList$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'marketerAds.noAdsYet';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('marketerAds.noAdsYet'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderAdvertisementsList$lambda$lambda(it) {
    return activityTypeLabel(it);
  }
  function renderAdvertisementsList$lambda_0($ads) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $ads.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = 'entry-card';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp4 = element.t2k_1;
        // Inline function 'kotlinx.html.img' call
        var classes_0 = 'photo-preview-thumb';
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_1 = new IMG(attributesMapOf(['alt', '', 'src', tmp4, 'loading', null == null ? null : enumEncode(null), 'class', classes_0]), this_0.j1f());
        this_1.j1f().a1h(this_1);
        this_1.j1f().b1h(this_1);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_2 = new P(attributesMapOf_0('class', null), this_0.j1f());
        this_2.j1f().a1h(this_2);
        this_2.n1f(joinToString(element.u2k_1, ', ', VOID, VOID, VOID, VOID, renderAdvertisementsList$lambda$lambda));
        this_2.j1f().b1h(this_2);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_3 = new P(attributesMapOf_0('class', null), this_0.j1f());
        this_3.j1f().a1h(this_3);
        this_3.n1f(I18n_getInstance().e28('marketerAds.radiusPrefix') + numberToInt(element.x2k_1) + I18n_getInstance().e28('marketerAds.radiusSuffix'));
        this_3.j1f().b1h(this_3);
        // Inline function 'kotlinx.html.span' call
        var classes_1 = element.y2k_1 ? 'badge badge-verified' : 'badge badge-rejected';
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_4 = new SPAN(attributesMapOf_0('class', classes_1), this_0.j1f());
        this_4.j1f().a1h(this_4);
        var tmp0 = this_4.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = element.y2k_1 ? 'marketerAds.activeLabel' : 'marketerAds.inactiveLabel';
        tmp0.m2(tmp2, value);
        this_4.n1f(I18n_getInstance().e28(element.y2k_1 ? 'marketerAds.activeLabel' : 'marketerAds.inactiveLabel'));
        this_4.j1f().b1h(this_4);
        if (element.y2k_1) {
          // Inline function 'kotlinx.html.div' call
          var classes_2 = 'entry-actions';
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_5 = new DIV(attributesMapOf_0('class', classes_2), this_0.j1f());
          this_5.j1f().a1h(this_5);
          // Inline function 'kotlinx.html.button' call
          var classes_3 = 'btn-reject';
          var tmp = null == null ? null : enumEncode(null);
          var tmp_0 = null == null ? null : enumEncode(null);
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_6 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_3]), this_5.j1f());
          this_6.j1f().a1h(this_6);
          this_6.z1j(ButtonType_button_getInstance());
          set_id(this_6, 'deactivateAd-' + element.r2k_1);
          var tmp0_0 = this_6.l1f();
          var tmp2_0 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value_0 = 'marketerAds.deactivateButton';
          tmp0_0.m2(tmp2_0, value_0);
          this_6.n1f(I18n_getInstance().e28('marketerAds.deactivateButton'));
          this_6.j1f().b1h(this_6);
          this_5.j1f().b1h(this_5);
        }
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function renderAdvertisementsList$lambda_1($companyId, $ad) {
    return function (it) {
      deactivateAdvertisement($companyId, $ad.r2k_1);
      return Unit_instance;
    };
  }
  function deactivateAdvertisement$slambda($companyId, $advertisementId, $status, resultContinuation) {
    this.g3s_1 = $companyId;
    this.h3s_1 = $advertisementId;
    this.i3s_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(deactivateAdvertisement$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(deactivateAdvertisement$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(deactivateAdvertisement$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = ApiClient_getInstance().a2x('/api/v1/bitacora/marketers/' + this.g3s_1 + '/advertisements/' + this.h3s_1, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            loadAdvertisements(this.g3s_1);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.i3s_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(deactivateAdvertisement$slambda).h22 = function ($this$launch, completion) {
    var i = new deactivateAdvertisement$slambda(this.g3s_1, this.h3s_1, this.i3s_1, completion);
    i.j3s_1 = $this$launch;
    return i;
  };
  function deactivateAdvertisement$slambda_0($companyId, $advertisementId, $status, resultContinuation) {
    var i = new deactivateAdvertisement$slambda($companyId, $advertisementId, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function get_bitakoreClassNames() {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    return bitakoreClassNames;
  }
  var bitakoreClassNames;
  function $deleteRawCOROUTINE$(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s3s_1 = _this__u8e3s4;
    this.t3s_1 = path;
  }
  protoOf($deleteRawCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = ApiClient_getInstance().g27('DELETE', this.t3s_1, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 2) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  function $putRawCOROUTINE$(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c3t_1 = _this__u8e3s4;
    this.d3t_1 = path;
  }
  protoOf($putRawCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = ApiClient_getInstance().g27('PUT', this.d3t_1, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 2) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  function BitakorePaymentsHttpClient() {
  }
  protoOf(BitakorePaymentsHttpClient).h23 = function (path, $completion) {
    return ApiClient_getInstance().g27('GET', path, null, true, $completion);
  };
  protoOf(BitakorePaymentsHttpClient).i23 = function (path, body, $completion) {
    return ApiClient_getInstance().g27('POST', path, body, true, $completion);
  };
  protoOf(BitakorePaymentsHttpClient).e3t = function (path, $completion) {
    var tmp = new $deleteRawCOROUTINE$(this, path, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(BitakorePaymentsHttpClient).f3t = function (path, $completion) {
    var tmp = new $putRawCOROUTINE$(this, path, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  var BitakorePaymentsHttpClient_instance;
  function BitakorePaymentsHttpClient_getInstance() {
    return BitakorePaymentsHttpClient_instance;
  }
  function BitakoreWalletKitHttpClient() {
  }
  protoOf(BitakoreWalletKitHttpClient).h23 = function (path, $completion) {
    return ApiClient_getInstance().g27('GET', path, null, true, $completion);
  };
  protoOf(BitakoreWalletKitHttpClient).i23 = function (path, body, $completion) {
    return ApiClient_getInstance().g27('POST', path, body, true, $completion);
  };
  var BitakoreWalletKitHttpClient_instance;
  function BitakoreWalletKitHttpClient_getInstance() {
    return BitakoreWalletKitHttpClient_instance;
  }
  function paymentMethodsLabels() {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    return new PaymentMethodsLabels(I18n_getInstance().e28('marketerBilling.noMethodsYet'), I18n_getInstance().e28('marketerBilling.expiresPrefix'), I18n_getInstance().e28('marketerBilling.primaryLabel'), I18n_getInstance().e28('marketerBilling.setPrimaryButton'), I18n_getInstance().e28('marketerBilling.removeButton'), I18n_getInstance().e28('marketerBilling.providersPrefix'));
  }
  function walletLabels() {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    return new WalletLabels(I18n_getInstance().e28('marketerBilling.walletHeading'), I18n_getInstance().e28('marketerBilling.topupCardLabel'), I18n_getInstance().e28('marketerBilling.topupAmountLabel'), I18n_getInstance().e28('marketerBilling.topupButton'), I18n_getInstance().e28('marketerBilling.walletLoadError'));
  }
  function addCardLabels() {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    return new AddCardLabels(I18n_getInstance().e28('marketerBilling.noProviderConfiguredError'), I18n_getInstance().e28('marketerBilling.stripeNotLoadedError'), I18n_getInstance().e28('marketerBilling.cardSaveError'), I18n_getInstance().e28('marketerBilling.genericErrorPrefix'));
  }
  function paymentMethodsBasePath(companyId) {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    return '/api/v1/payments/companies/' + companyId;
  }
  function walletBasePath(companyId) {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    return '/api/v1/finance/companies/' + companyId + '/wallet';
  }
  function renderWalletSection(companyId, paymentMethods) {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, renderWalletSection$slambda_0(companyId, paymentMethods, null));
  }
  function submitTopUp(companyId, paymentMethodRef, amountCents) {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    var tmp = document.getElementById('topupStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    status.textContent = '';
    if (isBlank(paymentMethodRef)) {
      status.textContent = I18n_getInstance().e28('marketerBilling.topupNoCardError');
      return Unit_instance;
    }
    if (compare(amountCents, new Long(0, 0)) <= 0) {
      status.textContent = I18n_getInstance().e28('marketerBilling.topupAmountError');
      return Unit_instance;
    }
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, submitTopUp$slambda_0(companyId, paymentMethodRef, amountCents, status, null));
  }
  function loadPaymentMethods(companyId) {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, loadPaymentMethods$slambda_0(companyId, null));
  }
  function setDefaultPaymentMethod(companyId, methodId) {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, setDefaultPaymentMethod$slambda_0(companyId, methodId, null));
  }
  function removePaymentMethod(companyId, methodId) {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, removePaymentMethod$slambda_0(companyId, methodId, null));
  }
  function startAddPaymentMethod(companyId) {
    _init_properties_MarketerBillingPage_kt__4rkdgx();
    var tmp = document.getElementById('paymentMethodFormStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    status.textContent = '';
    var tmp_0 = document.getElementById('cardSetupForm');
    (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.remove('hidden');
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, startAddPaymentMethod$slambda_0(companyId, status, null));
  }
  function MarketerBillingPageModule$init$lambda($companyId) {
    return function (it) {
      startAddPaymentMethod($companyId);
      return Unit_instance;
    };
  }
  function MarketerBillingPageModule() {
  }
  protoOf(MarketerBillingPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('companyId');
    var companyId = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    if (isBlank(companyId)) {
      var tmp = document.getElementById('marketerBillingMissingCompany');
      (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('hidden');
      var tmp_0 = document.getElementById('marketerBillingContent');
      (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.add('hidden');
      return Unit_instance;
    }
    var tmp_1 = document.getElementById('addPaymentMethodButton');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('click', MarketerBillingPageModule$init$lambda(companyId));
    loadPaymentMethods(companyId);
  };
  var MarketerBillingPageModule_instance;
  function MarketerBillingPageModule_getInstance() {
    return MarketerBillingPageModule_instance;
  }
  function renderWalletSection$slambda$lambda($companyId) {
    return function (paymentMethodRef, amountCents) {
      submitTopUp($companyId, paymentMethodRef, amountCents);
      return Unit_instance;
    };
  }
  function renderWalletSection$slambda($companyId, $paymentMethods, resultContinuation) {
    this.o3t_1 = $companyId;
    this.p3t_1 = $paymentMethods;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(renderWalletSection$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(renderWalletSection$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(renderWalletSection$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var path = walletBasePath(this.o3t_1);
            this.s3t_1 = get_walletKitJson();
            this.t7_1 = 1;
            suspendResult = BitakoreWalletKitHttpClient_instance.h23(path, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.s3t_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(WalletDto), arrayOf([]), true));
            tmp_0.r3t_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.r3t_1 = null;
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var wallet = this.r3t_1;
            var tmp_3 = document.getElementById('walletContainer');
            var tmp_4 = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
            var this_3 = this.p3t_1;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_3, 10));
            var _iterator__ex2g4s = this_3.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              var this_4 = item.p1e_1;
              destination.x(new TopUpPaymentMethodOption(item.o1e_1, this_4.toUpperCase() + ' \u2022\u2022\u2022\u2022 ' + item.q1e_1));
            }

            var tmp_5 = walletLabels();
            renderWallet(tmp_4, wallet, destination, tmp_5, renderWalletSection$slambda$lambda(this.o3t_1));
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(renderWalletSection$slambda).h22 = function ($this$launch, completion) {
    var i = new renderWalletSection$slambda(this.o3t_1, this.p3t_1, completion);
    i.q3t_1 = $this$launch;
    return i;
  };
  function renderWalletSection$slambda_0($companyId, $paymentMethods, resultContinuation) {
    var i = new renderWalletSection$slambda($companyId, $paymentMethods, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitTopUp$slambda($companyId, $paymentMethodRef, $amountCents, $status, resultContinuation) {
    this.b3u_1 = $companyId;
    this.c3u_1 = $paymentMethodRef;
    this.d3u_1 = $amountCents;
    this.e3u_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitTopUp$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitTopUp$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitTopUp$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp2 = walletBasePath(this.b3u_1) + '/topup';
            var body = new TopUpWalletRequestDto(this.c3u_1, this.d3u_1);
            this.g3u_1 = get_walletKitJson();
            this.t7_1 = 1;
            var this_0 = get_walletKitJson();
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(TopUpWalletRequestDto), arrayOf([]), false));
            suspendResult = BitakoreWalletKitHttpClient_instance.i23(tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.g3u_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(WalletDto), arrayOf([]), false));
            this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            loadPaymentMethods(this.b3u_1);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof Error) {
              var e = this.w7_1;
              this.e3u_1.textContent = I18n_getInstance().e28('marketerBilling.genericErrorPrefix') + e.message;
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitTopUp$slambda).h22 = function ($this$launch, completion) {
    var i = new submitTopUp$slambda(this.b3u_1, this.c3u_1, this.d3u_1, this.e3u_1, completion);
    i.f3u_1 = $this$launch;
    return i;
  };
  function submitTopUp$slambda_0($companyId, $paymentMethodRef, $amountCents, $status, resultContinuation) {
    var i = new submitTopUp$slambda($companyId, $paymentMethodRef, $amountCents, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function sam$kotlin_Comparator$0_4(function_0) {
    this.h3u_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_4).cc = function (a, b) {
    return this.h3u_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_4).compare = function (a, b) {
    return this.cc(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_4).c3 = function () {
    return this.h3u_1;
  };
  protoOf(sam$kotlin_Comparator$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.c3(), other.c3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_4).hashCode = function () {
    return hashCode(this.c3());
  };
  function loadPaymentMethods$slambda$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.t1e_1;
    var tmp$ret$2 = a.t1e_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function loadPaymentMethods$slambda$lambda_0($companyId) {
    return function (method) {
      setDefaultPaymentMethod($companyId, method.o1e_1);
      return Unit_instance;
    };
  }
  function loadPaymentMethods$slambda$lambda_1($companyId) {
    return function (method) {
      removePaymentMethod($companyId, method.o1e_1);
      return Unit_instance;
    };
  }
  function loadPaymentMethods$slambda($companyId, resultContinuation) {
    this.q3u_1 = $companyId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadPaymentMethods$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadPaymentMethods$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadPaymentMethods$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var path = paymentMethodsBasePath(this.q3u_1);
            this.t3u_1 = get_paymentsKitJson();
            this.t7_1 = 1;
            suspendResult = BitakorePaymentsHttpClient_instance.h23(path, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.t3u_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(PaymentMethodDto), arrayOf([]), false))]), false));
            tmp_0.s3u_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.s3u_1 = emptyList();
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var methods = this.s3u_1;
            var tmp_3 = loadPaymentMethods$slambda$lambda;
            var ordered = sortedWith(methods, new sam$kotlin_Comparator$0_4(tmp_3));
            var tmp_4 = document.getElementById('paymentMethodsList');
            var tmp_5 = tmp_4 instanceof HTMLElement ? tmp_4 : THROW_CCE();
            var tmp_6 = paymentMethodsLabels();
            var tmp_7 = loadPaymentMethods$slambda$lambda_0(this.q3u_1);
            renderPaymentMethodsList(tmp_5, ordered, tmp_6, tmp_7, loadPaymentMethods$slambda$lambda_1(this.q3u_1), get_bitakoreClassNames());
            renderWalletSection(this.q3u_1, ordered);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadPaymentMethods$slambda).h22 = function ($this$launch, completion) {
    var i = new loadPaymentMethods$slambda(this.q3u_1, completion);
    i.r3u_1 = $this$launch;
    return i;
  };
  function loadPaymentMethods$slambda_0($companyId, resultContinuation) {
    var i = new loadPaymentMethods$slambda($companyId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function setDefaultPaymentMethod$slambda($companyId, $methodId, resultContinuation) {
    this.c3v_1 = $companyId;
    this.d3v_1 = $methodId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(setDefaultPaymentMethod$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(setDefaultPaymentMethod$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(setDefaultPaymentMethod$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = BitakorePaymentsHttpClient_instance.f3t(paymentMethodsBasePath(this.c3v_1) + '/' + this.d3v_1 + '/default', this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof Error) {
              var e = this.w7_1;
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            loadPaymentMethods(this.c3v_1);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(setDefaultPaymentMethod$slambda).h22 = function ($this$launch, completion) {
    var i = new setDefaultPaymentMethod$slambda(this.c3v_1, this.d3v_1, completion);
    i.e3v_1 = $this$launch;
    return i;
  };
  function setDefaultPaymentMethod$slambda_0($companyId, $methodId, resultContinuation) {
    var i = new setDefaultPaymentMethod$slambda($companyId, $methodId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function removePaymentMethod$slambda($companyId, $methodId, resultContinuation) {
    this.n3v_1 = $companyId;
    this.o3v_1 = $methodId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(removePaymentMethod$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(removePaymentMethod$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(removePaymentMethod$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = BitakorePaymentsHttpClient_instance.e3t(paymentMethodsBasePath(this.n3v_1) + '/' + this.o3v_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof Error) {
              var e = this.w7_1;
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            loadPaymentMethods(this.n3v_1);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(removePaymentMethod$slambda).h22 = function ($this$launch, completion) {
    var i = new removePaymentMethod$slambda(this.n3v_1, this.o3v_1, completion);
    i.p3v_1 = $this$launch;
    return i;
  };
  function removePaymentMethod$slambda_0($companyId, $methodId, resultContinuation) {
    var i = new removePaymentMethod$slambda($companyId, $methodId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function startAddPaymentMethod$slambda$lambda($status) {
    return function (message) {
      $status.textContent = message;
      return Unit_instance;
    };
  }
  function startAddPaymentMethod$slambda$lambda_0($companyId) {
    return function () {
      var tmp = document.getElementById('cardSetupForm');
      var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.classList;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.add('hidden');
      }
      loadPaymentMethods($companyId);
      return Unit_instance;
    };
  }
  function startAddPaymentMethod$slambda($companyId, $status, resultContinuation) {
    this.y3v_1 = $companyId;
    this.z3v_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(startAddPaymentMethod$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(startAddPaymentMethod$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(startAddPaymentMethod$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 2;
            this.t7_1 = 1;
            var tmp_0 = BitakorePaymentsHttpClient_instance;
            var tmp_1 = paymentMethodsBasePath(this.y3v_1);
            var tmp_2 = addCardLabels();
            var tmp_3 = startAddPaymentMethod$slambda$lambda(this.z3v_1);
            suspendResult = (new AddCardFlow(tmp_0, tmp_1, '/api/v1/payments/public-config', tmp_2, tmp_3, startAddPaymentMethod$slambda$lambda_0(this.y3v_1))).j23('stripe-card-element', 'saveCardButton', 'paypal-card-element', this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 2) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  protoOf(startAddPaymentMethod$slambda).h22 = function ($this$launch, completion) {
    var i = new startAddPaymentMethod$slambda(this.y3v_1, this.z3v_1, completion);
    i.a3w_1 = $this$launch;
    return i;
  };
  function startAddPaymentMethod$slambda_0($companyId, $status, resultContinuation) {
    var i = new startAddPaymentMethod$slambda($companyId, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  var properties_initialized_MarketerBillingPage_kt_51oyoh;
  function _init_properties_MarketerBillingPage_kt__4rkdgx() {
    if (!properties_initialized_MarketerBillingPage_kt_51oyoh) {
      properties_initialized_MarketerBillingPage_kt_51oyoh = true;
      bitakoreClassNames = new PaymentMethodsClassNames('entry-card', 'muted', 'badge badge-verified', 'entry-actions', 'btn-set-primary', 'btn-reject');
    }
  }
  function submitCampaign(companyId) {
    var tmp = document.getElementById('campaignFormStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('campaignImage');
    var fileInput = tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.js.asDynamic' call
    var file = fileInput.files[0];
    if (file == undefined) {
      showError(status, I18n_getInstance().e28('marketerCampaigns.selectImageError'));
      return Unit_instance;
    }
    var activityTypes = selectedActivityTypes('campaign');
    if (activityTypes.r()) {
      showError(status, I18n_getInstance().e28('marketerCampaigns.selectActivityTypeError'));
      return Unit_instance;
    }
    var tmp_1 = document.getElementById('campaign-latitude');
    var latitude = toDoubleOrNull((tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value);
    var tmp_2 = document.getElementById('campaign-longitude');
    var longitude = toDoubleOrNull((tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value);
    if (latitude == null || longitude == null) {
      showError(status, I18n_getInstance().e28('marketerCampaigns.selectLocationError'));
      return Unit_instance;
    }
    var tmp_3 = document.getElementById('campaignRadiusKm');
    var tmp0_elvis_lhs = toDoubleOrNull((tmp_3 instanceof HTMLInputElement ? tmp_3 : THROW_CCE()).value);
    var radiusKm = tmp0_elvis_lhs == null ? 50.0 : tmp0_elvis_lhs;
    var tmp_4 = document.getElementById('campaignDestinationUrl');
    var destinationUrl = (tmp_4 instanceof HTMLInputElement ? tmp_4 : THROW_CCE()).value;
    var tmp_5 = document.getElementById('campaignStartDate');
    var startDate = (tmp_5 instanceof HTMLInputElement ? tmp_5 : THROW_CCE()).value;
    if (isBlank(startDate)) {
      showError(status, I18n_getInstance().e28('marketerCampaigns.selectStartDateError'));
      return Unit_instance;
    }
    var tmp_6 = document.getElementById('campaignEndDate');
    var endDate = (tmp_6 instanceof HTMLInputElement ? tmp_6 : THROW_CCE()).value;
    var tmp_7 = document.getElementById('campaignSize');
    var size = (tmp_7 instanceof HTMLSelectElement ? tmp_7 : THROW_CCE()).value;
    var tmp_8 = document.getElementById('campaignPlacementTier');
    var placementTier = (tmp_8 instanceof HTMLSelectElement ? tmp_8 : THROW_CCE()).value;
    var tmp_9 = document.getElementById('campaignBudgetUsd');
    var budgetUsd = toDoubleOrNull((tmp_9 instanceof HTMLInputElement ? tmp_9 : THROW_CCE()).value);
    if (budgetUsd == null || budgetUsd <= 0.0) {
      showError(status, I18n_getInstance().e28('marketerCampaigns.selectBudgetError'));
      return Unit_instance;
    }
    var tmp_10 = document.getElementById('campaignDailyBudgetUsd');
    var dailyBudgetUsd = toDoubleOrNull((tmp_10 instanceof HTMLInputElement ? tmp_10 : THROW_CCE()).value);
    var tmp_11 = get_AppScope();
    launch(tmp_11, VOID, VOID, submitCampaign$slambda_0(activityTypes, latitude, longitude, radiusKm, destinationUrl, startDate, endDate, budgetUsd, dailyBudgetUsd, size, placementTier, companyId, file, fileInput, status, null));
  }
  function loadCampaigns(companyId) {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, loadCampaigns$slambda_0(companyId, null));
  }
  function renderCampaignsList(companyId, campaigns) {
    var tmp = document.getElementById('campaignsList');
    var list = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    list.innerHTML = '';
    if (campaigns.r()) {
      append(list, renderCampaignsList$lambda);
      return Unit_instance;
    }
    append(list, renderCampaignsList$lambda_0(campaigns));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = campaigns.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (element.m2l_1 === 'ACTIVE' || element.m2l_1 === 'SCHEDULED') {
        var tmp_0 = document.getElementById('pauseCampaign-' + element.d2l_1);
        var tmp_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
        tmp_1.addEventListener('click', renderCampaignsList$lambda_1(companyId, element));
      }
      if (element.m2l_1 === 'PAUSED') {
        var tmp_2 = document.getElementById('resumeCampaign-' + element.d2l_1);
        var tmp_3 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
        tmp_3.addEventListener('click', renderCampaignsList$lambda_2(companyId, element));
      }
      var tmp_4 = document.getElementById('topupForm-' + element.d2l_1);
      var tmp_5 = tmp_4 instanceof HTMLElement ? tmp_4 : THROW_CCE();
      tmp_5.addEventListener('submit', renderCampaignsList$lambda_3(companyId, element));
    }
  }
  function campaignStatusBadgeClass(status) {
    switch (status) {
      case 'ACTIVE':
        return 'badge-verified';
      case 'BUDGET_EXHAUSTED':
        return 'badge-rejected';
      default:
        return 'badge-pending';
    }
  }
  function placementLabel_0(placementTier) {
    return placementTier === 'FEATURED' ? I18n_getInstance().e28('marketerCampaigns.placement.featured') : I18n_getInstance().e28('marketerCampaigns.placement.standard');
  }
  function sizeLabel_0(size) {
    switch (size) {
      case 'LARGE':
        return I18n_getInstance().e28('marketerCampaigns.size.large');
      case 'MEDIUM':
        return I18n_getInstance().e28('marketerCampaigns.size.medium');
      default:
        return I18n_getInstance().e28('marketerCampaigns.size.small');
    }
  }
  function usdFromCents(cents) {
    // Inline function 'kotlin.Long.div' call
    var dollars = divide(cents, fromInt(100));
    // Inline function 'kotlin.Long.rem' call
    var tmp$ret$1 = modulo(cents, fromInt(100));
    var remainder = padStart(tmp$ret$1.toString(), 2, _Char___init__impl__6a9atx(48));
    return '$' + dollars.toString() + '.' + remainder;
  }
  function formatDuration(ms) {
    // Inline function 'kotlin.Long.div' call
    var totalSeconds = divide(ms, fromInt(1000));
    // Inline function 'kotlin.Long.div' call
    var minutes = divide(totalSeconds, fromInt(60));
    // Inline function 'kotlin.Long.rem' call
    var seconds = modulo(totalSeconds, fromInt(60));
    return compare(minutes, new Long(0, 0)) > 0 ? minutes.toString() + 'm ' + seconds.toString() + 's' : seconds.toString() + 's';
  }
  function setCampaignStatus(companyId, campaignId, action) {
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, setCampaignStatus$slambda_0(companyId, campaignId, action, null));
  }
  function topUpCampaignBudget(companyId, campaignId) {
    var tmp = document.getElementById('topupStatus-' + campaignId);
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('topupAmountUsd-' + campaignId);
    var amountUsd = toDoubleOrNull((tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value);
    if (amountUsd == null || amountUsd <= 0.0) {
      status.classList.remove('hidden');
      showError(status, I18n_getInstance().e28('marketerCampaigns.topupAmountError'));
      return Unit_instance;
    }
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, topUpCampaignBudget$slambda_0(companyId, campaignId, amountUsd, status, null));
  }
  function MarketerCampaignsPageModule$init$lambda($companyId) {
    return function (event) {
      event.preventDefault();
      submitCampaign($companyId);
      return Unit_instance;
    };
  }
  function MarketerCampaignsPageModule() {
  }
  protoOf(MarketerCampaignsPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('companyId');
    var companyId = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    if (isBlank(companyId)) {
      var tmp = document.getElementById('marketerCampaignsMissingCompany');
      (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('hidden');
      var tmp_0 = document.getElementById('marketerCampaignsContent');
      (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.add('hidden');
      return Unit_instance;
    }
    wireLocationSearchPicker('campaign');
    var tmp_1 = document.getElementById('campaignForm');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('submit', MarketerCampaignsPageModule$init$lambda(companyId));
    loadCampaigns(companyId);
  };
  var MarketerCampaignsPageModule_instance;
  function MarketerCampaignsPageModule_getInstance() {
    return MarketerCampaignsPageModule_instance;
  }
  function submitCampaign$slambda($activityTypes, $latitude, $longitude, $radiusKm, $destinationUrl, $startDate, $endDate, $budgetUsd, $dailyBudgetUsd, $size, $placementTier, $companyId, $file, $fileInput, $status, resultContinuation) {
    this.j3w_1 = $activityTypes;
    this.k3w_1 = $latitude;
    this.l3w_1 = $longitude;
    this.m3w_1 = $radiusKm;
    this.n3w_1 = $destinationUrl;
    this.o3w_1 = $startDate;
    this.p3w_1 = $endDate;
    this.q3w_1 = $budgetUsd;
    this.r3w_1 = $dailyBudgetUsd;
    this.s3w_1 = $size;
    this.t3w_1 = $placementTier;
    this.u3w_1 = $companyId;
    this.v3w_1 = $file;
    this.w3w_1 = $fileInput;
    this.x3w_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitCampaign$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitCampaign$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitCampaign$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 3;
            var activityTypesParam = joinToString(this.j3w_1, ',');
            var this_0 = StringBuilder_init_$Create$();
            this_0.q('activityTypes=' + activityTypesParam + '&lat=' + this.k3w_1 + '&lon=' + this.l3w_1 + '&radiusKm=' + this.m3w_1);
            var this_1 = this.n3w_1;
            if (!isBlank(this_1)) {
              this_0.q('&destinationUrl=' + encodeURIComponent(this.n3w_1));
            }

            this_0.q('&startDate=' + this.o3w_1 + 'T00:00:00Z');
            var this_2 = this.p3w_1;
            if (!isBlank(this_2)) {
              this_0.q('&endDate=' + this.p3w_1 + 'T23:59:59Z');
            }

            this_0.q('&capCents=' + numberToLong(this.q3w_1 * 100).toString());
            if (!(this.r3w_1 == null)) {
              this_0.q('&dailyCapCents=' + numberToLong(this.r3w_1 * 100).toString());
            }

            this_0.q('&size=' + this.s3w_1);
            this_0.q('&placementTier=' + this.t3w_1);
            var query = this_0.toString();
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/marketers/' + this.u3w_1 + '/campaigns?' + query;
            var tmp6 = this.v3w_1;
            this.z3w_1 = tmp0;
            var formData = new FormData();
            formData.append('file', tmp6);
            var headers = new Headers();
            var tmp0_safe_receiver = AuthState_instance.y2w();
            if (tmp0_safe_receiver == null)
              null;
            else {
              headers.append('Authorization', 'Bearer ' + tmp0_safe_receiver);
            }

            var init = {};
            init.method = 'PUT';
            init.headers = headers;
            init.body = formData;
            this.t7_1 = 1;
            suspendResult = await_0(window.fetch(this.z3w_1.e27_1 + tmp2, init), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.a3x_1 = suspendResult;
            this.t7_1 = 2;
            suspendResult = await_0(this.a3x_1.text(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var text = suspendResult;
            if (!this.a3x_1.ok) {
              this.z3w_1.z2w(this.a3x_1.status, true);
              var this_3 = this.z3w_1;
              var tmp_0;
              try {
                var this_4 = this_3.f27_1;
                var this_5 = this_4.um();
                var this_6 = serializer(this_5, createKType(getKClass(ErrorResponse), arrayOf([]), false));
                var value = this_4.i13(isInterface(this_6, KSerializer) ? this_6 : THROW_CCE(), text);
                tmp_0 = _Result___init__impl__xyqfz8(value);
              } catch ($p) {
                var tmp_1;
                if ($p instanceof Error) {
                  var e = $p;
                  tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
                } else {
                  throw $p;
                }
                tmp_0 = tmp_1;
              }
              var this_7 = tmp_0;
              var parsed = _Result___get_isFailure__impl__jpiriv(this_7) ? null : _Result___get_value__impl__bjfvqg(this_7);
              var tmp_2 = this.a3x_1.status;
              var tmp2_elvis_lhs = parsed == null ? null : parsed.p2c_1;
              var tmp_3;
              if (tmp2_elvis_lhs == null) {
                var tmp_4;
                if (isBlank(text)) {
                  tmp_4 = 'Upload failed';
                } else {
                  tmp_4 = text;
                }
                tmp_3 = tmp_4;
              } else {
                tmp_3 = tmp2_elvis_lhs;
              }
              var tmp_5 = tmp_3;
              throw new ApiException(tmp_2, tmp_5, parsed == null ? null : parsed.q2c_1);
            }

            var this_8 = this.z3w_1.f27_1;
            var this_9 = this_8.um();
            var this_10 = serializer(this_9, createKType(getKClass(AdCampaignResponse), arrayOf([]), false));
            this_8.i13(isInterface(this_10, KSerializer) ? this_10 : THROW_CCE(), text);
            this.w3w_1.value = '';
            loadCampaigns(this.u3w_1);
            this.u7_1 = 4;
            this.t7_1 = 5;
            continue $sm;
          case 3:
            this.u7_1 = 4;
            var tmp_6 = this.w7_1;
            if (tmp_6 instanceof ApiException) {
              var e_0 = this.w7_1;
              showError(this.x3w_1, e_0.k2c_1);
              this.t7_1 = 5;
              continue $sm;
            } else {
              var tmp_7 = this.w7_1;
              if (tmp_7 instanceof Error) {
                var e_1 = this.w7_1;
                showError(this.x3w_1, I18n_getInstance().e28('marketerCampaigns.genericErrorPrefix') + e_1.message);
                this.t7_1 = 5;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 4:
            throw this.w7_1;
          case 5:
            this.u7_1 = 4;
            return Unit_instance;
        }
      } catch ($p_0) {
        var e_2 = $p_0;
        if (this.u7_1 === 4) {
          throw e_2;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_2;
        }
      }
     while (true);
  };
  protoOf(submitCampaign$slambda).h22 = function ($this$launch, completion) {
    var i = new submitCampaign$slambda(this.j3w_1, this.k3w_1, this.l3w_1, this.m3w_1, this.n3w_1, this.o3w_1, this.p3w_1, this.q3w_1, this.r3w_1, this.s3w_1, this.t3w_1, this.u3w_1, this.v3w_1, this.w3w_1, this.x3w_1, completion);
    i.y3w_1 = $this$launch;
    return i;
  };
  function submitCampaign$slambda_0($activityTypes, $latitude, $longitude, $radiusKm, $destinationUrl, $startDate, $endDate, $budgetUsd, $dailyBudgetUsd, $size, $placementTier, $companyId, $file, $fileInput, $status, resultContinuation) {
    var i = new submitCampaign$slambda($activityTypes, $latitude, $longitude, $radiusKm, $destinationUrl, $startDate, $endDate, $budgetUsd, $dailyBudgetUsd, $size, $placementTier, $companyId, $file, $fileInput, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function loadCampaigns$slambda($companyId, resultContinuation) {
    this.j3x_1 = $companyId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadCampaigns$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadCampaigns$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadCampaigns$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/marketers/' + this.j3x_1 + '/campaigns';
            this.m3x_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.m3x_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(AdCampaignResponse), arrayOf([]), false))]), false));
            tmp_0.l3x_1 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.l3x_1 = emptyList();
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var campaigns = this.l3x_1;
            renderCampaignsList(this.j3x_1, campaigns);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadCampaigns$slambda).h22 = function ($this$launch, completion) {
    var i = new loadCampaigns$slambda(this.j3x_1, completion);
    i.k3x_1 = $this$launch;
    return i;
  };
  function loadCampaigns$slambda_0($companyId, resultContinuation) {
    var i = new loadCampaigns$slambda($companyId, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderCampaignsList$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'marketerCampaigns.noCampaignsYet';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('marketerCampaigns.noCampaignsYet'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderCampaignsList$lambda_0($campaigns) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $campaigns.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = 'entry-card';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        // Inline function 'kotlinx.html.span' call
        var classes_0 = 'badge ' + campaignStatusBadgeClass(element.m2l_1);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_1 = new SPAN(attributesMapOf_0('class', classes_0), this_0.j1f());
        this_1.j1f().a1h(this_1);
        this_1.n1f(element.m2l_1);
        this_1.j1f().b1h(this_1);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_2 = new P(attributesMapOf_0('class', null), this_0.j1f());
        this_2.j1f().a1h(this_2);
        this_2.n1f(I18n_getInstance().e28('marketerCampaigns.sizePrefix') + sizeLabel_0(element.k2l_1));
        this_2.j1f().b1h(this_2);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_3 = new P(attributesMapOf_0('class', null), this_0.j1f());
        this_3.j1f().a1h(this_3);
        this_3.n1f(I18n_getInstance().e28('marketerCampaigns.placementPrefix') + placementLabel_0(element.l2l_1));
        this_3.j1f().b1h(this_3);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_4 = new P(attributesMapOf_0('class', null), this_0.j1f());
        this_4.j1f().a1h(this_4);
        this_4.n1f(I18n_getInstance().e28('marketerCampaigns.startedPrefix') + element.g2l_1);
        this_4.j1f().b1h(this_4);
        if (!(element.h2l_1 == null)) {
          // Inline function 'kotlinx.html.p' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_5 = new P(attributesMapOf_0('class', null), this_0.j1f());
          this_5.j1f().a1h(this_5);
          this_5.n1f(I18n_getInstance().e28('marketerCampaigns.endsPrefix') + element.h2l_1);
          this_5.j1f().b1h(this_5);
        }
        if (!(element.j2l_1 == null)) {
          // Inline function 'kotlinx.html.p' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_6 = new P(attributesMapOf_0('class', null), this_0.j1f());
          this_6.j1f().a1h(this_6);
          this_6.n1f(I18n_getInstance().e28('marketerCampaigns.dailyBudgetPrefix') + usdFromCents(element.j2l_1));
          this_6.j1f().b1h(this_6);
        }
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_7 = new P(attributesMapOf_0('class', null), this_0.j1f());
        this_7.j1f().a1h(this_7);
        this_7.n1f(I18n_getInstance().e28('marketerCampaigns.impressionsLabel') + element.o2l_1.toString());
        this_7.j1f().b1h(this_7);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_8 = new P(attributesMapOf_0('class', null), this_0.j1f());
        this_8.j1f().a1h(this_8);
        this_8.n1f(I18n_getInstance().e28('marketerCampaigns.clicksLabel') + element.p2l_1.toString());
        this_8.j1f().b1h(this_8);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_9 = new P(attributesMapOf_0('class', null), this_0.j1f());
        this_9.j1f().a1h(this_9);
        this_9.n1f(I18n_getInstance().e28('marketerCampaigns.timeDisplayedLabel') + formatDuration(element.q2l_1));
        this_9.j1f().b1h(this_9);
        // Inline function 'kotlinx.html.div' call
        var classes_1 = 'entry-actions';
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_10 = new DIV(attributesMapOf_0('class', classes_1), this_0.j1f());
        this_10.j1f().a1h(this_10);
        if (element.m2l_1 === 'ACTIVE' || element.m2l_1 === 'SCHEDULED') {
          // Inline function 'kotlinx.html.button' call
          var classes_2 = 'btn-reject';
          var tmp = null == null ? null : enumEncode(null);
          var tmp_0 = null == null ? null : enumEncode(null);
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_11 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_2]), this_10.j1f());
          this_11.j1f().a1h(this_11);
          this_11.z1j(ButtonType_button_getInstance());
          set_id(this_11, 'pauseCampaign-' + element.d2l_1);
          var tmp0 = this_11.l1f();
          var tmp2 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value = 'marketerCampaigns.pauseButton';
          tmp0.m2(tmp2, value);
          this_11.n1f(I18n_getInstance().e28('marketerCampaigns.pauseButton'));
          this_11.j1f().b1h(this_11);
        }
        if (element.m2l_1 === 'PAUSED') {
          // Inline function 'kotlinx.html.button' call
          var tmp_1 = null == null ? null : enumEncode(null);
          var tmp_2 = null == null ? null : enumEncode(null);
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_12 = new BUTTON(attributesMapOf(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_10.j1f());
          this_12.j1f().a1h(this_12);
          this_12.z1j(ButtonType_button_getInstance());
          set_id(this_12, 'resumeCampaign-' + element.d2l_1);
          var tmp0_0 = this_12.l1f();
          var tmp2_0 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value_0 = 'marketerCampaigns.resumeButton';
          tmp0_0.m2(tmp2_0, value_0);
          this_12.n1f(I18n_getInstance().e28('marketerCampaigns.resumeButton'));
          this_12.j1f().b1h(this_12);
        }
        this_10.j1f().b1h(this_10);
        // Inline function 'kotlinx.html.form' call
        var tmp_3 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_13 = new FORM(attributesMapOf(['action', null, 'enctype', tmp_3, 'method', null == null ? null : enumEncode(null), 'class', null]), this_0.j1f());
        this_13.j1f().a1h(this_13);
        set_id(this_13, 'topupForm-' + element.d2l_1);
        // Inline function 'kotlinx.html.label' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_14 = new LABEL(attributesMapOf_0('class', null), this_13.j1f());
        this_14.j1f().a1h(this_14);
        var tmp0_1 = this_14.l1f();
        var tmp2_1 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value_1 = 'marketerCampaigns.topupLabel';
        tmp0_1.m2(tmp2_1, value_1);
        this_14.n1f(I18n_getInstance().e28('marketerCampaigns.topupLabel'));
        // Inline function 'kotlinx.html.input' call
        var tmp0_safe_receiver = InputType_number_getInstance();
        var tmp_4 = tmp0_safe_receiver == null ? null : enumEncode(tmp0_safe_receiver);
        var tmp_5 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_15 = new INPUT(attributesMapOf(['type', tmp_4, 'formenctype', tmp_5, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_14.j1f());
        this_15.j1f().a1h(this_15);
        set_id(this_15, 'topupAmountUsd-' + element.d2l_1);
        // Inline function 'kotlin.collections.set' call
        this_15.l1f().m2('min', '1');
        // Inline function 'kotlin.collections.set' call
        this_15.l1f().m2('step', '1');
        this_15.j1f().b1h(this_15);
        this_14.j1f().b1h(this_14);
        // Inline function 'kotlinx.html.button' call
        var tmp_6 = null == null ? null : enumEncode(null);
        var tmp_7 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_16 = new BUTTON(attributesMapOf(['formenctype', tmp_6, 'formmethod', tmp_7, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_13.j1f());
        this_16.j1f().a1h(this_16);
        this_16.z1j(ButtonType_submit_getInstance());
        var tmp0_2 = this_16.l1f();
        var tmp2_2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value_2 = 'marketerCampaigns.topupButton';
        tmp0_2.m2(tmp2_2, value_2);
        this_16.n1f(I18n_getInstance().e28('marketerCampaigns.topupButton'));
        this_16.j1f().b1h(this_16);
        this_13.j1f().b1h(this_13);
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_17 = new DIV(attributesMapOf_0('class', 'hidden'), this_0.j1f());
        this_17.j1f().a1h(this_17);
        set_id(this_17, 'topupStatus-' + element.d2l_1);
        this_17.j1f().b1h(this_17);
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function renderCampaignsList$lambda_1($companyId, $campaign) {
    return function (it) {
      setCampaignStatus($companyId, $campaign.d2l_1, 'pause');
      return Unit_instance;
    };
  }
  function renderCampaignsList$lambda_2($companyId, $campaign) {
    return function (it) {
      setCampaignStatus($companyId, $campaign.d2l_1, 'resume');
      return Unit_instance;
    };
  }
  function renderCampaignsList$lambda_3($companyId, $campaign) {
    return function (event) {
      event.preventDefault();
      topUpCampaignBudget($companyId, $campaign.d2l_1);
      return Unit_instance;
    };
  }
  function setCampaignStatus$slambda($companyId, $campaignId, $action, resultContinuation) {
    this.v3x_1 = $companyId;
    this.w3x_1 = $campaignId;
    this.x3x_1 = $action;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(setCampaignStatus$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(setCampaignStatus$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(setCampaignStatus$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            this.t7_1 = 1;
            suspendResult = ApiClient_getInstance().g27('PUT', '/api/v1/bitacora/marketers/' + this.v3x_1 + '/campaigns/' + this.w3x_1 + '/' + this.x3x_1, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z3x_1 = suspendResult;
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof Error) {
              var e = this.w7_1;
              var tmp_1 = this;
              tmp_1.z3x_1 = Unit_instance;
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            loadCampaigns(this.v3x_1);
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(setCampaignStatus$slambda).h22 = function ($this$launch, completion) {
    var i = new setCampaignStatus$slambda(this.v3x_1, this.w3x_1, this.x3x_1, completion);
    i.y3x_1 = $this$launch;
    return i;
  };
  function setCampaignStatus$slambda_0($companyId, $campaignId, $action, resultContinuation) {
    var i = new setCampaignStatus$slambda($companyId, $campaignId, $action, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function topUpCampaignBudget$slambda($companyId, $campaignId, $amountUsd, $status, resultContinuation) {
    this.i3y_1 = $companyId;
    this.j3y_1 = $campaignId;
    this.k3y_1 = $amountUsd;
    this.l3y_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(topUpCampaignBudget$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(topUpCampaignBudget$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(topUpCampaignBudget$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/marketers/' + this.i3y_1 + '/campaigns/' + this.j3y_1 + '/topup';
            var body = new AllocateAdCampaignBudgetRequest(numberToLong(this.k3y_1 * 100));
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(AllocateAdCampaignBudgetRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            loadCampaigns(this.i3y_1);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              this.l3y_1.classList.remove('hidden');
              showError(this.l3y_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                this.l3y_1.classList.remove('hidden');
                showError(this.l3y_1, I18n_getInstance().e28('marketerCampaigns.genericErrorPrefix') + e_0.message);
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(topUpCampaignBudget$slambda).h22 = function ($this$launch, completion) {
    var i = new topUpCampaignBudget$slambda(this.i3y_1, this.j3y_1, this.k3y_1, this.l3y_1, completion);
    i.m3y_1 = $this$launch;
    return i;
  };
  function topUpCampaignBudget$slambda_0($companyId, $campaignId, $amountUsd, $status, resultContinuation) {
    var i = new topUpCampaignBudget$slambda($companyId, $campaignId, $amountUsd, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function set_expandedEntryId(_set____db54di) {
    _init_properties_MyBitacoraPage_kt__gi76qy();
    expandedEntryId = _set____db54di;
  }
  function get_expandedEntryId() {
    _init_properties_MyBitacoraPage_kt__gi76qy();
    return expandedEntryId;
  }
  var expandedEntryId;
  function set_lastLoadedEntries(_set____db54di) {
    _init_properties_MyBitacoraPage_kt__gi76qy();
    lastLoadedEntries = _set____db54di;
  }
  function get_lastLoadedEntries() {
    _init_properties_MyBitacoraPage_kt__gi76qy();
    return lastLoadedEntries;
  }
  var lastLoadedEntries;
  function loadMyEntries() {
    _init_properties_MyBitacoraPage_kt__gi76qy();
    var tmp = document.getElementById('myBitacoraList');
    var content = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('filterActivityType');
    var activityType = (tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('filterFrom');
    var from = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    var tmp_2 = document.getElementById('filterTo');
    var to = (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value;
    var tmp_3;
    var tmp_4;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(from)) {
      // Inline function 'kotlin.text.isNotBlank' call
      tmp_4 = !isBlank(to);
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = compareTo(from, to) > 0;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      content.innerHTML = '';
      append(content, loadMyEntries$lambda);
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(activityType)) {
      this_0.x('activityType=' + activityType);
    }
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(from)) {
      this_0.x('from=' + from + 'T00:00:00Z');
    }
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(to)) {
      this_0.x('to=' + to + 'T23:59:59Z');
    }
    var tmp$ret$2 = this_0.s4();
    // Inline function 'kotlin.let' call
    var it = joinToString(tmp$ret$2, '&');
    var query = isBlank(it) ? '' : '?' + it;
    var tmp_5 = get_AppScope();
    launch(tmp_5, VOID, VOID, loadMyEntries$slambda_0(query, content, null));
  }
  function renderArchiveUpsell(hasArchivedHistory) {
    _init_properties_MyBitacoraPage_kt__gi76qy();
    var tmp = document.getElementById('archiveUpsellSlot');
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var slot = tmp_0;
    slot.innerHTML = '';
    if (hasArchivedHistory) {
      append(slot, renderArchiveUpsell$lambda);
    }
  }
  function renderEntries(content, entries) {
    _init_properties_MyBitacoraPage_kt__gi76qy();
    set_lastLoadedEntries(entries);
    content.innerHTML = '';
    append(content, renderEntries$lambda(entries));
  }
  function toggleEntryDetail(entryId) {
    _init_properties_MyBitacoraPage_kt__gi76qy();
    var wasExpanded = get_expandedEntryId() === entryId;
    set_expandedEntryId(wasExpanded ? null : entryId);
    var tmp = document.getElementById('entry-detail-' + entryId);
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var detail = tmp_0;
    if (wasExpanded) {
      detail.classList.add('hidden');
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.find' call
    var tmp0 = get_lastLoadedEntries();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.h2h_1 === entryId) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp1_elvis_lhs = tmp$ret$1;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var entry = tmp_1;
    var tmp2_safe_receiver = entry.x2h_1;
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d2h_1;
    var trackPoints = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
    detail.innerHTML = '';
    append(detail, toggleEntryDetail$lambda(trackPoints, entryId, entry));
    detail.classList.remove('hidden');
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!trackPoints.r()) {
      var tmp_2 = 'map-' + entryId;
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(trackPoints, 10));
      var _iterator__ex2g4s_0 = trackPoints.t();
      while (_iterator__ex2g4s_0.u()) {
        var item = _iterator__ex2g4s_0.v();
        var tmp$ret$7 = to(item.v2g_1, item.w2g_1);
        destination.x(tmp$ret$7);
      }
      renderMapLibreTrackMap(tmp_2, destination);
    } else {
      if (!(entry.s2h_1 == null) && !(entry.t2h_1 == null)) {
        renderMapLibreMap('map-' + entryId, entry.s2h_1, entry.t2h_1);
      }
    }
  }
  function MyBitacoraPageModule$init$lambda(event) {
    event.preventDefault();
    loadMyEntries();
    return Unit_instance;
  }
  function MyBitacoraPageModule() {
  }
  protoOf(MyBitacoraPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    set_expandedEntryId(null);
    var tmp = document.getElementById('filterActivityType');
    appendActivityTypeOptions(tmp instanceof HTMLSelectElement ? tmp : THROW_CCE());
    var tmp_0 = document.getElementById('bitacoraFilterForm');
    var tmp_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    tmp_1.addEventListener('submit', MyBitacoraPageModule$init$lambda);
    loadMyEntries();
  };
  var MyBitacoraPageModule_instance;
  function MyBitacoraPageModule_getInstance() {
    return MyBitacoraPageModule_instance;
  }
  function loadMyEntries$lambda($this$append) {
    _init_properties_MyBitacoraPage_kt__gi76qy();
    // Inline function 'kotlinx.html.p' call
    var classes = 'status-error';
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    this_0.n1f(I18n_getInstance().e28('myBitacora.dateRangeInvalidError'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function loadMyEntries$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('myBitacora.loadError') + ': ' + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadMyEntries$slambda$lambda_0($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('myBitacora.loadError') + ': ' + $e.message);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadMyEntries$slambda($query, $content, resultContinuation) {
    this.v3y_1 = $query;
    this.w3y_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadMyEntries$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadMyEntries$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadMyEntries$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 3;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/entries/mine' + this.v3y_1;
            var tmp4 = 'X-Has-Archived-History';
            this.b3z_1 = tmp0;
            this.z3y_1 = tmp4;
            this.c3z_1 = true;
            var headers = new Headers();
            if (this.c3z_1) {
              var tmp0_safe_receiver = AuthState_instance.y2w();
              if (tmp0_safe_receiver == null)
                null;
              else {
                headers.append('Authorization', 'Bearer ' + tmp0_safe_receiver);
              }
            }

            var init = {};
            init.method = 'GET';
            init.headers = headers;
            this.t7_1 = 1;
            suspendResult = await_0(window.fetch(this.b3z_1.e27_1 + tmp2, init), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.a3z_1 = suspendResult;
            this.t7_1 = 2;
            suspendResult = await_0(this.a3z_1.text(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var text = suspendResult;
            if (!this.a3z_1.ok) {
              this.b3z_1.z2w(this.a3z_1.status, this.c3z_1);
              var this_0 = this.b3z_1;
              var tmp_0;
              try {
                var this_1 = this_0.f27_1;
                var this_2 = this_1.um();
                var this_3 = serializer(this_2, createKType(getKClass(ErrorResponse), arrayOf([]), false));
                var value = this_1.i13(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), text);
                tmp_0 = _Result___init__impl__xyqfz8(value);
              } catch ($p) {
                var tmp_1;
                if ($p instanceof Error) {
                  var e = $p;
                  tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
                } else {
                  throw $p;
                }
                tmp_0 = tmp_1;
              }
              var this_4 = tmp_0;
              var parsed = _Result___get_isFailure__impl__jpiriv(this_4) ? null : _Result___get_value__impl__bjfvqg(this_4);
              var tmp_2 = this.a3z_1.status;
              var tmp2_elvis_lhs = parsed == null ? null : parsed.p2c_1;
              var tmp_3;
              if (tmp2_elvis_lhs == null) {
                var tmp_4;
                if (isBlank(text)) {
                  tmp_4 = 'Request failed';
                } else {
                  tmp_4 = text;
                }
                tmp_3 = tmp_4;
              } else {
                tmp_3 = tmp2_elvis_lhs;
              }
              var tmp_5 = tmp_3;
              throw new ApiException(tmp_2, tmp_5, parsed == null ? null : parsed.q2c_1);
            }

            var this_5 = this.b3z_1.f27_1;
            var this_6 = this_5.um();
            var this_7 = serializer(this_6, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(BitacoraEntryResponse), arrayOf([]), false))]), false));
            var _destruct__k2r9zo = to(this_5.i13(isInterface(this_7, KSerializer) ? this_7 : THROW_CCE(), text), this.a3z_1.headers.get(this.z3y_1));
            var entries = _destruct__k2r9zo.g9();
            var hasArchivedHistory = _destruct__k2r9zo.h9();
            renderEntries(this.w3y_1, entries);
            var tmp_6 = this;
            renderArchiveUpsell(hasArchivedHistory === 'true');
            tmp_6.y3y_1 = Unit_instance;
            this.u7_1 = 4;
            this.t7_1 = 5;
            continue $sm;
          case 3:
            this.u7_1 = 4;
            var tmp_7 = this.w7_1;
            if (tmp_7 instanceof ApiException) {
              var e_0 = this.w7_1;
              var tmp_8 = this;
              if (e_0.j2c_1 === 401)
                return Unit_instance;
              this.w3y_1.innerHTML = '';
              tmp_8.y3y_1 = append(this.w3y_1, loadMyEntries$slambda$lambda(e_0));
              this.t7_1 = 5;
              continue $sm;
            } else {
              var tmp_9 = this.w7_1;
              if (tmp_9 instanceof Error) {
                var e_1 = this.w7_1;
                var tmp_10 = this;
                this.w3y_1.innerHTML = '';
                tmp_10.y3y_1 = append(this.w3y_1, loadMyEntries$slambda$lambda_0(e_1));
                this.t7_1 = 5;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 4:
            throw this.w7_1;
          case 5:
            this.u7_1 = 4;
            return Unit_instance;
        }
      } catch ($p_0) {
        var e_2 = $p_0;
        if (this.u7_1 === 4) {
          throw e_2;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_2;
        }
      }
     while (true);
  };
  protoOf(loadMyEntries$slambda).h22 = function ($this$launch, completion) {
    var i = new loadMyEntries$slambda(this.v3y_1, this.w3y_1, completion);
    i.x3y_1 = $this$launch;
    return i;
  };
  function loadMyEntries$slambda_0($query, $content, resultContinuation) {
    var i = new loadMyEntries$slambda($query, $content, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderArchiveUpsell$lambda($this$append) {
    _init_properties_MyBitacoraPage_kt__gi76qy();
    // Inline function 'kotlinx.html.div' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new DIV(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    upsellBanner(this_0, 'myBitacora.archiveUpsell', 'archiveUpsell');
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function sam$kotlin_Comparator$0_5(function_0) {
    this.d3z_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_5).cc = function (a, b) {
    return this.d3z_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_5).compare = function (a, b) {
    return this.cc(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_5).c3 = function () {
    return this.d3z_1;
  };
  protoOf(sam$kotlin_Comparator$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.c3(), other.c3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_5).hashCode = function () {
    return hashCode(this.c3());
  };
  function renderEntries$lambda$lambda(a, b) {
    _init_properties_MyBitacoraPage_kt__gi76qy();
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.m2h_1;
    var tmp$ret$2 = a.m2h_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function renderEntries$lambda$lambda_0($entry) {
    return function (it) {
      toggleEntryDetail($entry.h2h_1);
      return Unit_instance;
    };
  }
  function renderEntries$lambda($entries) {
    return function ($this$append) {
      var tmp;
      if ($entries.r()) {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp0 = this_0.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = 'myBitacora.noActivities';
        tmp0.m2(tmp2, value);
        this_0.n1f(I18n_getInstance().e28('myBitacora.noActivities'));
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      // Inline function 'kotlin.collections.sortedByDescending' call
      var this_1 = $entries;
      // Inline function 'kotlin.comparisons.compareByDescending' call
      var tmp_0 = renderEntries$lambda$lambda;
      var tmp$ret$8 = new sam$kotlin_Comparator$0_5(tmp_0);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = sortedWith(this_1, tmp$ret$8).t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = 'entry-card';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_2 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_2.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_2.j1f().a1h(this_2);
        set_onClickFunction(this_2, renderEntries$lambda$lambda_0(element));
        // Inline function 'kotlinx.html.h3' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_3 = new H3(attributesMapOf_0('class', null), this_2.j1f());
        this_3.j1f().a1h(this_3);
        this_3.n1f(activityTypeLabel(element.l2h_1));
        this_3.j1f().b1h(this_3);
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlinx.html.span' call
        var classes_0 = 'badge badge-' + element.q2h_1.s2_1.toLowerCase();
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_4 = new SPAN(attributesMapOf_0('class', classes_0), this_2.j1f());
        this_4.j1f().a1h(this_4);
        this_4.n1f(element.q2h_1.s2_1);
        this_4.j1f().b1h(this_4);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_5 = new P(attributesMapOf_0('class', null), this_2.j1f());
        this_5.j1f().a1h(this_5);
        this_5.n1f(I18n_getInstance().e28('myBitacora.loggedAtLabel') + ': ' + element.m2h_1);
        this_5.j1f().b1h(this_5);
        if (!(element.p2h_1 == null)) {
          // Inline function 'kotlinx.html.p' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_6 = new P(attributesMapOf_0('class', null), this_2.j1f());
          this_6.j1f().a1h(this_6);
          this_6.n1f(I18n_getInstance().e28('myBitacora.notesLabel') + ': ' + element.p2h_1);
          this_6.j1f().b1h(this_6);
        }
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_7 = new DIV(attributesMapOf_0('class', 'hidden'), this_2.j1f());
        this_7.j1f().a1h(this_7);
        set_id(this_7, 'entry-detail-' + element.h2h_1);
        this_7.j1f().b1h(this_7);
        this_2.j1f().b1h(this_2);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function toggleEntryDetail$lambda($trackPoints, $entryId, $entry) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$trackPoints.r()) {
        // Inline function 'kotlinx.html.div' call
        var classes = 'map-container';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        set_id(this_0, 'map-' + $entryId);
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
      } else {
        if (!($entry.s2h_1 == null) && !($entry.t2h_1 == null)) {
          // Inline function 'kotlinx.html.div' call
          var classes_0 = 'map-container';
          // Inline function 'kotlinx.html.visitAndFinalize' call
          // Inline function 'kotlinx.html.visitTagAndFinalize' call
          var this_1 = new DIV(attributesMapOf_0('class', classes_0), $this$append);
          if (!(this_1.j1f() === $this$append)) {
            throw IllegalArgumentException_init_$Create$('Wrong exception');
          }
          // Inline function 'kotlinx.html.visitTag' call
          this_1.j1f().a1h(this_1);
          set_id(this_1, 'map-' + $entryId);
          this_1.j1f().b1h(this_1);
          $this$append.d1h();
        } else {
          // Inline function 'kotlinx.html.p' call
          // Inline function 'kotlinx.html.visitAndFinalize' call
          // Inline function 'kotlinx.html.visitTagAndFinalize' call
          var this_2 = new P(attributesMapOf_0('class', null), $this$append);
          if (!(this_2.j1f() === $this$append)) {
            throw IllegalArgumentException_init_$Create$('Wrong exception');
          }
          // Inline function 'kotlinx.html.visitTag' call
          this_2.j1f().a1h(this_2);
          var tmp0 = this_2.l1f();
          var tmp2 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value = 'myBitacora.noLocation';
          tmp0.m2(tmp2, value);
          this_2.n1f(I18n_getInstance().e28('myBitacora.noLocation'));
          this_2.j1f().b1h(this_2);
          $this$append.d1h();
        }
      }
      return Unit_instance;
    };
  }
  var properties_initialized_MyBitacoraPage_kt_rh17bg;
  function _init_properties_MyBitacoraPage_kt__gi76qy() {
    if (!properties_initialized_MyBitacoraPage_kt_rh17bg) {
      properties_initialized_MyBitacoraPage_kt_rh17bg = true;
      expandedEntryId = null;
      lastLoadedEntries = emptyList();
    }
  }
  function OAuthCallbackPageModule() {
  }
  protoOf(OAuthCallbackPageModule).r28 = function () {
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('handoff');
    var tmp$ret$0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    completeOAuthCallback(tmp$ret$0, '/login');
  };
  var OAuthCallbackPageModule_instance;
  function OAuthCallbackPageModule_getInstance() {
    return OAuthCallbackPageModule_instance;
  }
  function completeOAuthCallback(handoffCode, loginLinkHref) {
    var tmp = document.getElementById('oauthCallbackStatus');
    var statusBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    if (isBlank(handoffCode)) {
      statusBox.innerHTML = '';
      statusBox.classList.add('status-error');
      append(statusBox, completeOAuthCallback$lambda(loginLinkHref));
      return Unit_instance;
    }
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, completeOAuthCallback$slambda_0(handoffCode, statusBox, loginLinkHref, null));
  }
  function completeOAuthCallback$lambda($loginLinkHref) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f('This sign-in link is missing its handoff code.');
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_1 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), $this$append);
      if (!(this_1.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_1.j1f().a1h(this_1);
      this_1.q1j($loginLinkHref);
      this_1.n1f('Back to login');
      this_1.j1f().b1h(this_1);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function completeOAuthCallback$slambda$lambda($e, $loginLinkHref) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f('Sign-in failed: ' + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_1 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), $this$append);
      if (!(this_1.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_1.j1f().a1h(this_1);
      this_1.q1j($loginLinkHref);
      this_1.n1f('Back to login');
      this_1.j1f().b1h(this_1);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function completeOAuthCallback$slambda$lambda_0($e, $loginLinkHref) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f('Something went wrong: ' + $e.message);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_1 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), $this$append);
      if (!(this_1.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_1.j1f().a1h(this_1);
      this_1.q1j($loginLinkHref);
      this_1.n1f('Back to login');
      this_1.j1f().b1h(this_1);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function completeOAuthCallback$slambda($handoffCode, $statusBox, $loginLinkHref, resultContinuation) {
    this.m3z_1 = $handoffCode;
    this.n3z_1 = $statusBox;
    this.o3z_1 = $loginLinkHref;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(completeOAuthCallback$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(completeOAuthCallback$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(completeOAuthCallback$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 3;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/auth/oauth/complete';
            var body = new OAuthCompleteRequest(this.m3z_1);
            this.r3z_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(OAuthCompleteRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.r3z_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(TokenResponse), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            AuthState_instance.m2y(result.t2c_1, result.u2c_1);
            this.t7_1 = 2;
            suspendResult = navigateAfterAuth(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_0 = this;
            tmp_0.q3z_1 = Unit_instance;
            this.u7_1 = 4;
            this.t7_1 = 5;
            continue $sm;
          case 3:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.n3z_1.innerHTML = '';
              this.n3z_1.classList.add('status-error');
              tmp_2.q3z_1 = append(this.n3z_1, completeOAuthCallback$slambda$lambda(e, this.o3z_1));
              this.t7_1 = 5;
              continue $sm;
            } else {
              var tmp_3 = this.w7_1;
              if (tmp_3 instanceof Error) {
                var e_0 = this.w7_1;
                var tmp_4 = this;
                this.n3z_1.innerHTML = '';
                this.n3z_1.classList.add('status-error');
                tmp_4.q3z_1 = append(this.n3z_1, completeOAuthCallback$slambda$lambda_0(e_0, this.o3z_1));
                this.t7_1 = 5;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 4:
            throw this.w7_1;
          case 5:
            this.u7_1 = 4;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 4) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(completeOAuthCallback$slambda).h22 = function ($this$launch, completion) {
    var i = new completeOAuthCallback$slambda(this.m3z_1, this.n3z_1, this.o3z_1, completion);
    i.p3z_1 = $this$launch;
    return i;
  };
  function completeOAuthCallback$slambda_0($handoffCode, $statusBox, $loginLinkHref, resultContinuation) {
    var i = new completeOAuthCallback$slambda($handoffCode, $statusBox, $loginLinkHref, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function get_moduleNavigateTo() {
    _init_properties_PageModuleNavigation_kt__o3sd5d();
    return moduleNavigateTo;
  }
  var moduleNavigateTo;
  function defaultModuleNavigateTo(path) {
    _init_properties_PageModuleNavigation_kt__o3sd5d();
    window.location.href = path;
  }
  function defaultModuleNavigateTo$ref() {
    return constructCallableReference(function (p0) {
      defaultModuleNavigateTo(p0);
      return Unit_instance;
    }, 1, 0, 13, 'defaultModuleNavigateTo');
  }
  var properties_initialized_PageModuleNavigation_kt_x4kbkf;
  function _init_properties_PageModuleNavigation_kt__o3sd5d() {
    if (!properties_initialized_PageModuleNavigation_kt_x4kbkf) {
      properties_initialized_PageModuleNavigation_kt_x4kbkf = true;
      moduleNavigateTo = defaultModuleNavigateTo$ref();
    }
  }
  function PendingApprovalsPageModule() {
  }
  protoOf(PendingApprovalsPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    loadPending_0();
  };
  var PendingApprovalsPageModule_instance;
  function PendingApprovalsPageModule_getInstance() {
    return PendingApprovalsPageModule_instance;
  }
  function loadPending_0() {
    var tmp = document.getElementById('pendingList');
    var content = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadPending$slambda_2(content, null));
  }
  function renderPendingList(content, entries) {
    content.innerHTML = '';
    append(content, renderPendingList$lambda(entries));
  }
  function decide_0(entryId, decision) {
    var tmp = document.getElementById('status-' + entryId);
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, decide$slambda_2(entryId, decision, status, null));
  }
  function loadPending$slambda$lambda_0($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('pendingApprovals.pendingLoadError') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadPending$slambda_1($content, resultContinuation) {
    this.a40_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadPending$slambda_1).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadPending$slambda_1).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadPending$slambda_1).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/entries/pending-for-me';
            this.d40_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.d40_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(BitacoraEntryResponse), arrayOf([]), false))]), false));
            var entries = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            renderPendingList(this.a40_1, entries);
            tmp_0.c40_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.a40_1.innerHTML = '';
              tmp_2.c40_1 = append(this.a40_1, loadPending$slambda$lambda_0(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadPending$slambda_1).h22 = function ($this$launch, completion) {
    var i = new loadPending$slambda_1(this.a40_1, completion);
    i.b40_1 = $this$launch;
    return i;
  };
  function loadPending$slambda_2($content, resultContinuation) {
    var i = new loadPending$slambda_1($content, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderPendingList$lambda$lambda($entry) {
    return function (it) {
      decide_0($entry.h2h_1, VerificationDecision_APPROVED_getInstance());
      return Unit_instance;
    };
  }
  function renderPendingList$lambda$lambda_0($entry) {
    return function (it) {
      decide_0($entry.h2h_1, VerificationDecision_REJECTED_getInstance());
      return Unit_instance;
    };
  }
  function renderPendingList$lambda($entries) {
    return function ($this$append) {
      var tmp;
      if ($entries.r()) {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp0 = this_0.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = 'pendingApprovals.nothingPending';
        tmp0.m2(tmp2, value);
        this_0.n1f(I18n_getInstance().e28('pendingApprovals.nothingPending'));
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $entries.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = 'entry-card';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_1 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_1.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_1.j1f().a1h(this_1);
        // Inline function 'kotlinx.html.h3' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_2 = new H3(attributesMapOf_0('class', null), this_1.j1f());
        this_2.j1f().a1h(this_2);
        this_2.n1f(activityTypeLabel(element.l2h_1));
        this_2.j1f().b1h(this_2);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_3 = new P(attributesMapOf_0('class', null), this_1.j1f());
        this_3.j1f().a1h(this_3);
        var tmp_0 = I18n_getInstance().e28('pendingApprovals.fromUser');
        var tmp0_elvis_lhs = element.j2h_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? element.v2h_1 : tmp0_elvis_lhs;
        this_3.n1f(tmp_0 + (tmp1_elvis_lhs == null ? I18n_getInstance().e28('pendingApprovals.unknownGuestName') : tmp1_elvis_lhs));
        this_3.j1f().b1h(this_3);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_4 = new P(attributesMapOf_0('class', null), this_1.j1f());
        this_4.j1f().a1h(this_4);
        this_4.n1f(I18n_getInstance().e28('pendingApprovals.loggedAt') + element.m2h_1);
        this_4.j1f().b1h(this_4);
        if (!(element.p2h_1 == null)) {
          // Inline function 'kotlinx.html.p' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_5 = new P(attributesMapOf_0('class', null), this_1.j1f());
          this_5.j1f().a1h(this_5);
          this_5.n1f(I18n_getInstance().e28('pendingApprovals.notes') + element.p2h_1);
          this_5.j1f().b1h(this_5);
        }
        // Inline function 'kotlinx.html.div' call
        var classes_0 = 'entry-actions';
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_6 = new DIV(attributesMapOf_0('class', classes_0), this_1.j1f());
        this_6.j1f().a1h(this_6);
        // Inline function 'kotlinx.html.button' call
        var classes_1 = 'btn-approve';
        var tmp_1 = null == null ? null : enumEncode(null);
        var tmp_2 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_7 = new BUTTON(attributesMapOf(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_1]), this_6.j1f());
        this_7.j1f().a1h(this_7);
        set_onClickFunction(this_7, renderPendingList$lambda$lambda(element));
        var tmp0_0 = this_7.l1f();
        var tmp2_0 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value_0 = 'pendingApprovals.approve';
        tmp0_0.m2(tmp2_0, value_0);
        this_7.n1f(I18n_getInstance().e28('pendingApprovals.approve'));
        this_7.j1f().b1h(this_7);
        // Inline function 'kotlinx.html.button' call
        var classes_2 = 'btn-reject';
        var tmp_3 = null == null ? null : enumEncode(null);
        var tmp_4 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_8 = new BUTTON(attributesMapOf(['formenctype', tmp_3, 'formmethod', tmp_4, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_2]), this_6.j1f());
        this_8.j1f().a1h(this_8);
        set_onClickFunction(this_8, renderPendingList$lambda$lambda_0(element));
        var tmp0_1 = this_8.l1f();
        var tmp2_1 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value_1 = 'pendingApprovals.reject';
        tmp0_1.m2(tmp2_1, value_1);
        this_8.n1f(I18n_getInstance().e28('pendingApprovals.reject'));
        this_8.j1f().b1h(this_8);
        this_6.j1f().b1h(this_6);
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_9 = new DIV(attributesMapOf_0('class', null), this_1.j1f());
        this_9.j1f().a1h(this_9);
        set_id(this_9, 'status-' + element.h2h_1);
        this_9.j1f().b1h(this_9);
        this_1.j1f().b1h(this_1);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function decide$slambda_1($entryId, $decision, $status, resultContinuation) {
    this.m40_1 = $entryId;
    this.n40_1 = $decision;
    this.o40_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(decide$slambda_1).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(decide$slambda_1).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(decide$slambda_1).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/entries/' + this.m40_1 + '/verify';
            var body = new VerifyBitacoraEntryRequest(this.n40_1);
            this.q40_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(VerifyBitacoraEntryRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.q40_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(BitacoraEntryResponse), arrayOf([]), false));
            this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            loadPending_0();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.o40_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(decide$slambda_1).h22 = function ($this$launch, completion) {
    var i = new decide$slambda_1(this.m40_1, this.n40_1, this.o40_1, completion);
    i.p40_1 = $this$launch;
    return i;
  };
  function decide$slambda_2($entryId, $decision, $status, resultContinuation) {
    var i = new decide$slambda_1($entryId, $decision, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function get_PRIVACY_SECTIONS() {
    _init_properties_PrivacyPage_kt__rfokcb();
    return PRIVACY_SECTIONS;
  }
  var PRIVACY_SECTIONS;
  function PrivacyPageModule$init$lambda($this$append) {
    // Inline function 'kotlinx.html.div' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new DIV(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    legalDocument(this_0, 'legal.privacy.title', 'legal.privacy.updated', 'legal.privacy.intro', get_PRIVACY_SECTIONS());
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function PrivacyPageModule() {
  }
  protoOf(PrivacyPageModule).r28 = function () {
    var tmp = document.getElementById('legal-content');
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var container = tmp_0;
    append(container, PrivacyPageModule$init$lambda);
  };
  var PrivacyPageModule_instance;
  function PrivacyPageModule_getInstance() {
    return PrivacyPageModule_instance;
  }
  var properties_initialized_PrivacyPage_kt_tqqc1z;
  function _init_properties_PrivacyPage_kt__rfokcb() {
    if (!properties_initialized_PrivacyPage_kt_tqqc1z) {
      properties_initialized_PrivacyPage_kt_tqqc1z = true;
      // Inline function 'kotlin.collections.map' call
      var this_0 = numberRangeToNumber(1, 10);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.j1_1;
      var last = this_0.k1_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$2 = 'legal.privacy.s' + item;
          destination.x(tmp$ret$2);
        }
         while (!(item === last));
      PRIVACY_SECTIONS = destination;
    }
  }
  function ProfilePageModule() {
  }
  protoOf(ProfilePageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    if (AuthState_instance.z27()) {
      get_moduleNavigateTo()('/');
      return Unit_instance;
    }
    loadProfile();
  };
  var ProfilePageModule_instance;
  function ProfilePageModule_getInstance() {
    return ProfilePageModule_instance;
  }
  function loadProfile() {
    var tmp = document.getElementById('profileContent');
    var content = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadProfile$slambda_0(content, null));
  }
  function renderProfileContent(content, profile) {
    content.innerHTML = '';
    append(content, renderProfileContent$lambda(profile));
    var tmp = document.getElementById('displayNameForm');
    var tmp_0 = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    tmp_0.addEventListener('submit', renderProfileContent$lambda_0);
    var tmp_1 = document.getElementById('avatarForm');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('submit', renderProfileContent$lambda_1);
    if (profile.x25_1 === 'ACTIVITY_PRACTITIONER') {
      var tmp_3 = document.getElementById('nicknameForm');
      var tmp_4 = tmp_3 instanceof HTMLElement ? tmp_3 : THROW_CCE();
      tmp_4.addEventListener('submit', renderProfileContent$lambda_2);
    }
    if (profile.x25_1 === 'COMPANY_MEMBER' && !(profile.c26_1 == null) && (equals(profile.e26_1, CompanyMemberRole_COMPANY_ADMIN_getInstance()) || equals(profile.e26_1, CompanyMemberRole_ACTIVITY_VERIFIER_getInstance()))) {
      loadCompanyOfferingsLink(profile.c26_1, equals(profile.e26_1, CompanyMemberRole_COMPANY_ADMIN_getInstance()));
    }
  }
  function loadCompanyOfferingsLink(companyId, isCompanyAdmin) {
    var tmp = document.getElementById('companyOfferingsLink');
    var linkBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadCompanyOfferingsLink$slambda_0(companyId, linkBox, isCompanyAdmin, null));
  }
  function submitCompanyLocation(companyId) {
    var tmp = document.getElementById('companyLocationStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('companyLocation-latitude');
    var latitude = toDoubleOrNull((tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value);
    var tmp_1 = document.getElementById('companyLocation-longitude');
    var longitude = toDoubleOrNull((tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value);
    if (latitude == null || longitude == null) {
      showError(status, 'Search for a place and confirm a location first.');
      return Unit_instance;
    }
    var tmp_2 = document.getElementById('companyLocation-locationLabel');
    // Inline function 'kotlin.text.ifBlank' call
    var this_0 = (tmp_2 instanceof HTMLInputElement ? tmp_2 : THROW_CCE()).value;
    var tmp_3;
    if (isBlank(this_0)) {
      tmp_3 = null;
    } else {
      tmp_3 = this_0;
    }
    var locationLabel = tmp_3;
    var tmp_4 = get_AppScope();
    launch(tmp_4, VOID, VOID, submitCompanyLocation$slambda_0(companyId, latitude, longitude, locationLabel, status, null));
  }
  function submitDisplayNameUpdate() {
    var tmp = document.getElementById('displayNameStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('displayNameInput');
    var newName = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, submitDisplayNameUpdate$slambda_0(newName, status, null));
  }
  function submitNicknameUpdate() {
    var tmp = document.getElementById('nicknameStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('nicknameInput');
    var nickname = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, submitNicknameUpdate$slambda_0(nickname, status, null));
  }
  function submitAvatarUpload() {
    var tmp = document.getElementById('avatarStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('avatarFile');
    var fileInput = tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.js.asDynamic' call
    var file = fileInput.files[0];
    if (file == null || file == undefined) {
      showError(status, 'Choose a file first.');
      return Unit_instance;
    }
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, submitAvatarUpload$slambda_0(file, status, null));
  }
  function loadProfile$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f('Could not load your profile: ' + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadProfile$slambda$lambda_0($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f('Could not load your profile: ' + $e.message);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadProfile$slambda($content, resultContinuation) {
    this.z40_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadProfile$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadProfile$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadProfile$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/members/me';
            this.c41_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.c41_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(MyProfileResponse), arrayOf([]), false));
            var profile = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            renderProfileContent(this.z40_1, profile);
            tmp_0.b41_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.z40_1.innerHTML = '';
              tmp_2.b41_1 = append(this.z40_1, loadProfile$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_3 = this.w7_1;
              if (tmp_3 instanceof Error) {
                var e_0 = this.w7_1;
                var tmp_4 = this;
                this.z40_1.innerHTML = '';
                tmp_4.b41_1 = append(this.z40_1, loadProfile$slambda$lambda_0(e_0));
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(loadProfile$slambda).h22 = function ($this$launch, completion) {
    var i = new loadProfile$slambda(this.z40_1, completion);
    i.a41_1 = $this$launch;
    return i;
  };
  function loadProfile$slambda_0($content, resultContinuation) {
    var i = new loadProfile$slambda($content, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderProfileContent$lambda($profile) {
    return function ($this$append) {
      var tmp;
      if (!($profile.b26_1 == null)) {
        // Inline function 'kotlinx.html.img' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new IMG(attributesMapOf(['alt', null, 'src', null, 'loading', null == null ? null : enumEncode(null), 'class', null]), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        this_0.m1m($profile.b26_1);
        this_0.l1m('Avatar');
        this_0.n1m('96');
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_1 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_1.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_1.j1f().a1h(this_1);
      this_1.n1f('Email: ' + $profile.z25_1);
      this_1.j1f().b1h(this_1);
      $this$append.d1h();
      if ($profile.x25_1 === 'COMPANY_MEMBER') {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_2 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_2.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_2.j1f().a1h(this_2);
        this_2.n1f('Company: ' + $profile.d26_1);
        this_2.j1f().b1h(this_2);
        $this$append.d1h();
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_3 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_3.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_3.j1f().a1h(this_3);
        var tmp0_safe_receiver = $profile.e26_1;
        this_3.n1f('Role: ' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s2_1));
        this_3.j1f().b1h(this_3);
        $this$append.d1h();
      } else {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_4 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_4.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_4.j1f().a1h(this_4);
        this_4.n1f('Activity practitioner');
        this_4.j1f().b1h(this_4);
        $this$append.d1h();
      }
      var tmp_0;
      if ($profile.x25_1 === 'ACTIVITY_PRACTITIONER') {
        // Inline function 'kotlinx.html.h2' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_5 = new H2(attributesMapOf_0('class', null), $this$append);
        if (!(this_5.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_5.j1f().a1h(this_5);
        this_5.n1f('Leaderboard nickname');
        this_5.j1f().b1h(this_5);
        $this$append.d1h();
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_6 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_6.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_6.j1f().a1h(this_6);
        this_6.n1f('Shown on activity leaderboards instead of your name \u2014 never linked back to your account. Leave it unset to opt out.');
        this_6.j1f().b1h(this_6);
        $this$append.d1h();
        // Inline function 'kotlinx.html.form' call
        var tmp_1 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_7 = new FORM(attributesMapOf(['action', null, 'enctype', tmp_1, 'method', null == null ? null : enumEncode(null), 'class', null]), $this$append);
        if (!(this_7.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_7.j1f().a1h(this_7);
        set_id(this_7, 'nicknameForm');
        // Inline function 'kotlinx.html.textInput' call
        var tmp_2 = InputType_text_getInstance().q1i_1;
        var tmp_3 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_8 = new INPUT(attributesMapOf(['type', tmp_2, 'formenctype', tmp_3, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_7.j1f());
        this_8.j1f().a1h(this_8);
        set_id(this_8, 'nicknameInput');
        var tmp0_elvis_lhs = $profile.f26_1;
        this_8.d1m(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
        this_8.b1m('e.g. TrailBlazer');
        this_8.a1m('3');
        this_8.z1l('30');
        this_8.j1f().b1h(this_8);
        // Inline function 'kotlinx.html.button' call
        var tmp_4 = null == null ? null : enumEncode(null);
        var tmp_5 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_9 = new BUTTON(attributesMapOf(['formenctype', tmp_4, 'formmethod', tmp_5, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_7.j1f());
        this_9.j1f().a1h(this_9);
        this_9.z1j(ButtonType_submit_getInstance());
        this_9.n1f('Save');
        this_9.j1f().b1h(this_9);
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_10 = new DIV(attributesMapOf_0('class', null), this_7.j1f());
        this_10.j1f().a1h(this_10);
        set_id(this_10, 'nicknameStatus');
        this_10.j1f().b1h(this_10);
        this_7.j1f().b1h(this_7);
        $this$append.d1h();
        tmp_0 = Unit_instance;
      }
      // Inline function 'kotlinx.html.h2' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_11 = new H2(attributesMapOf_0('class', null), $this$append);
      if (!(this_11.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_11.j1f().a1h(this_11);
      this_11.n1f('Activities');
      this_11.j1f().b1h(this_11);
      $this$append.d1h();
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_12 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_12.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_12.j1f().a1h(this_12);
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_13 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), this_12.j1f());
      this_13.j1f().a1h(this_13);
      this_13.q1j('/activities/select');
      this_13.n1f('Manage which activities I practice');
      this_13.j1f().b1h(this_13);
      this_12.j1f().b1h(this_12);
      $this$append.d1h();
      // Inline function 'kotlinx.html.div' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_14 = new DIV(attributesMapOf_0('class', null), $this$append);
      if (!(this_14.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_14.j1f().a1h(this_14);
      set_id(this_14, 'companyOfferingsLink');
      this_14.j1f().b1h(this_14);
      $this$append.d1h();
      // Inline function 'kotlinx.html.h2' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_15 = new H2(attributesMapOf_0('class', null), $this$append);
      if (!(this_15.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_15.j1f().a1h(this_15);
      this_15.n1f('Display name');
      this_15.j1f().b1h(this_15);
      $this$append.d1h();
      // Inline function 'kotlinx.html.form' call
      var tmp_6 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_16 = new FORM(attributesMapOf(['action', null, 'enctype', tmp_6, 'method', null == null ? null : enumEncode(null), 'class', null]), $this$append);
      if (!(this_16.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_16.j1f().a1h(this_16);
      set_id(this_16, 'displayNameForm');
      // Inline function 'kotlinx.html.textInput' call
      var tmp_7 = InputType_text_getInstance().q1i_1;
      var tmp_8 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_17 = new INPUT(attributesMapOf(['type', tmp_7, 'formenctype', tmp_8, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_16.j1f());
      this_17.j1f().a1h(this_17);
      set_id(this_17, 'displayNameInput');
      this_17.d1m($profile.y25_1);
      this_17.c1m(true);
      this_17.j1f().b1h(this_17);
      // Inline function 'kotlinx.html.button' call
      var tmp_9 = null == null ? null : enumEncode(null);
      var tmp_10 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_18 = new BUTTON(attributesMapOf(['formenctype', tmp_9, 'formmethod', tmp_10, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_16.j1f());
      this_18.j1f().a1h(this_18);
      this_18.z1j(ButtonType_submit_getInstance());
      this_18.n1f('Save');
      this_18.j1f().b1h(this_18);
      // Inline function 'kotlinx.html.div' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_19 = new DIV(attributesMapOf_0('class', null), this_16.j1f());
      this_19.j1f().a1h(this_19);
      set_id(this_19, 'displayNameStatus');
      this_19.j1f().b1h(this_19);
      this_16.j1f().b1h(this_16);
      $this$append.d1h();
      // Inline function 'kotlinx.html.h2' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_20 = new H2(attributesMapOf_0('class', null), $this$append);
      if (!(this_20.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_20.j1f().a1h(this_20);
      this_20.n1f('Avatar');
      this_20.j1f().b1h(this_20);
      $this$append.d1h();
      // Inline function 'kotlinx.html.form' call
      var tmp_11 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_21 = new FORM(attributesMapOf(['action', null, 'enctype', tmp_11, 'method', null == null ? null : enumEncode(null), 'class', null]), $this$append);
      if (!(this_21.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_21.j1f().a1h(this_21);
      set_id(this_21, 'avatarForm');
      // Inline function 'kotlinx.html.input' call
      var tmp0_safe_receiver_0 = InputType_file_getInstance();
      var tmp_12 = tmp0_safe_receiver_0 == null ? null : enumEncode(tmp0_safe_receiver_0);
      var tmp_13 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_22 = new INPUT(attributesMapOf(['type', tmp_12, 'formenctype', tmp_13, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_21.j1f());
      this_22.j1f().a1h(this_22);
      set_id(this_22, 'avatarFile');
      this_22.x1l('image/*');
      this_22.j1f().b1h(this_22);
      // Inline function 'kotlinx.html.button' call
      var tmp_14 = null == null ? null : enumEncode(null);
      var tmp_15 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_23 = new BUTTON(attributesMapOf(['formenctype', tmp_14, 'formmethod', tmp_15, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_21.j1f());
      this_23.j1f().a1h(this_23);
      this_23.z1j(ButtonType_submit_getInstance());
      this_23.n1f('Upload');
      this_23.j1f().b1h(this_23);
      // Inline function 'kotlinx.html.div' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_24 = new DIV(attributesMapOf_0('class', null), this_21.j1f());
      this_24.j1f().a1h(this_24);
      set_id(this_24, 'avatarStatus');
      this_24.j1f().b1h(this_24);
      this_21.j1f().b1h(this_21);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function renderProfileContent$lambda_0(event) {
    event.preventDefault();
    submitDisplayNameUpdate();
    return Unit_instance;
  }
  function renderProfileContent$lambda_1(event) {
    event.preventDefault();
    submitAvatarUpload();
    return Unit_instance;
  }
  function renderProfileContent$lambda_2(event) {
    event.preventDefault();
    submitNicknameUpdate();
    return Unit_instance;
  }
  function loadCompanyOfferingsLink$slambda$lambda($isCompanyAdmin, $companyId) {
    return function ($this$append) {
      var tmp;
      if ($isCompanyAdmin) {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        // Inline function 'kotlinx.html.a' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_1 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), this_0.j1f());
        this_1.j1f().a1h(this_1);
        this_1.q1j('/bitacora/company/offerings?companyId=' + $companyId);
        this_1.n1f('Manage activity offerings');
        this_1.j1f().b1h(this_1);
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_2 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_2.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_2.j1f().a1h(this_2);
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), this_2.j1f());
      this_3.j1f().a1h(this_3);
      this_3.q1j('/bitacora/company/log?companyId=' + $companyId);
      this_3.n1f('Log an activity for a practitioner');
      this_3.j1f().b1h(this_3);
      this_2.j1f().b1h(this_2);
      $this$append.d1h();
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_4 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_4.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_4.j1f().a1h(this_4);
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_5 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), this_4.j1f());
      this_5.j1f().a1h(this_5);
      this_5.q1j('/bitacora/company/activities?companyId=' + $companyId);
      this_5.n1f("This center's activity log");
      this_5.j1f().b1h(this_5);
      this_4.j1f().b1h(this_4);
      $this$append.d1h();
      var tmp_0;
      if ($isCompanyAdmin) {
        // Inline function 'kotlinx.html.h2' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_6 = new H2(attributesMapOf_0('class', null), $this$append);
        if (!(this_6.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_6.j1f().a1h(this_6);
        this_6.n1f('Location');
        this_6.j1f().b1h(this_6);
        $this$append.d1h();
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_7 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_7.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_7.j1f().a1h(this_7);
        this_7.n1f('Search your address, then drag the pin to confirm the exact spot \u2014 this is what /discover searches against.');
        this_7.j1f().b1h(this_7);
        $this$append.d1h();
        // Inline function 'kotlinx.html.form' call
        var tmp_1 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_8 = new FORM(attributesMapOf(['action', null, 'enctype', tmp_1, 'method', null == null ? null : enumEncode(null), 'class', null]), $this$append);
        if (!(this_8.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_8.j1f().a1h(this_8);
        set_id(this_8, 'companyLocationForm');
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_9 = new DIV(attributesMapOf_0('class', null), this_8.j1f());
        this_9.j1f().a1h(this_9);
        locationSearchPicker(this_9, 'companyLocation');
        this_9.j1f().b1h(this_9);
        // Inline function 'kotlinx.html.button' call
        var tmp_2 = null == null ? null : enumEncode(null);
        var tmp_3 = null == null ? null : enumEncode(null);
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_10 = new BUTTON(attributesMapOf(['formenctype', tmp_2, 'formmethod', tmp_3, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_8.j1f());
        this_10.j1f().a1h(this_10);
        this_10.z1j(ButtonType_submit_getInstance());
        this_10.n1f('Save location');
        this_10.j1f().b1h(this_10);
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_11 = new DIV(attributesMapOf_0('class', null), this_8.j1f());
        this_11.j1f().a1h(this_11);
        set_id(this_11, 'companyLocationStatus');
        this_11.j1f().b1h(this_11);
        this_8.j1f().b1h(this_8);
        $this$append.d1h();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function loadCompanyOfferingsLink$slambda$lambda_0($companyId) {
    return function (event) {
      event.preventDefault();
      submitCompanyLocation($companyId);
      return Unit_instance;
    };
  }
  function loadCompanyOfferingsLink$slambda$lambda_1($companyId) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), this_0.j1f());
      this_1.j1f().a1h(this_1);
      this_1.q1j('/bitacora/marketer/advertisements?companyId=' + $companyId);
      this_1.n1f('Manage advertisements');
      this_1.j1f().b1h(this_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_2 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_2.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_2.j1f().a1h(this_2);
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), this_2.j1f());
      this_3.j1f().a1h(this_3);
      this_3.q1j('/bitacora/marketer/campaigns?companyId=' + $companyId);
      this_3.n1f('Manage ad campaigns');
      this_3.j1f().b1h(this_3);
      this_2.j1f().b1h(this_2);
      $this$append.d1h();
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_4 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_4.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_4.j1f().a1h(this_4);
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_5 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), this_4.j1f());
      this_5.j1f().a1h(this_5);
      this_5.q1j('/bitacora/marketer/billing?companyId=' + $companyId);
      this_5.n1f('Billing');
      this_5.j1f().b1h(this_5);
      this_4.j1f().b1h(this_4);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadCompanyOfferingsLink$slambda$lambda_2($companyId) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_1 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), this_0.j1f());
      this_1.j1f().a1h(this_1);
      this_1.q1j('/bitacora/company/team?companyId=' + $companyId);
      this_1.n1f('Manage team');
      this_1.j1f().b1h(this_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_2 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_2.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_2.j1f().a1h(this_2);
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), this_2.j1f());
      this_3.j1f().a1h(this_3);
      this_3.q1j('/bitacora/company/analytics?companyId=' + $companyId);
      this_3.n1f('Company analytics');
      this_3.j1f().b1h(this_3);
      this_2.j1f().b1h(this_2);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadCompanyOfferingsLink$slambda($companyId, $linkBox, $isCompanyAdmin, resultContinuation) {
    this.l41_1 = $companyId;
    this.m41_1 = $linkBox;
    this.n41_1 = $isCompanyAdmin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadCompanyOfferingsLink$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadCompanyOfferingsLink$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadCompanyOfferingsLink$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/members/companies/' + this.l41_1;
            this.p41_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.p41_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(CompanyResponse), arrayOf([]), false));
            var company = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            if (company.t2t_1.equals(CompanyType_ACTIVITY_CENTER_getInstance())) {
              append(this.m41_1, loadCompanyOfferingsLink$slambda$lambda(this.n41_1, this.l41_1));
              if (this.n41_1) {
                var tmp_0 = document.getElementById('companyLocationForm');
                var tmp_1 = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
                tmp_1.addEventListener('submit', loadCompanyOfferingsLink$slambda$lambda_0(this.l41_1));
                var lat = company.b2u_1;
                var lon = company.c2u_1;
                if (!(lat == null) && !(lon == null)) {
                  showLocationOnMap('companyLocation', lat, lon, company.d2u_1);
                }
              }
            } else if (company.t2t_1.equals(CompanyType_MARKETER_getInstance()) && this.n41_1) {
              append(this.m41_1, loadCompanyOfferingsLink$slambda$lambda_1(this.l41_1));
            }

            if (this.n41_1) {
              append(this.m41_1, loadCompanyOfferingsLink$slambda$lambda_2(this.l41_1));
            }

            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_2 = this.w7_1;
            if (tmp_2 instanceof ApiException) {
              var e = this.w7_1;
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadCompanyOfferingsLink$slambda).h22 = function ($this$launch, completion) {
    var i = new loadCompanyOfferingsLink$slambda(this.l41_1, this.m41_1, this.n41_1, completion);
    i.o41_1 = $this$launch;
    return i;
  };
  function loadCompanyOfferingsLink$slambda_0($companyId, $linkBox, $isCompanyAdmin, resultContinuation) {
    var i = new loadCompanyOfferingsLink$slambda($companyId, $linkBox, $isCompanyAdmin, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitCompanyLocation$slambda($companyId, $latitude, $longitude, $locationLabel, $status, resultContinuation) {
    this.y41_1 = $companyId;
    this.z41_1 = $latitude;
    this.a42_1 = $longitude;
    this.b42_1 = $locationLabel;
    this.c42_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitCompanyLocation$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitCompanyLocation$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitCompanyLocation$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/members/companies/' + this.y41_1 + '/location';
            var body = new SetCompanyLocationRequest(this.z41_1, this.a42_1, this.b42_1);
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(SetCompanyLocationRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('PUT', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.c42_1.textContent = 'Saved.';
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.c42_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.c42_1, 'Something went wrong: ' + e_0.message);
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitCompanyLocation$slambda).h22 = function ($this$launch, completion) {
    var i = new submitCompanyLocation$slambda(this.y41_1, this.z41_1, this.a42_1, this.b42_1, this.c42_1, completion);
    i.d42_1 = $this$launch;
    return i;
  };
  function submitCompanyLocation$slambda_0($companyId, $latitude, $longitude, $locationLabel, $status, resultContinuation) {
    var i = new submitCompanyLocation$slambda($companyId, $latitude, $longitude, $locationLabel, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitDisplayNameUpdate$slambda($newName, $status, resultContinuation) {
    this.m42_1 = $newName;
    this.n42_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitDisplayNameUpdate$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitDisplayNameUpdate$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitDisplayNameUpdate$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/auth/me';
            var body = new UpdateDisplayNameRequest(this.m42_1);
            this.p42_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(UpdateDisplayNameRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('PUT', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.p42_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(UpdateDisplayNameResponse), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            this.n42_1.textContent = 'Saved as "' + result.d2f_1 + '".';
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.n42_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.n42_1, 'Something went wrong: ' + e_0.message);
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitDisplayNameUpdate$slambda).h22 = function ($this$launch, completion) {
    var i = new submitDisplayNameUpdate$slambda(this.m42_1, this.n42_1, completion);
    i.o42_1 = $this$launch;
    return i;
  };
  function submitDisplayNameUpdate$slambda_0($newName, $status, resultContinuation) {
    var i = new submitDisplayNameUpdate$slambda($newName, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitNicknameUpdate$slambda($nickname, $status, resultContinuation) {
    this.y42_1 = $nickname;
    this.z42_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitNicknameUpdate$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitNicknameUpdate$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitNicknameUpdate$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/members/me/nickname';
            var body = new UpdateMyNicknameRequest(this.y42_1);
            this.b43_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(UpdateMyNicknameRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('PUT', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.b43_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(UpdateMyNicknameResponse), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            this.z42_1.textContent = 'Saved as "' + result.k2t_1 + '".';
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.z42_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                showError(this.z42_1, 'Something went wrong: ' + e_0.message);
                this.t7_1 = 4;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 3) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitNicknameUpdate$slambda).h22 = function ($this$launch, completion) {
    var i = new submitNicknameUpdate$slambda(this.y42_1, this.z42_1, completion);
    i.a43_1 = $this$launch;
    return i;
  };
  function submitNicknameUpdate$slambda_0($nickname, $status, resultContinuation) {
    var i = new submitNicknameUpdate$slambda($nickname, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitAvatarUpload$slambda($file, $status, resultContinuation) {
    this.k43_1 = $file;
    this.l43_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitAvatarUpload$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitAvatarUpload$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitAvatarUpload$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 3;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/members/me/avatar';
            var tmp6 = this.k43_1;
            this.n43_1 = tmp0;
            var formData = new FormData();
            formData.append('file', tmp6);
            var headers = new Headers();
            var tmp0_safe_receiver = AuthState_instance.y2w();
            if (tmp0_safe_receiver == null)
              null;
            else {
              headers.append('Authorization', 'Bearer ' + tmp0_safe_receiver);
            }

            var init = {};
            init.method = 'PUT';
            init.headers = headers;
            init.body = formData;
            this.t7_1 = 1;
            suspendResult = await_0(window.fetch(this.n43_1.e27_1 + tmp2, init), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o43_1 = suspendResult;
            this.t7_1 = 2;
            suspendResult = await_0(this.o43_1.text(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var text = suspendResult;
            if (!this.o43_1.ok) {
              this.n43_1.z2w(this.o43_1.status, true);
              var this_0 = this.n43_1;
              var tmp_0;
              try {
                var this_1 = this_0.f27_1;
                var this_2 = this_1.um();
                var this_3 = serializer(this_2, createKType(getKClass(ErrorResponse), arrayOf([]), false));
                var value = this_1.i13(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), text);
                tmp_0 = _Result___init__impl__xyqfz8(value);
              } catch ($p) {
                var tmp_1;
                if ($p instanceof Error) {
                  var e = $p;
                  tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
                } else {
                  throw $p;
                }
                tmp_0 = tmp_1;
              }
              var this_4 = tmp_0;
              var parsed = _Result___get_isFailure__impl__jpiriv(this_4) ? null : _Result___get_value__impl__bjfvqg(this_4);
              var tmp_2 = this.o43_1.status;
              var tmp2_elvis_lhs = parsed == null ? null : parsed.p2c_1;
              var tmp_3;
              if (tmp2_elvis_lhs == null) {
                var tmp_4;
                if (isBlank(text)) {
                  tmp_4 = 'Upload failed';
                } else {
                  tmp_4 = text;
                }
                tmp_3 = tmp_4;
              } else {
                tmp_3 = tmp2_elvis_lhs;
              }
              var tmp_5 = tmp_3;
              throw new ApiException(tmp_2, tmp_5, parsed == null ? null : parsed.q2c_1);
            }

            var this_5 = this.n43_1.f27_1;
            var this_6 = this_5.um();
            var this_7 = serializer(this_6, createKType(getKClass(UploadResponse), arrayOf([]), false));
            var result = this_5.i13(isInterface(this_7, KSerializer) ? this_7 : THROW_CCE(), text);
            this.l43_1.textContent = 'Uploaded.';
            this.u7_1 = 4;
            this.t7_1 = 5;
            continue $sm;
          case 3:
            this.u7_1 = 4;
            var tmp_6 = this.w7_1;
            if (tmp_6 instanceof ApiException) {
              var e_0 = this.w7_1;
              showError(this.l43_1, e_0.k2c_1);
              this.t7_1 = 5;
              continue $sm;
            } else {
              var tmp_7 = this.w7_1;
              if (tmp_7 instanceof Error) {
                var e_1 = this.w7_1;
                showError(this.l43_1, 'Upload failed: ' + e_1.message);
                this.t7_1 = 5;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 4:
            throw this.w7_1;
          case 5:
            this.u7_1 = 4;
            return Unit_instance;
        }
      } catch ($p_0) {
        var e_2 = $p_0;
        if (this.u7_1 === 4) {
          throw e_2;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_2;
        }
      }
     while (true);
  };
  protoOf(submitAvatarUpload$slambda).h22 = function ($this$launch, completion) {
    var i = new submitAvatarUpload$slambda(this.k43_1, this.l43_1, completion);
    i.m43_1 = $this$launch;
    return i;
  };
  function submitAvatarUpload$slambda_0($file, $status, resultContinuation) {
    var i = new submitAvatarUpload$slambda($file, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function get_REGISTER_TABS() {
    _init_properties_RegisterPage_kt__j8pu2a();
    return REGISTER_TABS;
  }
  var REGISTER_TABS;
  function get_ORGANIZATION_HEADINGS() {
    _init_properties_RegisterPage_kt__j8pu2a();
    return ORGANIZATION_HEADINGS;
  }
  var ORGANIZATION_HEADINGS;
  function set_registerMode(_set____db54di) {
    _init_properties_RegisterPage_kt__j8pu2a();
    registerMode = _set____db54di;
  }
  function get_registerMode() {
    _init_properties_RegisterPage_kt__j8pu2a();
    return registerMode;
  }
  var registerMode;
  function RegisterPageModule() {
  }
  protoOf(RegisterPageModule).r28 = function () {
    set_registerMode('PRACTITIONER');
    renderRegisterTabs();
    renderRegisterFormPanel();
  };
  var RegisterPageModule_instance;
  function RegisterPageModule_getInstance() {
    return RegisterPageModule_instance;
  }
  function renderRegisterTabs() {
    _init_properties_RegisterPage_kt__j8pu2a();
    var tmp = document.getElementById('registerTabs');
    var tabs = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    tabs.innerHTML = '';
    append(tabs, renderRegisterTabs$lambda);
  }
  function switchRegisterMode(mode) {
    _init_properties_RegisterPage_kt__j8pu2a();
    if (get_registerMode() === mode)
      return Unit_instance;
    set_registerMode(mode);
    renderRegisterTabs();
    renderRegisterFormPanel();
  }
  function renderRegisterFormPanel() {
    _init_properties_RegisterPage_kt__j8pu2a();
    var tmp = document.getElementById('registerFormPanel');
    var panel = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    panel.innerHTML = '';
    if (get_registerMode() === 'PRACTITIONER') {
      append(panel, renderRegisterFormPanel$lambda);
      wirePractitionerForm();
    } else {
      var orgType = get_registerMode();
      append(panel, renderRegisterFormPanel$lambda_0(orgType));
      wireOrganizationForm(orgType);
      renderCountryOptions('country');
    }
  }
  function wirePractitionerForm() {
    _init_properties_RegisterPage_kt__j8pu2a();
    var tmp = document.getElementById('registerForm');
    var tmp_0 = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    tmp_0.addEventListener('submit', wirePractitionerForm$lambda);
  }
  function submitPractitionerRegistration() {
    _init_properties_RegisterPage_kt__j8pu2a();
    var tmp = document.getElementById('formError');
    var errorBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    errorBox.textContent = '';
    var methodError = authMethodValidationError();
    if (!(methodError == null)) {
      errorBox.textContent = methodError;
      return Unit_instance;
    }
    var tmp_0 = document.getElementById('email');
    var email = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('displayName');
    var displayName = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    var password = selectedPassword();
    var tmp_2 = get_AppScope();
    launch(tmp_2, VOID, VOID, submitPractitionerRegistration$slambda_0(email, password, displayName, errorBox, null));
  }
  function wireOrganizationForm(type) {
    _init_properties_RegisterPage_kt__j8pu2a();
    var tmp = document.getElementById('registerForm');
    var tmp_0 = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    tmp_0.addEventListener('submit', wireOrganizationForm$lambda(type));
  }
  function submitOrganizationRegistration(type) {
    _init_properties_RegisterPage_kt__j8pu2a();
    var tmp = document.getElementById('formError');
    var errorBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    errorBox.textContent = '';
    var methodError = authMethodValidationError();
    if (!(methodError == null)) {
      errorBox.textContent = methodError;
      return Unit_instance;
    }
    // Inline function 'kotlin.text.ifBlank' call
    var this_0 = submitOrganizationRegistration$value('website');
    var tmp_0;
    if (isBlank(this_0)) {
      tmp_0 = null;
    } else {
      tmp_0 = this_0;
    }
    var website = tmp_0;
    var password = selectedPassword();
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, submitOrganizationRegistration$slambda_0(type, website, password, errorBox, null));
  }
  function renderRegisterTabs$lambda($this$append) {
    _init_properties_RegisterPage_kt__j8pu2a();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = get_REGISTER_TABS().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var mode = element.g9();
      var label = element.h9();
      // Inline function 'kotlinx.html.a' call
      var classes = 'register-tab' + (get_registerMode() === mode ? ' active' : '');
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new A(attributesMapOf(['href', null, 'target', null, 'class', classes]), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      set_onClickFunction(this_0, renderRegisterTabs$lambda$lambda(mode));
      this_0.n1f(label);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
    }
    return Unit_instance;
  }
  function renderRegisterTabs$lambda$lambda($mode) {
    return function (it) {
      switchRegisterMode($mode);
      return Unit_instance;
    };
  }
  function renderRegisterFormPanel$lambda($this$append) {
    _init_properties_RegisterPage_kt__j8pu2a();
    // Inline function 'kotlinx.html.h1' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new H1(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    this_0.n1f('Register as a practitioner');
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    // Inline function 'kotlinx.html.form' call
    var tmp = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_1 = new FORM(attributesMapOf(['action', null, 'enctype', tmp, 'method', null == null ? null : enumEncode(null), 'class', null]), $this$append);
    if (!(this_1.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_1.j1f().a1h(this_1);
    set_id(this_1, 'registerForm');
    // Inline function 'kotlinx.html.label' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
    this_2.j1f().a1h(this_2);
    this_2.n1f('Email');
    // Inline function 'kotlinx.html.emailInput' call
    var tmp_0 = InputType_email_getInstance().q1i_1;
    var tmp_1 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_3 = new INPUT(attributesMapOf(['type', tmp_0, 'formenctype', tmp_1, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_2.j1f());
    this_3.j1f().a1h(this_3);
    set_id(this_3, 'email');
    this_3.c1m(true);
    this_3.j1f().b1h(this_3);
    this_2.j1f().b1h(this_2);
    // Inline function 'kotlinx.html.label' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_4 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
    this_4.j1f().a1h(this_4);
    this_4.n1f('Display name');
    // Inline function 'kotlinx.html.textInput' call
    var tmp_2 = InputType_text_getInstance().q1i_1;
    var tmp_3 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_5 = new INPUT(attributesMapOf(['type', tmp_2, 'formenctype', tmp_3, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_4.j1f());
    this_5.j1f().a1h(this_5);
    set_id(this_5, 'displayName');
    this_5.c1m(true);
    this_5.j1f().b1h(this_5);
    this_4.j1f().b1h(this_4);
    authMethodPicker(this_1);
    // Inline function 'kotlinx.html.div' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_6 = new DIV(attributesMapOf_0('class', null), this_1.j1f());
    this_6.j1f().a1h(this_6);
    set_id(this_6, 'formError');
    this_6.j1f().b1h(this_6);
    // Inline function 'kotlinx.html.button' call
    var tmp_4 = null == null ? null : enumEncode(null);
    var tmp_5 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_7 = new BUTTON(attributesMapOf(['formenctype', tmp_4, 'formmethod', tmp_5, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
    this_7.j1f().a1h(this_7);
    this_7.z1j(ButtonType_submit_getInstance());
    this_7.n1f('Register');
    this_7.j1f().b1h(this_7);
    this_1.j1f().b1h(this_1);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderRegisterFormPanel$lambda_0($orgType) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.h1' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new H1(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      var tmp0_elvis_lhs = get_ORGANIZATION_HEADINGS().i2($orgType);
      this_0.n1f(tmp0_elvis_lhs == null ? 'Register an organization' : tmp0_elvis_lhs);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      // Inline function 'kotlinx.html.form' call
      var tmp = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_1 = new FORM(attributesMapOf(['action', null, 'enctype', tmp, 'method', null == null ? null : enumEncode(null), 'class', null]), $this$append);
      if (!(this_1.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_1.j1f().a1h(this_1);
      set_id(this_1, 'registerForm');
      // Inline function 'kotlinx.html.label' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_2 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
      this_2.j1f().a1h(this_2);
      this_2.n1f('Name');
      // Inline function 'kotlinx.html.textInput' call
      var tmp_0 = InputType_text_getInstance().q1i_1;
      var tmp_1 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new INPUT(attributesMapOf(['type', tmp_0, 'formenctype', tmp_1, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_2.j1f());
      this_3.j1f().a1h(this_3);
      set_id(this_3, 'name');
      this_3.c1m(true);
      this_3.j1f().b1h(this_3);
      this_2.j1f().b1h(this_2);
      // Inline function 'kotlinx.html.label' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_4 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
      this_4.j1f().a1h(this_4);
      this_4.n1f('Fiscal ID');
      // Inline function 'kotlinx.html.textInput' call
      var tmp_2 = InputType_text_getInstance().q1i_1;
      var tmp_3 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_5 = new INPUT(attributesMapOf(['type', tmp_2, 'formenctype', tmp_3, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_4.j1f());
      this_5.j1f().a1h(this_5);
      set_id(this_5, 'fiscalId');
      this_5.c1m(true);
      this_5.j1f().b1h(this_5);
      this_4.j1f().b1h(this_4);
      // Inline function 'kotlinx.html.label' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_6 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
      this_6.j1f().a1h(this_6);
      this_6.n1f('Email');
      // Inline function 'kotlinx.html.emailInput' call
      var tmp_4 = InputType_email_getInstance().q1i_1;
      var tmp_5 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_7 = new INPUT(attributesMapOf(['type', tmp_4, 'formenctype', tmp_5, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_6.j1f());
      this_7.j1f().a1h(this_7);
      set_id(this_7, 'companyEmail');
      this_7.c1m(true);
      this_7.j1f().b1h(this_7);
      this_6.j1f().b1h(this_6);
      // Inline function 'kotlinx.html.label' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_8 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
      this_8.j1f().a1h(this_8);
      this_8.n1f('Phone');
      // Inline function 'kotlinx.html.textInput' call
      var tmp_6 = InputType_text_getInstance().q1i_1;
      var tmp_7 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_9 = new INPUT(attributesMapOf(['type', tmp_6, 'formenctype', tmp_7, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_8.j1f());
      this_9.j1f().a1h(this_9);
      set_id(this_9, 'phone');
      this_9.c1m(true);
      this_9.j1f().b1h(this_9);
      this_8.j1f().b1h(this_8);
      // Inline function 'kotlinx.html.label' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_10 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
      this_10.j1f().a1h(this_10);
      this_10.n1f('Address');
      // Inline function 'kotlinx.html.textInput' call
      var tmp_8 = InputType_text_getInstance().q1i_1;
      var tmp_9 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_11 = new INPUT(attributesMapOf(['type', tmp_8, 'formenctype', tmp_9, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_10.j1f());
      this_11.j1f().a1h(this_11);
      set_id(this_11, 'address');
      this_11.c1m(true);
      this_11.j1f().b1h(this_11);
      this_10.j1f().b1h(this_10);
      // Inline function 'kotlinx.html.label' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_12 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
      this_12.j1f().a1h(this_12);
      this_12.n1f('Country');
      countryPicker(this_12, 'country', 'Country', true);
      this_12.j1f().b1h(this_12);
      // Inline function 'kotlinx.html.label' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_13 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
      this_13.j1f().a1h(this_13);
      this_13.n1f('Website (optional)');
      // Inline function 'kotlinx.html.textInput' call
      var tmp_10 = InputType_text_getInstance().q1i_1;
      var tmp_11 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_14 = new INPUT(attributesMapOf(['type', tmp_10, 'formenctype', tmp_11, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_13.j1f());
      this_14.j1f().a1h(this_14);
      set_id(this_14, 'website');
      this_14.j1f().b1h(this_14);
      this_13.j1f().b1h(this_13);
      // Inline function 'kotlinx.html.h2' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_15 = new H2(attributesMapOf_0('class', null), this_1.j1f());
      this_15.j1f().a1h(this_15);
      this_15.n1f('Admin account');
      this_15.j1f().b1h(this_15);
      // Inline function 'kotlinx.html.label' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_16 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
      this_16.j1f().a1h(this_16);
      this_16.n1f('Admin email');
      // Inline function 'kotlinx.html.emailInput' call
      var tmp_12 = InputType_email_getInstance().q1i_1;
      var tmp_13 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_17 = new INPUT(attributesMapOf(['type', tmp_12, 'formenctype', tmp_13, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_16.j1f());
      this_17.j1f().a1h(this_17);
      set_id(this_17, 'adminEmail');
      this_17.c1m(true);
      this_17.j1f().b1h(this_17);
      this_16.j1f().b1h(this_16);
      // Inline function 'kotlinx.html.label' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_18 = new LABEL(attributesMapOf_0('class', null), this_1.j1f());
      this_18.j1f().a1h(this_18);
      this_18.n1f('Admin name');
      // Inline function 'kotlinx.html.textInput' call
      var tmp_14 = InputType_text_getInstance().q1i_1;
      var tmp_15 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_19 = new INPUT(attributesMapOf(['type', tmp_14, 'formenctype', tmp_15, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_18.j1f());
      this_19.j1f().a1h(this_19);
      set_id(this_19, 'adminName');
      this_19.c1m(true);
      this_19.j1f().b1h(this_19);
      this_18.j1f().b1h(this_18);
      authMethodPicker(this_1);
      // Inline function 'kotlinx.html.div' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_20 = new DIV(attributesMapOf_0('class', null), this_1.j1f());
      this_20.j1f().a1h(this_20);
      set_id(this_20, 'formError');
      this_20.j1f().b1h(this_20);
      // Inline function 'kotlinx.html.button' call
      var tmp_16 = null == null ? null : enumEncode(null);
      var tmp_17 = null == null ? null : enumEncode(null);
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_21 = new BUTTON(attributesMapOf(['formenctype', tmp_16, 'formmethod', tmp_17, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
      this_21.j1f().a1h(this_21);
      this_21.z1j(ButtonType_submit_getInstance());
      this_21.n1f('Register');
      this_21.j1f().b1h(this_21);
      this_1.j1f().b1h(this_1);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function wirePractitionerForm$lambda(event) {
    _init_properties_RegisterPage_kt__j8pu2a();
    event.preventDefault();
    submitPractitionerRegistration();
    return Unit_instance;
  }
  function submitPractitionerRegistration$slambda($email, $password, $displayName, $errorBox, resultContinuation) {
    this.x43_1 = $email;
    this.y43_1 = $password;
    this.z43_1 = $displayName;
    this.a44_1 = $errorBox;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitPractitionerRegistration$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitPractitionerRegistration$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitPractitionerRegistration$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 5;
            this.u7_1 = 4;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/members/practitioners';
            var body = new RegisterPractitionerRequest(this.x43_1, this.y43_1, this.z43_1);
            this.c44_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(RegisterPractitionerRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.c44_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(RegisterPractitionerResponse), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            AuthState_instance.m2y(result.u2s_1, result.v2s_1);
            Analytics_instance.y28('practitioner');
            this.t7_1 = 2;
            suspendResult = attachPasskeyIfSelected(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.t7_1 = 3;
            suspendResult = navigateAfterAuth(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.u7_1 = 5;
            this.t7_1 = 6;
            continue $sm;
          case 4:
            this.u7_1 = 5;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              this.a44_1.textContent = e.k2c_1;
              this.t7_1 = 6;
              continue $sm;
            } else {
              var tmp_1 = this.w7_1;
              if (tmp_1 instanceof Error) {
                var e_0 = this.w7_1;
                this.a44_1.textContent = 'Something went wrong: ' + e_0.message;
                this.t7_1 = 6;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 5:
            throw this.w7_1;
          case 6:
            this.u7_1 = 5;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 5) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitPractitionerRegistration$slambda).h22 = function ($this$launch, completion) {
    var i = new submitPractitionerRegistration$slambda(this.x43_1, this.y43_1, this.z43_1, this.a44_1, completion);
    i.b44_1 = $this$launch;
    return i;
  };
  function submitPractitionerRegistration$slambda_0($email, $password, $displayName, $errorBox, resultContinuation) {
    var i = new submitPractitionerRegistration$slambda($email, $password, $displayName, $errorBox, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function wireOrganizationForm$lambda($type) {
    return function (event) {
      event.preventDefault();
      submitOrganizationRegistration($type);
      return Unit_instance;
    };
  }
  function submitOrganizationRegistration$value(id) {
    var tmp = document.getElementById(id);
    return (tmp instanceof HTMLInputElement ? tmp : THROW_CCE()).value;
  }
  function submitOrganizationRegistration$slambda($type, $website, $password, $errorBox, resultContinuation) {
    this.l44_1 = $type;
    this.m44_1 = $website;
    this.n44_1 = $password;
    this.o44_1 = $errorBox;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitOrganizationRegistration$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitOrganizationRegistration$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitOrganizationRegistration$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 6;
            this.u7_1 = 5;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/members/companies';
            var tmp_0 = valueOf_1(this.l44_1);
            var tmp_1 = submitOrganizationRegistration$value('name');
            var tmp_2 = submitOrganizationRegistration$value('fiscalId');
            var tmp_3 = submitOrganizationRegistration$value('companyEmail');
            var tmp_4 = submitOrganizationRegistration$value('phone');
            var tmp_5 = submitOrganizationRegistration$value('address');
            var tmp0_elvis_lhs = countryInputValue('country');
            var body = new RegisterCompanyRequest(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, this.m44_1, tmp0_elvis_lhs == null ? submitOrganizationRegistration$value('country') : tmp0_elvis_lhs, submitOrganizationRegistration$value('adminEmail'), submitOrganizationRegistration$value('adminName'), this.n44_1);
            this.r44_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(RegisterCompanyRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var tmp_6 = this;
            var this_3 = this.r44_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(RegisterCompanyResponse), arrayOf([]), false));
            tmp_6.q44_1 = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            AuthState_instance.m2y(this.q44_1.k2s_1, this.q44_1.l2s_1);
            Analytics_instance.y28(this.l44_1);
            this.t7_1 = 2;
            suspendResult = attachPasskeyIfSelected(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (this.l44_1 === 'ACTIVITY_CENTER') {
              get_moduleNavigateTo()('/bitacora/company/offerings?companyId=' + this.q44_1.i2s_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              this.t7_1 = 3;
              suspendResult = navigateAfterAuth(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.t7_1 = 4;
            continue $sm;
          case 4:
            this.u7_1 = 6;
            this.t7_1 = 7;
            continue $sm;
          case 5:
            this.u7_1 = 6;
            var tmp_7 = this.w7_1;
            if (tmp_7 instanceof ApiException) {
              var e = this.w7_1;
              this.o44_1.textContent = e.k2c_1;
              this.t7_1 = 7;
              continue $sm;
            } else {
              var tmp_8 = this.w7_1;
              if (tmp_8 instanceof Error) {
                var e_0 = this.w7_1;
                this.o44_1.textContent = 'Something went wrong: ' + e_0.message;
                this.t7_1 = 7;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 6:
            throw this.w7_1;
          case 7:
            this.u7_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 6) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitOrganizationRegistration$slambda).h22 = function ($this$launch, completion) {
    var i = new submitOrganizationRegistration$slambda(this.l44_1, this.m44_1, this.n44_1, this.o44_1, completion);
    i.p44_1 = $this$launch;
    return i;
  };
  function submitOrganizationRegistration$slambda_0($type, $website, $password, $errorBox, resultContinuation) {
    var i = new submitOrganizationRegistration$slambda($type, $website, $password, $errorBox, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  var properties_initialized_RegisterPage_kt_ouu8to;
  function _init_properties_RegisterPage_kt__j8pu2a() {
    if (!properties_initialized_RegisterPage_kt_ouu8to) {
      properties_initialized_RegisterPage_kt_ouu8to = true;
      REGISTER_TABS = listOf([to('PRACTITIONER', 'Practitioner'), to('ACTIVITY_CENTER', 'Activity center'), to('CERTIFICATION_ISSUER', 'Certification issuer'), to('MARKETER', 'Marketer')]);
      ORGANIZATION_HEADINGS = mapOf([to('ACTIVITY_CENTER', 'Register an activity center'), to('CERTIFICATION_ISSUER', 'Register a certification issuer'), to('MARKETER', 'Register a marketer')]);
      registerMode = 'PRACTITIONER';
    }
  }
  var myCompanyId;
  function loadMyCompany() {
    var tmp = document.getElementById('visibilityPageContent');
    var content = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadMyCompany$slambda_0(content, null));
  }
  function renderPageBody(content, companyId) {
    content.innerHTML = '';
    append(content, renderPageBody$lambda);
    var tmp = document.getElementById('saveOfferingsButton');
    var tmp_0 = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    tmp_0.addEventListener('click', renderPageBody$lambda_0(companyId));
    var tmp_1 = document.getElementById('visibilityRequestForm');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('submit', renderPageBody$lambda_1(companyId));
    loadOfferings_0(companyId);
    loadSentRequests(companyId);
  }
  function loadOfferings_0(companyId) {
    var tmp = document.getElementById('offeringCheckboxes');
    var checkboxes = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadOfferings$slambda_2(companyId, checkboxes, null));
  }
  function renderOfferingCheckboxes(el, selected) {
    el.innerHTML = '';
    append(el, renderOfferingCheckboxes$lambda(selected));
  }
  function renderActivitySelect(offered) {
    var tmp = document.getElementById('visibilityActivitySelect');
    var select = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    select.innerHTML = '';
    append(select, renderActivitySelect$lambda(offered));
  }
  function saveOfferings(companyId) {
    var tmp = document.getElementById('offeringsStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = flatten(get_activityCatalogByCategory().k2());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp_0 = document.getElementById('offering-' + element.s24_1);
      var tmp0_safe_receiver = tmp_0 instanceof HTMLInputElement ? tmp_0 : null;
      if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.checked) === true) {
        destination.x(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.t();
    while (_iterator__ex2g4s_0.u()) {
      var item = _iterator__ex2g4s_0.v();
      var tmp$ret$5 = item.s24_1;
      destination_0.x(tmp$ret$5);
    }
    var selected = toSet(destination_0);
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, saveOfferings$slambda_0(companyId, selected, status, null));
  }
  function submitVisibilityRequest(companyId) {
    var tmp = document.getElementById('visibilityRequestStatus');
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = document.getElementById('visibilityActivitySelect');
    var activityType = (tmp_0 instanceof HTMLSelectElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('visibilityEmailsInput');
    // Inline function 'kotlin.collections.map' call
    var this_0 = split((tmp_1 instanceof HTMLTextAreaElement ? tmp_1 : THROW_CCE()).value, ['\n']);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$2 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
      destination.x(tmp$ret$2);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.t();
    while (_iterator__ex2g4s_0.u()) {
      var element = _iterator__ex2g4s_0.v();
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination_0.x(element);
      }
    }
    var emails = destination_0;
    if (isBlank(activityType)) {
      showError(status, I18n_getInstance().e28('requestCertVisibility.selectActivityError'));
      return Unit_instance;
    }
    if (emails.r()) {
      showError(status, I18n_getInstance().e28('requestCertVisibility.enterEmailError'));
      return Unit_instance;
    }
    var tmp_2 = get_AppScope();
    launch(tmp_2, VOID, VOID, submitVisibilityRequest$slambda_0(companyId, activityType, emails, status, null));
  }
  function renderOutcomes(outcomes) {
    var tmp = document.getElementById('visibilityOutcomeList');
    var el = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    el.innerHTML = '';
    append(el, renderOutcomes$lambda(outcomes));
  }
  function loadSentRequests(companyId) {
    var tmp = document.getElementById('sentRequestList');
    var el = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadSentRequests$slambda_0(companyId, el, null));
  }
  function renderSentRequests(el, companyId, requests) {
    el.innerHTML = '';
    append(el, renderSentRequests$lambda(requests, companyId));
  }
  function viewCertifications(companyId, requestId) {
    var tmp = document.getElementById('visibility-view-' + requestId);
    var el = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    el.innerHTML = '';
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, viewCertifications$slambda_0(companyId, requestId, el, null));
  }
  function RequestCertificationVisibilityPageModule() {
  }
  protoOf(RequestCertificationVisibilityPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    myCompanyId = null;
    loadMyCompany();
  };
  var RequestCertificationVisibilityPageModule_instance;
  function RequestCertificationVisibilityPageModule_getInstance() {
    return RequestCertificationVisibilityPageModule_instance;
  }
  function loadMyCompany$slambda$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'requestCertVisibility.staffOnly';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('requestCertVisibility.staffOnly'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function loadMyCompany$slambda$lambda_0($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('requestCertVisibility.profileLoadError') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadMyCompany$slambda($content, resultContinuation) {
    this.a45_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadMyCompany$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadMyCompany$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadMyCompany$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/members/me';
            this.d45_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.d45_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(MyProfileResponse), arrayOf([]), false));
            var profile = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var companyId = profile.c26_1;
            if (!(profile.x25_1 === 'COMPANY_MEMBER') || companyId == null) {
              this.a45_1.innerHTML = '';
              append(this.a45_1, loadMyCompany$slambda$lambda);
              return Unit_instance;
            }

            myCompanyId = companyId;
            var tmp_0 = this;
            renderPageBody(this.a45_1, companyId);
            tmp_0.c45_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.a45_1.innerHTML = '';
              tmp_2.c45_1 = append(this.a45_1, loadMyCompany$slambda$lambda_0(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadMyCompany$slambda).h22 = function ($this$launch, completion) {
    var i = new loadMyCompany$slambda(this.a45_1, completion);
    i.b45_1 = $this$launch;
    return i;
  };
  function loadMyCompany$slambda_0($content, resultContinuation) {
    var i = new loadMyCompany$slambda($content, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderPageBody$lambda($this$append) {
    // Inline function 'kotlinx.html.h2' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new H2(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    var tmp0 = this_0.l1f();
    var tmp2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value = 'requestCertVisibility.offeringsHeading';
    tmp0.m2(tmp2, value);
    this_0.n1f(I18n_getInstance().e28('requestCertVisibility.offeringsHeading'));
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    // Inline function 'kotlinx.html.div' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_1 = new DIV(attributesMapOf_0('class', null), $this$append);
    if (!(this_1.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_1.j1f().a1h(this_1);
    set_id(this_1, 'offeringCheckboxes');
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new P(attributesMapOf_0('class', null), this_1.j1f());
    this_2.j1f().a1h(this_2);
    var tmp0_0 = this_2.l1f();
    var tmp2_0 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value_0 = 'requestCertVisibility.loading';
    tmp0_0.m2(tmp2_0, value_0);
    this_2.n1f(I18n_getInstance().e28('requestCertVisibility.loading'));
    this_2.j1f().b1h(this_2);
    this_1.j1f().b1h(this_1);
    $this$append.d1h();
    // Inline function 'kotlinx.html.button' call
    var tmp = null == null ? null : enumEncode(null);
    var tmp_0 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_3 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), $this$append);
    if (!(this_3.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_3.j1f().a1h(this_3);
    this_3.z1j(ButtonType_button_getInstance());
    set_id(this_3, 'saveOfferingsButton');
    var tmp0_1 = this_3.l1f();
    var tmp2_1 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value_1 = 'requestCertVisibility.saveOfferingsButton';
    tmp0_1.m2(tmp2_1, value_1);
    this_3.n1f(I18n_getInstance().e28('requestCertVisibility.saveOfferingsButton'));
    this_3.j1f().b1h(this_3);
    $this$append.d1h();
    // Inline function 'kotlinx.html.div' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_4 = new DIV(attributesMapOf_0('class', null), $this$append);
    if (!(this_4.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_4.j1f().a1h(this_4);
    set_id(this_4, 'offeringsStatus');
    this_4.j1f().b1h(this_4);
    $this$append.d1h();
    // Inline function 'kotlinx.html.h2' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_5 = new H2(attributesMapOf_0('class', null), $this$append);
    if (!(this_5.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_5.j1f().a1h(this_5);
    var tmp0_2 = this_5.l1f();
    var tmp2_2 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value_2 = 'requestCertVisibility.requestHeading';
    tmp0_2.m2(tmp2_2, value_2);
    this_5.n1f(I18n_getInstance().e28('requestCertVisibility.requestHeading'));
    this_5.j1f().b1h(this_5);
    $this$append.d1h();
    // Inline function 'kotlinx.html.form' call
    var tmp_1 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_6 = new FORM(attributesMapOf(['action', null, 'enctype', tmp_1, 'method', null == null ? null : enumEncode(null), 'class', null]), $this$append);
    if (!(this_6.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_6.j1f().a1h(this_6);
    set_id(this_6, 'visibilityRequestForm');
    // Inline function 'kotlinx.html.label' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_7 = new LABEL(attributesMapOf_0('class', null), this_6.j1f());
    this_7.j1f().a1h(this_7);
    this_7.n1f(I18n_getInstance().e28('requestCertVisibility.activityLabel'));
    // Inline function 'kotlinx.html.select' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_8 = new SELECT(attributesMapOf_0('class', null), this_7.j1f());
    this_8.j1f().a1h(this_8);
    set_id(this_8, 'visibilityActivitySelect');
    this_8.j1f().b1h(this_8);
    this_7.j1f().b1h(this_7);
    // Inline function 'kotlinx.html.label' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_9 = new LABEL(attributesMapOf_0('class', null), this_6.j1f());
    this_9.j1f().a1h(this_9);
    this_9.n1f(I18n_getInstance().e28('requestCertVisibility.emailsLabel'));
    // Inline function 'kotlinx.html.textArea' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_10 = new TEXTAREA(attributesMapOf(['rows', null, 'cols', null, 'wrap', null == null ? null : enumEncode(null), 'class', null]), this_9.j1f());
    this_10.j1f().a1h(this_10);
    set_id(this_10, 'visibilityEmailsInput');
    this_10.b1q('4');
    this_10.c1q('50');
    this_10.j1f().b1h(this_10);
    this_9.j1f().b1h(this_9);
    // Inline function 'kotlinx.html.button' call
    var tmp_2 = null == null ? null : enumEncode(null);
    var tmp_3 = null == null ? null : enumEncode(null);
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_11 = new BUTTON(attributesMapOf(['formenctype', tmp_2, 'formmethod', tmp_3, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_6.j1f());
    this_11.j1f().a1h(this_11);
    this_11.z1j(ButtonType_submit_getInstance());
    var tmp0_3 = this_11.l1f();
    var tmp2_3 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value_3 = 'requestCertVisibility.submitButton';
    tmp0_3.m2(tmp2_3, value_3);
    this_11.n1f(I18n_getInstance().e28('requestCertVisibility.submitButton'));
    this_11.j1f().b1h(this_11);
    // Inline function 'kotlinx.html.div' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_12 = new DIV(attributesMapOf_0('class', null), this_6.j1f());
    this_12.j1f().a1h(this_12);
    set_id(this_12, 'visibilityRequestStatus');
    this_12.j1f().b1h(this_12);
    this_6.j1f().b1h(this_6);
    $this$append.d1h();
    // Inline function 'kotlinx.html.div' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_13 = new DIV(attributesMapOf_0('class', null), $this$append);
    if (!(this_13.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_13.j1f().a1h(this_13);
    set_id(this_13, 'visibilityOutcomeList');
    this_13.j1f().b1h(this_13);
    $this$append.d1h();
    // Inline function 'kotlinx.html.h2' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_14 = new H2(attributesMapOf_0('class', null), $this$append);
    if (!(this_14.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_14.j1f().a1h(this_14);
    var tmp0_4 = this_14.l1f();
    var tmp2_4 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value_4 = 'requestCertVisibility.sentRequestsHeading';
    tmp0_4.m2(tmp2_4, value_4);
    this_14.n1f(I18n_getInstance().e28('requestCertVisibility.sentRequestsHeading'));
    this_14.j1f().b1h(this_14);
    $this$append.d1h();
    // Inline function 'kotlinx.html.div' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_15 = new DIV(attributesMapOf_0('class', null), $this$append);
    if (!(this_15.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_15.j1f().a1h(this_15);
    set_id(this_15, 'sentRequestList');
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_16 = new P(attributesMapOf_0('class', null), this_15.j1f());
    this_16.j1f().a1h(this_16);
    var tmp0_5 = this_16.l1f();
    var tmp2_5 = 'data-i18n';
    // Inline function 'kotlin.collections.set' call
    var value_5 = 'requestCertVisibility.loading';
    tmp0_5.m2(tmp2_5, value_5);
    this_16.n1f(I18n_getInstance().e28('requestCertVisibility.loading'));
    this_16.j1f().b1h(this_16);
    this_15.j1f().b1h(this_15);
    $this$append.d1h();
    return Unit_instance;
  }
  function renderPageBody$lambda_0($companyId) {
    return function (it) {
      saveOfferings($companyId);
      return Unit_instance;
    };
  }
  function renderPageBody$lambda_1($companyId) {
    return function (event) {
      event.preventDefault();
      submitVisibilityRequest($companyId);
      return Unit_instance;
    };
  }
  function loadOfferings$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('requestCertVisibility.offeringsLoadError') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadOfferings$slambda_1($companyId, $checkboxes, resultContinuation) {
    this.m45_1 = $companyId;
    this.n45_1 = $checkboxes;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadOfferings$slambda_1).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadOfferings$slambda_1).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadOfferings$slambda_1).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/companies/' + this.m45_1 + '/activity-offerings';
            this.q45_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.q45_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(CompanyActivityOfferingsResponse), arrayOf([]), false));
            var offerings = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp0_0 = offerings.o2o_1;
            var destination = LinkedHashSet_init_$Create$();
            var _iterator__ex2g4s = tmp0_0.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              destination.x(item.s2_1);
            }

            renderOfferingCheckboxes(this.n45_1, destination);
            var tmp_0 = this;
            var tmp0_1 = offerings.o2o_1;
            var destination_0 = LinkedHashSet_init_$Create$();
            var _iterator__ex2g4s_0 = tmp0_1.t();
            while (_iterator__ex2g4s_0.u()) {
              var item_0 = _iterator__ex2g4s_0.v();
              destination_0.x(item_0.s2_1);
            }

            renderActivitySelect(destination_0);
            tmp_0.p45_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.n45_1.innerHTML = '';
              tmp_2.p45_1 = append(this.n45_1, loadOfferings$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadOfferings$slambda_1).h22 = function ($this$launch, completion) {
    var i = new loadOfferings$slambda_1(this.m45_1, this.n45_1, completion);
    i.o45_1 = $this$launch;
    return i;
  };
  function loadOfferings$slambda_2($companyId, $checkboxes, resultContinuation) {
    var i = new loadOfferings$slambda_1($companyId, $checkboxes, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderOfferingCheckboxes$lambda($selected) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = get_activityCatalogByCategory().l2().t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlin.collections.component1' call
        var category = element.e2();
        // Inline function 'kotlin.collections.component2' call
        var entries = element.f2();
        var categoryKey = getValue(get_activityCategoryI18nKeys(), category);
        // Inline function 'kotlinx.html.h4' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new H4(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp0 = this_0.l1f();
        // Inline function 'kotlin.collections.set' call
        var key = 'data-i18n';
        tmp0.m2(key, categoryKey);
        this_0.n1f(I18n_getInstance().e28(categoryKey));
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = entries.t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          // Inline function 'kotlinx.html.label' call
          // Inline function 'kotlinx.html.visitAndFinalize' call
          // Inline function 'kotlinx.html.visitTagAndFinalize' call
          var this_1 = new LABEL(attributesMapOf_0('class', null), $this$append);
          if (!(this_1.j1f() === $this$append)) {
            throw IllegalArgumentException_init_$Create$('Wrong exception');
          }
          // Inline function 'kotlinx.html.visitTag' call
          this_1.j1f().a1h(this_1);
          // Inline function 'kotlinx.html.input' call
          var tmp0_safe_receiver = InputType_checkBox_getInstance();
          var tmp = tmp0_safe_receiver == null ? null : enumEncode(tmp0_safe_receiver);
          var tmp_0 = null == null ? null : enumEncode(null);
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_2 = new INPUT(attributesMapOf(['type', tmp, 'formenctype', tmp_0, 'formmethod', null == null ? null : enumEncode(null), 'name', null, 'class', null]), this_1.j1f());
          this_2.j1f().a1h(this_2);
          set_id(this_2, 'offering-' + element_0.s24_1);
          this_2.y1l($selected.c2(element_0.s24_1));
          this_2.j1f().b1h(this_2);
          // Inline function 'kotlinx.html.span' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_3 = new SPAN(attributesMapOf_0('class', null), this_1.j1f());
          this_3.j1f().a1h(this_3);
          var tmp0_0 = this_3.l1f();
          var tmp2 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value = element_0.v24_1;
          tmp0_0.m2(tmp2, value);
          this_3.n1f(I18n_getInstance().e28(element_0.v24_1));
          this_3.j1f().b1h(this_3);
          this_1.j1f().b1h(this_1);
          $this$append.d1h();
        }
      }
      return Unit_instance;
    };
  }
  function renderActivitySelect$lambda($offered) {
    return function ($this$append) {
      var tmp;
      if ($offered.r()) {
        // Inline function 'kotlinx.html.option' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new OPTION(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        this_0.d1m('');
        var tmp0 = this_0.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = 'requestCertVisibility.noOfferingsOption';
        tmp0.m2(tmp2, value);
        this_0.n1f(I18n_getInstance().e28('requestCertVisibility.noOfferingsOption'));
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      // Inline function 'kotlin.collections.filter' call
      var tmp0_0 = flatten(get_activityCatalogByCategory().k2());
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0_0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if ($offered.c2(element.s24_1)) {
          destination.x(element);
        }
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = destination.t();
      while (_iterator__ex2g4s_0.u()) {
        var element_0 = _iterator__ex2g4s_0.v();
        // Inline function 'kotlinx.html.option' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_1 = new OPTION(attributesMapOf_0('class', null), $this$append);
        if (!(this_1.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_1.j1f().a1h(this_1);
        this_1.d1m(element_0.s24_1);
        var tmp0_1 = this_1.l1f();
        var tmp2_0 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value_0 = element_0.v24_1;
        tmp0_1.m2(tmp2_0, value_0);
        this_1.n1f(I18n_getInstance().e28(element_0.v24_1));
        this_1.j1f().b1h(this_1);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function saveOfferings$slambda($companyId, $selected, $status, resultContinuation) {
    this.z45_1 = $companyId;
    this.a46_1 = $selected;
    this.b46_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(saveOfferings$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(saveOfferings$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(saveOfferings$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/companies/' + this.z45_1 + '/activity-offerings';
            var tmp0_0 = this.a46_1;
            var destination = LinkedHashSet_init_$Create$();
            var _iterator__ex2g4s = tmp0_0.t();
            while (_iterator__ex2g4s.u()) {
              var item = _iterator__ex2g4s.v();
              destination.x(valueOf(item));
            }

            var body = new SetCompanyActivityOfferingsRequest(destination);
            this.d46_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(SetCompanyActivityOfferingsRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('PUT', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.d46_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(CompanyActivityOfferingsResponse), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            this.b46_1.textContent = I18n_getInstance().e28('requestCertVisibility.savedStatus');
            var tmp0_1 = result.o2o_1;
            var destination_0 = LinkedHashSet_init_$Create$();
            var _iterator__ex2g4s_0 = tmp0_1.t();
            while (_iterator__ex2g4s_0.u()) {
              var item_0 = _iterator__ex2g4s_0.v();
              destination_0.x(item_0.s2_1);
            }

            renderActivitySelect(destination_0);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.b46_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(saveOfferings$slambda).h22 = function ($this$launch, completion) {
    var i = new saveOfferings$slambda(this.z45_1, this.a46_1, this.b46_1, completion);
    i.c46_1 = $this$launch;
    return i;
  };
  function saveOfferings$slambda_0($companyId, $selected, $status, resultContinuation) {
    var i = new saveOfferings$slambda($companyId, $selected, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function submitVisibilityRequest$slambda($companyId, $activityType, $emails, $status, resultContinuation) {
    this.m46_1 = $companyId;
    this.n46_1 = $activityType;
    this.o46_1 = $emails;
    this.p46_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitVisibilityRequest$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitVisibilityRequest$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitVisibilityRequest$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/v1/bitacora/companies/' + this.m46_1 + '/visibility-requests';
            var body = new RequestCertificationVisibilityRequest(valueOf(this.n46_1), this.o46_1);
            this.r46_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(RequestCertificationVisibilityRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.r46_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(VisibilityRequestOutcomeResponse), arrayOf([]), false))]), false));
            var outcomes = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            this.p46_1.textContent = I18n_getInstance().e28('requestCertVisibility.submittedStatus');
            renderOutcomes(outcomes);
            loadSentRequests(this.m46_1);
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.p46_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(submitVisibilityRequest$slambda).h22 = function ($this$launch, completion) {
    var i = new submitVisibilityRequest$slambda(this.m46_1, this.n46_1, this.o46_1, this.p46_1, completion);
    i.q46_1 = $this$launch;
    return i;
  };
  function submitVisibilityRequest$slambda_0($companyId, $activityType, $emails, $status, resultContinuation) {
    var i = new submitVisibilityRequest$slambda($companyId, $activityType, $emails, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderOutcomes$lambda($outcomes) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $outcomes.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp0_subject = element.o2p_1;
        this_0.n1f(tmp0_subject === 'CREATED' ? element.n2p_1 + ': ' + I18n_getInstance().e28('requestCertVisibility.outcomeCreated') : tmp0_subject === 'NO_ACCOUNT' ? element.n2p_1 + ': ' + I18n_getInstance().e28('requestCertVisibility.outcomeNoAccount') : tmp0_subject === 'DUPLICATE_PENDING' ? element.n2p_1 + ': ' + I18n_getInstance().e28('requestCertVisibility.outcomeDuplicatePending') : element.n2p_1 + ': ' + element.o2p_1);
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function loadSentRequests$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('requestCertVisibility.sentRequestsLoadError') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadSentRequests$slambda($companyId, $el, resultContinuation) {
    this.a47_1 = $companyId;
    this.b47_1 = $el;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadSentRequests$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadSentRequests$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadSentRequests$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/companies/' + this.a47_1 + '/visibility-requests';
            this.e47_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.e47_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CertificationVisibilityRequestResponse), arrayOf([]), false))]), false));
            var requests = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            renderSentRequests(this.b47_1, this.a47_1, requests);
            tmp_0.d47_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.b47_1.innerHTML = '';
              tmp_2.d47_1 = append(this.b47_1, loadSentRequests$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadSentRequests$slambda).h22 = function ($this$launch, completion) {
    var i = new loadSentRequests$slambda(this.a47_1, this.b47_1, completion);
    i.c47_1 = $this$launch;
    return i;
  };
  function loadSentRequests$slambda_0($companyId, $el, resultContinuation) {
    var i = new loadSentRequests$slambda($companyId, $el, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderSentRequests$lambda$lambda($companyId, $request) {
    return function (it) {
      viewCertifications($companyId, $request.b2p_1);
      return Unit_instance;
    };
  }
  function renderSentRequests$lambda($requests, $companyId) {
    return function ($this$append) {
      var tmp;
      if ($requests.r()) {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp0 = this_0.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = 'requestCertVisibility.noRequestsSent';
        tmp0.m2(tmp2, value);
        this_0.n1f(I18n_getInstance().e28('requestCertVisibility.noRequestsSent'));
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $requests.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.div' call
        var classes = 'entry-card';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_1 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_1.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_1.j1f().a1h(this_1);
        // Inline function 'kotlinx.html.h3' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_2 = new H3(attributesMapOf_0('class', null), this_1.j1f());
        this_2.j1f().a1h(this_2);
        this_2.n1f(activityTypeLabel(element.f2p_1));
        this_2.j1f().b1h(this_2);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_3 = new P(attributesMapOf_0('class', null), this_1.j1f());
        this_3.j1f().a1h(this_3);
        this_3.n1f(I18n_getInstance().e28('requestCertVisibility.statusPrefix') + element.g2p_1);
        this_3.j1f().b1h(this_3);
        if (element.g2p_1 === 'APPROVED') {
          // Inline function 'kotlinx.html.button' call
          var tmp_0 = null == null ? null : enumEncode(null);
          var tmp_1 = null == null ? null : enumEncode(null);
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_4 = new BUTTON(attributesMapOf(['formenctype', tmp_0, 'formmethod', tmp_1, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', null]), this_1.j1f());
          this_4.j1f().a1h(this_4);
          set_onClickFunction(this_4, renderSentRequests$lambda$lambda($companyId, element));
          var tmp0_0 = this_4.l1f();
          var tmp2_0 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value_0 = 'requestCertVisibility.viewCertificationsButton';
          tmp0_0.m2(tmp2_0, value_0);
          this_4.n1f(I18n_getInstance().e28('requestCertVisibility.viewCertificationsButton'));
          this_4.j1f().b1h(this_4);
        }
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_5 = new DIV(attributesMapOf_0('class', null), this_1.j1f());
        this_5.j1f().a1h(this_5);
        set_id(this_5, 'visibility-view-' + element.b2p_1);
        this_5.j1f().b1h(this_5);
        this_1.j1f().b1h(this_1);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function viewCertifications$slambda$lambda($credentials) {
    return function ($this$append) {
      var tmp;
      if ($credentials.r()) {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        var tmp0 = this_0.l1f();
        var tmp2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value = 'requestCertVisibility.noCertificationsOnFile';
        tmp0.m2(tmp2, value);
        this_0.n1f(I18n_getInstance().e28('requestCertVisibility.noCertificationsOnFile'));
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $credentials.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_1 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_1.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_1.j1f().a1h(this_1);
        this_1.n1f(I18n_getInstance().e28('requestCertVisibility.certificatePrefix') + element.d2o_1 + (I18n_getInstance().e28('requestCertVisibility.certificateIssuedSuffix') + element.e2o_1 + ')'));
        this_1.j1f().b1h(this_1);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function viewCertifications$slambda$lambda_0($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('requestCertVisibility.certificationsLoadError') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function viewCertifications$slambda($companyId, $requestId, $el, resultContinuation) {
    this.n47_1 = $companyId;
    this.o47_1 = $requestId;
    this.p47_1 = $el;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(viewCertifications$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(viewCertifications$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(viewCertifications$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/companies/' + this.n47_1 + '/visibility-requests/' + this.o47_1 + '/certifications';
            this.s47_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.s47_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CredentialResponse), arrayOf([]), false))]), false));
            var credentials = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            tmp_0.r47_1 = append(this.p47_1, viewCertifications$slambda$lambda(credentials));
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.r47_1 = append(this.p47_1, viewCertifications$slambda$lambda_0(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(viewCertifications$slambda).h22 = function ($this$launch, completion) {
    var i = new viewCertifications$slambda(this.n47_1, this.o47_1, this.p47_1, completion);
    i.q47_1 = $this$launch;
    return i;
  };
  function viewCertifications$slambda_0($companyId, $requestId, $el, resultContinuation) {
    var i = new viewCertifications$slambda($companyId, $requestId, $el, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function ResetPasswordPageModule$init$lambda($token) {
    return function (event) {
      event.preventDefault();
      submitResetPassword($token);
      return Unit_instance;
    };
  }
  function ResetPasswordPageModule() {
  }
  protoOf(ResetPasswordPageModule).r28 = function () {
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('token');
    var token = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    if (isBlank(token)) {
      var tmp = document.getElementById('resetPasswordMissingToken');
      (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('hidden');
      return Unit_instance;
    }
    var tmp_0 = document.getElementById('resetPasswordForm');
    (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.remove('hidden');
    var tmp_1 = document.getElementById('resetPasswordForm');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('submit', ResetPasswordPageModule$init$lambda(token));
  };
  var ResetPasswordPageModule_instance;
  function ResetPasswordPageModule_getInstance() {
    return ResetPasswordPageModule_instance;
  }
  function submitResetPassword(token) {
    var tmp = document.getElementById('resetPasswordStatus');
    var statusBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    statusBox.innerHTML = '';
    statusBox.classList.remove('status-error');
    var tmp_0 = document.getElementById('resetPasswordNew');
    var newPassword = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var tmp_1 = document.getElementById('resetPasswordConfirm');
    var confirmPassword = (tmp_1 instanceof HTMLInputElement ? tmp_1 : THROW_CCE()).value;
    if (!(newPassword === confirmPassword)) {
      statusBox.classList.add('status-error');
      statusBox.textContent = "Passwords don't match.";
      return Unit_instance;
    }
    var tmp_2 = get_AppScope();
    launch(tmp_2, VOID, VOID, submitResetPassword$slambda_0(token, newPassword, statusBox, null));
  }
  function submitResetPassword$slambda$lambda($this$append) {
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new P(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    this_0.n1f('This link is invalid or has expired.');
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    // Inline function 'kotlinx.html.a' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_1 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), $this$append);
    if (!(this_1.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_1.j1f().a1h(this_1);
    this_1.q1j('/forgot-password');
    this_1.n1f('Request a new link');
    this_1.j1f().b1h(this_1);
    $this$append.d1h();
    return Unit_instance;
  }
  function submitResetPassword$slambda($token, $newPassword, $statusBox, resultContinuation) {
    this.b48_1 = $token;
    this.c48_1 = $newPassword;
    this.d48_1 = $statusBox;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitResetPassword$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitResetPassword$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitResetPassword$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 3;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/auth/reset-password';
            var body = new ResetPasswordRequest(this.b48_1, this.c48_1);
            this.g48_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(ResetPasswordRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.g48_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(TokenResponse), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            AuthState_instance.m2y(result.t2c_1, result.u2c_1);
            this.t7_1 = 2;
            suspendResult = navigateAfterAuth(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_0 = this;
            tmp_0.f48_1 = Unit_instance;
            this.u7_1 = 4;
            this.t7_1 = 5;
            continue $sm;
          case 3:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.d48_1.classList.add('status-error');
              this.d48_1.innerHTML = '';
              tmp_2.f48_1 = append(this.d48_1, submitResetPassword$slambda$lambda);
              this.t7_1 = 5;
              continue $sm;
            } else {
              var tmp_3 = this.w7_1;
              if (tmp_3 instanceof Error) {
                var e_0 = this.w7_1;
                var tmp_4 = this;
                this.d48_1.classList.add('status-error');
                this.d48_1.textContent = 'Something went wrong: ' + e_0.message;
                tmp_4.f48_1 = Unit_instance;
                this.t7_1 = 5;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 4:
            throw this.w7_1;
          case 5:
            this.u7_1 = 4;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 4) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitResetPassword$slambda).h22 = function ($this$launch, completion) {
    var i = new submitResetPassword$slambda(this.b48_1, this.c48_1, this.d48_1, completion);
    i.e48_1 = $this$launch;
    return i;
  };
  function submitResetPassword$slambda_0($token, $newPassword, $statusBox, resultContinuation) {
    var i = new submitResetPassword$slambda($token, $newPassword, $statusBox, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function get_CLOUD_PROVIDERS() {
    _init_properties_SettingsPage_kt__up7lla();
    return CLOUD_PROVIDERS;
  }
  var CLOUD_PROVIDERS;
  function get_ON_DEVICE_PROVIDERS() {
    _init_properties_SettingsPage_kt__up7lla();
    return ON_DEVICE_PROVIDERS;
  }
  var ON_DEVICE_PROVIDERS;
  function providerLabel(provider) {
    _init_properties_SettingsPage_kt__up7lla();
    switch (provider) {
      case 'STRAVA':
        return 'Strava';
      case 'GARMIN':
        return 'Garmin';
      case 'XIAOMI':
        return 'Xiaomi / Amazfit (Zepp)';
      case 'APPLE_HEALTH':
        return 'Apple Watch (Health)';
      case 'HEALTH_CONNECT':
        return 'Wear OS / Samsung (Health Connect)';
      case 'HUAWEI_HEALTH':
        return 'Huawei Watch (Health Kit)';
      default:
        return provider;
    }
  }
  function SettingsPageModule() {
  }
  protoOf(SettingsPageModule).r28 = function () {
    if (!AuthState_instance.y27()) {
      get_moduleNavigateTo()('/login');
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.filterValues' call
    var this_0 = mapOf([to('deviceSyncConnected', urlParam('deviceSyncConnected')), to('deviceSyncError', urlParam('deviceSyncError'))]);
    var result = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this_0.l2().t();
    while (_iterator__ex2g4s.u()) {
      var entry = _iterator__ex2g4s.v();
      if (!(entry.f2() == null)) {
        result.m2(entry.e2(), entry.f2());
      }
    }
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap_init_$Create$_0(mapCapacity(result.z()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_0 = result.l2().t();
    while (_iterator__ex2g4s_0.u()) {
      var element = _iterator__ex2g4s_0.v();
      var tmp = element.e2();
      var tmp$ret$7 = ensureNotNull(element.f2());
      destination.m2(tmp, tmp$ret$7);
    }
    renderBanner(destination);
    loadConnections();
  };
  var SettingsPageModule_instance;
  function SettingsPageModule_getInstance() {
    return SettingsPageModule_instance;
  }
  function renderBanner(params) {
    _init_properties_SettingsPage_kt__up7lla();
    var tmp = document.getElementById('deviceSyncBanner');
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var banner = tmp_0;
    var connectedProvider = params.i2('deviceSyncConnected');
    var error = params.i2('deviceSyncError');
    banner.innerHTML = '';
    append(banner, renderBanner$lambda(connectedProvider, error));
  }
  function loadConnections() {
    _init_properties_SettingsPage_kt__up7lla();
    var tmp = document.getElementById('deviceSyncList');
    var content = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, loadConnections$slambda_0(content, null));
  }
  function renderDeviceList(content, connectionsByProvider) {
    _init_properties_SettingsPage_kt__up7lla();
    content.innerHTML = '';
    append(content, renderDeviceList$lambda(connectionsByProvider));
  }
  function connect(provider) {
    _init_properties_SettingsPage_kt__up7lla();
    var tmp = document.getElementById('deviceSync-status-' + provider);
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, connect$slambda_0(provider, status, null));
  }
  function disconnect(provider) {
    _init_properties_SettingsPage_kt__up7lla();
    var tmp = document.getElementById('deviceSync-status-' + provider);
    var status = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    clearStatus(status);
    var tmp_0 = get_AppScope();
    launch(tmp_0, VOID, VOID, disconnect$slambda_0(provider, status, null));
  }
  function renderBanner$lambda($connectedProvider, $error) {
    return function ($this$append) {
      var tmp;
      if (!($connectedProvider == null)) {
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new P(attributesMapOf_0('class', null), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        this_0.n1f(I18n_getInstance().e28('settings.connectedTo') + providerLabel($connectedProvider));
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
        tmp = Unit_instance;
      } else if (!($error == null)) {
        // Inline function 'kotlinx.html.p' call
        var classes = 'status-error';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_1 = new P(attributesMapOf_0('class', classes), $this$append);
        if (!(this_1.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_1.j1f().a1h(this_1);
        this_1.n1f($error);
        this_1.j1f().b1h(this_1);
        $this$append.d1h();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function loadConnections$slambda$lambda($e) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      var classes = 'status-error';
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', classes), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f(I18n_getInstance().e28('settings.loadError') + $e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function loadConnections$slambda($content, resultContinuation) {
    this.p48_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadConnections$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(loadConnections$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(loadConnections$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/device-sync/connections';
            this.s48_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.s48_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DeviceSyncConnectionResponse), arrayOf([]), false))]), false));
            var connections = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = connections.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (!(element.m2q_1 === 'REVOKED')) {
                destination.x(element);
              }
            }

            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
            var destination_0 = LinkedHashMap_init_$Create$_0(capacity);
            var _iterator__ex2g4s_0 = destination.t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              destination_0.m2(element_0.l2q_1, element_0);
            }

            renderDeviceList(this.p48_1, destination_0);
            tmp_0.r48_1 = Unit_instance;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.p48_1.innerHTML = '';
              tmp_2.r48_1 = append(this.p48_1, loadConnections$slambda$lambda(e));
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(loadConnections$slambda).h22 = function ($this$launch, completion) {
    var i = new loadConnections$slambda(this.p48_1, completion);
    i.q48_1 = $this$launch;
    return i;
  };
  function loadConnections$slambda_0($content, resultContinuation) {
    var i = new loadConnections$slambda($content, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function renderDeviceList$lambda$lambda($provider) {
    return function (it) {
      disconnect($provider);
      return Unit_instance;
    };
  }
  function renderDeviceList$lambda$lambda_0($provider) {
    return function (it) {
      connect($provider);
      return Unit_instance;
    };
  }
  function renderDeviceList$lambda($connectionsByProvider) {
    return function ($this$append) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = get_CLOUD_PROVIDERS().t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var connection = $connectionsByProvider.i2(element);
        // Inline function 'kotlinx.html.div' call
        var classes = 'entry-card';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_0 = new DIV(attributesMapOf_0('class', classes), $this$append);
        if (!(this_0.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_0.j1f().a1h(this_0);
        // Inline function 'kotlinx.html.h3' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_1 = new H3(attributesMapOf_0('class', null), this_0.j1f());
        this_1.j1f().a1h(this_1);
        this_1.n1f(providerLabel(element));
        this_1.j1f().b1h(this_1);
        if (!(connection == null)) {
          // Inline function 'kotlinx.html.p' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_2 = new P(attributesMapOf_0('class', null), this_0.j1f());
          this_2.j1f().a1h(this_2);
          this_2.n1f(I18n_getInstance().e28('settings.status') + connection.m2q_1);
          this_2.j1f().b1h(this_2);
          var tmp0_safe_receiver = connection.n2q_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlinx.html.p' call
            // Inline function 'kotlinx.html.visit' call
            // Inline function 'kotlinx.html.visitTag' call
            var this_3 = new P(attributesMapOf_0('class', null), this_0.j1f());
            this_3.j1f().a1h(this_3);
            this_3.n1f(I18n_getInstance().e28('settings.lastSynced') + tmp0_safe_receiver);
            this_3.j1f().b1h(this_3);
          }
        } else {
          // Inline function 'kotlinx.html.p' call
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_4 = new P(attributesMapOf_0('class', null), this_0.j1f());
          this_4.j1f().a1h(this_4);
          var tmp0 = this_4.l1f();
          var tmp2 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value = 'settings.notConnected';
          tmp0.m2(tmp2, value);
          this_4.n1f(I18n_getInstance().e28('settings.notConnected'));
          this_4.j1f().b1h(this_4);
        }
        // Inline function 'kotlinx.html.div' call
        var classes_0 = 'entry-actions';
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_5 = new DIV(attributesMapOf_0('class', classes_0), this_0.j1f());
        this_5.j1f().a1h(this_5);
        if (!(connection == null)) {
          // Inline function 'kotlinx.html.button' call
          var classes_1 = 'btn-reject';
          var tmp = null == null ? null : enumEncode(null);
          var tmp_0 = null == null ? null : enumEncode(null);
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_6 = new BUTTON(attributesMapOf(['formenctype', tmp, 'formmethod', tmp_0, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_1]), this_5.j1f());
          this_6.j1f().a1h(this_6);
          set_onClickFunction(this_6, renderDeviceList$lambda$lambda(element));
          var tmp0_0 = this_6.l1f();
          var tmp2_0 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value_0 = 'settings.disconnect';
          tmp0_0.m2(tmp2_0, value_0);
          this_6.n1f(I18n_getInstance().e28('settings.disconnect'));
          this_6.j1f().b1h(this_6);
        } else {
          // Inline function 'kotlinx.html.button' call
          var classes_2 = 'btn-approve';
          var tmp_1 = null == null ? null : enumEncode(null);
          var tmp_2 = null == null ? null : enumEncode(null);
          // Inline function 'kotlinx.html.visit' call
          // Inline function 'kotlinx.html.visitTag' call
          var this_7 = new BUTTON(attributesMapOf(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', null, 'type', null == null ? null : enumEncode(null), 'class', classes_2]), this_5.j1f());
          this_7.j1f().a1h(this_7);
          set_onClickFunction(this_7, renderDeviceList$lambda$lambda_0(element));
          var tmp0_1 = this_7.l1f();
          var tmp2_1 = 'data-i18n';
          // Inline function 'kotlin.collections.set' call
          var value_1 = 'settings.connect';
          tmp0_1.m2(tmp2_1, value_1);
          this_7.n1f(I18n_getInstance().e28('settings.connect'));
          this_7.j1f().b1h(this_7);
        }
        this_5.j1f().b1h(this_5);
        // Inline function 'kotlinx.html.div' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_8 = new DIV(attributesMapOf_0('class', null), this_0.j1f());
        this_8.j1f().a1h(this_8);
        set_id(this_8, 'deviceSync-status-' + element);
        this_8.j1f().b1h(this_8);
        this_0.j1f().b1h(this_0);
        $this$append.d1h();
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = get_ON_DEVICE_PROVIDERS().t();
      while (_iterator__ex2g4s_0.u()) {
        var element_0 = _iterator__ex2g4s_0.v();
        // Inline function 'kotlinx.html.div' call
        var classes_3 = 'entry-card';
        // Inline function 'kotlinx.html.visitAndFinalize' call
        // Inline function 'kotlinx.html.visitTagAndFinalize' call
        var this_9 = new DIV(attributesMapOf_0('class', classes_3), $this$append);
        if (!(this_9.j1f() === $this$append)) {
          throw IllegalArgumentException_init_$Create$('Wrong exception');
        }
        // Inline function 'kotlinx.html.visitTag' call
        this_9.j1f().a1h(this_9);
        // Inline function 'kotlinx.html.h3' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_10 = new H3(attributesMapOf_0('class', null), this_9.j1f());
        this_10.j1f().a1h(this_10);
        this_10.n1f(providerLabel(element_0));
        this_10.j1f().b1h(this_10);
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_11 = new P(attributesMapOf_0('class', null), this_9.j1f());
        this_11.j1f().a1h(this_11);
        var tmp0_2 = this_11.l1f();
        var tmp2_2 = 'data-i18n';
        // Inline function 'kotlin.collections.set' call
        var value_2 = 'settings.onDeviceOnly';
        tmp0_2.m2(tmp2_2, value_2);
        this_11.n1f(I18n_getInstance().e28('settings.onDeviceOnly'));
        this_11.j1f().b1h(this_11);
        this_9.j1f().b1h(this_9);
        $this$append.d1h();
      }
      return Unit_instance;
    };
  }
  function connect$slambda($provider, $status, resultContinuation) {
    this.b49_1 = $provider;
    this.c49_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(connect$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(connect$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(connect$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/device-sync/' + this.b49_1.toLowerCase() + '/connect';
            this.e49_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('POST', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.e49_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(DeviceSyncConnectResponse), arrayOf([]), false));
            var result = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            window.location.href = result.i2q_1;
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_0 = this.w7_1;
            if (tmp_0 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.c49_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(connect$slambda).h22 = function ($this$launch, completion) {
    var i = new connect$slambda(this.b49_1, this.c49_1, completion);
    i.d49_1 = $this$launch;
    return i;
  };
  function connect$slambda_0($provider, $status, resultContinuation) {
    var i = new connect$slambda($provider, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function disconnect$slambda($provider, $status, resultContinuation) {
    this.n49_1 = $provider;
    this.o49_1 = $status;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(disconnect$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(disconnect$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(disconnect$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 3;
            this.u7_1 = 2;
            this.t7_1 = 1;
            var tmp_0 = ApiClient_getInstance();
            var this_0 = this.n49_1;
            suspendResult = tmp_0.a2x('/api/v1/bitacora/device-sync/' + this_0.toLowerCase(), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            loadConnections();
            this.u7_1 = 3;
            this.t7_1 = 4;
            continue $sm;
          case 2:
            this.u7_1 = 3;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              showError(this.o49_1, e.k2c_1);
              this.t7_1 = 4;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            throw this.w7_1;
          case 4:
            this.u7_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 3) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(disconnect$slambda).h22 = function ($this$launch, completion) {
    var i = new disconnect$slambda(this.n49_1, this.o49_1, completion);
    i.p49_1 = $this$launch;
    return i;
  };
  function disconnect$slambda_0($provider, $status, resultContinuation) {
    var i = new disconnect$slambda($provider, $status, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  var properties_initialized_SettingsPage_kt_bsekrw;
  function _init_properties_SettingsPage_kt__up7lla() {
    if (!properties_initialized_SettingsPage_kt_bsekrw) {
      properties_initialized_SettingsPage_kt_bsekrw = true;
      CLOUD_PROVIDERS = listOf(['STRAVA', 'GARMIN', 'XIAOMI']);
      ON_DEVICE_PROVIDERS = listOf(['APPLE_HEALTH', 'HEALTH_CONNECT', 'HUAWEI_HEALTH']);
    }
  }
  function SetupPageModule$init$lambda($token) {
    return function (event) {
      event.preventDefault();
      submitSetup($token, '/login');
      return Unit_instance;
    };
  }
  function SetupPageModule() {
  }
  protoOf(SetupPageModule).r28 = function () {
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = urlParam('token');
    var token = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    if (isBlank(token)) {
      var tmp = document.getElementById('setupMissingToken');
      (tmp instanceof HTMLElement ? tmp : THROW_CCE()).classList.remove('hidden');
      return Unit_instance;
    }
    var tmp_0 = document.getElementById('setupForm');
    (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).classList.remove('hidden');
    wireAuthMethodPicker();
    var tmp_1 = document.getElementById('setupForm');
    var tmp_2 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
    tmp_2.addEventListener('submit', SetupPageModule$init$lambda(token));
  };
  var SetupPageModule_instance;
  function SetupPageModule_getInstance() {
    return SetupPageModule_instance;
  }
  function submitSetup(token, loginLinkHref) {
    loginLinkHref = loginLinkHref === VOID ? '#/login' : loginLinkHref;
    var tmp = document.getElementById('setupFormError');
    var errorBox = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    errorBox.textContent = '';
    var methodError = authMethodValidationError();
    if (!(methodError == null)) {
      errorBox.textContent = methodError;
      return Unit_instance;
    }
    var tmp_0 = document.getElementById('setupDisplayName');
    var displayName = (tmp_0 instanceof HTMLInputElement ? tmp_0 : THROW_CCE()).value;
    var password = selectedPassword();
    var tmp_1 = get_AppScope();
    launch(tmp_1, VOID, VOID, submitSetup$slambda_0(token, password, displayName, errorBox, loginLinkHref, null));
  }
  function submitSetup$slambda$lambda($e, $loginLinkHref) {
    return function ($this$append) {
      // Inline function 'kotlinx.html.p' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_0 = new P(attributesMapOf_0('class', null), $this$append);
      if (!(this_0.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_0.j1f().a1h(this_0);
      this_0.n1f($e.k2c_1);
      this_0.j1f().b1h(this_0);
      $this$append.d1h();
      // Inline function 'kotlinx.html.a' call
      // Inline function 'kotlinx.html.visitAndFinalize' call
      // Inline function 'kotlinx.html.visitTagAndFinalize' call
      var this_1 = new A(attributesMapOf(['href', null, 'target', null, 'class', null]), $this$append);
      if (!(this_1.j1f() === $this$append)) {
        throw IllegalArgumentException_init_$Create$('Wrong exception');
      }
      // Inline function 'kotlinx.html.visitTag' call
      this_1.j1f().a1h(this_1);
      this_1.q1j($loginLinkHref);
      this_1.n1f('Back to login');
      this_1.j1f().b1h(this_1);
      $this$append.d1h();
      return Unit_instance;
    };
  }
  function submitSetup$slambda($token, $password, $displayName, $errorBox, $loginLinkHref, resultContinuation) {
    this.y49_1 = $token;
    this.z49_1 = $password;
    this.a4a_1 = $displayName;
    this.b4a_1 = $errorBox;
    this.c4a_1 = $loginLinkHref;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(submitSetup$slambda).g22 = function ($this$launch, $completion) {
    var tmp = this.h22($this$launch, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  };
  protoOf(submitSetup$slambda).k8 = function (p1, $completion) {
    return this.g22((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(submitSetup$slambda).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 5;
            this.u7_1 = 4;
            var tmp0 = ApiClient_getInstance();
            var tmp2 = '/api/auth/setup';
            var body = new SetupRequest(this.y49_1, this.z49_1, this.a4a_1);
            this.f4a_1 = tmp0.f27_1;
            this.t7_1 = 1;
            var this_0 = tmp0.f27_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(SetupRequest), arrayOf([]), false));
            suspendResult = tmp0.g27('POST', tmp2, this_0.h13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), body), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2_0 = suspendResult;
            var this_3 = this.f4a_1;
            var this_4 = this_3.um();
            var this_5 = serializer(this_4, createKType(getKClass(TokenResponse), arrayOf([]), false));
            var result = this_3.i13(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), tmp2_0);
            AuthState_instance.m2y(result.t2c_1, result.u2c_1);
            this.t7_1 = 2;
            suspendResult = attachPasskeyIfSelected(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.t7_1 = 3;
            suspendResult = navigateAfterAuth(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp_0 = this;
            tmp_0.e4a_1 = Unit_instance;
            this.u7_1 = 5;
            this.t7_1 = 6;
            continue $sm;
          case 4:
            this.u7_1 = 5;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof ApiException) {
              var e = this.w7_1;
              var tmp_2 = this;
              this.b4a_1.textContent = '';
              tmp_2.e4a_1 = append(this.b4a_1, submitSetup$slambda$lambda(e, this.c4a_1));
              this.t7_1 = 6;
              continue $sm;
            } else {
              var tmp_3 = this.w7_1;
              if (tmp_3 instanceof Error) {
                var e_0 = this.w7_1;
                var tmp_4 = this;
                this.b4a_1.textContent = 'Something went wrong: ' + e_0.message;
                tmp_4.e4a_1 = Unit_instance;
                this.t7_1 = 6;
                continue $sm;
              } else {
                throw this.w7_1;
              }
            }

          case 5:
            throw this.w7_1;
          case 6:
            this.u7_1 = 5;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.u7_1 === 5) {
          throw e_1;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(submitSetup$slambda).h22 = function ($this$launch, completion) {
    var i = new submitSetup$slambda(this.y49_1, this.z49_1, this.a4a_1, this.b4a_1, this.c4a_1, completion);
    i.d4a_1 = $this$launch;
    return i;
  };
  function submitSetup$slambda_0($token, $password, $displayName, $errorBox, $loginLinkHref, resultContinuation) {
    var i = new submitSetup$slambda($token, $password, $displayName, $errorBox, $loginLinkHref, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.g22($this$launch, $completion);
    }, 1);
  }
  function get_TERMS_SECTIONS() {
    _init_properties_TermsPage_kt__ixi0cc();
    return TERMS_SECTIONS;
  }
  var TERMS_SECTIONS;
  function legalDocument(_this__u8e3s4, titleKey, updatedKey, introKey, sectionKeys) {
    _init_properties_TermsPage_kt__ixi0cc();
    // Inline function 'kotlinx.html.h1' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_0 = new H1(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
    this_0.j1f().a1h(this_0);
    this_0.n1f(I18n_getInstance().e28(titleKey));
    this_0.j1f().b1h(this_0);
    // Inline function 'kotlinx.html.p' call
    var classes = 'legal-updated';
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_1 = new P(attributesMapOf_0('class', classes), _this__u8e3s4.j1f());
    this_1.j1f().a1h(this_1);
    this_1.n1f(I18n_getInstance().e28(updatedKey));
    this_1.j1f().b1h(this_1);
    // Inline function 'kotlinx.html.p' call
    // Inline function 'kotlinx.html.visit' call
    // Inline function 'kotlinx.html.visitTag' call
    var this_2 = new P(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
    this_2.j1f().a1h(this_2);
    this_2.n1f(I18n_getInstance().e28(introKey));
    this_2.j1f().b1h(this_2);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = sectionKeys.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlinx.html.h2' call
      // Inline function 'kotlinx.html.visit' call
      // Inline function 'kotlinx.html.visitTag' call
      var this_3 = new H2(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
      this_3.j1f().a1h(this_3);
      this_3.n1f(I18n_getInstance().e28(element + '.h'));
      this_3.j1f().b1h(this_3);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = split(I18n_getInstance().e28(element + '.b'), ['\n\n']).t();
      while (_iterator__ex2g4s_0.u()) {
        var element_0 = _iterator__ex2g4s_0.v();
        // Inline function 'kotlinx.html.p' call
        // Inline function 'kotlinx.html.visit' call
        // Inline function 'kotlinx.html.visitTag' call
        var this_4 = new P(attributesMapOf_0('class', null), _this__u8e3s4.j1f());
        this_4.j1f().a1h(this_4);
        this_4.n1f(element_0);
        this_4.j1f().b1h(this_4);
      }
    }
  }
  function TermsPageModule$init$lambda($this$append) {
    // Inline function 'kotlinx.html.div' call
    // Inline function 'kotlinx.html.visitAndFinalize' call
    // Inline function 'kotlinx.html.visitTagAndFinalize' call
    var this_0 = new DIV(attributesMapOf_0('class', null), $this$append);
    if (!(this_0.j1f() === $this$append)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }
    // Inline function 'kotlinx.html.visitTag' call
    this_0.j1f().a1h(this_0);
    legalDocument(this_0, 'legal.terms.title', 'legal.terms.updated', 'legal.terms.intro', get_TERMS_SECTIONS());
    this_0.j1f().b1h(this_0);
    $this$append.d1h();
    return Unit_instance;
  }
  function TermsPageModule() {
  }
  protoOf(TermsPageModule).r28 = function () {
    var tmp = document.getElementById('legal-content');
    var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var container = tmp_0;
    append(container, TermsPageModule$init$lambda);
  };
  var TermsPageModule_instance;
  function TermsPageModule_getInstance() {
    return TermsPageModule_instance;
  }
  var properties_initialized_TermsPage_kt_y5yeai;
  function _init_properties_TermsPage_kt__ixi0cc() {
    if (!properties_initialized_TermsPage_kt_y5yeai) {
      properties_initialized_TermsPage_kt_y5yeai = true;
      // Inline function 'kotlin.collections.map' call
      var this_0 = numberRangeToNumber(1, 12);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.j1_1;
      var last = this_0.k1_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$2 = 'legal.terms.s' + item;
          destination.x(tmp$ret$2);
        }
         while (!(item === last));
      TERMS_SECTIONS = destination;
    }
  }
  function get_navigateTo() {
    _init_properties_AuthNavigation_kt__bjpv44();
    return navigateTo;
  }
  var navigateTo;
  function defaultNavigateTo(path) {
    _init_properties_AuthNavigation_kt__bjpv44();
    window.location.href = path;
  }
  function navigateAfterAuth($completion) {
    var tmp = new $navigateAfterAuthCOROUTINE$($completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function defaultNavigateTo$ref() {
    return constructCallableReference(function (p0) {
      defaultNavigateTo(p0);
      return Unit_instance;
    }, 1, 0, 14, 'defaultNavigateTo');
  }
  function $navigateAfterAuthCOROUTINE$(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($navigateAfterAuthCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 4;
            this.u7_1 = 2;
            this.p4a_1 = Companion_instance;
            var tmp0 = ApiClient_getInstance();
            var path = '/api/v1/bitacora/my-registered-activities';
            this.q4a_1 = tmp0.f27_1;
            this.t7_1 = 1;
            suspendResult = tmp0.g27('GET', path, null, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            var this_0 = this.q4a_1;
            var this_1 = this_0.um();
            var this_2 = serializer(this_1, createKType(getKClass(KtSet), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().da(), arrayOf([]), false))]), false));
            var tmp2_0 = this_0.i13(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), tmp2);
            var tmp_0 = this;
            this.p4a_1;
            tmp_0.o4a_1 = _Result___init__impl__xyqfz8(tmp2_0);
            this.u7_1 = 4;
            this.t7_1 = 3;
            continue $sm;
          case 2:
            this.u7_1 = 4;
            var tmp_1 = this.w7_1;
            if (tmp_1 instanceof Error) {
              var e = this.w7_1;
              var tmp_2 = this;
              tmp_2.o4a_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.t7_1 = 3;
              continue $sm;
            } else {
              throw this.w7_1;
            }

          case 3:
            this.u7_1 = 4;
            var tmp0_0 = this.o4a_1;
            var tmp2_1 = setOf_0('_unknown');
            var tmp$ret$0;
            l$ret$1: do {
              if (_Result___get_isFailure__impl__jpiriv(tmp0_0)) {
                tmp$ret$0 = tmp2_1;
                break l$ret$1;
              }
              tmp$ret$0 = _Result___get_value__impl__bjfvqg(tmp0_0);
            }
             while (false);
            var registered = tmp$ret$0;
            get_navigateTo()(registered.r() ? '/activities/select' : '/discover');
            return Unit_instance;
          case 4:
            throw this.w7_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.u7_1 === 4) {
          throw e_0;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e_0;
        }
      }
     while (true);
  };
  var properties_initialized_AuthNavigation_kt_1eq52a;
  function _init_properties_AuthNavigation_kt__bjpv44() {
    if (!properties_initialized_AuthNavigation_kt_1eq52a) {
      properties_initialized_AuthNavigation_kt_1eq52a = true;
      navigateTo = defaultNavigateTo$ref();
    }
  }
  function _set_accessToken__uqv1kg($this, value) {
    if (value == null) {
      localStorage.removeItem('bitakore.accessToken');
    } else {
      localStorage.setItem('bitakore.accessToken', value);
    }
  }
  function _set_refreshToken__m7kg1l($this, value) {
    if (value == null) {
      localStorage.removeItem('bitakore.refreshToken');
    } else {
      localStorage.setItem('bitakore.refreshToken', value);
    }
  }
  function _set_roles__k8j8ko($this, value) {
    if (value == null) {
      localStorage.removeItem('bitakore.roles');
    } else {
      localStorage.setItem('bitakore.roles', joinToString(value, ','));
    }
  }
  function AuthState() {
    this.g26_1 = 'bitakore.accessToken';
    this.h26_1 = 'bitakore.refreshToken';
    this.i26_1 = 'bitakore.roles';
  }
  protoOf(AuthState).y2w = function () {
    return localStorage.getItem('bitakore.accessToken');
  };
  protoOf(AuthState).a28 = function () {
    var tmp0_safe_receiver = localStorage.getItem('bitakore.roles');
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : split(tmp0_safe_receiver, [',']);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp1_safe_receiver.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlin.text.isNotBlank' call
        if (!isBlank(element)) {
          destination.x(element);
        }
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    return tmp2_safe_receiver == null ? null : toSet(tmp2_safe_receiver);
  };
  protoOf(AuthState).y27 = function () {
    return !(this.y2w() == null);
  };
  protoOf(AuthState).z27 = function () {
    var tmp0_safe_receiver = this.a28();
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c2('SUPER_ADMIN')) === true;
  };
  protoOf(AuthState).m2y = function (accessToken, refreshToken) {
    _set_accessToken__uqv1kg(this, accessToken);
    _set_refreshToken__m7kg1l(this, refreshToken);
    _set_roles__k8j8ko(this, null);
  };
  protoOf(AuthState).k27 = function (roles) {
    _set_roles__k8j8ko(this, roles);
  };
  protoOf(AuthState).p2 = function () {
    _set_accessToken__uqv1kg(this, null);
    _set_refreshToken__m7kg1l(this, null);
    _set_roles__k8j8ko(this, null);
  };
  var AuthState_instance;
  function AuthState_getInstance() {
    return AuthState_instance;
  }
  function get(_this__u8e3s4, index) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = _this__u8e3s4[index];
    return (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
  }
  function set(_this__u8e3s4, index, value) {
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4[index] = value;
  }
  function base64UrlToBytes(b64url) {
    // Inline function 'kotlin.let' call
    var it = replace(replace(b64url, _Char___init__impl__6a9atx(45), _Char___init__impl__6a9atx(43)), _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(47));
    var padded = it + repeat('=', (4 - (it.length % 4 | 0) | 0) % 4 | 0);
    var binary = window.atob(padded);
    var bytes = new Uint8Array(binary.length);
    var inductionVariable = 0;
    var last = charSequenceLength(binary) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(binary, i);
        var tmp$ret$2 = Char__toInt_impl_vasixd(this_0);
        set(bytes, i, tmp$ret$2);
      }
       while (inductionVariable <= last);
    return bytes;
  }
  function bytesToBase64Url(buffer) {
    var bytes = new Uint8Array(buffer);
    var sb = StringBuilder_init_$Create$();
    var inductionVariable = 0;
    var last = bytes.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.s(numberToChar(get(bytes, i) & 255));
      }
       while (inductionVariable < last);
    return trimEnd(replace(replace(window.btoa(sb.toString()), _Char___init__impl__6a9atx(43), _Char___init__impl__6a9atx(45)), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(95)), charArrayOf([_Char___init__impl__6a9atx(61)]));
  }
  function createPasskeyCredential(optionsJson, $completion) {
    var tmp = new $createPasskeyCredentialCOROUTINE$(optionsJson, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function getPasskeyAssertion(optionsJson, $completion) {
    var tmp = new $getPasskeyAssertionCOROUTINE$(optionsJson, $completion);
    tmp.v7_1 = Unit_instance;
    tmp.w7_1 = null;
    return tmp.b8();
  }
  function $createPasskeyCredentialCOROUTINE$(optionsJson, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z4a_1 = optionsJson;
  }
  protoOf($createPasskeyCredentialCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 2;
            var options = JSON.parse(this.z4a_1);
            var publicKey = options.publicKey;
            var tmp_0 = publicKey.challenge;
            publicKey.challenge = base64UrlToBytes((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE());
            var tmp_1 = publicKey.user.id;
            publicKey.user.id = base64UrlToBytes((!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE());
            var excludeCredentials = publicKey.excludeCredentials;
            if (excludeCredentials != undefined) {
              var tmp_2 = excludeCredentials.length;
              var length = (!(tmp_2 == null) ? typeof tmp_2 === 'number' : false) ? tmp_2 : THROW_CCE();
              var inductionVariable = 0;
              if (inductionVariable < length)
                do {
                  var i = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var tmp_3 = excludeCredentials[i].id;
                  excludeCredentials[i].id = base64UrlToBytes((!(tmp_3 == null) ? typeof tmp_3 === 'string' : false) ? tmp_3 : THROW_CCE());
                }
                 while (inductionVariable < length);
            }

            this.t7_1 = 1;
            var tmp_4 = window.navigator.credentials.create(options);
            suspendResult = await_0(tmp_4 instanceof Promise ? tmp_4 : THROW_CCE(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var credential = suspendResult;
            var result = json([to('id', credential.id), to('rawId', bytesToBase64Url(credential.rawId)), to('type', credential.type), to('response', json([to('attestationObject', bytesToBase64Url(credential.response.attestationObject)), to('clientDataJSON', bytesToBase64Url(credential.response.clientDataJSON))])), to('clientExtensionResults', json([]))]);
            return JSON.stringify(result);
          case 2:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 2) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  function $getPasskeyAssertionCOROUTINE$(optionsJson, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i4b_1 = optionsJson;
  }
  protoOf($getPasskeyAssertionCOROUTINE$).b8 = function () {
    var suspendResult = this.v7_1;
    $sm: do
      try {
        var tmp = this.t7_1;
        switch (tmp) {
          case 0:
            this.u7_1 = 2;
            var options = JSON.parse(this.i4b_1);
            var publicKey = options.publicKey;
            var tmp_0 = publicKey.challenge;
            publicKey.challenge = base64UrlToBytes((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE());
            var allowCredentials = publicKey.allowCredentials;
            if (allowCredentials != undefined) {
              var tmp_1 = allowCredentials.length;
              var length = (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE();
              var inductionVariable = 0;
              if (inductionVariable < length)
                do {
                  var i = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var tmp_2 = allowCredentials[i].id;
                  allowCredentials[i].id = base64UrlToBytes((!(tmp_2 == null) ? typeof tmp_2 === 'string' : false) ? tmp_2 : THROW_CCE());
                }
                 while (inductionVariable < length);
            }

            this.t7_1 = 1;
            var tmp_3 = window.navigator.credentials.get(options);
            suspendResult = await_0(tmp_3 instanceof Promise ? tmp_3 : THROW_CCE(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var credential = suspendResult;
            var userHandle = credential.response.userHandle;
            var result = json([to('id', credential.id), to('rawId', bytesToBase64Url(credential.rawId)), to('type', credential.type), to('response', json([to('authenticatorData', bytesToBase64Url(credential.response.authenticatorData)), to('clientDataJSON', bytesToBase64Url(credential.response.clientDataJSON)), to('signature', bytesToBase64Url(credential.response.signature)), to('userHandle', userHandle != undefined && userHandle != null ? bytesToBase64Url(userHandle) : null)])), to('clientExtensionResults', json([]))]);
            return JSON.stringify(result);
          case 2:
            throw this.w7_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.u7_1 === 2) {
          throw e;
        } else {
          this.t7_1 = this.u7_1;
          this.w7_1 = e;
        }
      }
     while (true);
  };
  //region block: post-declaration
  protoOf($serializer).ju = typeParametersSerializers;
  protoOf($serializer_0).ju = typeParametersSerializers;
  protoOf($serializer_1).ju = typeParametersSerializers;
  protoOf($serializer_2).ju = typeParametersSerializers;
  protoOf($serializer_3).ju = typeParametersSerializers;
  protoOf($serializer_4).ju = typeParametersSerializers;
  protoOf($serializer_5).ju = typeParametersSerializers;
  protoOf($serializer_6).ju = typeParametersSerializers;
  protoOf($serializer_7).ju = typeParametersSerializers;
  protoOf($serializer_8).ju = typeParametersSerializers;
  protoOf($serializer_9).ju = typeParametersSerializers;
  protoOf($serializer_10).ju = typeParametersSerializers;
  protoOf($serializer_11).ju = typeParametersSerializers;
  protoOf($serializer_12).ju = typeParametersSerializers;
  protoOf($serializer_13).ju = typeParametersSerializers;
  protoOf($serializer_14).ju = typeParametersSerializers;
  protoOf($serializer_15).ju = typeParametersSerializers;
  protoOf($serializer_16).ju = typeParametersSerializers;
  protoOf($serializer_17).ju = typeParametersSerializers;
  protoOf($serializer_18).ju = typeParametersSerializers;
  protoOf($serializer_19).ju = typeParametersSerializers;
  protoOf($serializer_20).ju = typeParametersSerializers;
  protoOf($serializer_21).ju = typeParametersSerializers;
  protoOf($serializer_22).ju = typeParametersSerializers;
  protoOf($serializer_23).ju = typeParametersSerializers;
  protoOf($serializer_24).ju = typeParametersSerializers;
  protoOf($serializer_25).ju = typeParametersSerializers;
  protoOf($serializer_26).ju = typeParametersSerializers;
  protoOf($serializer_27).ju = typeParametersSerializers;
  protoOf($serializer_28).ju = typeParametersSerializers;
  protoOf($serializer_29).ju = typeParametersSerializers;
  protoOf($serializer_30).ju = typeParametersSerializers;
  protoOf($serializer_31).ju = typeParametersSerializers;
  protoOf($serializer_32).ju = typeParametersSerializers;
  protoOf($serializer_33).ju = typeParametersSerializers;
  protoOf($serializer_34).ju = typeParametersSerializers;
  protoOf($serializer_35).ju = typeParametersSerializers;
  protoOf($serializer_36).ju = typeParametersSerializers;
  protoOf($serializer_37).ju = typeParametersSerializers;
  protoOf($serializer_38).ju = typeParametersSerializers;
  protoOf($serializer_39).ju = typeParametersSerializers;
  protoOf($serializer_40).ju = typeParametersSerializers;
  protoOf($serializer_41).ju = typeParametersSerializers;
  protoOf($serializer_42).ju = typeParametersSerializers;
  protoOf($serializer_43).ju = typeParametersSerializers;
  protoOf($serializer_44).ju = typeParametersSerializers;
  protoOf($serializer_45).ju = typeParametersSerializers;
  protoOf($serializer_46).ju = typeParametersSerializers;
  protoOf($serializer_47).ju = typeParametersSerializers;
  protoOf($serializer_48).ju = typeParametersSerializers;
  protoOf($serializer_49).ju = typeParametersSerializers;
  protoOf($serializer_50).ju = typeParametersSerializers;
  protoOf($serializer_51).ju = typeParametersSerializers;
  protoOf($serializer_52).ju = typeParametersSerializers;
  protoOf($serializer_53).ju = typeParametersSerializers;
  protoOf($serializer_54).ju = typeParametersSerializers;
  protoOf($serializer_55).ju = typeParametersSerializers;
  protoOf($serializer_56).ju = typeParametersSerializers;
  protoOf($serializer_57).ju = typeParametersSerializers;
  protoOf($serializer_58).ju = typeParametersSerializers;
  protoOf($serializer_59).ju = typeParametersSerializers;
  protoOf($serializer_60).ju = typeParametersSerializers;
  protoOf($serializer_61).ju = typeParametersSerializers;
  protoOf($serializer_62).ju = typeParametersSerializers;
  protoOf($serializer_63).ju = typeParametersSerializers;
  protoOf($serializer_64).ju = typeParametersSerializers;
  protoOf($serializer_65).ju = typeParametersSerializers;
  protoOf($serializer_66).ju = typeParametersSerializers;
  protoOf($serializer_67).ju = typeParametersSerializers;
  protoOf($serializer_68).ju = typeParametersSerializers;
  protoOf($serializer_69).ju = typeParametersSerializers;
  protoOf($serializer_70).ju = typeParametersSerializers;
  protoOf($serializer_71).ju = typeParametersSerializers;
  protoOf($serializer_72).ju = typeParametersSerializers;
  protoOf($serializer_73).ju = typeParametersSerializers;
  protoOf($serializer_74).ju = typeParametersSerializers;
  protoOf($serializer_75).ju = typeParametersSerializers;
  protoOf($serializer_76).ju = typeParametersSerializers;
  protoOf($serializer_77).ju = typeParametersSerializers;
  protoOf($serializer_78).ju = typeParametersSerializers;
  protoOf($serializer_79).ju = typeParametersSerializers;
  protoOf($serializer_80).ju = typeParametersSerializers;
  protoOf($serializer_81).ju = typeParametersSerializers;
  protoOf($serializer_82).ju = typeParametersSerializers;
  protoOf($serializer_83).ju = typeParametersSerializers;
  protoOf($serializer_84).ju = typeParametersSerializers;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion();
  CommonModule_instance = new CommonModule();
  Companion_instance_1 = new Companion_0();
  Analytics_instance = new Analytics();
  ConsentBanner_instance = new ConsentBanner();
  locationSearchTimeoutHandle = null;
  Companion_instance_3 = new Companion_2();
  Companion_instance_4 = new Companion_3();
  Companion_instance_6 = new Companion_5();
  Companion_instance_7 = new Companion_6();
  Companion_instance_8 = new Companion_7();
  Companion_instance_9 = new Companion_8();
  Companion_instance_10 = new Companion_9();
  Companion_instance_11 = new Companion_10();
  Companion_instance_12 = new Companion_11();
  Companion_instance_13 = new Companion_12();
  Companion_instance_14 = new Companion_13();
  Companion_instance_15 = new Companion_14();
  Companion_instance_16 = new Companion_15();
  Companion_instance_17 = new Companion_16();
  Companion_instance_18 = new Companion_17();
  Companion_instance_19 = new Companion_18();
  Companion_instance_29 = new Companion_28();
  Companion_instance_30 = new Companion_29();
  Companion_instance_31 = new Companion_30();
  Companion_instance_33 = new Companion_32();
  Companion_instance_34 = new Companion_33();
  Companion_instance_35 = new Companion_34();
  Companion_instance_36 = new Companion_35();
  Companion_instance_38 = new Companion_37();
  Companion_instance_40 = new Companion_39();
  Companion_instance_41 = new Companion_40();
  Companion_instance_42 = new Companion_41();
  Companion_instance_43 = new Companion_42();
  Companion_instance_46 = new Companion_45();
  Companion_instance_47 = new Companion_46();
  Companion_instance_48 = new Companion_47();
  Companion_instance_52 = new Companion_51();
  Companion_instance_58 = new Companion_57();
  Companion_instance_60 = new Companion_59();
  Companion_instance_61 = new Companion_60();
  Companion_instance_62 = new Companion_61();
  Companion_instance_63 = new Companion_62();
  Companion_instance_64 = new Companion_63();
  Companion_instance_65 = new Companion_64();
  Companion_instance_67 = new Companion_66();
  Companion_instance_68 = new Companion_67();
  Companion_instance_70 = new Companion_69();
  Companion_instance_71 = new Companion_70();
  Companion_instance_72 = new Companion_71();
  Companion_instance_73 = new Companion_72();
  Companion_instance_75 = new Companion_74();
  Companion_instance_76 = new Companion_75();
  Companion_instance_77 = new Companion_76();
  Companion_instance_79 = new Companion_78();
  Companion_instance_80 = new Companion_79();
  Companion_instance_85 = new Companion_84();
  AcceptInvitationPageModule_instance = new AcceptInvitationPageModule();
  currentCompanyId = '';
  ActivityOfferingsPageModule_instance = new ActivityOfferingsPageModule();
  ActivitySelectionPageModule_instance = new ActivitySelectionPageModule();
  AdminAdPricingPageModule_instance = new AdminAdPricingPageModule();
  currentPage = 1;
  currentCompanyType = 'ACTIVITY_CENTER';
  editingCompanyId = null;
  ActivityCentersPageModule_instance = new ActivityCentersPageModule();
  CertificationIssuersPageModule_instance = new CertificationIssuersPageModule();
  MarketersPageModule_instance = new MarketersPageModule();
  AdminUsersPageModule_instance = new AdminUsersPageModule();
  CertificationTypesPageModule_instance = new CertificationTypesPageModule();
  CertificationVisibilityRequestsPageModule_instance = new CertificationVisibilityRequestsPageModule();
  ClaimInvitationsPageModule_instance = new ClaimInvitationsPageModule();
  CompanyActivityLogPageModule_instance = new CompanyActivityLogPageModule();
  CompanyAnalyticsPageModule_instance = new CompanyAnalyticsPageModule();
  currentTeamCompanyId = '';
  editingMemberUserId = null;
  CompanyTeamPageModule_instance = new CompanyTeamPageModule();
  DiscoverPageModule_instance = new DiscoverPageModule();
  ForgotPasswordPageModule_instance = new ForgotPasswordPageModule();
  HomePageModule_instance = new HomePageModule();
  IssuingAuthoritiesPageModule_instance = new IssuingAuthoritiesPageModule();
  LeaderboardPageModule_instance = new LeaderboardPageModule();
  LogActivityPageModule_instance = new LogActivityPageModule();
  LogCenterActivityPageModule_instance = new LogCenterActivityPageModule();
  LoginPageModule_instance = new LoginPageModule();
  MagicLinkLandingPageModule_instance = new MagicLinkLandingPageModule();
  MarketerAdvertisementsPageModule_instance = new MarketerAdvertisementsPageModule();
  BitakorePaymentsHttpClient_instance = new BitakorePaymentsHttpClient();
  BitakoreWalletKitHttpClient_instance = new BitakoreWalletKitHttpClient();
  MarketerBillingPageModule_instance = new MarketerBillingPageModule();
  MarketerCampaignsPageModule_instance = new MarketerCampaignsPageModule();
  MyBitacoraPageModule_instance = new MyBitacoraPageModule();
  OAuthCallbackPageModule_instance = new OAuthCallbackPageModule();
  PendingApprovalsPageModule_instance = new PendingApprovalsPageModule();
  PrivacyPageModule_instance = new PrivacyPageModule();
  ProfilePageModule_instance = new ProfilePageModule();
  RegisterPageModule_instance = new RegisterPageModule();
  myCompanyId = null;
  RequestCertificationVisibilityPageModule_instance = new RequestCertificationVisibilityPageModule();
  ResetPasswordPageModule_instance = new ResetPasswordPageModule();
  SettingsPageModule_instance = new SettingsPageModule();
  SetupPageModule_instance = new SetupPageModule();
  TermsPageModule_instance = new TermsPageModule();
  AuthState_instance = new AuthState();
  //endregion
  mainWrapper();
  return _;
}));

